(function () {  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jZ94Y", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e8cac1c1971aaac8$export$6503ec6e8aabbaf; }, function (v) { return $e8cac1c1971aaac8$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $e8cac1c1971aaac8$export$f7ad0328861e2f03; }, function (v) { return $e8cac1c1971aaac8$export$f7ad0328861e2f03 = v; });
var $e8cac1c1971aaac8$export$6503ec6e8aabbaf;
var $e8cac1c1971aaac8$export$f7ad0328861e2f03;
"use strict";
var $e8cac1c1971aaac8$var$mapping = new Map();
function $e8cac1c1971aaac8$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$e8cac1c1971aaac8$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $e8cac1c1971aaac8$var$resolve(id) {
    var resolved = $e8cac1c1971aaac8$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$e8cac1c1971aaac8$export$6503ec6e8aabbaf = $e8cac1c1971aaac8$var$register;
$e8cac1c1971aaac8$export$f7ad0328861e2f03 = $e8cac1c1971aaac8$var$resolve;

});

parcelRegister("jyfjk", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e3bd11aec1f3a376$export$bdfd709ae4826697; }, function (v) { return $e3bd11aec1f3a376$export$bdfd709ae4826697 = v; });
var $e3bd11aec1f3a376$export$bdfd709ae4826697;
var $e3bd11aec1f3a376$export$c9e73fbda7da57b6;
var $e3bd11aec1f3a376$export$5a759dc7a1cfb72a;
"use strict";
var $e3bd11aec1f3a376$var$bundleURL = {};
function $e3bd11aec1f3a376$var$getBundleURLCached(id) {
    var value = $e3bd11aec1f3a376$var$bundleURL[id];
    if (!value) {
        value = $e3bd11aec1f3a376$var$getBundleURL();
        $e3bd11aec1f3a376$var$bundleURL[id] = value;
    }
    return value;
}
function $e3bd11aec1f3a376$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e3bd11aec1f3a376$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $e3bd11aec1f3a376$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e3bd11aec1f3a376$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$e3bd11aec1f3a376$export$bdfd709ae4826697 = $e3bd11aec1f3a376$var$getBundleURLCached;
$e3bd11aec1f3a376$export$c9e73fbda7da57b6 = $e3bd11aec1f3a376$var$getBaseURL;
$e3bd11aec1f3a376$export$5a759dc7a1cfb72a = $e3bd11aec1f3a376$var$getOrigin;

});

parcelRegister("271MM", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $853dc053370b4dd4$export$e506a1d27d1eaa20; });
class $853dc053370b4dd4$export$e506a1d27d1eaa20 {
    static import(product) {
        this.product = product;
    }
}
$853dc053370b4dd4$export$e506a1d27d1eaa20.websiteUrl = undefined;
var $853dc053370b4dd4$var$_httpssedestralcom;
$853dc053370b4dd4$export$e506a1d27d1eaa20.domain = ($853dc053370b4dd4$var$_httpssedestralcom = "https://sedestral.com") !== null && $853dc053370b4dd4$var$_httpssedestralcom !== void 0 ? $853dc053370b4dd4$var$_httpssedestralcom : window.location.origin;
$853dc053370b4dd4$export$e506a1d27d1eaa20.version = "711f6eb7";
$853dc053370b4dd4$export$e506a1d27d1eaa20.environment = "prod";
$853dc053370b4dd4$export$e506a1d27d1eaa20.isDev = false;
$853dc053370b4dd4$export$e506a1d27d1eaa20.isProd = $853dc053370b4dd4$export$e506a1d27d1eaa20.environment == "prod";
$853dc053370b4dd4$export$e506a1d27d1eaa20.httpPanelUrl = "https://sedestral.com/panel";
$853dc053370b4dd4$export$e506a1d27d1eaa20.httpCommunityUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.websocketPanelUrl = "wss://livechat.sedestral.com/websocket";
$853dc053370b4dd4$export$e506a1d27d1eaa20.websocketCommunityUrl = "";
$853dc053370b4dd4$export$e506a1d27d1eaa20.editorCollaborationUrl = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.rumEnabled = false;
$853dc053370b4dd4$export$e506a1d27d1eaa20.blogSubDomain = undefined;
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorKey = "1HFPKNKBSCVT";
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorHost = "https://g.tenor.com/v1/";
$853dc053370b4dd4$export$e506a1d27d1eaa20.tenorMediaHost = "https://media.tenor.com/";
$853dc053370b4dd4$export$e506a1d27d1eaa20.domainParent = "sedestral.com";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleVersion = "1.0.14";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopFileName = "sedestral_v" + $853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleVersion + ".zip";
$853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopModuleLink = "/module/" + $853dc053370b4dd4$export$e506a1d27d1eaa20.prestaShopFileName;
$853dc053370b4dd4$export$e506a1d27d1eaa20.hotjarId = "5125087";
$853dc053370b4dd4$export$e506a1d27d1eaa20.hotjarPanelId = undefined;

});

parcelRegister("6IrtT", function(module, exports) {

var $7iilT = parcelRequire("7iilT");
module.exports = $7iilT("iyIBq").then(()=>parcelRequire('1v7O0'));

});
parcelRegister("7iilT", function(module, exports) {
"use strict";

function $54f8732b7a3aad4a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("jZ94Y")).resolve(id));
}
module.exports = $54f8732b7a3aad4a$var$load;

});


parcelRegister("68Z0d", function(module, exports) {

$parcel$export(module.exports, "EntityService", function () { return $9b2c4bfdf11e2b41$export$714c657d7d597c58; });

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $7Aqrk = parcelRequire("7Aqrk");

var $dH00N = parcelRequire("dH00N");

var $2Y8XI = parcelRequire("2Y8XI");

var $2eT6g = parcelRequire("2eT6g");

var $5pJMm = parcelRequire("5pJMm");

var $bKmye = parcelRequire("bKmye");

var $j8ebN = parcelRequire("j8ebN");

var $4in9X = parcelRequire("4in9X");

var $fdmdr = parcelRequire("fdmdr");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $1wiPK = parcelRequire("1wiPK");

var $lrxLu = parcelRequire("lrxLu");
class $9b2c4bfdf11e2b41$export$714c657d7d597c58 {
    /**
     * get and set
     */ static get activeEntity() {
        var _EntityService_activeEntities_find;
        this.initActives();
        return (_EntityService_activeEntities_find = $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities.find((value)=>value.product == (0, $271MM.config).product)) === null || _EntityService_activeEntities_find === void 0 ? void 0 : _EntityService_activeEntities_find.entity;
    }
    static set activeEntity(entity) {
        $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities.push({
            product: (0, $271MM.config).product,
            entity: entity
        });
    }
    static get activeSite() {
        var _EntityService_activeSites_find;
        this.initActives();
        return (_EntityService_activeSites_find = $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites.find((value)=>value.product == (0, $271MM.config).product)) === null || _EntityService_activeSites_find === void 0 ? void 0 : _EntityService_activeSites_find.site;
    }
    static set activeSite(entity) {
        $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites.push({
            product: (0, $271MM.config).product,
            site: entity
        });
    }
    static get activeWebPushToken() {
        return this._activeWebPushTokenValue;
    }
    static set activeWebPushToken(token) {
        this._activeWebPushTokenValue = token;
        (0, $1wiPK.SedestralStorage).setItem(this._activeWebPushToken, this._activeWebPushTokenValue);
    }
    static get activeToken() {
        return (0, $1wiPK.SedestralStorage).getItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static set activeToken(token) {
        (0, $1wiPK.SedestralStorage).setItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment, token);
    }
    static clearActiveToken() {
        (0, $1wiPK.SedestralStorage).removeItem(`_activeToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static get saveActiveToken() {
        return (0, $lrxLu.SedestralMemory).getItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static set saveActiveToken(token) {
        (0, $lrxLu.SedestralMemory).setItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment, token);
    }
    static clearSaveActiveToken() {
        (0, $lrxLu.SedestralMemory).removeItem(`_saveActiveToken` + (0, $271MM.config).product + (0, $271MM.config).environment);
    }
    static get activeTokenCookie() {
        this.initActives();
        return (0, $1wiPK.SedestralStorage).getCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product);
    }
    static set activeTokenCookie(token) {
        this.initActives();
        (0, $1wiPK.SedestralStorage).setCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product, token, "." + (0, $271MM.config).domainParent);
    }
    static clearTokenCookie() {
        (0, $1wiPK.SedestralStorage).deleteCookie(`_activeTokenCookie` + (0, $271MM.config).environment + (0, $271MM.config).product);
    }
    static dispose() {
        this.typingEvents = [];
    }
    static initActives() {
        if (!$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeEntities = [];
        if (!$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeSites = [];
    }
    static init() {
        this.initActives();
        (0, $2Y8XI.Services).beforeInit(this);
        this._activeWebPushTokenValue = (0, $1wiPK.SedestralStorage).getItem(this._activeWebPushToken);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_UPDATE, (data)=>{
            let entity = data;
            if ((0, $dH00N.Models).isAccountModel(entity)) (0, $7Aqrk.AccountService).store(entity);
        });
        //TODO remove typing only if typing is active
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_TYPING, (data)=>{
            // console.log(data)
            let entity = this.store(data.entity, data.entityType);
            data.files = (0, $bKmye.FileService).storeAll(data.files);
            data.previews = (0, $j8ebN.PreviewService).storeAll(data.previews);
            this.typingEvents.forEach((value)=>value(entity, data.content, data.files, data.previews));
        });
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["EntityService"] = this;
    }
    /**
     * http
     */ static async updateAvatar(accountId, files, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/account/avatar/update`, {
            files: files,
            accountId: accountId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * get
     */ static getEntity(type, id) {
        if (type == (0, $5pJMm.EntityType).ACCOUNT) return (0, $7Aqrk.AccountService).accounts.filter((value)=>value.id == id)[0];
    }
    static getType(entity) {
        return (0, $dH00N.Models).isContactModel(entity) ? (0, $5pJMm.EntityType).CONTACT : (0, $5pJMm.EntityType).ACCOUNT;
    }
    /**
     * websocket
     */ static typing(conversationId, typing, content, files, previews) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ENTITY_TYPING, {
            conversationId: conversationId,
            typing: typing,
            content: content,
            filesIds: files ? files.map((value)=>value.id) : undefined,
            previewsIds: previews ? previews.map((value)=>value.id) : undefined
        });
    }
    /**
     * headers
     */ static headersToken(headers, saveCookie = true) {
        if (headers !== undefined && headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER] != undefined) {
            $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeToken = headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER];
            if (saveCookie) $9b2c4bfdf11e2b41$export$714c657d7d597c58.activeTokenCookie = headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER];
        }
    }
    /**
     * virtual
     */ static virtualGenerate(avatar) {
        return {
            work: "",
            avatar: avatar,
            siteId: "virtualId",
            name: "name",
            id: "virtualId",
            email: "email",
            active: true,
            avatarId: avatar.id,
            twoFactor: false
        };
    }
    /**
     * events
     */ static onTyping(func, component) {
        this.typingEvents.push(func);
        component.onRemove(()=>this.typingEvents.splice(this.typingEvents.indexOf(func), 1));
    }
    /**
     * store
     */ static storeContext(entity, site) {
        this.activeEntity = this.store(entity, entity.type);
        this.activeSite = (0, $fdmdr.SiteService).store(site);
    }
    static storeAll(entities, type) {
        for(let key in entities)entities[key] = this.store(entities[key], type);
        return (0, $2Y8XI.Services).storeAll(entities);
    }
    static store(entity, type) {
        if (type == undefined) {
            if ((0, $dH00N.Models).isAccountModel(entity)) entity = (0, $7Aqrk.AccountService).store(entity);
        } else if (type == (0, $5pJMm.EntityType).ACCOUNT) // @ts-ignore
        entity = (0, $7Aqrk.AccountService).store(entity);
        return entity;
    }
}
$9b2c4bfdf11e2b41$export$714c657d7d597c58.typingEvents = [];
$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeOfferProducts = {};
$9b2c4bfdf11e2b41$export$714c657d7d597c58.activeOfferIsFailureToPay = false;
$9b2c4bfdf11e2b41$export$714c657d7d597c58._activeWebPushToken = "_activeWebPushToken";

});
parcelRegister("7AbeR", function(module, exports) {

$parcel$export(module.exports, "Network", function () { return $027898bf994f2033$export$95be4ae94445245a; });
parcelRequire("amWqg");
var $daxY8 = parcelRequire("daxY8");

var $271MM = parcelRequire("271MM");

var $68Z0d = parcelRequire("68Z0d");

var $nyKU9 = parcelRequire("nyKU9");

var $4in9X = parcelRequire("4in9X");

var $bTARt = parcelRequire("bTARt");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $5FliW = parcelRequire("5FliW");

var $bi5k0 = parcelRequire("bi5k0");

var $1wiPK = parcelRequire("1wiPK");

var $btxlx = parcelRequire("btxlx");

var $i00Q1 = parcelRequire("i00Q1");

var $6pO1Y = parcelRequire("6pO1Y");

var $4U8vF = parcelRequire("4U8vF");

var $8hCed = parcelRequire("8hCed");

var $dI9YH = parcelRequire("dI9YH");

var $39ltS = parcelRequire("39ltS");
class $027898bf994f2033$export$95be4ae94445245a {
    /**
     * logged
     */ static get logged() {
        return this._logged;
    }
    static set logged(value) {
        this._logged = value;
        (0, $1wiPK.SedestralStorage).setItem(`${this.productName}-online`, this._logged + "");
    }
    /**
     * init
     */ static async init(productName) {
        this.productName = productName;
        this._logged = (0, $1wiPK.SedestralStorage).getItem(`${this.productName}-online`) == undefined ? false : (0, $1wiPK.SedestralStorage).getItem(`${this.productName}-online`) == "true";
        this.vendor = (0, $39ltS.generateVendor)((0, $271MM.config).domain);
        this.tenor = (0, $daxY8.default).create({
            baseURL: (0, $271MM.config).tenorHost,
            timeout: this.timeoutTenor
        });
        this.tenor.defaults.params = {
            key: (0, $271MM.config).tenorKey
        };
        this.httpResources = (0, $daxY8.default).create({
            baseURL: (0, $271MM.config).httpPanelUrl,
            withCredentials: false,
            timeout: this.timeoutApi
        });
        this.registerAxios((0, $kfkzw.ProductType).PANEL, (0, $271MM.config).httpPanelUrl);
        var _config_httpCommunityUrl;
        this.registerAxios((0, $kfkzw.ProductType).COMMUNITY, (_config_httpCommunityUrl = (0, $271MM.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $271MM.config).domain);
        this.registerSocket((0, $kfkzw.ProductType).PANEL, (0, $271MM.config).websocketPanelUrl);
        this.registerSocket((0, $kfkzw.ProductType).COMMUNITY, (0, $271MM.config).websocketCommunityUrl);
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["NetworkService"] = this;
    }
    static initErrors() {
        this.commonErrors = [
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_CHANNEL_NO_FOUND,
                message: (0, $5FliW.Resources).t("words.errorSITE_CHANNEL_NO_FOUND")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_RECIPIENT,
                message: (0, $5FliW.Resources).t("words.errorNO_RECIPIENT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_SITE_CHANEl,
                message: (0, $5FliW.Resources).t("words.errorNO_SITE_CHANNEL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_TECHNICAL,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_TECHNICAL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CAPTCHA_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorCAPTCHA_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_CODE_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_CODE_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_TRANSACTION_NO_FOUND,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_TRANSACTION_NO_FOUND")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_EXPIRE_CODE,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_EXPIRE_CODE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_ATTEMPT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_ATTEMPT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_BAND_WIDTH_LIMIT,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_BAND_WIDTH_LIMIT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_METHOD_UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_METHOD_UNAUTHORIZED")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TWO_FACTOR_CREATE_INVALID_CODE,
                message: (0, $5FliW.Resources).t("words.errorTWO_FACTOR_CREATE_INVALID_CODE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_CHANNEL_PERMISSION,
                message: (0, $5FliW.Resources).t("words.errorSITE_CHANNEL_PERMISSION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PERMISSION,
                message: (0, $5FliW.Resources).t("words.errorPERMISSION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).VERIFICATION,
                message: (0, $5FliW.Resources).t("words.errorVERIFICATION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.errorSIZE_MAX")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NULLITY,
                message: (0, $5FliW.Resources).t("words.errorNULLITY")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EXCEPTION,
                message: (0, $5FliW.Resources).t("words.errorEXCEPTION")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CACHE,
                message: (0, $5FliW.Resources).t("words.errorCACHE")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).K8S_DOMAIN_ERROR,
                message: (0, $5FliW.Resources).t("words.errorK8S_DOMAIN_ERROR")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).DOMAIN_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorDOMAIN_FORMAT"),
                displayValue: true
            },
            {
                errorCode: (0, $bTARt.ErrorCode).DOMAIN_FULL,
                message: (0, $5FliW.Resources).t("words.errorDOMAIN_FULL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_INCORRECT,
                message: (0, $5FliW.Resources).t("words.errorHOST_INCORRECT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: (0, $5FliW.Resources).t("words.errorHOST_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NAME_EXIST,
                message: (0, $5FliW.Resources).t("words.errorNAME_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).WINDOW_EXPIRED,
                message: (0, $5FliW.Resources).t("words.errorWINDOW_EXPIRED")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_ALIAS_EXIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_ALIAS_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_ALIAS,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_ALIAS")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_EXIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_EXIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).EMAIL_BLACKLIST,
                message: (0, $5FliW.Resources).t("words.errorEMAIL_BLACKLIST")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAIL_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorMAIL_FORMAT"),
                displayValue: true
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PHONE_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorPHONE_FORMAT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAIL_DOMAIN,
                message: (0, $5FliW.Resources).t("words.errorMAIL_DOMAIN")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).RECIPIENT_FULL,
                message: (0, $5FliW.Resources).t("words.errorRECIPIENT_FULL")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).IMAGE_FORMAT,
                message: (0, $5FliW.Resources).t("words.errorIMAGE_FORMAT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).NO_CONTACT,
                message: (0, $5FliW.Resources).t("words.errorNO_CONTACT")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_COUNTRY,
                message: (0, $5FliW.Resources).t("words.postalCountryTaxCountry")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_TYPE,
                message: (0, $5FliW.Resources).t("words.taxTypeNotAvailable")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TAX_VALUE_INVALID,
                message: (0, $5FliW.Resources).t("words.taxValueInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).LOCATION_INVALID,
                message: (0, $5FliW.Resources).t("words.locationInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TOKEN_INVALID,
                message: (0, $5FliW.Resources).t("words.tokenInvalidMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PAYMENT_PROVIDER_CREATE_SUBSCRIPTION,
                message: (0, $5FliW.Resources).t("words.paymentProviderCreateSubscriptionMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_QUOTE_EXISTS,
                message: (0, $5FliW.Resources).t("words.quoteExistsErrorMessage")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).CREATE_ARTICLE_IA_FORM_EMPTY,
                message: (0, $5FliW.Resources).t("words.errorcreateArticleFormEmpty")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TASK_IN_PROGRESS,
                message: (0, $5FliW.Resources).t("words.taskInProgress")
            },
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.errorUNAUTHORIZED")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.errorNOT_FOUND")
            },
            {
                status: (0, $7ZaxO.HttpStatus).PRECONDITION_FAILED,
                message: (0, $5FliW.Resources).t("words.errorPRECONDITION_FAILED")
            },
            {
                status: (0, $7ZaxO.HttpStatus).BAD_GATEWAY,
                message: (0, $5FliW.Resources).t("words.errorSERVICE_UNAVAILABLE")
            },
            {
                status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                message: (0, $5FliW.Resources).t("words.errorSERVICE_UNAVAILABLE")
            },
            {
                status: (0, $7ZaxO.HttpStatus).INTERNAL_SERVER_ERROR,
                message: (0, $5FliW.Resources).t("words.errorINTERNAL_SERVER_ERROR")
            },
            {
                status: (0, $7ZaxO.HttpStatus).TOO_MANY_REQUESTS,
                message: (0, $5FliW.Resources).t("words.errorTOO_MANY_REQUESTS")
            }
        ];
    }
    /**
     * starting
     */ static async start(router) {
        if (router != undefined) {
            this.router = router;
            this.router.onStarted = ()=>this.startedFunctions.forEach((value)=>value());
        }
        if (await this.onToken()) {
            if ($027898bf994f2033$export$95be4ae94445245a.logged) await this.startLogin();
        } else {
            this.executeNetworkLost();
            return false;
        }
        return true;
    }
    static async startLogin() {
        if (!await this.onLogin()) {
            this.executeNetworkLost();
            return false;
        }
        return true;
    }
    static async startWebSocket(type, onDisconnect) {
        var _EntityService_activeSite;
        let socket = this.getSocket(type);
        socket.onDisconnect = ()=>{
            if (type == (0, $kfkzw.ProductType).PANEL) this.executeNetworkLost();
            if (onDisconnect) onDisconnect();
        };
        if (await socket.start({
            siteId: (_EntityService_activeSite = (0, $68Z0d.EntityService).activeSite) === null || _EntityService_activeSite === void 0 ? void 0 : _EntityService_activeSite.id,
            entityType: (0, $68Z0d.EntityService).activeEntity.type,
            activeToken: (0, $68Z0d.EntityService).activeToken
        })) return socket;
    }
    /**
     * websocket
     */ static async disconnect(type, logout) {
        this.getSocket(type).disconnect(logout);
    }
    static emit(type, event, value) {
        $027898bf994f2033$export$95be4ae94445245a.getSocket(type).emit(event, value);
    }
    static async emitSync(type, event, value) {
        return await $027898bf994f2033$export$95be4ae94445245a.getSocket(type).emitSync(event, value);
    }
    static on(type, event, func) {
        var _Network_getSocket;
        (_Network_getSocket = $027898bf994f2033$export$95be4ae94445245a.getSocket(type)) === null || _Network_getSocket === void 0 ? void 0 : _Network_getSocket.on(event, func);
    }
    static async join(type, data, route) {
        if (data != null) return await $027898bf994f2033$export$95be4ae94445245a.emitSync(type, route, data);
    }
    static getSocket(type) {
        var _this_sockets_find, _this_sockets_find1;
        if (type) return (_this_sockets_find = this.sockets.find((value)=>value.type == type)) === null || _this_sockets_find === void 0 ? void 0 : _this_sockets_find.socket;
        return (_this_sockets_find1 = this.sockets.find((value)=>value.type == (0, $kfkzw.ProductType).PANEL)) === null || _this_sockets_find1 === void 0 ? void 0 : _this_sockets_find1.socket;
    }
    static removeSocket(type) {
        let socket = this.sockets.find((value)=>value.type == type);
        if (socket) this.sockets.splice(this.sockets.indexOf(socket), 1);
    }
    static registerSocket(type, host) {
        this.removeSocket(type);
        this.sockets.push({
            type: type,
            socket: new (0, $i00Q1.NetworkSocket)(host)
        });
    }
    /**
     * axios
     */ static registerAxios(type, host) {
        let instance = this.axios.find((value)=>value.type == type);
        if (instance) this.axios.splice(this.axios.indexOf(instance), 1);
        let http = (0, $daxY8.default).create({
            baseURL: host,
            withCredentials: false,
            timeout: this.timeoutApi
        });
        http.interceptors.request.use(function(config) {
            if ((0, $68Z0d.EntityService).activeToken) config.headers[(0, $4in9X.NetworkHeaders).SESSION_HEADER] = (0, $68Z0d.EntityService).activeToken;
            if ((0, $68Z0d.EntityService).activeSite) config.headers[(0, $4in9X.NetworkHeaders).SITE_HEADER] = (0, $68Z0d.EntityService).activeSite.id;
            return config;
        });
        this.axios.push({
            type: type,
            http: http
        });
    }
    static getAxios(type) {
        var _this_axios_find, _this_axios_find1;
        if (type) return (_this_axios_find = this.axios.find((value)=>value.type == type)) === null || _this_axios_find === void 0 ? void 0 : _this_axios_find.http;
        return (_this_axios_find1 = this.axios.find((value)=>value.type == (0, $kfkzw.ProductType).PANEL)) === null || _this_axios_find1 === void 0 ? void 0 : _this_axios_find1.http;
    }
    /**
     * http
     */ static async request(type, request, component, config) {
        let tokenSource = (0, $daxY8.default).CancelToken.source();
        if (config === null || config === void 0 ? void 0 : config.cancelableCallback) config.cancelableCallback(tokenSource);
        if (component && component.onRemove) component.onRemove(()=>{
            tokenSource.cancel();
        });
        return (0, $nyKU9.SedestralMachine).promise((resolve)=>{
            let axiosRequest = request(tokenSource.token);
            axiosRequest.then((response)=>{
                var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router, _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                resolve(response);
                if ((_Network_router = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router.static) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.onSuccess) (_Network_router1 = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1.static) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.onSuccess(response);
                if (response && response.headers) this.requestAlert(response.headers);
            }).catch((response)=>{
                //Si pas de réponse, on en simule une
                if (!response.response && (response === null || response === void 0 ? void 0 : response.code) !== "ERR_CANCELED") response = {
                    response: {
                        status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                        data: ''
                    }
                };
                if (response.response && response.response.data && (response.response.data.status || response.response.data.errorCode) && response.response.status) {
                    var _Network_router_static_components_twoFactor, _Network_router_static_components, _Network_router_static, _Network_router;
                    this.requestTwoFactor(component, {
                        ...response,
                        productType: type
                    });
                    this.requestError(component, response.response.data);
                    if (response.response.status !== (0, $7ZaxO.HttpStatus).LOCKED) (_Network_router = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router === void 0 ? void 0 : (_Network_router_static = _Network_router.static) === null || _Network_router_static === void 0 ? void 0 : (_Network_router_static_components = _Network_router_static.components) === null || _Network_router_static_components === void 0 ? void 0 : (_Network_router_static_components_twoFactor = _Network_router_static_components.twoFactor) === null || _Network_router_static_components_twoFactor === void 0 ? void 0 : _Network_router_static_components_twoFactor.clear();
                } else {
                    var _Network_router_static_components_twoFactor1, _Network_router_static_components1, _Network_router_static1, _Network_router1;
                    if (response.response && response.response.status != (0, $7ZaxO.HttpStatus).OK) this.requestError(component, {
                        status: response.response.status
                    });
                    (_Network_router1 = $027898bf994f2033$export$95be4ae94445245a.router) === null || _Network_router1 === void 0 ? void 0 : (_Network_router_static1 = _Network_router1.static) === null || _Network_router_static1 === void 0 ? void 0 : (_Network_router_static_components1 = _Network_router_static1.components) === null || _Network_router_static_components1 === void 0 ? void 0 : (_Network_router_static_components_twoFactor1 = _Network_router_static_components1.twoFactor) === null || _Network_router_static_components_twoFactor1 === void 0 ? void 0 : _Network_router_static_components_twoFactor1.clear();
                }
                resolve(response.response);
            });
        });
    }
    static async requestAlert(headers) {
        let alertCode = headers[(0, $4in9X.NetworkHeaders).ALERT_HEADER];
        if (alertCode) $027898bf994f2033$export$95be4ae94445245a.router.static.components.notifications.notify((0, $5FliW.Resources).t("words.alert." + alertCode), undefined, 8000, "success");
    }
    static async requestError(component, data) {
        if (data) {
            if (data.status == (0, $7ZaxO.HttpStatus).PAYMENT_REQUIRED) this.onPaymentRequired(data.currentQuantity, data.limitQuantity, data.solutionType, data.productType);
            else if (data.errorCode != (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).TWO_FACTOR_REQUIRED]) {
                if (data.errorCode == (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).SURFACE_CONTROL]) {
                    if (data.subErrors) data.subErrors.forEach((subError)=>{
                        this.onError((0, $5FliW.Resources).r("words.errorFieldErrorMessage", {
                            field: subError.field,
                            message: subError.message
                        }));
                    });
                    else if (data.message && data.message.includes("parameter is missing")) this.onError((0, $5FliW.Resources).t("words.errorfillEmptyFieldsError"));
                    else {
                        var _SedestralDebugger_rum;
                        this.onError((0, $5FliW.Resources).t("words.errorgenericErrorMessage"));
                        (_SedestralDebugger_rum = (0, $6pO1Y.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.unHandledError(data.errorCode);
                    }
                } else if (data.status === (0, $7ZaxO.HttpStatus).NETWORK_AUTHENTICATION_REQUIRED) await this.createLogout();
                else {
                    let resultCheckError = $027898bf994f2033$export$95be4ae94445245a.checkError(component === null || component === void 0 ? void 0 : component.networkErrorsHandler, data) || $027898bf994f2033$export$95be4ae94445245a.checkError(this.commonErrors, data);
                    if (!resultCheckError) {
                        var _SedestralDebugger_rum1;
                        let message = data.error + ": " + data.message + " | code: " + data.errorCode + " | type: " + data.errorType + " | status: " + data.status;
                        (_SedestralDebugger_rum1 = (0, $6pO1Y.SedestralDebugger).rum) === null || _SedestralDebugger_rum1 === void 0 ? void 0 : _SedestralDebugger_rum1.unHandledError(data.errorCode);
                        this.onError(message);
                    }
                }
            }
        }
    }
    static requestTwoFactor(component, response) {
        if (response.response.data.errorCode == (0, $bTARt.ErrorCode)[(0, $bTARt.ErrorCode).TWO_FACTOR_REQUIRED]) {
            if ($027898bf994f2033$export$95be4ae94445245a.router.static.components.twoFactor.onSuccess) try {
                let data = response.response.headers[(0, $4in9X.NetworkHeaders).TF_TRANSACTION_DATA_HEADER];
                let method = +parseInt(response.response.headers[(0, $4in9X.NetworkHeaders).TF_TRANSACTION_METHOD_HEADER]);
                if (method !== undefined && (method == (0, $btxlx.IAccountTwoFactorMethod).TOTP || method == (0, $btxlx.IAccountTwoFactorMethod).EMAIL && data != undefined)) $027898bf994f2033$export$95be4ae94445245a.router.static.components.twoFactor.create(data, response);
                else this.onError("TWO_FACTOR_REQUIRED not data.");
            } catch (e) {
                this.onError("TWO_FACTOR_REQUIRED not data.");
            }
            else this.onError("TWO_FACTOR_REQUIRED not active.");
        }
    }
    static async postJson(type, url, data, component, config) {
        let jsonHeaders = {
            'Content-Type': 'application/json'
        };
        if (!config) config = {};
        config.headers = (0, $4U8vF.jsonConcat)(jsonHeaders, config.headers);
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, JSON.stringify(data), (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async postFormData(type, url, data, component, config) {
        let jsonHeaders = {
            'Content-Type': 'multipart/form-data'
        };
        if (!config) config = {};
        config.headers = (0, $4U8vF.jsonConcat)(jsonHeaders, config.headers);
        let formData = new FormData();
        Object.keys(data).forEach(function(key) {
            if (key != "files") formData.append(key, data[key]);
        });
        if (data.files) data.files.forEach((file)=>formData.append('files', file));
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, formData, (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component);
    }
    static async post(type, url, data, component, config, parseQuery = true) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).post(url, data ? parseQuery ? (0, $dI9YH.queryString)(data) : data : undefined, (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async put(type, url, data, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).put(url, data ? (0, $dI9YH.queryString)(data) : undefined, (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async putJson(type, url, data, component, config) {
        let jsonHeaders = {
            'Content-Type': 'application/json'
        };
        if (!config) config = {};
        config.headers = (0, $4U8vF.jsonConcat)(jsonHeaders, config.headers);
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).put(url, JSON.stringify(data), (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async get(type, url, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).get(url, (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async delete(type, url, component, config) {
        return await $027898bf994f2033$export$95be4ae94445245a.request(type, (token)=>$027898bf994f2033$export$95be4ae94445245a.getAxios(type).delete(url, (0, $4U8vF.jsonConcat)({
                cancelToken: token
            }, config)), component, config);
    }
    static async retry(response, component, config) {
        var _response_productType;
        const type = (_response_productType = response.productType) !== null && _response_productType !== void 0 ? _response_productType : (0, $kfkzw.ProductType).PANEL;
        switch(response.config.method){
            case "post":
                try {
                    let jsonData = JSON.parse(response.config.data);
                    return await $027898bf994f2033$export$95be4ae94445245a.postJson(type, response.config.url, jsonData, component, config);
                } catch (e) {
                    return await $027898bf994f2033$export$95be4ae94445245a.post(type, response.config.url, response.config.data, component, config, false);
                }
            case "put":
                try {
                    let jsonData = JSON.parse(response.config.data);
                    return await $027898bf994f2033$export$95be4ae94445245a.putJson(type, response.config.url, jsonData, component, config);
                } catch (e) {
                    return await $027898bf994f2033$export$95be4ae94445245a.put(type, response.config.url, response.config.data, component, config);
                }
            case "get":
                return await $027898bf994f2033$export$95be4ae94445245a.get(type, response.config.url, component, config);
            case "delete":
                return await $027898bf994f2033$export$95be4ae94445245a.delete(type, response.config.url, component, config);
        }
    }
    static async createLogout() {
        $027898bf994f2033$export$95be4ae94445245a.router.onLogout();
        await $027898bf994f2033$export$95be4ae94445245a.onLogout();
    }
    /**
     * to override
     */ static async onToken() {
        return false;
    }
    static async onLogin() {
        return false;
    }
    static async onLogout() {
        return false;
    }
    static onError(message) {}
    static onPaymentRequired(currentQuantity, limitQuantity, solutionType, productType) {}
    /**
     * network error
     */ static onNetworkLost(func) {
        this.lostFunctions.push(func);
    }
    static onNetworkLostSolved(func) {
        this.lostSolvedFunctions.push(func);
    }
    static executeNetworkLost() {
        if (!this.lostConnection) {
            this.lostConnection = true;
            this.lostFunctions.forEach((value)=>value());
            this.lostConnectionInterval = setInterval(async ()=>{
                if (await this.start()) {
                    this.lostConnection = false;
                    clearInterval(this.lostConnectionInterval);
                    this.lostSolvedFunctions.forEach((value)=>value());
                }
            }, this.getSecondsRetry());
        }
    }
    static getSecondsRetry() {
        return (0, $8hCed.randomInteger)(3000, 6000);
    }
    /**
     * initialized
     */ static onStarted(func) {
        this.startedFunctions.push(func);
    }
    /**
     * SSR
     */ static ssrRegisterDomain(context) {
        (0, $271MM.config).domain = context;
        this.vendor = (0, $39ltS.generateVendor)((0, $271MM.config).domain);
        return context;
    }
    static checkError(errors, data) {
        let error = undefined;
        if (errors !== undefined) {
            if (data.errorCode != undefined) error = errors.find((value)=>(0, $bTARt.ErrorCode)[value.errorCode] === data.errorCode);
            if (data.status != undefined && error === undefined) error = errors.find((value)=>value.status === data.status);
            if (error === undefined) error = errors.find((value)=>(value === null || value === void 0 ? void 0 : value.defaultError) === true);
            if (error !== undefined) {
                if (error.message && error.message !== "none") this.onError(error.message + (error.displayValue ? " (" + data.message + ")" : ""));
                else if (error.handle) error.handle();
            }
        }
        return error !== undefined;
    }
}
$027898bf994f2033$export$95be4ae94445245a.sockets = [];
$027898bf994f2033$export$95be4ae94445245a.axios = [];
$027898bf994f2033$export$95be4ae94445245a.timeoutApi = 60000;
$027898bf994f2033$export$95be4ae94445245a.timeoutTenor = 10000;
$027898bf994f2033$export$95be4ae94445245a.lostConnectionInterval = 0;
$027898bf994f2033$export$95be4ae94445245a.lostConnection = false;
$027898bf994f2033$export$95be4ae94445245a.lostFunctions = [];
$027898bf994f2033$export$95be4ae94445245a.lostSolvedFunctions = [];
$027898bf994f2033$export$95be4ae94445245a.startedFunctions = [];

});
parcelRegister("amWqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("daxY8")).default; });

var $daxY8 = parcelRequire("daxY8");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $78c946fdaa590200$export$1c00760e9e5a4e95, AxiosError: $78c946fdaa590200$export$c1fbed17c2f6a328, CanceledError: $78c946fdaa590200$export$1ab0c6b20d94fa14, isCancel: $78c946fdaa590200$export$3b22524397b493c6, CancelToken: $78c946fdaa590200$export$fd08e3cb425f0d61, VERSION: $78c946fdaa590200$export$a4ad2735b021c132, all: $78c946fdaa590200$export$84bf76cd7afc7469, Cancel: $78c946fdaa590200$export$848c9b7ead0df967, isAxiosError: $78c946fdaa590200$export$fbafdbe06a5b5a9a, spread: $78c946fdaa590200$export$3ae0fd4797ed47c8, toFormData: $78c946fdaa590200$export$10ae0d317ea97f8b, AxiosHeaders: $78c946fdaa590200$export$4e7d6ff0f3e6520, HttpStatusCode: $78c946fdaa590200$export$a972f69c851492b3, formToJSON: $78c946fdaa590200$export$86d7c59254d6a2c9, getAdapter: $78c946fdaa590200$export$17ddc20a97d669e2, mergeConfig: $78c946fdaa590200$export$7ec1ebcfa9d8bd6a } = (0, $daxY8.default);

});
parcelRegister("daxY8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99668f139e6d27a1$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jSUas = parcelRequire("jSUas");

var $lT31C = parcelRequire("lT31C");

var $4mJfT = parcelRequire("4mJfT");

var $gGIev = parcelRequire("gGIev");

var $e4j5G = parcelRequire("e4j5G");

var $82h0N = parcelRequire("82h0N");

var $4ar6q = parcelRequire("4ar6q");

var $2v382 = parcelRequire("2v382");

var $iro9b = parcelRequire("iro9b");

var $i2rBs = parcelRequire("i2rBs");

var $jdUqi = parcelRequire("jdUqi");

var $hImvc = parcelRequire("hImvc");

var $fn32J = parcelRequire("fn32J");

var $3V9hT = parcelRequire("3V9hT");

var $ekUJE = parcelRequire("ekUJE");

var $jLDDr = parcelRequire("jLDDr");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $99668f139e6d27a1$var$createInstance(defaultConfig) {
    const context = new (0, $lT31C.default)(defaultConfig);
    const instance = (0, $jSUas.default)((0, $lT31C.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $pci3K.default).extend(instance, (0, $lT31C.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $pci3K.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $99668f139e6d27a1$var$createInstance((0, $4mJfT.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $99668f139e6d27a1$var$axios = $99668f139e6d27a1$var$createInstance((0, $gGIev.default));
// Expose Axios class to allow class inheritance
$99668f139e6d27a1$var$axios.Axios = (0, $lT31C.default);
// Expose Cancel & CancelToken
$99668f139e6d27a1$var$axios.CanceledError = (0, $82h0N.default);
$99668f139e6d27a1$var$axios.CancelToken = (0, $4ar6q.default);
$99668f139e6d27a1$var$axios.isCancel = (0, $2v382.default);
$99668f139e6d27a1$var$axios.VERSION = (0, $iro9b.VERSION);
$99668f139e6d27a1$var$axios.toFormData = (0, $i2rBs.default);
// Expose AxiosError class
$99668f139e6d27a1$var$axios.AxiosError = (0, $jdUqi.default);
// alias for CanceledError for backward compatibility
$99668f139e6d27a1$var$axios.Cancel = $99668f139e6d27a1$var$axios.CanceledError;
// Expose all/spread
$99668f139e6d27a1$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$99668f139e6d27a1$var$axios.spread = (0, $hImvc.default);
// Expose isAxiosError
$99668f139e6d27a1$var$axios.isAxiosError = (0, $fn32J.default);
// Expose mergeConfig
$99668f139e6d27a1$var$axios.mergeConfig = (0, $4mJfT.default);
$99668f139e6d27a1$var$axios.AxiosHeaders = (0, $3V9hT.default);
$99668f139e6d27a1$var$axios.formToJSON = (thing)=>(0, $e4j5G.default)((0, $pci3K.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$99668f139e6d27a1$var$axios.getAdapter = (0, $ekUJE.default).getAdapter;
$99668f139e6d27a1$var$axios.HttpStatusCode = (0, $jLDDr.default);
$99668f139e6d27a1$var$axios.default = $99668f139e6d27a1$var$axios;
var // this module should only have a default export
$99668f139e6d27a1$export$2e2bcd8739ae039 = $99668f139e6d27a1$var$axios;

});
parcelRegister("pci3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bbde81f62a5b57$export$2e2bcd8739ae039; });

var $jSUas = parcelRequire("jSUas");

var $f8ZNS = parcelRequire("f8ZNS");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $04bbde81f62a5b57$var$toString } = Object.prototype;
const { getPrototypeOf: $04bbde81f62a5b57$var$getPrototypeOf } = Object;
const $04bbde81f62a5b57$var$kindOf = ((cache)=>(thing)=>{
        const str = $04bbde81f62a5b57$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $04bbde81f62a5b57$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$04bbde81f62a5b57$var$kindOf(thing) === type;
};
const $04bbde81f62a5b57$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $04bbde81f62a5b57$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $04bbde81f62a5b57$var$isUndefined = $04bbde81f62a5b57$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $04bbde81f62a5b57$var$isBuffer(val) {
    return val !== null && !$04bbde81f62a5b57$var$isUndefined(val) && val.constructor !== null && !$04bbde81f62a5b57$var$isUndefined(val.constructor) && $04bbde81f62a5b57$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $04bbde81f62a5b57$var$isArrayBuffer = $04bbde81f62a5b57$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $04bbde81f62a5b57$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $04bbde81f62a5b57$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $04bbde81f62a5b57$var$isString = $04bbde81f62a5b57$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $04bbde81f62a5b57$var$isFunction = $04bbde81f62a5b57$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $04bbde81f62a5b57$var$isNumber = $04bbde81f62a5b57$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $04bbde81f62a5b57$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $04bbde81f62a5b57$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $04bbde81f62a5b57$var$isPlainObject = (val)=>{
    if ($04bbde81f62a5b57$var$kindOf(val) !== 'object') return false;
    const prototype = $04bbde81f62a5b57$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $04bbde81f62a5b57$var$isDate = $04bbde81f62a5b57$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $04bbde81f62a5b57$var$isFile = $04bbde81f62a5b57$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $04bbde81f62a5b57$var$isBlob = $04bbde81f62a5b57$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $04bbde81f62a5b57$var$isFileList = $04bbde81f62a5b57$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $04bbde81f62a5b57$var$isStream = (val)=>$04bbde81f62a5b57$var$isObject(val) && $04bbde81f62a5b57$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $04bbde81f62a5b57$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $04bbde81f62a5b57$var$isFunction(thing.append) && ((kind = $04bbde81f62a5b57$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $04bbde81f62a5b57$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $04bbde81f62a5b57$var$isURLSearchParams = $04bbde81f62a5b57$var$kindOfTest('URLSearchParams');
const [$04bbde81f62a5b57$var$isReadableStream, $04bbde81f62a5b57$var$isRequest, $04bbde81f62a5b57$var$isResponse, $04bbde81f62a5b57$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($04bbde81f62a5b57$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $04bbde81f62a5b57$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $04bbde81f62a5b57$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($04bbde81f62a5b57$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $04bbde81f62a5b57$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $04bbde81f62a5b57$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $04bbde81f62a5b57$var$isContextDefined = (context)=>!$04bbde81f62a5b57$var$isUndefined(context) && context !== $04bbde81f62a5b57$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $04bbde81f62a5b57$var$merge() {
    const { caseless: caseless } = $04bbde81f62a5b57$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $04bbde81f62a5b57$var$findKey(result, key) || key;
        if ($04bbde81f62a5b57$var$isPlainObject(result[targetKey]) && $04bbde81f62a5b57$var$isPlainObject(val)) result[targetKey] = $04bbde81f62a5b57$var$merge(result[targetKey], val);
        else if ($04bbde81f62a5b57$var$isPlainObject(val)) result[targetKey] = $04bbde81f62a5b57$var$merge({}, val);
        else if ($04bbde81f62a5b57$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $04bbde81f62a5b57$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $04bbde81f62a5b57$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $04bbde81f62a5b57$var$forEach(b, (val, key)=>{
        if (thisArg && $04bbde81f62a5b57$var$isFunction(val)) a[key] = (0, $jSUas.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $04bbde81f62a5b57$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $04bbde81f62a5b57$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $04bbde81f62a5b57$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $04bbde81f62a5b57$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $04bbde81f62a5b57$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $04bbde81f62a5b57$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($04bbde81f62a5b57$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$04bbde81f62a5b57$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $04bbde81f62a5b57$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $04bbde81f62a5b57$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $04bbde81f62a5b57$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $04bbde81f62a5b57$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $04bbde81f62a5b57$var$isHTMLForm = $04bbde81f62a5b57$var$kindOfTest('HTMLFormElement');
const $04bbde81f62a5b57$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $04bbde81f62a5b57$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $04bbde81f62a5b57$var$isRegExp = $04bbde81f62a5b57$var$kindOfTest('RegExp');
const $04bbde81f62a5b57$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $04bbde81f62a5b57$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $04bbde81f62a5b57$var$freezeMethods = (obj)=>{
    $04bbde81f62a5b57$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($04bbde81f62a5b57$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$04bbde81f62a5b57$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $04bbde81f62a5b57$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $04bbde81f62a5b57$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $04bbde81f62a5b57$var$noop = ()=>{};
const $04bbde81f62a5b57$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $04bbde81f62a5b57$var$isSpecCompliantForm(thing) {
    return !!(thing && $04bbde81f62a5b57$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $04bbde81f62a5b57$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($04bbde81f62a5b57$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $04bbde81f62a5b57$var$isArray(source) ? [] : {};
                $04bbde81f62a5b57$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$04bbde81f62a5b57$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $04bbde81f62a5b57$var$isAsyncFn = $04bbde81f62a5b57$var$kindOfTest('AsyncFunction');
const $04bbde81f62a5b57$var$isThenable = (thing)=>thing && ($04bbde81f62a5b57$var$isObject(thing) || $04bbde81f62a5b57$var$isFunction(thing)) && $04bbde81f62a5b57$var$isFunction(thing.then) && $04bbde81f62a5b57$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $04bbde81f62a5b57$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $04bbde81f62a5b57$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $04bbde81f62a5b57$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $04bbde81f62a5b57$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $04bbde81f62a5b57$var$isFunction($04bbde81f62a5b57$var$_global.postMessage));
const $04bbde81f62a5b57$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($04bbde81f62a5b57$var$_global) : typeof $f8ZNS !== 'undefined' && $f8ZNS.nextTick || $04bbde81f62a5b57$var$_setImmediate;
var // *********************
$04bbde81f62a5b57$export$2e2bcd8739ae039 = {
    isArray: $04bbde81f62a5b57$var$isArray,
    isArrayBuffer: $04bbde81f62a5b57$var$isArrayBuffer,
    isBuffer: $04bbde81f62a5b57$var$isBuffer,
    isFormData: $04bbde81f62a5b57$var$isFormData,
    isArrayBufferView: $04bbde81f62a5b57$var$isArrayBufferView,
    isString: $04bbde81f62a5b57$var$isString,
    isNumber: $04bbde81f62a5b57$var$isNumber,
    isBoolean: $04bbde81f62a5b57$var$isBoolean,
    isObject: $04bbde81f62a5b57$var$isObject,
    isPlainObject: $04bbde81f62a5b57$var$isPlainObject,
    isReadableStream: $04bbde81f62a5b57$var$isReadableStream,
    isRequest: $04bbde81f62a5b57$var$isRequest,
    isResponse: $04bbde81f62a5b57$var$isResponse,
    isHeaders: $04bbde81f62a5b57$var$isHeaders,
    isUndefined: $04bbde81f62a5b57$var$isUndefined,
    isDate: $04bbde81f62a5b57$var$isDate,
    isFile: $04bbde81f62a5b57$var$isFile,
    isBlob: $04bbde81f62a5b57$var$isBlob,
    isRegExp: $04bbde81f62a5b57$var$isRegExp,
    isFunction: $04bbde81f62a5b57$var$isFunction,
    isStream: $04bbde81f62a5b57$var$isStream,
    isURLSearchParams: $04bbde81f62a5b57$var$isURLSearchParams,
    isTypedArray: $04bbde81f62a5b57$var$isTypedArray,
    isFileList: $04bbde81f62a5b57$var$isFileList,
    forEach: $04bbde81f62a5b57$var$forEach,
    merge: $04bbde81f62a5b57$var$merge,
    extend: $04bbde81f62a5b57$var$extend,
    trim: $04bbde81f62a5b57$var$trim,
    stripBOM: $04bbde81f62a5b57$var$stripBOM,
    inherits: $04bbde81f62a5b57$var$inherits,
    toFlatObject: $04bbde81f62a5b57$var$toFlatObject,
    kindOf: $04bbde81f62a5b57$var$kindOf,
    kindOfTest: $04bbde81f62a5b57$var$kindOfTest,
    endsWith: $04bbde81f62a5b57$var$endsWith,
    toArray: $04bbde81f62a5b57$var$toArray,
    forEachEntry: $04bbde81f62a5b57$var$forEachEntry,
    matchAll: $04bbde81f62a5b57$var$matchAll,
    isHTMLForm: $04bbde81f62a5b57$var$isHTMLForm,
    hasOwnProperty: $04bbde81f62a5b57$var$hasOwnProperty,
    hasOwnProp: $04bbde81f62a5b57$var$hasOwnProperty,
    reduceDescriptors: $04bbde81f62a5b57$var$reduceDescriptors,
    freezeMethods: $04bbde81f62a5b57$var$freezeMethods,
    toObjectSet: $04bbde81f62a5b57$var$toObjectSet,
    toCamelCase: $04bbde81f62a5b57$var$toCamelCase,
    noop: $04bbde81f62a5b57$var$noop,
    toFiniteNumber: $04bbde81f62a5b57$var$toFiniteNumber,
    findKey: $04bbde81f62a5b57$var$findKey,
    global: $04bbde81f62a5b57$var$_global,
    isContextDefined: $04bbde81f62a5b57$var$isContextDefined,
    isSpecCompliantForm: $04bbde81f62a5b57$var$isSpecCompliantForm,
    toJSONObject: $04bbde81f62a5b57$var$toJSONObject,
    isAsyncFn: $04bbde81f62a5b57$var$isAsyncFn,
    isThenable: $04bbde81f62a5b57$var$isThenable,
    setImmediate: $04bbde81f62a5b57$var$_setImmediate,
    asap: $04bbde81f62a5b57$var$asap
};

});
parcelRegister("jSUas", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e79ea136caa62a21$export$2e2bcd8739ae039; });
'use strict';
function $e79ea136caa62a21$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("f8ZNS", function(module, exports) {
// shim for using process in browser
var $b0678b3df8cce278$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b0678b3df8cce278$var$cachedSetTimeout;
var $b0678b3df8cce278$var$cachedClearTimeout;
function $b0678b3df8cce278$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $b0678b3df8cce278$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $b0678b3df8cce278$var$cachedSetTimeout = setTimeout;
        else $b0678b3df8cce278$var$cachedSetTimeout = $b0678b3df8cce278$var$defaultSetTimout;
    } catch (e) {
        $b0678b3df8cce278$var$cachedSetTimeout = $b0678b3df8cce278$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $b0678b3df8cce278$var$cachedClearTimeout = clearTimeout;
        else $b0678b3df8cce278$var$cachedClearTimeout = $b0678b3df8cce278$var$defaultClearTimeout;
    } catch (e) {
        $b0678b3df8cce278$var$cachedClearTimeout = $b0678b3df8cce278$var$defaultClearTimeout;
    }
})();
function $b0678b3df8cce278$var$runTimeout(fun) {
    if ($b0678b3df8cce278$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b0678b3df8cce278$var$cachedSetTimeout === $b0678b3df8cce278$var$defaultSetTimout || !$b0678b3df8cce278$var$cachedSetTimeout) && setTimeout) {
        $b0678b3df8cce278$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b0678b3df8cce278$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b0678b3df8cce278$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b0678b3df8cce278$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b0678b3df8cce278$var$runClearTimeout(marker) {
    if ($b0678b3df8cce278$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b0678b3df8cce278$var$cachedClearTimeout === $b0678b3df8cce278$var$defaultClearTimeout || !$b0678b3df8cce278$var$cachedClearTimeout) && clearTimeout) {
        $b0678b3df8cce278$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b0678b3df8cce278$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b0678b3df8cce278$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b0678b3df8cce278$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b0678b3df8cce278$var$queue = [];
var $b0678b3df8cce278$var$draining = false;
var $b0678b3df8cce278$var$currentQueue;
var $b0678b3df8cce278$var$queueIndex = -1;
function $b0678b3df8cce278$var$cleanUpNextTick() {
    if (!$b0678b3df8cce278$var$draining || !$b0678b3df8cce278$var$currentQueue) return;
    $b0678b3df8cce278$var$draining = false;
    if ($b0678b3df8cce278$var$currentQueue.length) $b0678b3df8cce278$var$queue = $b0678b3df8cce278$var$currentQueue.concat($b0678b3df8cce278$var$queue);
    else $b0678b3df8cce278$var$queueIndex = -1;
    if ($b0678b3df8cce278$var$queue.length) $b0678b3df8cce278$var$drainQueue();
}
function $b0678b3df8cce278$var$drainQueue() {
    if ($b0678b3df8cce278$var$draining) return;
    var timeout = $b0678b3df8cce278$var$runTimeout($b0678b3df8cce278$var$cleanUpNextTick);
    $b0678b3df8cce278$var$draining = true;
    var len = $b0678b3df8cce278$var$queue.length;
    while(len){
        $b0678b3df8cce278$var$currentQueue = $b0678b3df8cce278$var$queue;
        $b0678b3df8cce278$var$queue = [];
        while(++$b0678b3df8cce278$var$queueIndex < len)if ($b0678b3df8cce278$var$currentQueue) $b0678b3df8cce278$var$currentQueue[$b0678b3df8cce278$var$queueIndex].run();
        $b0678b3df8cce278$var$queueIndex = -1;
        len = $b0678b3df8cce278$var$queue.length;
    }
    $b0678b3df8cce278$var$currentQueue = null;
    $b0678b3df8cce278$var$draining = false;
    $b0678b3df8cce278$var$runClearTimeout(timeout);
}
$b0678b3df8cce278$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b0678b3df8cce278$var$queue.push(new $b0678b3df8cce278$var$Item(fun, args));
    if ($b0678b3df8cce278$var$queue.length === 1 && !$b0678b3df8cce278$var$draining) $b0678b3df8cce278$var$runTimeout($b0678b3df8cce278$var$drainQueue);
};
// v8 likes predictible objects
function $b0678b3df8cce278$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b0678b3df8cce278$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b0678b3df8cce278$var$process.title = 'browser';
$b0678b3df8cce278$var$process.browser = true;
$b0678b3df8cce278$var$process.env = {};
$b0678b3df8cce278$var$process.argv = [];
$b0678b3df8cce278$var$process.version = ''; // empty string to avoid regexp issues
$b0678b3df8cce278$var$process.versions = {};
function $b0678b3df8cce278$var$noop() {}
$b0678b3df8cce278$var$process.on = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.addListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.once = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.off = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.removeListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.removeAllListeners = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.emit = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.prependListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.prependOnceListener = $b0678b3df8cce278$var$noop;
$b0678b3df8cce278$var$process.listeners = function(name) {
    return [];
};
$b0678b3df8cce278$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$b0678b3df8cce278$var$process.cwd = function() {
    return '/';
};
$b0678b3df8cce278$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$b0678b3df8cce278$var$process.umask = function() {
    return 0;
};

});


parcelRegister("lT31C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef114c15b6f67d7$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $9EAAy = parcelRequire("9EAAy");

var $j4USS = parcelRequire("j4USS");

var $1dKS6 = parcelRequire("1dKS6");

var $4mJfT = parcelRequire("4mJfT");

var $lJkMI = parcelRequire("lJkMI");

var $121Mm = parcelRequire("121Mm");

var $3V9hT = parcelRequire("3V9hT");
'use strict';
const $fef114c15b6f67d7$var$validators = (0, $121Mm.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $fef114c15b6f67d7$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $4mJfT.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $121Mm.default).assertOptions(transitional, {
            silentJSONParsing: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean),
            forcedJSONParsing: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean),
            clarifyTimeoutError: $fef114c15b6f67d7$var$validators.transitional($fef114c15b6f67d7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $pci3K.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $121Mm.default).assertOptions(paramsSerializer, {
                encode: $fef114c15b6f67d7$var$validators.function,
                serialize: $fef114c15b6f67d7$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $121Mm.default).assertOptions(config, {
            baseUrl: $fef114c15b6f67d7$var$validators.spelling('baseURL'),
            withXsrfToken: $fef114c15b6f67d7$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $pci3K.default).merge(headers.common, headers[config.method]);
        headers && (0, $pci3K.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $3V9hT.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1dKS6.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1dKS6.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $4mJfT.default)(this.defaults, config);
        const fullPath = (0, $lJkMI.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $9EAAy.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $j4USS.default)(),
            response: new (0, $j4USS.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $pci3K.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $fef114c15b6f67d7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4mJfT.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $pci3K.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4mJfT.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $fef114c15b6f67d7$var$Axios.prototype[method] = generateHTTPMethod();
    $fef114c15b6f67d7$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $fef114c15b6f67d7$export$2e2bcd8739ae039 = $fef114c15b6f67d7$var$Axios;

});
parcelRegister("9EAAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70743b323e147633$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $kskWj = parcelRequire("kskWj");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $70743b323e147633$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $70743b323e147633$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $70743b323e147633$var$encode;
    if ((0, $pci3K.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $pci3K.default).isURLSearchParams(params) ? params.toString() : new (0, $kskWj.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("kskWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee46aa53bf55783d$export$2e2bcd8739ae039; });

var $i2rBs = parcelRequire("i2rBs");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $ee46aa53bf55783d$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $ee46aa53bf55783d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $i2rBs.default)(params, this, options);
}
const $ee46aa53bf55783d$var$prototype = $ee46aa53bf55783d$var$AxiosURLSearchParams.prototype;
$ee46aa53bf55783d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$ee46aa53bf55783d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $ee46aa53bf55783d$var$encode);
    } : $ee46aa53bf55783d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $ee46aa53bf55783d$export$2e2bcd8739ae039 = $ee46aa53bf55783d$var$AxiosURLSearchParams;

});
parcelRegister("i2rBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d21dd3491a3fc4ae$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $gJraw = parcelRequire("gJraw");

var $a94H4 = parcelRequire("a94H4");
var $d21dd3491a3fc4ae$require$Buffer = $a94H4.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d21dd3491a3fc4ae$var$isVisitable(thing) {
    return (0, $pci3K.default).isPlainObject(thing) || (0, $pci3K.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d21dd3491a3fc4ae$var$removeBrackets(key) {
    return (0, $pci3K.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d21dd3491a3fc4ae$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d21dd3491a3fc4ae$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d21dd3491a3fc4ae$var$isFlatArray(arr) {
    return (0, $pci3K.default).isArray(arr) && !arr.some($d21dd3491a3fc4ae$var$isVisitable);
}
const $d21dd3491a3fc4ae$var$predicates = (0, $pci3K.default).toFlatObject((0, $pci3K.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d21dd3491a3fc4ae$var$toFormData(obj, formData, options) {
    if (!(0, $pci3K.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $gJraw.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $pci3K.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $pci3K.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $pci3K.default).isSpecCompliantForm(formData);
    if (!(0, $pci3K.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $pci3K.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $pci3K.default).isBlob(value)) throw new (0, $jdUqi.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $pci3K.default).isArrayBuffer(value) || (0, $pci3K.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $d21dd3491a3fc4ae$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $pci3K.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $pci3K.default).isArray(value) && $d21dd3491a3fc4ae$var$isFlatArray(value) || ((0, $pci3K.default).isFileList(value) || (0, $pci3K.default).endsWith(key, '[]')) && (arr = (0, $pci3K.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d21dd3491a3fc4ae$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $pci3K.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d21dd3491a3fc4ae$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d21dd3491a3fc4ae$var$isVisitable(value)) return true;
        formData.append($d21dd3491a3fc4ae$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d21dd3491a3fc4ae$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d21dd3491a3fc4ae$var$isVisitable
    });
    function build(value, path) {
        if ((0, $pci3K.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $pci3K.default).forEach(value, function each(el, key) {
            const result = !((0, $pci3K.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $pci3K.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $pci3K.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $d21dd3491a3fc4ae$export$2e2bcd8739ae039 = $d21dd3491a3fc4ae$var$toFormData;

});
parcelRegister("jdUqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfeaffaadb19a284$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $dfeaffaadb19a284$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $pci3K.default).inherits($dfeaffaadb19a284$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $pci3K.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $dfeaffaadb19a284$var$prototype = $dfeaffaadb19a284$var$AxiosError.prototype;
const $dfeaffaadb19a284$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $dfeaffaadb19a284$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($dfeaffaadb19a284$var$AxiosError, $dfeaffaadb19a284$var$descriptors);
Object.defineProperty($dfeaffaadb19a284$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$dfeaffaadb19a284$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($dfeaffaadb19a284$var$prototype);
    (0, $pci3K.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $dfeaffaadb19a284$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $dfeaffaadb19a284$export$2e2bcd8739ae039 = $dfeaffaadb19a284$var$AxiosError;

});

parcelRegister("gJraw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e5ec71ec6e794f$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $c2e5ec71ec6e794f$export$2e2bcd8739ae039 = null;

});

parcelRegister("a94H4", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $762e62bc52707674$export$a143d493d941bafc; }, function (v) { return $762e62bc52707674$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $762e62bc52707674$export$f99ded8fe4b79145; }, function (v) { return $762e62bc52707674$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $762e62bc52707674$export$a143d493d941bafc;
var $762e62bc52707674$export$e4cf37d7f6fb9e0a;
var $762e62bc52707674$export$f99ded8fe4b79145;
var $762e62bc52707674$export$599f31c3813fae4d;
'use strict';

var $82Ig9 = parcelRequire("82Ig9");

var $awgx0 = parcelRequire("awgx0");
const $762e62bc52707674$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$762e62bc52707674$export$a143d493d941bafc = $762e62bc52707674$var$Buffer;
$762e62bc52707674$export$e4cf37d7f6fb9e0a = $762e62bc52707674$var$SlowBuffer;
$762e62bc52707674$export$f99ded8fe4b79145 = 50;
const $762e62bc52707674$var$K_MAX_LENGTH = 0x7fffffff;
$762e62bc52707674$export$599f31c3813fae4d = $762e62bc52707674$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $762e62bc52707674$var$Buffer.TYPED_ARRAY_SUPPORT = $762e62bc52707674$var$typedArraySupport();
if (!$762e62bc52707674$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $762e62bc52707674$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($762e62bc52707674$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$762e62bc52707674$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($762e62bc52707674$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$762e62bc52707674$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $762e62bc52707674$var$createBuffer(length) {
    if (length > $762e62bc52707674$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $762e62bc52707674$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $762e62bc52707674$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $762e62bc52707674$var$allocUnsafe(arg);
    }
    return $762e62bc52707674$var$from(arg, encodingOrOffset, length);
}
$762e62bc52707674$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $762e62bc52707674$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $762e62bc52707674$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $762e62bc52707674$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($762e62bc52707674$var$isInstance(value, ArrayBuffer) || value && $762e62bc52707674$var$isInstance(value.buffer, ArrayBuffer)) return $762e62bc52707674$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($762e62bc52707674$var$isInstance(value, SharedArrayBuffer) || value && $762e62bc52707674$var$isInstance(value.buffer, SharedArrayBuffer))) return $762e62bc52707674$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $762e62bc52707674$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $762e62bc52707674$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $762e62bc52707674$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $762e62bc52707674$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $762e62bc52707674$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($762e62bc52707674$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($762e62bc52707674$var$Buffer, Uint8Array);
function $762e62bc52707674$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $762e62bc52707674$var$alloc(size, fill, encoding) {
    $762e62bc52707674$var$assertSize(size);
    if (size <= 0) return $762e62bc52707674$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $762e62bc52707674$var$createBuffer(size).fill(fill, encoding) : $762e62bc52707674$var$createBuffer(size).fill(fill);
    return $762e62bc52707674$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $762e62bc52707674$var$Buffer.alloc = function(size, fill, encoding) {
    return $762e62bc52707674$var$alloc(size, fill, encoding);
};
function $762e62bc52707674$var$allocUnsafe(size) {
    $762e62bc52707674$var$assertSize(size);
    return $762e62bc52707674$var$createBuffer(size < 0 ? 0 : $762e62bc52707674$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $762e62bc52707674$var$Buffer.allocUnsafe = function(size) {
    return $762e62bc52707674$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $762e62bc52707674$var$Buffer.allocUnsafeSlow = function(size) {
    return $762e62bc52707674$var$allocUnsafe(size);
};
function $762e62bc52707674$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$762e62bc52707674$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $762e62bc52707674$var$byteLength(string, encoding) | 0;
    let buf = $762e62bc52707674$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $762e62bc52707674$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $762e62bc52707674$var$checked(array.length) | 0;
    const buf = $762e62bc52707674$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $762e62bc52707674$var$fromArrayView(arrayView) {
    if ($762e62bc52707674$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $762e62bc52707674$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $762e62bc52707674$var$fromArrayLike(arrayView);
}
function $762e62bc52707674$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $762e62bc52707674$var$Buffer.prototype);
    return buf;
}
function $762e62bc52707674$var$fromObject(obj) {
    if ($762e62bc52707674$var$Buffer.isBuffer(obj)) {
        const len = $762e62bc52707674$var$checked(obj.length) | 0;
        const buf = $762e62bc52707674$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $762e62bc52707674$var$numberIsNaN(obj.length)) return $762e62bc52707674$var$createBuffer(0);
        return $762e62bc52707674$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $762e62bc52707674$var$fromArrayLike(obj.data);
}
function $762e62bc52707674$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $762e62bc52707674$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $762e62bc52707674$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $762e62bc52707674$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $762e62bc52707674$var$Buffer.alloc(+length);
}
$762e62bc52707674$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $762e62bc52707674$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$762e62bc52707674$var$Buffer.compare = function compare(a, b) {
    if ($762e62bc52707674$var$isInstance(a, Uint8Array)) a = $762e62bc52707674$var$Buffer.from(a, a.offset, a.byteLength);
    if ($762e62bc52707674$var$isInstance(b, Uint8Array)) b = $762e62bc52707674$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$762e62bc52707674$var$Buffer.isBuffer(a) || !$762e62bc52707674$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$762e62bc52707674$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$762e62bc52707674$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $762e62bc52707674$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $762e62bc52707674$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($762e62bc52707674$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) buf = $762e62bc52707674$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $762e62bc52707674$var$byteLength(string, encoding) {
    if ($762e62bc52707674$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $762e62bc52707674$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $762e62bc52707674$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $762e62bc52707674$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $762e62bc52707674$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$762e62bc52707674$var$Buffer.byteLength = $762e62bc52707674$var$byteLength;
function $762e62bc52707674$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $762e62bc52707674$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $762e62bc52707674$var$utf8Slice(this, start, end);
        case 'ascii':
            return $762e62bc52707674$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $762e62bc52707674$var$latin1Slice(this, start, end);
        case 'base64':
            return $762e62bc52707674$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $762e62bc52707674$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$762e62bc52707674$var$Buffer.prototype._isBuffer = true;
function $762e62bc52707674$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$762e62bc52707674$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$762e62bc52707674$var$swap(this, i, i + 1);
    return this;
};
$762e62bc52707674$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $762e62bc52707674$var$swap(this, i, i + 3);
        $762e62bc52707674$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$762e62bc52707674$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $762e62bc52707674$var$swap(this, i, i + 7);
        $762e62bc52707674$var$swap(this, i + 1, i + 6);
        $762e62bc52707674$var$swap(this, i + 2, i + 5);
        $762e62bc52707674$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$762e62bc52707674$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $762e62bc52707674$var$utf8Slice(this, 0, length);
    return $762e62bc52707674$var$slowToString.apply(this, arguments);
};
$762e62bc52707674$var$Buffer.prototype.toLocaleString = $762e62bc52707674$var$Buffer.prototype.toString;
$762e62bc52707674$var$Buffer.prototype.equals = function equals(b) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $762e62bc52707674$var$Buffer.compare(this, b) === 0;
};
$762e62bc52707674$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $762e62bc52707674$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($762e62bc52707674$var$customInspectSymbol) $762e62bc52707674$var$Buffer.prototype[$762e62bc52707674$var$customInspectSymbol] = $762e62bc52707674$var$Buffer.prototype.inspect;
$762e62bc52707674$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($762e62bc52707674$var$isInstance(target, Uint8Array)) target = $762e62bc52707674$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$762e62bc52707674$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $762e62bc52707674$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($762e62bc52707674$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $762e62bc52707674$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($762e62bc52707674$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $762e62bc52707674$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $762e62bc52707674$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $762e62bc52707674$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$762e62bc52707674$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$762e62bc52707674$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $762e62bc52707674$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$762e62bc52707674$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $762e62bc52707674$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $762e62bc52707674$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($762e62bc52707674$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $762e62bc52707674$var$utf8Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $762e62bc52707674$var$asciiWrite(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$asciiToBytes(string), buf, offset, length);
}
function $762e62bc52707674$var$base64Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$base64ToBytes(string), buf, offset, length);
}
function $762e62bc52707674$var$ucs2Write(buf, string, offset, length) {
    return $762e62bc52707674$var$blitBuffer($762e62bc52707674$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$762e62bc52707674$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $762e62bc52707674$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $762e62bc52707674$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $762e62bc52707674$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $762e62bc52707674$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $762e62bc52707674$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$762e62bc52707674$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $762e62bc52707674$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $82Ig9.fromByteArray(buf);
    else return $82Ig9.fromByteArray(buf.slice(start, end));
}
function $762e62bc52707674$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $762e62bc52707674$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $762e62bc52707674$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $762e62bc52707674$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $762e62bc52707674$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $762e62bc52707674$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $762e62bc52707674$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $762e62bc52707674$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $762e62bc52707674$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$762e62bc52707674$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $762e62bc52707674$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $762e62bc52707674$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$762e62bc52707674$var$Buffer.prototype.readUintLE = $762e62bc52707674$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readUintBE = $762e62bc52707674$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readUint8 = $762e62bc52707674$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$762e62bc52707674$var$Buffer.prototype.readUint16LE = $762e62bc52707674$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$762e62bc52707674$var$Buffer.prototype.readUint16BE = $762e62bc52707674$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$762e62bc52707674$var$Buffer.prototype.readUint32LE = $762e62bc52707674$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$762e62bc52707674$var$Buffer.prototype.readUint32BE = $762e62bc52707674$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$762e62bc52707674$var$Buffer.prototype.readBigUInt64LE = $762e62bc52707674$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$762e62bc52707674$var$Buffer.prototype.readBigUInt64BE = $762e62bc52707674$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$762e62bc52707674$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$762e62bc52707674$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$762e62bc52707674$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$762e62bc52707674$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$762e62bc52707674$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$762e62bc52707674$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$762e62bc52707674$var$Buffer.prototype.readBigInt64LE = $762e62bc52707674$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$762e62bc52707674$var$Buffer.prototype.readBigInt64BE = $762e62bc52707674$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $762e62bc52707674$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $762e62bc52707674$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$762e62bc52707674$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return $awgx0.read(this, offset, true, 23, 4);
};
$762e62bc52707674$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 4, this.length);
    return $awgx0.read(this, offset, false, 23, 4);
};
$762e62bc52707674$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 8, this.length);
    return $awgx0.read(this, offset, true, 52, 8);
};
$762e62bc52707674$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkOffset(offset, 8, this.length);
    return $awgx0.read(this, offset, false, 52, 8);
};
function $762e62bc52707674$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$762e62bc52707674$var$Buffer.prototype.writeUintLE = $762e62bc52707674$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeUintBE = $762e62bc52707674$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeUint8 = $762e62bc52707674$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$762e62bc52707674$var$Buffer.prototype.writeUint16LE = $762e62bc52707674$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeUint16BE = $762e62bc52707674$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeUint32LE = $762e62bc52707674$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeUint32BE = $762e62bc52707674$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $762e62bc52707674$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $762e62bc52707674$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$762e62bc52707674$var$Buffer.prototype.writeBigUInt64LE = $762e62bc52707674$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$762e62bc52707674$var$Buffer.prototype.writeBigUInt64BE = $762e62bc52707674$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$762e62bc52707674$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $762e62bc52707674$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$762e62bc52707674$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$762e62bc52707674$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$762e62bc52707674$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$762e62bc52707674$var$Buffer.prototype.writeBigInt64LE = $762e62bc52707674$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$762e62bc52707674$var$Buffer.prototype.writeBigInt64BE = $762e62bc52707674$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $762e62bc52707674$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $762e62bc52707674$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $762e62bc52707674$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $awgx0.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$762e62bc52707674$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeFloat(this, value, offset, true, noAssert);
};
$762e62bc52707674$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeFloat(this, value, offset, false, noAssert);
};
function $762e62bc52707674$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $762e62bc52707674$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $awgx0.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$762e62bc52707674$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeDouble(this, value, offset, true, noAssert);
};
$762e62bc52707674$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $762e62bc52707674$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$762e62bc52707674$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$762e62bc52707674$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$762e62bc52707674$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$762e62bc52707674$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $762e62bc52707674$var$Buffer.isBuffer(val) ? val : $762e62bc52707674$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $762e62bc52707674$var$errors = {};
function $762e62bc52707674$var$E(sym, getMessage, Base) {
    $762e62bc52707674$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$762e62bc52707674$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$762e62bc52707674$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$762e62bc52707674$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $762e62bc52707674$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $762e62bc52707674$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $762e62bc52707674$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $762e62bc52707674$var$checkBounds(buf, offset, byteLength) {
    $762e62bc52707674$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $762e62bc52707674$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $762e62bc52707674$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $762e62bc52707674$var$checkBounds(buf, offset, byteLength);
}
function $762e62bc52707674$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $762e62bc52707674$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $762e62bc52707674$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $762e62bc52707674$var$validateNumber(value, type);
        throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $762e62bc52707674$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $762e62bc52707674$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $762e62bc52707674$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $762e62bc52707674$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($762e62bc52707674$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $762e62bc52707674$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $762e62bc52707674$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $762e62bc52707674$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $762e62bc52707674$var$base64ToBytes(str) {
    return $82Ig9.toByteArray($762e62bc52707674$var$base64clean(str));
}
function $762e62bc52707674$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $762e62bc52707674$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $762e62bc52707674$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $762e62bc52707674$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $762e62bc52707674$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $762e62bc52707674$var$BufferBigIntNotDefined : fn;
}
function $762e62bc52707674$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("82Ig9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5db0d7a96cab63b5$export$d622b2ad8d90c771; }, function (v) { return $5db0d7a96cab63b5$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5db0d7a96cab63b5$export$6100ba28696e12de; }, function (v) { return $5db0d7a96cab63b5$export$6100ba28696e12de = v; });
var $5db0d7a96cab63b5$export$a48f0734ac7c2329;
var $5db0d7a96cab63b5$export$d622b2ad8d90c771;
var $5db0d7a96cab63b5$export$6100ba28696e12de;
'use strict';
$5db0d7a96cab63b5$export$a48f0734ac7c2329 = $5db0d7a96cab63b5$var$byteLength;
$5db0d7a96cab63b5$export$d622b2ad8d90c771 = $5db0d7a96cab63b5$var$toByteArray;
$5db0d7a96cab63b5$export$6100ba28696e12de = $5db0d7a96cab63b5$var$fromByteArray;
var $5db0d7a96cab63b5$var$lookup = [];
var $5db0d7a96cab63b5$var$revLookup = [];
var $5db0d7a96cab63b5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5db0d7a96cab63b5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5db0d7a96cab63b5$var$i = 0, $5db0d7a96cab63b5$var$len = $5db0d7a96cab63b5$var$code.length; $5db0d7a96cab63b5$var$i < $5db0d7a96cab63b5$var$len; ++$5db0d7a96cab63b5$var$i){
    $5db0d7a96cab63b5$var$lookup[$5db0d7a96cab63b5$var$i] = $5db0d7a96cab63b5$var$code[$5db0d7a96cab63b5$var$i];
    $5db0d7a96cab63b5$var$revLookup[$5db0d7a96cab63b5$var$code.charCodeAt($5db0d7a96cab63b5$var$i)] = $5db0d7a96cab63b5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5db0d7a96cab63b5$var$revLookup['-'.charCodeAt(0)] = 62;
$5db0d7a96cab63b5$var$revLookup['_'.charCodeAt(0)] = 63;
function $5db0d7a96cab63b5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5db0d7a96cab63b5$var$byteLength(b64) {
    var lens = $5db0d7a96cab63b5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5db0d7a96cab63b5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5db0d7a96cab63b5$var$toByteArray(b64) {
    var tmp;
    var lens = $5db0d7a96cab63b5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5db0d7a96cab63b5$var$Arr($5db0d7a96cab63b5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 18 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 2 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i)] << 10 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5db0d7a96cab63b5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5db0d7a96cab63b5$var$tripletToBase64(num) {
    return $5db0d7a96cab63b5$var$lookup[num >> 18 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num >> 12 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num >> 6 & 0x3F] + $5db0d7a96cab63b5$var$lookup[num & 0x3F];
}
function $5db0d7a96cab63b5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5db0d7a96cab63b5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5db0d7a96cab63b5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5db0d7a96cab63b5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5db0d7a96cab63b5$var$lookup[tmp >> 2] + $5db0d7a96cab63b5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5db0d7a96cab63b5$var$lookup[tmp >> 10] + $5db0d7a96cab63b5$var$lookup[tmp >> 4 & 0x3F] + $5db0d7a96cab63b5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("awgx0", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $7a89b7596093d253$export$aafa59e2e03f2942; }, function (v) { return $7a89b7596093d253$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $7a89b7596093d253$export$68d8715fc104d294; }, function (v) { return $7a89b7596093d253$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7a89b7596093d253$export$aafa59e2e03f2942;
var $7a89b7596093d253$export$68d8715fc104d294;
$7a89b7596093d253$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7a89b7596093d253$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("j4USS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3a840601a5769e$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
'use strict';
class $de3a840601a5769e$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $pci3K.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $de3a840601a5769e$export$2e2bcd8739ae039 = $de3a840601a5769e$var$InterceptorManager;

});

parcelRegister("1dKS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e3b5d0ffe790033$export$2e2bcd8739ae039; });

var $9IlbM = parcelRequire("9IlbM");

var $2v382 = parcelRequire("2v382");

var $gGIev = parcelRequire("gGIev");

var $82h0N = parcelRequire("82h0N");

var $3V9hT = parcelRequire("3V9hT");

var $ekUJE = parcelRequire("ekUJE");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $0e3b5d0ffe790033$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $82h0N.default)(null, config);
}
function $0e3b5d0ffe790033$export$2e2bcd8739ae039(config) {
    $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
    config.headers = (0, $3V9hT.default).from(config.headers);
    // Transform request data
    config.data = (0, $9IlbM.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ekUJE.default).getAdapter(config.adapter || (0, $gGIev.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $9IlbM.default).call(config, config.transformResponse, response);
        response.headers = (0, $3V9hT.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2v382.default)(reason)) {
            $0e3b5d0ffe790033$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $9IlbM.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $3V9hT.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("9IlbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7128a8cf059b6df6$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $gGIev = parcelRequire("gGIev");

var $3V9hT = parcelRequire("3V9hT");
'use strict';
function $7128a8cf059b6df6$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $gGIev.default);
    const context = response || config;
    const headers = (0, $3V9hT.default).from(context.headers);
    let data = context.data;
    (0, $pci3K.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("gGIev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c262e1575c2b2818$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $jriIr = parcelRequire("jriIr");

var $i2rBs = parcelRequire("i2rBs");

var $1TxvX = parcelRequire("1TxvX");

var $66BHH = parcelRequire("66BHH");

var $e4j5G = parcelRequire("e4j5G");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c262e1575c2b2818$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $pci3K.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $pci3K.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c262e1575c2b2818$var$defaults = {
    transitional: (0, $jriIr.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $pci3K.default).isObject(data);
            if (isObjectPayload && (0, $pci3K.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $pci3K.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $e4j5G.default)(data)) : data;
            if ((0, $pci3K.default).isArrayBuffer(data) || (0, $pci3K.default).isBuffer(data) || (0, $pci3K.default).isStream(data) || (0, $pci3K.default).isFile(data) || (0, $pci3K.default).isBlob(data) || (0, $pci3K.default).isReadableStream(data)) return data;
            if ((0, $pci3K.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $pci3K.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $1TxvX.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $pci3K.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $i2rBs.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $c262e1575c2b2818$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $c262e1575c2b2818$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $pci3K.default).isResponse(data) || (0, $pci3K.default).isReadableStream(data)) return data;
            if (data && (0, $pci3K.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $jdUqi.default).from(e, (0, $jdUqi.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $66BHH.default).classes.FormData,
        Blob: (0, $66BHH.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $pci3K.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $c262e1575c2b2818$var$defaults.headers[method] = {};
});
var $c262e1575c2b2818$export$2e2bcd8739ae039 = $c262e1575c2b2818$var$defaults;

});
parcelRegister("jriIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e26f0e841b32bf7f$export$2e2bcd8739ae039; });
'use strict';
var $e26f0e841b32bf7f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("1TxvX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1614ecc4ad5f1e47$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $i2rBs = parcelRequire("i2rBs");

var $66BHH = parcelRequire("66BHH");
'use strict';
function $1614ecc4ad5f1e47$export$2e2bcd8739ae039(data, options) {
    return (0, $i2rBs.default)(data, new (0, $66BHH.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $66BHH.default).isNode && (0, $pci3K.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("66BHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47208ccc9dfa862e$export$2e2bcd8739ae039; });

var $aqRTH = parcelRequire("aqRTH");

var $7iFsh = parcelRequire("7iFsh");
var $47208ccc9dfa862e$export$2e2bcd8739ae039 = {
    ...$7iFsh,
    ...(0, $aqRTH.default)
};

});
parcelRegister("aqRTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $798623f976f1919b$export$2e2bcd8739ae039; });

var $2AvpN = parcelRequire("2AvpN");

var $cgjvw = parcelRequire("cgjvw");

var $hqwKZ = parcelRequire("hqwKZ");
var $798623f976f1919b$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $2AvpN.default,
        FormData: $cgjvw.default,
        Blob: $hqwKZ.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("2AvpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e274fee22f2affa$export$2e2bcd8739ae039; });

var $kskWj = parcelRequire("kskWj");
'use strict';
var $1e274fee22f2affa$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $kskWj.default);

});

parcelRegister("cgjvw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed61c72a76d48f8$export$2e2bcd8739ae039; });
'use strict';
var $8ed61c72a76d48f8$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("hqwKZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafe463d1ead3ee5$export$2e2bcd8739ae039; });
'use strict';
var $cafe463d1ead3ee5$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7iFsh", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $550a5efe63dbf3a9$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $550a5efe63dbf3a9$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $550a5efe63dbf3a9$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $550a5efe63dbf3a9$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $550a5efe63dbf3a9$export$f710a83a91838a36; });
const $550a5efe63dbf3a9$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $550a5efe63dbf3a9$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $550a5efe63dbf3a9$export$c0bcc9250309d66 = $550a5efe63dbf3a9$export$c4996c4b7b93b0bf && (!$550a5efe63dbf3a9$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($550a5efe63dbf3a9$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $550a5efe63dbf3a9$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $550a5efe63dbf3a9$export$f710a83a91838a36 = $550a5efe63dbf3a9$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("e4j5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3e03f6a4d69f3ca$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a3e03f6a4d69f3ca$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $pci3K.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a3e03f6a4d69f3ca$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a3e03f6a4d69f3ca$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $pci3K.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $pci3K.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $pci3K.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $pci3K.default).isArray(target[name])) target[name] = $a3e03f6a4d69f3ca$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $pci3K.default).isFormData(formData) && (0, $pci3K.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $pci3K.default).forEachEntry(formData, (name, value)=>{
            buildPath($a3e03f6a4d69f3ca$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a3e03f6a4d69f3ca$export$2e2bcd8739ae039 = $a3e03f6a4d69f3ca$var$formDataToJSON;

});


parcelRegister("3V9hT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dade64a2caaec98$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $20sPJ = parcelRequire("20sPJ");
'use strict';
const $2dade64a2caaec98$var$$internals = Symbol('internals');
function $2dade64a2caaec98$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2dade64a2caaec98$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $pci3K.default).isArray(value) ? value.map($2dade64a2caaec98$var$normalizeValue) : String(value);
}
function $2dade64a2caaec98$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2dade64a2caaec98$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2dade64a2caaec98$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $pci3K.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $pci3K.default).isString(value)) return;
    if ((0, $pci3K.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $pci3K.default).isRegExp(filter)) return filter.test(value);
}
function $2dade64a2caaec98$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2dade64a2caaec98$var$buildAccessors(obj, header) {
    const accessorName = (0, $pci3K.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2dade64a2caaec98$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $pci3K.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2dade64a2caaec98$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $pci3K.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $pci3K.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $pci3K.default).isString(header) && (header = header.trim()) && !$2dade64a2caaec98$var$isValidHeaderName(header)) setHeaders((0, $20sPJ.default)(header), valueOrRewrite);
        else if ((0, $pci3K.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2dade64a2caaec98$var$normalizeHeader(header);
        if (header) {
            const key = (0, $pci3K.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2dade64a2caaec98$var$parseTokens(value);
                if ((0, $pci3K.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $pci3K.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $2dade64a2caaec98$var$normalizeHeader(header);
        if (header) {
            const key = (0, $pci3K.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2dade64a2caaec98$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $pci3K.default).findKey(self, _header);
                if (key && (!matcher || $2dade64a2caaec98$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $pci3K.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2dade64a2caaec98$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $pci3K.default).forEach(this, (value, header)=>{
            const key = (0, $pci3K.default).findKey(headers, header);
            if (key) {
                self[key] = $2dade64a2caaec98$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2dade64a2caaec98$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2dade64a2caaec98$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $pci3K.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $pci3K.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2dade64a2caaec98$var$$internals] = this[$2dade64a2caaec98$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2dade64a2caaec98$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2dade64a2caaec98$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $pci3K.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$2dade64a2caaec98$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $pci3K.default).reduceDescriptors($2dade64a2caaec98$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $pci3K.default).freezeMethods($2dade64a2caaec98$var$AxiosHeaders);
var $2dade64a2caaec98$export$2e2bcd8739ae039 = $2dade64a2caaec98$var$AxiosHeaders;

});
parcelRegister("20sPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1761f28f3d84bf08$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $1761f28f3d84bf08$var$ignoreDuplicateOf = (0, $pci3K.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $1761f28f3d84bf08$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $1761f28f3d84bf08$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("2v382", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d20e7516bc422d6$export$2e2bcd8739ae039; });
'use strict';
function $1d20e7516bc422d6$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("82h0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d9bb4d7f700c43f$export$2e2bcd8739ae039; });

var $jdUqi = parcelRequire("jdUqi");

var $pci3K = parcelRequire("pci3K");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5d9bb4d7f700c43f$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $jdUqi.default).call(this, message == null ? 'canceled' : message, (0, $jdUqi.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $pci3K.default).inherits($5d9bb4d7f700c43f$var$CanceledError, (0, $jdUqi.default), {
    __CANCEL__: true
});
var $5d9bb4d7f700c43f$export$2e2bcd8739ae039 = $5d9bb4d7f700c43f$var$CanceledError;

});

parcelRegister("ekUJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fef15eee491476$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $gJraw = parcelRequire("gJraw");

var $e19rN = parcelRequire("e19rN");

var $223Mb = parcelRequire("223Mb");

var $jdUqi = parcelRequire("jdUqi");
const $a6fef15eee491476$var$knownAdapters = {
    http: (0, $gJraw.default),
    xhr: (0, $e19rN.default),
    fetch: (0, $223Mb.default)
};
(0, $pci3K.default).forEach($a6fef15eee491476$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $a6fef15eee491476$var$renderReason = (reason)=>`- ${reason}`;
const $a6fef15eee491476$var$isResolvedHandle = (adapter)=>(0, $pci3K.default).isFunction(adapter) || adapter === null || adapter === false;
var $a6fef15eee491476$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $pci3K.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a6fef15eee491476$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a6fef15eee491476$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $jdUqi.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($a6fef15eee491476$var$renderReason).join('\n') : ' ' + $a6fef15eee491476$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $jdUqi.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $a6fef15eee491476$var$knownAdapters
};

});
parcelRegister("e19rN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3487cbc89bd0978$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $6DPL7 = parcelRequire("6DPL7");

var $jriIr = parcelRequire("jriIr");

var $jdUqi = parcelRequire("jdUqi");

var $82h0N = parcelRequire("82h0N");

var $3lsUt = parcelRequire("3lsUt");

var $66BHH = parcelRequire("66BHH");

var $3V9hT = parcelRequire("3V9hT");

var $kGLeM = parcelRequire("kGLeM");

var $kXlMv = parcelRequire("kXlMv");
const $a3487cbc89bd0978$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a3487cbc89bd0978$export$2e2bcd8739ae039 = $a3487cbc89bd0978$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $kXlMv.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $3V9hT.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $3V9hT.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $6DPL7.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $jdUqi.default)('Request aborted', (0, $jdUqi.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $jdUqi.default)('Network Error', (0, $jdUqi.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $jriIr.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $jdUqi.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $jdUqi.default).ETIMEDOUT : (0, $jdUqi.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $pci3K.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $pci3K.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $kGLeM.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $kGLeM.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $82h0N.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $3lsUt.default)(_config.url);
        if (protocol && (0, $66BHH.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $jdUqi.default)('Unsupported protocol ' + protocol + ':', (0, $jdUqi.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("6DPL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d5e88df11592ed8$export$2e2bcd8739ae039; });

var $jdUqi = parcelRequire("jdUqi");
'use strict';
function $4d5e88df11592ed8$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $jdUqi.default)('Request failed with status code ' + response.status, [
        (0, $jdUqi.default).ERR_BAD_REQUEST,
        (0, $jdUqi.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("3lsUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f9c226a90c9425$export$2e2bcd8739ae039; });
'use strict';
function $26f9c226a90c9425$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("kGLeM", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $f0fc5f4288818cb0$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $f0fc5f4288818cb0$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $f0fc5f4288818cb0$export$5d35863c355a22a9; });

var $dTgiS = parcelRequire("dTgiS");

var $3Emrv = parcelRequire("3Emrv");

var $pci3K = parcelRequire("pci3K");
const $f0fc5f4288818cb0$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $dTgiS.default)(50, 250);
    return (0, $3Emrv.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $f0fc5f4288818cb0$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $f0fc5f4288818cb0$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $pci3K.default).asap(()=>fn(...args));

});
parcelRegister("dTgiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1cd0ef492c22059$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1cd0ef492c22059$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1cd0ef492c22059$export$2e2bcd8739ae039 = $a1cd0ef492c22059$var$speedometer;

});

parcelRegister("3Emrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a868430fff916ba$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2a868430fff916ba$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2a868430fff916ba$export$2e2bcd8739ae039 = $2a868430fff916ba$var$throttle;

});


parcelRegister("kXlMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41a36a8254ee805$export$2e2bcd8739ae039; });

var $66BHH = parcelRequire("66BHH");

var $pci3K = parcelRequire("pci3K");

var $kCPPq = parcelRequire("kCPPq");

var $jxWsx = parcelRequire("jxWsx");

var $lJkMI = parcelRequire("lJkMI");

var $4mJfT = parcelRequire("4mJfT");

var $3V9hT = parcelRequire("3V9hT");

var $9EAAy = parcelRequire("9EAAy");
var $f41a36a8254ee805$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $4mJfT.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $3V9hT.default).from(headers);
    newConfig.url = (0, $9EAAy.default)((0, $lJkMI.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $pci3K.default).isFormData(data)) {
        if ((0, $66BHH.default).hasStandardBrowserEnv || (0, $66BHH.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $66BHH.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $pci3K.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $kCPPq.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $jxWsx.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("kCPPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f03f8f4d92ae9bdf$export$2e2bcd8739ae039; });

var $66BHH = parcelRequire("66BHH");
var $f03f8f4d92ae9bdf$export$2e2bcd8739ae039 = (0, $66BHH.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $66BHH.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $66BHH.default).origin), (0, $66BHH.default).navigator && /(msie|trident)/i.test((0, $66BHH.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("jxWsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3ae722d856af038$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $66BHH = parcelRequire("66BHH");
var $e3ae722d856af038$export$2e2bcd8739ae039 = (0, $66BHH.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $pci3K.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $pci3K.default).isString(path) && cookie.push('path=' + path);
        (0, $pci3K.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("lJkMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1dec58a8c6c17d$export$2e2bcd8739ae039; });

var $pvQE7 = parcelRequire("pvQE7");

var $kSJaN = parcelRequire("kSJaN");
'use strict';
function $fd1dec58a8c6c17d$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $pvQE7.default)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $kSJaN.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("pvQE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04cb0a4a1ff44deb$export$2e2bcd8739ae039; });
'use strict';
function $04cb0a4a1ff44deb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("kSJaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33be43c2be54ac7$export$2e2bcd8739ae039; });
'use strict';
function $f33be43c2be54ac7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("4mJfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32dc523f48a8a3ad$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");

var $3V9hT = parcelRequire("3V9hT");
'use strict';
const $32dc523f48a8a3ad$var$headersToObject = (thing)=>thing instanceof (0, $3V9hT.default) ? {
        ...thing
    } : thing;
function $32dc523f48a8a3ad$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $pci3K.default).isPlainObject(target) && (0, $pci3K.default).isPlainObject(source)) return (0, $pci3K.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $pci3K.default).isPlainObject(source)) return (0, $pci3K.default).merge({}, source);
        else if ((0, $pci3K.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $pci3K.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $pci3K.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $pci3K.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($32dc523f48a8a3ad$var$headersToObject(a), $32dc523f48a8a3ad$var$headersToObject(b), prop, true)
    };
    (0, $pci3K.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $pci3K.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("223Mb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17aeb28412910353$export$2e2bcd8739ae039; });

var $66BHH = parcelRequire("66BHH");

var $pci3K = parcelRequire("pci3K");

var $jdUqi = parcelRequire("jdUqi");

var $fdt1W = parcelRequire("fdt1W");

var $dWNSC = parcelRequire("dWNSC");

var $3V9hT = parcelRequire("3V9hT");

var $kGLeM = parcelRequire("kGLeM");

var $kXlMv = parcelRequire("kXlMv");

var $6DPL7 = parcelRequire("6DPL7");
const $17aeb28412910353$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $17aeb28412910353$var$isReadableStreamSupported = $17aeb28412910353$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $17aeb28412910353$var$encodeText = $17aeb28412910353$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $17aeb28412910353$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $17aeb28412910353$var$supportsRequestStream = $17aeb28412910353$var$isReadableStreamSupported && $17aeb28412910353$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $66BHH.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $17aeb28412910353$var$DEFAULT_CHUNK_SIZE = 65536;
const $17aeb28412910353$var$supportsResponseStream = $17aeb28412910353$var$isReadableStreamSupported && $17aeb28412910353$var$test(()=>(0, $pci3K.default).isReadableStream(new Response('').body));
const $17aeb28412910353$var$resolvers = {
    stream: $17aeb28412910353$var$supportsResponseStream && ((res)=>res.body)
};
$17aeb28412910353$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$17aeb28412910353$var$resolvers[type] && ($17aeb28412910353$var$resolvers[type] = (0, $pci3K.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $jdUqi.default)(`Response type '${type}' is not supported`, (0, $jdUqi.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $17aeb28412910353$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $pci3K.default).isBlob(body)) return body.size;
    if ((0, $pci3K.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $66BHH.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $pci3K.default).isArrayBufferView(body) || (0, $pci3K.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $pci3K.default).isURLSearchParams(body)) body = body + '';
    if ((0, $pci3K.default).isString(body)) return (await $17aeb28412910353$var$encodeText(body)).byteLength;
};
const $17aeb28412910353$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $pci3K.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $17aeb28412910353$var$getBodyLength(body) : length;
};
var $17aeb28412910353$export$2e2bcd8739ae039 = $17aeb28412910353$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $kXlMv.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $fdt1W.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $17aeb28412910353$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $17aeb28412910353$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $pci3K.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $kGLeM.progressEventDecorator)(requestContentLength, (0, $kGLeM.progressEventReducer)((0, $kGLeM.asyncDecorator)(onUploadProgress)));
                data = (0, $dWNSC.trackStream)(_request.body, $17aeb28412910353$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $pci3K.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $17aeb28412910353$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($17aeb28412910353$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $pci3K.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $kGLeM.progressEventDecorator)(responseContentLength, (0, $kGLeM.progressEventReducer)((0, $kGLeM.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $dWNSC.trackStream)(response.body, $17aeb28412910353$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $17aeb28412910353$var$resolvers[(0, $pci3K.default).findKey($17aeb28412910353$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $6DPL7.default)(resolve, reject, {
                data: responseData,
                headers: (0, $3V9hT.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $jdUqi.default)('Network Error', (0, $jdUqi.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $jdUqi.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("fdt1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13e96be51450e73$export$2e2bcd8739ae039; });

var $82h0N = parcelRequire("82h0N");

var $jdUqi = parcelRequire("jdUqi");

var $pci3K = parcelRequire("pci3K");
const $b13e96be51450e73$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $jdUqi.default) ? err : new (0, $82h0N.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $jdUqi.default)(`timeout ${timeout} of ms exceeded`, (0, $jdUqi.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $pci3K.default).asap(unsubscribe);
        return signal;
    }
};
var $b13e96be51450e73$export$2e2bcd8739ae039 = $b13e96be51450e73$var$composeSignals;

});

parcelRegister("dWNSC", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $a277623eac33c0de$export$b0119225647bd83; });
const $a277623eac33c0de$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $a277623eac33c0de$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $a277623eac33c0de$var$readStream(iterable))yield* $a277623eac33c0de$export$71b051935044bd5d(chunk, chunkSize);
};
const $a277623eac33c0de$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $a277623eac33c0de$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $a277623eac33c0de$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("121Mm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c075b9e77890a56$export$2e2bcd8739ae039; });

var $iro9b = parcelRequire("iro9b");

var $jdUqi = parcelRequire("jdUqi");
'use strict';
const $0c075b9e77890a56$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $0c075b9e77890a56$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $0c075b9e77890a56$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $0c075b9e77890a56$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $iro9b.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $jdUqi.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $jdUqi.default).ERR_DEPRECATED);
        if (version && !$0c075b9e77890a56$var$deprecatedWarnings[opt]) {
            $0c075b9e77890a56$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$0c075b9e77890a56$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $0c075b9e77890a56$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $jdUqi.default)('options must be an object', (0, $jdUqi.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $jdUqi.default)('option ' + opt + ' must be ' + result, (0, $jdUqi.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $jdUqi.default)('Unknown option ' + opt, (0, $jdUqi.default).ERR_BAD_OPTION);
    }
}
var $0c075b9e77890a56$export$2e2bcd8739ae039 = {
    assertOptions: $0c075b9e77890a56$var$assertOptions,
    validators: $0c075b9e77890a56$var$validators
};

});
parcelRegister("iro9b", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $d6cd7ab6ae29eb1f$export$a4ad2735b021c132; });
const $d6cd7ab6ae29eb1f$export$a4ad2735b021c132 = "1.8.2";

});



parcelRegister("4ar6q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308d1ea1794f5d49$export$2e2bcd8739ae039; });

var $82h0N = parcelRequire("82h0N");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $308d1ea1794f5d49$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $308d1ea1794f5d49$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $82h0N.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $308d1ea1794f5d49$export$2e2bcd8739ae039 = $308d1ea1794f5d49$var$CancelToken;

});

parcelRegister("hImvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce580039593d0787$export$2e2bcd8739ae039; });
'use strict';
function $ce580039593d0787$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("fn32J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30b5d498c872f1f$export$2e2bcd8739ae039; });

var $pci3K = parcelRequire("pci3K");
'use strict';
function $b30b5d498c872f1f$export$2e2bcd8739ae039(payload) {
    return (0, $pci3K.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("jLDDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e64126d4def41443$export$2e2bcd8739ae039; });
const $e64126d4def41443$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($e64126d4def41443$var$HttpStatusCode).forEach(([key, value])=>{
    $e64126d4def41443$var$HttpStatusCode[value] = key;
});
var $e64126d4def41443$export$2e2bcd8739ae039 = $e64126d4def41443$var$HttpStatusCode;

});



parcelRegister("nyKU9", function(module, exports) {

$parcel$export(module.exports, "SedestralMachine", function () { return $fb5d1aea492fd636$export$3241e4b560eb63f6; });

var $kCqD1 = parcelRequire("kCqD1");

var $gRinL = parcelRequire("gRinL");
class $fb5d1aea492fd636$export$3241e4b560eb63f6 {
    static dispose() {
        this.listeners.forEach((value)=>{
            this.removeListener(value);
        });
        this.resizeObserver.disconnect();
    }
    static async init() {
        this.listeners = [];
        this.outsideClickListeners = [];
        if (this.log) this.setInterval(()=>{
            console.log("listeners " + this.listeners.length);
        }, 3000);
        this.resizeObserver = new ResizeObserver((entries)=>{
            window.requestAnimationFrame(()=>{
                if (!Array.isArray(entries) || !entries.length) return;
                for (let entry of entries)for (let f of entry.target['resizeFunctions'])f(entry.contentRect);
            });
        });
        this.addListener(window, "keydown", (e)=>{
            let nextIndex = e.code == "ArrowDown" ? 1 : e.code == "ArrowUp" ? -1 : 0;
            if (nextIndex != 0) {
                let focusedInput = this.inputs.find((value)=>value.isFocus());
                if (focusedInput) {
                    let nextInput = this.inputs[this.inputs.indexOf(focusedInput) + nextIndex];
                    if (nextInput) nextInput.focus();
                }
            }
        });
    }
    /**
     * timeout/interval
     */ static setTimeout(func, time) {
        return setTimeout(()=>{
            func();
        }, time);
    }
    static setInterval(func, time) {
        return setInterval(()=>{
            func();
        }, time);
    }
    /**
     * listeners
     */ static removeListener(listener) {
        if (listener == undefined) return;
        listener.element.removeEventListener(listener.name, listener.callback, listener.options);
        let index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
        let outsideClickIndex = this.outsideClickListeners.indexOf(listener);
        if (outsideClickIndex >= 0) this.outsideClickListeners.splice(outsideClickIndex, 1);
    }
    static addListener(element, name, callback, options) {
        element.addEventListener(name, callback, options);
        let listener = new (0, $kCqD1.MachineListener)(element, name, callback, options);
        this.listeners.push(listener);
        return listener;
    }
    static addHotKeyListener(component, keys, func) {
        let existingKey = this.hotkeyListeners.find((value)=>value.hotkeys == keys && value.element == component.getHTMLElement());
        if (!existingKey) {
            existingKey = {
                hotkeys: keys,
                element: component.getHTMLElement(),
                entries: []
            };
            this.hotkeyListeners.push(existingKey);
            let map = {};
            map[keys] = (event)=>{
                existingKey.entries.forEach((value)=>value.function(event));
            };
            let handler = (0, $gRinL.createKeybindingsHandler)(map);
            component.getHTMLElement().addEventListener("keydown", handler);
        }
        existingKey.entries.push({
            function: (e)=>func(e)
        });
        return existingKey;
    }
    static deleteHotKeyListener(component, keys) {
        let existingKey = this.hotkeyListeners.find((value)=>value.hotkeys == keys && value.element == component.getHTMLElement());
        if (existingKey) this.hotkeyListeners.splice(this.hotkeyListeners.indexOf(existingKey), 1);
    }
    static addOutsideClickListener(listener, component) {
        listener['component'] = component;
        this.outsideClickListeners.push(listener);
    }
    /**
     * delay
     */ static async wait(func, time) {
        return $fb5d1aea492fd636$export$3241e4b560eb63f6.promise((end)=>{
            let promise = $fb5d1aea492fd636$export$3241e4b560eb63f6.promise(async (resolve)=>{
                setTimeout(()=>{
                    resolve(-1);
                }, time);
                let result = await func();
                resolve(result);
            });
            promise.then((data)=>{
                end(data);
            });
        });
    }
    static async delay(asyncFunc, minimumTime) {
        let result = undefined;
        let run = async ()=>result = await asyncFunc();
        await Promise.all([
            run(),
            this.sleep(minimumTime)
        ]);
        return result;
    }
    static async sleep(ms) {
        await $fb5d1aea492fd636$export$3241e4b560eb63f6.promise((resolve)=>{
            setTimeout(()=>{
                resolve();
            }, ms);
        });
    }
    /**
     * promise
     */ static promiseCancelable(executor) {
        let rejectFn;
        const wrappedPromise = new Promise((resolve, reject)=>{
            rejectFn = reject;
            Promise.resolve(new Promise(executor)).then(resolve).catch(reject);
        });
        wrappedPromise['cancel'] = ()=>{
            rejectFn({
                canceled: true
            });
        };
        return wrappedPromise;
    }
    static async promise(executor, displayRequired, component) {
        let promise = this.promiseCancelable(executor);
        let savedPromise = {
            component: component,
            promise: promise,
            displayRequired: displayRequired
        };
        this.promises.push(savedPromise);
        promise.then(()=>{
            this.promises.splice(this.promises.indexOf(savedPromise), 1);
        });
        if (component) component.onRemove(()=>{
            $fb5d1aea492fd636$export$3241e4b560eb63f6.requestFrame()(()=>{
                if (this.promises.indexOf(savedPromise) >= 0) {
                    savedPromise.promise['cancel']();
                    this.promises.splice(this.promises.indexOf(savedPromise), 1);
                }
            });
        });
        return promise;
    }
    /**
     * frame
     */ static requestFrame() {
        // @ts-ignore
        let raf = window.requestAnimationFrame || window['mozRequestAnimationFrame'] || window.webkitRequestAnimationFrame || function(fn) {
            return window.setTimeout(fn, 20);
        };
        return function(fn) {
            return raf(fn);
        };
    }
    static cancelFrame() {
        // @ts-ignore
        let cancel = window.cancelAnimationFrame || window['mozCancelAnimationFrame'] || window.webkitCancelAnimationFrame || window.clearTimeout;
        return function(id) {
            return cancel(id);
        };
    }
}
$fb5d1aea492fd636$export$3241e4b560eb63f6.log = false;
$fb5d1aea492fd636$export$3241e4b560eb63f6.listeners = [];
$fb5d1aea492fd636$export$3241e4b560eb63f6.inputs = [];
$fb5d1aea492fd636$export$3241e4b560eb63f6.hotkeyListeners = [];
$fb5d1aea492fd636$export$3241e4b560eb63f6.outsideClickListeners = [];
$fb5d1aea492fd636$export$3241e4b560eb63f6.promises = [];

});
parcelRegister("kCqD1", function(module, exports) {

$parcel$export(module.exports, "MachineListener", function () { return $710adb1ecd8169dc$export$884d1a73c2ef5109; });
class $710adb1ecd8169dc$export$884d1a73c2ef5109 {
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get callback() {
        return this._callback;
    }
    set callback(value) {
        this._callback = value;
    }
    get options() {
        return this._options;
    }
    set options(value) {
        this._options = value;
    }
    constructor(element, name, callback, options){
        this._element = element;
        this._name = name;
        this._callback = callback;
        this._options = options;
    }
}

});

parcelRegister("gRinL", function(module, exports) {

$parcel$export(module.exports, "createKeybindingsHandler", function () { return $032ad61ca0c9753b$export$a3db0ee43d16bb47; });
var $032ad61ca0c9753b$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $032ad61ca0c9753b$var$e = "object" == typeof navigator ? navigator.platform : "", $032ad61ca0c9753b$var$n = /Mac|iPod|iPhone|iPad/.test($032ad61ca0c9753b$var$e), $032ad61ca0c9753b$var$o = $032ad61ca0c9753b$var$n ? "Meta" : "Control", $032ad61ca0c9753b$var$r = "Win32" === $032ad61ca0c9753b$var$e ? [
    "Control",
    "Alt"
] : $032ad61ca0c9753b$var$n ? [
    "Alt"
] : [];
function $032ad61ca0c9753b$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $032ad61ca0c9753b$var$r.includes(e) && t.getModifierState("AltGraph"));
}
function $032ad61ca0c9753b$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop(), r = n.match(/^\((.+)\)$/);
        return r && (n = new RegExp("^" + r[1] + "$")), [
            e = e.map(function(t) {
                return "$mod" === t ? $032ad61ca0c9753b$var$o : t;
            }),
            n
        ];
    });
}
function $032ad61ca0c9753b$export$5eab49042bbaa75(e, n) {
    var o = n[0], r = n[1];
    return !((r instanceof RegExp ? !r.test(e.key) && !r.test(e.code) : r.toUpperCase() !== e.key.toUpperCase() && r !== e.code) || o.find(function(t) {
        return !$032ad61ca0c9753b$var$i(e, t);
    }) || $032ad61ca0c9753b$var$t.find(function(t) {
        return !o.includes(t) && r !== t && $032ad61ca0c9753b$var$i(e, t);
    }));
}
function $032ad61ca0c9753b$export$a3db0ee43d16bb47(t, e) {
    var n;
    void 0 === e && (e = {});
    var o = null != (n = e.timeout) ? n : 1e3, r = Object.keys(t).map(function(e) {
        return [
            $032ad61ca0c9753b$export$d0b30d424c95c5e9(e),
            t[e]
        ];
    }), c = new Map, f = null;
    return function(t) {
        t instanceof KeyboardEvent && (r.forEach(function(e) {
            var n = e[0], o = e[1], r = c.get(n) || n;
            $032ad61ca0c9753b$export$5eab49042bbaa75(t, r[0]) ? r.length > 1 ? c.set(n, r.slice(1)) : (c.delete(n), o(t)) : $032ad61ca0c9753b$var$i(t, t.key) || c.delete(n);
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $032ad61ca0c9753b$export$6fc42dca60e28416(t, e, n) {
    var o = void 0 === n ? {} : n, r = o.event, i = void 0 === r ? "keydown" : r, a = o.capture, u = $032ad61ca0c9753b$export$a3db0ee43d16bb47(e, {
        timeout: o.timeout
    });
    return t.addEventListener(i, u, a), function() {
        t.removeEventListener(i, u, a);
    };
}

});


parcelRegister("4in9X", function(module, exports) {

$parcel$export(module.exports, "NetworkHeaders", function () { return $97febb0327db6720$export$6c0c30308e42bb4b; });
var $97febb0327db6720$export$6c0c30308e42bb4b = /*#__PURE__*/ function(NetworkHeaders) {
    NetworkHeaders["SESSION_HEADER"] = "x-sedestral-session";
    NetworkHeaders["SITE_HEADER"] = "site";
    NetworkHeaders["TF_TRANSACTION_ID_HEADER"] = "tf-transaction-id";
    NetworkHeaders["TF_TRANSACTION_CODE_HEADER"] = "tf-transaction-code";
    NetworkHeaders["TF_TRANSACTION_METHOD_HEADER"] = "tf-transaction-method";
    NetworkHeaders["TF_TRANSACTION_DATA_HEADER"] = "tf-transaction-data";
    NetworkHeaders["ALERT_HEADER"] = "alert";
    return NetworkHeaders;
}({});

});

parcelRegister("bTARt", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb; });
var $735f6b1fdc93c9a6$export$d4e71bc0b80dc0fb = /*#__PURE__*/ function(ErrorCode) {
    ErrorCode[ErrorCode["NO_RECIPIENT"] = 0] = "NO_RECIPIENT";
    ErrorCode[ErrorCode["NO_SITE_CHANEl"] = 1] = "NO_SITE_CHANEl";
    ErrorCode[ErrorCode["NO_SITE"] = 2] = "NO_SITE";
    ErrorCode[ErrorCode["RECIPIENT_FULL"] = 3] = "RECIPIENT_FULL";
    ErrorCode[ErrorCode["MAIL_FORMAT"] = 4] = "MAIL_FORMAT";
    ErrorCode[ErrorCode["MAIL_RECEIVE"] = 5] = "MAIL_RECEIVE";
    ErrorCode[ErrorCode["MAIL_DOMAIN"] = 6] = "MAIL_DOMAIN";
    ErrorCode[ErrorCode["MAIL"] = 7] = "MAIL";
    ErrorCode[ErrorCode["EMAIL_EXIST"] = 8] = "EMAIL_EXIST";
    ErrorCode[ErrorCode["EMAIL_BLACKLIST"] = 9] = "EMAIL_BLACKLIST";
    ErrorCode[ErrorCode["EMAIL_FULL"] = 10] = "EMAIL_FULL";
    ErrorCode[ErrorCode["EMAIL_ALIAS_EXIST"] = 11] = "EMAIL_ALIAS_EXIST";
    ErrorCode[ErrorCode["EMAIL_ALIAS"] = 12] = "EMAIL_ALIAS";
    ErrorCode[ErrorCode["URL_FORMAT"] = 13] = "URL_FORMAT";
    ErrorCode[ErrorCode["IMAGE_FORMAT"] = 14] = "IMAGE_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FORMAT"] = 15] = "DOMAIN_FORMAT";
    ErrorCode[ErrorCode["DOMAIN_FULL"] = 16] = "DOMAIN_FULL";
    ErrorCode[ErrorCode["WINDOW_EXPIRED"] = 17] = "WINDOW_EXPIRED";
    ErrorCode[ErrorCode["SITE_CHANNEL_NO_FOUND"] = 18] = "SITE_CHANNEL_NO_FOUND";
    ErrorCode[ErrorCode["CHANEl_TYPE_NO_FOUND"] = 19] = "CHANEl_TYPE_NO_FOUND";
    ErrorCode[ErrorCode["CONTACT_NO_FOUND"] = 20] = "CONTACT_NO_FOUND";
    ErrorCode[ErrorCode["SITE_CHANNEL_PERMISSION"] = 21] = "SITE_CHANNEL_PERMISSION";
    ErrorCode[ErrorCode["NAME_EXIST"] = 22] = "NAME_EXIST";
    ErrorCode[ErrorCode["PERMISSION"] = 23] = "PERMISSION";
    ErrorCode[ErrorCode["NULLITY"] = 24] = "NULLITY";
    ErrorCode[ErrorCode["SIZE_MAX"] = 25] = "SIZE_MAX";
    ErrorCode[ErrorCode["SIZE_MIN"] = 26] = "SIZE_MIN";
    ErrorCode[ErrorCode["VERIFICATION"] = 27] = "VERIFICATION";
    ErrorCode[ErrorCode["EXCEPTION"] = 28] = "EXCEPTION";
    ErrorCode[ErrorCode["CACHE"] = 29] = "CACHE";
    ErrorCode[ErrorCode["SURFACE_CONTROL"] = 30] = "SURFACE_CONTROL";
    /*
    {"errorCode":"SURFACE_CONTROL","errorType":"FUNCTIONAL","subErrors":[{"field":"email","rejectedValue":"frrfrffrrfrfrf","message":"doit être une adresse électronique syntaxiquement correcte"},{"field":"password","rejectedValue":"uy","message":"la longueur doit être comprise entre 4 et 2147483647"},{"field":"name","rejectedValue":"  ","message":"ne doit pas être vide"}]}
     */ ErrorCode[ErrorCode["TWO_FACTOR_TECHNICAL"] = 31] = "TWO_FACTOR_TECHNICAL";
    ErrorCode[ErrorCode["TWO_FACTOR_REQUIRED"] = 32] = "TWO_FACTOR_REQUIRED";
    ErrorCode[ErrorCode["TWO_FACTOR_TRANSACTION_NO_FOUND"] = 33] = "TWO_FACTOR_TRANSACTION_NO_FOUND";
    ErrorCode[ErrorCode["TWO_FACTOR_EXPIRE_CODE"] = 34] = "TWO_FACTOR_EXPIRE_CODE";
    ErrorCode[ErrorCode["TWO_FACTOR_ATTEMPT"] = 35] = "TWO_FACTOR_ATTEMPT";
    ErrorCode[ErrorCode["TWO_FACTOR_BAND_WIDTH_LIMIT"] = 36] = "TWO_FACTOR_BAND_WIDTH_LIMIT";
    ErrorCode[ErrorCode["TWO_FACTOR_CODE_INCORRECT"] = 37] = "TWO_FACTOR_CODE_INCORRECT";
    ErrorCode[ErrorCode["TWO_FACTOR_METHOD_UNAUTHORIZED"] = 38] = "TWO_FACTOR_METHOD_UNAUTHORIZED";
    ErrorCode[ErrorCode["TWO_FACTOR_CREATE_INVALID_CODE"] = 39] = "TWO_FACTOR_CREATE_INVALID_CODE";
    ErrorCode[ErrorCode["CAPTCHA_INCORRECT"] = 40] = "CAPTCHA_INCORRECT";
    ErrorCode[ErrorCode["HOST_INCORRECT"] = 41] = "HOST_INCORRECT";
    ErrorCode[ErrorCode["HOST_EXIST"] = 42] = "HOST_EXIST";
    ErrorCode[ErrorCode["K8S_DOMAIN_ERROR"] = 43] = "K8S_DOMAIN_ERROR";
    ErrorCode[ErrorCode["PARTNER_NO_FOUND"] = 44] = "PARTNER_NO_FOUND";
    ErrorCode[ErrorCode["INVALID_LANGUAGE"] = 45] = "INVALID_LANGUAGE";
    ErrorCode[ErrorCode["ROUTE_EXIST"] = 46] = "ROUTE_EXIST";
    ErrorCode[ErrorCode["DATE_RANGE"] = 47] = "DATE_RANGE";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COMBINATION"] = 48] = "PUBLISHER_ATTACHMENT_COMBINATION";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_COUNT"] = 49] = "PUBLISHER_ATTACHMENT_COUNT";
    ErrorCode[ErrorCode["PUBLISHER_ATTACHMENT_LINK"] = 50] = "PUBLISHER_ATTACHMENT_LINK";
    ErrorCode[ErrorCode["PASSWORD"] = 51] = "PASSWORD";
    ErrorCode[ErrorCode["PARTICIPANTS_EMPTY"] = 52] = "PARTICIPANTS_EMPTY";
    ErrorCode[ErrorCode["ATTACHMENT_MANDATORY"] = 53] = "ATTACHMENT_MANDATORY";
    ErrorCode[ErrorCode["PUBLISHER_POST_EMPTY"] = 54] = "PUBLISHER_POST_EMPTY";
    ErrorCode[ErrorCode["NO_CONTACT"] = 55] = "NO_CONTACT";
    ErrorCode[ErrorCode["GPT_RETRY_LIMIT"] = 56] = "GPT_RETRY_LIMIT";
    ErrorCode[ErrorCode["PAYMENT_REQUIRED"] = 57] = "PAYMENT_REQUIRED";
    ErrorCode[ErrorCode["BUNDLES_SIZE"] = 58] = "BUNDLES_SIZE";
    ErrorCode[ErrorCode["BUNDLE_OPTION_SIZE"] = 59] = "BUNDLE_OPTION_SIZE";
    ErrorCode[ErrorCode["OFFER_ALREADY_EXISTS"] = 60] = "OFFER_ALREADY_EXISTS";
    ErrorCode[ErrorCode["SITE_COUNT_MAX"] = 61] = "SITE_COUNT_MAX";
    ErrorCode[ErrorCode["PROMOTION_CODE_INVALID"] = 62] = "PROMOTION_CODE_INVALID";
    ErrorCode[ErrorCode["ACTIVE_OFFER_IS_FAILURE_TO_PAY"] = 63] = "ACTIVE_OFFER_IS_FAILURE_TO_PAY";
    ErrorCode[ErrorCode["OFFER_PRODUCTS_EMPTY"] = 64] = "OFFER_PRODUCTS_EMPTY";
    ErrorCode[ErrorCode["OFFER_SAME_OFFER_ACTIVE"] = 65] = "OFFER_SAME_OFFER_ACTIVE";
    ErrorCode[ErrorCode["TASK_IN_PROGRESS"] = 66] = "TASK_IN_PROGRESS";
    ErrorCode[ErrorCode["OFFER_ACTIVE_EXISTS"] = 67] = "OFFER_ACTIVE_EXISTS";
    ErrorCode[ErrorCode["OFFER_CANCELLED_EXPIRED"] = 68] = "OFFER_CANCELLED_EXPIRED";
    ErrorCode[ErrorCode["SUSPENDED"] = 69] = "SUSPENDED";
    ErrorCode[ErrorCode["PHONE_FORMAT"] = 70] = "PHONE_FORMAT";
    ErrorCode[ErrorCode["PARTNER_CONFING_INVALID"] = 71] = "PARTNER_CONFING_INVALID";
    ErrorCode[ErrorCode["PARTNER_CONFING_PERMISSIONS"] = 72] = "PARTNER_CONFING_PERMISSIONS";
    ErrorCode[ErrorCode["COMMUNITY_AUTOPILOT_DAYS_MAX"] = 73] = "COMMUNITY_AUTOPILOT_DAYS_MAX";
    ErrorCode[ErrorCode["TAX_COUNTRY"] = 74] = "TAX_COUNTRY";
    ErrorCode[ErrorCode["TAX_TYPE"] = 75] = "TAX_TYPE";
    ErrorCode[ErrorCode["TAX_VALUE_INVALID"] = 76] = "TAX_VALUE_INVALID";
    ErrorCode[ErrorCode["LOCATION_INVALID"] = 77] = "LOCATION_INVALID";
    ErrorCode[ErrorCode["TOKEN_INVALID"] = 78] = "TOKEN_INVALID";
    ErrorCode[ErrorCode["PAYMENT_PROVIDER_CREATE_SUBSCRIPTION"] = 79] = "PAYMENT_PROVIDER_CREATE_SUBSCRIPTION";
    ErrorCode[ErrorCode["OFFER_QUOTE_EXISTS"] = 80] = "OFFER_QUOTE_EXISTS";
    ErrorCode[ErrorCode["CREATE_ARTICLE_IA_FORM_EMPTY"] = 81] = "CREATE_ARTICLE_IA_FORM_EMPTY";
    ErrorCode[ErrorCode["MAX_LIMIT"] = 82] = "MAX_LIMIT";
    ErrorCode[ErrorCode["FORMAT"] = 83] = "FORMAT";
    ErrorCode[ErrorCode["AUDIT_ALREADY_RUNNING"] = 84] = "AUDIT_ALREADY_RUNNING";
    return ErrorCode;
}({});

});

parcelRegister("7ZaxO", function(module, exports) {

$parcel$export(module.exports, "HttpStatus", function () { return $6f3d3ee98d6e2b63$export$2b71909294c66558; });
var $6f3d3ee98d6e2b63$export$2b71909294c66558 = /*#__PURE__*/ function(HttpStatus) {
    HttpStatus[HttpStatus["CONTINUE"] = 100] = "CONTINUE";
    HttpStatus[HttpStatus["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    HttpStatus[HttpStatus["PROCESSING"] = 102] = "PROCESSING";
    HttpStatus[HttpStatus["OK"] = 200] = "OK";
    HttpStatus[HttpStatus["CREATED"] = 201] = "CREATED";
    HttpStatus[HttpStatus["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatus[HttpStatus["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    HttpStatus[HttpStatus["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatus[HttpStatus["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    HttpStatus[HttpStatus["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    HttpStatus[HttpStatus["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    HttpStatus[HttpStatus["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
    HttpStatus[HttpStatus["IM_USED"] = 226] = "IM_USED";
    HttpStatus[HttpStatus["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpStatus[HttpStatus["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpStatus[HttpStatus["FOUND"] = 302] = "FOUND";
    HttpStatus[HttpStatus["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatus[HttpStatus["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpStatus[HttpStatus["USE_PROXY"] = 305] = "USE_PROXY";
    HttpStatus[HttpStatus["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    HttpStatus[HttpStatus["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpStatus[HttpStatus["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatus[HttpStatus["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpStatus[HttpStatus["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpStatus[HttpStatus["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpStatus[HttpStatus["CONFLICT"] = 409] = "CONFLICT";
    HttpStatus[HttpStatus["GONE"] = 410] = "GONE";
    HttpStatus[HttpStatus["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpStatus[HttpStatus["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HttpStatus[HttpStatus["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HttpStatus[HttpStatus["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpStatus[HttpStatus["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HttpStatus[HttpStatus["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpStatus[HttpStatus["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    HttpStatus[HttpStatus["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HttpStatus[HttpStatus["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HttpStatus[HttpStatus["LOCKED"] = 423] = "LOCKED";
    HttpStatus[HttpStatus["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HttpStatus[HttpStatus["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpStatus[HttpStatus["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HttpStatus[HttpStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpStatus[HttpStatus["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpStatus[HttpStatus["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpStatus[HttpStatus["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpStatus[HttpStatus["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpStatus[HttpStatus["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpStatus[HttpStatus["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpStatus[HttpStatus["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpStatus[HttpStatus["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HttpStatus[HttpStatus["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HttpStatus[HttpStatus["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HttpStatus[HttpStatus["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HttpStatus[HttpStatus["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
    HttpStatus[HttpStatus["BANDWIDTH_LIMIT"] = 509] = "BANDWIDTH_LIMIT";
    return HttpStatus;
}({});

});

parcelRegister("kfkzw", function(module, exports) {

$parcel$export(module.exports, "ProductType", function () { return $e5cb6c8f7045f949$export$11b099a658b17995; });
var $e5cb6c8f7045f949$export$11b099a658b17995 = /*#__PURE__*/ function(ProductType) {
    ProductType[ProductType["SEDESTRAL"] = 1] = "SEDESTRAL";
    ProductType[ProductType["INBOX"] = 2] = "INBOX";
    ProductType[ProductType["PUBLISHER"] = 3] = "PUBLISHER";
    ProductType[ProductType["STATISTICS"] = 4] = "STATISTICS";
    ProductType[ProductType["CONTACTS"] = 5] = "CONTACTS";
    ProductType[ProductType["CHANNELS"] = 6] = "CHANNELS";
    ProductType[ProductType["LIVECHAT"] = 7] = "LIVECHAT";
    ProductType[ProductType["PANEL"] = 8] = "PANEL";
    ProductType[ProductType["GENERAL"] = 9] = "GENERAL";
    ProductType[ProductType["CHAT_BOT"] = 10] = "CHAT_BOT";
    ProductType[ProductType["MAILS"] = 11] = "MAILS";
    ProductType[ProductType["SELL"] = 12] = "SELL";
    ProductType[ProductType["ENGAGEMENT"] = 13] = "ENGAGEMENT";
    ProductType[ProductType["ADVERTISING"] = 14] = "ADVERTISING";
    ProductType[ProductType["MAILLING"] = 15] = "MAILLING";
    ProductType[ProductType["MEDIAS"] = 16] = "MEDIAS";
    ProductType[ProductType["CALENDAR"] = 17] = "CALENDAR";
    ProductType[ProductType["DOCUMENTS"] = 18] = "DOCUMENTS";
    ProductType[ProductType["PRODUCTS"] = 19] = "PRODUCTS";
    ProductType[ProductType["ESTIMATE"] = 20] = "ESTIMATE";
    ProductType[ProductType["CONTACTS_GREY"] = 21] = "CONTACTS_GREY";
    ProductType[ProductType["PUBLISHER_GREY"] = 22] = "PUBLISHER_GREY";
    ProductType[ProductType["INBOX_GREY"] = 23] = "INBOX_GREY";
    ProductType[ProductType["HELPCENTER"] = 24] = "HELPCENTER";
    ProductType[ProductType["WEBSITE"] = 25] = "WEBSITE";
    ProductType[ProductType["CLIENT_SERVICE"] = 26] = "CLIENT_SERVICE";
    ProductType[ProductType["BLOG"] = 27] = "BLOG";
    ProductType[ProductType["MOBILE"] = 28] = "MOBILE";
    ProductType[ProductType["COMMUNITY"] = 29] = "COMMUNITY";
    ProductType[ProductType["ADMIN"] = 30] = "ADMIN";
    return ProductType;
}({});

});

parcelRegister("5FliW", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $2c6b78a6d87e1877$export$e9a269813a6315a4; });

var $7AbeR = parcelRequire("7AbeR");

var $271MM = parcelRequire("271MM");

var $fTxZM = parcelRequire("fTxZM");

var $276sx = parcelRequire("276sx");

var $1wiPK = parcelRequire("1wiPK");

var $2aBLW = parcelRequire("2aBLW");

var $g6Ma5 = parcelRequire("g6Ma5");

var $39ltS = parcelRequire("39ltS");

var $kfkzw = parcelRequire("kfkzw");

var $bi5k0 = parcelRequire("bi5k0");
class $2c6b78a6d87e1877$export$e9a269813a6315a4 {
    static getCountryCode() {
        return this.languageToCountryMap[this.language] || "fr";
    }
    static async init(languagesCandidate, languages, defaultLanguage = this.getDefaultLanguage()) {
        this.languages = languages;
        let selectBestLanguageCandidate = this.getBestLanguageCandidate(languages, languagesCandidate);
        this.setLanguage(selectBestLanguageCandidate);
        if (!this.language) this.setLanguage(defaultLanguage);
        if (!this.language) this.setLanguage(this.getDefaultLanguage());
        if ((0, $271MM.config).product == "blog") this.theme((0, $kfkzw.ProductType).BLOG) == (0, $276sx.AppearanceTheme).LIGHT ? (0, $2aBLW.SedestralInterface).html.removeClass("black") : (0, $2aBLW.SedestralInterface).html.addClass("black");
    }
    static async loadI18n(product, vendor = (0, $39ltS.generateVendor)(window.location.origin)) {
        const request = await (0, $7AbeR.Network).httpResources.get(vendor + "languages/" + product + "/" + this.language + ".json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        if (this.words !== undefined) this.words = this.mergeI18n(this.words, request.data);
        else {
            this.words = request.data;
            (0, $7AbeR.Network).initErrors();
            (0, $fTxZM.DateIntervalPickerPurposes).init();
        }
    }
    static async loadCountries(vendor = (0, $39ltS.generateVendor)(window.location.origin)) {
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "countries/" + this.language + ".json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        this.countries = request.data;
    }
    static async loadEmojis(vendor = (0, $39ltS.generateVendor)(window.location.origin)) {
        if (this.emojis != undefined) return this.emojis;
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "emojis/emojis.json?" + (0, $271MM.config).version);
        this.emojis = request.data;
        return this.emojis;
    }
    static async loadWorldLanguages(vendor = (0, $39ltS.generateVendor)(window.location.origin)) {
        let request = await (0, $7AbeR.Network).httpResources.get(vendor + "languages/names.json?" + (0, $271MM.config).version, {
            timeout: 60000
        });
        this.worldLanguages = request.data;
    }
    static t(value, words) {
        const values = value.split(".");
        let object = words !== null && words !== void 0 ? words : this.words;
        for (const val of values)if (object) object = object[val];
        return object !== null && object !== void 0 ? object : value;
    }
    static r(value, replacements, words = this.words) {
        const values = value.split(".");
        let object = words;
        for (const val of values)if (typeof object !== "undefined") object = object[val];
        let result = typeof object === "undefined" || typeof object === "object" ? value : object;
        for(const key in replacements)result = result.replace(`\${${key}}`, replacements[key]);
        return result;
    }
    static exist(value, words) {
        const values = value.split(".");
        let object = words !== null && words !== void 0 ? words : this.words;
        for (const val of values)if (object) object = object[val];
        return object !== undefined;
    }
    static country(a2) {
        a2 = a2.toLowerCase();
        return this.countries.filter((value)=>value['a2'] == a2)[0];
    }
    static lang(code) {
        code = (0, $g6Ma5.txtSimpleLang)(code);
        for(let key in this.worldLanguages)if (this.worldLanguages.hasOwnProperty(key)) {
            if (this.worldLanguages[key].code == code) return this.worldLanguages[key];
        }
    }
    static getLanguagesCandidate() {
        return [
            ...new Set(navigator.languages.map((language)=>this.removeRegionLanguage(language)))
        ];
    }
    static getLanguagesCandidateWidthDefault(bestLanguageCandidate) {
        return [
            ...new Set([
                $2c6b78a6d87e1877$export$e9a269813a6315a4.removeRegionLanguage(bestLanguageCandidate),
                ...$2c6b78a6d87e1877$export$e9a269813a6315a4.getLanguagesCandidate()
            ].filter((language)=>language !== undefined))
        ];
    }
    static getBestLanguageCandidate(languages, languagesCandidate = this.getLanguagesCandidate()) {
        return languagesCandidate.find((language)=>languages.includes(language));
    }
    static getDefaultLanguage() {
        return "en";
    }
    static setLanguage(language) {
        if (this.languages.includes(language)) this.language = language;
    }
    static removeRegionLanguage(language) {
        if (language == undefined) return undefined;
        const withoutQuality = language.split(";")[0];
        if (withoutQuality.includes("-")) return withoutQuality.split("-")[0];
        if (withoutQuality.includes("_")) return withoutQuality.split("_")[0];
        return withoutQuality;
    }
    static theme(productType) {
        let theme = this.realTheme(productType);
        if (theme == (0, $276sx.AppearanceTheme).AUTO) {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return (0, $276sx.AppearanceTheme).DARK;
            else return (0, $276sx.AppearanceTheme).LIGHT;
        }
        return theme;
    }
    static realTheme(productType) {
        let theme = (0, $1wiPK.SedestralStorage).getItem(`${(0, $bi5k0.ProductName).toString(productType)}-theme`);
        if (theme == null) return (0, $276sx.AppearanceTheme).AUTO;
        return parseInt(theme);
    }
    static invertTheme(productType, theme) {
        return (theme ? theme : $2c6b78a6d87e1877$export$e9a269813a6315a4.theme(productType)) == (0, $276sx.AppearanceTheme).DARK ? (0, $276sx.AppearanceTheme).LIGHT : (0, $276sx.AppearanceTheme).DARK;
    }
    static setTheme(productType, theme, silent) {
        (0, $1wiPK.SedestralStorage).setItem(`${(0, $bi5k0.ProductName).toString(productType)}-theme`, "" + theme);
        if (!silent) this.theme(productType) == (0, $276sx.AppearanceTheme).LIGHT ? (0, $2aBLW.SedestralInterface).html.removeClass("black") : (0, $2aBLW.SedestralInterface).html.addClass("black");
    }
    static mergeI18n(wordsA, wordsB) {
        return {
            ...wordsA,
            ...wordsB,
            words: {
                ...wordsA.words,
                ...wordsB.words
            },
            network: {
                ...wordsA.network,
                ...wordsB.network
            },
            errors: {
                ...wordsA.errors,
                ...wordsB.errors
            },
            placeholders: {
                ...wordsA.placeholders,
                ...wordsB.placeholders
            },
            sentences: {
                ...wordsA.sentences,
                ...wordsB.sentences
            },
            products: {
                ...wordsA.products,
                ...wordsB.products
            },
            time: {
                ...wordsA.time,
                ...wordsB.time
            }
        };
    }
}
$2c6b78a6d87e1877$export$e9a269813a6315a4.languageToCountryMap = {
    "fr": "fr",
    "en": "en",
    "es": "es",
    "it": "it",
    "pt": "pt",
    "nl": "nl",
    "de": "de",
    "lb": "lu",
    "da": "dk" // Denmark
};

});
parcelRegister("fTxZM", function(module, exports) {

$parcel$export(module.exports, "DateIntervalPickerPurposes", function () { return $ca933db306d550fe$export$c965c81194e437f6; });

var $5FliW = parcelRequire("5FliW");

var $h08y3 = parcelRequire("h08y3");

var $i4Vbe = parcelRequire("i4Vbe");

var $hpTr2 = parcelRequire("hpTr2");
class $ca933db306d550fe$export$c965c81194e437f6 {
    static init() {
        $ca933db306d550fe$export$c965c81194e437f6.basePurposes = [
            {
                value: "today",
                name: (0, $5FliW.Resources).t("words.todayCalendar"),
                show: true
            },
            {
                value: "yesterday",
                name: (0, $5FliW.Resources).t("words.yesterday"),
                show: true
            },
            {
                value: "week",
                name: (0, $5FliW.Resources).r("words.lastDays", {
                    count: 7
                }),
                show: true
            },
            {
                value: "4week",
                name: (0, $5FliW.Resources).r("words.lastWeeks", {
                    count: 4
                }),
                show: true
            },
            {
                value: "3month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 3
                }),
                show: true
            },
            {
                value: "6month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 6
                }),
                show: true
            },
            {
                value: "12month",
                name: (0, $5FliW.Resources).r("words.lastMonths", {
                    count: 12
                }),
                show: true
            }
        ];
        $ca933db306d550fe$export$c965c81194e437f6.comparatorPurposes = [
            {
                value: "lastPeriod",
                name: (0, $5FliW.Resources).t("words.lastPeriod"),
                show: true
            },
            {
                value: "lastWeek",
                name: (0, $5FliW.Resources).t("words.lastWeek"),
                show: true
            },
            {
                value: "lastMonth",
                name: (0, $5FliW.Resources).t("words.lastMonth"),
                show: true
            },
            {
                value: "lastTrimester",
                name: (0, $5FliW.Resources).t("words.lastTrimester"),
                show: true
            },
            {
                value: "lastSemester",
                name: (0, $5FliW.Resources).t("words.lastSemester"),
                show: true
            },
            {
                value: "lastYear",
                name: (0, $5FliW.Resources).t("words.lastYear"),
                show: true
            },
            {
                value: "undefined",
                name: (0, $5FliW.Resources).t("words.noComparison"),
                show: true
            }
        ];
    }
    /**
     * calcs
     */ static baseCalc(purposeValue) {
        switch(purposeValue){
            case "today":
                return [
                    new Date(),
                    new Date()
                ];
            case "yesterday":
                return [
                    (0, $i4Vbe.datePrevious)(1),
                    (0, $i4Vbe.datePrevious)(1)
                ];
            case "week":
                return [
                    (0, $i4Vbe.datePrevious)(6),
                    new Date()
                ];
            case "4week":
                return [
                    (0, $i4Vbe.datePrevious)(28),
                    new Date()
                ];
            case "3month":
                let month3 = new Date();
                month3.setMonth(month3.getMonth() - 3);
                return [
                    month3,
                    new Date()
                ];
            case "6month":
                let month6 = new Date();
                month6.setMonth(month6.getMonth() - 6);
                return [
                    month6,
                    new Date()
                ];
            case "12month":
                let month12 = new Date();
                month12.setMonth(month12.getMonth() - 12);
                return [
                    month12,
                    new Date()
                ];
        }
    }
    static comparatorCalc(purposeValue, firstDate, secondDate) {
        let comparatorDays = (0, $h08y3.dateCountDaysBetweenDates)(firstDate, secondDate, true);
        let difference = 0;
        firstDate = (0, $hpTr2.dateToCompare)(firstDate);
        secondDate = (0, $hpTr2.dateToCompare)(secondDate, true);
        switch(purposeValue){
            case "lastPeriod":
                return [
                    (0, $i4Vbe.datePrevious)(comparatorDays + 1, firstDate),
                    (0, $i4Vbe.datePrevious)(comparatorDays + 1, secondDate)
                ];
            case "undefined":
                return [
                    undefined,
                    undefined
                ];
            case "lastWeek":
                return [
                    (0, $i4Vbe.datePrevious)(7, firstDate),
                    (0, $i4Vbe.datePrevious)(7, secondDate)
                ];
            case "lastMonth":
                firstDate.setMonth(firstDate.getMonth() - 1);
                secondDate.setMonth(secondDate.getMonth() - 1);
                difference = comparatorDays - (0, $h08y3.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastTrimester":
                firstDate.setMonth(firstDate.getMonth() - 3);
                secondDate.setMonth(secondDate.getMonth() - 3);
                difference = comparatorDays - (0, $h08y3.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastSemester":
                firstDate.setMonth(firstDate.getMonth() - 6);
                secondDate.setMonth(secondDate.getMonth() - 6);
                difference = comparatorDays - (0, $h08y3.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
            case "lastYear":
                firstDate.setFullYear(firstDate.getFullYear() - 1);
                secondDate.setFullYear(secondDate.getFullYear() - 1);
                difference = comparatorDays - (0, $h08y3.dateCountDaysBetweenDates)(firstDate, secondDate, true);
                firstDate.setDate(firstDate.getDate() - difference);
                return [
                    firstDate,
                    secondDate
                ];
        }
    }
    /**
     * find
     */ static basePurpose(value) {
        return this.basePurposes.filter((v)=>v.value == value)[0];
    }
    static comparatorPurpose(value) {
        return this.comparatorPurposes.filter((v)=>v.value == value)[0];
    }
}

});
parcelRegister("h08y3", function(module, exports) {

$parcel$export(module.exports, "dateCountDaysBetweenDates", function () { return $4e0a34f6524ca2f2$export$4161df2d8c6bdac8; });

var $hpTr2 = parcelRequire("hpTr2");
function $4e0a34f6524ca2f2$export$4161df2d8c6bdac8(date, futureDate, noCountToday) {
    date = (0, $hpTr2.dateToCompare)(new Date(date));
    futureDate = new Date(futureDate);
    let days = [];
    while(date.getTime() < futureDate.getTime()){
        let key = "" + date.getFullYear() + date.getMonth() + date.getDate();
        if (!days.includes(key)) days.push(key);
        date.setDate(date.getDate() + 1);
    }
    return days.length - (noCountToday != undefined && noCountToday ? 1 : 0);
}

});
parcelRegister("hpTr2", function(module, exports) {

$parcel$export(module.exports, "dateToCompare", function () { return $7f5fc2be0a9af51b$export$90108030505d8ba4; });
/**
 * Met les heures, minutes etc à 0 ou les minutes etc à 59
 */ function $7f5fc2be0a9af51b$export$90108030505d8ba4(d, end) {
    d = new Date(d);
    if (d != undefined) {
        if (end) {
            d.setUTCHours(23);
            d.setUTCMinutes(59);
            d.setUTCSeconds(59);
            d.setUTCMilliseconds(999);
        } else {
            d.setUTCHours(0);
            d.setUTCMinutes(0);
            d.setUTCSeconds(0);
            d.setUTCMilliseconds(0);
        }
    }
    return d;
}

});


parcelRegister("i4Vbe", function(module, exports) {

$parcel$export(module.exports, "datePrevious", function () { return $bf2e78eb58ef6817$export$41249170adb44dba; });
/**
 * Retourne la date - x nombre de jours par rapport à la date actuel
 */ function $bf2e78eb58ef6817$export$41249170adb44dba(previousDays, fromDate) {
    let myDate = new Date(fromDate == undefined ? new Date() : fromDate);
    myDate.setDate(myDate.getDate() - previousDays);
    return myDate;
}

});


parcelRegister("276sx", function(module, exports) {

$parcel$export(module.exports, "AppearanceTheme", function () { return $4ce679db9bfe7ff3$export$81ee01c5982277e7; });
var $4ce679db9bfe7ff3$export$81ee01c5982277e7 = /*#__PURE__*/ function(AppearanceTheme) {
    AppearanceTheme[AppearanceTheme["LIGHT"] = 1] = "LIGHT";
    AppearanceTheme[AppearanceTheme["DARK"] = 2] = "DARK";
    AppearanceTheme[AppearanceTheme["AUTO"] = 3] = "AUTO";
    return AppearanceTheme;
}({});

});

parcelRegister("1wiPK", function(module, exports) {

$parcel$export(module.exports, "SedestralStorage", function () { return $31409b504a7321ee$export$c4d24105fc1cd347; });

var $lrxLu = parcelRequire("lrxLu");

var $jRIEn = parcelRequire("jRIEn");
class $31409b504a7321ee$export$c4d24105fc1cd347 {
    static async init() {
        if (!(0, $jRIEn.isLocalStorageAvailable)()) this.isLocalStorageEnabled = false;
    }
    static setItem(key, value) {
        if (this.isLocalStorageEnabled) localStorage.setItem(key, value);
        else (0, $lrxLu.SedestralMemory).setItem(key, value);
    }
    static getItem(key) {
        if (this.isLocalStorageEnabled) return localStorage.getItem(key);
        else return (0, $lrxLu.SedestralMemory).getItem(key);
    }
    static hasItem(key) {
        return this.getItem(key) != null;
    }
    static removeItem(key) {
        if (this.isLocalStorageEnabled) localStorage.removeItem(key);
        else (0, $lrxLu.SedestralMemory).removeItem(key);
    }
    static setCookie(name, value, domain = location.hostname) {
        try {
            let expireDate = new Date();
            expireDate.setFullYear(expireDate.getFullYear() + 1); // Expire après le nombre d'années spécifié
            document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expireDate.toUTCString()}; domain=${domain}; path=/`;
        } catch (e) {
            console.error("Failed to set cookie", e);
        }
    }
    static getCookie(name) {
        const nameEQ = encodeURIComponent(name) + "=";
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            let cookie = cookies[i];
            while(cookie.charAt(0) === ' ')cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
        }
        return null;
    }
    static deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
}
$31409b504a7321ee$export$c4d24105fc1cd347.isLocalStorageEnabled = true;

});
parcelRegister("lrxLu", function(module, exports) {

$parcel$export(module.exports, "SedestralMemory", function () { return $ac6049bfbb29bd92$export$fa0502262c0fea12; });
class $ac6049bfbb29bd92$export$fa0502262c0fea12 {
    static async init() {
        this._items = [];
    }
    static setItem(key, value) {
        this._items[key] = value;
    }
    static getItem(key) {
        return this._items[key] ? this._items[key] : null;
    }
    static removeItem(key) {
        delete this._items[key];
    }
}

});

parcelRegister("jRIEn", function(module, exports) {

$parcel$export(module.exports, "isLocalStorageAvailable", function () { return $42b3c8fc818e35a7$export$117a30df0da2af20; });
/**
 * vérifie si le localstorage est dispo
 */ function $42b3c8fc818e35a7$export$117a30df0da2af20() {
    let test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("2aBLW", function(module, exports) {

$parcel$export(module.exports, "SedestralInterface", function () { return $f6fd4fe65fafb38e$export$a48299ae308b6bd7; });

var $fsnB5 = parcelRequire("fsnB5");

var $nyKU9 = parcelRequire("nyKU9");
class $f6fd4fe65fafb38e$export$a48299ae308b6bd7 {
    static async init() {
        this.components = [];
        if (this.log) (0, $nyKU9.SedestralMachine).setInterval(()=>{
            let nullComponents = [];
            for (let component of this.components)if (component.element == undefined) // if (component.constructor.name != "PageComponent")
            nullComponents.push(component);
            console.log(nullComponents);
            console.log(this.components);
            console.log("comp: " + (this.components.length - nullComponents.length));
            console.log("comp n: " + nullComponents.length);
        }, 3000);
        this.html = this.ec("html");
        this.body = this.ec("body");
        this.main = this.ec("main");
        let listeners = [
            'dragenter',
            'dragover',
            'dragleave',
            'drop'
        ];
        listeners.forEach((eventName)=>this.body.putListener(window, eventName, (e)=>e.preventDefault()));
    }
    static dispose() {
        this.components.forEach((c)=>{
            c.nullify();
        });
        this.components = [];
        this.body = undefined;
        this.main = undefined;
    }
    static store(element) {
        this.components.push(element);
    }
    static unStore(element) {
        let index = this.components.indexOf(element);
        if (index >= 0) this.components.splice(index, 1);
    }
    static ec(selector) {
        let e = document.querySelector(selector);
        if (e != undefined) return new (0, $fsnB5.Component)(e);
        return undefined;
    }
    static el(element) {
        return new (0, $fsnB5.Component)(element);
    }
}
$f6fd4fe65fafb38e$export$a48299ae308b6bd7.log = false;

});
parcelRegister("fsnB5", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $881b67775ffe46ab$export$16fa2f45be04daa8; });

var $nyKU9 = parcelRequire("nyKU9");

var $2aBLW = parcelRequire("2aBLW");

var $idTHf = parcelRequire("idTHf");

var $i3Hbv = parcelRequire("i3Hbv");

var $8YCm8 = parcelRequire("8YCm8");

var $bLZiK = parcelRequire("bLZiK");

var $6pO1Y = parcelRequire("6pO1Y");

var $9UiNT = parcelRequire("9UiNT");

var $3SbXF = parcelRequire("3SbXF");

var $42a2f = parcelRequire("42a2f");

var $gKcOU = parcelRequire("gKcOU");

var $55dRq = parcelRequire("55dRq");

var $cyFTW = parcelRequire("cyFTW");

var $itwAE = parcelRequire("itwAE");

var $4HMUz = parcelRequire("4HMUz");

var $ftoGP = parcelRequire("ftoGP");
class $881b67775ffe46ab$export$16fa2f45be04daa8 {
    /**
     * Logic
     */ property(type) {
        let offsets = this.getParentOffsets();
        let offsetProperty = typeof offsets[type] == "undefined" ? 0 : offsets[type];
        if (type == "height") offsetProperty = this.getHeight();
        return offsetProperty;
    }
    /**
     * Machine
     */ async sleep(ms) {
        await this.promise((resolve)=>{
            this.timeOut(()=>{
                resolve(undefined);
            }, ms);
        });
    }
    runAsCommit(func) {
        if (this.committed) func();
        else this.onCommit(()=>func());
    }
    async wait(animations) {
        await Promise.all(animations);
    }
    async promise(executor, displayRequired) {
        return (0, $nyKU9.SedestralMachine).promise(executor, displayRequired, this);
    }
    async simplePromise(executor, displayRequired) {
        return new Promise(executor);
    }
    /**
     * Animations
     */ async translate(params) {
        return this.simplePromise((resolve)=>{
            if (this.element instanceof HTMLElement) {
                let delay = params.delay == undefined ? 100 : params.delay;
                let delayStyle = `transition-duration: ${delay / 1000}s;`;
                /**
                 * transform
                 */ let transformStyle = ``;
                if (params.translateX != undefined) transformStyle += `translateX(${params.translateX}px) `;
                if (params.translateY != undefined) transformStyle += `translateY(${params.translateY}px) `;
                if (params.scale != undefined) transformStyle += `scale(${params.scale}) `;
                if (params.rotate != undefined) transformStyle += `rotate(${params.rotate}) `;
                if (transformStyle != ``) transformStyle = `transform:${transformStyle};`;
                /**
                 * position
                 */ let offsets = this.getParentOffsets();
                if (offsets == undefined) return;
                let positionStyle = ``;
                if (params.left != undefined) {
                    this.element.style.left = `${offsets['left']}px`;
                    this.element.style.right = "unset";
                    positionStyle += `left:${offsets['left'] + params.left}px;`;
                }
                if (params.top != undefined) {
                    this.element.style.top = `${offsets['top']}px`;
                    this.element.style.bottom = "unset";
                    positionStyle += `top:${offsets['top'] + params.top}px;`;
                }
                if (params.bottom != undefined) {
                    this.element.style.bottom = `${offsets['bottom']}px`;
                    this.element.style.top = "unset";
                    positionStyle += `bottom:${offsets['bottom'] + params.bottom}px;`;
                }
                if (params.right != undefined) {
                    this.element.style.right = `${offsets['right']}px`;
                    this.element.style.left = "unset";
                    positionStyle += `right:${offsets['right'] + params.right}px;`;
                }
                /**
                 * move
                 */ if (params.moveRight != undefined) {
                    this.element.style.right = `${offsets['right']}px`;
                    this.element.style.left = "unset";
                    positionStyle += `right:${params.moveRight}px;`;
                }
                if (params.moveLeft != undefined) {
                    this.element.style.left = `${offsets['left']}px`;
                    this.element.style.right = "unset";
                    positionStyle += `left:${params.moveLeft}px;`;
                }
                if (params.moveTop != undefined) {
                    this.element.style.top = `${offsets['top']}px`;
                    this.element.style.bottom = "unset";
                    positionStyle += `top:${params.moveTop}px;`;
                }
                if (params.moveBottom != undefined) {
                    this.element.style.bottom = `${offsets['bottom']}px`;
                    this.element.style.top = "unset";
                    positionStyle += `bottom:${params.moveBottom}px;`;
                }
                let propertiesStyle = ``;
                /**
                 * properties
                 */ if (params.opacity != undefined) propertiesStyle += `opacity:${params.opacity};`;
                if (params.padding != undefined) propertiesStyle += `padding:${params.padding}px;`;
                if (params.margin != undefined) propertiesStyle += `margin:${params.margin}px;`;
                if (params.height != undefined) {
                    this.element.style.height = `${this.getHeight()}px`;
                    propertiesStyle += `height:${params.height}px;`;
                }
                if (params.maxHeight != undefined) {
                    this.element.style.maxHeight = `${this.getHeight()}px`;
                    propertiesStyle += `max-height:${params.maxHeight}px;`;
                }
                if (params.maxWidth != undefined) {
                    this.element.style.maxWidth = `${this.getWidth()}px`;
                    propertiesStyle += `max-width:${params.maxWidth}px;`;
                }
                if (params.width != undefined) {
                    this.element.style.width = `${this.getWidth()}px`;
                    propertiesStyle += `width:${params.width}px;`;
                }
                if (params.widthPercent != undefined) propertiesStyle += `width:${params.widthPercent}%;`;
                if (params.borderRadius != undefined) propertiesStyle += `border-radius:${params.borderRadius};`;
                /**
                 * execution
                 */ (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                    setTimeout(()=>{
                        this.setStyle(transformStyle + delayStyle + positionStyle + propertiesStyle);
                    });
                });
                /**
                 * sync
                 */ this.timeOut(()=>{
                    resolve();
                    if (params.remove != undefined && params.remove == true) this.remove();
                }, delay);
            }
        });
    }
    async scale(start, value, speed) {
        if (this.element instanceof HTMLElement) {
            this.element.style.transform = "scale(" + start + ")";
            await this.translate({
                delay: speed,
                scale: value
            });
        }
    }
    async fade(value, speed) {
        if (this.element instanceof HTMLElement) {
            if (value == "in") this.show();
            let start = value == "in" ? 0 : 1;
            let final = value == "in" ? 1 : 0;
            this.setStyle(`opacity:${start}`);
            await this.translate({
                delay: speed,
                opacity: final
            });
        }
    }
    /**
     * toggle
     */ toggle(tog, gle) {
        let toggled = false;
        this.onClick(()=>{
            if (!toggled) {
                tog();
                toggled = true;
            } else {
                gle();
                toggled = false;
            }
        });
    }
    /**
     * Animations advanced
     */ async openUp(delay) {
        if (!(0, $ftoGP.isMobile)()) return this.scaleShow(delay);
        else return this.swapUp();
    }
    async closeDown(delay, scale, clear) {
        if (!(0, $ftoGP.isMobile)()) return this.scaleHide(delay, scale, clear);
        else return this.swapDown(clear);
    }
    async swapUp() {
        this.displayShow();
        this.setStyle(`transform:translateY(100%) scale(1);opacity:1;`);
        await this.translate({
            translateY: 0,
            delay: 400
        });
    }
    async swapDown(clear) {
        this.setStyle(`transform:scale(1);opacity:1;`);
        await this.translate({
            translateY: window.innerHeight,
            delay: 400
        });
        this.displayHide();
        if (clear == undefined || clear == true) this.clearAll();
    }
    async scaleShow(delay, withoutDisplay) {
        if (!withoutDisplay) this.displayShow();
        this.setStyle(`transform:scale(0.9);opacity:0;`);
        await this.translate({
            delay: delay == undefined ? 80 : delay,
            scale: 1,
            opacity: 1
        });
        this.isHide = false;
    }
    async scaleHide(delay, scale, clear) {
        this.setStyle(`transform:scale(1);opacity:1;`);
        await this.simplePromise((resolve)=>{
            (0, $nyKU9.SedestralMachine).requestFrame()(async ()=>{
                await this.translate({
                    delay: delay == undefined ? 80 : delay,
                    scale: scale == undefined ? 0.9 : scale,
                    opacity: 0
                });
                this.displayHide();
                (0, $nyKU9.SedestralMachine).requestFrame()(async ()=>{
                    this.timeOut(()=>{
                        if (clear == undefined || clear == true) this.clearAll();
                        resolve(true);
                    }, 100);
                });
            });
        });
        this.isHide = true;
    }
    async scaleShowTranslate(delay) {
        this.show();
        this.setStyle(`transform:scale(0.9) translateY(20px);opacity:0;`);
        await this.translate({
            delay: delay == undefined ? 80 : delay,
            translateY: 0,
            scale: 1,
            opacity: 1
        });
    }
    /**
     * outside click
     */ excludeOutsideClickComponent(component) {
        this.outsideClickExcludedComponents.push(component);
        component.onRemove(()=>this.outsideClickExcludedComponents.splice(this.outsideClickExcludedComponents.indexOf(component), 1));
    }
    /**
     * Scroll
     */ getScrollPercent() {
        if (this.element instanceof HTMLElement) return Math.round(this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight) * 100);
        return 0;
    }
    getScrollTop() {
        if (this.element instanceof HTMLElement) return this.element.scrollTop;
        return 0;
    }
    getScrollLeft() {
        if (this.element instanceof HTMLElement) return this.element.scrollLeft;
        return 0;
    }
    setScrollLeft(value) {
        if (this.element instanceof HTMLElement) this.element.scrollLeft = value;
    }
    setScrollTop(value) {
        if (this.element instanceof HTMLElement) this.element.scrollTop = value;
    }
    getScrollBottom() {
        if (this.element instanceof HTMLElement) return this.element.scrollHeight - Math.round(this.element.scrollTop + this.getHeight());
    }
    scrollTop(value, speed) {
        let easeInOutQuad = function(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };
        let start = this.getScrollTop(), change = value - start, currentTime = 0, increment = 20;
        let animateScroll = ()=>{
            currentTime += increment;
            this.setScrollTop(easeInOutQuad(currentTime, start, change, speed));
            if (currentTime < speed) (0, $nyKU9.SedestralMachine).setTimeout(animateScroll, increment);
        };
        animateScroll();
    }
    scrollIntoView(parent, offset, behavior) {
        parent = parent == undefined ? this.element.parentElement : parent;
        if (parent instanceof HTMLElement) {
            let parentRect = parent.getBoundingClientRect();
            let childRect = this.getHTMLElement().getBoundingClientRect();
            parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top + (offset == undefined ? 0 : offset);
        } else {
            let parentRect = parent.getHTMLElement().getBoundingClientRect();
            let childRect = this.getHTMLElement().getBoundingClientRect();
            let scrollTop = Math.round(childRect.top + parent.getHTMLElement().scrollTop - parentRect.top) + (offset == undefined ? 0 : offset);
            parent.getHTMLElement().scrollTo({
                top: scrollTop,
                behavior: behavior ? behavior : "smooth"
            });
        }
    }
    scrollTo(parent, offset) {
        parent.getHTMLElement().scrollTo({
            top: this.getParentOffsets(parent).top + (offset ? offset : 0),
            behavior: "smooth"
        });
    }
    scrollBottom(value, speed) {
        if (this.element instanceof HTMLElement) {
            let startDistance = this.element.scrollTop;
            let endDistance = this.element.scrollHeight - this.getHeight() - value;
            let frame = 0;
            let delta = (endDistance - startDistance) / speed / 0.06;
            let handle = (0, $nyKU9.SedestralMachine).setInterval(()=>{
                if (this.element instanceof HTMLElement) {
                    frame++;
                    let value = startDistance + delta * frame;
                    this.element.scrollTo(0, value);
                    if (this.element == undefined) clearInterval(handle);
                    if (value >= endDistance) clearInterval(handle);
                }
            }, 1 / 0.06);
        }
    }
    forceScrollUpdate() {
        this.addClass("scroll-sdt-scr");
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>this.removeClass("scroll-sdt-scr"));
    }
    /**
     * Dimensions
     */ getPaddingHeight() {
        let top = this.getHTMLElement().style.paddingTop.length > 0 ? parseInt(this.getHTMLElement().style.paddingTop) : 0;
        let bottom = this.getHTMLElement().style.paddingBottom.length > 0 ? parseInt(this.getHTMLElement().style.paddingBottom) : 0;
        return top + bottom;
    }
    getFullHeight() {
        let height = this.getHTMLElement().clientHeight;
        let style = getComputedStyle(this.getHTMLElement());
        height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
    }
    getHeightCalculated() {
        let getFullHeight = (element)=>{
            let style = window.getComputedStyle(element);
            let hauteur = element.offsetHeight;
            let margeHaut = parseInt(style.marginTop);
            let margeBas = parseInt(style.marginBottom);
            return hauteur + margeHaut + margeBas;
        };
        let height = 0;
        let childs = this.getHTMLElement() ? this.getHTMLElement().children : [];
        let parentStyle = window.getComputedStyle(this.getHTMLElement());
        let gap = parseInt(parentStyle.gap) || 0;
        for(let i = 0; i < childs.length; i++)if (!childs[i].hasAttribute('scrolltrack')) height += getFullHeight(childs[i]);
        height += gap * (childs.length - 1);
        return height;
    }
    getHeight() {
        if (this.element instanceof HTMLElement) return this.getHTMLElement().getBoundingClientRect().height + this.getPaddingHeight();
    }
    getHeightWithoutBorders() {
        return this.getHeight() - (this.getHTMLElement().offsetHeight - this.getHTMLElement().clientHeight);
    }
    getWidth() {
        if (this.element instanceof HTMLElement) return this.element.clientWidth;
    }
    getPaddingWidth() {
        let left = parseInt(this.getHTMLElement().style.paddingLeft);
        let right = parseInt(this.getHTMLElement().style.paddingRight);
        return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
    }
    getMarginWidth() {
        let left = parseInt(this.getHTMLElement().style.marginLeft);
        let right = parseInt(this.getHTMLElement().style.marginRight);
        return (Number.isNaN(left) ? 0 : left) + (Number.isNaN(right) ? 0 : right);
    }
    /**
     * Offsets
     */ getParentOffsets(element) {
        let parent = this.element.parentNode;
        if (typeof element != "undefined") parent = element.element;
        if (parent == undefined) return undefined;
        let parentOffsets = (0, $gKcOU.elementOffsets)(parent);
        let eOffsets = (0, $gKcOU.elementOffsets)(this.element);
        return {
            top: eOffsets["top"] - parentOffsets["top"],
            left: eOffsets["left"] - parentOffsets["left"],
            right: eOffsets["right"] - parentOffsets["right"],
            bottom: eOffsets["bottom"] - parentOffsets["bottom"]
        };
    }
    getOffsets() {
        return (0, $gKcOU.elementOffsets)(this.element);
    }
    /**
     * Value and html and text
     */ getValue() {
        if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) return this.element.value;
        return "";
    }
    getValueTrim() {
        return this.getValue().trim();
    }
    setValue(value) {
        if (this.element instanceof HTMLInputElement || this.element instanceof HTMLTextAreaElement) this.element.value = value;
        return "";
    }
    streamValue(text, delay) {
        let index = 0;
        this.setValue("");
        let interval = this.interval(()=>{
            if (index < text.length) {
                this.setValue(this.getValue() + text[index]);
                index++;
            } else clearInterval(interval);
        }, delay / text.length);
    }
    getHtml() {
        if (this.element instanceof HTMLElement) return this.element.innerHTML;
    }
    setHtml(html) {
        if (this.element instanceof HTMLElement) this.element.innerHTML = "" + html;
    }
    getText() {
        if (this.element instanceof HTMLElement) return this.element.innerText;
    }
    streamText(text, delay) {
        let index = 0;
        this.setHtml(""); // Effacer le contenu initial
        const addHtml = ()=>{
            if (index < text.length) {
                if (text.substring(index, index + 8) === '<strong>') {
                    // On a trouvé le début d'une balise <strong>
                    const endOfStrongTag = text.indexOf('</strong>', index);
                    if (endOfStrongTag !== -1) {
                        // Ajouter la balise <strong>...</strong> entière en une fois
                        this.setHtml(this.getHtml() + text.substring(index, endOfStrongTag + 9));
                        index = endOfStrongTag + 9; // Avancer l'index après la balise </strong>
                    }
                } else {
                    // Ajouter un caractère normal
                    this.setHtml(this.getHtml() + text[index]);
                    index++;
                }
            } else clearInterval(interval); // Arrêter l'insertion lorsque tout le texte est ajouté
        };
        let interval = setInterval(addHtml, delay / text.length);
    }
    setText(text) {
        if (this.element instanceof HTMLElement) this.element.innerText = text;
    }
    /**
     * style
     */ setPlaceHolderStyle(value) {
        this.placeHolderSelector = (0, $itwAE.randomString)(20, false);
        this.addClass(this.placeHolderSelector);
        if (!this.placeholderStyleElement) {
            this.placeholderStyleElement = document.createElement("style");
            this.placeholderStyleElement = this.getHTMLElement().appendChild(this.placeholderStyleElement);
        }
        this.placeholderStyleElement.innerHTML = `.${this.placeHolderSelector}::placeholder { ${value} }`;
    }
    setStyle(value) {
        if (this.element instanceof HTMLElement || this.element instanceof SVGElement) this.element.style.cssText += value;
    }
    getStyle(strCssRule) {
        let strValue = "";
        if (this.element instanceof HTMLElement) {
            if (document.defaultView && document.defaultView.getComputedStyle) strValue = document.defaultView.getComputedStyle(this.element, "").getPropertyValue(strCssRule);
            else if (this.element['currentStyle']) {
                strCssRule = strCssRule.replace(/\-(\w)/g, function(strMatch, p1) {
                    return p1.toUpperCase();
                });
                strValue = this.element['currentStyle'][strCssRule];
            }
        }
        return strValue;
    }
    setStyleValue(type, value) {
        if (this.element instanceof HTMLElement) this.element.style[type] = value;
    }
    /**
     * visibility status
     */ hide() {
        this.isHide = true;
        this.setStyle("visibility:hidden;");
    }
    show() {
        this.isHide = false;
        this.setStyle("visibility:visible;");
    }
    displayHide() {
        this.isHide = true;
        this.setStyle("display:none;");
    }
    displayShow() {
        this.isHide = false;
        this.setStyle("display:block;");
    }
    displayFlex() {
        this.isHide = false;
        this.setStyle("display:flex;");
    }
    isDisplayNone() {
        return this.getStyle("display") == "none";
    }
    isVisible() {
        if (this.element instanceof HTMLElement) return this.element.offsetParent !== undefined;
    }
    /**
     * On events
     */ onHotKeys(keys, func) {
        keys.forEach((key)=>{
            this.hotKeyListeners.push(key);
            (0, $nyKU9.SedestralMachine).addHotKeyListener(this, key, func);
        });
    }
    onHotKey(keys, func) {
        this.hotKeyListeners.push(keys);
        (0, $nyKU9.SedestralMachine).addHotKeyListener(this, keys, func);
        return keys;
    }
    onChange(func) {
        if (this.mutationObserver == undefined) {
            this.mutationFunctions = [];
            this.mutationObserver = new MutationObserver((mutations)=>{
                for (let f of this.mutationFunctions)f(mutations);
            });
            this.mutationObserver.observe(this.getHTMLElement(), {
                subtree: true,
                childList: true,
                characterData: true,
                attributes: true,
                characterDataOldValue: true,
                attributeOldValue: true,
                attributeFilter: [
                    'id',
                    'class'
                ]
            });
        }
        this.mutationFunctions.push(func);
        return func;
    }
    onResize(func) {
        if (this.element instanceof Element) {
            let f = ()=>{
                let offsets = this.getOffsets();
                func({
                    height: this.getHeight(),
                    width: this.getWidth(),
                    x: offsets.left,
                    y: offsets.top
                });
            };
            window.addEventListener("resize", f);
            this.onRemove(()=>window.removeEventListener("resize", f));
            this.onChange(()=>f());
            (0, $nyKU9.SedestralMachine).resizeObserver.observe(this.element);
            if (this.element['resizeFunctions'] == undefined) this.element['resizeFunctions'] = [];
            this.element['resizeFunctions'].push(func);
        }
    }
    onInput(func, delay) {
        return this.addListener('input', this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onKey(func, delay) {
        return this.addListener('keydown', this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onKeyUp(func, delay) {
        return this.addListener('keyup', this.delay(func, typeof delay == "undefined" ? 0 : delay));
    }
    onClick(func, stopPropagation, mobileDelay) {
        return this.addListener('click', (e)=>{
            if (stopPropagation) {
                e.stopImmediatePropagation();
                e.stopPropagation();
            }
            if ((0, $ftoGP.isMobile)() && mobileDelay) this.timeOut(()=>func(e), 200);
            else func(e);
        });
    }
    onDragEvent(onEnter, onLeave) {
        let entered = false;
        let leave = true;
        let listeners = [];
        listeners.push(this.putListener(window, "dragleave", (e)=>{
            if (!leave) {
                if (!(0, $55dRq.elementParents)(e.target).includes(this.getHTMLElement())) {
                    entered = false;
                    leave = true;
                    onLeave(e);
                }
            }
        }));
        listeners.push(this.putListener(window, "dragenter", (e)=>{
            if (!entered) {
                if (e.target == this.getHTMLElement() || (0, $55dRq.elementParents)(e.target).includes(this.getHTMLElement())) {
                    this.timeOut(()=>leave = false, 50);
                    entered = true;
                    onEnter(e);
                }
            }
        }));
        this.putListener(window, "focus", (e)=>onLeave(e));
        return listeners;
    }
    onDragDrop(func) {
        return this.addListener("drop", (e)=>func(e));
    }
    onRightClick(func) {
        this.addListener("contextmenu", (e)=>{
            e.preventDefault();
            func(e);
        });
    }
    onWindowResize(func) {
        this.putListener(window, "resize", func);
    }
    onFocus(func) {
        return this.addListener('focus', (e)=>func(e));
    }
    onBlur(func) {
        return this.addListener('blur', (e)=>func(e));
    }
    onScroll(callback) {
        return this.addListener("scroll", callback);
    }
    async onOutsideClick(func, propagation) {
        await (0, $nyKU9.SedestralMachine).sleep(50);
        let listener = this.putListener(window, 'click', (e)=>{
            if (!(0, $3SbXF.elementNotChildren)(document, e.target)) {
                if (!this.isNull() && (0, $3SbXF.elementNotChildren)(this.element, e.target) && this.outsideClickExcludedComponents.filter((value)=>!(0, $3SbXF.elementNotChildren)(value.element, e.target)).length == 0) {
                    if (typeof propagation != "undefined") e.stopImmediatePropagation();
                    func(e);
                }
            }
        });
        (0, $nyKU9.SedestralMachine).addOutsideClickListener(listener, this);
        return listener;
    }
    async onOutsideRightClick(func, propagation) {
        await (0, $nyKU9.SedestralMachine).sleep(50);
        return this.putListener(window, "contextmenu", (e)=>{
            if ((0, $3SbXF.elementNotChildren)(this.element, e.target)) {
                if (typeof propagation != "undefined") e.stopImmediatePropagation();
                func(e);
            }
        });
    }
    onComponentClick(name, func) {
        let globalFunc = function(e) {
            let parentsClasses = [];
            let a = e.target;
            while(a){
                a = a.parentNode;
                if (a != undefined) {
                    if (a.className !== "") parentsClasses.push(a.className);
                }
            }
            let has = false;
            if ((0, $42a2f.elementHasClass)(e.target.className, name)) has = true;
            for(let i = 0; i < parentsClasses.length; i++)if ((0, $42a2f.elementHasClass)(parentsClasses[i], name)) has = true;
            if (has) func();
        };
        return this.addListener('click', globalFunc);
    }
    onHover(func, time) {
        return this.addListener('mouseenter', (e)=>{
            if (time == undefined) func(e);
            else {
                let timeOut = this.timeOut(()=>{
                    func(e);
                }, time);
                let leaveListener = this.addListener('mouseleave', (e)=>{
                    clearTimeout(timeOut);
                    this.deleteListener(leaveListener);
                });
            }
        });
    }
    onLeave(func, time) {
        return this.addListener('mouseleave', (e)=>{
            if (time == undefined) func(e);
            else {
                let timeOut = this.timeOut(()=>{
                    func(e);
                }, time);
                let leaveListener = this.addListener('mouseenter', (e)=>{
                    clearTimeout(timeOut);
                    this.deleteListener(leaveListener);
                });
            }
        });
    }
    onSubmit(func) {
        if (this.element instanceof HTMLElement) this.element.onsubmit = (e)=>{
            func(e);
        };
    }
    onCommit(func) {
        this.onCommitFunctions.push(func);
    }
    onRemove(func) {
        this.onRemoveFunctions.push(func);
    }
    onReactiveObserve(func) {
        this.reactives.push((0, $i3Hbv.observe)(()=>func(), {
            lazy: false
        }));
    }
    onBufferReactiveObserve(func) {
        let scheduled;
        this.reactives.push((0, $i3Hbv.observe)(()=>func(), {
            lazy: false,
            scheduler: ()=>{
                clearTimeout(scheduled);
                scheduled = this.timeOut(()=>{
                    if (!this.isNull()) func();
                }, 25);
                return setTimeout(undefined, 0);
            }
        }));
    }
    onVisible(callback) {
        if (!this.isNull()) new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.intersectionRatio > 0) {
                    callback(this.getHTMLElement());
                    observer.disconnect();
                }
            });
        }).observe(this.getHTMLElement());
    }
    onVisibilityChange(callback) {
        if (!this.isNull()) new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                callback(entry.isIntersecting);
            });
        }, {
            threshold: [
                0
            ]
        }).observe(this.getHTMLElement());
    }
    onParentsScroll(callback) {
        return this.putListener(document, "scroll", (e)=>{
            if ((0, $55dRq.elementParents)(this.getHTMLElement()).includes(e.target)) callback(e);
        }, true);
    }
    isBelowScroll(callback, mid) {
        function isElementBelowViewportBottom(element, currentScrollTop) {
            const viewportBottom = currentScrollTop + window.innerHeight;
            const elementTop = element.getBoundingClientRect().top + window.scrollY;
            return elementTop > viewportBottom - (mid ? window.innerHeight / 2 - 100 : 0);
        }
        this.putListener(document, "scroll", ()=>{
            const scrollTop = window.scrollY;
            const targetElement = this.getHTMLElement();
            if (isElementBelowViewportBottom(targetElement, scrollTop)) callback(false);
            else callback(true);
        });
        callback(false);
    }
    /**
     * focus
     */ isFocus() {
        return document.activeElement == this.element;
    }
    focus() {
        if (this.element instanceof HTMLElement) this.element.focus();
    }
    focusAtEnd() {
        this.focus();
        let inputElement = this.getHTMLElement();
        if (inputElement) {
            let strLength = this.getValue().length * 2;
            (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                let type = inputElement.type;
                inputElement.type = "text";
                inputElement.focus();
                inputElement.setSelectionRange(strLength, strLength);
                inputElement.type = type;
            });
        }
    }
    /**
     * append and prepend html text inside component
     */ pendTop() {
        let eElement = this.element.parentNode;
        if (eElement.firstChild != this.element) {
            let newFirstElement = this.element;
            eElement.insertBefore(newFirstElement, eElement.firstChild);
        }
    }
    pendBottom() {
        let eElement = this.element.parentNode;
        let newFirstElement = this.element;
        eElement.appendChild(newFirstElement);
    }
    pendAfter(beforeComponent, component) {
        component = component ? component : this;
        beforeComponent.element.parentElement.appendChild(component.element);
        let beforeElement = beforeComponent.element;
        beforeElement = beforeElement.nextSibling == undefined ? beforeElement : beforeElement.nextSibling;
        beforeComponent.element.parentElement.insertBefore(component.element, beforeElement);
    }
    pendBefore(beforeComponent, component) {
        component = component ? component : this;
        beforeComponent.element.parentElement.appendChild(component.element);
        beforeComponent.element.parentElement.insertBefore(component.element, beforeComponent.element);
    }
    prepend(html, tag) {
        let component = this.append(html, tag);
        component.pendTop();
        return component;
    }
    append(html, tag) {
        let buffer = document.createElement(typeof tag == "undefined" ? "div" : typeof this.tagParents[tag] == "undefined" ? tag : this.tagParents[tag]);
        buffer.innerHTML = html.trim();
        let element = buffer.firstChild;
        if (buffer.childNodes.length > 1) {
            var _this_element, _this_element1;
            (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(buffer);
            (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(buffer, this.element.lastChild);
            element = buffer;
        } else {
            var _this_element2, _this_element3;
            (_this_element2 = this.element) === null || _this_element2 === void 0 ? void 0 : _this_element2.appendChild(element);
            (_this_element3 = this.element) === null || _this_element3 === void 0 ? void 0 : _this_element3.insertBefore(element, this.element.lastChild);
        }
        let component = (0, $2aBLW.SedestralInterface).el(element);
        this.childrens.filter((value)=>!value.drawCommitted).forEach((value)=>this.drawCommit(value));
        if (!component.committed) component.tryCommit();
        this.addChildren(component);
        return component;
    }
    /**
     * Reactive
     */ reactive(v) {
        let id = (0, $itwAE.randomString)(18, true);
        this.onReactiveObserve(()=>{
            try {
                let value = v();
                if (!this.isNull()) {
                    let element = this.getHTMLElement().getElementsByClassName(id)[0];
                    if (element != undefined) element.innerHTML = (0, $cyFTW.filterXSS)(value);
                }
            } catch (e) {}
        });
        return `<reactive class="${id}">${(0, $cyFTW.filterXSS)(v())}</reactive>`;
    }
    reactiveObservable(obj) {
        return (0, $i3Hbv.observable)(obj);
    }
    reactiveUnObserve(v) {
        (0, $i3Hbv.unobserve)(v);
    }
    reactivesUnObserve() {
        for(let i = 0; i < this.reactives.length; i++)this.reactiveUnObserve(this.reactives[i]);
        this.reactives = [];
    }
    /**
     * Return the template of an component and added to childrens for final commit
     */ drawAll(components) {
        let template = "";
        for(let i = 0; i < components.length; i++){
            let component = components[i];
            template += this.draw(component);
        }
        return template;
    }
    drawCommit(component) {
        component.drawCommitted = true;
        if (!component.committed) {
            let element = document.getElementById(component.componentId);
            if (element != undefined) {
                component.element = element;
                component.removeAttribute("id");
            }
            component.tryCommit();
        }
    }
    draw(component) {
        component.drawCommitted = false;
        let buffer = document.createElement('div');
        buffer.innerHTML = component.getTemplate().trim();
        if (buffer.childNodes.length > 1) {
            buffer.id = component.componentId;
            component.template = buffer['outerHTML'];
        } else {
            buffer.firstChild['id'] = component.componentId;
            component.template = buffer['innerHTML'];
        }
        if (this.committed) (0, $nyKU9.SedestralMachine).requestFrame()(()=>this.drawCommit(component));
        else this.onCommit(()=>this.drawCommit(component));
        this.addChildren(component);
        return component.getTemplate();
    }
    drawFly(component) {
        if (this.committed) {
            this.render(component);
            let html = component.getHTMLElement().outerHTML;
            component.remove();
            return html;
        }
    }
    /**
     * Append a component inside other, better performance than draw()
     */ prerender(component) {
        return this.render(component, true);
    }
    render(component, prepend, beforeComponent, beforeAfter) {
        var _this_element, _this_element1;
        let buffer = document.createElement(typeof this.tagParents[component.type] == "undefined" ? component.type : this.tagParents[component.type]);
        buffer.innerHTML = component.getTemplate().trim();
        let element = buffer.firstChild;
        if (buffer.childNodes.length > 1) element = buffer;
        (_this_element = this.element) === null || _this_element === void 0 ? void 0 : _this_element.appendChild(element);
        (_this_element1 = this.element) === null || _this_element1 === void 0 ? void 0 : _this_element1.insertBefore(element, !prepend ? this.element.lastChild : this.element.firstChild);
        component.element = element;
        if (!component.committed) component.tryCommit();
        this.addChildren(component);
        if (beforeComponent) beforeAfter ? this.pendAfter(beforeComponent, component) : this.pendBefore(beforeComponent, component);
        return component;
    }
    /**
     * call this function after apend in DOM
     */ tryCommit() {
        try {
            this.commit();
            this.committed = true;
        } catch (e) {
            (0, $6pO1Y.SedestralDebugger).addError("SEDESTRAL COMMIT ERROR", e);
            this.committedError = true;
            this.commitFailed();
        }
    }
    commit() {
        this.committed;
        if (!this.committed) {
            this.committed = true;
            for (let commitFunc of this.onCommitFunctions)commitFunc();
        }
    }
    commitFailed() {}
    commitTooltips() {
        let elements = (0, $9UiNT.elementChildrens)(this.getHTMLElement());
        elements.forEach((element)=>{
            if (!element['commitTooltips']) {
                element['commitTooltips'] = true;
                let tooltipText = element.getAttribute("data-tooltip");
                let tooltipPosition = element.getAttribute("data-tooltip-position");
                if (tooltipText != undefined) {
                    let component = this.ele(element);
                    component.setTooltip(tooltipText, tooltipPosition);
                }
            }
        });
    }
    /**
     * errors
     */ addNetworkErrors(errors) {
        errors.forEach((error)=>this.networkErrorsHandler.push(error));
    }
    /**
     * create an empty element in DOM with className
     */ virtual(name) {
        let buffer = document.createElement('div');
        buffer.className = name;
        this.element = buffer;
        document.body.appendChild(buffer);
        document.body.insertBefore(buffer, this.element.lastChild);
    }
    addChildren(element) {
        if (!this.childrens.includes(element)) this.childrens.push(element);
    }
    removeChildren(element) {
        let index = this.childrens.indexOf(element);
        if (index >= 0) this.childrens.splice(index, 1);
    }
    /**
     * save and restore headers
     */ saveScroll() {
        this.savedScroll = this.getHTMLElement().scrollTop;
        this.savedScrollCalc = this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight;
    }
    restoreScroll() {
        this.getHTMLElement().scrollTop = this.savedScroll + (this.getHTMLElement().scrollHeight - this.getHTMLElement().clientHeight - this.savedScrollCalc);
    }
    save() {
        if (this.element instanceof HTMLElement) {
            this.savedStyle = this.element.getAttribute("style");
            this.savedHtml = this.element.innerHTML;
        }
    }
    saveAndClear() {
        this.save();
        this.clear();
    }
    saveForLoading() {
        this.setStyle(`padding:0;height:${this.getHeightWithoutBorders()}px;width:${this.getWidth()}px;`);
        this.saveAndClear();
    }
    restore() {
        if (this.element instanceof HTMLElement) {
            this.element.setAttribute("style", this.savedStyle);
            this.element.innerHTML = this.savedHtml;
        }
    }
    /**
     * Listeners
     */ clearListeners() {
        for(let i = 0; i < this.listeners.length; i++)(0, $nyKU9.SedestralMachine).removeListener(this.listeners[i]);
        this.hotKeyListeners.forEach((value)=>(0, $nyKU9.SedestralMachine).deleteHotKeyListener(this, value));
        this.listeners = [];
        this.hotKeyListeners = [];
    }
    clearTooltipListeners() {
        for(let i = 0; i < this.tooltipListeners.length; i++)(0, $nyKU9.SedestralMachine).removeListener(this.tooltipListeners[i]);
        this.tooltipListeners = [];
        if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) this.tooltip.tooltipComponent.remove();
        this.tooltip = undefined;
    }
    clearTimeouts() {
        for(let i = 0; i < this.timeOuts.length; i++)clearTimeout(this.timeOuts[i]);
        this.timeOuts = [];
    }
    clearIntervals() {
        for(let i = 0; i < this.intervals.length; i++)clearInterval(this.intervals[i]);
        this.intervals = [];
    }
    addListener(name, func) {
        var _SedestralDebugger_rum;
        (0, $6pO1Y.SedestralDebugger).eventTarget(this, name);
        let rum = (_SedestralDebugger_rum = (0, $6pO1Y.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.eventTarget(name);
        return this.putListener(this.element, name, (e)=>{
            func(e);
            rum === null || rum === void 0 ? void 0 : rum.end();
        });
    }
    putListener(element, name, func, options) {
        let listener = (0, $nyKU9.SedestralMachine).addListener(element, name, func, options);
        this.listeners.push(listener);
        return listener;
    }
    deleteListener(data) {
        if (data != undefined) {
            (0, $nyKU9.SedestralMachine).removeListener(data);
            let index = this.listeners.indexOf(data);
            if (index >= 0) this.listeners.splice(index, 1);
        }
    }
    deleteListeners(listeners) {
        for (let listener of listeners)this.deleteListener(listener);
    }
    deleteHotKeyListener(hotkeys) {
        (0, $nyKU9.SedestralMachine).deleteHotKeyListener(this, hotkeys);
        let index = this.hotKeyListeners.indexOf(hotkeys);
        if (index >= 0) this.hotKeyListeners.splice(index, 1);
    }
    deleteHotKeyListeners(hotkeys) {
        hotkeys.forEach((value)=>this.deleteHotKeyListener(value));
    }
    deleteOnChangeListener(func) {
        this.mutationFunctions.splice(this.mutationFunctions.indexOf(func), 1);
    }
    /**
     * run listeners
     */ runRemoves() {
        if (this.onRemoveFunctions.length > 0) for (let removeFunc of this.onRemoveFunctions)removeFunc();
        this.onRemoveFunctions = [];
    }
    /**
     * Class interaction
     */ hasClass(cls) {
        if (this.element instanceof HTMLElement) return (0, $42a2f.elementHasClass)(this.element.className, cls);
    }
    addClass(cls) {
        if (this.element instanceof HTMLElement) {
            if (!this.hasClass(cls)) {
                const last = this.element.className.charAt(this.element.className.length - 1);
                this.element.className += (last == " " ? "" : " ") + cls;
            }
        }
    }
    removeClass(cls) {
        if (this.element instanceof HTMLElement) {
            if (this.hasClass(cls)) {
                let reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
                this.element.className = this.element.className.replace(reg, " ");
            }
        }
    }
    /**
     * Attribute interactions
     */ getAttribute(name) {
        if (this.element instanceof HTMLElement) return this.element.getAttribute(name);
    }
    setAttribute(name, content) {
        if (this.element instanceof HTMLElement) this.element.setAttribute(name, content);
    }
    removeAttribute(name) {
        if (this.element instanceof HTMLElement) this.element.removeAttribute(name);
    }
    /**
     * child headers manipulation
     */ els(className) {
        if (this.element instanceof HTMLElement) {
            let elements = [];
            let components = [];
            if (this.hasClass(className)) elements.push(this.element);
            let classes = this.element.getElementsByClassName(className);
            for(let i = 0; i < classes.length; i++)elements.push(classes[i]);
            for (let element of elements){
                let cache = this.childrens.filter((value)=>value.element == element)[0];
                if (cache == undefined) {
                    let e = (0, $2aBLW.SedestralInterface).el(element);
                    e.committed = true;
                    components.push(e);
                    this.addChildren(e);
                } else components.push(cache);
            }
            return components;
        }
    }
    el(className, noCache) {
        if (!noCache) {
            let cache = this.childrens.filter((value)=>value.element != undefined && value.hasClass(className))[0];
            if (cache != undefined) return cache;
        }
        if (this.element instanceof HTMLElement) {
            let e = (0, $2aBLW.SedestralInterface).el(this.hasClass(className) ? this.element : this.element.getElementsByClassName(className)[0]);
            e.committed = true;
            this.addChildren(e);
            return e;
        }
    }
    ele(element) {
        let cache = this.childrens.filter((value)=>value.element == element)[0];
        if (cache == undefined) {
            let e = (0, $2aBLW.SedestralInterface).el(element);
            e.committed = true;
            this.addChildren(e);
            return e;
        }
        return cache;
    }
    has(className) {
        if (this.element instanceof HTMLElement) {
            let elements = this.element.getElementsByClassName(className);
            if (elements.length > 0) return true;
        }
        return false;
    }
    clearChildrens() {
        for(let i = 0; i < this.childrens.length; i++){
            let child = this.childrens[i];
            child.destroy();
        }
        this.childrens = [];
    }
    count(className) {
        if (this.element instanceof HTMLElement) {
            let elements = this.element.getElementsByTagName("*");
            let count = 0;
            for(let i = 0; i < elements.length; i++)if (!!elements[i].className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))) count++;
            return count;
        }
    }
    /**
     * apply events
     */ delay(callback, ms) {
        if (ms == 0) return callback;
        else {
            let timer = 0;
            return (params)=>{
                clearTimeout(timer);
                timer = (0, $nyKU9.SedestralMachine).setTimeout(()=>{
                    callback(params);
                }, ms || 0);
            };
        }
    }
    timeOut(callback, ms) {
        let timeout = (0, $nyKU9.SedestralMachine).setTimeout(()=>{
            callback();
        }, ms);
        this.timeOuts.push(timeout);
        return timeout;
    }
    interval(callback, ms, lazy) {
        if (!lazy) callback();
        let timeout = (0, $nyKU9.SedestralMachine).setInterval(()=>{
            callback();
        }, ms);
        this.intervals.push(timeout);
        return timeout;
    }
    /**
     * others
     */ isNull() {
        return this.element == undefined;
    }
    /**
     * end
     */ remove() {
        if (this.element != undefined && this.element.parentNode !== undefined) {
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.destroy();
    }
    nullify() {
        if (this.getHTMLElement() != undefined) (0, $nyKU9.SedestralMachine).resizeObserver.unobserve(this.getHTMLElement());
        if (this.mutationObserver != undefined) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
            this.mutationFunctions = [];
        }
        this.clearAll();
        this.element = undefined;
        this.timeOuts = [];
        this.intervals = [];
        this.reactives = [];
        this.listeners = [];
        this.hotKeyListeners = [];
        this.childrens = [];
        this.isHide = undefined;
        this.savedHtml = undefined;
        this.savedStyle = undefined;
        this.savedScroll = undefined;
        this.savedScroll = undefined;
        this.savedScrollCalc = undefined;
        this.outsideClickExcludedComponents = [];
        this.template = undefined;
        this.type = undefined;
        this.scrollbar = undefined;
        this.swapBar = undefined;
        this.runRemoves();
        this.onCommitFunctions = [];
        for(let key in this)if (this.hasOwnProperty(key)) {
            let value = this[key];
            let isArray = Array.isArray(value);
            if (isArray && value['length'] != 0 || !isArray && value != undefined) {
                if (isArray) value = [];
                else value = undefined;
            }
        }
    }
    destroy() {
        this.nullify();
        (0, $2aBLW.SedestralInterface).unStore(this);
    }
    destroyChildrens() {
        this.childrens.forEach((value)=>{
            value.destroyChildrens();
            value.destroy();
        });
    }
    clear() {
        if (this.element instanceof HTMLElement) {
            this.element.innerHTML = "";
            this.clearChildrens();
        }
    }
    clearAll() {
        this.scrollbar = undefined;
        this.swapBar = undefined;
        this.clear();
        this.clearListeners();
        this.clearTooltipListeners();
        this.clearIntervals();
        this.clearTimeouts();
        this.reactivesUnObserve();
    }
    /**
     * change element status
     */ scrollable(autoPlace) {
        if (this.scrollbar == undefined) this.scrollbar = new (0, $idTHf.ComponentScrollbar)(this, autoPlace);
        return this.scrollbar;
    }
    swapable(onDispose) {
        if ((0, $ftoGP.isMobile)()) {
            if (this.swapBar == undefined) this.swapBar = new (0, $bLZiK.ComponentSwapBar)(this, onDispose);
            return this.swapBar;
        }
    }
    unClickable() {
        this.onClick((e)=>{
            e.preventDefault();
        }, true);
    }
    /**
     * tooltip
     */ showShadowTooltip(template, color) {
        this.setStyle(`box-shadow: 0 0 0 2px ${color};`);
        this.showTooltip(template, 2000, "bottom");
        clearTimeout(this.tooltipShowShadowTimeout);
        this.tooltipShowShadowTimeout = this.timeOut(()=>{
            this.setStyle(`box-shadow: unset;`);
        }, 2000);
    }
    showTooltip(template, delay, position, noAnimation) {
        clearTimeout(this.tooltipShowTimeout);
        if (!this.tooltip) this.tooltip = new (0, $8YCm8.ComponentTooltip)(this, template, position, noAnimation);
        this.tooltipShowTimeout = this.timeOut(()=>{
            if (this.tooltip) this.tooltip.tooltipComponent.remove();
            this.tooltip = undefined;
        }, delay ? delay : 3000);
    }
    setTooltip(template, position, noAnimation, disabled) {
        if ((0, $ftoGP.isMobile)()) {
            let showed = false;
            let show = ()=>{
                if (disabled == undefined || !disabled()) {
                    this.tooltip = new (0, $8YCm8.ComponentTooltip)(this, template, position, noAnimation);
                    showed = true;
                }
            };
            let hide = ()=>{
                if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) {
                    this.tooltip.tooltipComponent.remove();
                    this.tooltip = undefined;
                    showed = false;
                }
            };
            this.tooltipListeners.push(this.onClick(()=>{
                if (showed) hide();
                else show();
            }));
            this.onOutsideClick(()=>hide()).then((value)=>this.tooltipListeners.push(value));
        } else {
            this.tooltipListeners.push(this.onHover(()=>{
                if (disabled == undefined || !disabled()) this.tooltip = new (0, $8YCm8.ComponentTooltip)(this, template, position, noAnimation);
            }));
            this.tooltipListeners.push(this.onClick(()=>{
                if (this.tooltip != undefined && this.tooltip.tooltipComponent != undefined && !this.tooltip.tooltipComponent.isNull()) {
                    this.tooltip.tooltipComponent.remove();
                    this.tooltip = undefined;
                }
            }));
        }
    }
    /**
     * getter and setter
     */ getHTMLElement() {
        if (this.element instanceof HTMLElement) return this.element;
    }
    getTemplate() {
        return this.template;
    }
    constructor(element){
        this.networkErrorsHandler = [];
        this.tagParents = {
            "th": "tr",
            "td": "tr",
            "tr": "tbody"
        };
        this.element = element;
        this.componentId = (0, $4HMUz.randomUUID)();
        this.timeOuts = [];
        this.intervals = [];
        this.reactives = [];
        this.listeners = [];
        this.hotKeyListeners = [];
        this.childrens = [];
        this.isHide = false;
        this.savedHtml = undefined;
        this.savedStyle = undefined;
        this.savedScroll = 0;
        this.savedScrollCalc = 0;
        this.template = `<div></div>`;
        this.type = "DIV";
        this.committedError = false;
        this.committed = false;
        this.drawCommitted = true;
        this.onCommitFunctions = [];
        this.onRemoveFunctions = [];
        this.tooltipListeners = [];
        this.outsideClickExcludedComponents = [];
        (0, $2aBLW.SedestralInterface).store(this);
    }
}

});
parcelRegister("idTHf", function(module, exports) {

$parcel$export(module.exports, "ComponentScrollbar", function () { return $db47589a35a2e807$export$17759cda9c0355fc; });

var $nyKU9 = parcelRequire("nyKU9");

var $eo9gQ = parcelRequire("eo9gQ");

var $6L35I = parcelRequire("6L35I");

var $ftoGP = parcelRequire("ftoGP");
class $db47589a35a2e807$export$17759cda9c0355fc {
    build() {
        if (this.component.element instanceof HTMLElement) {
            if (!(0, $ftoGP.isMobile)()) {
                let template = `
                <div scrollTrack class="${$eo9gQ.scrollVirtualTrack}">
                    <div scrollBar class="${$eo9gQ.scrollVirtualBar}"></div>
                </div>`;
                this.component.prepend(template);
                this.track = this.component.el($eo9gQ.scrollVirtualTrack);
                this.bar = this.component.el($eo9gQ.scrollVirtualBar);
            }
            this.component.addClass($eo9gQ.scrollVirtual);
            if (!(0, $ftoGP.isMobile)() && this.autoPlace) {
                this.place();
                this.component.putListener(window, "resize", ()=>this.place());
            }
        }
    }
    binding() {
        this.bar.addListener("mousedown", (e)=>{
            this.onBarMouseDown(e);
        });
        this.track.addListener("click", (e)=>{
            this.onTrackClick(e);
        });
        this.component.onScroll(()=>this.onScrollResize());
        //this.component.onChange(() => this.onScrollResize());
        this.component.onResize(()=>this.onScrollResize());
        this.component.interval(()=>this.onScrollResize(), 500);
    }
    onScrollResize() {
        if (performance.now() - this.now > 1) {
            if (!(0, $6L35I.isTabletNative)() && this.component.element instanceof HTMLElement) {
                let difference = this.component.element.scrollHeight - this.component.element.clientHeight;
                if (difference <= 0) {
                    this.track.setStyle("display:none;");
                    this.component.removeClass($eo9gQ.scrollVirtual);
                    (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                        this.component.removeAttribute("scrollVirtual");
                    });
                } else {
                    this.track.setStyle("display:block;");
                    this.component.addClass($eo9gQ.scrollVirtual);
                    this.component.setAttribute("scrollVirtual", "");
                }
                this.moveBar();
                this.timeOutResize = this.component.timeOut(()=>this.getTrackBounds(), 200);
            }
            this.now = performance.now();
        }
    }
    onDrag(e) {
        this.isDragging = true;
        let delta = e.pageY - this.lastPageY;
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
            let sTop = document.documentElement.scrollTop;
            let isDragWithinTrackBounds = e.pageY >= this.trackRect.top + sTop && e.pageY <= this.trackRect.bottom + sTop;
            if (isDragWithinTrackBounds) this.component.setScrollTop(this.dragScrollTop + delta / this.scrollRatio);
            else {
                this.dragScrollTop = this.component.getScrollTop();
                this.lastPageY = e.pageY;
            }
        });
    }
    onStopDrag(e) {
        this.bar.removeClass($eo9gQ.scrollVirtualGrabbed);
        this.track.removeClass($eo9gQ.scrollVirtualGrabbed);
        this.bar.removeAttribute("scrollGrabbed");
        this.track.removeAttribute("scrollGrabbed");
        document.body.classList.remove($eo9gQ.scrollVirtualSelect);
        this.component.deleteListener(this.mouseDragListener);
        this.component.deleteListener(this.mouseStopDragListener);
        this.component.timeOut(()=>{
            this.isDragging = false;
        }, 100);
    }
    onBarMouseDown(e) {
        this.dragScrollTop = this.component.getScrollTop();
        this.lastPageY = e.pageY;
        this.bar.addClass($eo9gQ.scrollVirtualGrabbed);
        this.track.addClass($eo9gQ.scrollVirtualGrabbed);
        this.bar.setAttribute("scrollGrabbed", "");
        this.track.setAttribute("scrollGrabbed", "");
        document.body.classList.add($eo9gQ.scrollVirtualSelect);
        this.mouseDragListener = this.component.putListener(window, "mousemove", (e)=>{
            this.onDrag(e);
        });
        this.mouseStopDragListener = this.component.putListener(window, "mouseup", (e)=>{
            this.onStopDrag(e);
        });
    }
    onTrackClick(e) {
        if (this.isDragging) return;
        if (this.component.element instanceof HTMLElement) {
            let perc = (e.clientY - this.trackRect.top) / (this.trackRect.height - this.trackRect['topPad'] - this.trackRect['bottomPad']);
            let scrollHeight = this.component.element.scrollHeight;
            let ownHeight = this.component.element.clientHeight;
            let newScrollTop = perc * (scrollHeight - ownHeight);
            this.component.element.style.scrollBehavior = 'smooth';
            this.component.timeOut(()=>{
                if (this.component.element instanceof HTMLElement) this.component.element.style.scrollBehavior = 'unset';
            }, 500);
            this.component.element.scrollTop = newScrollTop;
        }
    }
    getTrackBounds() {
        if (this.track.element instanceof HTMLElement) {
            this.trackRect = this.track.element.getBoundingClientRect();
            let styles = window.getComputedStyle(this.track.element, undefined);
            this.trackRect['topPad'] = parseInt(styles.paddingTop, 10);
            this.trackRect['bottomPad'] = parseInt(styles.paddingBottom, 10);
        }
    }
    moveBar() {
        if (this.component.element instanceof HTMLElement && this.track.element instanceof HTMLElement) {
            let scrollHeight = this.component.element.scrollHeight;
            let clientHeight = this.component.element.clientHeight;
            this.scrollRatio = this.track.element.clientHeight / scrollHeight;
            (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                if (this.component.element instanceof HTMLElement) {
                    let height = clientHeight / scrollHeight * 100;
                    let top = this.component.element.scrollTop / scrollHeight * 100;
                    this.bar.setStyle(`height:${height.toFixed(1)}%;top:${top.toFixed(1)}%;`);
                }
            });
        }
    }
    place() {
        this.track.setStyle(`position:fixed;transition:0s;right:${this.component.getOffsets().right + 2}px;height:${this.component.getHeight() - 8}px;top: ${this.component.getOffsets().top + 4}px;`);
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>this.track.setStyle(`transition: 0.1s`));
    }
    constructor(component, autoPlace){
        this.track = undefined;
        this.bar = undefined;
        this.dragScrollTop = 0;
        this.timeOutResize = 0;
        this.isDragging = false;
        this.trackRect = undefined;
        this.scrollRatio = 1;
        this.component = component;
        this.now = performance.now();
        this.autoPlace = autoPlace;
        this.build();
        if (!(0, $ftoGP.isMobile)()) this.binding();
    }
}

});
parcelRegister("eo9gQ", function(module, exports) {

$parcel$export(module.exports, "scrollVirtual", function () { return $a79a7f8f4403545a$export$c05bc4a5d5bdd591; }, function (v) { return $a79a7f8f4403545a$export$c05bc4a5d5bdd591 = v; });
$parcel$export(module.exports, "scrollVirtualTrack", function () { return $a79a7f8f4403545a$export$f006a8e874a0c0c2; }, function (v) { return $a79a7f8f4403545a$export$f006a8e874a0c0c2 = v; });
$parcel$export(module.exports, "scrollVirtualBar", function () { return $a79a7f8f4403545a$export$f95b7f37ecd6af3f; }, function (v) { return $a79a7f8f4403545a$export$f95b7f37ecd6af3f = v; });
$parcel$export(module.exports, "scrollVirtualSelect", function () { return $a79a7f8f4403545a$export$baea668a85f138e4; }, function (v) { return $a79a7f8f4403545a$export$baea668a85f138e4 = v; });
$parcel$export(module.exports, "scrollVirtualGrabbed", function () { return $a79a7f8f4403545a$export$7fde6f40368c3f64; }, function (v) { return $a79a7f8f4403545a$export$7fde6f40368c3f64 = v; });
var $a79a7f8f4403545a$export$c05bc4a5d5bdd591;
var $a79a7f8f4403545a$export$f006a8e874a0c0c2;
var $a79a7f8f4403545a$export$f95b7f37ecd6af3f;
var $a79a7f8f4403545a$export$baea668a85f138e4;
var $a79a7f8f4403545a$export$7fde6f40368c3f64;
$a79a7f8f4403545a$export$c05bc4a5d5bdd591 = "LrIP1";
$a79a7f8f4403545a$export$f006a8e874a0c0c2 = "yYNu3";
$a79a7f8f4403545a$export$f95b7f37ecd6af3f = "vC-Op";
$a79a7f8f4403545a$export$baea668a85f138e4 = "FN46B";
$a79a7f8f4403545a$export$7fde6f40368c3f64 = "zHL2l";

});

parcelRegister("6L35I", function(module, exports) {

$parcel$export(module.exports, "isTabletNative", function () { return $611c2f7f9b61ec79$export$3d3a4f4557ce39f9; });
/**
 * Vérifie si la largeur est inférieur à 450px
 */ 
var $9qDN7 = parcelRequire("9qDN7");
function $611c2f7f9b61ec79$export$3d3a4f4557ce39f9() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= 970 && (0, $9qDN7.IS_NATIVE);
}

});
parcelRegister("9qDN7", function(module, exports) {

$parcel$export(module.exports, "IS_NATIVE", function () { return $ef1c483c2f5410ec$export$b8b535c3ef3eecc4; });
$parcel$export(module.exports, "IMG_EMPTY", function () { return $ef1c483c2f5410ec$export$d43b17a7dbe4169b; });
let $ef1c483c2f5410ec$export$b8b535c3ef3eecc4 = false;
const $ef1c483c2f5410ec$export$e5ab80781acdc6e8 = 16732543783000;
const $ef1c483c2f5410ec$export$fa5433ab32a7595b = 20;
const $ef1c483c2f5410ec$export$d43b17a7dbe4169b = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

});


parcelRegister("ftoGP", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $043eca4f0f7ae0d4$export$d0a8044dce8ff2fc; });
function $043eca4f0f7ae0d4$export$d0a8044dce8ff2fc() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 600;
}

});


parcelRegister("i3Hbv", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $d25a015a8f8adc65$export$d1203567a167490e; });
$parcel$export(module.exports, "unobserve", function () { return $d25a015a8f8adc65$export$23a2283368c55ea2; });
$parcel$export(module.exports, "observable", function () { return $d25a015a8f8adc65$export$5ab46cbf6120b33a; });
var $d25a015a8f8adc65$var$connectionStore = new WeakMap();
var $d25a015a8f8adc65$var$ITERATION_KEY = Symbol('iteration key');
function $d25a015a8f8adc65$var$storeObservable(obj) {
    // this will be used to save (obj.key -> reaction) connections later
    $d25a015a8f8adc65$var$connectionStore.set(obj, new Map());
}
function $d25a015a8f8adc65$var$registerReactionForOperation(reaction, ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    if (type === 'iterate') key = $d25a015a8f8adc65$var$ITERATION_KEY;
    var reactionsForObj = $d25a015a8f8adc65$var$connectionStore.get(target);
    var reactionsForKey = reactionsForObj.get(key);
    if (!reactionsForKey) {
        reactionsForKey = new Set();
        reactionsForObj.set(key, reactionsForKey);
    }
    // save the fact that the key is used by the reaction during its current run
    if (!reactionsForKey.has(reaction)) {
        reactionsForKey.add(reaction);
        reaction.cleaners.push(reactionsForKey);
    }
}
function $d25a015a8f8adc65$var$getReactionsForOperation(ref) {
    var target = ref.target;
    var key = ref.key;
    var type = ref.type;
    var reactionsForTarget = $d25a015a8f8adc65$var$connectionStore.get(target);
    var reactionsForKey = new Set();
    if (type === 'clear') reactionsForTarget.forEach(function(_, key) {
        $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    });
    else $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key);
    if (type === 'add' || type === 'delete' || type === 'clear') {
        var iterationKey = Array.isArray(target) ? 'length' : $d25a015a8f8adc65$var$ITERATION_KEY;
        $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
    }
    return reactionsForKey;
}
function $d25a015a8f8adc65$var$addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
    var reactions = reactionsForTarget.get(key);
    reactions && reactions.forEach(reactionsForKey.add, reactionsForKey);
}
function $d25a015a8f8adc65$var$releaseReaction(reaction) {
    if (reaction.cleaners) reaction.cleaners.forEach($d25a015a8f8adc65$var$releaseReactionKeyConnection, reaction);
    reaction.cleaners = [];
}
function $d25a015a8f8adc65$var$releaseReactionKeyConnection(reactionsForKey) {
    reactionsForKey.delete(this);
}
// reactions can call each other and form a call stack
var $d25a015a8f8adc65$var$reactionStack = [];
var $d25a015a8f8adc65$var$isDebugging = false;
function $d25a015a8f8adc65$var$runAsReaction(reaction, fn, context, args) {
    // do not build reactive relations, if the reaction is unobserved
    if (reaction.unobserved) return Reflect.apply(fn, context, args);
    // only run the reaction if it is not already in the reaction stack
    // TODO: improve this to allow explicitly recursive reactions
    if ($d25a015a8f8adc65$var$reactionStack.indexOf(reaction) === -1) {
        // release the (obj -> key -> reactions) connections
        // and reset the cleaner connections
        $d25a015a8f8adc65$var$releaseReaction(reaction);
        try {
            // set the reaction as the currently running one
            // this is required so that we can create (observable.prop -> reaction) pairs in the get trap
            $d25a015a8f8adc65$var$reactionStack.push(reaction);
            return Reflect.apply(fn, context, args);
        } finally{
            // always remove the currently running flag from the reaction when it stops execution
            $d25a015a8f8adc65$var$reactionStack.pop();
        }
    }
}
// register the currently running reaction to be queued again on obj.key mutations
function $d25a015a8f8adc65$var$registerRunningReactionForOperation(operation) {
    // get the current reaction from the top of the stack
    var runningReaction = $d25a015a8f8adc65$var$reactionStack[$d25a015a8f8adc65$var$reactionStack.length - 1];
    if (runningReaction) {
        $d25a015a8f8adc65$var$debugOperation(runningReaction, operation);
        $d25a015a8f8adc65$var$registerReactionForOperation(runningReaction, operation);
    }
}
function $d25a015a8f8adc65$var$queueReactionsForOperation(operation) {
    // iterate and queue every reaction, which is triggered by obj.key mutation
    $d25a015a8f8adc65$var$getReactionsForOperation(operation).forEach($d25a015a8f8adc65$var$queueReaction, operation);
}
function $d25a015a8f8adc65$var$queueReaction(reaction) {
    $d25a015a8f8adc65$var$debugOperation(reaction, this);
    // queue the reaction for later execution or run it immediately
    if (typeof reaction.scheduler === 'function') reaction.scheduler(reaction);
    else if (typeof reaction.scheduler === 'object') reaction.scheduler.add(reaction);
    else reaction();
}
function $d25a015a8f8adc65$var$debugOperation(reaction, operation) {
    if (reaction.debugger && !$d25a015a8f8adc65$var$isDebugging) try {
        $d25a015a8f8adc65$var$isDebugging = true;
        reaction.debugger(operation);
    } finally{
        $d25a015a8f8adc65$var$isDebugging = false;
    }
}
function $d25a015a8f8adc65$var$hasRunningReaction() {
    return $d25a015a8f8adc65$var$reactionStack.length > 0;
}
var $d25a015a8f8adc65$var$IS_REACTION = Symbol('is reaction');
function $d25a015a8f8adc65$export$d1203567a167490e(fn, options) {
    if (options === void 0) options = {};
    // wrap the passed function in a reaction, if it is not already one
    var reaction = fn[$d25a015a8f8adc65$var$IS_REACTION] ? fn : function reaction() {
        return $d25a015a8f8adc65$var$runAsReaction(reaction, fn, this, arguments);
    };
    // save the scheduler and debugger on the reaction
    reaction.scheduler = options.scheduler;
    reaction.debugger = options.debugger;
    // save the fact that this is a reaction
    reaction[$d25a015a8f8adc65$var$IS_REACTION] = true;
    // run the reaction once if it is not a lazy one
    if (!options.lazy) reaction();
    return reaction;
}
function $d25a015a8f8adc65$export$23a2283368c55ea2(reaction) {
    // do nothing, if the reaction is already unobserved
    if (!reaction.unobserved) {
        // indicate that the reaction should not be triggered any more
        reaction.unobserved = true;
        // release (obj -> key -> reaction) connections
        $d25a015a8f8adc65$var$releaseReaction(reaction);
    }
    // unschedule the reaction, if it is scheduled
    if (typeof reaction.scheduler === 'object') reaction.scheduler.delete(reaction);
}
var $d25a015a8f8adc65$var$proxyToRaw = new WeakMap();
var $d25a015a8f8adc65$var$rawToProxy = new WeakMap();
var $d25a015a8f8adc65$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d25a015a8f8adc65$var$findObservable(obj) {
    var observableObj = $d25a015a8f8adc65$var$rawToProxy.get(obj);
    if ($d25a015a8f8adc65$var$hasRunningReaction() && typeof obj === 'object' && obj !== null) {
        if (observableObj) return observableObj;
        return $d25a015a8f8adc65$export$5ab46cbf6120b33a(obj);
    }
    return observableObj || obj;
}
function $d25a015a8f8adc65$var$patchIterator(iterator, isEntries) {
    var originalNext = iterator.next;
    iterator.next = function() {
        var ref = originalNext.call(iterator);
        var done = ref.done;
        var value = ref.value;
        if (!done) {
            if (isEntries) value[1] = $d25a015a8f8adc65$var$findObservable(value[1]);
            else value = $d25a015a8f8adc65$var$findObservable(value);
        }
        return {
            done: done,
            value: value
        };
    };
    return iterator;
}
var $d25a015a8f8adc65$var$instrumentations = {
    has: function has(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'has'
        });
        return proto.has.apply(target, arguments);
    },
    get: function get(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            key: key,
            type: 'get'
        });
        return $d25a015a8f8adc65$var$findObservable(proto.get.apply(target, arguments));
    },
    add: function add(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.add.apply(target, arguments);
        if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: key,
            type: 'add'
        });
        return result;
    },
    set: function set(key, value) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get.call(target, key);
        // forward the operation before queueing reactions
        var result = proto.set.apply(target, arguments);
        if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            type: 'add'
        });
        else if (value !== oldValue) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            value: value,
            oldValue: oldValue,
            type: 'set'
        });
        return result;
    },
    delete: function delete$1(key) {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadKey = proto.has.call(target, key);
        var oldValue = proto.get ? proto.get.call(target, key) : undefined;
        // forward the operation before queueing reactions
        var result = proto.delete.apply(target, arguments);
        if (hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            key: key,
            oldValue: oldValue,
            type: 'delete'
        });
        return result;
    },
    clear: function clear() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        var hadItems = target.size !== 0;
        var oldTarget = target instanceof Map ? new Map(target) : new Set(target);
        // forward the operation before queueing reactions
        var result = proto.clear.apply(target, arguments);
        if (hadItems) $d25a015a8f8adc65$var$queueReactionsForOperation({
            target: target,
            oldTarget: oldTarget,
            type: 'clear'
        });
        return result;
    },
    forEach: function forEach(cb) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        // swap out the raw values with their observable pairs
        // before passing them to the callback
        var wrappedCb = function(value) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            return cb.apply(void 0, [
                $d25a015a8f8adc65$var$findObservable(value)
            ].concat(rest));
        };
        var ref;
        return (ref = proto.forEach).call.apply(ref, [
            target,
            wrappedCb
        ].concat(args));
    },
    keys: function keys() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return proto.keys.apply(target, arguments);
    },
    values: function values() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.values.apply(target, arguments);
        return $d25a015a8f8adc65$var$patchIterator(iterator, false);
    },
    entries: function entries() {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        var iterator = proto.entries.apply(target, arguments);
        return $d25a015a8f8adc65$var$patchIterator(iterator, true);
    },
    get size () {
        var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
        var proto = Reflect.getPrototypeOf(this);
        $d25a015a8f8adc65$var$registerRunningReactionForOperation({
            target: target,
            type: 'iterate'
        });
        return Reflect.get(proto, 'size', target);
    }
};
$d25a015a8f8adc65$var$instrumentations[Symbol.iterator] = function() {
    var target = $d25a015a8f8adc65$var$proxyToRaw.get(this);
    var proto = Reflect.getPrototypeOf(this);
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    var iterator = proto[Symbol.iterator].apply(target, arguments);
    return $d25a015a8f8adc65$var$patchIterator(iterator, target instanceof Map);
};
var $d25a015a8f8adc65$var$collectionHandlers = {
    get: function get(target, key, receiver) {
        // instrument methods and property accessors to be reactive
        target = $d25a015a8f8adc65$var$hasOwnProperty.call($d25a015a8f8adc65$var$instrumentations, key) ? $d25a015a8f8adc65$var$instrumentations : target;
        return Reflect.get(target, key, receiver);
    }
};
// eslint-disable-next-line
var $d25a015a8f8adc65$var$globalObj = typeof window === 'object' ? window : Function('return this')();
// built-in object can not be wrapped by Proxies
// their methods expect the object instance as the 'this' instead of the Proxy wrapper
// complex objects are wrapped with a Proxy of instrumented methods
// which switch the proxy to the raw object and to add reactive wiring
var $d25a015a8f8adc65$var$handlers = new Map([
    [
        Map,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        Set,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        WeakMap,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        WeakSet,
        $d25a015a8f8adc65$var$collectionHandlers
    ],
    [
        Object,
        false
    ],
    [
        Array,
        false
    ],
    [
        Int8Array,
        false
    ],
    [
        Uint8Array,
        false
    ],
    [
        Uint8ClampedArray,
        false
    ],
    [
        Int16Array,
        false
    ],
    [
        Uint16Array,
        false
    ],
    [
        Int32Array,
        false
    ],
    [
        Uint32Array,
        false
    ],
    [
        Float32Array,
        false
    ],
    [
        Float64Array,
        false
    ]
]);
function $d25a015a8f8adc65$var$shouldInstrument(ref) {
    var constructor = ref.constructor;
    var isBuiltIn = typeof constructor === 'function' && constructor.name in $d25a015a8f8adc65$var$globalObj && $d25a015a8f8adc65$var$globalObj[constructor.name] === constructor;
    return !isBuiltIn || $d25a015a8f8adc65$var$handlers.has(constructor);
}
function $d25a015a8f8adc65$var$getHandlers(obj) {
    return $d25a015a8f8adc65$var$handlers.get(obj.constructor);
}
var $d25a015a8f8adc65$var$hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $d25a015a8f8adc65$var$wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter(function(value) {
    return typeof value === 'symbol';
}));
// intercept get operations on observables to know which reaction uses their properties
function $d25a015a8f8adc65$var$get(target, key, receiver) {
    var result = Reflect.get(target, key, receiver);
    // do not register (observable.prop -> reaction) pairs for well known symbols
    // these symbols are frequently retrieved in low level JavaScript under the hood
    if (typeof key === 'symbol' && $d25a015a8f8adc65$var$wellKnownSymbols.has(key)) return result;
    // register and save (observable.prop -> runningReaction)
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        receiver: receiver,
        type: 'get'
    });
    // if we are inside a reaction and observable.prop is an object wrap it in an observable too
    // this is needed to intercept property access on that object too (dynamic observable tree)
    var observableResult = $d25a015a8f8adc65$var$rawToProxy.get(result);
    if ($d25a015a8f8adc65$var$hasRunningReaction() && typeof result === 'object' && result !== null) {
        if (observableResult) return observableResult;
        // do not violate the none-configurable none-writable prop get handler invariant
        // fall back to none reactive mode in this case, instead of letting the Proxy throw a TypeError
        var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
        if (!descriptor || !(descriptor.writable === false && descriptor.configurable === false)) return $d25a015a8f8adc65$export$5ab46cbf6120b33a(result);
    }
    // otherwise return the observable wrapper if it is already created and cached or the raw object
    return observableResult || result;
}
function $d25a015a8f8adc65$var$has(target, key) {
    var result = Reflect.has(target, key);
    // register and save (observable.prop -> runningReaction)
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        key: key,
        type: 'has'
    });
    return result;
}
function $d25a015a8f8adc65$var$ownKeys(target) {
    $d25a015a8f8adc65$var$registerRunningReactionForOperation({
        target: target,
        type: 'iterate'
    });
    return Reflect.ownKeys(target);
}
// intercept set operations on observables to know when to trigger reactions
function $d25a015a8f8adc65$var$set(target, key, value, receiver) {
    // make sure to do not pollute the raw object with observables
    if (typeof value === 'object' && value !== null) value = $d25a015a8f8adc65$var$proxyToRaw.get(value) || value;
    // save if the object had a descriptor for this key
    var hadKey = $d25a015a8f8adc65$var$hasOwnProperty$1.call(target, key);
    // save if the value changed because of this set operation
    var oldValue = target[key];
    // execute the set operation before running any reaction
    var result = Reflect.set(target, key, value, receiver);
    // do not queue reactions if the target of the operation is not the raw receiver
    // (possible because of prototypal inheritance)
    if (target !== $d25a015a8f8adc65$var$proxyToRaw.get(receiver)) return result;
    // queue a reaction if it's a new property or its value changed
    if (!hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        receiver: receiver,
        type: 'add'
    });
    else if (value !== oldValue) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        value: value,
        oldValue: oldValue,
        receiver: receiver,
        type: 'set'
    });
    return result;
}
function $d25a015a8f8adc65$var$deleteProperty(target, key) {
    // save if the object had the key
    var hadKey = $d25a015a8f8adc65$var$hasOwnProperty$1.call(target, key);
    var oldValue = target[key];
    // execute the delete operation before running any reaction
    var result = Reflect.deleteProperty(target, key);
    // only queue reactions for delete operations which resulted in an actual change
    if (hadKey) $d25a015a8f8adc65$var$queueReactionsForOperation({
        target: target,
        key: key,
        oldValue: oldValue,
        type: 'delete'
    });
    return result;
}
var $d25a015a8f8adc65$var$baseHandlers = {
    get: $d25a015a8f8adc65$var$get,
    has: $d25a015a8f8adc65$var$has,
    ownKeys: $d25a015a8f8adc65$var$ownKeys,
    set: $d25a015a8f8adc65$var$set,
    deleteProperty: $d25a015a8f8adc65$var$deleteProperty
};
function $d25a015a8f8adc65$export$5ab46cbf6120b33a(obj) {
    if (obj === void 0) obj = {};
    // if it is already an observable or it should not be wrapped, return it
    if ($d25a015a8f8adc65$var$proxyToRaw.has(obj) || !$d25a015a8f8adc65$var$shouldInstrument(obj)) return obj;
    // if it already has a cached observable wrapper, return it
    // otherwise create a new observable
    return $d25a015a8f8adc65$var$rawToProxy.get(obj) || $d25a015a8f8adc65$var$createObservable(obj);
}
function $d25a015a8f8adc65$var$createObservable(obj) {
    // if it is a complex built-in object or a normal object, wrap it
    var handlers = $d25a015a8f8adc65$var$getHandlers(obj) || $d25a015a8f8adc65$var$baseHandlers;
    var observable = new Proxy(obj, handlers);
    // save these to switch between the raw object and the wrapped object with ease later
    $d25a015a8f8adc65$var$rawToProxy.set(obj, observable);
    $d25a015a8f8adc65$var$proxyToRaw.set(observable, obj);
    // init basic data structures to save and cleanup later (observable.prop -> reaction) connections
    $d25a015a8f8adc65$var$storeObservable(obj);
    return observable;
}
function $d25a015a8f8adc65$export$5cd057a6046189f9(obj) {
    return $d25a015a8f8adc65$var$proxyToRaw.has(obj);
}
function $d25a015a8f8adc65$export$1776c186c69df29e(obj) {
    return $d25a015a8f8adc65$var$proxyToRaw.get(obj) || obj;
}

});

parcelRegister("8YCm8", function(module, exports) {

$parcel$export(module.exports, "ComponentTooltip", function () { return $41609f9b1c465c64$export$5e82891434456073; });

var $fsnB5 = parcelRequire("fsnB5");

var $2aBLW = parcelRequire("2aBLW");

var $brfs4 = parcelRequire("brfs4");

var $gKcOU = parcelRequire("gKcOU");

var $nyKU9 = parcelRequire("nyKU9");
class $41609f9b1c465c64$export$5e82891434456073 {
    async place(replace) {
        switch(this.preference){
            case "left":
                this.placeLeft();
                break;
            case "leftTop":
                this.placeLeftTop();
                break;
            case "rightTop":
                this.placeRightTop();
                break;
            case "right":
                this.placeRight();
                break;
            case "bottom":
                this.placeBottom();
                break;
            default:
                this.placeTop();
                break;
        }
        let tooltipOffsets = (0, $gKcOU.elementOffsets)(this.tooltipComponent.element);
        if (this.isOutside(tooltipOffsets)) {
            let places = [
                "placeTop",
                "placeRight",
                "placeBottom",
                "placeLeft"
            ];
            if (this.preference == "leftTop") places = [
                "placeTop",
                "placeLeft",
                "placeBottom",
                "placeRight"
            ];
            for (let placeFunc of places){
                await this[placeFunc]();
                tooltipOffsets = (0, $gKcOU.elementOffsets)(this.tooltipComponent.element);
                if (!this.isOutside(tooltipOffsets)) break;
            }
        }
        if (!this.noAnimation) {
            if (!replace) {
                this.tooltipComponent.setStyle(`opacity:0;transform:scale(0.9);`);
                this.tooltipComponent.translate({
                    delay: 40,
                    opacity: 1,
                    scale: 1
                });
            } else this.tooltipComponent.setStyle(`transition-duration: 0s;`);
        } else this.tooltipComponent.setStyle(`transition-duration: 0s;opacity:1;transform:scale(1);`);
    }
    replace() {
        let timeNow = performance.now();
        if (timeNow - 1 > this.time) {
            this.time = timeNow;
            this.place(true);
        }
    }
    async placeTop() {
        return this.tooltipComponent.promise((resolve)=>{
            let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
            let left = offsets.left + (this.component.getWidth() / 2 - this.tooltipComponent.getWidth() / 2);
            let top = offsets.top - this.tooltipComponent.getHeight() - 8;
            this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
            (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                let top = offsets.top - this.tooltipComponent.getHeight() - 8;
                this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
                resolve(undefined);
            });
            this.placeArrowTop();
        });
    }
    placeBottom() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let left = offsets.left + (this.component.getWidth() / 2 - this.tooltipComponent.getWidth() / 2);
        let top = offsets.top + this.component.getHeight() + 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowBottom();
    }
    placeLeftTop() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let left = offsets.left;
        let top = offsets.top - this.tooltipComponent.getHeight() - 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowLeftTop();
    }
    placeRightTop() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let left = offsets.left + this.component.getWidth() - this.tooltipComponent.getWidth();
        let top = offsets.top - this.tooltipComponent.getHeight() - 8;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowRightTop();
    }
    placeLeft() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let left = offsets.left - this.tooltipComponent.getWidth() - 8;
        let top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowLeft();
    }
    placeRight() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let left = offsets.left + this.component.getWidth() + 8;
        let top = offsets.top + this.component.getHeight() / 2 - this.tooltipComponent.getHeight() / 2;
        this.tooltipComponent.setStyle(`left:${left}px;top:${top}px;`);
        this.placeArrowRight();
    }
    placeArrowLeft() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let tooltipOffsets = (0, $gKcOU.elementOffsets)(this.tooltipComponent.element);
        this.tooltipComponent.el($brfs4.arrow).setStyle(`right:-5px;left:unset;bottom:unset;top:${offsets.top - tooltipOffsets.top + (this.component.getHeight() / 2 - 5)}px`);
    }
    placeArrowLeftTop() {
        let left = this.tooltipComponent.getWidth() / 2 - 5;
        this.tooltipComponent.el($brfs4.arrow).setStyle(`bottom:-5px;right:unset;top:unset;left:${left > 15 ? 15 : left}px`);
    }
    placeArrowRightTop() {
        let left = this.tooltipComponent.getWidth() / 2 - 5;
        this.tooltipComponent.el($brfs4.arrow).setStyle(`bottom:-5px;right:unset;top:unset;right:${left > 15 ? 15 : left}px`);
    }
    placeArrowRight() {
        this.placeArrowLeft();
        this.tooltipComponent.el($brfs4.arrow).setStyle(`left:-5px;right:unset;`);
    }
    placeArrowTop() {
        let offsets = (0, $gKcOU.elementOffsets)(this.component.element);
        let tooltipOffsets = (0, $gKcOU.elementOffsets)(this.tooltipComponent.element);
        this.tooltipComponent.el($brfs4.arrow).setStyle(`bottom:-5px;right:unset;top:unset;left:${offsets.left - tooltipOffsets.left + (this.component.getWidth() / 2 - 5)}px`);
    }
    placeArrowBottom() {
        this.placeArrowTop();
        this.tooltipComponent.el($brfs4.arrow).setStyle(`bottom:unset;top:-5px`);
    }
    isOutside(offsets) {
        return offsets.top < -1 || offsets.left < -1 || offsets.right < -1 || offsets.bottom < -1;
    }
    async dispose() {
        if (!this.noAnimation) await this.tooltipComponent.translate({
            delay: 40,
            opacity: 0,
            scale: 0.9
        });
        if (!this.tooltipComponent.isNull()) this.tooltipComponent.remove();
    }
    constructor(component, template, preference, noAnimation){
        this.component = component;
        this.hoverDelay = 0;
        this.leaveDelay = 0;
        this.time = performance.now();
        this.noAnimation = noAnimation;
        this.preference = preference;
        this.tooltipComponent = new (0, $fsnB5.Component)();
        //language=HTML
        this.tooltipComponent.template = `
            <div class="${$brfs4.tooltip}">
                <div class="${$brfs4.content}">
                    ${typeof template == "string" ? template : this.tooltipComponent.draw(template())}
                </div>
                <div class="${$brfs4.arrow}"></div>
            </div>
        `;
        (0, $2aBLW.SedestralInterface).main.render(this.tooltipComponent);
        (0, $2aBLW.SedestralInterface).main.removeChildren(this.tooltipComponent);
        this.component.onLeave(async ()=>this.dispose());
        this.tooltipComponent.putListener(window, "resize", ()=>this.replace());
        this.tooltipComponent.putListener(window, "scroll", ()=>this.replace(), true);
        this.place();
    }
}

});
parcelRegister("brfs4", function(module, exports) {

$parcel$export(module.exports, "tooltip", function () { return $853e33b912eddf04$export$4e6f96734dfe12f4; }, function (v) { return $853e33b912eddf04$export$4e6f96734dfe12f4 = v; });
$parcel$export(module.exports, "arrow", function () { return $853e33b912eddf04$export$f2120bbfa5450bd2; }, function (v) { return $853e33b912eddf04$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "content", function () { return $853e33b912eddf04$export$a7db06668cad9adb; }, function (v) { return $853e33b912eddf04$export$a7db06668cad9adb = v; });
var $853e33b912eddf04$export$4e6f96734dfe12f4;
var $853e33b912eddf04$export$f2120bbfa5450bd2;
var $853e33b912eddf04$export$a7db06668cad9adb;
$853e33b912eddf04$export$4e6f96734dfe12f4 = "k4BLk";
$853e33b912eddf04$export$f2120bbfa5450bd2 = "R0ByI";
$853e33b912eddf04$export$a7db06668cad9adb = "B1zGi";

});

parcelRegister("gKcOU", function(module, exports) {

$parcel$export(module.exports, "elementOffsets", function () { return $9378e1839030f1a0$export$ee0dccb429ca5135; });
function $9378e1839030f1a0$export$ee0dccb429ca5135(element) {
    if (element instanceof HTMLElement) {
        let offsets = element.getBoundingClientRect();
        return {
            top: offsets.top,
            left: offsets.left,
            right: window.innerWidth - (offsets.left + element.clientWidth),
            bottom: window.innerHeight - (offsets.top + element.clientHeight)
        };
    }
}

});


parcelRegister("bLZiK", function(module, exports) {

$parcel$export(module.exports, "ComponentSwapBar", function () { return $c06430ae8d53c25e$export$db3c68524c9422f3; });

var $8rexF = parcelRequire("8rexF");

var $51nMl = parcelRequire("51nMl");
class $c06430ae8d53c25e$export$db3c68524c9422f3 {
    init() {
        this.component.addClass($8rexF.swap);
        //language=HTML
        let selector = this.component.prepend(`
            <div swapBar class="${$8rexF.swapBar}">
                <div class="${$8rexF.bar}"></div>
            </div>
        `);
        let swiper = (0, $51nMl.onSwipe)(selector, this.component);
        swiper.onDown = ()=>this.onDispose();
    }
    constructor(component, onDispose){
        this.component = component;
        this.onDispose = onDispose;
        this.init();
    }
}

});
parcelRegister("8rexF", function(module, exports) {

$parcel$export(module.exports, "swapBar", function () { return $624c201d22420420$export$e77117ea01f7e7b4; }, function (v) { return $624c201d22420420$export$e77117ea01f7e7b4 = v; });
$parcel$export(module.exports, "bar", function () { return $624c201d22420420$export$d927737047eb3867; }, function (v) { return $624c201d22420420$export$d927737047eb3867 = v; });
$parcel$export(module.exports, "swap", function () { return $624c201d22420420$export$b0e76d9850c64156; }, function (v) { return $624c201d22420420$export$b0e76d9850c64156 = v; });
var $624c201d22420420$export$e77117ea01f7e7b4;
var $624c201d22420420$export$d927737047eb3867;
var $624c201d22420420$export$b0e76d9850c64156;
$624c201d22420420$export$e77117ea01f7e7b4 = "MHPN0";
$624c201d22420420$export$d927737047eb3867 = "SOfAh";
$624c201d22420420$export$b0e76d9850c64156 = "JlCaV";

});

parcelRegister("51nMl", function(module, exports) {

$parcel$export(module.exports, "onSwipe", function () { return $42449d22b127a918$export$84b1cb3e0372354b; });
/**
 * Swippable
 */ 
var $fIVYh = parcelRequire("fIVYh");
function $42449d22b127a918$export$84b1cb3e0372354b(selector, component) {
    return new (0, $fIVYh.Swiper)(selector, component ? component : selector);
}

});
parcelRegister("fIVYh", function(module, exports) {

$parcel$export(module.exports, "Swiper", function () { return $35124bc09774d782$export$6b3850921bc5a414; });

var $4c50c = parcelRequire("4c50c");
class $35124bc09774d782$export$6b3850921bc5a414 {
    /**
     * override
     */ onLeft() {}
    onRight() {}
    onUp() {}
    onDown() {}
    constructor(selector, component){
        this.yCurrent = 0;
        this.selector = selector;
        component.addListener('touchend', (evt)=>{
            let percent = component.getHeight() / 4;
            if (this.yCurrent > percent) this.onDown();
            else component.setStyle(`bottom:0px !important;transition:0.4s;`);
            this.yCurrent = 0;
        });
        (0, $4c50c.onDrag)(selector, (left, top)=>{
            if (top > 0) {
                this.yCurrent = top;
                component.setStyle(`bottom:calc(${-top}px - env(safe-area-inset-top)) !important;transition:0s;`);
            }
        });
    }
}

});
parcelRegister("4c50c", function(module, exports) {

$parcel$export(module.exports, "onDrag", function () { return $9507c58dcbb98bf9$export$11a07b18d6f8f6d2; });

var $2aBLW = parcelRequire("2aBLW");
function $9507c58dcbb98bf9$export$11a07b18d6f8f6d2(component, func, onFinish, selector) {
    let initX, initY, mousePressX, mousePressY;
    let down = false;
    let tDown = false;
    let moveListener = undefined;
    let upListener = undefined;
    let tMoveListener = undefined;
    let tUpListener = undefined;
    let componentListener = selector ? selector : component;
    let touchDown = (e)=>{
        (0, $2aBLW.SedestralInterface).body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = e.touches[0].pageX;
            mousePressY = e.touches[0].pageY;
            tDown = true;
            tMoveListener = componentListener.putListener(window, 'touchmove', move);
            tUpListener = componentListener.putListener(window, 'touchend', touchUp);
        }
    };
    let touchUp = (e)=>{
        (0, $2aBLW.SedestralInterface).body.setStyle(`user-select:unset;`);
        if (tDown) {
            tDown = false;
            componentListener.deleteListener(tMoveListener);
            componentListener.deleteListener(tUpListener);
            if (onFinish) onFinish();
        }
    };
    let mouseDown = (event)=>{
        (0, $2aBLW.SedestralInterface).body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = event.pageX;
            mousePressY = event.pageY;
            down = true;
            moveListener = componentListener.putListener(window, 'mousemove', move);
            upListener = componentListener.putListener(window, 'mouseup', mouseUp);
        }
    };
    let mouseUp = ()=>{
        (0, $2aBLW.SedestralInterface).body.setStyle(`user-select:unset;`);
        if (down) {
            down = false;
            componentListener.deleteListener(moveListener);
            componentListener.deleteListener(upListener);
            if (onFinish) onFinish();
        }
    };
    componentListener.addListener('touchstart', touchDown);
    componentListener.addListener('mousedown', mouseDown);
    let move = (event)=>{
        if (tDown) {
            let left = initX + event.touches[0].pageX - mousePressX;
            let top = initY + event.touches[0].pageY - mousePressY;
            func(left, top);
        }
        if (down) {
            let left = initX + event.pageX - mousePressX;
            let top = initY + event.pageY - mousePressY;
            func(left, top);
        }
    };
}

});




parcelRegister("6pO1Y", function(module, exports) {

$parcel$export(module.exports, "SedestralDebugger", function () { return $9db03a29fe58b39a$export$455e2f1284cdadf9; });

var $2aBLW = parcelRequire("2aBLW");

var $271MM = parcelRequire("271MM");

class $9db03a29fe58b39a$export$455e2f1284cdadf9 {
    static async init() {
        if ((0, $271MM.config).rumEnabled) try {
            this.rum = new (await (parcelRequire("6IrtT"))).SedestralRum();
        } catch (e) {
            console.error(e);
        }
        window.onerror = (error, url, line, column, e)=>{
            /*
            console.log(error);
            console.log(url);
            console.log(line);
            console.log(column);

             */ this.addError("UNDEFINED", e);
        };
        window.onabort = ()=>{
            console.log("abort");
        };
    }
    static addError(title, error) {
        if (error) {
            var _this_rum;
            let now = performance.now();
            let listeners = this.listenersLogs.filter((value)=>value.time > now - 100);
            let trace = listeners.map((value)=>value.log).join("\n=> ");
            console.log('%c' + title, 'color: white;font-size:14px;background:red;padding:3px;');
            if (listeners.length > 0) console.log("=> " + trace);
            console.error(error);
            (_this_rum = this.rum) === null || _this_rum === void 0 ? void 0 : _this_rum.error(error, trace);
        }
    }
    static eventTarget(component, name) {
        let child = (0, $2aBLW.SedestralInterface).components.filter((value)=>value.childrens.find((value)=>value == component) != undefined)[0];
        this.listenersLogs.push({
            log: "[[" + name + " - " + (child == undefined ? "" : child.constructor.name) + " - " + component.constructor.name + " - " + component.element['className'] + "]]",
            time: performance.now()
        });
    }
}
$9db03a29fe58b39a$export$455e2f1284cdadf9.listenersLogs = [];

});

parcelRegister("9UiNT", function(module, exports) {

$parcel$export(module.exports, "elementChildrens", function () { return $93a8301a4ad4a194$export$7ee75abb6f48dde2; });
/**
 * retourne tous les enfants d'un élément ainsi que lui même
 */ function $93a8301a4ad4a194$export$7ee75abb6f48dde2(element) {
    let elements = [];
    let childs = element.getElementsByTagName("*");
    for (let child of childs)elements.push(child);
    elements.push(element);
    return elements;
}

});

parcelRegister("3SbXF", function(module, exports) {

$parcel$export(module.exports, "elementNotChildren", function () { return $78c1d2a79cc2dfe4$export$81078fe376cc4110; });
/**
 * Vérifie si un élément n'est pas le fils
 */ function $78c1d2a79cc2dfe4$export$81078fe376cc4110(parent, element) {
    let childrens = Array.from(parent.getElementsByTagName("*"));
    if (element != parent && childrens.indexOf(element) == -1) return true;
}

});

parcelRegister("42a2f", function(module, exports) {

$parcel$export(module.exports, "elementHasClass", function () { return $23bc3fc71870d9aa$export$2122b72d0e83e4af; });
/**
 * Vérifie si un élément a une class
 */ function $23bc3fc71870d9aa$export$2122b72d0e83e4af(classes, name) {
    if (typeof classes == "undefined" || classes == "") return false;
    return !!classes.match(new RegExp('(\\s|^)' + name + '(\\s|$)'));
}

});

parcelRegister("55dRq", function(module, exports) {

$parcel$export(module.exports, "elementParents", function () { return $26615867ae45edef$export$aedc7b608ca8e855; });
/**
 * Retourne la liste des parents des éléments
 */ function $26615867ae45edef$export$aedc7b608ca8e855(element) {
    let nodes = [];
    nodes.push(element);
    while(element.parentNode){
        nodes.unshift(element.parentNode);
        element = element.parentNode;
    }
    return nodes;
}

});

parcelRegister("cyFTW", function(module, exports) {

$parcel$export(module.exports, "filterXSS", function () { return $28ada7b469423a3e$export$95c1dcf5e40cf598; });

var $2im9I = parcelRequire("2im9I");
function $28ada7b469423a3e$export$95c1dcf5e40cf598(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2im9I))).sanitize(string, {
        USE_PROFILES: {
            html: true
        }
    });
}

});
parcelRegister("2im9I", function(module, exports) {
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.4';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("itwAE", function(module, exports) {

$parcel$export(module.exports, "randomString", function () { return $8aed3f27a5f3e1a8$export$7fa8378418b4411e; });
/**
 * genere une chaine de caractère aléatoire
 */ function $8aed3f27a5f3e1a8$export$7fa8378418b4411e(length, numbers) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    if (numbers) characters += "0123456789";
    let charactersLength = characters.length;
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
    return result;
}

});

parcelRegister("4HMUz", function(module, exports) {

$parcel$export(module.exports, "randomUUID", function () { return $3b4bcace4ac05c1f$export$f15387b9ab8915bf; });
/**
 * genere un identifiant UUID
 */ function $3b4bcace4ac05c1f$export$f15387b9ab8915bf() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});



parcelRegister("g6Ma5", function(module, exports) {

$parcel$export(module.exports, "txtSimpleLang", function () { return $bfbb59df36776484$export$9499e98ac7c1c42; });
/**
 * retourne un code unique de langue "fr-Fr" vers "fr"
 */ function $bfbb59df36776484$export$9499e98ac7c1c42(code) {
    return code.includes("-") ? code.split("-")[0] : code;
}

});

parcelRegister("39ltS", function(module, exports) {

$parcel$export(module.exports, "generateVendor", function () { return $dd49f85866921cd7$export$866fc66270dcd090; });
/**
 * generer l'url vendor
 */ function $dd49f85866921cd7$export$866fc66270dcd090(domain) {
    return new URL("vendor/", domain).toString();
}

});

parcelRegister("bi5k0", function(module, exports) {

$parcel$export(module.exports, "ProductName", function () { return $1c4f8fbe22f89fbb$export$acdfad52bc8c6626; });

var $kfkzw = parcelRequire("kfkzw");
class $1c4f8fbe22f89fbb$export$acdfad52bc8c6626 {
    static toString(type) {
        switch(type){
            case (0, $kfkzw.ProductType).SEDESTRAL:
                return "sedestral";
            case (0, $kfkzw.ProductType).INBOX:
                return "inbox";
            case (0, $kfkzw.ProductType).PUBLISHER:
                return "publisher";
            case (0, $kfkzw.ProductType).STATISTICS:
                return "statistics";
            case (0, $kfkzw.ProductType).CONTACTS:
                return "contacts";
            case (0, $kfkzw.ProductType).CHANNELS:
                return "channels";
            case (0, $kfkzw.ProductType).LIVECHAT:
                return "livechat";
            case (0, $kfkzw.ProductType).PANEL:
                return "panel";
            case (0, $kfkzw.ProductType).GENERAL:
                return "general";
            case (0, $kfkzw.ProductType).CHAT_BOT:
                return "chatBot";
            case (0, $kfkzw.ProductType).MAILS:
                return "mails";
            case (0, $kfkzw.ProductType).SELL:
                return "sell";
            case (0, $kfkzw.ProductType).ENGAGEMENT:
                return "engagement";
            case (0, $kfkzw.ProductType).ADVERTISING:
                return "advertising";
            case (0, $kfkzw.ProductType).MAILLING:
                return "mailling";
            case (0, $kfkzw.ProductType).MEDIAS:
                return "medias";
            case (0, $kfkzw.ProductType).CALENDAR:
                return "calendar";
            case (0, $kfkzw.ProductType).DOCUMENTS:
                return "documents";
            case (0, $kfkzw.ProductType).PRODUCTS:
                return "products";
            case (0, $kfkzw.ProductType).ESTIMATE:
                return "estimate";
            case (0, $kfkzw.ProductType).CONTACTS_GREY:
                return "contactsGrey";
            case (0, $kfkzw.ProductType).INBOX_GREY:
                return "inboxGrey";
            case (0, $kfkzw.ProductType).PUBLISHER_GREY:
                return "publisherGrey";
            case (0, $kfkzw.ProductType).HELPCENTER:
                return "helpCenter";
            case (0, $kfkzw.ProductType).WEBSITE:
                return "website";
            case (0, $kfkzw.ProductType).CLIENT_SERVICE:
                return "clientService";
            case (0, $kfkzw.ProductType).BLOG:
                return "blog";
            case (0, $kfkzw.ProductType).MOBILE:
                return "mobile";
            case (0, $kfkzw.ProductType).COMMUNITY:
                return "community";
            case (0, $kfkzw.ProductType).ADMIN:
                return "admin";
        }
    }
}

});


parcelRegister("btxlx", function(module, exports) {

$parcel$export(module.exports, "IAccountTwoFactorMethod", function () { return $82d4a3b23976e37d$export$195d311003943aa6; });
var $82d4a3b23976e37d$export$195d311003943aa6 = /*#__PURE__*/ function(IAccountTwoFactorMethod) {
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["EMAIL"] = 1] = "EMAIL";
    IAccountTwoFactorMethod[IAccountTwoFactorMethod["TOTP"] = 2] = "TOTP";
    return IAccountTwoFactorMethod;
}({});

});

parcelRegister("i00Q1", function(module, exports) {

$parcel$export(module.exports, "NetworkSocket", function () { return $fda1665b58771d3f$export$af02ff68916c531; });

var $k56Hb = parcelRequire("k56Hb");

var $2eT6g = parcelRequire("2eT6g");

var $nyKU9 = parcelRequire("nyKU9");

var $68Z0d = parcelRequire("68Z0d");
class $fda1665b58771d3f$export$af02ff68916c531 {
    async start(options) {
        return (0, $nyKU9.SedestralMachine).promise(async (started)=>{
            let success = await this.startConnectionTry(options, 0);
            if (success) this.socket.on("disconnect", ()=>{
                if (!this.logout) this.onDisconnect();
            });
            if (success) this.events.forEach((value)=>this.on(value.event, value.func));
            started(success);
        });
    }
    async startConnection(options) {
        return (0, $nyKU9.SedestralMachine).promise((resolve)=>{
            try {
                this.logout = false;
                this.socket = new (0, $k56Hb.NetworkSocketConnection)(options, this.host);
                this.socket.on("connect", ()=>resolve(true));
                this.socket.on("error", ()=>resolve(false));
            } catch (e) {
                resolve(false);
            }
        });
    }
    async startConnectionTry(options, attempts) {
        return (0, $nyKU9.SedestralMachine).promise(async (resolve)=>{
            if (attempts < 3) {
                attempts++;
                let connected = await this.startConnection(options);
                if (connected) {
                    this.on((0, $2eT6g.WebSocketPanelEventName).CONNECTION_ERROR, async ()=>{
                        await (0, $nyKU9.SedestralMachine).sleep(1000);
                        resolve(this.startConnectionTry(options, attempts));
                    });
                    this.on((0, $2eT6g.WebSocketPanelEventName).CONNECTION_READY, (data)=>{
                        (0, $68Z0d.EntityService).activeEntity.active = data;
                        resolve(true);
                    });
                } else {
                    await (0, $nyKU9.SedestralMachine).sleep(1000);
                    resolve(this.startConnectionTry(options, attempts));
                }
            } else resolve(false);
        });
    }
    disconnect(logout) {
        this.socket.disconnect();
        this.socket = undefined;
        this.logout = logout;
    }
    emit(event, value) {
        this.socket.emit(event, value);
    }
    async emitSync(event, value) {
        return await this.socket.emitSync(event, value);
    }
    on(event, func) {
        if (!this.events.find((value)=>value.event == event)) this.events.push({
            event: event,
            func: func
        });
        if (this.socket) this.socket.on(event, func);
    }
    async join(data, route) {
        if (data != null) return await this.emitSync(route, data);
    }
    removeListener(event) {
        this.socket.removeListener(event);
    }
    /**
     * override
     */ onDisconnect() {}
    constructor(host){
        this.host = host;
        this.events = [];
    }
}

});
parcelRegister("k56Hb", function(module, exports) {

$parcel$export(module.exports, "NetworkSocketConnection", function () { return $15a872c8de3bdf0f$export$a82946cdc7ec341d; });

var $nyKU9 = parcelRequire("nyKU9");
class $15a872c8de3bdf0f$export$a82946cdc7ec341d {
    bind() {
        this.ws.onclose = (data)=>{
            this.disconnectEvents.forEach((value)=>value.func(data));
            clearInterval(this.pingInterval);
        };
        this.ws.onopen = (data)=>{
            clearInterval(this.pingInterval);
            this.pingInterval = setInterval(()=>{
                this.ws.send("2");
            }, 14000);
            this.connectEvents.forEach((value)=>value.func(data));
        };
        this.ws.onerror = (data)=>{
            this.errorEvents.forEach((value)=>value.func(data));
            clearInterval(this.pingInterval);
        };
        this.ws.onmessage = (message)=>{
            //Si on reçoit un ping, on retourne un pong
            if (message.data == "2") this.ws.send("3");
            if (message.data.startsWith("42")) {
                let decoded = JSON.parse(message.data.substring(2));
                let events = this.events.filter((value)=>value.id == decoded[0]);
                events.forEach((event)=>{
                    event.func(decoded[1]);
                });
            }
        };
    }
    /**
     * listen
     */ on(id, func) {
        let event = {
            id: id,
            func: func
        };
        switch(id){
            case "disconnect":
                this.disconnectEvents.push(event);
                break;
            case "error":
                this.errorEvents.push(event);
                break;
            case "connect":
                this.connectEvents.push(event);
                break;
            default:
                this.events.push(event);
                break;
        }
        return event;
    }
    /**
     * emit
     */ emit(event, value) {
        let array = [
            event,
            value
        ];
        let content = `42${JSON.stringify(array)}`;
        this.ws.send(content);
    }
    async emitSync(id, value) {
        this.emit(id, value);
        return (0, $nyKU9.SedestralMachine).promise(async (resolve)=>{
            let event = this.on(id, (data)=>{
                this.events.splice(this.events.indexOf(event), 1);
                resolve(data);
            });
        });
    }
    /**
     * logic
     */ close() {
        this.ws.close();
    }
    disconnect() {
        this.networkOnLogout = true;
        this.ws.close();
    }
    removeListener(event) {
        this.events = this.events.filter((value)=>value.id != event);
    }
    constructor(options, host){
        this.events = [];
        this.disconnectEvents = [];
        this.connectEvents = [];
        this.errorEvents = [];
        let site = options.siteId ? `&site=${options.siteId}` : ``;
        this.ws = new WebSocket(`${host}/?token=${options.activeToken}&type=${options.entityType}&EIO=3&transport=websocket${site}`);
        this.bind();
    }
}

});

parcelRegister("2eT6g", function(module, exports) {

$parcel$export(module.exports, "WebSocketPanelEventName", function () { return $7b0b33cebe0cb20a$export$379e1fa1a42f4e1e; });
class $7b0b33cebe0cb20a$export$379e1fa1a42f4e1e {
}
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONNECTION_READY = "connection/ready";
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.CONNECTION_ERROR = "connection/error";
//collab editor room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_JOIN = "collaboration/editor/join" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_LEAVE = "collaboration/editor/leave" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_ATTACHMENTS = "collaboration/editor/attachments" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_SAVE_METADATA = "collaboration/editor/metadata" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_JOIN = "collaboration/editor/viewer/join" //compose editor
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.COLLABORATION_EDITOR_VIEWER_LEAVE = "collaboration/editor/viewer/leave" //compose editor
;
//manage room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_JOIN = "site/join" // receive join
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_LEAVE = "site/leave" // receive leave
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_UPDATE = "site/update" //compose site
;
//site and livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_JOIN_ACCOUNT = "site/join/account" //compose joined account
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_LEAVE_ACCOUNT = "site/leave/account" //compose account
;
//inbox room
//no room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_RELOAD = "site/reload" //compose true
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_UPDATE = "role/update" //compose role
;
//set to roles room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_CREATE = "role/create" //compose role
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ROLE_DELETE = "role/delete" //compose role
;
//no room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_LOGOUT = "account/logout" //compose true
;
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_UPDATE = "account/update" //compose account
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ACCOUNT_KICK = "account/kick" //compose account
;
// inbox and livechat room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ENTITY_TYPING = "entity/typing" //compose entity typing
;
//site room
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.ENTITY_UPDATE = "entity/update" //compose contact or account
;
//site channel
$7b0b33cebe0cb20a$export$379e1fa1a42f4e1e.SITE_CHANNEL_UPDATE = "sitechannel/update";

});


parcelRegister("4U8vF", function(module, exports) {

$parcel$export(module.exports, "jsonConcat", function () { return $f7d597ba55052d67$export$18a01edb43e2b5d0; });
/**
 * Concat two json
 */ function $f7d597ba55052d67$export$18a01edb43e2b5d0(o1, o2) {
    if (!o2) return o1;
    for(let key in o2)o1[key] = o2[key];
    return o1;
}

});

parcelRegister("8hCed", function(module, exports) {

$parcel$export(module.exports, "randomInteger", function () { return $25ef68c464c485b6$export$3f522a9c938dfb72; });
/**
 * random
 */ /**
 * genere un nombre aléatoire
 */ function $25ef68c464c485b6$export$3f522a9c938dfb72(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

});

parcelRegister("dI9YH", function(module, exports) {

$parcel$export(module.exports, "queryString", function () { return $7c9d9db8e63cd145$export$ded69dcd8ce7e468; });
/**
 * Transforme du JSON en data pour les requêtes ajax
 */ function $7c9d9db8e63cd145$export$ded69dcd8ce7e468(object) {
    let data = "";
    let counter = 1;
    Object.keys(object).forEach((k)=>{
        if (object[k] != undefined) {
            data += k + "=" + encodeURIComponent(object[k]) + (counter >= Object.keys(object).length ? "" : "&");
            counter++;
        }
    });
    return data;
}

});


parcelRegister("7Aqrk", function(module, exports) {

$parcel$export(module.exports, "AccountService", function () { return $f62ac74e8bd8a8cb$export$b662858863b75c61; });

var $7AbeR = parcelRequire("7AbeR");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7ZaxO = parcelRequire("7ZaxO");

var $g0YRJ = parcelRequire("g0YRJ");

var $5pJMm = parcelRequire("5pJMm");

var $2eT6g = parcelRequire("2eT6g");

var $kCcuA = parcelRequire("kCcuA");

var $68Z0d = parcelRequire("68Z0d");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $f62ac74e8bd8a8cb$export$b662858863b75c61 {
    static dispose() {
        this.accounts = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_UPDATE, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_LOGOUT, ()=>{
            location.reload();
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ACCOUNT_KICK, (data)=>{
            let account = this.store(data);
            account.siteId = undefined;
            if (account.id == (0, $68Z0d.EntityService).activeEntity.id) location.reload();
        });
    }
    /**
     * rest
     */ static async create(data, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).TOO_MANY_REQUESTS,
                message: (0, $5FliW.Resources).t("words.accountRegisterToManyRequests")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/account`, data, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async update(name, email, work, numberPhone, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/update", {
            name: name,
            language: (0, $5FliW.Resources).language,
            email: email,
            work: work,
            numberPhone: numberPhone
        }, component);
        return request.status;
    }
    static async registerTransaction(transactionId, sessionId, component) {
        return await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/register/transaction", {
            transactionId: transactionId,
            sessionId: sessionId
        }, component);
    }
    static async updatePassword(oldPassword, newPassword, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PASSWORD,
                message: (0, $5FliW.Resources).t("words.account.currentPasswordUnavailable")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/update/password", {
            oldPassword: oldPassword,
            newPassword: newPassword
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async activity(active, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/account/activity`, {
            active: active
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findRolesBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/roles/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findById(id, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorVerify(id, token, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/verify/${id}/${token}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorDisabled(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/disable`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async twoFactorEnabled(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/2fa/enable`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getAccountAdmin(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/` + id, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async updateEmailNotifyAccountAdmin(id, state, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/emailNotify/` + id + '/' + state, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async updateDisplayPromoCodeInputAccountAdmin(id, state, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/admin/displayPromoCodeInput/` + id + '/' + state, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async hasEvent(id, event, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/account/event/${id}/${event}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async addEvent(id, event, component) {
        await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/event", {
            id: id,
            event: event
        }, component);
    }
    /**
     * has
     */ static hasRole(account, role) {
        if (account.rolesAccount != undefined) return account.rolesAccount.filter((roleAccount)=>roleAccount.role.id == role.id).length > 0;
        return false;
    }
    /**
     * logic
     */ static async requestLogin(request) {
        (0, $68Z0d.EntityService).headersToken(request === null || request === void 0 ? void 0 : request.headers);
        await (0, $7AbeR.Network).onToken();
        await (0, $7AbeR.Network).onLogin();
        (0, $7AbeR.Network).router.onLogin();
    }
    /**
     * get
     */ static getAll() {
        return this.accounts;
    }
    /**
     * store
     */ static storeAll(accounts) {
        for(let key in accounts)accounts[key] = this.store(accounts[key]);
        return (0, $2Y8XI.Services).storeAll(accounts);
    }
    static store(account) {
        if (account != undefined) {
            var _EntityService_activeEntity, _EntityService_activeEntity1;
            if (account.avatar != undefined) account.avatar = (0, $g0YRJ.AvatarService).store(account.avatar);
            if (account.rolesAccount != undefined) account.rolesAccount = (0, $kCcuA.RoleAccountService).storeAll(account.rolesAccount);
            account.type = (0, $5pJMm.EntityType).ACCOUNT;
            if (account.id === ((_EntityService_activeEntity = (0, $68Z0d.EntityService).activeEntity) === null || _EntityService_activeEntity === void 0 ? void 0 : _EntityService_activeEntity.id) && account.email === "") account.email = (_EntityService_activeEntity1 = (0, $68Z0d.EntityService).activeEntity) === null || _EntityService_activeEntity1 === void 0 ? void 0 : _EntityService_activeEntity1.email;
            return (0, $2Y8XI.Services).store("id", this.accounts, account);
        }
    }
}
$f62ac74e8bd8a8cb$export$b662858863b75c61.accounts = (0, $i3Hbv.observable)([]);

});
parcelRegister("2Y8XI", function(module, exports) {

$parcel$export(module.exports, "Services", function () { return $0b02b3d6e2a603d1$export$c447b0cdbd1cd184; });

var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $3uVji = parcelRequire("3uVji");
class $0b02b3d6e2a603d1$export$c447b0cdbd1cd184 {
    static storeAll(list) {
        if (list == undefined) return undefined;
        return (0, $i3Hbv.observable)(list);
    }
    static store(key, array, object) {
        // @ts-ignore
        object = (0, $i3Hbv.observable)(object);
        let cache = array.filter((a)=>a[key] == object[key])[0];
        if (cache != undefined) {
            (0, $3uVji.objectUpdate)(cache, object);
            return cache;
        }
        array.push(object);
        return object;
    }
    static unStore(key, array, object) {
        let cache = array.filter((a)=>a[key] == object[key])[0];
        if (cache != undefined) {
            array.splice(array.indexOf(cache), 1);
            return cache;
        }
        return undefined;
    }
    static get(key, array, value) {
        return array.filter((a)=>a[key] == value)[0];
    }
    static on(service, type, event, func) {
        if (!service.socketHandlers) service.socketHandlers = [];
        service.socketHandlers.push({
            event: event,
            func: func
        });
        (0, $7AbeR.Network).on(type, event, func);
    }
    static beforeInit(service) {
        if (service.socketHandlers && (0, $7AbeR.Network).getSocket()) {
            service.socketHandlers.forEach((v)=>(0, $7AbeR.Network).getSocket().removeListener(v.event));
            service.socketHandlers = [];
        }
    }
    static handleErrors(component, errors) {
        if (!component) component = {
            networkErrorsHandler: [],
            addNetworkErrors (errors) {
                errors.forEach((error)=>this.networkErrorsHandler.push(error));
            }
        };
        if (component && component.networkErrorsHandler.length === 0) component.addNetworkErrors(errors);
    }
}

});
parcelRegister("3uVji", function(module, exports) {

$parcel$export(module.exports, "objectUpdate", function () { return $ab95059939b7ca32$export$e20c9e8e0502f2a5; });

var $7MANU = parcelRequire("7MANU");
function $ab95059939b7ca32$export$e20c9e8e0502f2a5(objectBase, newObject) {
    if (newObject) {
        for(let property in objectBase){
            if (objectBase.hasOwnProperty(property)) {
                if (typeof newObject[property] !== "undefined") {
                    if (!Array.isArray(newObject[property])) {
                        if (objectBase[property] != newObject[property]) objectBase[property] = newObject[property];
                    } else if (!(0, $7MANU.arrayEquals)(objectBase[property], newObject[property])) objectBase[property] = newObject[property];
                }
            }
        }
        for(let property in newObject){
            if (!objectBase.hasOwnProperty(property)) {
                if (typeof newObject[property] !== "undefined") objectBase[property] = newObject[property];
            }
        }
    }
    return objectBase;
}

});
parcelRegister("7MANU", function(module, exports) {

$parcel$export(module.exports, "arrayEquals", function () { return $91c8ac590ba50b0a$export$22d6d01dd47e89dd; });
/**
 * array
 */ 
var $cXUbD = parcelRequire("cXUbD");
function $91c8ac590ba50b0a$export$22d6d01dd47e89dd(arr1, arr2) {
    if (arr1 == undefined || arr2 == undefined) return false;
    if (arr1.length != arr2.length) return false;
    if (arr1.length == 0 && arr2.length == 0) return true;
    arr1 = [
        ...arr1
    ];
    arr2 = [
        ...arr2
    ];
    arr1 = arr1.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    arr2 = arr2.sort(function(a, b) {
        return a > b ? 1 : -1;
    });
    for(let i = 0; i < arr1.length; i++)if (typeof arr1[i] == "object") {
        if (!(0, $cXUbD.objectEquals)(arr1[i], arr2[i])) return false;
    } else {
        if (arr1[i] != arr2[i]) return false;
    }
    return true;
}

});
parcelRegister("cXUbD", function(module, exports) {

$parcel$export(module.exports, "objectEquals", function () { return $6501409114e16eb6$export$5b4d20f570fee173; });
/**
 * Vérifie de manière recursif si deux objets sont identique
 */ 
var $7MANU = parcelRequire("7MANU");
function $6501409114e16eb6$export$5b4d20f570fee173(obj1, obj2) {
    if (obj1 == undefined || obj2 == undefined) return false;
    for(let property in obj1)if (obj1.hasOwnProperty(property)) {
        let value = obj1[property];
        let compareValue = obj2[property];
        if (typeof value == "object") {
            if (!$6501409114e16eb6$export$5b4d20f570fee173(value, compareValue)) return false;
        } else if (Array.isArray(value)) {
            if (!(0, $7MANU.arrayEquals)(value, compareValue)) return false;
        } else {
            if (typeof value === 'string') {
                let valueNumber = Number(value);
                if (!Number.isNaN(valueNumber)) value = valueNumber;
            }
            if (typeof compareValue === 'string') {
                let valueNumber = Number(value);
                if (!Number.isNaN(valueNumber)) compareValue = valueNumber;
            }
            if (value != compareValue) return false;
        }
    }
    return true;
}

});




parcelRegister("g0YRJ", function(module, exports) {

$parcel$export(module.exports, "AvatarService", function () { return $73823d77789937ac$export$c122ef7a8e25709e; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $bKmye = parcelRequire("bKmye");

var $fYPFR = parcelRequire("fYPFR");

var $68Z0d = parcelRequire("68Z0d");
class $73823d77789937ac$export$c122ef7a8e25709e {
    static init() {}
    static dispose() {
        this.avatars = (0, $i3Hbv.observable)([]);
    }
    static storeAll(avatars) {
        for(let key in avatars)avatars[key] = this.store(avatars[key]);
        return (0, $2Y8XI.Services).storeAll(avatars);
    }
    static store(avatar) {
        let storedAvatar = (0, $2Y8XI.Services).get("id", this.avatars, avatar.id);
        if (storedAvatar != undefined) {
            if (avatar.file == undefined) storedAvatar.file = undefined;
            if (avatar.color == undefined) storedAvatar.color = undefined;
        }
        if (avatar.file != undefined) avatar.file = (0, $bKmye.FileService).store(avatar.file);
        if (avatar.color != undefined) avatar.color = (0, $fYPFR.AvatarColorService).store(avatar.color);
        return (0, $2Y8XI.Services).store("id", this.avatars, avatar);
    }
    static isActive(activeModel) {
        return activeModel["siteId"] != undefined ? activeModel.active && activeModel["siteId"] == (0, $68Z0d.EntityService).activeSite.id : activeModel.active;
    }
}
$73823d77789937ac$export$c122ef7a8e25709e.avatars = (0, $i3Hbv.observable)([]);

});
parcelRegister("bKmye", function(module, exports) {

$parcel$export(module.exports, "FileService", function () { return $dc50932e05ed7fd7$export$4adefade6695ab45; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");
class $dc50932e05ed7fd7$export$4adefade6695ab45 {
    static init() {}
    static dispose() {
        this.files = (0, $i3Hbv.observable)([]);
    }
    /**
     * rest
     */ static async create(siteId, origin, files, progress, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/files`, {
            files: files,
            siteId: siteId,
            origin: origin
        }, component, {
            onUploadProgress: (progressEvent)=>{
                progress(progressEvent.loaded * 100 / progressEvent.total);
            }
        });
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    /**
     * link
     */ static link(file) {
        return (0, $271MM.config).httpPanelUrl + `/files/${file.id}.${file.extension}`;
    }
    static storeAll(files) {
        for(let key in files)files[key] = this.store(files[key]);
        return (0, $2Y8XI.Services).storeAll(files);
    }
    static store(file) {
        file.link = $dc50932e05ed7fd7$export$4adefade6695ab45.link(file);
        return (0, $2Y8XI.Services).store("id", this.files, file);
    }
}
$dc50932e05ed7fd7$export$4adefade6695ab45.files = (0, $i3Hbv.observable)([]);

});

parcelRegister("fYPFR", function(module, exports) {

$parcel$export(module.exports, "AvatarColorService", function () { return $4a50255f26c705bb$export$8fd88b7de3288064; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $4a50255f26c705bb$export$8fd88b7de3288064 {
    static init() {}
    static dispose() {
        this.colors = (0, $i3Hbv.observable)([]);
    }
    static storeAll(colors) {
        for(let key in colors)colors[key] = this.store(colors[key]);
        return (0, $2Y8XI.Services).storeAll(colors);
    }
    static store(color) {
        return (0, $2Y8XI.Services).store("color", this.colors, color);
    }
}
$4a50255f26c705bb$export$8fd88b7de3288064.colors = (0, $i3Hbv.observable)([]);

});


parcelRegister("5pJMm", function(module, exports) {

$parcel$export(module.exports, "EntityType", function () { return $22639064657c8baf$export$8eda7e02f8f033b2; });
var $22639064657c8baf$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType[EntityType["ACCOUNT"] = 1] = "ACCOUNT";
    EntityType[EntityType["CONTACT"] = 2] = "CONTACT";
    EntityType[EntityType["CHATBOT"] = 3] = "CHATBOT";
    EntityType[EntityType["EXTERNAL"] = 4] = "EXTERNAL";
    return EntityType;
}({});

});

parcelRegister("kCcuA", function(module, exports) {

$parcel$export(module.exports, "RoleAccountService", function () { return $13646c59b2684459$export$776d4b659cbf7495; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $jdUQG = parcelRequire("jdUQG");

var $kfkzw = parcelRequire("kfkzw");
class $13646c59b2684459$export$776d4b659cbf7495 {
    static dispose() {
        this.accounts = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * http
     */ static async delete(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/roles/account/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
        return false;
    }
    static async create(accountId, roleId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/account", {
            accountId: accountId,
            roleId: roleId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    /**
     * store
     */ static storeAll(rolesAccount) {
        for(let key in rolesAccount)rolesAccount[key] = this.store(rolesAccount[key]);
        return (0, $2Y8XI.Services).storeAll(rolesAccount);
    }
    static store(roleAccount) {
        roleAccount.role = (0, $jdUQG.RoleService).store(roleAccount.role);
        roleAccount = (0, $2Y8XI.Services).store("id", this.accounts, roleAccount);
        return roleAccount;
    }
}
$13646c59b2684459$export$776d4b659cbf7495.accounts = (0, $i3Hbv.observable)([]);

});
parcelRegister("jdUQG", function(module, exports) {

$parcel$export(module.exports, "RoleService", function () { return $4eb5e681485625fd$export$bb170c807acfe5f; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2eT6g = parcelRequire("2eT6g");

var $4ymN9 = parcelRequire("4ymN9");

var $68Z0d = parcelRequire("68Z0d");

var $dvTuK = parcelRequire("dvTuK");

var $9jYbZ = parcelRequire("9jYbZ");

var $kfkzw = parcelRequire("kfkzw");
class $4eb5e681485625fd$export$bb170c807acfe5f {
    static dispose() {
        this.roles = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_UPDATE, (data)=>{
            this.store(data);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_CREATE, (data)=>{
            let role = this.store(data);
            this.roleChange(role);
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).ROLE_DELETE, (data)=>{
            let role = this.store(data);
            this.unStore(role);
            this.roleChange(role);
        });
    }
    /**
     * http
     */ static async findBySite(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/roles/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async updateRanks(siteId, orders, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/roles/update/ranks", {
            siteId: siteId,
            orders: orders
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async updatePermissions(roleId, permissions, siteChannelsIdsInbox, siteChannelsIdsPublisher, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/update/permissions", {
            roleId: roleId,
            permissions: permissions,
            siteChannelsIdsInbox: siteChannelsIdsInbox,
            siteChannelsIdsPublisher: siteChannelsIdsPublisher
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static getAll() {
        return this.roles;
    }
    static async update(roleId, name, color, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/update", {
            roleId: roleId,
            name: name,
            color: color
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async create(siteId, name, color, model, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles", {
            siteId: siteId,
            name: name,
            color: color,
            model: model
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let role = this.store(request.data);
            this.roleChange(role);
            return role;
        }
        return undefined;
    }
    static async delete(roleId, component) {
        let role = this.roles.filter((role)=>role.id == roleId)[0];
        this.unStore(role);
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/roles/${roleId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.roleChange(role);
            return true;
        }
        return false;
    }
    static async duplicate(roleId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/roles/duplicate", {
            roleId: roleId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let role = this.store(request.data);
            this.roleChange(role);
            return role;
        }
        return undefined;
    }
    /**
     * utilities
     */ static maxRank(account) {
        let maxRank = 0;
        for (let role of account.rolesAccount.map((roleAccount)=>roleAccount.role))if (role.rank > maxRank) maxRank = role.rank;
        return maxRank;
    }
    static greater(account) {
        let myAccount = (0, $68Z0d.EntityService).activeEntity;
        let mySite = (0, $68Z0d.EntityService).activeSite;
        if (myAccount.id == mySite.accountId) return true;
        if (account.id == mySite.accountId) return false;
        if (myAccount.rolesAccount == undefined || myAccount.rolesAccount.length == 0) return false;
        if (account.rolesAccount == undefined || account.rolesAccount.length == 0) return true;
        return this.maxRank(myAccount) > this.maxRank(account);
    }
    static can(...permissions) {
        if ((0, $68Z0d.EntityService).activeSite == undefined) return false;
        return this.canAccess((0, $68Z0d.EntityService).activeEntity, ...permissions);
    }
    static updateRole(role) {
        return this.canUpdateRole((0, $68Z0d.EntityService).activeEntity, (0, $68Z0d.EntityService).activeSite, role);
    }
    static hasPermission(rolesAccounts, ...permissions) {
        for (let permission of permissions){
            if (rolesAccounts.filter((roleAccount)=>roleAccount.role.permissions.includes(permission)).length > 0) return true;
        }
        return false;
    }
    static canAccess(account, ...permissions) {
        if (account.rolesAccount == undefined) return false;
        if (this.hasPermission(account.rolesAccount, (0, $4ymN9.RolePermissionsType).ADMINISTRATOR)) return true;
        return this.hasPermission(account.rolesAccount, ...permissions);
    }
    static canUpdateRole(account, site, role) {
        if (role.id == site.superRoleId) return false;
        if (account.id == site.accountId) return true;
        return this.maxRank(account) > role.rank;
    }
    /**
     * avatar
     */ static avatar(role) {
        return {
            type: (0, $dvTuK.AvatarType).ROLE,
            color: {
                color: role.color
            }
        };
    }
    /**
     * events
     */ static roleChange(role) {
        this.rolesChange.forEach((value)=>value(role));
    }
    static onRoleChange(func, component) {
        this.rolesChange.push(func);
        component.onRemove(()=>this.rolesChange.splice(this.rolesChange.indexOf(func), 1));
    }
    /**
     * store
     */ static storeAll(roles) {
        for(let key in roles)roles[key] = this.store(roles[key]);
        return (0, $2Y8XI.Services).storeAll(roles);
    }
    static store(role) {
        role.siteChannelsInbox = (0, $9jYbZ.SiteChannelService).storeAll(role.siteChannelsInbox);
        role.siteChannelsPublisher = (0, $9jYbZ.SiteChannelService).storeAll(role.siteChannelsPublisher);
        role = (0, $2Y8XI.Services).store("id", this.roles, role);
        return role;
    }
    static unStore(role) {
        (0, $2Y8XI.Services).unStore("id", this.roles, role);
    }
}
$4eb5e681485625fd$export$bb170c807acfe5f.roles = (0, $i3Hbv.observable)([]);
$4eb5e681485625fd$export$bb170c807acfe5f.rolesChange = [];

});
parcelRegister("4ymN9", function(module, exports) {

$parcel$export(module.exports, "RolePermissionsType", function () { return $42e5c2c0d98d9329$export$6f6fd11394c3f5db; });
class $42e5c2c0d98d9329$export$6f6fd11394c3f5db {
}
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ADMINISTRATOR = "a";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_ADMINISTRATOR = "pa";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_PUBLISH = "be";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER = "p";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_FACEBOOK_READ = "ba";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_INSTAGRAM_PAGE_READ = "bb";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.PUBLISHER_TWITTER_READ = "bc";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_ADMINISTRATOR = "m";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX = "b";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_ASSIGNMENT = "h";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FILTERS_PUBLIC = "j";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_SHORTCUTS_PUBLIC = "q";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FILES = "z";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_CATEGORIES_PUBLIC = "ac";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_EDIT_ALL = "af";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_LIVECHAT_READ = "f";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_MAIL_READ = "ak";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_TWITTER_READ = "bd";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_FACEBOOK_READ = "rfb";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_INSTAGRAM_PAGE_READ = "ris";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_LINKEDIN_READ = "bg";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INBOX_SHOPIFY_READ = "bo";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.GENERAL = "c";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ACCOUNT_MANAGE = "g";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.INVITATIONS_MANAGE = "k";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_MANAGE = "l";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_LIVECHAT_MANAGE = "r";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_CHANNEL_MAILS_MANAGE = "ah";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.ROLES_MANAGE = "n";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SITE_MANAGE = "ad";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_ADMINISTRATOR = "s";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_NOTES = "t";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_NOTES_MANAGE = "v";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_PRIVATE_DATA = "aa";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_ACTIVES = "ad";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_BAN = "ae";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_EDIT_DATA = "ag";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.CONTACT_CREATE = "bh";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_ADMINISTRATOR = "ab";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX = "e";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_CONVERSATION = "u";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_MESSAGES = "w";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.STATISTICS_INBOX_MEMBERS = "x";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_ADMINISTRATOR = "bn";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_READING = "bp";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_WRITING = "bq";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_PUBLISH = "bs";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.HELPCENTER_DELETE = "br";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_ADMINISTRATOR = "bi";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_READING = "bj";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_WRITING = "bk";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_PUBLISH = "bt";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.BLOG_DELETE = "bl";
$42e5c2c0d98d9329$export$6f6fd11394c3f5db.SUBSCRIPTION_ADMINISTRATOR = "bm";

});

parcelRegister("dvTuK", function(module, exports) {

$parcel$export(module.exports, "AvatarType", function () { return $6359b9e3c26ba03a$export$c11c93bc4a4bfefe; });
var $6359b9e3c26ba03a$export$c11c93bc4a4bfefe = /*#__PURE__*/ function(AvatarType) {
    AvatarType[AvatarType["ENTITY"] = 1] = "ENTITY";
    AvatarType[AvatarType["ROLE"] = 2] = "ROLE";
    AvatarType[AvatarType["SITE"] = 3] = "SITE";
    AvatarType[AvatarType["SITE_CHANNEL"] = 4] = "SITE_CHANNEL";
    AvatarType[AvatarType["BOT"] = 5] = "BOT";
    AvatarType[AvatarType["MAIL"] = 6] = "MAIL";
    AvatarType[AvatarType["HELP_CENTER"] = 7] = "HELP_CENTER";
    return AvatarType;
}({});

});

parcelRegister("9jYbZ", function(module, exports) {

$parcel$export(module.exports, "SiteChannelService", function () { return $87b88de78b4d8705$export$d235de51709f9b1d; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $nSXuR = parcelRequire("nSXuR");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $g0YRJ = parcelRequire("g0YRJ");

var $bOsdQ = parcelRequire("bOsdQ");

var $dvTuK = parcelRequire("dvTuK");

var $68Z0d = parcelRequire("68Z0d");

var $1b6Hd = parcelRequire("1b6Hd");

var $7Aqrk = parcelRequire("7Aqrk");

var $kfkzw = parcelRequire("kfkzw");

var $2eT6g = parcelRequire("2eT6g");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $87b88de78b4d8705$export$d235de51709f9b1d {
    static dispose() {
        this.siteChannels = (0, $i3Hbv.observable)([]);
        this.updates = [];
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_CHANNEL_UPDATE, (data)=>{
            let update = data;
            this.updates.forEach((value)=>value(update));
        });
    }
    static async findUrlConnectPartner(invitationId, isLogin, channelType, communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/oauth/url/${channelType}/${isLogin}`, {
            invitationId: invitationId,
            communityId: communityId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return decodeURIComponent(request.data);
        return undefined;
    }
    static async findBySiteId(siteId, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findBySiteIdAndPerms(siteId, product, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/perms/${siteId}/${product}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findByType(channelType, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/type/${channelType}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return [];
    }
    static async findReliedAccounts(siteChannelId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/channel/relied/accounts/${siteChannelId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $7Aqrk.AccountService).storeAll(request.data);
        return [];
    }
    static async pickedByPerms(component, channelType) {
        let siteChannels = await this.findBySiteIdAndPerms((0, $68Z0d.EntityService).activeSite.id, (0, $kfkzw.ProductType).INBOX, component);
        siteChannels = siteChannels.filter((value)=>!channelType || value.channel.type == channelType);
        let siteChannel = siteChannels.find((value)=>value.id == (0, $1b6Hd.PreferencesService).siteChannelPickerSelected);
        return siteChannel ? siteChannel : siteChannels[0];
    }
    static async delete(id, component) {
        let siteChannel = this.siteChannels.filter((value)=>value.id == id)[0];
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/site/channel/delete", {
            id: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.unStore(siteChannel);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async update(id, component) {
        let request = await (0, $7AbeR.Network).put((0, $kfkzw.ProductType).PANEL, "/site/channel/update", {
            id: id
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.store(request.data);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async register(registerOutgoingModel, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PARTNER_CONFING_INVALID,
                message: (0, $5FliW.Resources).t("words.partnerConnectionFailed")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).PARTNER_CONFING_PERMISSIONS,
                message: registerOutgoingModel.channelType == (0, $bOsdQ.ChannelType).SHOPIFY ? (0, $5FliW.Resources).t("words.shopifyPermissionsMessage") : (0, $5FliW.Resources).t("words.missingPermissions")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/site/channel/register`, registerOutgoingModel, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    /**
     * avatar
     */ static avatar(siteChannel) {
        if (siteChannel.avatar) return siteChannel.avatar;
        return {
            type: (0, $dvTuK.AvatarType).SITE_CHANNEL,
            color: {
                color: siteChannel.color
            }
        };
    }
    /**
     * ws
     */ static onUpdates(func, component) {
        this.updates.push(func);
        component.onRemove(()=>this.updates.splice(this.updates.indexOf(func), 1));
    }
    /**
     * store
     */ static storeAll(siteChannels) {
        for(let key in siteChannels)siteChannels[key] = this.store(siteChannels[key]);
        return (0, $2Y8XI.Services).storeAll(siteChannels);
    }
    static store(siteChannel) {
        if (siteChannel.avatar != undefined) siteChannel.avatar = (0, $g0YRJ.AvatarService).store(siteChannel.avatar);
        siteChannel.channel = (0, $nSXuR.ChannelService).findById(siteChannel.channelId);
        return siteChannel;
    }
    static unStore(siteChannel) {
        (0, $2Y8XI.Services).unStore("id", this.siteChannels, siteChannel);
    }
}
$87b88de78b4d8705$export$d235de51709f9b1d.siteChannels = (0, $i3Hbv.observable)([]);
$87b88de78b4d8705$export$d235de51709f9b1d.updates = [];

});
parcelRegister("nSXuR", function(module, exports) {

$parcel$export(module.exports, "ChannelService", function () { return $78d27de023919bc7$export$ad877c9653fa6220; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $78d27de023919bc7$export$ad877c9653fa6220 {
    static init() {}
    static dispose() {
        this.channels = (0, $i3Hbv.observable)([]);
    }
    static findById(id) {
        return $78d27de023919bc7$export$ad877c9653fa6220.channels.find((channel)=>channel.id === id);
    }
    static findAllByFiter() {
        return $78d27de023919bc7$export$ad877c9653fa6220.channels.filter((channel)=>channel.inboxProperties);
    }
    static storeAll(channels) {
        return channels.map((value)=>this.store(value));
    }
    static store(channel) {
        return (0, $2Y8XI.Services).store("id", this.channels, channel);
    }
}
$78d27de023919bc7$export$ad877c9653fa6220.channels = (0, $i3Hbv.observable)([]);

});

parcelRegister("bOsdQ", function(module, exports) {

$parcel$export(module.exports, "ChannelType", function () { return $6ec2cf14a5300222$export$36655de2868043ae; });
var $6ec2cf14a5300222$export$36655de2868043ae = /*#__PURE__*/ function(ChannelType) {
    ChannelType["LIVECHAT"] = "2e3b69b2999c4c38b45c5076f98e6946";
    ChannelType["TWITTER"] = "200cfded4cfd4bde977f174bc16bc634";
    ChannelType["FACEBOOK"] = "eebf03447dbc46068dd217fcd62e586d";
    ChannelType["LINKEDIN"] = "d7d61128f27a4af7b4bbd78394d65582";
    ChannelType["INSTAGRAM"] = "8d4446321fa7481cb71ddac1d78cd0ct";
    ChannelType["MAIL"] = "25132600ff214f18b623479258eecf38";
    ChannelType["SHOPIFY"] = "t7d61128f27a4bf7b4bbd78394d65572";
    ChannelType["WIX"] = "w7x61128f27a4b4rd4bbd78394d65512";
    ChannelType["WORDPRESS"] = "wwx61128f27a4b45d4bbd78394d65516";
    ChannelType["WEBFLOW"] = "wfx61128f27a4b45d4bbd78394d65519";
    ChannelType["PRESTASHOP"] = "ppx61128f27a4b4rd4bbd78394d65512";
    ChannelType["GOOGLE"] = "1";
    ChannelType["UNKNOWN"] = "0";
    return ChannelType;
}({});
function $6ec2cf14a5300222$export$c91bb9fb1b59614a(type) {
    return Object.keys($6ec2cf14a5300222$export$36655de2868043ae).find((value)=>$6ec2cf14a5300222$export$36655de2868043ae[value] == type);
}

});

parcelRegister("1b6Hd", function(module, exports) {

$parcel$export(module.exports, "PreferencesService", function () { return $cfeb42a5c4fe0291$export$cc55b2103fd9a32b; });

var $e4AOZ = parcelRequire("e4AOZ");

var $1wiPK = parcelRequire("1wiPK");
class $cfeb42a5c4fe0291$export$cc55b2103fd9a32b {
    static get editorSpellChecker() {
        return this._editorSpellChecker;
    }
    static set editorSpellChecker(value) {
        (0, $1wiPK.SedestralStorage).setItem("_editorSpellChecker", JSON.stringify(value));
        this._editorSpellChecker = value;
    }
    static get editorLineMode() {
        return this._editorLineMode;
    }
    static set editorLineMode(value) {
        (0, $1wiPK.SedestralStorage).setItem("_editorLineMode", value);
        this._editorLineMode = value;
    }
    static get mediaVolume() {
        return this._mediaVolume;
    }
    static set mediaVolume(value) {
        (0, $1wiPK.SedestralStorage).setItem("_mediaVolume", "" + value);
        this._mediaVolume = value;
    }
    static get siteChannelPickerSelected() {
        return this._siteChannelPickerSelected;
    }
    static set siteChannelPickerSelected(value) {
        this._siteChannelPickerSelected = value;
        if (value == undefined) (0, $1wiPK.SedestralStorage).removeItem("_siteChannelPickerSelected");
        else (0, $1wiPK.SedestralStorage).setItem("_siteChannelPickerSelected", value);
    }
    static get inboxBodyDetailsClosed() {
        return this._inboxBodyDetailsClosed;
    }
    static set inboxBodyDetailsClosed(value) {
        (0, $1wiPK.SedestralStorage).setItem("_inboxBodyDetailsClosed", JSON.stringify(value));
        this._inboxBodyDetailsClosed = value;
    }
    static get inboxSearchValue() {
        return this._inboxSearchValue;
    }
    static set inboxSearchValue(value) {
        this._inboxSearchValue = value;
        if (value == undefined) (0, $1wiPK.SedestralStorage).removeItem("_inboxSearchValue");
        else (0, $1wiPK.SedestralStorage).setItem("_inboxSearchValue", value);
    }
    static get inboxSearchFilterData() {
        return this._inboxSearchFilterData;
    }
    static set inboxSearchFilterData(value) {
        this._inboxSearchFilterData = value;
        if (value == undefined) (0, $1wiPK.SedestralStorage).removeItem("_inboxSearchFilterData");
        else (0, $1wiPK.SedestralStorage).setItem("_inboxSearchFilterData", value);
    }
    static get inboxSearchSort() {
        return this._inboxSearchSort;
    }
    static set inboxSearchSort(value) {
        this._inboxSearchSort = value;
        if (value == undefined) (0, $1wiPK.SedestralStorage).removeItem("_inboxSearchSort");
        else (0, $1wiPK.SedestralStorage).setItem("_inboxSearchSort", "" + value);
    }
    static get inboxFilterEntryId() {
        return this._inboxFilterEntryId;
    }
    static set inboxFilterEntryId(value) {
        this._inboxFilterEntryId = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterEntryId", value);
    }
    static get inboxFilterEntryData() {
        return this._inboxFilterEntryData;
    }
    static set inboxFilterEntryData(value) {
        this._inboxFilterEntryData = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterEntryData", value);
    }
    static get inboxFilterEntryName() {
        return this._inboxFilterEntryName;
    }
    static set inboxFilterEntryName(value) {
        this._inboxFilterEntryName = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterEntryName", value);
    }
    static get inboxFilterId() {
        return this._inboxFilterId;
    }
    static set inboxFilterId(value) {
        this._inboxFilterId = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterId", value);
    }
    static get inboxFilterData() {
        return this._inboxFilterData;
    }
    static set inboxFilterData(value) {
        this._inboxFilterData = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterData", value);
    }
    static get inboxFilterName() {
        return this._inboxFilterName;
    }
    static set inboxFilterName(value) {
        this._inboxFilterName = value;
        (0, $1wiPK.SedestralStorage).setItem("_inboxFilterName", value);
    }
    static get contactDetailsSort() {
        return this._contactDetailsSort;
    }
    static set contactDetailsSort(value) {
        (0, $1wiPK.SedestralStorage).setItem("_contactDetailsSort", value);
        this._contactDetailsSort = value;
    }
    static get statisticsInboxHomeDays() {
        return this._statisticsInboxHomeDays;
    }
    static set statisticsInboxHomeDays(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxHomeDays", "" + value);
        this._statisticsInboxHomeDays = value;
    }
    static get statisticsInboxConversationFilters() {
        return this._statisticsInboxConversationFilters == "undefined" || this._statisticsInboxConversationFilters == "null" ? undefined : this._statisticsInboxConversationFilters;
    }
    static set statisticsInboxConversationFilters(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxConversationCountFilters", value);
        this._statisticsInboxConversationFilters = value;
    }
    static get statisticsInboxMessagesFilters() {
        return this._statisticsInboxMessagesFilters == "undefined" || this._statisticsInboxMessagesFilters == "null" ? undefined : this._statisticsInboxMessagesFilters;
    }
    static set statisticsInboxMessagesFilters(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxMessagesFilters", value);
        this._statisticsInboxMessagesFilters = value;
    }
    static get statisticsInboxMembersSort() {
        return this._statisticsInboxMembersSort == "undefined" || this._statisticsInboxMembersSort == "null" ? undefined : this._statisticsInboxMembersSort;
    }
    static set statisticsInboxMembersSort(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxMembersSort", value);
        this._statisticsInboxMembersSort = value;
    }
    static get statisticsInboxSplitType() {
        return this._statisticsInboxSplitType;
    }
    static set statisticsInboxSplitType(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxConversationCountSplitType", "" + value);
        this._statisticsInboxSplitType = value;
    }
    static get statisticsInboxFirstInterval() {
        return this._statisticsInboxFirstInterval;
    }
    static set statisticsInboxFirstInterval(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxConversationCountFirstInterval", value);
        this._statisticsInboxFirstInterval = value;
    }
    static get statisticsInboxSecondInterval() {
        return this._statisticsInboxSecondInterval;
    }
    static set statisticsInboxSecondInterval(value) {
        (0, $1wiPK.SedestralStorage).setItem("_statisticsInboxConversationCountSecondInterval", value);
        this._statisticsInboxSecondInterval = value;
    }
    static get timeZoneOffset() {
        return this._timeZoneOffset;
    }
    static set timeZoneOffset(value) {
        (0, $1wiPK.SedestralStorage).setItem("_timeZoneOffset", "" + value);
        this._timeZoneOffset = value;
    }
    static get timeZoneName() {
        return this._timeZoneName;
    }
    static set timeZoneName(value) {
        (0, $1wiPK.SedestralStorage).setItem("_timeZoneName", "" + value);
        this._timeZoneName = value;
    }
    static get hour12() {
        return this._hour12;
    }
    static set hour12(value) {
        (0, $1wiPK.SedestralStorage).setItem("_hour12", JSON.stringify(value));
        this._hour12 = value;
    }
    static get livechatPopupCloseTime() {
        return this._livechatPopupCloseTime;
    }
    static set livechatPopupCloseTime(value) {
        (0, $1wiPK.SedestralStorage).setItem("_livechatPopupCloseTime", "" + value);
        this._livechatPopupCloseTime = value;
    }
    static init() {
        this._editorSpellChecker = JSON.parse((0, $1wiPK.SedestralStorage).getItem("_editorSpellChecker"));
        this._editorLineMode = (0, $1wiPK.SedestralStorage).getItem("_editorLineMode");
        this._contactDetailsSort = (0, $1wiPK.SedestralStorage).getItem("_contactDetailsSort");
        this._mediaVolume = (0, $1wiPK.SedestralStorage).getItem("_mediaVolume") == undefined ? 0.5 : parseFloat((0, $1wiPK.SedestralStorage).getItem("_mediaVolume"));
        this._livechatPopupCloseTime = (0, $1wiPK.SedestralStorage).getItem("_livechatPopupCloseTime") == undefined ? 0 : Number((0, $1wiPK.SedestralStorage).getItem("_livechatPopupCloseTime"));
        this._inboxFilterName = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterName") == undefined ? "Inbox" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterName");
        this._inboxFilterEntryName = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryName") == undefined ? "G\xe9n\xe9ral" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryName");
        this._inboxFilterEntryData = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryData") == undefined ? "inbox" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryData");
        this._inboxFilterEntryId = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryId") == undefined ? "inbox" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterEntryId");
        this._inboxSearchValue = (0, $1wiPK.SedestralStorage).getItem("_inboxSearchValue");
        this._siteChannelPickerSelected = (0, $1wiPK.SedestralStorage).getItem("_siteChannelPickerSelected");
        this._inboxSearchSort = (0, $1wiPK.SedestralStorage).getItem("_inboxSearchSort") == undefined ? (0, $e4AOZ.OperatorType).ORDER_DESC : parseInt((0, $1wiPK.SedestralStorage).getItem("_inboxSearchSort"));
        this._inboxSearchFilterData = (0, $1wiPK.SedestralStorage).getItem("_inboxSearchFilterData");
        this._inboxFilterId = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterId") == undefined ? "inbox" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterId");
        this._inboxFilterData = (0, $1wiPK.SedestralStorage).getItem("_inboxFilterData") == undefined ? "inbox" : (0, $1wiPK.SedestralStorage).getItem("_inboxFilterData");
        this._inboxBodyDetailsClosed = JSON.parse((0, $1wiPK.SedestralStorage).getItem("_inboxBodyDetailsClosed"));
        this._statisticsInboxHomeDays = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxHomeDays") == undefined ? 7 : parseInt((0, $1wiPK.SedestralStorage).getItem("_statisticsInboxHomeDays"));
        this._statisticsInboxConversationFilters = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxConversationCountFilters");
        this._statisticsInboxMessagesFilters = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxMessagesFilters");
        this._statisticsInboxMembersSort = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxMembersSort");
        this._statisticsInboxSplitType = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType") == undefined ? -1 : parseInt((0, $1wiPK.SedestralStorage).getItem("_statisticsInboxConversationCountSplitType"));
        this._statisticsInboxFirstInterval = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxConversationCountFirstInterval");
        this._statisticsInboxSecondInterval = (0, $1wiPK.SedestralStorage).getItem("_statisticsInboxConversationCountSecondInterval");
        this._timeZoneOffset = new Date().getTimezoneOffset();
        this._timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this._hour12 = new Intl.DateTimeFormat().resolvedOptions().hour12;
    }
    static dispose() {}
}

});
parcelRegister("e4AOZ", function(module, exports) {

$parcel$export(module.exports, "OperatorType", function () { return $7cf1e0abb5e22052$export$c18bb9d3f9b808b3; });
var $7cf1e0abb5e22052$export$c18bb9d3f9b808b3 = /*#__PURE__*/ function(OperatorType) {
    OperatorType[OperatorType["IS"] = 1] = "IS";
    OperatorType[OperatorType["IS_NOT"] = 2] = "IS_NOT";
    OperatorType[OperatorType["CONTAINS_ALL"] = 12] = "CONTAINS_ALL";
    OperatorType[OperatorType["CONTAINS"] = 3] = "CONTAINS";
    OperatorType[OperatorType["NOT_CONTAINS"] = 4] = "NOT_CONTAINS";
    OperatorType[OperatorType["EXIST"] = 5] = "EXIST";
    OperatorType[OperatorType["NOT_EXIST"] = 6] = "NOT_EXIST";
    OperatorType[OperatorType["GREATER"] = 7] = "GREATER";
    OperatorType[OperatorType["AFTER"] = 10] = "AFTER";
    OperatorType[OperatorType["LESS"] = 8] = "LESS";
    OperatorType[OperatorType["BEFORE"] = 9] = "BEFORE";
    OperatorType[OperatorType["STARTS_WITH"] = 16] = "STARTS_WITH";
    OperatorType[OperatorType["ENDS_WITH"] = 17] = "ENDS_WITH";
    OperatorType[OperatorType["ORDER_DESC"] = 14] = "ORDER_DESC";
    OperatorType[OperatorType["ORDER_ASC"] = 15] = "ORDER_ASC";
    OperatorType[OperatorType["INTERVAL"] = 11] = "INTERVAL";
    return OperatorType;
}({});

});






parcelRegister("dH00N", function(module, exports) {

$parcel$export(module.exports, "Models", function () { return $f1ebd9544e1eb9b6$export$6edbc060ce567afa; });
class $f1ebd9544e1eb9b6$export$6edbc060ce567afa {
    static isPreviewModel(objet) {
        return objet['baseUrl'] != undefined;
    }
    static isContactModel(object) {
        return object['sessionsCount'] != undefined;
    }
    static isMediaModel(object) {
        return object["extension"] != undefined;
    }
    static isAccountModel(object) {
        return object['account'] != undefined;
    }
    static isEntityModel(object) {
        return this.isAccountModel(object) || this.isContactModel(object);
    }
}

});

parcelRegister("j8ebN", function(module, exports) {

$parcel$export(module.exports, "PreviewService", function () { return $f03233c3c182bdcd$export$f1f35c887a42c378; });

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $ayMnG = parcelRequire("ayMnG");

var $271MM = parcelRequire("271MM");

var $kfkzw = parcelRequire("kfkzw");
class $f03233c3c182bdcd$export$f1f35c887a42c378 {
    static dispose() {
        this.previews = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * load
     */ static async findByUrl(url, component) {
        //TODO store and cache
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/preview/get`, {
            url: url
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static proxyUrl(preview) {
        switch(preview.type){
            case (0, $ayMnG.PreviewType).GIF:
            case (0, $ayMnG.PreviewType).FILE:
            case (0, $ayMnG.PreviewType).AUDIO:
            case (0, $ayMnG.PreviewType).IMAGE:
            case (0, $ayMnG.PreviewType).VIDEO:
                if (preview.baseUrl != undefined && !this.proxyBypass(preview)) return (0, $271MM.config).httpPanelUrl + `/proxy?hash=${preview.id}&url=${encodeURI(preview.baseUrl)}`;
                break;
            case (0, $ayMnG.PreviewType).WEBSITE:
                if (preview.fileUrl != undefined) {
                    console.log(preview.fileUrl);
                    return (0, $271MM.config).httpPanelUrl + `/proxy?hash=${preview.id}&url=${encodeURI(preview.fileUrl)}`;
                }
                break;
        }
        return preview.baseUrl;
    }
    static proxyBypass(preview) {
        return preview.baseUrl.startsWith((0, $271MM.config).tenorMediaHost);
    }
    /**
     * store
     */ static storeAll(previews) {
        for(let key in previews)previews[key] = this.store(previews[key]);
        return (0, $2Y8XI.Services).storeAll(previews);
    }
    static store(preview) {
        preview = (0, $2Y8XI.Services).store("id", this.previews, preview);
        return preview;
    }
}
$f03233c3c182bdcd$export$f1f35c887a42c378.previews = (0, $i3Hbv.observable)([]);

});
parcelRegister("ayMnG", function(module, exports) {

$parcel$export(module.exports, "PreviewType", function () { return $ff97855fee9fb07b$export$ec949ba0ad63fae4; });
var $ff97855fee9fb07b$export$ec949ba0ad63fae4 = /*#__PURE__*/ function(PreviewType) {
    PreviewType[PreviewType["WEBSITE"] = 1] = "WEBSITE";
    PreviewType[PreviewType["IMAGE"] = 2] = "IMAGE";
    PreviewType[PreviewType["VIDEO"] = 3] = "VIDEO";
    PreviewType[PreviewType["GIF"] = 4] = "GIF";
    PreviewType[PreviewType["FILE"] = 5] = "FILE";
    PreviewType[PreviewType["AUDIO"] = 6] = "AUDIO";
    return PreviewType;
}({});

});


parcelRegister("fdmdr", function(module, exports) {

$parcel$export(module.exports, "SiteService", function () { return $850cf6f71545fc5e$export$eb480a33ba4bd7a; });

var $7AbeR = parcelRequire("7AbeR");

var $2eT6g = parcelRequire("2eT6g");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $g0YRJ = parcelRequire("g0YRJ");

var $7Aqrk = parcelRequire("7Aqrk");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");

var $68Z0d = parcelRequire("68Z0d");

var $32rNO = parcelRequire("32rNO");
class $850cf6f71545fc5e$export$eb480a33ba4bd7a {
    static dispose() {
        this.sites = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_JOIN_ACCOUNT, (data)=>(0, $7Aqrk.AccountService).store(data));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_LEAVE_ACCOUNT, (data)=>{
            let account = (0, $7Aqrk.AccountService).store(data);
            account.siteId = undefined;
            account.active = false;
        });
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_UPDATE, (data)=>this.store(data));
        (0, $2Y8XI.Services).on(this, (0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_RELOAD, ()=>this.onReload());
    }
    /**
     * http
     */ static async findActiveAccounts(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/site/activeAccounts`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            request.data = (0, $7Aqrk.AccountService).storeAll(request.data);
            return request.data;
        }
        return undefined;
    }
    static async findMind(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/mind`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async findStatistics(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/statistics`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async select(siteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/select", {
            siteId: siteId
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async unSelect(siteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/unselect", {
            siteId: siteId
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async create(name, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SITE_COUNT_MAX,
                message: (0, $5FliW.Resources).t("words.maxSite")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites", {
            name: name
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAvatar(files, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).PANEL, `/sites/avatar/update`, {
            files: files
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async update(name, link, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/sites/update", {
            name: name,
            link: link
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateAddress(address, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/sites/update/address", address, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async orderColumns(columns, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/sites/column/order`, columns, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createColumn(siteColumn, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/sites/column`, siteColumn, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async deleteColumn(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/sites/column/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async getTaxTypes(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/sites/taxTypes`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    /**
     * websocket
     */ static async join(id) {
        if (id != null) await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).PANEL, id, (0, $2eT6g.WebSocketPanelEventName).SITE_JOIN);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).PANEL, (0, $2eT6g.WebSocketPanelEventName).SITE_LEAVE, id);
    }
    /**
     * override
     */ static onReload() {}
    /**
     * store
     */ static storeAll(conversations) {
        for(let key in conversations)conversations[key] = this.store(conversations[key]);
        return (0, $2Y8XI.Services).storeAll(conversations);
    }
    static store(site) {
        if (site != undefined) {
            if ((0, $68Z0d.EntityService).activeSite && (0, $68Z0d.EntityService).activeSite.id == site.id) (0, $68Z0d.EntityService).activeSite = site;
            site.avatar = (0, $g0YRJ.AvatarService).store(site.avatar);
            site.paymentProvider = (0, $32rNO.getPaymentProviderById)(site.paymentProviderType);
            return (0, $2Y8XI.Services).store("id", this.sites, site);
        }
    }
}
$850cf6f71545fc5e$export$eb480a33ba4bd7a.sites = (0, $i3Hbv.observable)([]);

});
parcelRegister("32rNO", function(module, exports) {

$parcel$export(module.exports, "PaymentProviderType", function () { return $44a7722bc63ba98b$export$d106de282c1be6c1; });
$parcel$export(module.exports, "getPaymentProviderById", function () { return $44a7722bc63ba98b$export$b030ae93ac7cf1ce; });
var $44a7722bc63ba98b$export$d106de282c1be6c1 = /*#__PURE__*/ function(PaymentProviderType) {
    PaymentProviderType[PaymentProviderType["STRIPE"] = 0] = "STRIPE";
    PaymentProviderType[PaymentProviderType["SHOPIFY"] = 1] = "SHOPIFY";
    return PaymentProviderType;
}($44a7722bc63ba98b$export$d106de282c1be6c1 || {});
class $44a7722bc63ba98b$export$202bc391a3eb96a {
    constructor(id, invoice, cb, address, directDeleteDefinitiveOffer){
        this.id = id;
        this.invoice = invoice;
        this.cb = cb;
        this.address = address;
        this.directDeleteDefinitiveOffer = directDeleteDefinitiveOffer;
    }
}
const $44a7722bc63ba98b$export$735606310a3da449 = new $44a7722bc63ba98b$export$202bc391a3eb96a(0, true, true, true, false);
const $44a7722bc63ba98b$export$6da9acb12d5139d4 = new $44a7722bc63ba98b$export$202bc391a3eb96a(1, false, false, false, true);
const $44a7722bc63ba98b$var$paymentProvidersMap = {
    [0]: $44a7722bc63ba98b$export$735606310a3da449,
    [1]: $44a7722bc63ba98b$export$6da9acb12d5139d4
};
function $44a7722bc63ba98b$export$b030ae93ac7cf1ce(id) {
    return $44a7722bc63ba98b$var$paymentProvidersMap[id];
}

});



parcelRegister("39pJ6", function(module, exports) {

var $7iilT = parcelRequire("7iilT");
module.exports = $7iilT("hcmyN").then(()=>parcelRequire('lTdbw'));

});

var $bb6bb1801ddeba50$exports = {};


(parcelRequire("jZ94Y")).register((parcelRequire("jyfjk")).getBundleURL('bf0Ja'), JSON.parse("[\"bf0Ja\",\"website.de42d0a3.js\",\"iyIBq\",\"SedestralRum.a4692ff8.js\",\"hcmyN\",\"stripe-js.7a15e489.js\"]"));

var $a32d25ff06603372$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a32d25ff06603372$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $a32d25ff06603372$exports));
try {
    regeneratorRuntime = $a32d25ff06603372$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a32d25ff06603372$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a32d25ff06603372$var$runtime);
}



var $nyKU9 = parcelRequire("nyKU9");

var $2aBLW = parcelRequire("2aBLW");

var $lrxLu = parcelRequire("lrxLu");

var $6pO1Y = parcelRequire("6pO1Y");

var $7AbeR = parcelRequire("7AbeR");

var $nyKU9 = parcelRequire("nyKU9");

var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");
class $d808f887fcf63765$export$f650c34b939fcf30 {
    static async init() {
        var _window_location_pathname;
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["ssr"] = this;
        this.ssrPath = (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.endsWith("sedestral.ssr");
    }
    static hasSsr() {
        return this.ssrPath;
    }
    static async awaitProcessing() {
        await this.awaitRequests();
        let promises = (0, $nyKU9.SedestralMachine).promises.filter((promise)=>promise.displayRequired);
        if (promises.length > 0) await Promise.all(promises.map((promise)=>promise.promise));
    }
    static async awaitRequests() {
        let request = await this.awaitRequest();
        if (request) return await this.awaitRequests();
    }
    static async awaitRequest() {
        return (0, $nyKU9.SedestralMachine).promise((resolve)=>{
            let origOpen = XMLHttpRequest.prototype.open;
            let timeOut = setTimeout(()=>{
                resolve(false);
            });
            XMLHttpRequest.prototype.open = function() {
                this.addEventListener('load', function() {
                    resolve(true);
                });
                clearTimeout(timeOut);
                origOpen.apply(this, arguments);
                XMLHttpRequest.prototype.open = origOpen;
            };
        });
    }
    /**
     * SSR
     */ static async renderPageSsr(path) {
        document.body.className = "";
        await (0, $7AbeR.Network).router.pages.reload(path);
        await this.awaitProcessing();
        await (0, $nyKU9.SedestralMachine).sleep(1);
        if ((0, $7AbeR.Network).router.static.components.loader) (0, $7AbeR.Network).router.static.components.loader.displayShow();
        document.body.className += "ssrPageReady";
    }
    static getRoutesSsr() {
        if ((0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).BLOG) || (0, $7AbeR.Network).productName === (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).HELPCENTER)) return (0, $5FliW.Resources).languages.flatMap((language)=>[
                "/" + language + "/home"
            ]).join(",");
        return (0, $5FliW.Resources).languages.flatMap((language)=>{
            return Object.keys((0, $7AbeR.Network).router.pages.pages).map((route)=>"/" + language + route);
        }).join(",");
    }
}



var $1wiPK = parcelRequire("1wiPK");
class $805fc3389134ffba$export$d1af847c14d84dee {
    static async init() {
        await Promise.all([
            (0, $6pO1Y.SedestralDebugger).init(),
            (0, $nyKU9.SedestralMachine).init(),
            (0, $2aBLW.SedestralInterface).init(),
            (0, $lrxLu.SedestralMemory).init(),
            (0, $1wiPK.SedestralStorage).init(),
            (0, $d808f887fcf63765$export$f650c34b939fcf30).init()
        ]);
    }
    static ready(callback) {
        if (document.readyState !== 'loading') callback();
        else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
        else // @ts-ignore
        document.attachEvent('onreadystatechange', ()=>{
            if (document.readyState == 'complete') callback();
        });
    }
}



var $271MM = parcelRequire("271MM");

var $7AbeR = parcelRequire("7AbeR");


var $26ca5ec496cc3ef8$export$f32d71d2735e0373;
$26ca5ec496cc3ef8$export$f32d71d2735e0373 = "_7x5qp";



var $5FliW = parcelRequire("5FliW");

var $7AbeR = parcelRequire("7AbeR");

var $2aBLW = parcelRequire("2aBLW");

var $nyKU9 = parcelRequire("nyKU9");


var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");

var $7AbeR = parcelRequire("7AbeR");

var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");

var $1wiPK = parcelRequire("1wiPK");

var $nyKU9 = parcelRequire("nyKU9");

var $2aBLW = parcelRequire("2aBLW");
class $8aa3f9d3e6e9ea1a$export$6125f896890f3b30 {
    init() {
        this.currentPageDuration = 0;
    }
    setupActivityTracking() {
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') this.startTracking();
            else this.stopTracking();
        });
        if (document.visibilityState === 'visible') this.startTracking();
    }
    startTracking() {
        if (this.intervalId !== null) return;
        this.intervalId = setInterval(()=>{
            this.currentPageDuration++;
        }, 1000);
    }
    stopTracking() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    dispose() {
        this.stopTracking();
        this.currentPageDuration = 0;
    }
    constructor(){
        this.currentPageDuration = 0;
        this.intervalId = null;
        this.setupActivityTracking();
    }
}



var $4HMUz = parcelRequire("4HMUz");
class $2e9b64418990b65c$export$cffcd64a3cd48b50 {
    startPage() {
        this.currentPage = {
            duration: 0,
            endTime: 0,
            startTime: Date.now(),
            route: this.pages.getPath(),
            viewedPercentage: 0,
            actions: []
        };
        //duration
        this.activity.init();
        //scroll
        this.currentPageScroll = (0, $2aBLW.SedestralInterface).main.onScroll(()=>{
            let percentage = (0, $2aBLW.SedestralInterface).main.getScrollPercent();
            if (percentage > this.currentPage.viewedPercentage) this.currentPage.viewedPercentage = percentage;
        });
        //link
        this.currentPageLink = (0, $2aBLW.SedestralInterface).main.putListener(window, "click", (e)=>{
            let target = e.target;
            while(target != null && target.nodeName !== 'A')target = target.parentNode;
            if (target && target.nodeName === 'A') {
                if (!target.href.startsWith(this.baseUrl)) {
                    if (this.currentPage) this.currentPage.actions.push({
                        name: target.innerText,
                        value: target.href,
                        time: Date.now(),
                        type: "link"
                    });
                }
            }
        });
    }
    endPage() {
        if (this.currentPage) {
            this.currentPage.endTime = Date.now();
            this.currentPage.duration = this.activity.currentPageDuration;
            this.activity.dispose();
            (0, $nyKU9.SedestralMachine).removeListener(this.currentPageScroll);
            (0, $nyKU9.SedestralMachine).removeListener(this.currentPageLink);
            this.newPageFunc.forEach((value)=>value(this, this.currentPage));
        }
    }
    close() {
        this.endPage();
        this.closePageFunc.forEach((value)=>value(this));
    }
    onNewPage(func) {
        this.newPageFunc.push(func);
    }
    onClosePage(func) {
        this.closePageFunc.push(func);
    }
    constructor(pages){
        this.newPageFunc = [];
        this.closePageFunc = [];
        this.pages = pages;
        let frontId = (0, $1wiPK.SedestralStorage).getItem("fid");
        if (frontId == null) {
            frontId = (0, $4HMUz.randomUUID)().replaceAll("-", "");
            (0, $1wiPK.SedestralStorage).setItem("fid", frontId);
        }
        this.frontId = frontId;
        this.baseUrl = window.location.origin;
        this.referrer = document.referrer.startsWith(this.baseUrl) ? undefined : document.referrer;
        this.activity = new (0, $8aa3f9d3e6e9ea1a$export$6125f896890f3b30)();
        this.pages.onPopState(undefined, ()=>{
            this.endPage();
            this.startPage();
        });
        (0, $nyKU9.SedestralMachine).addListener(window, "beforeunload", ()=>this.close());
    }
}



var $6pO1Y = parcelRequire("6pO1Y");

var $55dRq = parcelRequire("55dRq");

var $ftoGP = parcelRequire("ftoGP");
class $6de89f4cc8348a7e$export$cd5a914b394b4ddc {
    /**
     * init
     */ init() {
        this.main.clear();
        this.intAHref();
        this.initPopState();
    }
    intAHref() {
        let globalFunc = (e)=>{
            let parents = (0, $55dRq.elementParents)(e.target);
            let elementA = e.target.tagName == "A" ? e.target : parents.find((value)=>value.tagName == "A");
            if (elementA) {
                let href = elementA.getAttribute("href");
                let target = elementA.getAttribute("target");
                let download = elementA.getAttribute("download");
                if (target == "_blank") e.stopPropagation();
                if (target !== "_blank" && download == undefined) {
                    try {
                        let url = new URL(href);
                        let x;
                        if (url.origin != "https://sedestral.com") window.open(url);
                        href = href.replace(url.origin, "");
                        if (href == "") href = this.pathLogin;
                    } catch (ignored) {}
                    e.preventDefault();
                    if (elementA.getAttribute("click") == undefined && elementA.getAttribute("data-click") == undefined) this.setPath(href);
                }
            }
        };
        (0, $nyKU9.SedestralMachine).addListener(document, 'click', globalFunc, true);
    }
    initPopState() {
        window.onpopstate = async ()=>{
            this.isOnPopState = true;
            await this.execute(this.getPath());
        };
        this.setPath(this.getPath());
    }
    /**
     * pages
     */ async getPage(path) {
        path = path.startsWith("/") ? path.substring(1) : path;
        const segments = path.split("/");
        let page;
        for(let i = segments.length; i > 0; i--){
            const partialPath = "/" + segments.slice(0, i).join("/");
            if (this.pages[partialPath] !== undefined) {
                page = this.pagesInitialized[partialPath];
                if (page == undefined) {
                    this.pagePath = partialPath;
                    page = await this.pages[partialPath](partialPath);
                    this.pagesInitialized[partialPath] = page;
                }
                break;
            }
        }
        return page;
    }
    registerPage(name, component, componentMobile) {
        this.pages[name] = (0, $ftoGP.isMobile)() && componentMobile ? componentMobile : component;
    }
    // @ts-ignore
    async getDynamicPage(path) {}
    /**
     * language
     */ pathIsLanguage(path) {
        return this.languages.includes(path);
    }
    pathHasLanguage(path) {
        let firstPath = path.split("/").filter((value)=>value != "")[0];
        return this.pathIsLanguage(firstPath);
    }
    removeLanguageFromPath(path) {
        if (this.pathHasLanguage(path)) {
            let language = this.getLanguageFromPath(path);
            if (language) path = path.replace(`/${language}`, "");
        }
        return path;
    }
    getLanguageFromPath(path) {
        let firstPath = path.split("/").filter((value)=>value != "")[0];
        return this.pathIsLanguage(firstPath) ? firstPath : undefined;
    }
    addLanguageToPath(language, path) {
        return `/${language}` + path;
    }
    getLanguage() {
        let language = this.getLanguageFromPath(this.getPath());
        if (language && this.pathIsLanguage(language)) return language;
        return this.defaultLanguage;
    }
    setLanguage(language) {
        this.setPath(`/${language}${this.getPathWithoutLanguage()}`);
        window.location.reload();
    }
    /**
     * hash
     */ /**
     * Récupérer le hash actuel, sinon le hash de login si vide
     */ getPath() {
        let path = window.location.pathname;
        if (path == "/" || this.pathIsLanguage(path.replace("/", ""))) path = this.pathHome;
        return path;
    }
    getPathWithoutLanguage() {
        return this.removeLanguageFromPath(this.getPath());
    }
    async setPath(path) {
        if (!this.pathHasLanguage(path)) path = this.addLanguageToPath(this.getLanguage(), path);
        if (path != this.getPath()) {
            if (!this.isOnPopState) {
                if (!this.bufferHistoryPath) this.bufferHistoryPath = this.getPath();
                clearTimeout(this.bufferHistory);
                history.replaceState({}, '', path);
                this.bufferHistory = setTimeout(()=>{
                    history.replaceState({}, '', this.bufferHistoryPath);
                    history.pushState({}, '', path);
                    this.bufferHistoryPath = undefined;
                }, 500);
            }
            clearTimeout(this.bufferPopState);
            this.bufferPopState = setTimeout(()=>{
                this.isOnPopState = false;
            }, 500);
        }
        await this.execute(path);
    }
    async changePath(path) {
        let p = this.removeLanguageFromPath(path).substring(1);
        p = "/" + p.split("/")[0];
        let page = this.pagesInitialized[p];
        if (!page) page = this.page;
        if (page.constructor.name == this.page.constructor.name) {
            this.change = true;
            await this.setPath(path);
        } else await this.setPath(path);
    }
    /**
     * redirection
     */ async redirect(path, newTab) {
        if (newTab) window.open(path);
        else {
            path = path == "" || path == "/" ? this.pathHome : path;
            await this.setPath(path);
            window.scroll(0, 0);
        }
    }
    async reload(path) {
        this.onReload = true;
        await this.redirect(path !== null && path !== void 0 ? path : this.getPath());
    }
    /**
     * params
     */ getParams() {
        return (this.dynamicPath ? this.dynamicPath : this.getPath()).split("/");
    }
    getParam(name) {
        let hashes = this.getParams();
        for(let i = 0; i < hashes.length; i++)if (hashes[i] == name) {
            if (typeof hashes[i + 1] !== "undefined") return hashes[i + 1];
        }
        return undefined;
    }
    getParamAtIndex(index) {
        return this.getParams()[index];
    }
    hasParam(name) {
        let hashes = this.getPath().split("/");
        for(let i = 0; i < hashes.length; i++){
            if (hashes[i] == name) return true;
        }
        return false;
    }
    removeParams(names, noHash) {
        names.forEach((value)=>this.removeParam(value, noHash));
    }
    removeParam(name, noHash, forceBase) {
        if (this.hasParam(name)) {
            this.noOnHash = noHash;
            let currentParam = this.getParam(name);
            let hash = this.getPath().replace("/" + name + "/" + currentParam, "");
            if (forceBase) hash = hash.replace("/" + name, "");
            this.changePath(hash);
        }
    }
    removeParamAfter(paramName) {
        let params = (0, $7AbeR.Network).router.pages.getParams();
        for(let i = 0; i < params.length; i++){
            let baseIndex = params.indexOf(paramName);
            if (baseIndex >= 0) {
                if (i > baseIndex) {
                    if (params[i].length > 0) (0, $7AbeR.Network).router.pages.removeParam(params[i], true);
                }
            }
        }
    }
    setParams(params, noHash) {
        let hash = this.getPath();
        if (noHash) this.noOnHash = true;
        params.forEach((param)=>{
            if (param.value) hash = this.setParamUrl(hash, param.name, param.value, true);
            else hash = this.removeParamStr(hash, param.name);
        });
        this.changePath(hash);
    }
    setParam(name, value, preserve, noHash) {
        if (noHash) this.noOnHash = true;
        this.changePath(this.setParamUrl(this.getPath(), name, value, preserve));
    }
    setParamStr(path, name, value) {
        const regex = new RegExp(`/${name}/[^/]+`);
        if (path.match(regex)) return path.replace(regex, `/${name}/${value}`);
        else return `${path}/${name}/${value}`;
    }
    removeParamStr(path, name) {
        const regex = new RegExp(`/${name}/[^/]+`);
        return path.replace(regex, '');
    }
    hasParamStr(path, name) {
        const regex = new RegExp(`/${name}/[^/]+`);
        return regex.test(path);
    }
    /**
     * funcs
     */ onPopState(component, func, hash) {
        if (hash) {
            this.popStateHashFunctions.push(func);
            if (component) component.onRemove(()=>this.popStateHashFunctions.splice(this.popStateHashFunctions.indexOf(func), 1));
        } else {
            this.popStateFunctions.push(func);
            if (component) component.onRemove(()=>this.popStateFunctions.splice(this.popStateFunctions.indexOf(func), 1));
        }
    }
    /**
     * run
     */ async execute(path) {
        this.dynamicPath = undefined;
        if (!this.noOnHash) {
            path = this.removeLanguageFromPath(path);
            let page = await this.getPage(path);
            if (page == undefined) {
                page = await this.getDynamicPage(path);
                if (page == undefined) return this.redirect(this.path404);
            }
            if (!page.status.open) {
                if (page.status.open != undefined && page.status.online == true && !this.isOnline()) return this.redirect(this.pathLogin);
                if (path != this.path404 && page.status.online != undefined && page.status.online == false && this.isOnline()) return this.redirect(this.pathHome);
            }
            if (!this.change) {
                if (!this.onReload && page == this.page) {
                    page.onHash();
                    this.router.static.onHash();
                } else {
                    if (this.page !== undefined) {
                        this.page.remove();
                        (0, $2aBLW.SedestralInterface).main.clear();
                    }
                    this.page = page;
                    this.renderPage(page);
                    page.onHash();
                    this.router.static.onHash();
                    this.updatePageMeta(page);
                }
            } else {
                if (this.onReload || page != this.page) {
                    if (this.page != undefined) {
                        this.page.remove();
                        (0, $2aBLW.SedestralInterface).main.clear();
                    }
                    this.page = page;
                    this.renderPage(page);
                    this.updatePageMeta(page);
                }
                page.onHash();
                this.router.static.onHash();
            }
        }
        if (!this.noOnHash) this.popStateFunctions.forEach((value)=>value());
        else this.popStateHashFunctions.forEach((value)=>value());
        this.onReload = false;
        this.change = false;
        this.noOnHash = false;
    }
    renderPage(page) {
        var _SedestralDebugger_rum;
        let rum = (_SedestralDebugger_rum = (0, $6pO1Y.SedestralDebugger).rum) === null || _SedestralDebugger_rum === void 0 ? void 0 : _SedestralDebugger_rum.pageLoad();
        (0, $2aBLW.SedestralInterface).main.render(page);
        (0, $d808f887fcf63765$export$f650c34b939fcf30).awaitProcessing().then(()=>{
            rum === null || rum === void 0 ? void 0 : rum.end();
        });
        window.scroll(0, 0);
    }
    /**
     * logic
     */ updatePageMeta(page) {
        document.documentElement.lang = (0, $5FliW.Resources).language;
        document.title = page.title;
        this.updateMeta("robots", this.getRobots(page));
        this.updateMeta("og:locale", (0, $5FliW.Resources).language);
        this.updateMeta("og:title", page.title);
        this.updateMeta("twitter:title", page.title);
        this.updateMeta("name", page.title);
        this.updateMeta("description", page.description);
        this.updateMeta("og:description", page.description);
        this.updateMeta("twitter:description", page.description);
        this.updateMeta("keywords", page.keywords);
        this.updateMeta("image", page.image);
        this.updateMeta("og:image", page.image);
        this.updateMeta("twitter:image", page.image);
        this.updateMeta("og:url", page.ogUrl);
        this.updateMeta("og:site_name", page.ogSiteName);
        this.updateMeta("og:type", page.ogType);
        this.updateAlternateLinks(page.alternateLang);
        this.updateFavIcon(page.favicon);
    }
    updateMetasCommunity(community, isArticle, title, description, keywords, image, alternateLang) {
        var _community_logoFile, _community_faviconFile;
        var _community_text_metaTitle;
        this.page.title = title ? title : (_community_text_metaTitle = community.text.metaTitle) !== null && _community_text_metaTitle !== void 0 ? _community_text_metaTitle : (0, $5FliW.Resources).t("words.metas.title");
        var _community_text_metaTitle1;
        this.page.ogSiteName = (_community_text_metaTitle1 = community.text.metaTitle) !== null && _community_text_metaTitle1 !== void 0 ? _community_text_metaTitle1 : (0, $5FliW.Resources).t("words.metas.title");
        this.page.description = description ? description : community.text.metaDescription;
        this.page.keywords = keywords ? keywords.join(", ") : community.text.metaKeywords.join(", ");
        var _community_logoFile_link;
        this.page.image = image ? image.link : (_community_logoFile_link = (_community_logoFile = community.logoFile) === null || _community_logoFile === void 0 ? void 0 : _community_logoFile.link) !== null && _community_logoFile_link !== void 0 ? _community_logoFile_link : undefined;
        this.page.ogUrl = this.getCurrentUrlWithLang();
        this.page.favicon = community === null || community === void 0 ? void 0 : (_community_faviconFile = community.faviconFile) === null || _community_faviconFile === void 0 ? void 0 : _community_faviconFile.link;
        this.page.ogType = isArticle ? "article" : "website";
        if (!alternateLang) {
            alternateLang = new Map();
            community.languages.forEach((lang)=>{
                alternateLang.set(lang, this.getCurrentUrlWithLang(lang));
            });
        }
        this.page.alternateLang = alternateLang;
        this.updatePageMeta(this.page);
    }
    updateMeta(name, value) {
        const metas = document.querySelectorAll(`head meta[name="${name}"], head meta[itemprop="${name}"], head meta[property="${name}"]`);
        metas.forEach((meta)=>{
            meta.setAttribute('content', value !== null && value !== void 0 ? value : "");
        });
    }
    updateFavIcon(icon = (0, $7AbeR.Network).vendor + "images/favicon.png") {
        let link = document.querySelector('link[rel="icon"]');
        if (link) link.setAttribute('href', icon);
    }
    getUrlWithLang(lang) {
        return (0, $271MM.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $5FliW.Resources).language) + (0, $7AbeR.Network).router.pages.pagePath;
    }
    getCurrentUrlWithLang(lang) {
        return (0, $271MM.config).domain + "/" + (lang !== null && lang !== void 0 ? lang : (0, $5FliW.Resources).language) + location.pathname.replace(/^\/[a-z]{2}/i, '');
    }
    getUrlWithPath(path) {
        return (0, $271MM.config).domain + "/" + (0, $5FliW.Resources).language + "/" + path;
    }
    getPanelUrl(path) {
        return this.generateUrl("https://panel.sedestral.com", path);
    }
    getWebsiteUrl(path) {
        return this.generateUrl(undefined, path);
    }
    updateAlternateLinks(alternateLanguages) {
        // Supprimer tous les liens alternatifs existants
        document.querySelectorAll('link[rel="alternate"]').forEach((link)=>{
            var _link_parentNode;
            (_link_parentNode = link.parentNode) === null || _link_parentNode === void 0 ? void 0 : _link_parentNode.removeChild(link);
        });
        // Ajouter les nouveaux liens alternatifs
        alternateLanguages.forEach((url, lang)=>{
            this.updateAlternateLink(lang, url);
        });
        //Si aucun lien alternate, alors on place quand même l'url actuelle
        if (alternateLanguages.size == 0) this.updateAlternateLink((0, $5FliW.Resources).language, window.location.pathname);
    }
    /**
     * override
     */ isOnline() {
        return false;
    }
    isNoneSite() {
        return false;
    }
    setParamUrl(hash, name, value, preserve) {
        let finalHash;
        if (this.hasParam(name)) {
            let currentParam = this.getParam(name);
            let toReplace = name + (currentParam == undefined ? "" : "/" + currentParam);
            let replacement = name + "/" + value;
            finalHash = hash.replace(toReplace, replacement);
            let afters = finalHash.split(replacement);
            if (afters.length > 0) {
                if (!preserve) finalHash = finalHash.replace(afters[1], "");
            }
        } else finalHash = hash + "/" + name + "/" + value;
        return finalHash;
    }
    getRobots(page) {
        let noIndex = [
            "/helpcenter",
            "/service-client",
            "/inbox",
            "/mail",
            "/publisher",
            "/statistics",
            "/livechat"
        ];
        if (noIndex.includes(location.pathname.replace(/^\/[a-z]{2}/i, ''))) return "noindex";
        if (!(0, $271MM.config).isProd) return "noindex";
        if ((0, $7AbeR.Network).productName == (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).WEBSITE)) return "index";
        else return (0, $d808f887fcf63765$export$f650c34b939fcf30).hasSsr() || this.hasPathIndex() ? "index" : "noindex";
    }
    hasPathIndex() {
        const pathsToCheck = [
            "login",
            "signup",
            "password"
        ];
        return pathsToCheck.some((path)=>{
            var _window_location_pathname;
            return (_window_location_pathname = window.location.pathname) === null || _window_location_pathname === void 0 ? void 0 : _window_location_pathname.includes(path);
        });
    }
    updateAlternateLink(lang, url) {
        if (!url.startsWith('http')) url = (0, $271MM.config).domain + url;
        let link = document.createElement('link');
        link.rel = 'alternate';
        link.hreflang = lang;
        link.href = url;
        document.head.appendChild(link);
    }
    generateUrl(url, path) {
        if (path) return url + "/" + (0, $5FliW.Resources).language + "/" + path;
        else return url + "/" + (0, $5FliW.Resources).language;
    }
    constructor(router, languages, defaultLanguage){
        this.router = router;
        this.languages = languages !== null && languages !== void 0 ? languages : [
            (0, $5FliW.Resources).getDefaultLanguage()
        ];
        this.defaultLanguage = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $5FliW.Resources).getDefaultLanguage();
        this.main = (0, $2aBLW.SedestralInterface).main;
        this.pages = {};
        this.pagesInitialized = {};
        this.page = undefined;
        this.change = false;
        this.popStateFunctions = [];
        this.popStateHashFunctions = [];
        this.stats = new (0, $2e9b64418990b65c$export$cffcd64a3cd48b50)(this);
    }
}


class $62c946ea789d0779$export$81033b5937b7c31e {
    /**
     * get and set
     */ get components() {
        return this._components;
    }
    set components(value) {
        this._components = value;
    }
    register(name, component) {
        this._components[name] = component;
    }
    onHash() {
        for(let key in this._components)if (this._components.hasOwnProperty(key)) {
            let component = this._components[key];
            component.onHash();
        }
    }
    constructor(router){
        this._components = {};
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $68Z0d = parcelRequire("68Z0d");

var $2aBLW = parcelRequire("2aBLW");
class $4a9c7d750f35dc22$export$1a9aa230c91bad4e {
    get online() {
        return this._online;
    }
    set online(value) {
        this._online = value;
    }
    get open() {
        return this._open;
    }
    set open(value) {
        this._open = value;
    }
    constructor(){
        this._online = false;
        this._open = false;
    }
}



var $fsnB5 = parcelRequire("fsnB5");

var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $cbeb6df493e9dc90$export$c4dc9eeb28e63095 extends (0, $fsnB5.Component) {
    updateMetas(pageName) {
        const { title: title, description: description, keywords: keywords } = this.getPageData(pageName);
        this.title = title;
        this.description = description;
        this.keywords = keywords;
    }
    getTemplate() {
        this.init();
        return super.getTemplate();
    }
    destroy() {
        this.nullify();
        this.committed = false;
    }
    renderNoneSite() {}
    renderNoneRole() {}
    getPageData(pageName) {
        const keyPrefix = `pagesDatas.${pageName}.`;
        return {
            title: (0, $5FliW.Resources).t(`words.${keyPrefix}title`),
            description: (0, $5FliW.Resources).t(`words.${keyPrefix}description`),
            keywords: (0, $5FliW.Resources).exist(`words.${keyPrefix}keywords`) ? (0, $5FliW.Resources).t(`words.${keyPrefix}keywords`) : undefined
        };
    }
    constructor(){
        super();
        this.image = (0, $7AbeR.Network).vendor + "images/capture-blog.webp";
        this.ogUrl = (0, $7AbeR.Network).router.pages.getUrlWithLang();
        this.ogSiteName = "Sedestral";
        this.ogType = "website";
        this.container = undefined;
        this.template = "<div>page</div>";
        this.status = new (0, $4a9c7d750f35dc22$export$1a9aa230c91bad4e)();
        let alternateLanguages = new Map();
        (0, $5FliW.Resources).languages.forEach((lang)=>{
            alternateLanguages.set(lang, (0, $7AbeR.Network).router.pages.getUrlWithLang(lang));
        });
        this.alternateLang = alternateLanguages;
    }
}


class $c3f396103eac9678$export$7f99477635901bdd extends (0, $cbeb6df493e9dc90$export$c4dc9eeb28e63095) {
    init() {
        //language=HTML
        console.log('finish');
        this.template = `
            <div class="ssrPageLoadReady"></div>`;
    }
    onHash() {}
    constructor(){
        super();
        this.title = "Sedestral SSR";
        this.status.online = false;
    }
}



var $1wiPK = parcelRequire("1wiPK");

var $5FliW = parcelRequire("5FliW");
class $e116fd09b7cc437c$export$d35034d02907e61a {
    /**
     * init
     */ init(config) {
        this.config = config;
    }
    initStarted() {
        var _this_config, _this_config1;
        this.pages = new (0, $6de89f4cc8348a7e$export$cd5a914b394b4ddc)(this, (_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.languages, (_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.defaultLanguage);
        this.static = new (0, $62c946ea789d0779$export$81033b5937b7c31e)(this);
        this.pages.isOnline = ()=>(0, $7AbeR.Network).logged;
        this.pages.isNoneSite = ()=>(0, $68Z0d.EntityService).activeSite == null;
        this.registerStatic();
        this.registerPages();
        this.registerSsr();
        this.static.components.loader.displayHide();
        this.pages.init();
        this.onStarted();
    }
    initNotStarted(errorComponent) {
        this.pages = new (0, $6de89f4cc8348a7e$export$cd5a914b394b4ddc)(this);
        this.static = new (0, $62c946ea789d0779$export$81033b5937b7c31e)(this);
        this.registerStatic();
        this.static.components.loader.displayHide();
        (0, $2aBLW.SedestralInterface).body.render(errorComponent);
    }
    /**
     * register
     */ registerStatic() {}
    registerPages() {}
    registerSsr() {
        this.pages.registerPage("/sedestral.ssr", ()=>new (0, $c3f396103eac9678$export$7f99477635901bdd)());
    }
    /**
     * import
     */ async importPage(func, product) {
        let key = "panelRouter" + product; //+ Date.now();
        if (Date.now() - 3600000 < new Date(parseInt((0, $1wiPK.SedestralStorage).getItem(key))).getTime()) product = undefined;
        else (0, $1wiPK.SedestralStorage).setItem(key, "" + Date.now());
        this.static.components.pageLoader.remove();
        clearTimeout(this.pageLoaderTimeout);
        this.static.components.pageLoader.product = product;
        this.static.components.pageLoader.init();
        let module = await func();
        if (product != undefined) this.pageLoaderTimeout = setTimeout(()=>{
            this.static.components.pageLoader.animateRemove();
        }, 2500);
        else this.static.components.pageLoader.remove();
        return module;
    }
    /**
     * language
     */ language(defaultLanguage) {
        let firstPath = window.location.pathname.split("/").filter((value)=>value != "")[0];
        if (this.languages.includes(firstPath)) return firstPath;
        if (this.pages && this.pages.defaultLanguage) return this.pages.defaultLanguage;
        var _ref;
        return (_ref = defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : (0, $5FliW.Resources).getBestLanguageCandidate(this.languages)) !== null && _ref !== void 0 ? _ref : (0, $5FliW.Resources).getDefaultLanguage();
    }
    /**
     * override
     */ onLogin() {}
    onLogout() {}
    onStarted() {}
    constructor(languages){
        this.languages = languages;
    }
}


var $b4573842ced37483$export$d160ab07b491fe06;
var $b4573842ced37483$export$e9396702b45dbab1;
var $b4573842ced37483$export$6f093cfa640b7166;
var $b4573842ced37483$export$bd0dc469391eee2c;
var $b4573842ced37483$export$fb184b623420d9be;
var $b4573842ced37483$export$6d59db4903f20f7d;
var $b4573842ced37483$export$14439f5cc10d722f;
var $b4573842ced37483$export$1ca1ec8b29a4ce27;
$b4573842ced37483$export$d160ab07b491fe06 = "d9hJK";
$b4573842ced37483$export$e9396702b45dbab1 = "Aoupu";
$b4573842ced37483$export$6f093cfa640b7166 = "GkPC8";
$b4573842ced37483$export$bd0dc469391eee2c = "_6TdY7";
$b4573842ced37483$export$fb184b623420d9be = "OdVCJ";
$b4573842ced37483$export$6d59db4903f20f7d = "E7EQ0";
$b4573842ced37483$export$14439f5cc10d722f = "hpI31";
$b4573842ced37483$export$1ca1ec8b29a4ce27 = "Emzq9";



var $5FliW = parcelRequire("5FliW");


var $fsnB5 = parcelRequire("fsnB5");
var $8ec3a74dbaa1aa7f$export$4e3eb2b5df8a6b94;
var $8ec3a74dbaa1aa7f$export$5fd5031fecdacec3;
var $8ec3a74dbaa1aa7f$export$6f093cfa640b7166;
var $8ec3a74dbaa1aa7f$export$a7db06668cad9adb;
var $8ec3a74dbaa1aa7f$export$34e0f9847d4c02dd;
var $8ec3a74dbaa1aa7f$export$14439f5cc10d722f;
var $8ec3a74dbaa1aa7f$export$fb184b623420d9be;
var $8ec3a74dbaa1aa7f$export$6d59db4903f20f7d;
var $8ec3a74dbaa1aa7f$export$827f4ee28efc37;
var $8ec3a74dbaa1aa7f$export$5afc6c8569fc1bd;
var $8ec3a74dbaa1aa7f$export$4ea799498ef4a755;
var $8ec3a74dbaa1aa7f$export$a8ff84c12d48cfa6;
var $8ec3a74dbaa1aa7f$export$f2120bbfa5450bd2;
var $8ec3a74dbaa1aa7f$export$3e523c77c1f23f8c;
var $8ec3a74dbaa1aa7f$export$185802fd694ee1f5;
var $8ec3a74dbaa1aa7f$export$a0973bcfe11b05c9;
var $8ec3a74dbaa1aa7f$export$4487c9d305171aae;
$8ec3a74dbaa1aa7f$export$4e3eb2b5df8a6b94 = "MdSsb";
$8ec3a74dbaa1aa7f$export$5fd5031fecdacec3 = "MpSeh";
$8ec3a74dbaa1aa7f$export$6f093cfa640b7166 = "bL0rY";
$8ec3a74dbaa1aa7f$export$a7db06668cad9adb = "tQc9T";
$8ec3a74dbaa1aa7f$export$34e0f9847d4c02dd = "joeNi";
$8ec3a74dbaa1aa7f$export$14439f5cc10d722f = "oIqL9";
$8ec3a74dbaa1aa7f$export$fb184b623420d9be = "_9DgBb";
$8ec3a74dbaa1aa7f$export$6d59db4903f20f7d = "_1XD06";
$8ec3a74dbaa1aa7f$export$827f4ee28efc37 = "D1aLr";
$8ec3a74dbaa1aa7f$export$5afc6c8569fc1bd = "MSWwh";
$8ec3a74dbaa1aa7f$export$4ea799498ef4a755 = "_7HNrv";
$8ec3a74dbaa1aa7f$export$a8ff84c12d48cfa6 = "_5kw27";
$8ec3a74dbaa1aa7f$export$f2120bbfa5450bd2 = "P1TmC";
$8ec3a74dbaa1aa7f$export$3e523c77c1f23f8c = "CcwDt";
$8ec3a74dbaa1aa7f$export$185802fd694ee1f5 = "sp6xN";
$8ec3a74dbaa1aa7f$export$a0973bcfe11b05c9 = "_4yS0g";
$8ec3a74dbaa1aa7f$export$4487c9d305171aae = "_7st3p";



var $fsnB5 = parcelRequire("fsnB5");
var $707b1b6618790d81$export$f4055a8322d74206;
var $707b1b6618790d81$export$2235f094b8d7361f;
var $707b1b6618790d81$export$bb628a54ab399bc9;
var $707b1b6618790d81$export$bb654e07daaf8c3a;
var $707b1b6618790d81$export$eb03490a10c3abc9;
$707b1b6618790d81$export$f4055a8322d74206 = "lN1gY";
$707b1b6618790d81$export$2235f094b8d7361f = "y48H6";
$707b1b6618790d81$export$bb628a54ab399bc9 = "ZeMux";
$707b1b6618790d81$export$bb654e07daaf8c3a = "-Yh7x";
$707b1b6618790d81$export$eb03490a10c3abc9 = "_8TQdO";


class $34e30a061648660e$export$8ed40a6e8d9e757d extends (0, $fsnB5.Component) {
    constructor(p){
        super();
        this.template = `
            <div loaderLight class="${$707b1b6618790d81$export$f4055a8322d74206}">
                <div class="${$707b1b6618790d81$export$2235f094b8d7361f}">
                    <svg style="${p && p.width ? `width:${p.width}px;height:${p.width}px;` : ``}" viewBox="0 0 50 50">
                        <circle style="${p && p.strokeWidth ? `stroke-width:${p.strokeWidth}px;` : ``}${p && p.strokeColor ? `stroke:${p.strokeColor};` : ``}" class="${$707b1b6618790d81$export$bb654e07daaf8c3a}" cx="25" cy="25" r="20" fill="none" stroke-width="2"/>
                    </svg>
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $d0c7a79d18898f88$export$30c9ebb4c11a4f0e;
var $d0c7a79d18898f88$export$827f4ee28efc37;
var $d0c7a79d18898f88$export$22275bc6362b2804;
var $d0c7a79d18898f88$export$a8ff84c12d48cfa6;
var $d0c7a79d18898f88$export$2077e0241d6afd3c;
var $d0c7a79d18898f88$export$1ca1ec8b29a4ce27;
var $d0c7a79d18898f88$export$1fb296bfdbc45c30;
var $d0c7a79d18898f88$export$de65de8213222d10;
var $d0c7a79d18898f88$export$add244bda2f9423c;
$d0c7a79d18898f88$export$30c9ebb4c11a4f0e = "M-u8I";
$d0c7a79d18898f88$export$827f4ee28efc37 = "_91Na6";
$d0c7a79d18898f88$export$22275bc6362b2804 = "RR1Lv";
$d0c7a79d18898f88$export$a8ff84c12d48cfa6 = "_2gJrE";
$d0c7a79d18898f88$export$2077e0241d6afd3c = "mKbbs";
$d0c7a79d18898f88$export$1ca1ec8b29a4ce27 = "-coP-";
$d0c7a79d18898f88$export$1fb296bfdbc45c30 = "j-rId";
$d0c7a79d18898f88$export$de65de8213222d10 = "_4t882";
$d0c7a79d18898f88$export$add244bda2f9423c = "wUbdo";



var $2aBLW = parcelRequire("2aBLW");

var $7AbeR = parcelRequire("7AbeR");

var $ftoGP = parcelRequire("ftoGP");

var $nyKU9 = parcelRequire("nyKU9");
class $d7fa30f5b69b40db$export$2a517e1cac1c1f85 extends (0, $fsnB5.Component) {
    commit() {
        this.visualModal = this.el($d0c7a79d18898f88$export$30c9ebb4c11a4f0e);
        this.headContainer = this.el($d0c7a79d18898f88$export$1fb296bfdbc45c30);
        this.boxContainer = this.el($d0c7a79d18898f88$export$827f4ee28efc37);
        this.nameContainer = this.el($d0c7a79d18898f88$export$a8ff84c12d48cfa6);
        this.contentContainer = this.el($d0c7a79d18898f88$export$add244bda2f9423c);
        this.closeButton = this.el($d0c7a79d18898f88$export$de65de8213222d10);
        this.nameContainer.setHtml(this.name);
        this.modalContainer = this.contentContainer.append(this.modalTemplate);
        this.boxContainer.onOutsideClick(()=>{
            if (!this.fixed && !this.fixedWithTitle) this.close();
        });
        this.closeButton.onClick(()=>{
            this.close();
        });
        if (this.modalStyle) this.boxContainer.setStyle(this.modalStyle);
        if (this.headMargin) this.headContainer.setStyle(`margin-bottom:15px;`);
        if (this.fixed) this.headContainer.remove();
        if (this.fixedWithTitle) {
            if (!(0, $ftoGP.isMobile)()) this.setStyle(`background: white;`);
            this.closeButton.remove();
            (0, $7AbeR.Network).router.pages.onPopState(this, ()=>this.close());
        }
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>this.resize());
        if (this.autoResize) this.onResize(()=>this.timeOut(()=>this.resize(), 50));
        this.animateOpen();
        super.commit();
    }
    resize() {
        let fullHeight = this.modalContainer.getHeightCalculated();
        if (this.modalHeight != fullHeight) {
            this.modalHeight = fullHeight;
            if (fullHeight + 60 > window.innerHeight) this.boxContainer.setStyle(`height: ${window.innerHeight - 80}px;`);
            else this.boxContainer.setStyle(`height:${fullHeight + 36}px`);
        }
    }
    async close() {
        await this.animateClose();
        this.onClose();
        if (!this.isNull()) this.remove();
    }
    screenRender() {
        (0, $2aBLW.SedestralInterface).body.render(this);
    }
    screenPreRender() {
        (0, $2aBLW.SedestralInterface).body.prerender(this);
    }
    excludeOutsideClickComponent(component) {
        this.boxContainer.excludeOutsideClickComponent(component);
    }
    /**
     * animate
     */ async animateOpen() {
        if ((0, $ftoGP.isMobile)()) {
            this.displayShow();
            this.boxContainer.setStyle(`transform:translateY(100%) scale(1);opacity:1;`);
            await this.boxContainer.translate({
                translateY: 0,
                delay: 250
            });
        } else {
            await this.boxContainer.scale(0.8, 1, 80);
            await this.boxContainer.fade("in", 100);
        }
        this.boxContainer.timeOut(()=>{
            this.boxContainer.setStyle("transform:unset;");
        }, 150);
    }
    async animateClose() {
        if ((0, $ftoGP.isMobile)()) await this.boxContainer.wait([
            this.boxContainer.translate({
                translateY: 150,
                delay: 80
            }),
            this.boxContainer.fade("out", 80),
            this.fade("out", 80)
        ]);
        else await this.boxContainer.wait([
            this.boxContainer.scale(1, 0.9, 50),
            this.boxContainer.fade("out", 80),
            this.fade("out", 80)
        ]);
    }
    /**
     * override
     */ onClose() {}
    constructor(){
        super();
        this.modalTemplate = `<div>template</div>`;
        this.modalStyle = "width:360px;";
        this.name = "name";
        this.template = `
            <div class="${$d0c7a79d18898f88$export$30c9ebb4c11a4f0e}">
                <div class="${$d0c7a79d18898f88$export$827f4ee28efc37}">
                    <div class="${$d0c7a79d18898f88$export$1fb296bfdbc45c30}">
                        <div class="${$d0c7a79d18898f88$export$a8ff84c12d48cfa6}"></div>
                        <div class="${$d0c7a79d18898f88$export$de65de8213222d10} ${$d0c7a79d18898f88$export$2077e0241d6afd3c}">
                            <div class="${$d0c7a79d18898f88$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </div>
                    <div class="${$d0c7a79d18898f88$export$add244bda2f9423c}"></div>
                </div>
            </div>
        `;
    }
}


var $524a62d1acfddf99$export$cb46c5951159e3af;
var $524a62d1acfddf99$export$fb184b623420d9be;
var $524a62d1acfddf99$export$3931a0da49df8dc0;
$524a62d1acfddf99$export$cb46c5951159e3af = "seOEH";
$524a62d1acfddf99$export$fb184b623420d9be = "skqkt";
$524a62d1acfddf99$export$3931a0da49df8dc0 = "SK6Wl";



var $fsnB5 = parcelRequire("fsnB5");
var $cba37490dea6b1ac$export$9973266709ea69b1;
var $cba37490dea6b1ac$export$5fd5031fecdacec3;
var $cba37490dea6b1ac$export$f2120bbfa5450bd2;
var $cba37490dea6b1ac$export$1ca1ec8b29a4ce27;
var $cba37490dea6b1ac$export$a8ff84c12d48cfa6;
$cba37490dea6b1ac$export$9973266709ea69b1 = "P1Qa3";
$cba37490dea6b1ac$export$5fd5031fecdacec3 = "vEpPs";
$cba37490dea6b1ac$export$f2120bbfa5450bd2 = "IGeX9";
$cba37490dea6b1ac$export$1ca1ec8b29a4ce27 = "vOA3l";
$cba37490dea6b1ac$export$a8ff84c12d48cfa6 = "_89DM9";


class $217eb7d0b4880dad$export$6e0ba5664525d2a0 extends (0, $fsnB5.Component) {
    commit() {
        this.initBase();
        this.initButtons();
        this.onCommit(()=>{
            this.height = this.getFullHeight();
            this.setStyle(`height:${this.height}px;`);
        });
        super.commit();
    }
    /**
     * logic
     */ initHead(name) {
        //language=HTML
        this.headContainer = this.append(`
            <div class="${$cba37490dea6b1ac$export$5fd5031fecdacec3}">
                <div class="${$cba37490dea6b1ac$export$f2120bbfa5450bd2}">
                    <div class="${$cba37490dea6b1ac$export$1ca1ec8b29a4ce27}"></div>
                </div>
                <div class="${$cba37490dea6b1ac$export$a8ff84c12d48cfa6}">
                    ${name}
                </div>
            </div>
        `);
        this.headContainer.el($cba37490dea6b1ac$export$f2120bbfa5450bd2).onClick(()=>this.resetBase());
    }
    initButton(btnClass, func, name) {
        this.el(btnClass).onClick(async ()=>{
            await this.translate({
                translateX: -(this.getWidth() / 2),
                opacity: 0,
                delay: 150
            });
            this.setStyle(`transform:translateX(${this.getWidth() / 2}px);transition-duration: 0s;`);
            this.clearAll();
            this.initHead(name);
            let component = func();
            this.render(component);
            this.translate({
                translateX: 0,
                height: component.getHeight() + this.headContainer.getHeight() + 30,
                opacity: 1,
                delay: 150
            });
        }, true);
    }
    /**
     * override
     */ initBase() {}
    initButtons() {}
    /**
     * reset
     */ async resetBase() {
        await this.translate({
            translateX: this.getWidth() / 2,
            height: this.height,
            opacity: 0,
            delay: 150
        });
        this.setStyle(`transform:translateX(${-(this.getWidth() / 2)}px);transition-duration: 0s;`);
        this.clearAll();
        this.initBase();
        this.translate({
            translateX: 0,
            opacity: 1,
            delay: 150
        });
        this.initButtons();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$cba37490dea6b1ac$export$9973266709ea69b1}"></div>
        `;
    }
}


var $150a72f146e28f6e$export$8efcc86333d6e64f;
var $150a72f146e28f6e$export$a8ff84c12d48cfa6;
var $150a72f146e28f6e$export$9c30223ca0a664fb;
var $150a72f146e28f6e$export$bbea856fdb3e3c5f;
$150a72f146e28f6e$export$8efcc86333d6e64f = "_3ZoNJ";
$150a72f146e28f6e$export$a8ff84c12d48cfa6 = "_0DLIZ";
$150a72f146e28f6e$export$9c30223ca0a664fb = "Yg6XI";
$150a72f146e28f6e$export$bbea856fdb3e3c5f = "_16y-3";




var $fsnB5 = parcelRequire("fsnB5");

var $11545b4cf2e272d1$export$b53266dac128743c;
var $11545b4cf2e272d1$export$c073df10e766abfa;
var $11545b4cf2e272d1$export$3a57bbc0fbe4b744;
var $11545b4cf2e272d1$export$4ededb8e5b56a6fb;
var $11545b4cf2e272d1$export$3cd3724d2f91e9d3;
$11545b4cf2e272d1$export$b53266dac128743c = "Lh6iX";
$11545b4cf2e272d1$export$c073df10e766abfa = "OdoUB";
$11545b4cf2e272d1$export$3a57bbc0fbe4b744 = "_8NIB-";
$11545b4cf2e272d1$export$4ededb8e5b56a6fb = "XlN05";
$11545b4cf2e272d1$export$3cd3724d2f91e9d3 = "uYb7g";



var $5FliW = parcelRequire("5FliW");
class $0d1af15bbe311e9e$export$f0c6024316437792 extends (0, $fsnB5.Component) {
    commit() {
        this.saveButton = this.el($11545b4cf2e272d1$export$3a57bbc0fbe4b744);
        this.cancelButton = this.el($11545b4cf2e272d1$export$4ededb8e5b56a6fb);
        this.saveButton.onClick(()=>{
            if (!this.saveButton.hasClass($11545b4cf2e272d1$export$3cd3724d2f91e9d3)) this.onSave();
        }, true);
        this.cancelButton.onClick(()=>{
            if (!this.cancelLoading) this.onCancel();
        }, true);
        if (this.settings) {
            if (this.settings.hideSaveButton) this.saveButton.remove();
            if (this.settings.hideCancelButton) this.cancelButton.remove();
        }
        super.commit();
    }
    /**
     * events
     */ onSave() {}
    onCancel() {}
    setCancelLoading() {
        this.cancelButton.save();
        this.cancelButton.setStyle(`padding:0;height:${this.cancelButton.getHeight()}px;width:${this.cancelButton.getWidth()}px;`);
        this.cancelButton.clear();
        this.cancelButton.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
        this.cancelLoading = true;
    }
    remCancelLoading() {
        if (this.cancelLoading) {
            this.cancelButton.restore();
            this.cancelLoading = true;
        }
    }
    setLoadingAndInactive() {
        this.setLoading();
        this.setInactive();
    }
    remLoadingAndInactive() {
        this.remLoading();
        this.removeInactive();
    }
    setLoading() {
        this.saveButton.save();
        this.saveButton.setStyle(`padding:0;height:${this.saveButton.getHeight()}px;width:${this.saveButton.getWidth()}px;`);
        this.saveButton.clear();
        this.saveButton.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
        this.saveLoading = true;
    }
    remLoading() {
        if (this.saveLoading) {
            this.saveButton.restore();
            this.saveLoading = false;
        }
    }
    setInactive() {
        this.saveButton.addClass($11545b4cf2e272d1$export$3cd3724d2f91e9d3);
    }
    removeInactive() {
        this.saveButton.removeClass($11545b4cf2e272d1$export$3cd3724d2f91e9d3);
    }
    isInactive() {
        return this.saveButton.hasClass($11545b4cf2e272d1$export$3cd3724d2f91e9d3);
    }
    constructor(settings){
        var _this_settings, _this_settings1;
        super();
        this.settings = settings;
        //language=HTML
        this.template = `
            <div btnSave class="${$11545b4cf2e272d1$export$b53266dac128743c} ${(settings === null || settings === void 0 ? void 0 : settings.themeBlack) ? $11545b4cf2e272d1$export$c073df10e766abfa : ``}">
                <div btnS class="${$11545b4cf2e272d1$export$3a57bbc0fbe4b744}">
                    ${((_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.saveText) ? this.settings.saveText : (0, $5FliW.Resources).t("words.save")}
                </div>
                <div btnC class="${$11545b4cf2e272d1$export$4ededb8e5b56a6fb}">
                    ${((_this_settings1 = this.settings) === null || _this_settings1 === void 0 ? void 0 : _this_settings1.cancelText) ? this.settings.cancelText : (0, $5FliW.Resources).t("words.cancel")}
                </div>
            </div>
        `;
    }
}



var $fdmdr = parcelRequire("fdmdr");

var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $a1b58c6f1e932935$export$64d4c812f849ef19 extends (0, $217eb7d0b4880dad$export$6e0ba5664525d2a0) {
    commit() {
        this.buttons.onSave = async ()=>{
            if (!this.buttons.saveLoading) {
                this.buttons.setLoading();
                let name = this.el($150a72f146e28f6e$export$a8ff84c12d48cfa6).getValue();
                if (name.length < 3) return this.error((0, $5FliW.Resources).t("words.workspaceNameTooShort"));
                let site = await (0, $fdmdr.SiteService).create(name, this);
                if (site) await (0, $fdmdr.SiteService).select(site.id, this);
                else this.buttons.remLoading();
            }
        };
        super.commit();
    }
    error(description) {
        (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.unableToContinue"), description, 8000);
        this.buttons.remLoading();
    }
    constructor(){
        super();
        this.buttons = new (0, $0d1af15bbe311e9e$export$f0c6024316437792)();
        //language=HTML
        this.template = `
            <div class="${$150a72f146e28f6e$export$8efcc86333d6e64f}">
                <input class="${$150a72f146e28f6e$export$a8ff84c12d48cfa6}" placeholder="${(0, $5FliW.Resources).t("words.workspaceName")}"/>
                <div class="${$150a72f146e28f6e$export$bbea856fdb3e3c5f}">
                    ${this.draw(this.buttons)}
                </div>
            </div>
        `;
    }
}


var $e07cefa27fe9e968$export$48edaaeba8b27219;
var $e07cefa27fe9e968$export$fb184b623420d9be;
var $e07cefa27fe9e968$export$b7e3ae3d7c15e42e;
var $e07cefa27fe9e968$export$bbea856fdb3e3c5f;
$e07cefa27fe9e968$export$48edaaeba8b27219 = "fVBBq";
$e07cefa27fe9e968$export$fb184b623420d9be = "ekyEZ";
$e07cefa27fe9e968$export$b7e3ae3d7c15e42e = "llCoa";
$e07cefa27fe9e968$export$bbea856fdb3e3c5f = "Jemon";





var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $fdmdr = parcelRequire("fdmdr");

var $jdUQG = parcelRequire("jdUQG");

var $kfkzw = parcelRequire("kfkzw");
class $82dd075fc824038c$export$dcb66d9e8650d51c {
    static init() {}
    static dispose() {
        this.invitations = (0, $i3Hbv.observable)([]);
    }
    /**
     * http
     */ static async findById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/invitation/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findBySite(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/invitation/site/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async use(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/invitation/use/${id}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async create(hours, maxUses, rolesIds, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/invitation", {
            hours: hours,
            maxUses: maxUses,
            rolesIds: rolesIds
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async delete(invitation, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/invitation/${invitation.id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.unStore(invitation);
            return true;
        }
        return false;
    }
    /**
     * store
     */ static storeAll(invitations) {
        for(let key in invitations)invitations[key] = this.store(invitations[key]);
        return (0, $2Y8XI.Services).storeAll(invitations);
    }
    static store(invitation) {
        invitation.site = (0, $fdmdr.SiteService).store(invitation.site);
        invitation.roles = (0, $jdUQG.RoleService).storeAll(invitation.roles);
        return (0, $2Y8XI.Services).store("id", this.invitations, invitation);
    }
    static unStore(invitation) {
        (0, $2Y8XI.Services).unStore("id", this.invitations, invitation);
    }
}
$82dd075fc824038c$export$dcb66d9e8650d51c.invitations = (0, $i3Hbv.observable)([]);



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $02b403c47521d4f4$export$bb3ce8ec10e1a90a extends (0, $217eb7d0b4880dad$export$6e0ba5664525d2a0) {
    commit() {
        this.buttons.onSave = async ()=>{
            let link = this.el($e07cefa27fe9e968$export$b7e3ae3d7c15e42e).getValue();
            if (!link.includes("invitation/i/")) return this.error();
            //http://localhost:1111/#/invitation/i/691a0513bc194cd2945e9716f24a44a9a21881e43a3b4916b50c47e6fa0c91e53893801b8b5a49f4a5bc7be953d5b8cx
            let invitationId = link.split("invitation/i/")[1];
            if (invitationId.length < 1) return this.error();
            this.buttons.setLoading();
            let invitation = await (0, $82dd075fc824038c$export$dcb66d9e8650d51c).findById(invitationId, this);
            if (invitation == undefined) return this.error();
            await (0, $7AbeR.Network).router.pages.redirect("/invitation/i/" + invitationId);
        };
        super.commit();
    }
    error() {
        (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.unableToContinue"), (0, $5FliW.Resources).t("words.invalidInvitationLink"), 8000);
        this.buttons.remLoading();
    }
    constructor(){
        super();
        this.buttons = new (0, $0d1af15bbe311e9e$export$f0c6024316437792)();
        //language=HTML
        this.template = `
            <div class="${$e07cefa27fe9e968$export$48edaaeba8b27219}">
                <input class="${$e07cefa27fe9e968$export$b7e3ae3d7c15e42e}" placeholder="${(0, $5FliW.Resources).t("words.invitationLink")}"/>
                <div class="${$e07cefa27fe9e968$export$bbea856fdb3e3c5f}">
                    ${this.draw(this.buttons)}
                </div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
var $b990c850337b1a22$exports = {};

$parcel$export($b990c850337b1a22$exports, "globalCase", function () { return $b990c850337b1a22$export$343854cb8c07b515; }, function (v) { return $b990c850337b1a22$export$343854cb8c07b515 = v; });
$parcel$export($b990c850337b1a22$exports, "case", function () { return $b990c850337b1a22$export$e850e66917a23e0f; }, function (v) { return $b990c850337b1a22$export$e850e66917a23e0f = v; });
$parcel$export($b990c850337b1a22$exports, "invitation", function () { return $b990c850337b1a22$export$fba01e68c459a9dd; }, function (v) { return $b990c850337b1a22$export$fba01e68c459a9dd = v; });
$parcel$export($b990c850337b1a22$exports, "icon", function () { return $b990c850337b1a22$export$1ca1ec8b29a4ce27; }, function (v) { return $b990c850337b1a22$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($b990c850337b1a22$exports, "create", function () { return $b990c850337b1a22$export$185802fd694ee1f5; }, function (v) { return $b990c850337b1a22$export$185802fd694ee1f5 = v; });
$parcel$export($b990c850337b1a22$exports, "articleBlank", function () { return $b990c850337b1a22$export$91888c26f50efce2; }, function (v) { return $b990c850337b1a22$export$91888c26f50efce2 = v; });
$parcel$export($b990c850337b1a22$exports, "articleAi", function () { return $b990c850337b1a22$export$60c7b865d28898e9; }, function (v) { return $b990c850337b1a22$export$60c7b865d28898e9 = v; });
$parcel$export($b990c850337b1a22$exports, "mini", function () { return $b990c850337b1a22$export$3cde769702d1be3a; }, function (v) { return $b990c850337b1a22$export$3cde769702d1be3a = v; });
$parcel$export($b990c850337b1a22$exports, "text", function () { return $b990c850337b1a22$export$6f093cfa640b7166; }, function (v) { return $b990c850337b1a22$export$6f093cfa640b7166 = v; });
$parcel$export($b990c850337b1a22$exports, "description", function () { return $b990c850337b1a22$export$6d59db4903f20f7d; }, function (v) { return $b990c850337b1a22$export$6d59db4903f20f7d = v; });
var $b990c850337b1a22$export$343854cb8c07b515;
var $b990c850337b1a22$export$e850e66917a23e0f;
var $b990c850337b1a22$export$fba01e68c459a9dd;
var $b990c850337b1a22$export$1ca1ec8b29a4ce27;
var $b990c850337b1a22$export$185802fd694ee1f5;
var $b990c850337b1a22$export$91888c26f50efce2;
var $b990c850337b1a22$export$60c7b865d28898e9;
var $b990c850337b1a22$export$3cde769702d1be3a;
var $b990c850337b1a22$export$6f093cfa640b7166;
var $b990c850337b1a22$export$6d59db4903f20f7d;
$b990c850337b1a22$export$343854cb8c07b515 = "gmTu0";
$b990c850337b1a22$export$e850e66917a23e0f = "rs-Ya";
$b990c850337b1a22$export$fba01e68c459a9dd = "zDvEK";
$b990c850337b1a22$export$1ca1ec8b29a4ce27 = "n-YCY";
$b990c850337b1a22$export$185802fd694ee1f5 = "cVNN-";
$b990c850337b1a22$export$91888c26f50efce2 = "wWdjm";
$b990c850337b1a22$export$60c7b865d28898e9 = "iKfs0";
$b990c850337b1a22$export$3cde769702d1be3a = "-UkJ-";
$b990c850337b1a22$export$6f093cfa640b7166 = "_8xlDx";
$b990c850337b1a22$export$6d59db4903f20f7d = "DHL-w";



var $fsnB5 = parcelRequire("fsnB5");

class $abaf9eb280706a16$export$487f8b75dbe0c048 extends (0, $fsnB5.Component) {
    commit() {
        this.entries.forEach((entry)=>{
            //language=HTML
            let caseComponent = this.append(`
                <div class="${$b990c850337b1a22$exports.case} ${entry.mini ? $b990c850337b1a22$exports.mini : ``} ${$b990c850337b1a22$exports[entry.id]} ${entry.id}">
                    <div class="${$b990c850337b1a22$exports.icon}"></div>
                    <div class="${$b990c850337b1a22$exports.text}">
                        ${entry.name}
                    </div>
                </div>
            `);
            if (entry.description) //language=HTML
            caseComponent.append(`
                    <div class="${$b990c850337b1a22$exports.description}">
                        ${entry.description}
                    </div>
                `);
            if (entry.click) caseComponent.onClick(()=>{
                caseComponent.clearAll();
                caseComponent.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
                entry.click();
            });
        });
        super.commit();
    }
    constructor(entries){
        super();
        this.entries = entries;
        //language=HTML
        this.template = `
            <div class="${$b990c850337b1a22$exports.globalCase}"></div>`;
    }
}


class $e6b23d3cbf8252bf$export$f0dd3d3d1b613563 extends (0, $217eb7d0b4880dad$export$6e0ba5664525d2a0) {
    initButtons() {
        this.initButton("create", ()=>new (0, $a1b58c6f1e932935$export$64d4c812f849ef19)(), (0, $5FliW.Resources).t("words.createSite"));
        this.initButton("invitation", ()=>new (0, $02b403c47521d4f4$export$bb3ce8ec10e1a90a)(), (0, $5FliW.Resources).t("words.joinSite"));
    }
    initBase() {
        //language=HTML
        this.append(`
            <div class="${$524a62d1acfddf99$export$cb46c5951159e3af}">
                <div class="${$524a62d1acfddf99$export$fb184b623420d9be}">
                    \u{1F3DB} ${(0, $5FliW.Resources).t("words.addWorkspace")}
                </div>
                <div class="${$524a62d1acfddf99$export$3931a0da49df8dc0}">
                    ${this.draw(new (0, $abaf9eb280706a16$export$487f8b75dbe0c048)([
            {
                name: (0, $5FliW.Resources).t("words.new"),
                id: "create"
            },
            {
                name: (0, $5FliW.Resources).t("words.invitation"),
                id: "invitation"
            }
        ]))}
                </div>
            </div>
        `);
    }
    constructor(){
        super();
    }
}


class $64e02850f29c68a2$export$f59adc86f55bf373 extends (0, $d7fa30f5b69b40db$export$2a517e1cac1c1f85) {
    commit() {
        super.commit();
    }
    constructor(){
        super();
        this.name = "";
        this.autoResize = true;
        this.modalTemplate = this.draw(new (0, $e6b23d3cbf8252bf$export$f0dd3d3d1b613563)());
    }
}



var $fdmdr = parcelRequire("fdmdr");


var $fsnB5 = parcelRequire("fsnB5");

var $fsnB5 = parcelRequire("fsnB5");
var $cdcf9298df1a7e84$export$8079ad1b16c50b33;
var $cdcf9298df1a7e84$export$4ea799498ef4a755;
var $cdcf9298df1a7e84$export$f3c22307ab7b1568;
var $cdcf9298df1a7e84$export$a7db06668cad9adb;
var $cdcf9298df1a7e84$export$a8ff84c12d48cfa6;
var $cdcf9298df1a7e84$export$6f093cfa640b7166;
var $cdcf9298df1a7e84$export$b96bb35bc88d6fa;
$cdcf9298df1a7e84$export$8079ad1b16c50b33 = "xqnPq";
$cdcf9298df1a7e84$export$4ea799498ef4a755 = "Inaak";
$cdcf9298df1a7e84$export$f3c22307ab7b1568 = "iEuXb";
$cdcf9298df1a7e84$export$a7db06668cad9adb = "mvy1a";
$cdcf9298df1a7e84$export$a8ff84c12d48cfa6 = "Nnb6i";
$cdcf9298df1a7e84$export$6f093cfa640b7166 = "SZXCH";
$cdcf9298df1a7e84$export$b96bb35bc88d6fa = "_1iX3r";



var $fsnB5 = parcelRequire("fsnB5");
var $51eabbbe828ad7a1$export$82e7c8e479f92dd4;
var $51eabbbe828ad7a1$export$63e82393dc8977bf;
var $51eabbbe828ad7a1$export$345c5736c8054f22;
var $51eabbbe828ad7a1$export$1ca1ec8b29a4ce27;
var $51eabbbe828ad7a1$export$4b5127edceda427d;
var $51eabbbe828ad7a1$export$3100efae45e879;
var $51eabbbe828ad7a1$export$6c0ec2aaaedda558;
var $51eabbbe828ad7a1$export$e5e25fbcc1f7affe;
var $51eabbbe828ad7a1$export$6193722c8094ee5f;
var $51eabbbe828ad7a1$export$7d4dd925a096c195;
var $51eabbbe828ad7a1$export$e0fa3e8e7ca66abf;
var $51eabbbe828ad7a1$export$564e4a74ab2e0db0;
var $51eabbbe828ad7a1$export$89da14300d534261;
var $51eabbbe828ad7a1$export$3cd3724d2f91e9d3;
var $51eabbbe828ad7a1$export$759d1803c860a44e;
var $51eabbbe828ad7a1$export$14073983b879be0b;
var $51eabbbe828ad7a1$export$df8a68e89d215ac9;
$51eabbbe828ad7a1$export$82e7c8e479f92dd4 = "VRZUP";
$51eabbbe828ad7a1$export$63e82393dc8977bf = "bHs6q";
$51eabbbe828ad7a1$export$345c5736c8054f22 = "aU1Zc";
$51eabbbe828ad7a1$export$1ca1ec8b29a4ce27 = "qIxIz";
$51eabbbe828ad7a1$export$4b5127edceda427d = "Zjhxj";
$51eabbbe828ad7a1$export$3100efae45e879 = "jMLMa";
$51eabbbe828ad7a1$export$6c0ec2aaaedda558 = "e6g5f";
$51eabbbe828ad7a1$export$e5e25fbcc1f7affe = "xEPse";
$51eabbbe828ad7a1$export$6193722c8094ee5f = "MTUPx";
$51eabbbe828ad7a1$export$7d4dd925a096c195 = "b9Y0T";
$51eabbbe828ad7a1$export$e0fa3e8e7ca66abf = "oqhiS";
$51eabbbe828ad7a1$export$564e4a74ab2e0db0 = "-n8LO";
$51eabbbe828ad7a1$export$89da14300d534261 = "fcekX";
$51eabbbe828ad7a1$export$3cd3724d2f91e9d3 = "BqQa-";
$51eabbbe828ad7a1$export$759d1803c860a44e = "Blnge";
$51eabbbe828ad7a1$export$14073983b879be0b = "bLqoW";
$51eabbbe828ad7a1$export$df8a68e89d215ac9 = "eOgwf";



var $g0YRJ = parcelRequire("g0YRJ");


var $bKmye = parcelRequire("bKmye");

var $dvTuK = parcelRequire("dvTuK");
class $1e2ae4e77c8a16bf$export$adff159d7a56dcf {
    static staticTemplate(avatar) {
        //language=HTML
        return `
            <div ${avatar.color != undefined ? `style="background-image:${avatar.color.color}"` : ``}
                 class="${$51eabbbe828ad7a1$export$82e7c8e479f92dd4}">
                ${this.imageTemplate(avatar)}
            </div>
        `;
    }
    static imageTemplate(avatar) {
        if (avatar.url != undefined) return this.urlTemplate(avatar);
        var _avatar_file_link;
        //language=HTML
        return `
            <div class="${$51eabbbe828ad7a1$export$63e82393dc8977bf}">
                ${avatar.file != undefined ? `<img class="${$51eabbbe828ad7a1$export$345c5736c8054f22}" src="${(_avatar_file_link = avatar.file.link) !== null && _avatar_file_link !== void 0 ? _avatar_file_link : (0, $bKmye.FileService).link(avatar.file)}" alt="avatar"/>` : this.iconDivTemplate(avatar)}
            </div>
        `;
    }
    static iconDivTemplate(avatar) {
        return `<div class="${$51eabbbe828ad7a1$export$1ca1ec8b29a4ce27} ${this.iconTemplate(avatar)}"></div>`;
    }
    static urlTemplate(avatar) {
        //language=HTML
        return `
            <div class="${$51eabbbe828ad7a1$export$63e82393dc8977bf}">
                <img width="100%" height="unset" class="${$51eabbbe828ad7a1$export$345c5736c8054f22}" src="${avatar.url}" alt="avatar"/>
            </div>
        `;
    }
    static iconTemplate(avatar) {
        switch(avatar.type){
            case (0, $dvTuK.AvatarType).ENTITY:
                return $51eabbbe828ad7a1$export$4b5127edceda427d;
            case (0, $dvTuK.AvatarType).ROLE:
                return $51eabbbe828ad7a1$export$3100efae45e879;
            case (0, $dvTuK.AvatarType).SITE:
                return $51eabbbe828ad7a1$export$6193722c8094ee5f;
            case (0, $dvTuK.AvatarType).SITE_CHANNEL:
                return $51eabbbe828ad7a1$export$7d4dd925a096c195;
            case (0, $dvTuK.AvatarType).BOT:
                return $51eabbbe828ad7a1$export$e0fa3e8e7ca66abf;
            case (0, $dvTuK.AvatarType).MAIL:
                return $51eabbbe828ad7a1$export$e5e25fbcc1f7affe;
            case (0, $dvTuK.AvatarType).HELP_CENTER:
                return $51eabbbe828ad7a1$export$6c0ec2aaaedda558;
        }
        return $51eabbbe828ad7a1$export$4b5127edceda427d;
    }
}


var $dbf3d2c5baa4e893$export$544ac6dc05ac737e = /*#__PURE__*/ function(AssignableType) {
    AssignableType[AssignableType["ACCOUNT"] = 1] = "ACCOUNT";
    AssignableType[AssignableType["ROLE"] = 2] = "ROLE";
    AssignableType[AssignableType["CONTACT"] = 3] = "CONTACT";
    AssignableType[AssignableType["MAIL"] = 4] = "MAIL";
    return AssignableType;
}({});



var $fsnB5 = parcelRequire("fsnB5");

var $kfkzw = parcelRequire("kfkzw");

var $bi5k0 = parcelRequire("bi5k0");

var $fsnB5 = parcelRequire("fsnB5");

var $bi5k0 = parcelRequire("bi5k0");
var $900c1f5da924e455$exports = {};

$parcel$export($900c1f5da924e455$exports, "componentCapsuleIcon", function () { return $900c1f5da924e455$export$64da90efda5e2a8f; }, function (v) { return $900c1f5da924e455$export$64da90efda5e2a8f = v; });
$parcel$export($900c1f5da924e455$exports, "inbox", function () { return $900c1f5da924e455$export$9c1acc30f900961c; }, function (v) { return $900c1f5da924e455$export$9c1acc30f900961c = v; });
$parcel$export($900c1f5da924e455$exports, "inboxGrey", function () { return $900c1f5da924e455$export$6008f82f189447c4; }, function (v) { return $900c1f5da924e455$export$6008f82f189447c4 = v; });
$parcel$export($900c1f5da924e455$exports, "admin", function () { return $900c1f5da924e455$export$7d0f136b730edfdf; }, function (v) { return $900c1f5da924e455$export$7d0f136b730edfdf = v; });
$parcel$export($900c1f5da924e455$exports, "sell", function () { return $900c1f5da924e455$export$e761f9e0703de895; }, function (v) { return $900c1f5da924e455$export$e761f9e0703de895 = v; });
$parcel$export($900c1f5da924e455$exports, "blog", function () { return $900c1f5da924e455$export$300b2c23f49a49cb; }, function (v) { return $900c1f5da924e455$export$300b2c23f49a49cb = v; });
$parcel$export($900c1f5da924e455$exports, "statistics", function () { return $900c1f5da924e455$export$9ebee87b1eb4e24e; }, function (v) { return $900c1f5da924e455$export$9ebee87b1eb4e24e = v; });
$parcel$export($900c1f5da924e455$exports, "channels", function () { return $900c1f5da924e455$export$9659c395d9de169e; }, function (v) { return $900c1f5da924e455$export$9659c395d9de169e = v; });
$parcel$export($900c1f5da924e455$exports, "clientService", function () { return $900c1f5da924e455$export$dd6fd28d4b3e1cb5; }, function (v) { return $900c1f5da924e455$export$dd6fd28d4b3e1cb5 = v; });
$parcel$export($900c1f5da924e455$exports, "publisher", function () { return $900c1f5da924e455$export$eb39f87c5509319c; }, function (v) { return $900c1f5da924e455$export$eb39f87c5509319c = v; });
$parcel$export($900c1f5da924e455$exports, "publisherGrey", function () { return $900c1f5da924e455$export$8924b6f929971904; }, function (v) { return $900c1f5da924e455$export$8924b6f929971904 = v; });
$parcel$export($900c1f5da924e455$exports, "contacts", function () { return $900c1f5da924e455$export$7f1a29bc3be2296e; }, function (v) { return $900c1f5da924e455$export$7f1a29bc3be2296e = v; });
$parcel$export($900c1f5da924e455$exports, "contactsGrey", function () { return $900c1f5da924e455$export$b85d51bb3a50ac09; }, function (v) { return $900c1f5da924e455$export$b85d51bb3a50ac09 = v; });
$parcel$export($900c1f5da924e455$exports, "chatBot", function () { return $900c1f5da924e455$export$c84166c64dfbd7ab; }, function (v) { return $900c1f5da924e455$export$c84166c64dfbd7ab = v; });
$parcel$export($900c1f5da924e455$exports, "mails", function () { return $900c1f5da924e455$export$de7df53586297632; }, function (v) { return $900c1f5da924e455$export$de7df53586297632 = v; });
$parcel$export($900c1f5da924e455$exports, "livechat", function () { return $900c1f5da924e455$export$17a8a1cb950cf89a; }, function (v) { return $900c1f5da924e455$export$17a8a1cb950cf89a = v; });
$parcel$export($900c1f5da924e455$exports, "engagement", function () { return $900c1f5da924e455$export$e1c03b54a682a141; }, function (v) { return $900c1f5da924e455$export$e1c03b54a682a141 = v; });
$parcel$export($900c1f5da924e455$exports, "advertising", function () { return $900c1f5da924e455$export$b195d7ba5a0a4b33; }, function (v) { return $900c1f5da924e455$export$b195d7ba5a0a4b33 = v; });
$parcel$export($900c1f5da924e455$exports, "mailling", function () { return $900c1f5da924e455$export$13055afe968066cb; }, function (v) { return $900c1f5da924e455$export$13055afe968066cb = v; });
$parcel$export($900c1f5da924e455$exports, "medias", function () { return $900c1f5da924e455$export$ccc39835abb5f24f; }, function (v) { return $900c1f5da924e455$export$ccc39835abb5f24f = v; });
$parcel$export($900c1f5da924e455$exports, "calendar", function () { return $900c1f5da924e455$export$56bbcdb8aca31149; }, function (v) { return $900c1f5da924e455$export$56bbcdb8aca31149 = v; });
$parcel$export($900c1f5da924e455$exports, "documents", function () { return $900c1f5da924e455$export$3260cc9ddc8b12d; }, function (v) { return $900c1f5da924e455$export$3260cc9ddc8b12d = v; });
$parcel$export($900c1f5da924e455$exports, "products", function () { return $900c1f5da924e455$export$b6aad051bad07f12; }, function (v) { return $900c1f5da924e455$export$b6aad051bad07f12 = v; });
$parcel$export($900c1f5da924e455$exports, "estimate", function () { return $900c1f5da924e455$export$9f3a0795ca2cc944; }, function (v) { return $900c1f5da924e455$export$9f3a0795ca2cc944 = v; });
$parcel$export($900c1f5da924e455$exports, "sedestral", function () { return $900c1f5da924e455$export$5218b6b8649290d3; }, function (v) { return $900c1f5da924e455$export$5218b6b8649290d3 = v; });
$parcel$export($900c1f5da924e455$exports, "general", function () { return $900c1f5da924e455$export$78b80bc2f5d4953a; }, function (v) { return $900c1f5da924e455$export$78b80bc2f5d4953a = v; });
$parcel$export($900c1f5da924e455$exports, "helpCenter", function () { return $900c1f5da924e455$export$6c0ec2aaaedda558; }, function (v) { return $900c1f5da924e455$export$6c0ec2aaaedda558 = v; });
$parcel$export($900c1f5da924e455$exports, "document", function () { return $900c1f5da924e455$export$5a7bfc01df82fcd1; }, function (v) { return $900c1f5da924e455$export$5a7bfc01df82fcd1 = v; });
var $900c1f5da924e455$export$64da90efda5e2a8f;
var $900c1f5da924e455$export$9c1acc30f900961c;
var $900c1f5da924e455$export$6008f82f189447c4;
var $900c1f5da924e455$export$7d0f136b730edfdf;
var $900c1f5da924e455$export$e761f9e0703de895;
var $900c1f5da924e455$export$300b2c23f49a49cb;
var $900c1f5da924e455$export$9ebee87b1eb4e24e;
var $900c1f5da924e455$export$9659c395d9de169e;
var $900c1f5da924e455$export$dd6fd28d4b3e1cb5;
var $900c1f5da924e455$export$eb39f87c5509319c;
var $900c1f5da924e455$export$8924b6f929971904;
var $900c1f5da924e455$export$7f1a29bc3be2296e;
var $900c1f5da924e455$export$b85d51bb3a50ac09;
var $900c1f5da924e455$export$c84166c64dfbd7ab;
var $900c1f5da924e455$export$de7df53586297632;
var $900c1f5da924e455$export$17a8a1cb950cf89a;
var $900c1f5da924e455$export$e1c03b54a682a141;
var $900c1f5da924e455$export$b195d7ba5a0a4b33;
var $900c1f5da924e455$export$13055afe968066cb;
var $900c1f5da924e455$export$ccc39835abb5f24f;
var $900c1f5da924e455$export$56bbcdb8aca31149;
var $900c1f5da924e455$export$3260cc9ddc8b12d;
var $900c1f5da924e455$export$b6aad051bad07f12;
var $900c1f5da924e455$export$9f3a0795ca2cc944;
var $900c1f5da924e455$export$5218b6b8649290d3;
var $900c1f5da924e455$export$78b80bc2f5d4953a;
var $900c1f5da924e455$export$6c0ec2aaaedda558;
var $900c1f5da924e455$export$5a7bfc01df82fcd1;
$900c1f5da924e455$export$64da90efda5e2a8f = "_8wXnX";
$900c1f5da924e455$export$9c1acc30f900961c = "_3666q";
$900c1f5da924e455$export$6008f82f189447c4 = "w9-CC";
$900c1f5da924e455$export$7d0f136b730edfdf = "C5aOO";
$900c1f5da924e455$export$e761f9e0703de895 = "IT55P";
$900c1f5da924e455$export$300b2c23f49a49cb = "PIrpP";
$900c1f5da924e455$export$9ebee87b1eb4e24e = "iUHNS";
$900c1f5da924e455$export$9659c395d9de169e = "VEt1c";
$900c1f5da924e455$export$dd6fd28d4b3e1cb5 = "_6V-hK";
$900c1f5da924e455$export$eb39f87c5509319c = "X2WtW";
$900c1f5da924e455$export$8924b6f929971904 = "N8plC";
$900c1f5da924e455$export$7f1a29bc3be2296e = "cw9eh";
$900c1f5da924e455$export$b85d51bb3a50ac09 = "JpkLN";
$900c1f5da924e455$export$c84166c64dfbd7ab = "Yw9YY";
$900c1f5da924e455$export$de7df53586297632 = "BVFrS";
$900c1f5da924e455$export$17a8a1cb950cf89a = "j-yl6";
$900c1f5da924e455$export$e1c03b54a682a141 = "kMETM";
$900c1f5da924e455$export$b195d7ba5a0a4b33 = "_2DevX";
$900c1f5da924e455$export$13055afe968066cb = "G8G4P";
$900c1f5da924e455$export$ccc39835abb5f24f = "-Hrqj";
$900c1f5da924e455$export$56bbcdb8aca31149 = "LdtAG";
$900c1f5da924e455$export$3260cc9ddc8b12d = "-ri-N";
$900c1f5da924e455$export$b6aad051bad07f12 = "_748by";
$900c1f5da924e455$export$9f3a0795ca2cc944 = "cHAKr";
$900c1f5da924e455$export$5218b6b8649290d3 = "RxvUN";
$900c1f5da924e455$export$78b80bc2f5d4953a = "mkZ4G";
$900c1f5da924e455$export$6c0ec2aaaedda558 = "lz-5-";
$900c1f5da924e455$export$5a7bfc01df82fcd1 = "vUyaI";


class $fe767b1a359bcd0c$export$eff4b1de68e1c259 extends (0, $fsnB5.Component) {
    constructor(product){
        super();
        //language=HTML
        this.template = `
            <div class="${$900c1f5da924e455$exports.componentCapsuleIcon} ${$900c1f5da924e455$exports[(0, $bi5k0.ProductName).toString(product)]}"></div>
        `;
    }
}


var $df672a3bf5a3884d$exports = {};

$parcel$export($df672a3bf5a3884d$exports, "componentCapsule", function () { return $df672a3bf5a3884d$export$3d5bac00ab4da99c; }, function (v) { return $df672a3bf5a3884d$export$3d5bac00ab4da99c = v; });
$parcel$export($df672a3bf5a3884d$exports, "icon", function () { return $df672a3bf5a3884d$export$1ca1ec8b29a4ce27; }, function (v) { return $df672a3bf5a3884d$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($df672a3bf5a3884d$exports, "soon", function () { return $df672a3bf5a3884d$export$7bfacca66fdbc2e1; }, function (v) { return $df672a3bf5a3884d$export$7bfacca66fdbc2e1 = v; });
$parcel$export($df672a3bf5a3884d$exports, "position", function () { return $df672a3bf5a3884d$export$5880b8b5730aff45; }, function (v) { return $df672a3bf5a3884d$export$5880b8b5730aff45 = v; });
$parcel$export($df672a3bf5a3884d$exports, "chatBot", function () { return $df672a3bf5a3884d$export$c84166c64dfbd7ab; }, function (v) { return $df672a3bf5a3884d$export$c84166c64dfbd7ab = v; });
$parcel$export($df672a3bf5a3884d$exports, "admin", function () { return $df672a3bf5a3884d$export$7d0f136b730edfdf; }, function (v) { return $df672a3bf5a3884d$export$7d0f136b730edfdf = v; });
$parcel$export($df672a3bf5a3884d$exports, "mails", function () { return $df672a3bf5a3884d$export$de7df53586297632; }, function (v) { return $df672a3bf5a3884d$export$de7df53586297632 = v; });
$parcel$export($df672a3bf5a3884d$exports, "clientService", function () { return $df672a3bf5a3884d$export$dd6fd28d4b3e1cb5; }, function (v) { return $df672a3bf5a3884d$export$dd6fd28d4b3e1cb5 = v; });
$parcel$export($df672a3bf5a3884d$exports, "livechat", function () { return $df672a3bf5a3884d$export$17a8a1cb950cf89a; }, function (v) { return $df672a3bf5a3884d$export$17a8a1cb950cf89a = v; });
$parcel$export($df672a3bf5a3884d$exports, "medias", function () { return $df672a3bf5a3884d$export$ccc39835abb5f24f; }, function (v) { return $df672a3bf5a3884d$export$ccc39835abb5f24f = v; });
$parcel$export($df672a3bf5a3884d$exports, "engagement", function () { return $df672a3bf5a3884d$export$e1c03b54a682a141; }, function (v) { return $df672a3bf5a3884d$export$e1c03b54a682a141 = v; });
$parcel$export($df672a3bf5a3884d$exports, "advertising", function () { return $df672a3bf5a3884d$export$b195d7ba5a0a4b33; }, function (v) { return $df672a3bf5a3884d$export$b195d7ba5a0a4b33 = v; });
$parcel$export($df672a3bf5a3884d$exports, "mailling", function () { return $df672a3bf5a3884d$export$13055afe968066cb; }, function (v) { return $df672a3bf5a3884d$export$13055afe968066cb = v; });
$parcel$export($df672a3bf5a3884d$exports, "calendar", function () { return $df672a3bf5a3884d$export$56bbcdb8aca31149; }, function (v) { return $df672a3bf5a3884d$export$56bbcdb8aca31149 = v; });
$parcel$export($df672a3bf5a3884d$exports, "documents", function () { return $df672a3bf5a3884d$export$3260cc9ddc8b12d; }, function (v) { return $df672a3bf5a3884d$export$3260cc9ddc8b12d = v; });
$parcel$export($df672a3bf5a3884d$exports, "products", function () { return $df672a3bf5a3884d$export$b6aad051bad07f12; }, function (v) { return $df672a3bf5a3884d$export$b6aad051bad07f12 = v; });
$parcel$export($df672a3bf5a3884d$exports, "estimate", function () { return $df672a3bf5a3884d$export$9f3a0795ca2cc944; }, function (v) { return $df672a3bf5a3884d$export$9f3a0795ca2cc944 = v; });
$parcel$export($df672a3bf5a3884d$exports, "contactsGrey", function () { return $df672a3bf5a3884d$export$b85d51bb3a50ac09; }, function (v) { return $df672a3bf5a3884d$export$b85d51bb3a50ac09 = v; });
$parcel$export($df672a3bf5a3884d$exports, "inboxGrey", function () { return $df672a3bf5a3884d$export$6008f82f189447c4; }, function (v) { return $df672a3bf5a3884d$export$6008f82f189447c4 = v; });
$parcel$export($df672a3bf5a3884d$exports, "publisherGrey", function () { return $df672a3bf5a3884d$export$8924b6f929971904; }, function (v) { return $df672a3bf5a3884d$export$8924b6f929971904 = v; });
$parcel$export($df672a3bf5a3884d$exports, "document", function () { return $df672a3bf5a3884d$export$5a7bfc01df82fcd1; }, function (v) { return $df672a3bf5a3884d$export$5a7bfc01df82fcd1 = v; });
$parcel$export($df672a3bf5a3884d$exports, "inbox", function () { return $df672a3bf5a3884d$export$9c1acc30f900961c; }, function (v) { return $df672a3bf5a3884d$export$9c1acc30f900961c = v; });
$parcel$export($df672a3bf5a3884d$exports, "statistics", function () { return $df672a3bf5a3884d$export$9ebee87b1eb4e24e; }, function (v) { return $df672a3bf5a3884d$export$9ebee87b1eb4e24e = v; });
$parcel$export($df672a3bf5a3884d$exports, "blog", function () { return $df672a3bf5a3884d$export$300b2c23f49a49cb; }, function (v) { return $df672a3bf5a3884d$export$300b2c23f49a49cb = v; });
$parcel$export($df672a3bf5a3884d$exports, "helpCenter", function () { return $df672a3bf5a3884d$export$6c0ec2aaaedda558; }, function (v) { return $df672a3bf5a3884d$export$6c0ec2aaaedda558 = v; });
$parcel$export($df672a3bf5a3884d$exports, "sell", function () { return $df672a3bf5a3884d$export$e761f9e0703de895; }, function (v) { return $df672a3bf5a3884d$export$e761f9e0703de895 = v; });
$parcel$export($df672a3bf5a3884d$exports, "publisher", function () { return $df672a3bf5a3884d$export$eb39f87c5509319c; }, function (v) { return $df672a3bf5a3884d$export$eb39f87c5509319c = v; });
$parcel$export($df672a3bf5a3884d$exports, "contacts", function () { return $df672a3bf5a3884d$export$7f1a29bc3be2296e; }, function (v) { return $df672a3bf5a3884d$export$7f1a29bc3be2296e = v; });
$parcel$export($df672a3bf5a3884d$exports, "sedestral", function () { return $df672a3bf5a3884d$export$5218b6b8649290d3; }, function (v) { return $df672a3bf5a3884d$export$5218b6b8649290d3 = v; });
$parcel$export($df672a3bf5a3884d$exports, "general", function () { return $df672a3bf5a3884d$export$78b80bc2f5d4953a; }, function (v) { return $df672a3bf5a3884d$export$78b80bc2f5d4953a = v; });
var $df672a3bf5a3884d$export$3d5bac00ab4da99c;
var $df672a3bf5a3884d$export$1ca1ec8b29a4ce27;
var $df672a3bf5a3884d$export$7bfacca66fdbc2e1;
var $df672a3bf5a3884d$export$5880b8b5730aff45;
var $df672a3bf5a3884d$export$c84166c64dfbd7ab;
var $df672a3bf5a3884d$export$7d0f136b730edfdf;
var $df672a3bf5a3884d$export$de7df53586297632;
var $df672a3bf5a3884d$export$dd6fd28d4b3e1cb5;
var $df672a3bf5a3884d$export$17a8a1cb950cf89a;
var $df672a3bf5a3884d$export$ccc39835abb5f24f;
var $df672a3bf5a3884d$export$e1c03b54a682a141;
var $df672a3bf5a3884d$export$b195d7ba5a0a4b33;
var $df672a3bf5a3884d$export$13055afe968066cb;
var $df672a3bf5a3884d$export$56bbcdb8aca31149;
var $df672a3bf5a3884d$export$3260cc9ddc8b12d;
var $df672a3bf5a3884d$export$b6aad051bad07f12;
var $df672a3bf5a3884d$export$9f3a0795ca2cc944;
var $df672a3bf5a3884d$export$b85d51bb3a50ac09;
var $df672a3bf5a3884d$export$6008f82f189447c4;
var $df672a3bf5a3884d$export$8924b6f929971904;
var $df672a3bf5a3884d$export$5a7bfc01df82fcd1;
var $df672a3bf5a3884d$export$9c1acc30f900961c;
var $df672a3bf5a3884d$export$9ebee87b1eb4e24e;
var $df672a3bf5a3884d$export$300b2c23f49a49cb;
var $df672a3bf5a3884d$export$6c0ec2aaaedda558;
var $df672a3bf5a3884d$export$e761f9e0703de895;
var $df672a3bf5a3884d$export$eb39f87c5509319c;
var $df672a3bf5a3884d$export$7f1a29bc3be2296e;
var $df672a3bf5a3884d$export$5218b6b8649290d3;
var $df672a3bf5a3884d$export$78b80bc2f5d4953a;
$df672a3bf5a3884d$export$3d5bac00ab4da99c = "Tt0wR";
$df672a3bf5a3884d$export$1ca1ec8b29a4ce27 = "HoMZO";
$df672a3bf5a3884d$export$7bfacca66fdbc2e1 = "Cbv0h";
$df672a3bf5a3884d$export$5880b8b5730aff45 = "Pw8r6";
$df672a3bf5a3884d$export$c84166c64dfbd7ab = "nKAd9";
$df672a3bf5a3884d$export$7d0f136b730edfdf = "tqGEO";
$df672a3bf5a3884d$export$de7df53586297632 = "R71fv";
$df672a3bf5a3884d$export$dd6fd28d4b3e1cb5 = "_9REBJ";
$df672a3bf5a3884d$export$17a8a1cb950cf89a = "_3S-uD";
$df672a3bf5a3884d$export$ccc39835abb5f24f = "d0uDN";
$df672a3bf5a3884d$export$e1c03b54a682a141 = "K3bc5";
$df672a3bf5a3884d$export$b195d7ba5a0a4b33 = "S8omn";
$df672a3bf5a3884d$export$13055afe968066cb = "Fw9WT";
$df672a3bf5a3884d$export$56bbcdb8aca31149 = "wZ-cV";
$df672a3bf5a3884d$export$3260cc9ddc8b12d = "eZksr";
$df672a3bf5a3884d$export$b6aad051bad07f12 = "_1l-33";
$df672a3bf5a3884d$export$9f3a0795ca2cc944 = "Hin-K";
$df672a3bf5a3884d$export$b85d51bb3a50ac09 = "Bbqm8";
$df672a3bf5a3884d$export$6008f82f189447c4 = "_144aY";
$df672a3bf5a3884d$export$8924b6f929971904 = "wUQcP";
$df672a3bf5a3884d$export$5a7bfc01df82fcd1 = "_-2It8";
$df672a3bf5a3884d$export$9c1acc30f900961c = "XWipe";
$df672a3bf5a3884d$export$9ebee87b1eb4e24e = "ifwk-";
$df672a3bf5a3884d$export$300b2c23f49a49cb = "bNX2C";
$df672a3bf5a3884d$export$6c0ec2aaaedda558 = "_5KAfU";
$df672a3bf5a3884d$export$e761f9e0703de895 = "vM-fJ";
$df672a3bf5a3884d$export$eb39f87c5509319c = "eaoid";
$df672a3bf5a3884d$export$7f1a29bc3be2296e = "_0hqmv";
$df672a3bf5a3884d$export$5218b6b8649290d3 = "s3pKw";
$df672a3bf5a3884d$export$78b80bc2f5d4953a = "-rKLq";



var $fsnB5 = parcelRequire("fsnB5");
var $fd2f243f2b56cf22$export$a01e695ac355f334;
$fd2f243f2b56cf22$export$a01e695ac355f334 = "_0D8ml";


class $f548e13bbb66b1ad$export$8049d12bcdeca35f extends (0, $fsnB5.Component) {
    commit() {
        this.onVisible(()=>this.setStyle(`font-size: ${this.getWidth() / 2.5}px;`));
        super.commit();
    }
    constructor(text, fill){
        super();
        //language=HTML
        this.template = `
            <div class="${$fd2f243f2b56cf22$export$a01e695ac355f334}" style="color:${fill};">
                ${text}
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $e44d13759b9e9405$export$5c3f85cf9710806e extends (0, $fsnB5.Component) {
    commit() {
        switch(this.productType){
            case (0, $kfkzw.ProductType).CALENDAR:
            case (0, $kfkzw.ProductType).ADVERTISING:
            case (0, $kfkzw.ProductType).CHAT_BOT:
            case (0, $kfkzw.ProductType).SELL:
            case (0, $kfkzw.ProductType).MAILLING:
            case (0, $kfkzw.ProductType).MEDIAS:
            case (0, $kfkzw.ProductType).ENGAGEMENT:
            case (0, $kfkzw.ProductType).ESTIMATE:
            case (0, $kfkzw.ProductType).DOCUMENTS:
            case (0, $kfkzw.ProductType).PRODUCTS:
                this.renderSoon();
                break;
        }
        super.commit();
    }
    renderSoon() {
        if (this.soon !== true) //language=HTML
        this.append(`
                <div class="${$df672a3bf5a3884d$exports.soon}">
                    <div class="${$df672a3bf5a3884d$exports.position}">
                        ${this.draw(new (0, $f548e13bbb66b1ad$export$8049d12bcdeca35f)((0, $5FliW.Resources).t("words.soon"), "white"))}
                    </div>
                </div>
            `);
    }
    constructor(type, soon){
        super();
        this.productType = type;
        this.soon = soon ? soon : false;
        let style = "";
        switch(type){
            case (0, $kfkzw.ProductType).SEDESTRAL:
            case (0, $kfkzw.ProductType).GENERAL:
                style = "width:50%;height:50%;";
                break;
            case (0, $kfkzw.ProductType).MAILS:
            case (0, $kfkzw.ProductType).CHAT_BOT:
            case (0, $kfkzw.ProductType).MAILLING:
            case (0, $kfkzw.ProductType).ENGAGEMENT:
                style = "width:46%;height:46%;";
                break;
            case (0, $kfkzw.ProductType).ADVERTISING:
            case (0, $kfkzw.ProductType).INBOX:
            case (0, $kfkzw.ProductType).MEDIAS:
                style = "width:42%;height:42%;";
                break;
        }
        //language=HTML
        this.template = `
            <div class="${$df672a3bf5a3884d$exports.componentCapsule} ${$df672a3bf5a3884d$exports[(0, $bi5k0.ProductName).toString(type)]}">
                <div style="${style}" class="${$df672a3bf5a3884d$exports.icon}">
                    ${this.draw(new (0, $fe767b1a359bcd0c$export$eff4b1de68e1c259)(type))}
                </div>
            </div>
        `;
    }
}



var $kfkzw = parcelRequire("kfkzw");

var $ftoGP = parcelRequire("ftoGP");
class $55502dda577b8e85$export$d9b0d60bf0a19302 extends (0, $fsnB5.Component) {
    commit() {
        super.commit();
        if (this.tooltipSettings != undefined) {
            let exec = ()=>{
                if (this.tooltipComponent == undefined) {
                    if (this.tooltipSettings.contentId != "virtualId") {
                        this.tooltipComponent = new this.tooltipSettings.componentClass(this, this.tooltipSettings.contentId);
                        this.tooltipComponent.create();
                        this.tooltipComponent.onDispose = ()=>this.tooltipComponent = undefined;
                    }
                }
            };
            if ((0, $ftoGP.isMobile)()) this.onClick(()=>exec());
            else this.onHover(()=>exec(), 300);
        }
        this.onReactiveObserve(()=>this.init());
    }
    init() {
        this.removeAttribute("style");
        if (this.avatar) {
            if (this.avatar && this.avatar.color != undefined) this.setStyle(`background-image:${this.avatar.color.color};background:${this.avatar.color.color}`);
            let template = (0, $1e2ae4e77c8a16bf$export$adff159d7a56dcf).imageTemplate(this.avatar);
            if (this.nameActiveModel) !this.avatar.file && this.avatar.color && this.nameActiveModel.name;
            if (this.activeModel) template += this.activeModel.active != undefined ? `<div class="${$51eabbbe828ad7a1$export$564e4a74ab2e0db0} ${(0, $g0YRJ.AvatarService).isActive(this.activeModel) ? $51eabbbe828ad7a1$export$89da14300d534261 : $51eabbbe828ad7a1$export$3cd3724d2f91e9d3}"></div>` : ``;
            this.setHtml(template);
            let avatarContainer = this.el($51eabbbe828ad7a1$export$345c5736c8054f22);
            if (!avatarContainer.isNull()) avatarContainer.addListener("error", ()=>{
                let template = (0, $1e2ae4e77c8a16bf$export$adff159d7a56dcf).iconDivTemplate(this.avatar);
                this.setHtml(template);
            });
        }
    }
    /**
     * active
     */ setActive(activeModel) {
        if (activeModel != undefined) {
            this.activeModel = activeModel;
            this.nameActiveModel = activeModel;
        }
        return this;
    }
    /**
     * name
     */ setName(activeModel) {
        this.nameActiveModel = activeModel;
        return this;
    }
    /**
     * type
     */ setType(assignableType) {
        //language=HTML
        let typeContainer = this.append(`
            <div class="${$51eabbbe828ad7a1$export$14073983b879be0b}"></div>`);
        if (assignableType == (0, $dbf3d2c5baa4e893$export$544ac6dc05ac737e).CONTACT) typeContainer.render(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).CONTACTS));
        else if (assignableType == (0, $dbf3d2c5baa4e893$export$544ac6dc05ac737e).MAIL) typeContainer.render(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).MAILS));
        else if (assignableType == (0, $dbf3d2c5baa4e893$export$544ac6dc05ac737e).ACCOUNT) typeContainer.append(`<div class="${$51eabbbe828ad7a1$export$df8a68e89d215ac9}">A</div>`);
    }
    constructor(avatar, tooltipSettings){
        super();
        this.tooltipSettings = tooltipSettings;
        this.avatar = avatar;
        //language=HTML
        this.template = `
            <div class="${$51eabbbe828ad7a1$export$82e7c8e479f92dd4}"></div>
        `;
    }
}


class $f4073a45215bdc88$export$bf256e9408857fc3 extends (0, $fsnB5.Component) {
    constructor(site, checked){
        super();
        //language=HTML
        this.template = `
            <div site class="${$cdcf9298df1a7e84$export$8079ad1b16c50b33}">
                <div class="${$cdcf9298df1a7e84$export$4ea799498ef4a755}">
                    ${this.draw(new (0, $55502dda577b8e85$export$d9b0d60bf0a19302)(site.avatar))}
                    ${site.notificationsCount > 0 ? `<div class="${$cdcf9298df1a7e84$export$f3c22307ab7b1568}">${site.notificationsCount}</div>` : ``}
                </div>
                <div class="${$cdcf9298df1a7e84$export$a7db06668cad9adb}">
                    <div class="${$cdcf9298df1a7e84$export$a8ff84c12d48cfa6}">
                        <div class="${$cdcf9298df1a7e84$export$6f093cfa640b7166}">
                            ${this.reactive(()=>site.name)}
                        </div>
                    </div>
                </div>
                ${checked ? `<div class="${$cdcf9298df1a7e84$export$b96bb35bc88d6fa}"></div>` : ``}
            </div>
        `;
    }
}


var $3e8d7bcc2ccfa68a$export$7935c8964bef1c2f;
$3e8d7bcc2ccfa68a$export$7935c8964bef1c2f = "CyXTF";



var $fdmdr = parcelRequire("fdmdr");

class $66745fa8ab60e33a$export$9cde866c69654769 extends (0, $fsnB5.Component) {
    async commit() {
        if (this.sites == undefined) {
            this.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
            this.sites = await (0, $fdmdr.SiteService).findMind(this);
            this.clearAll();
        }
        this.sites.forEach((site)=>{
            let component = new (0, $f4073a45215bdc88$export$bf256e9408857fc3)(site, this.checkedIds != undefined && this.checkedIds.includes(site.id));
            this.render(component);
            component.onClick(()=>this.onPick(site));
        });
        this.scrollable();
        super.commit();
    }
    /**
     * override
     */ onPick(site) {}
    constructor(sites, checkedIds){
        super();
        this.sites = sites;
        this.checkedIds = checkedIds;
        //language=HTML
        this.template = `
            <div class="${$3e8d7bcc2ccfa68a$export$7935c8964bef1c2f}"></div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $80806ef33f4e287d$export$e80bff15bbf26afe extends (0, $d7fa30f5b69b40db$export$2a517e1cac1c1f85) {
    constructor(sites, checkedIds){
        super();
        this.sites = sites;
        this.checkedIds = checkedIds;
        this.sitesComponent = new (0, $66745fa8ab60e33a$export$9cde866c69654769)(this.sites, this.checkedIds);
        this.name = (0, $5FliW.Resources).t("words.selectWorkspace");
        this.modalTemplate = this.draw(this.sitesComponent);
        this.autoResize = true;
    }
}



var $5FliW = parcelRequire("5FliW");


var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $fdmdr = parcelRequire("fdmdr");

var $7Aqrk = parcelRequire("7Aqrk");

var $5FliW = parcelRequire("5FliW");

var $68Z0d = parcelRequire("68Z0d");

var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $kfkzw = parcelRequire("kfkzw");
class $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1 {
    static dispose() {
        this.preferences = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * rest
     */ static async update(accountId, language, hourClock, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/preferences/update", {
            accountId: accountId,
            language: language,
            hourClock: hourClock
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1.store(request.data);
        return undefined;
    }
    static async updateNotifications(accountId, data, component) {
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).PANEL, `/account/preferences/notifications/${accountId}`, data, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1.store(request.data);
        return undefined;
    }
    /**
     * store
     */ static storeAll(preferences) {
        for(let key in preferences)preferences[key] = this.store(preferences[key]);
        return (0, $2Y8XI.Services).storeAll(preferences);
    }
    static store(preference) {
        if (preference != undefined) return (0, $2Y8XI.Services).store("accountId", this.preferences, preference);
    }
}
$1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1.preferences = (0, $i3Hbv.observable)([]);



var $kCcuA = parcelRequire("kCcuA");

var $kfkzw = parcelRequire("kfkzw");

var $2Y8XI = parcelRequire("2Y8XI");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $fcf1926ebea8d49d$export$cd69738ed1a42348 {
    static dispose() {
        this.products = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * store
     */ static storeAllObject(products) {
        if (products) {
            Object.keys(products).forEach((key)=>{
                products[key] = this.store(products[key]);
            });
            return products;
        }
    }
    static storeAll(products) {
        for(let key in products)products[key] = this.store(products[key]);
        return (0, $2Y8XI.Services).storeAll(products);
    }
    static store(product) {
        product = (0, $2Y8XI.Services).store("id", this.products, product);
        return product;
    }
}
$fcf1926ebea8d49d$export$cd69738ed1a42348.products = (0, $i3Hbv.observable)([]);


function $18de50c1cbef370b$export$cd10aaa149c5324c(url) {
    try {
        // Ajouter le préfixe 'http://' si l'URL ne commence pas par 'http://' ou 'https://'
        if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
        const parsedUrl = new URL(url);
        return parsedUrl.host;
    } catch (e) {
        console.error("Invalid URL:", e);
        return null;
    }
}
function $18de50c1cbef370b$export$e870aa252b9361ba(url) {
    try {
        // Décoder et extraire la dernière partie du chemin
        const lastRoute = decodeURIComponent(new URL(url).pathname).split('/').filter(Boolean).pop();
        if (!lastRoute) return '';
        const withoutExtension = lastRoute.replace(/\.[^/.]+$/, '');
        if (withoutExtension.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)) return '';
        if (!/[a-zA-Z]/.test(withoutExtension)) return '';
        return withoutExtension.replace(/[-_0-9]/g, ' ').trim().toLowerCase().replace(/\s+/g, ' ').substring(0, 200);
    } catch (error) {
        return '';
    }
}
function $18de50c1cbef370b$export$ecf541e09a511845(param) {
    try {
        const url = window.location.href;
        const regex = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
        const result = regex.exec(url);
        return result ? decodeURIComponent(result[1]) : null;
    } catch (error) {
        return null;
    }
}
function $18de50c1cbef370b$export$f1ee45924ce04785(param) {
    try {
        const url = window.location.href;
        const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)', 'i');
        // Si le paramètre n'existe pas dans l'URL, ne rien faire
        if (!regex.test(url)) return;
        let newUrl = url.replace(regex, (match, p1, p2, offset, string)=>{
            return string.charAt(offset - 1) === '?' ? '?' : '';
        });
        // Nettoyer les '&' ou '?' en double générés
        newUrl = newUrl.replace(/[?&]+$/, '');
        newUrl = newUrl.replace(/[?&]+(?=[#])/g, '');
        // Remplacer l'URL dans la barre d'adresse sans recharger la page
        window.history.replaceState(null, '', newUrl);
    } catch (error) {
        console.error('Error removing parameter:', error);
    }
}



var $nSXuR = parcelRequire("nSXuR");
class $c7f887b940cb52a2$export$8b2d45e406ebb5ab {
    static dispose() {}
    static init() {}
    /**
     * rest
     */ static async token() {
        try {
            if ((0, $18de50c1cbef370b$export$ecf541e09a511845)("transaction") != null) {
                if ((0, $68Z0d.EntityService).activeToken) {
                    (0, $68Z0d.EntityService).saveActiveToken = (0, $68Z0d.EntityService).activeToken;
                    (0, $68Z0d.EntityService).clearActiveToken();
                }
            }
            let tokenRequest = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/session/token");
            if (tokenRequest.status != (0, $7ZaxO.HttpStatus).OK) return false;
            (0, $7AbeR.Network).logged = tokenRequest.data.online;
            (0, $68Z0d.EntityService).headersToken(tokenRequest.headers);
            //SiteColumnsContactService.storeStandard(tokenRequest.data.standardColumnsContacts);
            if ((0, $7AbeR.Network).logged) {
                (0, $nSXuR.ChannelService).storeAll(tokenRequest.data.channels);
                (0, $68Z0d.EntityService).activeOfferIsFailureToPay = tokenRequest.data.activeOfferIsFailureToPay;
                (0, $68Z0d.EntityService).activeOfferProducts = (0, $fcf1926ebea8d49d$export$cd69738ed1a42348).storeAllObject(tokenRequest.data.products);
                (0, $68Z0d.EntityService).activeEntity = (0, $7Aqrk.AccountService).store(tokenRequest.data.account);
                (0, $68Z0d.EntityService).activeEntity['preferences'] = (0, $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1).store(tokenRequest.data.preferences);
                (0, $68Z0d.EntityService).activeEntity['rolesAccount'] = (0, $kCcuA.RoleAccountService).storeAll(tokenRequest.data.rolesAccount);
                (0, $68Z0d.EntityService).activeSite = (0, $fdmdr.SiteService).store(tokenRequest.data.site);
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }
    static async login(mail, password, invitation, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: (0, $5FliW.Resources).t("words.wrongIdentifiers")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/session/login", {
            email: mail,
            password: password,
            invitationId: invitation == undefined ? undefined : invitation.id
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async logout(component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/session/logout", "", component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) await $c7f887b940cb52a2$export$8b2d45e406ebb5ab.createLogout();
    }
    static async connectionAccountAdmin(accountId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/account/session/admin/remplaceSession", {
            accountId: accountId,
            sessionId: (0, $68Z0d.EntityService).activeToken
        }, component);
        return (0, $7ZaxO.HttpStatus).OK == request.status;
    }
    /**
     * on events
     */ static async onLogin() {
        await (0, $fdmdr.SiteService).join((0, $68Z0d.EntityService).activeEntity.siteId);
    }
    static onLogout() {
        (0, $fdmdr.SiteService).leave((0, $68Z0d.EntityService).activeEntity.siteId);
    }
    static async createLogout() {
        (0, $7AbeR.Network).router.onLogout();
        await (0, $7AbeR.Network).onLogout();
        (0, $68Z0d.EntityService).clearActiveToken();
    }
}


class $fe687badf5a941a9$export$9635fd1ed971cc0d extends (0, $fsnB5.Component) {
    commit() {
        this.sitePickerContainer = this.el($8ec3a74dbaa1aa7f$export$5afc6c8569fc1bd);
        this.createContainer = this.el($8ec3a74dbaa1aa7f$export$185802fd694ee1f5);
        this.createContainer.onClick(()=>{
            let creator = new (0, $64e02850f29c68a2$export$f59adc86f55bf373)();
            this.render(creator);
        });
        let logoutButton = this.el($8ec3a74dbaa1aa7f$export$a0973bcfe11b05c9);
        let onLogout = false;
        logoutButton.onClick(async (e)=>{
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (!onLogout) {
                onLogout = true;
                logoutButton.save();
                logoutButton.clear();
                logoutButton.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
                await (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).logout(this);
            }
        }, true);
        this.renderSitePicker();
        super.commit();
    }
    async renderSitePicker() {
        let sites = await (0, $fdmdr.SiteService).findMind(this);
        this.sitePickerContainer.clearAll();
        if (!sites || sites.length == 0) this.sitePickerContainer.setHtml(`<span>${(0, $5FliW.Resources).t("words.noAffiliatedWorkspace")}</span>`);
        else {
            //language=HTML
            this.sitePickerContainer.append(`
                <div class="${$8ec3a74dbaa1aa7f$export$4ea799498ef4a755}">
                    ${this.sitePickerContainer.draw(new (0, $55502dda577b8e85$export$d9b0d60bf0a19302)(sites[0].avatar))}
                </div>
                <div class="${$8ec3a74dbaa1aa7f$export$a8ff84c12d48cfa6}">
                    ${this.sitePickerContainer.reactive(()=>sites[0].name)}
                </div>
                <div class="${$8ec3a74dbaa1aa7f$export$f2120bbfa5450bd2}"></div>
            `);
            this.sitePickerContainer.onClick(()=>{
                let modal = new (0, $80806ef33f4e287d$export$e80bff15bbf26afe)(sites);
                modal.sitesComponent.onPick = (site)=>{
                    modal.close();
                    this.sitePickerContainer.clearAll();
                    this.sitePickerContainer.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
                    (0, $fdmdr.SiteService).select(site.id, this);
                };
                this.render(modal);
            });
        }
    }
    constructor(permissions){
        super();
        //language=HTML
        this.template = `
            <div siteNone class="${$8ec3a74dbaa1aa7f$export$4e3eb2b5df8a6b94}">
                <div siteNoneHead class="${$8ec3a74dbaa1aa7f$export$5fd5031fecdacec3}">
                    <div class="${$8ec3a74dbaa1aa7f$export$6f093cfa640b7166}">
                        ${(0, $5FliW.Resources).t("words.sedestral")}
                    </div>
                </div>
                <div class="${$8ec3a74dbaa1aa7f$export$a7db06668cad9adb}">
                    <div class="${$8ec3a74dbaa1aa7f$export$34e0f9847d4c02dd}">
                        <div class="${$8ec3a74dbaa1aa7f$export$14439f5cc10d722f}"></div>
                        <div class="${$8ec3a74dbaa1aa7f$export$fb184b623420d9be}">
                            ${permissions ? (0, $5FliW.Resources).t("words.noPermission") : (0, $5FliW.Resources).t("words.noActiveWorkspace")}
                        </div>
                        <div class="${$8ec3a74dbaa1aa7f$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.mustHaveWorkspace")}
                        </div>
                        <div class="${$8ec3a74dbaa1aa7f$export$827f4ee28efc37}">
                            <div class="${$8ec3a74dbaa1aa7f$export$5afc6c8569fc1bd}">
                                ${this.draw(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)())}
                            </div>
                            <div class="${$8ec3a74dbaa1aa7f$export$3e523c77c1f23f8c}"></div>
                            <div class="${$8ec3a74dbaa1aa7f$export$185802fd694ee1f5}">
                                ${(0, $5FliW.Resources).t("words.addWorkspace")}
                            </div>
                            <div class="${$8ec3a74dbaa1aa7f$export$a0973bcfe11b05c9}">
                                ${(0, $5FliW.Resources).t("words.deconnexion")}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="${$8ec3a74dbaa1aa7f$export$4487c9d305171aae}"></div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $6ae9ea39439f1d38$export$221bcb11230b996e;
var $6ae9ea39439f1d38$export$34e0f9847d4c02dd;
var $6ae9ea39439f1d38$export$1ca1ec8b29a4ce27;
var $6ae9ea39439f1d38$export$6f093cfa640b7166;
var $6ae9ea39439f1d38$export$8f45430ccf837300;
var $6ae9ea39439f1d38$export$1e95b668f3b82d;
var $6ae9ea39439f1d38$export$35e9368ef982300f;
var $6ae9ea39439f1d38$export$101619b11a34a0bd;
var $6ae9ea39439f1d38$export$60e660859c376841;
var $6ae9ea39439f1d38$export$df838d0240c938cf;
var $6ae9ea39439f1d38$export$4f33f238a5c1ad77;
var $6ae9ea39439f1d38$export$7fe88b5920ffddd2;
var $6ae9ea39439f1d38$export$df7c425476ed4f2;
$6ae9ea39439f1d38$export$221bcb11230b996e = "_7zFcP";
$6ae9ea39439f1d38$export$34e0f9847d4c02dd = "TsvOz";
$6ae9ea39439f1d38$export$1ca1ec8b29a4ce27 = "uECWc";
$6ae9ea39439f1d38$export$6f093cfa640b7166 = "Wd5Gn";
$6ae9ea39439f1d38$export$8f45430ccf837300 = "pyth-";
$6ae9ea39439f1d38$export$1e95b668f3b82d = "_86Vex";
$6ae9ea39439f1d38$export$35e9368ef982300f = "_3dCRr";
$6ae9ea39439f1d38$export$101619b11a34a0bd = "-YW3H";
$6ae9ea39439f1d38$export$60e660859c376841 = "jsAhO";
$6ae9ea39439f1d38$export$df838d0240c938cf = "jmoai";
$6ae9ea39439f1d38$export$4f33f238a5c1ad77 = "iw0Py";
$6ae9ea39439f1d38$export$7fe88b5920ffddd2 = "xkme7";
$6ae9ea39439f1d38$export$df7c425476ed4f2 = "Ks-xm";



var $5FliW = parcelRequire("5FliW");
class $426287fa564c6079$export$a6f6f1cb6d6f034e extends (0, $fsnB5.Component) {
    constructor(text){
        super();
        //language=HTML
        this.template = `
            <div roleNone class="${$6ae9ea39439f1d38$export$221bcb11230b996e}">
                <div class="${$6ae9ea39439f1d38$export$8f45430ccf837300} ${$6ae9ea39439f1d38$export$1e95b668f3b82d}">
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$101619b11a34a0bd}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$60e660859c376841}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$df838d0240c938cf}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$4f33f238a5c1ad77}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$7fe88b5920ffddd2}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$df7c425476ed4f2}"></div>
                </div>

                <div class="${$6ae9ea39439f1d38$export$34e0f9847d4c02dd}">
                    <div class="${$6ae9ea39439f1d38$export$1ca1ec8b29a4ce27}"></div>
                    <div class="${$6ae9ea39439f1d38$export$6f093cfa640b7166}">
                        ${text == undefined ? (0, $5FliW.Resources).t("words.noPermission") : text}
                    </div>
                </div>
                <div class="${$6ae9ea39439f1d38$export$8f45430ccf837300}">
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$101619b11a34a0bd}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$60e660859c376841}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$df838d0240c938cf}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$4f33f238a5c1ad77}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$7fe88b5920ffddd2}"></div>
                    <div class="${$6ae9ea39439f1d38$export$35e9368ef982300f} ${$6ae9ea39439f1d38$export$df7c425476ed4f2}"></div>
                </div>
            </div>
        `;
    }
}


var $02c1d8df0a8a48da$export$523fb3936f49e028;
var $02c1d8df0a8a48da$export$4caf129a4f120781;
var $02c1d8df0a8a48da$export$eabcd2c8791e7bf4;
var $02c1d8df0a8a48da$export$acf4eaf431084f78;
var $02c1d8df0a8a48da$export$a8ff84c12d48cfa6;
var $02c1d8df0a8a48da$export$321c0b1a406de31f;
var $02c1d8df0a8a48da$export$79ffe56a765070d2;
var $02c1d8df0a8a48da$export$6f093cfa640b7166;
var $02c1d8df0a8a48da$export$2ba01fb71ed41cb6;
var $02c1d8df0a8a48da$export$a7db06668cad9adb;
var $02c1d8df0a8a48da$export$13e2de3c33d99539;
var $02c1d8df0a8a48da$export$5fd5031fecdacec3;
var $02c1d8df0a8a48da$export$351f93dff0fc1e76;
var $02c1d8df0a8a48da$export$5f68ff167dfc5831;
var $02c1d8df0a8a48da$export$75a30c72c46d1150;
var $02c1d8df0a8a48da$export$3280a108d7f81d56;
var $02c1d8df0a8a48da$export$7191e3a7048e77a9;
var $02c1d8df0a8a48da$export$aaf8edec33967047;
var $02c1d8df0a8a48da$export$e16d8520af44a096;
var $02c1d8df0a8a48da$export$564e4a74ab2e0db0;
var $02c1d8df0a8a48da$export$f25d54de1f4102d2;
$02c1d8df0a8a48da$export$523fb3936f49e028 = "e-HHS";
$02c1d8df0a8a48da$export$4caf129a4f120781 = "D8Wan";
$02c1d8df0a8a48da$export$eabcd2c8791e7bf4 = "_7g7Ks";
$02c1d8df0a8a48da$export$acf4eaf431084f78 = "_5nqUv";
$02c1d8df0a8a48da$export$a8ff84c12d48cfa6 = "oFaJ7";
$02c1d8df0a8a48da$export$321c0b1a406de31f = "WYl4r";
$02c1d8df0a8a48da$export$79ffe56a765070d2 = "_0L2Nh";
$02c1d8df0a8a48da$export$6f093cfa640b7166 = "IKCyP";
$02c1d8df0a8a48da$export$2ba01fb71ed41cb6 = "l7uch";
$02c1d8df0a8a48da$export$a7db06668cad9adb = "_0WZXB";
$02c1d8df0a8a48da$export$13e2de3c33d99539 = "m73Xi";
$02c1d8df0a8a48da$export$5fd5031fecdacec3 = "Zl448";
$02c1d8df0a8a48da$export$351f93dff0fc1e76 = "PFN-E";
$02c1d8df0a8a48da$export$5f68ff167dfc5831 = "Tn1fN";
$02c1d8df0a8a48da$export$75a30c72c46d1150 = "t2VMc";
$02c1d8df0a8a48da$export$3280a108d7f81d56 = "_8tyun";
$02c1d8df0a8a48da$export$7191e3a7048e77a9 = "LET9l";
$02c1d8df0a8a48da$export$aaf8edec33967047 = "XvKY6";
$02c1d8df0a8a48da$export$e16d8520af44a096 = "-al70";
$02c1d8df0a8a48da$export$564e4a74ab2e0db0 = "JpQtF";
$02c1d8df0a8a48da$export$f25d54de1f4102d2 = "Xq6l6";



var $fsnB5 = parcelRequire("fsnB5");
var $e50850232a3a82f1$export$c6d08212a1d61bc2;
var $e50850232a3a82f1$export$884c4fb92a8b1ea6;
var $e50850232a3a82f1$export$649ecc744817b5c7;
var $e50850232a3a82f1$export$eff34822f84c3a88;
$e50850232a3a82f1$export$c6d08212a1d61bc2 = "_4kuzS";
$e50850232a3a82f1$export$884c4fb92a8b1ea6 = "U-yIa";
$e50850232a3a82f1$export$649ecc744817b5c7 = "-LTPy";
$e50850232a3a82f1$export$eff34822f84c3a88 = "ikg9-";


var $ff6dc9ee572382e3$export$6516733363c4513e = /*#__PURE__*/ function(OfferProductTemplateType) {
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_FREE"] = 1] = "HELP_CENTER_FREE";
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_BASIC"] = 2] = "HELP_CENTER_BASIC";
    OfferProductTemplateType[OfferProductTemplateType["HELP_CENTER_AGENCY"] = 3] = "HELP_CENTER_AGENCY";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_FREE"] = 4] = "BLOG_FREE";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_BASIC"] = 5] = "BLOG_BASIC";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_PRO"] = 6] = "BLOG_PRO";
    OfferProductTemplateType[OfferProductTemplateType["INBOX"] = 7] = "INBOX";
    OfferProductTemplateType[OfferProductTemplateType["PUBLISHER"] = 8] = "PUBLISHER";
    OfferProductTemplateType[OfferProductTemplateType["CONTACTS"] = 9] = "CONTACTS";
    OfferProductTemplateType[OfferProductTemplateType["BLOG_ENTERPRISE"] = 10] = "BLOG_ENTERPRISE";
    return OfferProductTemplateType;
}({});


class $f49d8292e8bb8162$export$e11200deb10216e7 extends (0, $fsnB5.Component) {
    constructor(type){
        super();
        let cl = $e50850232a3a82f1$export$884c4fb92a8b1ea6;
        switch(type){
            case (0, $ff6dc9ee572382e3$export$6516733363c4513e).BLOG_BASIC:
                cl = $e50850232a3a82f1$export$884c4fb92a8b1ea6;
                break;
            case (0, $ff6dc9ee572382e3$export$6516733363c4513e).BLOG_PRO:
                cl = $e50850232a3a82f1$export$649ecc744817b5c7;
                break;
            case (0, $ff6dc9ee572382e3$export$6516733363c4513e).BLOG_ENTERPRISE:
                cl = $e50850232a3a82f1$export$eff34822f84c3a88;
                break;
        }
        //language=HTML
        this.template = `
            <div class="${$e50850232a3a82f1$export$c6d08212a1d61bc2} ${cl}"></div>
        `;
    }
}




var $fsnB5 = parcelRequire("fsnB5");
var $1fdd39807a87de14$export$77181601c038f22b;
var $1fdd39807a87de14$export$61f6990d5944375a;
var $1fdd39807a87de14$export$96ff94e0adb1d772;
var $1fdd39807a87de14$export$96e4b36520c26a2c;
var $1fdd39807a87de14$export$a7db06668cad9adb;
var $1fdd39807a87de14$export$321c0b1a406de31f;
var $1fdd39807a87de14$export$f4c5de44377d2946;
var $1fdd39807a87de14$export$1e95b668f3b82d;
var $1fdd39807a87de14$export$da0c8716dc13cd97;
var $1fdd39807a87de14$export$40e52e4cb633d77a;
var $1fdd39807a87de14$export$a8fc3402335b0b04;
var $1fdd39807a87de14$export$34e0f9847d4c02dd;
var $1fdd39807a87de14$export$d90250155de6d7e7;
var $1fdd39807a87de14$export$e29b1f3b2b6a7669;
var $1fdd39807a87de14$export$c99df9cf5e6bee9b;
var $1fdd39807a87de14$export$fb184b623420d9be;
var $1fdd39807a87de14$export$6b8103ff35a0f6fe;
var $1fdd39807a87de14$export$333eed13d25bd57;
$1fdd39807a87de14$export$77181601c038f22b = "XlFv1";
$1fdd39807a87de14$export$61f6990d5944375a = "cCXA8";
$1fdd39807a87de14$export$96ff94e0adb1d772 = "U1m8K";
$1fdd39807a87de14$export$96e4b36520c26a2c = "Oy7Bn";
$1fdd39807a87de14$export$a7db06668cad9adb = "_0MZGS";
$1fdd39807a87de14$export$321c0b1a406de31f = "uR2dm";
$1fdd39807a87de14$export$f4c5de44377d2946 = "Q9D5i";
$1fdd39807a87de14$export$1e95b668f3b82d = "sk6Ee";
$1fdd39807a87de14$export$da0c8716dc13cd97 = "V8CB3";
$1fdd39807a87de14$export$40e52e4cb633d77a = "JJztT";
$1fdd39807a87de14$export$a8fc3402335b0b04 = "pCHxs";
$1fdd39807a87de14$export$34e0f9847d4c02dd = "sUbOC";
$1fdd39807a87de14$export$d90250155de6d7e7 = "gP8z9";
$1fdd39807a87de14$export$e29b1f3b2b6a7669 = "UA1jT";
$1fdd39807a87de14$export$c99df9cf5e6bee9b = "qddhs";
$1fdd39807a87de14$export$fb184b623420d9be = "b9Ca-";
$1fdd39807a87de14$export$6b8103ff35a0f6fe = "SsI6m";
$1fdd39807a87de14$export$333eed13d25bd57 = "kj4UB";



var $fsnB5 = parcelRequire("fsnB5");
var $35fd842316b18391$export$fe72765e3e76693f;
var $35fd842316b18391$export$fb184b623420d9be;
var $35fd842316b18391$export$6e9570de354791bd;
var $35fd842316b18391$export$6788812c4e6611e6;
$35fd842316b18391$export$fe72765e3e76693f = "qc9Zu";
$35fd842316b18391$export$fb184b623420d9be = "IL033";
$35fd842316b18391$export$6e9570de354791bd = "CQODP";
$35fd842316b18391$export$6788812c4e6611e6 = "_5GN64";


class $bd33c90c0ceb36a8$export$48a3aac3632ef8 extends (0, $fsnB5.Component) {
    commit() {
        this.offersContainer = this.el($35fd842316b18391$export$6e9570de354791bd);
        this.contents.forEach((value)=>{
            this.offersContainer.append(`<li>${value}</li>`);
        });
        super.commit();
    }
    constructor(contents, text){
        super();
        this.contents = contents;
        //language=HTML
        this.template = `
            <div class="${$35fd842316b18391$export$fe72765e3e76693f}">
                ${text ? `<div class="${$35fd842316b18391$export$fb184b623420d9be}">${text}</div>` : ``}
                <ul class="${$35fd842316b18391$export$6e9570de354791bd}"></ul>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $e64b16c4af7f9116$export$32f66f1b48c85b65;
var $e64b16c4af7f9116$export$a8ff84c12d48cfa6;
var $e64b16c4af7f9116$export$58734539bbfa41a2;
var $e64b16c4af7f9116$export$2077e0241d6afd3c;
var $e64b16c4af7f9116$export$bb1a638da8ad190f;
var $e64b16c4af7f9116$export$1ca1ec8b29a4ce27;
var $e64b16c4af7f9116$export$f25d54de1f4102d2;
var $e64b16c4af7f9116$export$b7e3ae3d7c15e42e;
$e64b16c4af7f9116$export$32f66f1b48c85b65 = "EUyoY";
$e64b16c4af7f9116$export$a8ff84c12d48cfa6 = "mVkxk";
$e64b16c4af7f9116$export$58734539bbfa41a2 = "lvn7g";
$e64b16c4af7f9116$export$2077e0241d6afd3c = "_1tERG";
$e64b16c4af7f9116$export$bb1a638da8ad190f = "P5YuJ";
$e64b16c4af7f9116$export$1ca1ec8b29a4ce27 = "BXKYA";
$e64b16c4af7f9116$export$f25d54de1f4102d2 = "GWDS3";
$e64b16c4af7f9116$export$b7e3ae3d7c15e42e = "_4f7rU";



var $5FliW = parcelRequire("5FliW");

var $7AbeR = parcelRequire("7AbeR");
class $eff67f7dcb6c028b$export$3629cf1b14c0cc2b extends (0, $fsnB5.Component) {
    commit() {
        this.inputContainer = this.el($e64b16c4af7f9116$export$b7e3ae3d7c15e42e);
        this.lessButton = this.el($e64b16c4af7f9116$export$bb1a638da8ad190f);
        this.plusButton = this.el($e64b16c4af7f9116$export$f25d54de1f4102d2);
        this.lessButton.onClick(()=>this.lessGranularity());
        this.plusButton.onClick(()=>this.plusGranularity());
        super.commit();
    }
    plusGranularity() {
        if (this.bundle.maxOption == undefined || this.solutionCount() < this.bundle.maxOption) {
            this.value += this.solution.granularity;
            this.inputContainer.setText(this.value + "");
            this.onSolutionChange(this.solutionCount());
        } else (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.offerSolutionLimit"), undefined, 3000);
    }
    lessGranularity() {
        let value = this.value - this.solution.granularity;
        if (value >= this.solution.quantityInitial) {
            this.value = value;
            this.inputContainer.setText(this.value + "");
            this.onSolutionChange(this.solutionCount());
        }
    }
    setGranularity(count) {
        var _this_inputContainer;
        this.value = this.solution.quantityInitial + this.solution.granularity * count;
        (_this_inputContainer = this.inputContainer) === null || _this_inputContainer === void 0 ? void 0 : _this_inputContainer.setText(this.value + "");
    }
    solutionCount() {
        return this.solution.granularity > 0 ? Math.round((this.value - this.solution.quantityInitial) / this.solution.granularity) : Math.round(this.value - this.solution.quantityInitial);
    }
    onSolutionChange(count) {}
    constructor(bundle, solution){
        super();
        this.solution = solution;
        this.bundle = bundle;
        this.value = solution.quantityInitial;
        //language=HTML
        this.template = `
            <div class="${$e64b16c4af7f9116$export$32f66f1b48c85b65}">
                <div class="${$e64b16c4af7f9116$export$a8ff84c12d48cfa6}">
                    ${(0, $5FliW.Resources).t(`words.offerSolutionDescription${solution.type}`)}
                </div>
                <div class="${$e64b16c4af7f9116$export$58734539bbfa41a2}">
                    <div class="${$e64b16c4af7f9116$export$2077e0241d6afd3c} ${$e64b16c4af7f9116$export$bb1a638da8ad190f}">
                        <div class="${$e64b16c4af7f9116$export$1ca1ec8b29a4ce27}"></div>
                    </div>
                    <div class="${$e64b16c4af7f9116$export$b7e3ae3d7c15e42e}">${solution.quantityInitial}</div>
                    <div class="${$e64b16c4af7f9116$export$2077e0241d6afd3c} ${$e64b16c4af7f9116$export$f25d54de1f4102d2}">
                        <div class="${$e64b16c4af7f9116$export$1ca1ec8b29a4ce27}"></div>
                    </div>
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $e36a442fea511cdd$export$915c6aaf55728df8;
var $e36a442fea511cdd$export$e4b2ac9215619f8d;
var $e36a442fea511cdd$export$fb184b623420d9be;
var $e36a442fea511cdd$export$ee3212a4833dc722;
var $e36a442fea511cdd$export$321c0b1a406de31f;
var $e36a442fea511cdd$export$da0c8716dc13cd97;
var $e36a442fea511cdd$export$2ba01fb71ed41cb6;
var $e36a442fea511cdd$export$46c1c92549715335;
$e36a442fea511cdd$export$915c6aaf55728df8 = "yzXs-";
$e36a442fea511cdd$export$e4b2ac9215619f8d = "uMQLz";
$e36a442fea511cdd$export$fb184b623420d9be = "OWv0j";
$e36a442fea511cdd$export$ee3212a4833dc722 = "kb75t";
$e36a442fea511cdd$export$321c0b1a406de31f = "h4AwQ";
$e36a442fea511cdd$export$da0c8716dc13cd97 = "D-iwl";
$e36a442fea511cdd$export$2ba01fb71ed41cb6 = "tKSgY";
$e36a442fea511cdd$export$46c1c92549715335 = "_6MlXq";


var $7c9924087ecfb7dd$export$b7ac94010691eccd = /*#__PURE__*/ function(OfferPeriodType) {
    OfferPeriodType[OfferPeriodType["MONTHLY"] = 0] = "MONTHLY";
    OfferPeriodType[OfferPeriodType["ANNUAL"] = 1] = "ANNUAL";
    return OfferPeriodType;
}({});



var $5FliW = parcelRequire("5FliW");


var $5FliW = parcelRequire("5FliW");
function $d8dc22cce01f37a9$export$6349d151e019902e(priceCentimes, includedTax) {
    const priceEuros = priceCentimes / 100;
    const formattedPrice = priceEuros.toFixed(2);
    const tax = includedTax == undefined ? "" : includedTax == true ? " " + (0, $5FliW.Resources).t("words.offerIncludeTax") : " " + (0, $5FliW.Resources).t("words.offerExcludeTax");
    if (formattedPrice.endsWith("00")) return formattedPrice.substring(0, formattedPrice.length - 3) + "\u20AC" + tax;
    return formattedPrice + "\u20AC" + tax;
}


class $cd4983a2f3152f9d$export$19746147d1b55543 extends (0, $fsnB5.Component) {
    commit() {
        this.button = this.el($e36a442fea511cdd$export$2ba01fb71ed41cb6);
        this.button.onClick(()=>{
            if (!this.button.hasClass($e36a442fea511cdd$export$46c1c92549715335)) this.onGetStarted();
        });
        super.commit();
    }
    setLoading() {
        this.remLoading();
        this.loader = new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)({
            strokeColor: "white"
        });
        this.button.addClass($e36a442fea511cdd$export$46c1c92549715335);
        this.button.render(this.loader);
    }
    remLoading() {
        if (this.loader) {
            this.loader.remove();
            this.loader = undefined;
        }
        this.button.removeClass($e36a442fea511cdd$export$46c1c92549715335);
    }
    onGetStarted() {
        this.setLoading();
    }
    constructor(p){
        super();
        this.period = p.period;
        this.price = p.price;
        if (!p.noCalculateYear && p.period.periodType == (0, $7c9924087ecfb7dd$export$b7ac94010691eccd).ANNUAL) this.price = (p.price - p.price * p.period.advantagePercentage) * 12;
        //language=HTML
        this.template = `
            <div class="${$e36a442fea511cdd$export$915c6aaf55728df8}">
                <div class="${$e36a442fea511cdd$export$e4b2ac9215619f8d}">
                    <div class="${$e36a442fea511cdd$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.offerTotalPrice")}
                    </div>
                    <div class="${$e36a442fea511cdd$export$ee3212a4833dc722}">
                        <span class="${$e36a442fea511cdd$export$321c0b1a406de31f}">${(0, $d8dc22cce01f37a9$export$6349d151e019902e)(this.price)}
                            ${!p.totalPrice ? (0, $5FliW.Resources).t("words.offerExcludeTax") : (0, $5FliW.Resources).t("words.offerIncludeTax")}</span>

                        ${p.totalPrice ? `` : `/<span
                            class="${$e36a442fea511cdd$export$da0c8716dc13cd97}">${(0, $5FliW.Resources).t(`words.offerPeriodTitle${this.period.periodType}`)}</span>`}
                    </div>
                </div>
                <div class="${$e36a442fea511cdd$export$2ba01fb71ed41cb6}">
                    ${p.text}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $91a6cde92bfc0adf$export$d3861ffa4af1796e;
var $91a6cde92bfc0adf$export$1e95b668f3b82d;
var $91a6cde92bfc0adf$export$40e543e69a8b3fbb;
$91a6cde92bfc0adf$export$d3861ffa4af1796e = "OEmeL";
$91a6cde92bfc0adf$export$1e95b668f3b82d = "Pc1iI";
$91a6cde92bfc0adf$export$40e543e69a8b3fbb = "StgcT";



var $fsnB5 = parcelRequire("fsnB5");
var $b25ec2e204dfea00$export$5533f3fa6fce9810;
var $b25ec2e204dfea00$export$8a5e915bd1d05fe0;
var $b25ec2e204dfea00$export$1158a42d67788fdd;
$b25ec2e204dfea00$export$5533f3fa6fce9810 = "FMZE3";
$b25ec2e204dfea00$export$8a5e915bd1d05fe0 = "lcPDH";
$b25ec2e204dfea00$export$1158a42d67788fdd = "e1j1C";


class $8ded8f90dcf72e04$export$225d33e6c7e4852d extends (0, $fsnB5.Component) {
    constructor(shine){
        super();
        //language=HTML
        this.template = `
            <div loaderBlock class="${$b25ec2e204dfea00$export$5533f3fa6fce9810} ${shine ? $b25ec2e204dfea00$export$8a5e915bd1d05fe0 : ``}">
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $090102e6239eba0f$export$8cb904089a919076;
var $090102e6239eba0f$export$8a5e915bd1d05fe0;
var $090102e6239eba0f$export$1158a42d67788fdd;
var $090102e6239eba0f$export$be5493f9613cbbe;
$090102e6239eba0f$export$8cb904089a919076 = "FWezv";
$090102e6239eba0f$export$8a5e915bd1d05fe0 = "FJOsh";
$090102e6239eba0f$export$1158a42d67788fdd = "MkV2y";
$090102e6239eba0f$export$be5493f9613cbbe = "Hs9sf";



var $8hCed = parcelRequire("8hCed");
class $cd5317ab87c4e8fc$export$766a040f1f31f2a9 extends (0, $fsnB5.Component) {
    object() {
        let height = (0, $8hCed.randomInteger)(this.minHeight == undefined ? 60 : this.minHeight, this.maxHeight ? this.maxHeight : 120);
        return `<div style="height: ${height}px;" class="${$090102e6239eba0f$export$be5493f9613cbbe}"></div>`;
    }
    constructor(shine, size, minHeight, maxHeight){
        super();
        this.minHeight = minHeight;
        this.maxHeight = maxHeight;
        if (typeof size == "undefined") size = 16;
        let objects = this.object();
        for(let i = 0; i < size; i++)objects += this.object();
        this.template = `
            <div loaderObjectList class="${$090102e6239eba0f$export$8cb904089a919076} ${shine ? $090102e6239eba0f$export$8a5e915bd1d05fe0 : ``}">
                ${objects}
            </div>
        `;
    }
}


class $1d10a4a39a7b3567$export$71a85bce14e8f1c5 extends (0, $fsnB5.Component) {
    constructor(shine){
        super();
        //language=HTML
        this.template = `
            <div class="${$91a6cde92bfc0adf$export$d3861ffa4af1796e}">
                <div class="${$91a6cde92bfc0adf$export$1e95b668f3b82d}">
                    ${this.draw(new (0, $cd5317ab87c4e8fc$export$766a040f1f31f2a9)(shine, 1, 40, 40))}
                </div>
                <div class="${$91a6cde92bfc0adf$export$40e543e69a8b3fbb}">
                    ${this.draw(new (0, $8ded8f90dcf72e04$export$225d33e6c7e4852d)(shine))}
                </div>
            </div>
        `;
    }
}



var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");
class $97d14140b155c27f$export$9b114977314e08a5 {
    static dispose() {
        this.templates = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    /**
     * store
     */ static storeAll(templates) {
        for(let key in templates)templates[key] = this.store(templates[key]);
        return (0, $2Y8XI.Services).storeAll(templates);
    }
    static store(template) {
        template = (0, $2Y8XI.Services).store("id", this.templates, template);
        return template;
    }
}
$97d14140b155c27f$export$9b114977314e08a5.templates = (0, $i3Hbv.observable)([]);



var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
var $2fe4e1e98a5ae575$export$d4c083ce95fb2409 = /*#__PURE__*/ function(OfferState) {
    OfferState[OfferState["CONFIRMED"] = 0] = "CONFIRMED";
    OfferState[OfferState["PAYMENT"] = 1] = "PAYMENT";
    OfferState[OfferState["SUSPENDED"] = 2] = "SUSPENDED";
    OfferState[OfferState["CLOSED"] = 3] = "CLOSED";
    OfferState[OfferState["SCHEDULED"] = 4] = "SCHEDULED";
    OfferState[OfferState["IN_PROGRESS"] = 5] = "IN_PROGRESS";
    OfferState[OfferState["FAILURE_TO_PAY"] = 6] = "FAILURE_TO_PAY";
    return OfferState;
}({});



var $68Z0d = parcelRequire("68Z0d");
var $377ed0589d754635$export$361763241a2a268d = /*#__PURE__*/ function(OfferProductLevel) {
    OfferProductLevel[OfferProductLevel["PREMIUM"] = 0] = "PREMIUM";
    OfferProductLevel[OfferProductLevel["FREE"] = 1] = "FREE";
    return OfferProductLevel;
}({});


class $6552c5473243fcef$export$a047eb6606b2561b {
    static dispose() {
        this.offers = (0, $i3Hbv.observable)([]);
    }
    static init() {}
    static async findAll(component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/templates`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let templates = request.data;
            Object.keys(templates.templates).forEach((value)=>{
                templates.templates[value] = (0, $97d14140b155c27f$export$9b114977314e08a5).store(templates.templates[value]);
            });
            return templates;
        }
    }
    static async active(displayPayment, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/active/${displayPayment}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async scheduled(component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/schedule`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async cancel(offerId, isCancel, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).TASK_IN_PROGRESS,
                message: (0, $5FliW.Resources).t("words.taskInProgressOnCurrentOffer")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_CANCELLED_EXPIRED,
                message: (0, $5FliW.Resources).t("words.offerCancelledExpired")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, `/offer/cancel/${offerId}/${isCancel}`, {}, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async getDateCancel(offerId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/cancel/estimateDate/${offerId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    //Récupérer le devis en cours quand tu actualises la page
    static async quote(component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/quote`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    //Créer un devis
    static async quoteSubscription(offerSubscription, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PROMOTION_CODE_INVALID,
                message: (0, $5FliW.Resources).t("words.promoCodeInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_ALREADY_EXISTS,
                message: (0, $5FliW.Resources).t("words.youAlreadyHaveAnOngoingQuote")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).ACTIVE_OFFER_IS_FAILURE_TO_PAY,
                message: (0, $5FliW.Resources).t("words.currentOfferPaymentDefault")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_SAME_OFFER_ACTIVE,
                message: (0, $5FliW.Resources).t("words.sameOfferConfiguration")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/offer/quote/subscription", offerSubscription, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async quoteCancel(component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).TASK_IN_PROGRESS,
                message: (0, $5FliW.Resources).t("words.taskInProgressOnCurrentOffer")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/offer/quote/cancel`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async quoteConfirmed(data, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).PROMOTION_CODE_INVALID,
                message: (0, $5FliW.Resources).t("words.promoCodeInvalid")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).ACTIVE_OFFER_IS_FAILURE_TO_PAY,
                message: (0, $5FliW.Resources).t("words.currentOfferPaymentDefault")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).TASK_IN_PROGRESS,
                message: (0, $5FliW.Resources).t("words.taskInProgressOnCurrentOffer")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, "/offer/quote/confirmed", data, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async deleteCb(component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).OFFER_ACTIVE_EXISTS,
                message: (0, $5FliW.Resources).t("words.cannotDeleteCardDueToActiveOffer")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.noCarError")
            }
        ]);
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).PANEL, `/offer/cb`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async getOfferPaymentSecrets(component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.cannotRetrievePaymentInfo")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.noBankCardRegistered")
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).PANEL, `/offer/cb/paymentSecret`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    //permissions
    static offerIsFree(type) {
        var _EntityService_activeOfferProducts_type;
        return ((_EntityService_activeOfferProducts_type = (0, $68Z0d.EntityService).activeOfferProducts[type]) === null || _EntityService_activeOfferProducts_type === void 0 ? void 0 : _EntityService_activeOfferProducts_type.level) == (0, $377ed0589d754635$export$361763241a2a268d).FREE;
    }
    /**
     * store
     */ static storeAll(offers) {
        for(let key in offers)offers[key] = this.store(offers[key]);
        return (0, $2Y8XI.Services).storeAll(offers);
    }
    static store(offer) {
        offer = (0, $2Y8XI.Services).store("id", this.offers, offer);
        return offer;
    }
    static isPaymentFailed(offerDetails) {
        return (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offer.state) == (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).FAILURE_TO_PAY || (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offer.state) == (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).SUSPENDED;
    }
}
$6552c5473243fcef$export$a047eb6606b2561b.offers = (0, $i3Hbv.observable)([]);



var $fsnB5 = parcelRequire("fsnB5");
var $ac5cc8914ebfc892$export$f3270842e3266d55;
var $ac5cc8914ebfc892$export$df8deae090c7c8ce;
var $ac5cc8914ebfc892$export$aea217a45095ce11;
var $ac5cc8914ebfc892$export$1ca1ec8b29a4ce27;
$ac5cc8914ebfc892$export$f3270842e3266d55 = "Ple9y";
$ac5cc8914ebfc892$export$df8deae090c7c8ce = "-BMvC";
$ac5cc8914ebfc892$export$aea217a45095ce11 = "vMVi1";
$ac5cc8914ebfc892$export$1ca1ec8b29a4ce27 = "NaNLE";



var $nyKU9 = parcelRequire("nyKU9");
class $b9e5a026e9385887$export$60ff82c3e26d6c1f extends (0, $fsnB5.Component) {
    commit() {
        this.selectorComponent = this.el($ac5cc8914ebfc892$export$aea217a45095ce11);
        for (let entry of this.entries){
            let entryComponent = this.append(`
                <div chEntry ${entry.title == undefined ? `` : `data-tooltip="${entry.title}"`} class="${$ac5cc8914ebfc892$export$df8deae090c7c8ce}">
                    ${entry.html}
                </div>
            `);
            entryComponent.onClick(()=>{
                this.select(entry.value);
            });
            entry.component = entryComponent;
        }
        this.currentValue = this.entries[0].value;
        if (this.selected != undefined) (0, $nyKU9.SedestralMachine).requestFrame()(()=>this.select(this.selected));
        super.commitTooltips();
        super.commit();
    }
    onSelect(value) {}
    select(value, noAnimation) {
        for (let entry of this.entries)if (entry.value == value) {
            let speed = noAnimation != undefined ? 10 : 200;
            this.selectorComponent.translate({
                moveLeft: entry.component.getParentOffsets().left,
                delay: speed
            });
            this.currentComponent = entry.component;
            this.currentValue = entry.value;
            this.onSelect(value);
        }
    }
    constructor(entries, selected){
        super();
        this.entries = entries;
        this.selected = selected;
        //language=HTML
        this.template = `
            <div chSliding class="${$ac5cc8914ebfc892$export$f3270842e3266d55}">
                <div chEntry class="${$ac5cc8914ebfc892$export$df8deae090c7c8ce} ${$ac5cc8914ebfc892$export$aea217a45095ce11}"></div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $3f4821c0645aeb9a$export$8f6adf886c3e91d5 extends (0, $b9e5a026e9385887$export$60ff82c3e26d6c1f) {
    constructor(periods){
        super(periods.map((period)=>{
            return {
                html: (0, $5FliW.Resources).t(`words.offerPeriod${period.periodType}`),
                value: period.periodType + ""
            };
        }));
    }
}




var $5FliW = parcelRequire("5FliW");



var $fsnB5 = parcelRequire("fsnB5");
var $67559bb61cc9bc51$export$1c80ec59d1789323;
var $67559bb61cc9bc51$export$7c341cb16fc91138;
var $67559bb61cc9bc51$export$1ca1ec8b29a4ce27;
var $67559bb61cc9bc51$export$8f981dffec84ba52;
var $67559bb61cc9bc51$export$ce69bd05624d0c48;
var $67559bb61cc9bc51$export$acf4eaf431084f78;
var $67559bb61cc9bc51$export$a8ff84c12d48cfa6;
var $67559bb61cc9bc51$export$18f552c4c727aeb5;
var $67559bb61cc9bc51$export$72108e4fb43880e3;
var $67559bb61cc9bc51$export$7b388ca536128c6d;
var $67559bb61cc9bc51$export$1237798dc640739a;
var $67559bb61cc9bc51$export$66fec733742690b6;
var $67559bb61cc9bc51$export$fb184b623420d9be;
var $67559bb61cc9bc51$export$6d59db4903f20f7d;
var $67559bb61cc9bc51$export$337d1885ef6f1e24;
var $67559bb61cc9bc51$export$56030be9156ae856;
var $67559bb61cc9bc51$export$321c0b1a406de31f;
var $67559bb61cc9bc51$export$40e0ca2dfa95ba9e;
var $67559bb61cc9bc51$export$735606310a3da449;
var $67559bb61cc9bc51$export$a3bc9b8ed74fc;
var $67559bb61cc9bc51$export$49c44dfc2bb21d70;
var $67559bb61cc9bc51$export$98ea8a8009e37bf1;
var $67559bb61cc9bc51$export$70b61ad426ddbe54;
var $67559bb61cc9bc51$export$74d6ad014ec5fd29;
$67559bb61cc9bc51$export$1c80ec59d1789323 = "_5F2IX";
$67559bb61cc9bc51$export$7c341cb16fc91138 = "q3klv";
$67559bb61cc9bc51$export$1ca1ec8b29a4ce27 = "pmorz";
$67559bb61cc9bc51$export$8f981dffec84ba52 = "PjWcP";
$67559bb61cc9bc51$export$ce69bd05624d0c48 = "amZSr";
$67559bb61cc9bc51$export$acf4eaf431084f78 = "M5Ge7";
$67559bb61cc9bc51$export$a8ff84c12d48cfa6 = "zKT09";
$67559bb61cc9bc51$export$18f552c4c727aeb5 = "_7XTTr";
$67559bb61cc9bc51$export$72108e4fb43880e3 = "Dmndu";
$67559bb61cc9bc51$export$7b388ca536128c6d = "_6-jQd";
$67559bb61cc9bc51$export$1237798dc640739a = "_03LXX";
$67559bb61cc9bc51$export$66fec733742690b6 = "bLieP";
$67559bb61cc9bc51$export$fb184b623420d9be = "VKtj9";
$67559bb61cc9bc51$export$6d59db4903f20f7d = "QVU1G";
$67559bb61cc9bc51$export$337d1885ef6f1e24 = "uawxm";
$67559bb61cc9bc51$export$56030be9156ae856 = "_2ODnS";
$67559bb61cc9bc51$export$321c0b1a406de31f = "p23dZ";
$67559bb61cc9bc51$export$40e0ca2dfa95ba9e = "_2lpps";
$67559bb61cc9bc51$export$735606310a3da449 = "cRi-p";
$67559bb61cc9bc51$export$a3bc9b8ed74fc = "UyISm";
$67559bb61cc9bc51$export$49c44dfc2bb21d70 = "UcQJZ";
$67559bb61cc9bc51$export$98ea8a8009e37bf1 = "H73mJ";
$67559bb61cc9bc51$export$70b61ad426ddbe54 = "_9iP2Y";
$67559bb61cc9bc51$export$74d6ad014ec5fd29 = "X3f6l";





var $f0999943c1731015$export$2ab62eda9e453014;
var $f0999943c1731015$export$4c2b230493b2b322;
var $f0999943c1731015$export$fb184b623420d9be;
var $f0999943c1731015$export$a3bc9b8ed74fc;
var $f0999943c1731015$export$b7e3ae3d7c15e42e;
var $f0999943c1731015$export$73ba5813cda80a49;
var $f0999943c1731015$export$7e39b47ba949ea16;
var $f0999943c1731015$export$f9258c55612cbed7;
var $f0999943c1731015$export$1fb2911de90ed83f;
var $f0999943c1731015$export$2e6c959c16ff56b8;
var $f0999943c1731015$export$1f96961348e52fad;
$f0999943c1731015$export$2ab62eda9e453014 = "aqsVz";
$f0999943c1731015$export$4c2b230493b2b322 = "_2-8xc";
$f0999943c1731015$export$fb184b623420d9be = "HZ1gj";
$f0999943c1731015$export$a3bc9b8ed74fc = "vogRx";
$f0999943c1731015$export$b7e3ae3d7c15e42e = "_88EKk";
$f0999943c1731015$export$73ba5813cda80a49 = "_9dWOo";
$f0999943c1731015$export$7e39b47ba949ea16 = "_3ype4";
$f0999943c1731015$export$f9258c55612cbed7 = "b2gKv";
$f0999943c1731015$export$1fb2911de90ed83f = "-CEZY";
$f0999943c1731015$export$2e6c959c16ff56b8 = "N5bLS";
$f0999943c1731015$export$1f96961348e52fad = "ek2RZ";



var $fsnB5 = parcelRequire("fsnB5");

var $nyKU9 = parcelRequire("nyKU9");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $1eebc1d299a7e90f$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                        "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $2a97d13aa518dbca$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


var $76e2f9734a40370c$var$objectConstructor = {}.constructor;
function $76e2f9734a40370c$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $76e2f9734a40370c$var$objectConstructor;
}


function $d205db8c3736bafd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d205db8c3736bafd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d205db8c3736bafd$var$_typeof(obj);
}
function $d205db8c3736bafd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d205db8c3736bafd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d205db8c3736bafd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d205db8c3736bafd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d205db8c3736bafd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $d205db8c3736bafd$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $d205db8c3736bafd$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $d205db8c3736bafd$var$V4 = '1.7.35';
var $d205db8c3736bafd$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $d205db8c3736bafd$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $d205db8c3736bafd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $d205db8c3736bafd$var$_classCallCheck(this, Metadata);
        $d205db8c3736bafd$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $d205db8c3736bafd$var$setVersion.call(this, metadata);
    }
    $d205db8c3736bafd$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $d205db8c3736bafd$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $d205db8c3736bafd$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $d205db8c3736bafd$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $d205db8c3736bafd$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $d205db8c3736bafd$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $d205db8c3736bafd$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $d205db8c3736bafd$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $d205db8c3736bafd$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $d205db8c3736bafd$var$getType(this.types(), _type2)) return new $d205db8c3736bafd$var$Type($d205db8c3736bafd$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $d205db8c3736bafd$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $d205db8c3736bafd$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $d205db8c3736bafd$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $d205db8c3736bafd$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $d205db8c3736bafd$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$d205db8c3736bafd$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $d205db8c3736bafd$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $d205db8c3736bafd$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $d205db8c3736bafd$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $d205db8c3736bafd$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $d205db8c3736bafd$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $d205db8c3736bafd$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $76e2f9734a40370c$export$2e2bcd8739ae039)(metadata) || !(0, $76e2f9734a40370c$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $76e2f9734a40370c$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $d205db8c3736bafd$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $d205db8c3736bafd$var$typeOf = function typeOf(_) {
    return $d205db8c3736bafd$var$_typeof(_);
};
function $d205db8c3736bafd$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $d205db8c3736bafd$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $d205db8c3736bafd$var$DEFAULT_EXT_PREFIX;
}
function $d205db8c3736bafd$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $d205db8c3736bafd$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $d205db8c3736bafd$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $d205db8c3736bafd$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $2a97d13aa518dbca$export$2e2bcd8739ae039)(version, $d205db8c3736bafd$var$V3) === -1) this.v2 = true;
        else if ((0, $2a97d13aa518dbca$export$2e2bcd8739ae039)(version, $d205db8c3736bafd$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




function $289df1fb4cf0edae$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $289df1fb4cf0edae$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $289df1fb4cf0edae$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $289df1fb4cf0edae$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $289df1fb4cf0edae$var$_arrayLikeToArray(o, minLen);
}
function $289df1fb4cf0edae$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $289df1fb4cf0edae$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $289df1fb4cf0edae$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $2596cecf4d3d11e2$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $2596cecf4d3d11e2$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $2596cecf4d3d11e2$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $2596cecf4d3d11e2$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $289df1fb4cf0edae$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $33fad89b3f893c9d$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $33fad89b3f893c9d$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $33fad89b3f893c9d$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $2596cecf4d3d11e2$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}



/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $c0a3ce619dd279ab$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $b2f1512c56c0141f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b2f1512c56c0141f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b2f1512c56c0141f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b2f1512c56c0141f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b2f1512c56c0141f$var$_arrayLikeToArray(o, minLen);
}
function $b2f1512c56c0141f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b2f1512c56c0141f$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $b2f1512c56c0141f$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($b2f1512c56c0141f$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($b2f1512c56c0141f$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $b2f1512c56c0141f$var$_createForOfIteratorHelperLoose($b2f1512c56c0141f$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($b2f1512c56c0141f$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $b2f1512c56c0141f$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $76f5ad169d5c4bc4$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $b2f1512c56c0141f$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $2e8cf25d577815cb$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $2e8cf25d577815cb$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $2e8cf25d577815cb$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}



// The minimum length of the national significant number.
var $73b2aa7b23455d61$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $73b2aa7b23455d61$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $73b2aa7b23455d61$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $73b2aa7b23455d61$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $73b2aa7b23455d61$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $73b2aa7b23455d61$var$SLASHES = "\uFF0F/";
var $73b2aa7b23455d61$var$DOTS = "\uFF0E.";
var $73b2aa7b23455d61$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $73b2aa7b23455d61$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $73b2aa7b23455d61$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $73b2aa7b23455d61$export$7f01587e28f9194 = "".concat($73b2aa7b23455d61$var$DASHES).concat($73b2aa7b23455d61$var$SLASHES).concat($73b2aa7b23455d61$var$DOTS).concat($73b2aa7b23455d61$export$20542845033f576e).concat($73b2aa7b23455d61$var$BRACKETS).concat($73b2aa7b23455d61$var$TILDES);
var $73b2aa7b23455d61$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


var $70d0406102861fb3$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + '])');
function $70d0406102861fb3$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($70d0406102861fb3$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $30ab495acbec212a$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $2b87deacddb78271$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $30ab495acbec212a$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$2b87deacddb78271$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$2b87deacddb78271$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $2b87deacddb78271$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $2b87deacddb78271$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $2596cecf4d3d11e2$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $e4c9205270d8a548$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $d205db8c3736bafd$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $2b87deacddb78271$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $2b87deacddb78271$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $2596cecf4d3d11e2$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $f2f11f2e75713265$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $70d0406102861fb3$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $e4c9205270d8a548$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $73b2aa7b23455d61$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $0624e13b0a4e77e6$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $73b2aa7b23455d61$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $f3b97fdb27b7c7ca$export$4f32ad1c51a7a6be = /(\$\d)/;
function $f3b97fdb27b7c7ca$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($f3b97fdb27b7c7ca$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $0624e13b0a4e77e6$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $6ffb6ffe374a1dbe$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $6ffb6ffe374a1dbe$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($6ffb6ffe374a1dbe$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}




var $0d6cdab2e3a45ad1$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $73b2aa7b23455d61$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $0d6cdab2e3a45ad1$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $0d6cdab2e3a45ad1$var$RFC3966_EXTN_PREFIX + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $0d6cdab2e3a45ad1$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $ccb56328d6bf3411$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']{' + (0, $73b2aa7b23455d61$export$cd8355bcbe13154) + '}'; //
var $ccb56328d6bf3411$export$a77dd7471651eee = '[' + (0, $73b2aa7b23455d61$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + ']*' + '[' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $ccb56328d6bf3411$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $73b2aa7b23455d61$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + ']*' + '[' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $ccb56328d6bf3411$export$a2d12a04749c087d = $ccb56328d6bf3411$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $0d6cdab2e3a45ad1$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $ccb56328d6bf3411$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $ccb56328d6bf3411$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $ccb56328d6bf3411$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $ccb56328d6bf3411$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $73b2aa7b23455d61$export$cd8355bcbe13154) && $ccb56328d6bf3411$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $ccb56328d6bf3411$export$4c3f76c95c05197c(number) {
    return $ccb56328d6bf3411$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}


function $cac39b1cc9b575e6$var$_slicedToArray(arr, i) {
    return $cac39b1cc9b575e6$var$_arrayWithHoles(arr) || $cac39b1cc9b575e6$var$_iterableToArrayLimit(arr, i) || $cac39b1cc9b575e6$var$_unsupportedIterableToArray(arr, i) || $cac39b1cc9b575e6$var$_nonIterableRest();
}
function $cac39b1cc9b575e6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cac39b1cc9b575e6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cac39b1cc9b575e6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cac39b1cc9b575e6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $cac39b1cc9b575e6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cac39b1cc9b575e6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cac39b1cc9b575e6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cac39b1cc9b575e6$var$_arrayLikeToArray(o, minLen);
}
function $cac39b1cc9b575e6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cac39b1cc9b575e6$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $cac39b1cc9b575e6$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $cac39b1cc9b575e6$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $ccb56328d6bf3411$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $cac39b1cc9b575e6$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $df18fc94ff654ca5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $df18fc94ff654ca5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df18fc94ff654ca5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $df18fc94ff654ca5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $df18fc94ff654ca5$var$_arrayLikeToArray(o, minLen);
}
function $df18fc94ff654ca5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $df18fc94ff654ca5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $df18fc94ff654ca5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $df18fc94ff654ca5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $df18fc94ff654ca5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $df18fc94ff654ca5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $df18fc94ff654ca5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $df18fc94ff654ca5$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $df18fc94ff654ca5$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $df18fc94ff654ca5$var$_objectSpread($df18fc94ff654ca5$var$_objectSpread({}, $df18fc94ff654ca5$var$DEFAULT_OPTIONS), options);
    else options = $df18fc94ff654ca5$var$DEFAULT_OPTIONS;
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $df18fc94ff654ca5$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $df18fc94ff654ca5$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $df18fc94ff654ca5$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $df18fc94ff654ca5$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $cac39b1cc9b575e6$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $df18fc94ff654ca5$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $df18fc94ff654ca5$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $df18fc94ff654ca5$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $df18fc94ff654ca5$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $f3b97fdb27b7c7ca$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $df18fc94ff654ca5$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $df18fc94ff654ca5$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $df18fc94ff654ca5$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $df18fc94ff654ca5$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $d205db8c3736bafd$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $df18fc94ff654ca5$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $6ffb6ffe374a1dbe$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($df18fc94ff654ca5$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $1534af99047191e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1534af99047191e5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1534af99047191e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1534af99047191e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1534af99047191e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1534af99047191e5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1534af99047191e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1534af99047191e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1534af99047191e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1534af99047191e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1534af99047191e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $1534af99047191e5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $1534af99047191e5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $1534af99047191e5$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === 'string') {
            if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
            if ((0, $76e2f9734a40370c$export$2e2bcd8739ae039)(nationalNumber) && (0, $76e2f9734a40370c$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$1534af99047191e5$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $f2f11f2e75713265$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
         // Validate `metadata` argument.
        (0, $d205db8c3736bafd$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $1534af99047191e5$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $1534af99047191e5$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $2e8cf25d577815cb$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $33fad89b3f893c9d$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $76f5ad169d5c4bc4$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $b2f1512c56c0141f$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $df18fc94ff654ca5$export$2e2bcd8739ae039)(this, _format, options ? $1534af99047191e5$var$_objectSpread($1534af99047191e5$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $1534af99047191e5$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $1534af99047191e5$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($1534af99047191e5$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($1534af99047191e5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $1534af99047191e5$var$E164_NUMBER_REGEXP = /^\+\d+$/;


function $4f74df840a83de37$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f74df840a83de37$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4f74df840a83de37$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f74df840a83de37$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f74df840a83de37$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var $4f74df840a83de37$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $4f74df840a83de37$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $4f74df840a83de37$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(_ref2) {
                var country = _ref2.country, callingCode = _ref2.callingCode;
                this.international = false;
                this.missingPlus = false;
                this.IDDPrefix = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();


function $999f677285dbdae3$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $999f677285dbdae3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $999f677285dbdae3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $999f677285dbdae3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $999f677285dbdae3$var$_arrayLikeToArray(o, minLen);
}
function $999f677285dbdae3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $999f677285dbdae3$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $999f677285dbdae3$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($999f677285dbdae3$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $999f677285dbdae3$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $999f677285dbdae3$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $999f677285dbdae3$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $999f677285dbdae3$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $999f677285dbdae3$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $999f677285dbdae3$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $999f677285dbdae3$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $999f677285dbdae3$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $999f677285dbdae3$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $999f677285dbdae3$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $999f677285dbdae3$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($999f677285dbdae3$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($999f677285dbdae3$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($999f677285dbdae3$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}



function $00d5be64dc2bb541$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $00d5be64dc2bb541$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $00d5be64dc2bb541$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $00d5be64dc2bb541$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $00d5be64dc2bb541$var$_arrayLikeToArray(o, minLen);
}
function $00d5be64dc2bb541$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $00d5be64dc2bb541$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $00d5be64dc2bb541$export$1d16fddea1437169(character) {
    return $00d5be64dc2bb541$export$2848f3d68c08fe69[character];
}
function $00d5be64dc2bb541$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $00d5be64dc2bb541$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $00d5be64dc2bb541$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}



function $6aa142e4222f58ad$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $6aa142e4222f58ad$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $6aa142e4222f58ad$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $2596cecf4d3d11e2$export$2e2bcd8739ae039)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $6aa142e4222f58ad$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $6aa142e4222f58ad$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $6aa142e4222f58ad$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $6aa142e4222f58ad$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $f3b97fdb27b7c7ca$export$2e2bcd8739ae039)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($6aa142e4222f58ad$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $6aa142e4222f58ad$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $00d5be64dc2bb541$export$2e2bcd8739ae039)(formattedNationalNumber) === state.getNationalDigits();
}


function $89c8b21d581361ca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $89c8b21d581361ca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $89c8b21d581361ca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $89c8b21d581361ca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $89c8b21d581361ca$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $89c8b21d581361ca$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $89c8b21d581361ca$var$_classCallCheck(this, PatternParser);
    }
    $89c8b21d581361ca$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $89c8b21d581361ca$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($89c8b21d581361ca$var$OPERATOR);
                if (!match) {
                    if ($89c8b21d581361ca$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($89c8b21d581361ca$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($89c8b21d581361ca$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $89c8b21d581361ca$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $89c8b21d581361ca$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $89c8b21d581361ca$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $89c8b21d581361ca$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $89c8b21d581361ca$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}


function $655fcf85c465f1b3$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $655fcf85c465f1b3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $655fcf85c465f1b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $655fcf85c465f1b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $655fcf85c465f1b3$var$_arrayLikeToArray(o, minLen);
}
function $655fcf85c465f1b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $655fcf85c465f1b3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $655fcf85c465f1b3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $655fcf85c465f1b3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $655fcf85c465f1b3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $655fcf85c465f1b3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $655fcf85c465f1b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $655fcf85c465f1b3$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $89c8b21d581361ca$export$2e2bcd8739ae039)().parse(pattern);
    }
    $655fcf85c465f1b3$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $655fcf85c465f1b3$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $655fcf85c465f1b3$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $655fcf85c465f1b3$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $655fcf85c465f1b3$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $655fcf85c465f1b3$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $655fcf85c465f1b3$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}






function $40fa04ec334b69e6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $40fa04ec334b69e6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $40fa04ec334b69e6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $40fa04ec334b69e6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $40fa04ec334b69e6$var$_arrayLikeToArray(o, minLen);
}
function $40fa04ec334b69e6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $40fa04ec334b69e6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $40fa04ec334b69e6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $40fa04ec334b69e6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $40fa04ec334b69e6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $40fa04ec334b69e6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $40fa04ec334b69e6$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $40fa04ec334b69e6$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $40fa04ec334b69e6$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $999f677285dbdae3$export$76d90c956114f2c2)($40fa04ec334b69e6$var$DUMMY_DIGIT, $40fa04ec334b69e6$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $40fa04ec334b69e6$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $40fa04ec334b69e6$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $40fa04ec334b69e6$var$CREATE_CHARACTER_CLASS_PATTERN = $40fa04ec334b69e6$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $40fa04ec334b69e6$var$CREATE_STANDALONE_DIGIT_PATTERN = $40fa04ec334b69e6$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $40fa04ec334b69e6$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + ']*' + '(\\$\\d[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $40fa04ec334b69e6$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $40fa04ec334b69e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $40fa04ec334b69e6$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $40fa04ec334b69e6$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $6aa142e4222f58ad$export$9e33d25ea5d3e526)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $40fa04ec334b69e6$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $6aa142e4222f58ad$export$2e2bcd8739ae039)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $999f677285dbdae3$export$2a0174a7c311f338)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $999f677285dbdae3$export$2a0174a7c311f338));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $40fa04ec334b69e6$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $40fa04ec334b69e6$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $655fcf85c465f1b3$export$2e2bcd8739ae039)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$40fa04ec334b69e6$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $40fa04ec334b69e6$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($40fa04ec334b69e6$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $40fa04ec334b69e6$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $999f677285dbdae3$export$2a0174a7c311f338), index + 1);
                    i++;
                }
                return (0, $999f677285dbdae3$export$ac095dcff0205861)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $999f677285dbdae3$export$2a0174a7c311f338)) + (0, $999f677285dbdae3$export$76d90c956114f2c2)((0, $999f677285dbdae3$export$2a0174a7c311f338), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($40fa04ec334b69e6$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($40fa04ec334b69e6$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($40fa04ec334b69e6$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $40fa04ec334b69e6$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $40fa04ec334b69e6$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $f3b97fdb27b7c7ca$export$4f32ad1c51a7a6be), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $00d5be64dc2bb541$export$2e2bcd8739ae039)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $00d5be64dc2bb541$export$2e2bcd8739ae039)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $999f677285dbdae3$export$2a0174a7c311f338));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($40fa04ec334b69e6$var$DUMMY_DIGIT, 'g'), (0, $999f677285dbdae3$export$2a0174a7c311f338)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $999f677285dbdae3$export$76d90c956114f2c2)((0, $999f677285dbdae3$export$2a0174a7c311f338), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $999f677285dbdae3$export$76d90c956114f2c2)((0, $999f677285dbdae3$export$2a0174a7c311f338), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $0624e13b0a4e77e6$export$2e2bcd8739ae039)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $999f677285dbdae3$export$a15547494b55ca4e)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $999f677285dbdae3$export$ac095dcff0205861)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();








function $2db4176172430e6e$var$_slicedToArray(arr, i) {
    return $2db4176172430e6e$var$_arrayWithHoles(arr) || $2db4176172430e6e$var$_iterableToArrayLimit(arr, i) || $2db4176172430e6e$var$_unsupportedIterableToArray(arr, i) || $2db4176172430e6e$var$_nonIterableRest();
}
function $2db4176172430e6e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2db4176172430e6e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2db4176172430e6e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2db4176172430e6e$var$_arrayLikeToArray(o, minLen);
}
function $2db4176172430e6e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2db4176172430e6e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2db4176172430e6e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2db4176172430e6e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2db4176172430e6e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2db4176172430e6e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2db4176172430e6e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2db4176172430e6e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']+';
var $2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $73b2aa7b23455d61$export$207c99ccf3902df8) + ']' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']*' + '|' + '[' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']+' + ')';
var $2db4176172430e6e$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $73b2aa7b23455d61$export$7f01587e28f9194) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $2db4176172430e6e$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $2db4176172430e6e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $2db4176172430e6e$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $2db4176172430e6e$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $2db4176172430e6e$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $2db4176172430e6e$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $00d5be64dc2bb541$export$2e2bcd8739ae039)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $f2f11f2e75713265$export$2e2bcd8739ae039)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $2db4176172430e6e$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $30ab495acbec212a$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $30ab495acbec212a$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $70d0406102861fb3$export$2e2bcd8739ae039)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $e4c9205270d8a548$export$2e2bcd8739ae039)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $2db4176172430e6e$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($2db4176172430e6e$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $2db4176172430e6e$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $2db4176172430e6e$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $2db4176172430e6e$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $2db4176172430e6e$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $2db4176172430e6e$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$2db4176172430e6e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}




function $ffc6698d26cbd182$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ffc6698d26cbd182$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ffc6698d26cbd182$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ffc6698d26cbd182$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ffc6698d26cbd182$var$_arrayLikeToArray(o, minLen);
}
function $ffc6698d26cbd182$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ffc6698d26cbd182$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $ffc6698d26cbd182$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $b2f1512c56c0141f$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $5ce3acefb7d6404e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $5ce3acefb7d6404e$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($5ce3acefb7d6404e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $ffc6698d26cbd182$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}




function $75d5debb09ddc2c0$var$_slicedToArray(arr, i) {
    return $75d5debb09ddc2c0$var$_arrayWithHoles(arr) || $75d5debb09ddc2c0$var$_iterableToArrayLimit(arr, i) || $75d5debb09ddc2c0$var$_unsupportedIterableToArray(arr, i) || $75d5debb09ddc2c0$var$_nonIterableRest();
}
function $75d5debb09ddc2c0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $75d5debb09ddc2c0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $75d5debb09ddc2c0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $75d5debb09ddc2c0$var$_arrayLikeToArray(o, minLen);
}
function $75d5debb09ddc2c0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $75d5debb09ddc2c0$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $75d5debb09ddc2c0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $75d5debb09ddc2c0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75d5debb09ddc2c0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $75d5debb09ddc2c0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $75d5debb09ddc2c0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $75d5debb09ddc2c0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $75d5debb09ddc2c0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $75d5debb09ddc2c0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $75d5debb09ddc2c0$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $75d5debb09ddc2c0$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
        // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
        // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $75d5debb09ddc2c0$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ((0, $76e2f9734a40370c$export$2e2bcd8739ae039)(optionsOrDefaultCountry)) {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($75d5debb09ddc2c0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $4f74df840a83de37$export$2e2bcd8739ae039)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $40fa04ec334b69e6$export$2e2bcd8739ae039)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $2db4176172430e6e$export$2e2bcd8739ae039)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                });
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($75d5debb09ddc2c0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $999f677285dbdae3$export$2a0174a7c311f338));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $5ce3acefb7d6404e$export$2e2bcd8739ae039)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                 // `state.country` and `state.callingCode` aren't required to be in sync.
                // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
                // So `country` and `callingCode` are totally independent.
                if (!country && !callingCode) return;
                 // By default, if `defaultCountry` parameter was passed when
                // creating `AsYouType` instance, `state.country` is gonna be
                // that `defaultCountry`, which doesn't entirely conform with
                // `parsePhoneNumber()`'s behavior where it attempts to determine
                // the country more precisely in cases when multiple countries
                // could correspond to the same `countryCallingCode`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
                //
                // Because `AsYouType.getNumber()` method is supposed to be a 1:1
                // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
                // then it should also behave accordingly in cases of `country` ambiguity.
                // That's how users of this library would expect it to behave anyway.
                //
                if (country) {
                    if (country === this.defaultCountry) {
                        // `state.country` and `state.callingCode` aren't required to be in sync.
                        // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
                        // So `state.country` and `state.callingCode` are totally independent.
                        var metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(this.metadata.metadata);
                        metadata.selectNumberingPlan(country);
                        var _callingCode = metadata.numberingPlan.callingCode();
                        var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
                        if (ambiguousCountries.length > 1) {
                            var exactCountry = (0, $ffc6698d26cbd182$export$2e2bcd8739ae039)(nationalSignificantNumber, {
                                countries: ambiguousCountries,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            if (exactCountry) country = exactCountry;
                        }
                    }
                }
                var phoneNumber = new (0, $1534af99047191e5$export$2e2bcd8739ae039)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();


function $56640966002d6b9b$export$80d8c6912928a4eb(country) {
    return (0, $75d5debb09ddc2c0$export$2e2bcd8739ae039).call(this, country, (0, $1eebc1d299a7e90f$export$2e2bcd8739ae039));
}
$56640966002d6b9b$export$80d8c6912928a4eb.prototype = Object.create((0, $75d5debb09ddc2c0$export$2e2bcd8739ae039).prototype, {});
$56640966002d6b9b$export$80d8c6912928a4eb.prototype.constructor = $56640966002d6b9b$export$80d8c6912928a4eb;

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

function $3d3a5065c528ceec$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $1eebc1d299a7e90f$export$2e2bcd8739ae039));
    return func.apply(this, args);
}



function $7b2a1f359d584fce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7b2a1f359d584fce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7b2a1f359d584fce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7b2a1f359d584fce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7b2a1f359d584fce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7b2a1f359d584fce$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7b2a1f359d584fce$var$_slicedToArray(arr, i) {
    return $7b2a1f359d584fce$var$_arrayWithHoles(arr) || $7b2a1f359d584fce$var$_iterableToArrayLimit(arr, i) || $7b2a1f359d584fce$var$_unsupportedIterableToArray(arr, i) || $7b2a1f359d584fce$var$_nonIterableRest();
}
function $7b2a1f359d584fce$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b2a1f359d584fce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b2a1f359d584fce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b2a1f359d584fce$var$_arrayLikeToArray(o, minLen);
}
function $7b2a1f359d584fce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b2a1f359d584fce$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7b2a1f359d584fce$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7b2a1f359d584fce$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $7b2a1f359d584fce$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $7b2a1f359d584fce$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $76e2f9734a40370c$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

function $8c87c80854944d08$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8c87c80854944d08$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8c87c80854944d08$var$_typeof(obj);
}
function $8c87c80854944d08$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8c87c80854944d08$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8c87c80854944d08$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8c87c80854944d08$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8c87c80854944d08$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8c87c80854944d08$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8c87c80854944d08$var$_setPrototypeOf(subClass, superClass);
}
function $8c87c80854944d08$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8c87c80854944d08$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8c87c80854944d08$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8c87c80854944d08$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8c87c80854944d08$var$_possibleConstructorReturn(this, result);
    };
}
function $8c87c80854944d08$var$_possibleConstructorReturn(self, call) {
    if (call && ($8c87c80854944d08$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8c87c80854944d08$var$_assertThisInitialized(self);
}
function $8c87c80854944d08$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8c87c80854944d08$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8c87c80854944d08$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8c87c80854944d08$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8c87c80854944d08$var$_construct(Class, arguments, $8c87c80854944d08$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8c87c80854944d08$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8c87c80854944d08$var$_wrapNativeSuper(Class);
}
function $8c87c80854944d08$var$_construct(Parent, args, Class) {
    if ($8c87c80854944d08$var$_isNativeReflectConstruct()) $8c87c80854944d08$var$_construct = Reflect.construct;
    else $8c87c80854944d08$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8c87c80854944d08$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8c87c80854944d08$var$_construct.apply(null, arguments);
}
function $8c87c80854944d08$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8c87c80854944d08$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8c87c80854944d08$var$_setPrototypeOf(o, p) {
    $8c87c80854944d08$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8c87c80854944d08$var$_setPrototypeOf(o, p);
}
function $8c87c80854944d08$var$_getPrototypeOf(o) {
    $8c87c80854944d08$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8c87c80854944d08$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $8c87c80854944d08$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $8c87c80854944d08$var$_inherits(ParseError, _Error);
    var _super = $8c87c80854944d08$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $8c87c80854944d08$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($8c87c80854944d08$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $8c87c80854944d08$var$_createClass(ParseError);
}(/*#__PURE__*/ $8c87c80854944d08$var$_wrapNativeSuper(Error));





// 1 or more valid digits, for use when parsing.
var $7d6a722b4b7f36ad$var$EXTN_PATTERN = new RegExp('(?:' + (0, $0d6cdab2e3a45ad1$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $7d6a722b4b7f36ad$export$2e2bcd8739ae039(number) {
    var start = number.search($7d6a722b4b7f36ad$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($7d6a722b4b7f36ad$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}



function $495f7a5da3e59b25$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $495f7a5da3e59b25$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $495f7a5da3e59b25$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $495f7a5da3e59b25$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $495f7a5da3e59b25$var$_arrayLikeToArray(o, minLen);
}
function $495f7a5da3e59b25$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $495f7a5da3e59b25$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $495f7a5da3e59b25$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $495f7a5da3e59b25$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $495f7a5da3e59b25$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $00d5be64dc2bb541$export$1d16fddea1437169)(character);
}










// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $5ece934617750c18$export$1ddc7eed78155f68 = '+';
var $5ece934617750c18$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $5ece934617750c18$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']' + '|' + $5ece934617750c18$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $5ece934617750c18$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $5ece934617750c18$export$1ddc7eed78155f68 + $5ece934617750c18$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']' + $5ece934617750c18$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $5ece934617750c18$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($5ece934617750c18$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $5ece934617750c18$var$ALPHANUM_ = (0, $73b2aa7b23455d61$export$852d1d4a47329634);
var $5ece934617750c18$var$RFC3966_DOMAINLABEL_ = '[' + $5ece934617750c18$var$ALPHANUM_ + ']+((\\-)*[' + $5ece934617750c18$var$ALPHANUM_ + '])*';
var $5ece934617750c18$var$VALID_ALPHA_ = 'a-zA-Z';
var $5ece934617750c18$var$RFC3966_TOPLABEL_ = '[' + $5ece934617750c18$var$VALID_ALPHA_ + ']+((\\-)*[' + $5ece934617750c18$var$ALPHANUM_ + '])*';
var $5ece934617750c18$var$RFC3966_DOMAINNAME_ = '^(' + $5ece934617750c18$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $5ece934617750c18$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $5ece934617750c18$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($5ece934617750c18$var$RFC3966_DOMAINNAME_, 'g');
var $5ece934617750c18$export$70d485ce3f6de783 = 'tel:';
var $5ece934617750c18$export$f6d5879d582c3a27 = ';phone-context=';
var $5ece934617750c18$export$9e356e12edb00a81 = ';isub=';
function $5ece934617750c18$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($5ece934617750c18$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $5ece934617750c18$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $5ece934617750c18$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $5ece934617750c18$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $5ece934617750c18$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $74988d7d5ffdb263$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $5ece934617750c18$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $5ece934617750c18$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $5ece934617750c18$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $5ece934617750c18$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $5ece934617750c18$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $5ece934617750c18$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $5ece934617750c18$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $f998b030520b5b51$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $f998b030520b5b51$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $73b2aa7b23455d61$export$207c99ccf3902df8) + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $f998b030520b5b51$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $73b2aa7b23455d61$export$852d1d4a47329634) + '#' + ']+$');
var $f998b030520b5b51$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $f998b030520b5b51$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $d205db8c3736bafd$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $f998b030520b5b51$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $f998b030520b5b51$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $73b2aa7b23455d61$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $73b2aa7b23455d61$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $1534af99047191e5$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $c0a3ce619dd279ab$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $f998b030520b5b51$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $33fad89b3f893c9d$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $f998b030520b5b51$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $f998b030520b5b51$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $8c87c80854944d08$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($f998b030520b5b51$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($f998b030520b5b51$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $f998b030520b5b51$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $74988d7d5ffdb263$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $f998b030520b5b51$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $ccb56328d6bf3411$export$2e2bcd8739ae039)(number)) {
        if ((0, $ccb56328d6bf3411$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $7d6a722b4b7f36ad$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $f998b030520b5b51$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $f998b030520b5b51$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $f2f11f2e75713265$export$2e2bcd8739ae039)((0, $495f7a5da3e59b25$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($f998b030520b5b51$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $d205db8c3736bafd$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $2b87deacddb78271$export$2e2bcd8739ae039)((0, $495f7a5da3e59b25$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $5ce3acefb7d6404e$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $3633fa26f5275cff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3633fa26f5275cff$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3633fa26f5275cff$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3633fa26f5275cff$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3633fa26f5275cff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3633fa26f5275cff$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3633fa26f5275cff$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $f998b030520b5b51$export$2e2bcd8739ae039)(text, $3633fa26f5275cff$var$_objectSpread($3633fa26f5275cff$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $3f218f6aa8f1201a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3f218f6aa8f1201a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3f218f6aa8f1201a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3f218f6aa8f1201a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3f218f6aa8f1201a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3f218f6aa8f1201a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f218f6aa8f1201a$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $d205db8c3736bafd$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $3f218f6aa8f1201a$var$_objectSpread($3f218f6aa8f1201a$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $3633fa26f5275cff$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $8c87c80854944d08$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $d64f3626f996cef6$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $7b2a1f359d584fce$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $3f218f6aa8f1201a$export$2e2bcd8739ae039)(text, options, metadata);
}


function $527cb2cbfc4f8a71$export$da44e4eaa54bc82e() {
    return (0, $3d3a5065c528ceec$export$2e2bcd8739ae039)((0, $d64f3626f996cef6$export$2e2bcd8739ae039), arguments);
}



var $fsnB5 = parcelRequire("fsnB5");
var $d86d6bc815a51e30$export$b605972fbb5a633b;
var $d86d6bc815a51e30$export$683472f6198a076e;
var $d86d6bc815a51e30$export$aa5fcd1d589f5ce8;
var $d86d6bc815a51e30$export$542cf336a574a3f8;
$d86d6bc815a51e30$export$b605972fbb5a633b = "WgQ0f";
$d86d6bc815a51e30$export$683472f6198a076e = "svHEm";
$d86d6bc815a51e30$export$aa5fcd1d589f5ce8 = "JBpGF";
$d86d6bc815a51e30$export$542cf336a574a3f8 = "vhYdc";



var $fsnB5 = parcelRequire("fsnB5");

var $2aBLW = parcelRequire("2aBLW");

var $nyKU9 = parcelRequire("nyKU9");

var $gKcOU = parcelRequire("gKcOU");
class $50c275588d1044b8$export$ec7a7f40ea27f7a7 extends (0, $fsnB5.Component) {
    /**
     * get and set
     */ get component() {
        return this._component;
    }
    set component(value) {
        this._component = value;
    }
    /**
     * place and position
     */ place() {
        if (this.component.getOffsets().top > window.innerHeight / 2) this.setStyle(`transition-duration:0;left:${this.calcMiddle()}px;top:unset;bottom:${this.calcOutsideBottom()}px;`);
        else this.setStyle(`transition-duration:0;left:${this.calcMiddle()}px;top:${this.calcTop()}px;`);
        if (this.outsideBottom()) this.setStyle(`top:unset;bottom:${this.calcOutsideBottom()}px`);
        if (this.outsideRight()) this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
        if (this.firstPlace) {
            this.firstPlace = false;
            (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                if (this.outsideBottom() || this.outsideRight() || this.outsideLeft()) this.place();
            });
        }
    }
    placeTop() {
        this.setStyle(`top:unset;bottom:${this.calcOutsideBottom()}px`);
        if (this.outsideTop()) this.setStyle(`bottom:unset;top:${this.calcTop()}px;`);
    }
    placeRight() {
        this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
    }
    placeOnRight() {
        this.setStyle(`left:${this.calcLeft() + this._component.getWidth() + 15};right: unset;`);
        this.setStyle(`top:${this.calcMiddleTop()}px;`);
        if (this.outsideLeft()) this.setStyle(`right:unset;left:${this.calcOutsideLeft()}px;`);
        if (this.outsideRight()) this.setStyle(`left:unset;right:${this.calcOutsideRight()}px;`);
        if (this.outsideTop()) this.setStyle(`bottom:unset;top:${this.calcOutsideTop()}px;`);
        if (this.outsideBottom()) this.setStyle(`bottom: 10px;top: unset;`);
    }
    replace() {
        let timeNow = performance.now();
        if (timeNow - 10 > this.time) {
            this.time = timeNow;
            this.setStyle(`transition-duration: 0s;`);
            this.place();
        }
    }
    /**
     * calc position
     */ //place element to middle
    calcMiddle() {
        return this._component.getOffsets().left + this._component.getWidth() / 2 - this.getWidth() / 2;
    }
    calcMiddleTop() {
        return this._component.getOffsets().top + this._component.getHeight() / 2 - this.getHeight() / 2;
    }
    // place to left element
    calcLeft() {
        return this._component.getOffsets().left;
    }
    // place if limit left
    calcOutsideLeft() {
        return 10;
    }
    calcOutsideTop() {
        return 10;
    }
    //place on bottom of element
    calcTop() {
        return this._component.getOffsets().top + this._component.getHeight() + 5;
    }
    //place on top of element if bottom is limit
    calcOutsideBottom() {
        return this.component.getOffsets().bottom + this._component.getHeight() + 4;
    }
    // place if limit right
    calcOutsideRight() {
        return 10;
    }
    /**
     * calc if element is outside screen
     */ outsideLeft() {
        return (0, $gKcOU.elementOffsets)(this.getHTMLElement()).left < 10;
    }
    outsideBottom() {
        return this.getHTMLElement().getBoundingClientRect().height + this.getOffsets().top > window.innerHeight;
    }
    outsideTop() {
        return this.getOffsets().top < 0;
    }
    outsideRight() {
        return this.getWidth() + this.getOffsets().left > window.innerWidth;
    }
    /**
     * append and remove
     */ dispose() {
        if (!this.isNull()) this.remove();
        this.onDispose();
    }
    create() {
        (0, $2aBLW.SedestralInterface).main.render(this);
        (0, $2aBLW.SedestralInterface).main.removeChildren(this);
    }
    /**
     *override
     */ onDispose() {}
    beforeDispose() {}
    constructor(component){
        super();
        this._component = component;
        this.time = performance.now();
        this.firstPlace = true;
        this.putListener(window, "resize", ()=>this.replace());
    }
}


var $db5564e29d6e7392$export$ea5c36236b0b24c6;
var $db5564e29d6e7392$export$1114d5e9985e6d2a;
$db5564e29d6e7392$export$ea5c36236b0b24c6 = "ELPJA";
$db5564e29d6e7392$export$1114d5e9985e6d2a = "_50N--";



var $nyKU9 = parcelRequire("nyKU9");

var $2aBLW = parcelRequire("2aBLW");

var $ftoGP = parcelRequire("ftoGP");
class $3cca83df42d6cbae$export$2b42b674fe95a29 extends (0, $50c275588d1044b8$export$ec7a7f40ea27f7a7) {
    get hovered() {
        return this._hovered;
    }
    get minHeight() {
        return this._minHeight;
    }
    set minHeight(value) {
        this._minHeight = value;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    get hoverDelay() {
        return this._hoverDelay;
    }
    set hoverDelay(value) {
        this._hoverDelay = value;
    }
    get leaveDelay() {
        return this._leaveDelay;
    }
    set leaveDelay(value) {
        this._leaveDelay = value;
    }
    /**
     * get set
     */ get isAnimation() {
        return this._animation;
    }
    get animationDelay() {
        return this._delay;
    }
    set animationDelay(value) {
        this._delay = value;
    }
    commit() {
        if (this._autoMaxHeight) {
            this.calcMaxHeight();
            (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
                this.calcMaxHeight();
                this.onChange(()=>{
                    this.calcMaxHeight();
                });
            });
        }
        this.bind();
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
            this.place();
        });
        super.commit();
    }
    /**
     * bind
     */ bind() {
        if (!(0, $ftoGP.isMobile)() && !this._disableLeave) {
            this.onLeave(async ()=>{
                await this.dispose();
            });
            let listener = this.component.onLeave(async ()=>{
                if (!this._hovered) {
                    await this.dispose();
                    this.component.deleteListener(listener);
                }
            }, this._leaveDelay == undefined ? 200 : this._leaveDelay);
            this.onHover(()=>{
                if (!this._hovered) {
                    this._hovered = true;
                    this.component.deleteListener(listener);
                }
            }, this._hoverDelay == undefined ? 0 : this._hoverDelay);
        } else this.onOutsideClick(()=>this.dispose());
    }
    /**
     * init and dispose
     */ async dispose() {
        this.beforeDispose();
        if (this._animation) this._mobileStyle ? await this.closeDown(this._delay) : await this.scaleHide(this._delay);
        else {
            this.displayHide();
            this.clearAll();
        }
        if (this._disableLeave) this.component[this._keyId] = undefined;
        super.dispose();
    }
    create() {
        if (this._disableLeave) {
            if (this.component[this._keyId]) {
                (0, $2aBLW.SedestralInterface).unStore(this);
                this.clearAll();
                return;
            }
            this.component[this._keyId] = true;
        }
        super.create();
        if (this._animation) this._mobileStyle ? this.openUp(this._delay) : this.scaleShow(this._delay);
        else this.displayShow();
    }
    place() {
        if (this._mobileStyle && (0, $ftoGP.isMobile)()) {
            let paddingLeft = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue('padding-left');
            let paddingRight = window.getComputedStyle(this.getHTMLElement(), null).getPropertyValue('padding-right');
            this.setStyle(`width:calc(100% - ${parseInt(paddingLeft) + parseInt(paddingRight)}px);left:unset !important;right:0 !important;top:unset !important;bottom:0;border-radius: 15px 15px 0px 0px;`);
            this.getHTMLElement().lastElementChild['style'].cssText += "padding-bottom: 20px !important;";
        } else super.place();
    }
    /**
     * template
     */ getTemplate() {
        if (this._width !== 0) return this.template = `
                <div style="min-height: ${this._minHeight}px;width:${this._width}px;" class="${$db5564e29d6e7392$export$ea5c36236b0b24c6}">
                     ${super.getTemplate()}
                </div>
            `;
        else return this.template = `
                <div style="min-height: ${this._minHeight}px;width: calc(100% - 60px); left: 15px !important; top: 15px !important" class="${$db5564e29d6e7392$export$ea5c36236b0b24c6}">
                     ${super.getTemplate()}
                </div>
            `;
    }
    /**
     * settings
     */ animation(value) {
        this._animation = value;
        return this;
    }
    mobileStyle(value) {
        this._mobileStyle = value;
        return this;
    }
    autoMaxHeight(value) {
        this._autoMaxHeight = value;
        return this;
    }
    /**
     * height
     */ calcMaxHeight() {
        if (!this.component.isNull() && !this.isNull()) {
            let firstElement = this.getFirstChildElement();
            if (firstElement != undefined) {
                let maxHeight;
                if (this.component.getOffsets().top > window.innerHeight / 2) {
                    let bottom = this.component.getHeight() + this.component.getOffsets().bottom + 30;
                    maxHeight = window.innerHeight - bottom;
                } else {
                    let top = this.component.getHeight() + this.component.getOffsets().top + 30;
                    maxHeight = window.innerHeight - top;
                }
                let child = firstElement;
                for(let i = 0; i < child.children.length; i++)child.children[i]['_scrollTop'] = child.children[i].scrollTop;
                child.style.cssText += `height:fit-content !important;`;
                let childHeight = child.scrollHeight;
                if (childHeight > maxHeight - 10) {
                    child.style.cssText += `height:${maxHeight - ((0, $ftoGP.isMobile)() ? 40 : 0)}px !important;`;
                    this.setStyle(`height:${maxHeight}px;transition:0s;`);
                } else {
                    child.style.cssText += `height:${childHeight + 1}px !important;`;
                    this.setStyle(`height:fit-content;transition:0s;`);
                }
                for(let i = 0; i < child.children.length; i++)child.children[i]['scrollTop'] = child.children[i]['_scrollTop'];
                this.place();
            }
        }
    }
    getFirstChildElement() {
        let firstElement = this.getHTMLElement().firstElementChild;
        if (firstElement && firstElement.hasAttribute("swapBar")) return firstElement.nextElementSibling;
        return firstElement;
    }
    constructor(component, minHeight, width){
        super(component);
        this._hovered = false;
        this._minHeight = minHeight;
        this._width = width;
        this._animation = true;
        this._keyId = "tooltip-" + this.constructor.name;
    }
}



var $2aBLW = parcelRequire("2aBLW");


var $nyKU9 = parcelRequire("nyKU9");
class $c732cc70575ee021$export$dea594182f495d9c extends (0, $3cca83df42d6cbae$export$2b42b674fe95a29) {
    /**
     * get and set
     */ get screenContainer() {
        return this._screenContainer;
    }
    get isReady() {
        return this._isReady;
    }
    bind() {
        this.addListener("contextmenu", (e)=>e.stopPropagation());
        this.onOutsideClick(async ()=>await this.dispose());
        this.onOutsideRightClick(async ()=>await this.dispose());
        this.component.onRemove(async ()=>{
            this.disposeScreen();
            await this.dispose();
        });
    }
    async create(hidden) {
        if (this.component[this._keyId]) {
            (0, $2aBLW.SedestralInterface).unStore(this);
            this.clearAll();
            return;
        }
        this.component[this._keyId] = true;
        (0, $2aBLW.SedestralInterface).main.render(this);
        if (this._screen) {
            this._screenContainer = (0, $2aBLW.SedestralInterface).body.append(`<div class="${$db5564e29d6e7392$export$1114d5e9985e6d2a}"></div>`);
            (0, $2aBLW.SedestralInterface).body.removeChildren(this._screenContainer);
        }
        if (this._unClickable) this.unClickable();
        if (!hidden) {
            if (this.isAnimation) this._mobileStyle ? await this.openUp(this.animationDelay) : await this.scaleShow(this.animationDelay);
            else this.displayShow();
        } else this.displayHide();
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
            this._isReady = true;
        });
    }
    async dispose() {
        this.disposeScreen();
        await super.dispose();
        this._isReady = false;
        this.component[this._keyId] = undefined;
    }
    disposeScreen() {
        if (this._screen && this._screenContainer != undefined) {
            this._screenContainer.remove();
            this._screenContainer = undefined;
        }
    }
    /**
     * settings
     */ screen(value) {
        this._screen = value;
        return this;
    }
    setUnClickable(value) {
        this._unClickable = value;
        return this;
    }
    setComponentUnClickable(classValue) {
        if (!this.isNull()) this.onClick((e)=>{
            (0, $nyKU9.SedestralMachine).outsideClickListeners.forEach((value)=>{
                if (!(value['component'] instanceof classValue)) value.callback(e);
            });
        }, true);
    }
    constructor(component, minHeight, width){
        super(component, minHeight, width);
        this._screen = true;
        this._unClickable = true;
        this._isReady = false;
    }
}


var $86064bbed7170646$export$d1d55afab036cac2;
var $86064bbed7170646$export$100aa851bad32d9d;
var $86064bbed7170646$export$1ca1ec8b29a4ce27;
var $86064bbed7170646$export$b7e3ae3d7c15e42e;
var $86064bbed7170646$export$c6d40e657c4cb32e;
var $86064bbed7170646$export$e850e66917a23e0f;
var $86064bbed7170646$export$151a98b9b0a52b4e;
var $86064bbed7170646$export$d90250155de6d7e7;
var $86064bbed7170646$export$51987bb50e1f6752;
var $86064bbed7170646$export$6d59db4903f20f7d;
$86064bbed7170646$export$d1d55afab036cac2 = "_9PF-j";
$86064bbed7170646$export$100aa851bad32d9d = "T-B3N";
$86064bbed7170646$export$1ca1ec8b29a4ce27 = "f-EUc";
$86064bbed7170646$export$b7e3ae3d7c15e42e = "cFmpY";
$86064bbed7170646$export$c6d40e657c4cb32e = "hHIr0";
$86064bbed7170646$export$e850e66917a23e0f = "BFocA";
$86064bbed7170646$export$151a98b9b0a52b4e = "_-8Nbr";
$86064bbed7170646$export$d90250155de6d7e7 = "_9LzAM";
$86064bbed7170646$export$51987bb50e1f6752 = "bLGZA";
$86064bbed7170646$export$6d59db4903f20f7d = "hFpcJ";



var $5FliW = parcelRequire("5FliW");
function $21f578350e80d4d9$export$bd9d5a37ac9dc911(txt) {
    txt = txt.trim().toLowerCase();
    txt = txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    txt = txt.replace("s", "").replace("x", "").replace("\u2019", "'").replace("\u2018", "'").replace("\xb4", "'").replace("`", "'");
    return txt;
}


/**
 * Transforme le HTML en plain text
 */ function $8b3ae76a3c7bb865$export$20bf31df4b15cdec(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\n/g, '');
}


class $db38a17dfd6de99c$export$76cac35af4870249 extends (0, $c732cc70575ee021$export$dea594182f495d9c) {
    commit() {
        this.casesContainer = this.el($86064bbed7170646$export$151a98b9b0a52b4e);
        this.casesScrollable = this.el($86064bbed7170646$export$c6d40e657c4cb32e);
        if (this.settings.search) this.casesScrollable.setStyle(`height:calc(100% - 32px);`);
        this.casesScrollable.scrollable();
        this.init();
        this.swapable(()=>this.dispose());
        super.commit();
    }
    init() {
        this.setStyle(`padding:5px;`);
        this.setStyle(`z-index:100000000;`);
        if (this.settings.search) {
            //language=HTML
            this.el($86064bbed7170646$export$d1d55afab036cac2).prepend(`
                <div class="${$86064bbed7170646$export$100aa851bad32d9d}">
                    <div class="${$86064bbed7170646$export$1ca1ec8b29a4ce27}"></div>
                    <input placeholder="${(0, $5FliW.Resources).t("words.search")}" class="${$86064bbed7170646$export$b7e3ae3d7c15e42e}"/>
                </div>
            `);
            let input = this.el($86064bbed7170646$export$b7e3ae3d7c15e42e);
            input.onKeyUp(()=>this.renderButtons(input.getValue()));
            input.focus();
        }
        this.renderButtons();
    }
    renderButtons(search) {
        this.casesContainer.clearAll();
        this.settings.entries.filter((value)=>{
            let searchValue = this.settings.searchDescription ? value.description : value.label;
            return search == undefined || (this.settings.searchInclude ? (0, $8b3ae76a3c7bb865$export$20bf31df4b15cdec)((0, $21f578350e80d4d9$export$bd9d5a37ac9dc911)(searchValue)).includes((0, $21f578350e80d4d9$export$bd9d5a37ac9dc911)(search)) : (0, $8b3ae76a3c7bb865$export$20bf31df4b15cdec)((0, $21f578350e80d4d9$export$bd9d5a37ac9dc911)(searchValue)).startsWith((0, $21f578350e80d4d9$export$bd9d5a37ac9dc911)(search)));
        }).forEach((entry)=>{
            //language=HTML
            let button = this.casesContainer.append(`
                <div class="${$86064bbed7170646$export$e850e66917a23e0f} ${(this.settings.multiple ? this.selectedValue.includes("" + entry.value) : this.selectedValue == entry.value) ? $86064bbed7170646$export$d90250155de6d7e7 : ``}">
                    ${entry.label ? entry.label : ``}
                </div>
            `);
            button['entry'] = entry;
            button.onClick(async ()=>{
                this.selectedValue = entry.value;
                if (!this.settings.multiple) {
                    if (this.settings.selectedValueNullable) {
                        if (this.selectedButton && this.selectedButton != button) this.selectedButton.removeClass($86064bbed7170646$export$d90250155de6d7e7);
                        if (button.hasClass($86064bbed7170646$export$d90250155de6d7e7)) {
                            this.selectedButton = undefined;
                            button.removeClass($86064bbed7170646$export$d90250155de6d7e7);
                        } else {
                            this.selectedButton = button;
                            button.addClass($86064bbed7170646$export$d90250155de6d7e7);
                            await this.dispose();
                        }
                    } else await this.dispose();
                } else if (button.hasClass($86064bbed7170646$export$d90250155de6d7e7)) button.removeClass($86064bbed7170646$export$d90250155de6d7e7);
                else button.addClass($86064bbed7170646$export$d90250155de6d7e7);
                this.onSelect(entry);
            }, true);
            if (entry.description) {
                button.addClass($86064bbed7170646$export$51987bb50e1f6752);
                //language=HTML
                button.append(`
                    <div class="${$86064bbed7170646$export$6d59db4903f20f7d}">
                        ${entry.description}
                    </div>
                `);
            }
            this.buttonsComponents.push(button);
        });
    }
    calcMiddle() {
        return this.component.getOffsets().left;
    }
    /**
     * override
     */ onSelect(entry) {}
    constructor(component, settings, selectedValue){
        super(component, 0, settings.width ? settings.width : component.getWidth());
        this.settings = settings;
        this.buttonsComponents = [];
        this.typedWord = "";
        if (this.settings.entries.length > 0) this.selectedValue = selectedValue;
        //language=HTML
        this.template = `
            <div class="${$86064bbed7170646$export$d1d55afab036cac2}">
                <div class="${$86064bbed7170646$export$c6d40e657c4cb32e}">
                    <div class="${$86064bbed7170646$export$151a98b9b0a52b4e}"></div>
                </div>
            </div>
        `;
        this.mobileStyle(true);
        this.autoMaxHeight(true);
    }
}



var $5FliW = parcelRequire("5FliW");
class $e405542e42644909$export$32ca16bda187b168 extends (0, $fsnB5.Component) {
    commit() {
        this.selectIcon = this.el($d86d6bc815a51e30$export$aa5fcd1d589f5ce8);
        this.selectedContainer = this.el($d86d6bc815a51e30$export$542cf336a574a3f8);
        this.onClick(()=>this.renderPicker());
        this.onRemove(()=>{
            if (this.pickerComponent != undefined && !this.pickerComponent.isNull()) this.pickerComponent.remove();
        });
        this.renderSelection();
        super.commit();
    }
    select(value) {
        if (this.settings.entries.length > 0) {
            let entry = this.settings.entries.filter((entry)=>entry.value == value)[0];
            if (entry != undefined) {
                if (!this.settings.multiple) {
                    if (this.settings.selectedValueNullable && this.selectedValue == entry.value) this.selectedValue = undefined;
                    else this.selectedValue = entry.value;
                } else {
                    let values = this.selectedValue;
                    let v = entry.value;
                    if (values.indexOf(v) >= 0) values.splice(values.indexOf(v), 1);
                    else this.selectedValue.push("" + entry.value);
                }
                this.renderSelection();
            }
        }
    }
    renderSelection() {
        if (!this.settings.multiple) this.selectedContainer.setHtml(this.settings.previewIsValue ? this.getSelection().value : this.getSelection().label);
        else if (this.getSelections().length > 0) this.selectedContainer.setHtml(this.getSelections().map((value)=>value.label).join(", "));
        else this.selectedContainer.setHtml(this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none"));
    }
    renderPicker() {
        if (this.pickerComponent != undefined && !this.pickerComponent.isNull()) this.pickerComponent.dispose();
        else {
            this.pickerComponent = new (0, $db38a17dfd6de99c$export$76cac35af4870249)(this.selectedContainer, this.settings, this.selectedValue);
            this.pickerComponent.screen(false);
            this.pickerComponent.onOutsideClick(()=>this.pickerComponent.dispose());
            this.pickerComponent.create();
            this.pickerComponent.onSelect = (entry)=>{
                if (this.beforeSelect(entry)) {
                    this.select("" + entry.value);
                    this.onSelect(entry);
                }
            };
        }
    }
    getSelection() {
        if (this.settings.multiple) {
            let selectedValues = this.selectedValue;
            if (this.settings.entries.length == 0 || (!selectedValues || selectedValues.length == 0) && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) // @ts-ignore
            return [
                {
                    value: undefined,
                    label: this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none")
                }
            ];
            else {
                if (!selectedValues) return [
                    this.settings.entries[0]
                ];
                else // @ts-ignore
                return selectedValues.map((value)=>{
                    return this.settings.entries.find((entry)=>entry.value == value);
                });
            }
        } else {
            let selectedValue = this.selectedValue;
            if (this.settings.entries.length == 0 || !selectedValue && this.settings.selectedValueNullable != undefined && this.settings.selectedValueNullable == true) return {
                value: undefined,
                label: this.settings.noneText ? this.settings.noneText : (0, $5FliW.Resources).t("words.none")
            };
            else {
                var _this_settings_entries_find;
                if (!selectedValue) return this.settings.entries[0];
                else return (_this_settings_entries_find = this.settings.entries.find((value)=>value.value == selectedValue)) !== null && _this_settings_entries_find !== void 0 ? _this_settings_entries_find : this.settings.entries[0];
            }
        }
    }
    getSelections() {
        return this.getSelection();
    }
    classDisable() {
        this.addClass($d86d6bc815a51e30$export$683472f6198a076e);
    }
    /**
     * override
     *
     */ beforeSelect(entry) {
        return true;
    }
    onSelect(entry) {}
    constructor(settings){
        var _this_settings;
        super();
        this.settings = settings;
        this.selectedValue = !this.settings.selectedValue && this.settings.multiple ? [] : this.settings.selectedValue;
        //language=HTML
        this.template = `
            <div ${this.settings.maxHeight ? 'style="height: calc(100% - 8px);"' : ""} data-selectbox="true"
                 class="${$d86d6bc815a51e30$export$b605972fbb5a633b}">
                <div style="font-size: ${(_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.fontSize}px;" class="${$d86d6bc815a51e30$export$542cf336a574a3f8}"></div>
                <div data-selectIcon class="${$d86d6bc815a51e30$export$aa5fcd1d589f5ce8}"></div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");

var $cyFTW = parcelRequire("cyFTW");
/**
 * Permet d'escaper tous les < > etc
 */ function $930edbe9748085c2$export$96b5765c47169ce9(text) {
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}


class $76727da246e74b4f$export$a6f05ece7dba1e5c extends (0, $fsnB5.Component) {
    commit() {
        var _this_p;
        this.input = this.el($f0999943c1731015$export$b7e3ae3d7c15e42e);
        if ((_this_p = this.p) === null || _this_p === void 0 ? void 0 : _this_p.focus) {
            this.input.focusAtEnd();
            this.addClass($f0999943c1731015$export$4c2b230493b2b322);
        }
        if (this.input.getValue().length > 0) this.addClass($f0999943c1731015$export$4c2b230493b2b322);
        this.initEvents();
        if (this.p.type == "tel") this.initTel();
        if (this.p.autoWidth) this.initAutoWidth();
        if (this.p.saveMode) this.initSave();
        super.commit();
    }
    /**
     * init
     */ initEvents() {
        this.checker = ()=>{
            const inputValueLength = this.input.getValue().length;
            if (this.p.required && inputValueLength == 0) return false;
            if (this.p.minLength && inputValueLength < this.p.minLength) return false;
            if (this.p.minLength > 0 && this.input.getValue().replaceAll(" ", "").length == 0) return false;
            return !(this.p.maxLength && inputValueLength > this.p.maxLength);
        };
        this.input.onFocus(()=>this.addClass($f0999943c1731015$export$4c2b230493b2b322));
        this.input.onBlur(()=>{
            if (this.input.getValue().length <= 0) this.removeClass($f0999943c1731015$export$4c2b230493b2b322);
            else this.addClass($f0999943c1731015$export$4c2b230493b2b322);
        });
        this.onKeyUp((key)=>{
            this.input.setValue(this.formatValue(this.input.getValue()));
            if (key.key != "Enter") this.check();
        });
    }
    initTel() {
        let selectBox = new (0, $e405542e42644909$export$32ca16bda187b168)({
            entries: (0, $5FliW.Resources).countries.map((value)=>{
                return {
                    value: value['a2'].toUpperCase(),
                    label: `${value['n']} (${value['a2'].toUpperCase()})`
                };
            }),
            selectedValue: this.telCountry,
            search: true,
            width: 220,
            previewIsValue: true
        });
        //language=HTML
        this.prepend(`
            <div class="${$f0999943c1731015$export$2e6c959c16ff56b8}">
                ${this.draw(selectBox)}
            </div>
        `);
        selectBox.onSelect = (entry)=>{
            this.telCountry = entry.value;
            this.input.setValue(this.formatValue(this.input.getValue()));
            this.check();
        };
    }
    initAutoWidth() {
        this.setStyle(`width: auto;`);
        this.addListener("input", ()=>{
            this.input.setStyle(`width: ${this.contentWidth()}px`);
        });
        this.input.setStyle(`width: ${this.contentWidth()}px`);
    }
    initSave() {
        let edited = false;
        let focused = false;
        this.input.onClick(()=>focused = true);
        this.input.onKeyUp(()=>edited = true);
        this.input.onHotKey("Enter", ()=>{
            this.input.getHTMLElement().blur();
            this.onSave();
        });
        this.input.onOutsideClick(()=>{
            if (focused && edited) this.onSave(true);
            edited = false;
            focused = false;
        });
    }
    /**
     * value
     */ getValue() {
        if (this.p.type == "tel") {
            var _formatter_getNumber;
            let formatter = new (0, $56640966002d6b9b$export$80d8c6912928a4eb)(this.telCountry);
            formatter.input(this.input.getValue());
            return (_formatter_getNumber = formatter.getNumber()) === null || _formatter_getNumber === void 0 ? void 0 : _formatter_getNumber.number;
        }
        return this.input.getValue();
    }
    setValue(value) {
        if (value.length > 0) this.addClass($f0999943c1731015$export$4c2b230493b2b322);
        else this.removeClass($f0999943c1731015$export$4c2b230493b2b322);
        this.input.setValue(value);
        if (this.p.autoWidth) this.input.setStyle(`width: ${this.contentWidth()}px`);
        return (0, $cyFTW.filterXSS)(value);
    }
    formatValue(value) {
        if (this.p.type == "tel") {
            let formatter = new (0, $56640966002d6b9b$export$80d8c6912928a4eb)(this.telCountry);
            let parser = (0, $527cb2cbfc4f8a71$export$da44e4eaa54bc82e)(value);
            return parser ? parser.formatNational() : formatter.input(value);
        }
        return value;
    }
    /**
     * width
     */ contentWidth(placeholder) {
        let temp = document.createElement('span');
        temp.style.font = window.getComputedStyle(this.input.getHTMLElement()).font;
        temp.style.visibility = 'hidden';
        temp.innerHTML = (placeholder ? placeholder : this.input.getValue()).replace(/ /g, '&nbsp;');
        document.body.appendChild(temp);
        let width = temp.offsetWidth + (this.p.paddingLeft ? this.p.paddingLeft * 2 : this.getPaddingWidth() * 10) + 2;
        document.body.removeChild(temp);
        let placeholderWidth = 0;
        if (!placeholder && this.p.placeholder) placeholderWidth = this.contentWidth(this.p.placeholder);
        return (this.input.getValue().length == 0 && width < placeholderWidth && placeholderWidth != 0 ? placeholderWidth : width) + 15;
    }
    /**
     * state
     */ setStateError() {
        this.addClass($f0999943c1731015$export$a3bc9b8ed74fc);
    }
    removeState() {
        this.removeClass($f0999943c1731015$export$a3bc9b8ed74fc);
    }
    /**
     * check
     */ check() {
        if (this.checker() && this.checkerLocal()) this.removeState();
        else this.setStateError();
        return this.isValid();
    }
    checkerLocal() {
        if (this.p.type == "tel") {
            let type = new (0, $56640966002d6b9b$export$80d8c6912928a4eb)(this.telCountry);
            type.input(this.input.getValue());
            return type.isValid();
        }
        return true;
    }
    isValid() {
        return !this.hasClass($f0999943c1731015$export$a3bc9b8ed74fc);
    }
    /**
     * focus
     */ isFocus() {
        return document.activeElement == this.input.getHTMLElement();
    }
    focus() {
        this.input.focusAtEnd();
    }
    /**
     * other
     */ showShadowTooltip(template, color) {
        this.input.showShadowTooltip(template, color);
    }
    /**
     * keys
     */ onKeyUp(func, delay) {
        return this.input.onKeyUp(func, delay);
    }
    onKey(func, delay) {
        return this.input.onKey(func, delay);
    }
    /**
     * override
     */ onSave(outsideClick) {}
    async dispose() {}
    constructor(p){
        super();
        this.p = p;
        if (this.p.type == "tel") {
            let parser = (0, $527cb2cbfc4f8a71$export$da44e4eaa54bc82e)(p.value ? p.value : "");
            this.telCountry = parser ? parser.country : (0, $5FliW.Resources).getCountryCode().toUpperCase();
        }
        //language=HTML
        this.template = `
            <div class="${$f0999943c1731015$export$2ab62eda9e453014} ${p.noBorder ? $f0999943c1731015$export$1fb2911de90ed83f : ""} ${p.bold ? $f0999943c1731015$export$73ba5813cda80a49 : ""} ${p.semiBold ? $f0999943c1731015$export$7e39b47ba949ea16 : ""} ${p.outline ? $f0999943c1731015$export$f9258c55612cbed7 : ""}">
                <div style="font-size: ${p.fontSize ? p.fontSize : 15}px;left: ${p.paddingLeft != undefined ? p.paddingLeft : p.type === "tel" ? 80 : 15}px;"
                     class="${$f0999943c1731015$export$fb184b623420d9be} ${p.noLabel ? $f0999943c1731015$export$1f96961348e52fad : ""}">
                    ${p.placeholder}${p.required ? "*" : ""}
                </div>

                <input style="${p.maxWidth ? `max-width: ${p.maxWidth}px;` : ``}${p.borderRadius ? `border-radius: ${p.borderRadius}px;` : ``}cursor: text;${p.maxHeight ? 'height: calc(100% - 4px) !important;' : ''}font-size: ${p.fontSize ? p.fontSize : 15}px;padding-left: ${p.paddingLeft != undefined ? p.paddingLeft : 15}px; ${p.padding != undefined ? "padding:" + p.padding + "px" : ""}"
                       class="${$f0999943c1731015$export$b7e3ae3d7c15e42e}"
                       ${p.required ? `required` : ``}
                       ${p.disabled ? `disabled` : ``}
                       ${p.minNumber ? `min="${p.minNumber}"` : ``}
                       ${p.maxNumber ? `max="${p.maxNumber}"` : ``}
                       ${p.value ? `value="${(0, $930edbe9748085c2$export$96b5765c47169ce9)(this.formatValue(p.value))}"` : ``}
                       ${p.noLabel && p.placeholder ? `placeholder="${p.placeholder}"` : ``}
                       ${p.type ? `type="${p.type}"` : ``}
                       spellcheck="false"/>
            </div>
        `;
        (0, $nyKU9.SedestralMachine).inputs.push(this);
        this.onRemove(()=>(0, $nyKU9.SedestralMachine).inputs.splice((0, $nyKU9.SedestralMachine).inputs.indexOf(this)));
    }
}



var $5FliW = parcelRequire("5FliW");

var $dc4983938ef4c08f$export$a7617739149c6d10;
var $dc4983938ef4c08f$export$86201b36d8e19735;
var $dc4983938ef4c08f$export$e88cb2efb12ae807;
$dc4983938ef4c08f$export$a7617739149c6d10 = "WM8X6";
$dc4983938ef4c08f$export$86201b36d8e19735 = "Ylxmj";
$dc4983938ef4c08f$export$e88cb2efb12ae807 = "eudQO";



var $fsnB5 = parcelRequire("fsnB5");
class $5e8508c6a4affdf8$export$405ce769029154bc extends (0, $fsnB5.Component) {
    commit() {
        this.bind();
        super.commit();
    }
    bind() {
        this.onClick(()=>{
            this.stateChange(!this.checked);
        }, true);
    }
    /**
     * state
     */ stateChange(checked, noCallback) {
        this.checked = checked;
        this.stateChangeClass();
        if (!noCallback) {
            if (checked) this.onCheck();
            else this.onUnCheck();
            this.onStateChange(checked);
        }
    }
    stateAuto() {
        this.stateChange(!this.checked);
    }
    stateChangeClass() {
        this.removeAttribute("checked");
        this.removeAttribute("unchecked");
        this.setAttribute(this.state(), "");
    }
    state() {
        return this.checked ? "checked" : "unchecked";
    }
    /**
     * override
     */ onCheck() {}
    onUnCheck() {}
    onStateChange(checked) {}
    constructor(checked){
        super();
        this.checked = checked;
    }
}


class $b8020928b8e0d47d$export$667c5478f6e1eafe extends (0, $5e8508c6a4affdf8$export$405ce769029154bc) {
    constructor(checked, checker){
        super(checked);
        //language=HTML
        this.template = `
            <div btnCheckBox class="${$dc4983938ef4c08f$export$a7617739149c6d10} ${checker ? $dc4983938ef4c08f$export$86201b36d8e19735 : ``}" ${this.state()}>
                <div btnCheckBoxCaret class="${$dc4983938ef4c08f$export$e88cb2efb12ae807}"></div>
            </div>
        `;
    }
}



var $7AbeR = parcelRequire("7AbeR");


var $5FliW = parcelRequire("5FliW");

var $1b6Hd = parcelRequire("1b6Hd");
function $c675d49824235e50$export$4e4cb19dd88cd821(date, hour) {
    let options = {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    };
    if (hour) {
        options['hour'] = "2-digit";
        options['minute'] = "2-digit";
        options['hour12'] = (0, $1b6Hd.PreferencesService).hour12;
    }
    return new Intl.DateTimeFormat((0, $5FliW.Resources).language, options).format(date);
}
function $c675d49824235e50$export$1aac387c4ed0273c(date) {
    let options = {};
    options['hour'] = "2-digit";
    options['minute'] = "2-digit";
    options['hour12'] = (0, $1b6Hd.PreferencesService).hour12;
    return new Intl.DateTimeFormat((0, $5FliW.Resources).language, options).format(date);
}


var $0f280d51825a9a93$export$50ba419e547989b9 = /*#__PURE__*/ function(OfferPaymentActionType) {
    OfferPaymentActionType[OfferPaymentActionType["PAYMENT"] = 0] = "PAYMENT";
    OfferPaymentActionType[OfferPaymentActionType["INTENT"] = 1] = "INTENT";
    OfferPaymentActionType[OfferPaymentActionType["NONE"] = 2] = "NONE";
    return OfferPaymentActionType;
}({});




var $fsnB5 = parcelRequire("fsnB5");
var $de6749ba25f084dc$export$aaa2fdfbe3211bee;
var $de6749ba25f084dc$export$1237798dc640739a;
var $de6749ba25f084dc$export$6170c7625ed1f3cc;
var $de6749ba25f084dc$export$72108e4fb43880e3;
$de6749ba25f084dc$export$aaa2fdfbe3211bee = "zOxDG";
$de6749ba25f084dc$export$1237798dc640739a = "_8ZWTx";
$de6749ba25f084dc$export$6170c7625ed1f3cc = "kXdyw";
$de6749ba25f084dc$export$72108e4fb43880e3 = "dcUax";


var $e1507b7504c68d44$export$cb01125cc4e845f0;
var $e1507b7504c68d44$export$a4510362933968c8;
$e1507b7504c68d44$export$cb01125cc4e845f0 = "osy8p";
$e1507b7504c68d44$export$a4510362933968c8 = "ER-w7";



var $fsnB5 = parcelRequire("fsnB5");


var $3uVji = parcelRequire("3uVji");

var $5FliW = parcelRequire("5FliW");
class $6c7c285de2ff33f9$export$143c167d2a04bd23 extends (0, $fsnB5.Component) {
    commit() {
        var _this_settings;
        super.commit();
        this.selectBox = new (0, $e405542e42644909$export$32ca16bda187b168)((0, $3uVji.objectUpdate)(this.settings ? this.settings : {}, {
            entries: (0, $5FliW.Resources).countries.filter((l)=>!this.filters || this.filters.includes(l.a2)).map((v)=>{
                return {
                    label: v.n,
                    value: v.a2
                };
            }),
            selectedValue: this.value,
            search: ((_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.search) != undefined ? this.settings.search : true
        }));
        this.selectBox.onSelect = (entry)=>this.onSelect(entry.value);
        this.clearAll();
        this.render(this.selectBox);
    }
    onSelect(language) {}
    constructor(value, settings, filters){
        super();
        this.value = value;
        this.settings = settings;
        this.filters = filters;
        //language=HTML
        this.template = `
            <div class="${$e1507b7504c68d44$export$cb01125cc4e845f0}"></div>
        `;
    }
}



var $68Z0d = parcelRequire("68Z0d");


var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");


var $fdmdr = parcelRequire("fdmdr");


var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");
var $c55a05b001b5e6d6$export$e6f751ba8af48c04;
var $c55a05b001b5e6d6$export$6e22c362a0406a2c;
$c55a05b001b5e6d6$export$e6f751ba8af48c04 = "jNb2G";
$c55a05b001b5e6d6$export$6e22c362a0406a2c = "LRXto";



var $7AbeR = parcelRequire("7AbeR");
class $8f5af7753071df31$export$3a3ab308824b90fa extends (0, $fsnB5.Component) {
    constructor(code){
        super();
        if (code) {
            code = code.toUpperCase();
            //language=HTML
            this.template = `
                <div style="background: url('${(0, $7AbeR.Network).vendor + "countries/flags/" + code + ".svg"}'); background-size: contain;"
                     class="${$c55a05b001b5e6d6$export$e6f751ba8af48c04}">
                </div>
            `;
        } else //language=HTML
        this.template = `
                <div class="${$c55a05b001b5e6d6$export$e6f751ba8af48c04}">
                    <div class="${$c55a05b001b5e6d6$export$6e22c362a0406a2c}"></div>
                </div>
            `;
    }
}


var $6e5311f41eea8bdd$export$7323b7ababca8042;
var $6e5311f41eea8bdd$export$edc875d7f22c9a5b;
$6e5311f41eea8bdd$export$7323b7ababca8042 = "uGsry";
$6e5311f41eea8bdd$export$edc875d7f22c9a5b = "E-t4F";



var $68Z0d = parcelRequire("68Z0d");
class $8f959f87bab975eb$export$d347b2ed4a8490cf extends (0, $fsnB5.Component) {
    commit() {
        this.init();
        super.commit();
    }
    async init() {
        this.taxes = await (0, $fdmdr.SiteService).getTaxTypes(this);
        let entries = [];
        let selectedValue;
        this.taxes.forEach((value)=>{
            var _EntityService_activeSite_address_tax, _EntityService_activeSite_address, _EntityService_activeSite_address_tax1, _EntityService_activeSite_address1, _EntityService_activeSite_address2;
            let country = (0, $5FliW.Resources).country(value.country);
            var _country_n;
            entries.push({
                value: value.id,
                label: (country ? `<div class="${$6e5311f41eea8bdd$export$edc875d7f22c9a5b}">${this.draw(new (0, $8f5af7753071df31$export$3a3ab308824b90fa)(country.a3))}</div> ` : ``) + value.label,
                description: (_country_n = country === null || country === void 0 ? void 0 : country.n) !== null && _country_n !== void 0 ? _country_n : value.country
            });
            var _EntityService_activeSite_address_country;
            if ((_EntityService_activeSite_address = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address === void 0 ? void 0 : (_EntityService_activeSite_address_tax = _EntityService_activeSite_address.tax) === null || _EntityService_activeSite_address_tax === void 0 ? void 0 : _EntityService_activeSite_address_tax.type) selectedValue = (_EntityService_activeSite_address1 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address1 === void 0 ? void 0 : (_EntityService_activeSite_address_tax1 = _EntityService_activeSite_address1.tax) === null || _EntityService_activeSite_address_tax1 === void 0 ? void 0 : _EntityService_activeSite_address_tax1.type;
            else if ((country === null || country === void 0 ? void 0 : country.a2) == ((_EntityService_activeSite_address_country = (_EntityService_activeSite_address2 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address2 === void 0 ? void 0 : _EntityService_activeSite_address2.country) !== null && _EntityService_activeSite_address_country !== void 0 ? _EntityService_activeSite_address_country : (0, $5FliW.Resources).getCountryCode())) selectedValue = value.id;
        });
        this.clearAll();
        this.selectBox = new (0, $e405542e42644909$export$32ca16bda187b168)({
            search: true,
            searchDescription: true,
            entries: entries,
            selectedValue: selectedValue
        });
        this.render(this.selectBox);
    }
    getSelectedTax() {
        return this.taxes.find((value)=>value.id == this.selectBox.getSelection().value);
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$6e5311f41eea8bdd$export$7323b7ababca8042}">
                ${this.draw(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)())}
            </div>
        `;
    }
}


class $937f360d3eafb541$export$ec80a8c98df77cb5 extends (0, $fsnB5.Component) {
    getAddress() {
        return {
            city: this.cityInput.getValue(),
            country: this.countryPicker.selectBox.getSelection().value,
            line1: this.line1Input.getValue(),
            line2: this.line2Input.getValue(),
            name: this.nameInput.getValue(),
            postalCode: this.postalCodeInput.getValue(),
            state: this.stateInput.getValue(),
            tax: this.taxInput.getValueTrim().length > 0 ? {
                code: this.taxInput.getValue(),
                type: this.taxPicker.getSelectedTax().id
            } : undefined
        };
    }
    constructor(){
        var _EntityService_activeSite_address, _EntityService_activeSite_address1, _EntityService_activeSite_address2, _EntityService_activeSite_address3, _EntityService_activeSite_address4, _EntityService_activeSite_address5, _EntityService_activeSite_address6, _EntityService_activeSite_address7, _EntityService_activeSite_address_tax, _EntityService_activeSite_address8;
        super();
        this.countryPicker = new (0, $6c7c285de2ff33f9$export$143c167d2a04bd23)(((_EntityService_activeSite_address = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address === void 0 ? void 0 : _EntityService_activeSite_address.country) ? (_EntityService_activeSite_address1 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address1 === void 0 ? void 0 : _EntityService_activeSite_address1.country : (0, $5FliW.Resources).getCountryCode());
        this.nameInput = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $5FliW.Resources).t("words.name"),
            value: (_EntityService_activeSite_address2 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address2 === void 0 ? void 0 : _EntityService_activeSite_address2.name
        });
        this.line1Input = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $5FliW.Resources).t("words.address"),
            value: (_EntityService_activeSite_address3 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address3 === void 0 ? void 0 : _EntityService_activeSite_address3.line1
        });
        this.line2Input = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            placeholder: (0, $5FliW.Resources).t("words.addressDetails"),
            value: (_EntityService_activeSite_address4 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address4 === void 0 ? void 0 : _EntityService_activeSite_address4.line2
        });
        this.postalCodeInput = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $5FliW.Resources).t("words.zipCode"),
            value: (_EntityService_activeSite_address5 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address5 === void 0 ? void 0 : _EntityService_activeSite_address5.postalCode
        });
        this.cityInput = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            required: true,
            placeholder: (0, $5FliW.Resources).t("words.city"),
            value: (_EntityService_activeSite_address6 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address6 === void 0 ? void 0 : _EntityService_activeSite_address6.city
        });
        this.stateInput = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            placeholder: (0, $5FliW.Resources).t("words.addressState"),
            value: (_EntityService_activeSite_address7 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address7 === void 0 ? void 0 : _EntityService_activeSite_address7.state
        });
        this.taxInput = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            placeholder: (0, $5FliW.Resources).t("words.number"),
            value: (_EntityService_activeSite_address8 = (0, $68Z0d.EntityService).activeSite.address) === null || _EntityService_activeSite_address8 === void 0 ? void 0 : (_EntityService_activeSite_address_tax = _EntityService_activeSite_address8.tax) === null || _EntityService_activeSite_address_tax === void 0 ? void 0 : _EntityService_activeSite_address_tax.code
        });
        this.taxPicker = new (0, $8f959f87bab975eb$export$d347b2ed4a8490cf)();
        //language=HTML
        this.template = `
            <div class="${$de6749ba25f084dc$export$aaa2fdfbe3211bee}">
                <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                    ${this.draw(this.nameInput)}
                </div>
                <div>
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.line1Input)}
                    </div>
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.line2Input)}
                    </div>
                </div>
                <div class="${$de6749ba25f084dc$export$6170c7625ed1f3cc}">
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.postalCodeInput)}
                    </div>
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.cityInput)}
                    </div>
                </div>
                <div class="${$de6749ba25f084dc$export$6170c7625ed1f3cc}">
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.stateInput)}
                    </div>
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.countryPicker)}
                    </div>
                </div>
                <div class="${$de6749ba25f084dc$export$1237798dc640739a}">
                    ${(0, $5FliW.Resources).t("words.optionalTaxNumber")}
                </div>
                <div class="${$de6749ba25f084dc$export$6170c7625ed1f3cc}">
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.taxPicker)}
                    </div>
                    <div class="${$de6749ba25f084dc$export$72108e4fb43880e3}">
                        ${this.draw(this.taxInput)}
                    </div>
                </div>
            </div>
        `;
    }
}




var $68Z0d = parcelRequire("68Z0d");

var $32rNO = parcelRequire("32rNO");

var $5FliW = parcelRequire("5FliW");
var $ce8a18c9c407f030$export$6fdb7f490b0acb5b = /*#__PURE__*/ function(OfferProductSolutionType) {
    OfferProductSolutionType[OfferProductSolutionType["ACCOUNT"] = 0] = "ACCOUNT";
    OfferProductSolutionType[OfferProductSolutionType["LIVECHAT"] = 1] = "LIVECHAT";
    OfferProductSolutionType[OfferProductSolutionType["MAILS"] = 2] = "MAILS";
    OfferProductSolutionType[OfferProductSolutionType["IA"] = 3] = "IA";
    OfferProductSolutionType[OfferProductSolutionType["SITE_CHANNEL"] = 4] = "SITE_CHANNEL";
    OfferProductSolutionType[OfferProductSolutionType["COMMUNITY"] = 5] = "COMMUNITY";
    OfferProductSolutionType[OfferProductSolutionType["AI_CONTENT"] = 6] = "AI_CONTENT";
    OfferProductSolutionType[OfferProductSolutionType["AUTOPILOT"] = 7] = "AUTOPILOT";
    OfferProductSolutionType[OfferProductSolutionType["WRITING_STYLE"] = 8] = "WRITING_STYLE";
    OfferProductSolutionType[OfferProductSolutionType["SEO_RANKING"] = 9] = "SEO_RANKING";
    OfferProductSolutionType[OfferProductSolutionType["SEO_CLUSTER"] = 10] = "SEO_CLUSTER";
    OfferProductSolutionType[OfferProductSolutionType["SEO_AUDIT"] = 11] = "SEO_AUDIT";
    OfferProductSolutionType[OfferProductSolutionType["OPTIMIZATION_CONTENT"] = 12] = "OPTIMIZATION_CONTENT";
    OfferProductSolutionType[OfferProductSolutionType["BRIEF_CONTENT"] = 13] = "BRIEF_CONTENT";
    return OfferProductSolutionType;
}({});


var $d29384eb3821c3f1$export$6913bb0f068db6f0 = /*#__PURE__*/ function(IOfferContentsTableIcon) {
    IOfferContentsTableIcon[IOfferContentsTableIcon["WORDPRESS"] = 0] = "WORDPRESS";
    IOfferContentsTableIcon[IOfferContentsTableIcon["SHOPIFY"] = 1] = "SHOPIFY";
    IOfferContentsTableIcon[IOfferContentsTableIcon["WIX"] = 2] = "WIX";
    IOfferContentsTableIcon[IOfferContentsTableIcon["PRESTASHOP"] = 3] = "PRESTASHOP";
    IOfferContentsTableIcon[IOfferContentsTableIcon["WEBFLOW"] = 4] = "WEBFLOW";
    return IOfferContentsTableIcon;
}({});


class $bc6537ccb176bcc0$export$b6ed60a23ae88524 {
    static table(templates) {
        let table = [
            {
                name: (0, $5FliW.Resources).t("words.briefContentSeoWriting"),
                entries: [],
                description: (0, $5FliW.Resources).t("words.briefContentSeoWritingDescription"),
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).BRIEF_CONTENT,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.automaticOptimization"),
                entries: [],
                description: (0, $5FliW.Resources).t("words.automaticOptimizationDescription"),
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).OPTIMIZATION_CONTENT,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.seoOptimizedBlogContents"),
                entries: [],
                description: (0, $5FliW.Resources).t("words.generateContentDescription"),
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).AI_CONTENT,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.topicsAndClusters"),
                entries: [],
                description: (0, $5FliW.Resources).t("words.topicsAndClustersDescription"),
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).SEO_CLUSTER,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.seoAuditName"),
                entries: [],
                description: (0, $5FliW.Resources).t("words.seoAuditDescription"),
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).SEO_AUDIT,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.teamMembers"),
                entries: [
                    {
                        value: `<span>1</span> ${(0, $5FliW.Resources).t("words.singleMember")}`
                    },
                    {
                        value: `<span>3</span> ${(0, $5FliW.Resources).t("words.multipleMembers")}`
                    },
                    {
                        value: `<span>10</span> ${(0, $5FliW.Resources).t("words.multipleMembers")}`
                    }
                ],
                entriesCustom: true,
                description: (0, $5FliW.Resources).t("words.teamMembersDescription"),
                solutionType: undefined,
                addToContents: true,
                type: "text"
            },
            {
                name: (0, $5FliW.Resources).t("words.competitorAnalysis"),
                description: (0, $5FliW.Resources).t("words.analyzeCompetitorsDescription"),
                addToContents: true,
                entries: [],
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).SEO_RANKING,
                type: "bool",
                boolMin: 1
            },
            {
                name: (0, $5FliW.Resources).t("words.multiLanguageSites"),
                description: (0, $5FliW.Resources).t("words.generateMultiLangContentDescription"),
                entries: [],
                addToContents: true,
                solutionType: (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).COMMUNITY,
                type: "textBool",
                boolMin: 1
            },
            {
                name: (0, $5FliW.Resources).t("words.integrationWithYourSite"),
                description: (0, $5FliW.Resources).t("words.connectYourSiteDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool",
                icons: [
                    (0, $d29384eb3821c3f1$export$6913bb0f068db6f0).PRESTASHOP,
                    (0, $d29384eb3821c3f1$export$6913bb0f068db6f0).SHOPIFY,
                    (0, $d29384eb3821c3f1$export$6913bb0f068db6f0).WORDPRESS,
                    (0, $d29384eb3821c3f1$export$6913bb0f068db6f0).WIX,
                    (0, $d29384eb3821c3f1$export$6913bb0f068db6f0).WEBFLOW
                ]
            },
            {
                name: (0, $5FliW.Resources).t("words.seoPositionTracking"),
                description: (0, $5FliW.Resources).t("words.seoPositionTrackingDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.textHumanization"),
                description: (0, $5FliW.Resources).t("words.textHumanizationDescription"),
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.autopilot"),
                description: (0, $5FliW.Resources).t("words.automaticPilotDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.keywordResearch"),
                description: (0, $5FliW.Resources).t("words.keywordResearchDescription"),
                entries: [],
                addToContents: true,
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.internalLinks"),
                description: (0, $5FliW.Resources).t("words.internalLinksDescription"),
                entries: [],
                addToContents: true,
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.googleSearchConsole"),
                description: (0, $5FliW.Resources).t("words.googleSearchConsoleDescription"),
                entries: [],
                solutionType: undefined,
                type: "bool"
            },
            {
                name: (0, $5FliW.Resources).t("words.onboardingHelp"),
                description: (0, $5FliW.Resources).t("words.contactUsForAssistanceDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool"
            }
        ];
        templates.forEach((product)=>{
            let bundle = product.bundles[0];
            table.forEach((tableLine)=>{
                let solution = bundle.solutions.find((value)=>value.type == tableLine.solutionType);
                let entry = {
                    templateId: product.id
                };
                switch(tableLine.type){
                    case "text":
                        if (solution) entry.value = `<span>${solution.quantityInitial}</span> ${(0, $5FliW.Resources).t(`words.offerSolution${product.type}${product.productType}${solution.type}`)}`;
                        break;
                    case "textBool":
                        if (solution && solution.quantityInitial > tableLine.boolMin) entry.value = `<span>${solution.quantityInitial}</span> ${(0, $5FliW.Resources).t(`words.offerSolution${product.type}${product.productType}${solution.type}`)}`;
                        break;
                    case "bool":
                        if (solution) {
                            if (solution.quantityInitial > tableLine.boolMin) entry.value = true;
                        } else entry.value = true;
                        break;
                }
                if (!tableLine.entriesCustom) tableLine.entries.push(entry);
            });
        });
        return table;
    }
    static hiddenTypes() {
        return [
            (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).SEO_RANKING,
            (0, $ce8a18c9c407f030$export$6fdb7f490b0acb5b).WRITING_STYLE
        ];
    }
    static popularTemplates() {
        return [
            "17778c6ca54349a69a4999ca218aced9"
        ];
    }
    static contents(baseContents, template) {
        let table = this.table([
            template
        ]);
        table.forEach((tableLine)=>{
            if (tableLine.addToContents) {
                var _tableLine_entries_find;
                let value = (_tableLine_entries_find = tableLine.entries.find((value)=>value.templateId == template.id)) === null || _tableLine_entries_find === void 0 ? void 0 : _tableLine_entries_find.value;
                if (value !== undefined) {
                    if (!value || tableLine.type == "bool") value = tableLine.name;
                    baseContents.push(value);
                }
            }
        });
        return baseContents;
    }
}


class $22f9cb9201e3dccd$export$958f4fee317b0b7c extends (0, $fsnB5.Component) {
    commit() {
        this.renderAll();
        this.scrollable();
        super.commit();
    }
    renderAll() {
        this.renderBack((0, $5FliW.Resources).t(`words.offerBack`));
        this.renderOfferContent();
        this.renderAddress();
        this.renderAdvantageCode();
        if (this.quote.offer.startDate > Date.now()) this.renderScheduled();
        this.renderPrice();
    }
    renderBack(text) {
        if (!this.quote.offer.active) {
            //language=HTML
            this.backButton = this.append(`
                <div class="${$67559bb61cc9bc51$export$7c341cb16fc91138}">
                    <div class="${$67559bb61cc9bc51$export$1ca1ec8b29a4ce27}"></div>
                    ${text}
                </div>
            `);
            this.backButton.onClick(async ()=>this.back());
        } else this.append(`
            <div class="${$67559bb61cc9bc51$export$7c341cb16fc91138}"></div>
        `);
    }
    renderOfferContent() {
        let contents = this.bundle.solutions.filter((solution)=>!(0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type)).filter((solution)=>solution.quantity > 0).map((solution)=>`${solution.quantity} ${(0, $5FliW.Resources).t(`words.offerSolution${this.product.template.type}${this.product.template.productType}${solution.type}`)}`);
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$8f981dffec84ba52}">
                <div class="${$67559bb61cc9bc51$export$ce69bd05624d0c48}">
                    <div class="${$67559bb61cc9bc51$export$acf4eaf431084f78}">
                        ${this.draw(new (0, $f49d8292e8bb8162$export$e11200deb10216e7)(this.product.template.type))}
                    </div>
                    <div class="${$67559bb61cc9bc51$export$a8ff84c12d48cfa6}">
                        ${(0, $5FliW.Resources).t(`words.offer`)} ${(0, $5FliW.Resources).t(`words.offerName${this.product.template.type}`)}
                    </div>
                </div>
                ${this.draw(new (0, $bd33c90c0ceb36a8$export$48a3aac3632ef8)((0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).contents(contents, this.product.template), (0, $5FliW.Resources).t("words.offerContentRecap")))}
            </div>
        `);
    }
    renderAddress() {
        this.cgvButton = new (0, $b8020928b8e0d47d$export$667c5478f6e1eafe)(false);
        this.addressComponent = new (0, $937f360d3eafb541$export$ec80a8c98df77cb5)();
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$7b388ca536128c6d}">
                ${this.paymentProvider.address ? `
                <div class="${$67559bb61cc9bc51$export$1237798dc640739a}">
                    ${(0, $5FliW.Resources).t("words.offerWriteAddress")}
                </div>
                ${this.draw(this.addressComponent)}
            ` : ''}

                <div class="${$67559bb61cc9bc51$export$1237798dc640739a}">
                    <a href="${(0, $7AbeR.Network).router.pages.getWebsiteUrl('cgv')}" target="_blank">
                        ${(0, $5FliW.Resources).t("words.offerCgv")}
                    </a>
                    <span>${this.draw(this.cgvButton)}</span>
                </div>
            </div>
        `);
    }
    renderAdvantageCode() {
        this.advantageCode = new (0, $76727da246e74b4f$export$a6f05ece7dba1e5c)({
            placeholder: (0, $5FliW.Resources).t("words.offerApplyAdvantageCodeInput")
        });
        //language=HTML
        this.append(`<div class="${$67559bb61cc9bc51$export$18f552c4c727aeb5}">
                ${this.displayPromoCodeInput ? `
                    <div>${(0, $5FliW.Resources).t("words.offerApplyAdvantageCode")}</div>
                    <div class="${$67559bb61cc9bc51$export$72108e4fb43880e3}">
                        ${this.draw(this.advantageCode)}
                    </div> ` : ''}
            </div>`);
    }
    renderScheduled() {
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$49c44dfc2bb21d70}">
                ${(0, $5FliW.Resources).t("words.offerTakeEffectAt")} ${(0, $c675d49824235e50$export$4e4cb19dd88cd821)(new Date(this.quote.offer.startDate))}
            </div>
        `);
    }
    renderPrice(fixedPrice, text) {
        this.priceComponent = new (0, $cd4983a2f3152f9d$export$19746147d1b55543)({
            period: {
                periodType: this.quote.offer.periodType,
                advantagePercentage: this.quote.offer.advantagePercentage
            },
            price: fixedPrice ? fixedPrice : this.quote.offer.totalPrice,
            noCalculateYear: true,
            text: text ? text : (0, $5FliW.Resources).t("words.continue"),
            totalPrice: fixedPrice != undefined
        });
        this.priceComponent.onGetStarted = async ()=>this.getStarted();
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$74d6ad014ec5fd29}">
                ${this.draw(this.priceComponent)}
            </div>
        `);
    }
    async back() {
        this.clearAll();
        this.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
        await (0, $6552c5473243fcef$export$a047eb6606b2561b).quoteCancel(this);
        this.onStep();
    }
    async getStarted() {
        if (!this.cgvButton.checked) (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.offerAcceptCgv"), undefined, 3000);
        else {
            this.priceComponent.setLoading();
            let quote = await (0, $6552c5473243fcef$export$a047eb6606b2561b).quoteConfirmed({
                offerId: this.quote.offer.id,
                address: this.paymentProvider.address ? this.addressComponent.getAddress() : undefined,
                advantageCode: this.displayPromoCodeInput && this.advantageCode.getValue().length > 0 ? this.advantageCode.getValue() : undefined
            }, this);
            if (quote) {
                var _quote_payment;
                await (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).token();
                if (this.paymentProvider.id == (0, $32rNO.PaymentProviderType).STRIPE && ((_quote_payment = quote.payment) === null || _quote_payment === void 0 ? void 0 : _quote_payment.actionType) == (0, $0f280d51825a9a93$export$50ba419e547989b9).NONE) await this.startStripePayCheck(quote.offer);
                else {
                    this.onStep(quote);
                    this.priceComponent.remLoading();
                }
            } else this.priceComponent.remLoading();
        }
    }
    scheduleExpiredQuote() {
        if (this.quote.offer.expiredTime > 0) {
            let time = this.quote.offer.expiredTime - Date.now();
            this.timeOut(()=>this.back(), time);
        }
    }
    async startStripePayCheck(offerQuote) {
        if (offerQuote.state === (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).SCHEDULED) {
            this.onCloseModal();
            (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.offerNowScheduled"), undefined, 3000, "success");
            await this.reloadOrRedirect();
        } else {
            let intervalCount = 0;
            let interval = this.interval(async ()=>{
                if (intervalCount >= 3) {
                    (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.errorMessage"), undefined, 3000);
                    clearInterval(interval);
                    this.priceComponent.remLoading();
                    return;
                }
                intervalCount++;
                let offerDetails = await (0, $6552c5473243fcef$export$a047eb6606b2561b).active(false, this);
                if (offerDetails && offerDetails.offer.id == offerQuote.id) {
                    clearInterval(interval);
                    this.onCloseModal();
                    (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.offerNowActive"), undefined, 3000, "success");
                    await this.reloadOrRedirect();
                }
            }, 7000);
            this.priceComponent.setLoading();
        }
    }
    onStep(details) {}
    onCloseModal() {}
    async reloadOrRedirect() {
        if ((0, $7AbeR.Network).router.pages.getPath().includes("/b/home/content/subscriptions/home")) await (0, $7AbeR.Network).router.pages.reload();
        else await (0, $7AbeR.Network).router.pages.redirect("/b/home/content/subscriptions/home");
    }
    constructor(productType, quote){
        super();
        this.productType = productType;
        this.quote = quote;
        this.paymentProvider = (0, $68Z0d.EntityService).activeSite.paymentProvider;
        var _EntityService_activeEntity_displayPromoCodeInput;
        this.displayPromoCodeInput = (_EntityService_activeEntity_displayPromoCodeInput = (0, $68Z0d.EntityService).activeEntity.displayPromoCodeInput) !== null && _EntityService_activeEntity_displayPromoCodeInput !== void 0 ? _EntityService_activeEntity_displayPromoCodeInput : false;
        this.product = this.quote.offer.products[this.productType];
        this.bundle = this.quote.offer.products[this.productType].bundles[0];
        this.bundleTemplate = this.quote.offer.products[this.productType].template[0];
        //language=HTML
        this.template = `
            <div class="${$67559bb61cc9bc51$export$1c80ec59d1789323}"></div>`;
    }
}






var $5FliW = parcelRequire("5FliW");



/**
 * Retourne les codes de mois entre deux dates
 */ function $0da9830f22d50126$export$14d4a9b10446dd73(timestamp1, timestamp2) {
    // Création des objets Date à partir des timestamps
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);
    // Calcul des composants année et mois
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();
    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();
    // Calcul de la différence en mois
    return (year2 - year1) * 12 + (month2 - month1);
}



var $5FliW = parcelRequire("5FliW");

function $c2b3d6c0e63b349f$export$afa05e915c2edbb5(details, product) {
    if (details.payment) {
        var _details_payment_nextAdvantages;
        let advantages = (_details_payment_nextAdvantages = details.payment.nextAdvantages) === null || _details_payment_nextAdvantages === void 0 ? void 0 : _details_payment_nextAdvantages.filter((value)=>value.productTemplateId == product.template.id);
        let advantagePercentage = 0;
        let advantageMonths = 0;
        if (advantages && advantages.length > 0) {
            advantagePercentage = advantages[0].advantagePercentage * 100;
            advantageMonths = (0, $0da9830f22d50126$export$14d4a9b10446dd73)(advantages[0].startDate, advantages[0].endDate) - 1;
        }
        let advantageText = advantagePercentage > 0 ? `${advantagePercentage}% ${(0, $5FliW.Resources).t("words.offerAdvantageNow")}` : ``;
        if (details.offer.advantageCode && details.offer.periodType == (0, $7c9924087ecfb7dd$export$b7ac94010691eccd).ANNUAL) advantageText = (0, $5FliW.Resources).t("words.offerAdvantageYearApplied");
        return {
            advantageMonths: advantageMonths,
            advantagePercentage: advantagePercentage,
            advantageText: advantageText
        };
    }
}



var $fsnB5 = parcelRequire("fsnB5");


var $5FliW = parcelRequire("5FliW");

var $8hCed = parcelRequire("8hCed");

class $4ce4e5788b3a3309$export$ff62fe619d647b4e extends (0, $fsnB5.Component) {
    commit() {
        super.commit();
        this.init();
    }
    async init() {
        const stripeJs = await (parcelRequire("39pJ6"));
        this.stripe = await stripeJs.loadStripe(undefined, {
            betas: [
                "elements_customers_beta_1"
            ],
            apiVersion: "2024-04-10"
        });
        let customerOptions;
        if (this.secrets.ephemeralKey) customerOptions = {
            ephemeralKey: this.secrets.ephemeralKey,
            customer: this.secrets.customer
        };
        this.stripeElements = this.stripe.elements({
            clientSecret: this.secrets.clientSecret,
            customerOptions: customerOptions
        });
        let paymentElement = this.stripeElements.create('payment');
        paymentElement.mount("#" + this.id);
    }
    async payment() {
        let errorStripe = undefined;
        let successStripe = undefined;
        if (this.actionType === (0, $0f280d51825a9a93$export$50ba419e547989b9).PAYMENT) {
            const paymentIntentResult = await this.stripe.confirmPayment({
                elements: this.stripeElements,
                redirect: "if_required"
            });
            errorStripe = paymentIntentResult.error;
            successStripe = paymentIntentResult.paymentIntent;
        } else if (this.actionType === (0, $0f280d51825a9a93$export$50ba419e547989b9).INTENT) {
            const setupIntentResult = await this.stripe.confirmSetup({
                elements: this.stripeElements,
                redirect: "if_required"
            });
            errorStripe = setupIntentResult.error;
            successStripe = setupIntentResult.setupIntent;
        }
        if (errorStripe) {
            var _errorStripe_message;
            if (errorStripe.code == "payment_intent_unexpected_state") this.onPaid();
            else this.onError(errorStripe.code != "incomplete_number" ? (_errorStripe_message = errorStripe.message) !== null && _errorStripe_message !== void 0 ? _errorStripe_message : (0, $5FliW.Resources).t("words.errorgenericErrorMessage") : undefined);
        } else if (successStripe) this.onPaid();
    }
    onPaid() {}
    onError(error) {}
    constructor(secrets, actionType){
        super();
        this.id = "offer-stripe-component" + (0, $8hCed.randomInteger)(0, 1000000);
        this.secrets = secrets;
        this.actionType = actionType;
        //language=HTML
        this.template = `
            <div id="${this.id}"></div>`;
    }
}


class $6d478d93f91d9a6c$export$97cdf95035444dd8 extends (0, $22f9cb9201e3dccd$export$958f4fee317b0b7c) {
    renderAll() {
        this.renderBack((0, $5FliW.Resources).t("words.offerBackContent"));
        this.renderOfferContent();
        this.renderPriceDetailsCurrent();
        this.renderPriceDetailsNext();
        if (this.quote.payment.actionType !== (0, $0f280d51825a9a93$export$50ba419e547989b9).NONE) this.renderStripe(this.quote.payment.secrets, this.quote.payment.actionType);
        this.renderPrice(this.quote.payment.currentPriceTotal, (0, $5FliW.Resources).t("words.offerPay"));
        this.scheduleExpiredQuote();
    }
    renderPriceDetailsNext() {
        if (!this.quote.offer.active) {
            let advantages = (0, $c2b3d6c0e63b349f$export$afa05e915c2edbb5)(this.quote, this.product);
            this.renderPriceDetails(`${(0, $5FliW.Resources).t("words.offerSince")} ${(0, $c675d49824235e50$export$4e4cb19dd88cd821)(new Date(this.quote.offer.nextBilling))}`, (0, $5FliW.Resources).t(this.quote.offer.periodType == (0, $7c9924087ecfb7dd$export$b7ac94010691eccd).MONTHLY ? "words.offerPaidMonth" : "words.offerPaidYear"), this.quote.payment.nextPriceExcludingTaxEstimate, this.quote.payment.nextPriceIncludingTaxEstimate, (advantages === null || advantages === void 0 ? void 0 : advantages.advantagePercentage) > 0 ? `${advantages.advantagePercentage}% ${(0, $5FliW.Resources).r("words.offerAdvantageMonth", {
                advantageMonths: advantages.advantageMonths
            })}` : ``, (advantages === null || advantages === void 0 ? void 0 : advantages.advantageMonths) > 0 ? this.quote.payment.nextAdvantageEndPriceIncludingTax : undefined, (advantages === null || advantages === void 0 ? void 0 : advantages.advantageMonths) > 0 ? this.quote.payment.nextAdvantageEndPriceExcludingTax : undefined);
        }
    }
    renderPriceDetailsCurrent() {
        let advantages = (0, $c2b3d6c0e63b349f$export$afa05e915c2edbb5)(this.quote, this.product);
        var _advantages_advantageText;
        this.renderPriceDetails(`${(0, $5FliW.Resources).t("words.offerCurrentPeriod")} <span>(${(0, $5FliW.Resources).t("words.from")} ${(0, $c675d49824235e50$export$4e4cb19dd88cd821)(new Date(this.quote.payment.currentPeriodStartDate))} ${(0, $5FliW.Resources).t("words.to")} ${(0, $c675d49824235e50$export$4e4cb19dd88cd821)(new Date(this.quote.payment.currentPeriodEndDate))})</span>`, (0, $5FliW.Resources).t("words.offerCurrentPeriodPaid"), this.quote.payment.currentPriceExcludingTax, this.quote.payment.currentPriceTotal, (_advantages_advantageText = advantages === null || advantages === void 0 ? void 0 : advantages.advantageText) !== null && _advantages_advantageText !== void 0 ? _advantages_advantageText : "", undefined, undefined, this.quote.payment.currentInvoiceUrl);
    }
    renderPriceDetails(title, description, priceVAT, price, advantageText, advantageEndVATPrice, advantageEndTotalPrice, invoiceUrl) {
        //language=HTML
        let details = this.append(`
            <div class="${$67559bb61cc9bc51$export$66fec733742690b6}">
                <div class="${$67559bb61cc9bc51$export$fb184b623420d9be}">
                    ${title}
                    <div class="${$67559bb61cc9bc51$export$6d59db4903f20f7d}">
                        ${description}
                    </div>
                </div>
                ${advantageText ? `<div class="${$67559bb61cc9bc51$export$337d1885ef6f1e24} ${$67559bb61cc9bc51$export$56030be9156ae856}">${advantageText}</div>` : ``}
                ${price ? `<div class="${$67559bb61cc9bc51$export$337d1885ef6f1e24}">${(0, $d8dc22cce01f37a9$export$6349d151e019902e)(priceVAT, false)}</div>` : ''}
                <div class="${$67559bb61cc9bc51$export$321c0b1a406de31f}">
                    ${(0, $d8dc22cce01f37a9$export$6349d151e019902e)(price !== null && price !== void 0 ? price : priceVAT, Boolean(price))}
                </div>
            </div>
        `);
        if (advantageEndVATPrice) //language=HTML
        details.append(`
                <div style="margin-top: 15px;">
                    <div class="${$67559bb61cc9bc51$export$337d1885ef6f1e24} ${$67559bb61cc9bc51$export$56030be9156ae856}">${(0, $5FliW.Resources).t("words.offerAtAdvantageEnd")}</div>
                    <div class="${$67559bb61cc9bc51$export$337d1885ef6f1e24}">
                        ${(0, $d8dc22cce01f37a9$export$6349d151e019902e)(advantageEndVATPrice, false)}
                    </div>
                    <div class="${$67559bb61cc9bc51$export$321c0b1a406de31f}">
                        ${(0, $d8dc22cce01f37a9$export$6349d151e019902e)(advantageEndTotalPrice, true)}
                    </div>
                </div>
            `);
        if (invoiceUrl) //language=HTML
        details.append(`
                <a href="${invoiceUrl}" class="${$67559bb61cc9bc51$export$40e0ca2dfa95ba9e}" download>
                    ${(0, $5FliW.Resources).t("words.offerDownloadInvoice")}
                    <div class="${$67559bb61cc9bc51$export$1ca1ec8b29a4ce27}"></div>
                </a>
            `);
    }
    async renderStripe(secrets, actionType) {
        if (secrets) {
            let stripeComponent = new (0, $4ce4e5788b3a3309$export$ff62fe619d647b4e)(secrets, actionType);
            stripeComponent.onPaid = ()=>this.startStripePayCheck(this.quote.offer);
            stripeComponent.onError = (error)=>{
                if (error) {
                    if (errorContainer) errorContainer.remove();
                    errorContainer = stripeContainer.prepend(`<div class="${$67559bb61cc9bc51$export$a3bc9b8ed74fc}">${error}</div>`);
                }
                this.priceComponent.remLoading();
            };
            //language=HTML
            let stripeContainer = this.append(`
                <div class="${$67559bb61cc9bc51$export$735606310a3da449}"></div>`);
            stripeContainer.render(stripeComponent);
            let errorContainer;
            this.getStarted = async ()=>{
                this.priceComponent.setLoading();
                await stripeComponent.payment();
            };
        } else {
            this.getStarted = async ()=>{};
            this.priceComponent.clear();
        }
    }
    constructor(productType, quote){
        super(productType, quote);
        //language=HTML
        this.template = `
            <div class="${$67559bb61cc9bc51$export$1c80ec59d1789323}"></div>`;
    }
}




var $5FliW = parcelRequire("5FliW");


var $fsnB5 = parcelRequire("fsnB5");
var $201f281728a1fe73$export$56715c470bdac314;
var $201f281728a1fe73$export$f1e544e8e1c4eecb;
var $201f281728a1fe73$export$f4c5de44377d2946;
var $201f281728a1fe73$export$a19185d1233fc4b2;
var $201f281728a1fe73$export$6f093cfa640b7166;
var $201f281728a1fe73$export$dc57ddd528b7443f;
var $201f281728a1fe73$export$2ba01fb71ed41cb6;
var $201f281728a1fe73$export$46c1c92549715335;
$201f281728a1fe73$export$56715c470bdac314 = "POGiS";
$201f281728a1fe73$export$f1e544e8e1c4eecb = "qmkTN";
$201f281728a1fe73$export$f4c5de44377d2946 = "_3pXQU";
$201f281728a1fe73$export$a19185d1233fc4b2 = "_1xGyO";
$201f281728a1fe73$export$6f093cfa640b7166 = "Oia-2";
$201f281728a1fe73$export$dc57ddd528b7443f = "Nf2mf";
$201f281728a1fe73$export$2ba01fb71ed41cb6 = "OaL6X";
$201f281728a1fe73$export$46c1c92549715335 = "sQqtO";



var $7AbeR = parcelRequire("7AbeR");

class $2deeb64e7ff2ce24$export$8f93841fb2480ea2 extends (0, $fsnB5.Component) {
    commit() {
        this.buttonContainer = this.el($201f281728a1fe73$export$dc57ddd528b7443f);
        this.button = this.el($201f281728a1fe73$export$2ba01fb71ed41cb6);
        this.textContainer = this.el($201f281728a1fe73$export$6f093cfa640b7166);
        if (this.buttonContainer && !this.buttonContainer.isNull()) this.buttonContainer.onClick(()=>{
            if (!this.button.hasClass($201f281728a1fe73$export$46c1c92549715335)) this.onButtonClick();
        });
        super.commit();
    }
    onButtonClick() {
        (0, $7AbeR.Network).router.pages.redirect("/general/categories");
    }
    setButtonLoading() {
        if (!this.buttonContainer.isNull()) {
            this.loading = this.button.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
            this.button.addClass($201f281728a1fe73$export$46c1c92549715335);
        }
    }
    remButtonLoading() {
        if (!this.buttonContainer.isNull() && this.loading) {
            this.button.removeClass($201f281728a1fe73$export$46c1c92549715335);
            this.loading.remove();
            this.loading = undefined;
        }
    }
    constructor(emoji, text, buttonText, loader){
        super();
        //language=HTML
        this.template = `
            <div emptyBasic class="${$201f281728a1fe73$export$56715c470bdac314}">
                <div class="${$201f281728a1fe73$export$f1e544e8e1c4eecb}">
                    <div emptyemoji class="${$201f281728a1fe73$export$a19185d1233fc4b2}">${emoji}</div>
                    ${text == undefined ? `` : `<div emptyText class="${$201f281728a1fe73$export$6f093cfa640b7166}">${text}</div>`}
                    ${buttonText == undefined ? `` : `<div class="${$201f281728a1fe73$export$dc57ddd528b7443f}"><div emptyButton class="${$201f281728a1fe73$export$2ba01fb71ed41cb6}">${buttonText}</div></div>`}
                    ${loader == undefined ? `` : `<div class="${$201f281728a1fe73$export$f4c5de44377d2946}">${this.draw(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)({
            width: 50,
            strokeWidth: 3
        }))}</div>`}
                </div>
            </div>
        `;
    }
}






var $7AbeR = parcelRequire("7AbeR");

var $68Z0d = parcelRequire("68Z0d");

var $a143f837bd474065$export$e69bd631d8b8dbd7;
var $a143f837bd474065$export$6d59db4903f20f7d;
var $a143f837bd474065$export$bbea856fdb3e3c5f;
var $a143f837bd474065$export$2ba01fb71ed41cb6;
var $a143f837bd474065$export$70b61ad426ddbe54;
var $a143f837bd474065$export$c4c4198845d8b888;
$a143f837bd474065$export$e69bd631d8b8dbd7 = "-eIPc";
$a143f837bd474065$export$6d59db4903f20f7d = "Z6d2k";
$a143f837bd474065$export$bbea856fdb3e3c5f = "yLDdq";
$a143f837bd474065$export$2ba01fb71ed41cb6 = "_2bOXJ";
$a143f837bd474065$export$70b61ad426ddbe54 = "fXoRb";
$a143f837bd474065$export$c4c4198845d8b888 = "qd6Jo";




var $5FliW = parcelRequire("5FliW");
class $57675f916c4c9dbc$export$f09a8aef9d6f86e4 extends (0, $d7fa30f5b69b40db$export$2a517e1cac1c1f85) {
    commit() {
        super.commit();
        this.visualModal.setStyle(`z-index:99999999;`);
        this.boxContainer.setStyle(`width:250px;`);
        this.cancelButton = this.el($a143f837bd474065$export$70b61ad426ddbe54);
        this.continueButton = this.el($a143f837bd474065$export$c4c4198845d8b888);
        if (!this.okButton) {
            this.cancelButton.onClick(async ()=>{
                await this.close();
            });
            this.continueButton.onClick(()=>{
                this.onContinue();
            });
        } else this.continueButton.onClick(async ()=>{
            await this.close();
        });
    }
    setLoading() {
        this.continueButton.save();
        this.continueButton.clearAll();
        this.continueButton.render(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)());
    }
    /**
     * override
     */ onContinue() {}
    constructor(description, name, okButton){
        super();
        this.name = name !== null && name !== void 0 ? name : (0, $5FliW.Resources).t("words.confirmation");
        this.okButton = okButton;
        //language=HTML
        this.modalTemplate = `
            <div class="${$a143f837bd474065$export$e69bd631d8b8dbd7}">
                <div class="${$a143f837bd474065$export$6d59db4903f20f7d}">
                    ${description}
                </div>
                <div class="${$a143f837bd474065$export$bbea856fdb3e3c5f}">
                    ${this.okButton ? '' : `<div class="${$a143f837bd474065$export$2ba01fb71ed41cb6} ${$a143f837bd474065$export$70b61ad426ddbe54}">
                        ${(0, $5FliW.Resources).t("words.cancel")}
                    </div>`}
                    <div class="${$a143f837bd474065$export$2ba01fb71ed41cb6} ${$a143f837bd474065$export$c4c4198845d8b888}">
                        ${this.okButton ? (0, $5FliW.Resources).t("words.ok") : (0, $5FliW.Resources).t("words.continue")}
                    </div>
                </div>
            </div>
        `;
    }
}


class $7b33bbac2cdd5613$export$18390818359c51b8 extends (0, $6d478d93f91d9a6c$export$97cdf95035444dd8) {
    commit() {
        super.commit();
    }
    renderAll() {
        this.renderEmpty();
        this.renderOfferContent();
        this.renderPriceDetailsNext();
        if (!this.paymentProvider.directDeleteDefinitiveOffer) this.renderCancel();
    }
    renderEmpty() {
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$98ea8a8009e37bf1}">
                ${this.draw(new (0, $2deeb64e7ff2ce24$export$8f93841fb2480ea2)(`<div class="${$67559bb61cc9bc51$export$1ca1ec8b29a4ce27}"></div>`, `${(0, $5FliW.Resources).t("words.offerTakeEffectAt")} ${(0, $c675d49824235e50$export$4e4cb19dd88cd821)(new Date(this.quote.offer.startDate))}`))}
            </div>
        `);
    }
    renderCancel() {
        let buttons = new (0, $0d1af15bbe311e9e$export$f0c6024316437792)({
            hideCancelButton: true,
            saveText: (0, $5FliW.Resources).t("words.offerCancelSchedule")
        });
        buttons.onSave = async ()=>{
            let confirmation = new (0, $57675f916c4c9dbc$export$f09a8aef9d6f86e4)((0, $5FliW.Resources).t("words.offerCancelScheduleConfirmation"));
            confirmation.screenRender();
            confirmation.onContinue = async ()=>{
                buttons.setLoading();
                try {
                    if (await (0, $6552c5473243fcef$export$a047eb6606b2561b).cancel(this.quote.offer.id, true, this)) (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.actionSuccess"), undefined, 3000, "success");
                } catch (e) {
                    console.error(e);
                }
                this.onCloseModal();
                await (0, $7AbeR.Network).router.pages.reload();
                await confirmation.close();
            };
        };
        //language=HTML
        this.append(`
            <div class="${$67559bb61cc9bc51$export$70b61ad426ddbe54}">
                ${this.draw(buttons)}
            </div>
        `);
    }
    constructor(productType, quote){
        super(productType, quote);
        this.paymentProvider = (0, $68Z0d.EntityService).activeSite.paymentProvider;
        //language=HTML
        this.template = `
            <div class="${$67559bb61cc9bc51$export$1c80ec59d1789323}"></div>`;
    }
}



var $7AbeR = parcelRequire("7AbeR");


var $fsnB5 = parcelRequire("fsnB5");
var $09a8079b610eaf30$exports = {};

$parcel$export($09a8079b610eaf30$exports, "componentOfferGrid", function () { return $09a8079b610eaf30$export$6fab4431c6d3110c; }, function (v) { return $09a8079b610eaf30$export$6fab4431c6d3110c = v; });
$parcel$export($09a8079b610eaf30$exports, "line", function () { return $09a8079b610eaf30$export$53f1d5ea8de3d7c; }, function (v) { return $09a8079b610eaf30$export$53f1d5ea8de3d7c = v; });
$parcel$export($09a8079b610eaf30$exports, "entry", function () { return $09a8079b610eaf30$export$c407db72103fecfa; }, function (v) { return $09a8079b610eaf30$export$c407db72103fecfa = v; });
$parcel$export($09a8079b610eaf30$exports, "title", function () { return $09a8079b610eaf30$export$fb184b623420d9be; }, function (v) { return $09a8079b610eaf30$export$fb184b623420d9be = v; });
$parcel$export($09a8079b610eaf30$exports, "description", function () { return $09a8079b610eaf30$export$6d59db4903f20f7d; }, function (v) { return $09a8079b610eaf30$export$6d59db4903f20f7d = v; });
$parcel$export($09a8079b610eaf30$exports, "icons", function () { return $09a8079b610eaf30$export$df03f54e09e486fa; }, function (v) { return $09a8079b610eaf30$export$df03f54e09e486fa = v; });
$parcel$export($09a8079b610eaf30$exports, "descIcon", function () { return $09a8079b610eaf30$export$674d17a43c1246d4; }, function (v) { return $09a8079b610eaf30$export$674d17a43c1246d4 = v; });
$parcel$export($09a8079b610eaf30$exports, "shopify", function () { return $09a8079b610eaf30$export$6da9acb12d5139d4; }, function (v) { return $09a8079b610eaf30$export$6da9acb12d5139d4 = v; });
$parcel$export($09a8079b610eaf30$exports, "webflow", function () { return $09a8079b610eaf30$export$7902342170a40c7a; }, function (v) { return $09a8079b610eaf30$export$7902342170a40c7a = v; });
$parcel$export($09a8079b610eaf30$exports, "wordpress", function () { return $09a8079b610eaf30$export$97971ff30d8c30d2; }, function (v) { return $09a8079b610eaf30$export$97971ff30d8c30d2 = v; });
$parcel$export($09a8079b610eaf30$exports, "wix", function () { return $09a8079b610eaf30$export$ad6718c788124d32; }, function (v) { return $09a8079b610eaf30$export$ad6718c788124d32 = v; });
$parcel$export($09a8079b610eaf30$exports, "prestashop", function () { return $09a8079b610eaf30$export$7c5480d2d52b096a; }, function (v) { return $09a8079b610eaf30$export$7c5480d2d52b096a = v; });
$parcel$export($09a8079b610eaf30$exports, "value", function () { return $09a8079b610eaf30$export$2ab9a8f9f1186f14; }, function (v) { return $09a8079b610eaf30$export$2ab9a8f9f1186f14 = v; });
$parcel$export($09a8079b610eaf30$exports, "boolTrue", function () { return $09a8079b610eaf30$export$428ef1f8ddd66578; }, function (v) { return $09a8079b610eaf30$export$428ef1f8ddd66578 = v; });
$parcel$export($09a8079b610eaf30$exports, "icon", function () { return $09a8079b610eaf30$export$1ca1ec8b29a4ce27; }, function (v) { return $09a8079b610eaf30$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($09a8079b610eaf30$exports, "boolFalse", function () { return $09a8079b610eaf30$export$d4a36b86e0c64e34; }, function (v) { return $09a8079b610eaf30$export$d4a36b86e0c64e34 = v; });
var $09a8079b610eaf30$export$6fab4431c6d3110c;
var $09a8079b610eaf30$export$53f1d5ea8de3d7c;
var $09a8079b610eaf30$export$c407db72103fecfa;
var $09a8079b610eaf30$export$fb184b623420d9be;
var $09a8079b610eaf30$export$6d59db4903f20f7d;
var $09a8079b610eaf30$export$df03f54e09e486fa;
var $09a8079b610eaf30$export$674d17a43c1246d4;
var $09a8079b610eaf30$export$6da9acb12d5139d4;
var $09a8079b610eaf30$export$7902342170a40c7a;
var $09a8079b610eaf30$export$97971ff30d8c30d2;
var $09a8079b610eaf30$export$ad6718c788124d32;
var $09a8079b610eaf30$export$7c5480d2d52b096a;
var $09a8079b610eaf30$export$2ab9a8f9f1186f14;
var $09a8079b610eaf30$export$428ef1f8ddd66578;
var $09a8079b610eaf30$export$1ca1ec8b29a4ce27;
var $09a8079b610eaf30$export$d4a36b86e0c64e34;
$09a8079b610eaf30$export$6fab4431c6d3110c = "_9XhK6";
$09a8079b610eaf30$export$53f1d5ea8de3d7c = "XPv7g";
$09a8079b610eaf30$export$c407db72103fecfa = "riHOJ";
$09a8079b610eaf30$export$fb184b623420d9be = "MUJJR";
$09a8079b610eaf30$export$6d59db4903f20f7d = "uGTfi";
$09a8079b610eaf30$export$df03f54e09e486fa = "CQK23";
$09a8079b610eaf30$export$674d17a43c1246d4 = "jwaPT";
$09a8079b610eaf30$export$6da9acb12d5139d4 = "zb4TS";
$09a8079b610eaf30$export$7902342170a40c7a = "KYMQg";
$09a8079b610eaf30$export$97971ff30d8c30d2 = "-s90n";
$09a8079b610eaf30$export$ad6718c788124d32 = "btfWH";
$09a8079b610eaf30$export$7c5480d2d52b096a = "RJsSQ";
$09a8079b610eaf30$export$2ab9a8f9f1186f14 = "ASwW5";
$09a8079b610eaf30$export$428ef1f8ddd66578 = "XIDxA";
$09a8079b610eaf30$export$1ca1ec8b29a4ce27 = "-qoDq";
$09a8079b610eaf30$export$d4a36b86e0c64e34 = "V-MC8";





var $fsnB5 = parcelRequire("fsnB5");
var $35a6c81e42500c0e$exports = {};

$parcel$export($35a6c81e42500c0e$exports, "componentOfferTemplate", function () { return $35a6c81e42500c0e$export$f88754492213681b; }, function (v) { return $35a6c81e42500c0e$export$f88754492213681b = v; });
$parcel$export($35a6c81e42500c0e$exports, "selected", function () { return $35a6c81e42500c0e$export$d90250155de6d7e7; }, function (v) { return $35a6c81e42500c0e$export$d90250155de6d7e7 = v; });
$parcel$export($35a6c81e42500c0e$exports, "selectedCheck", function () { return $35a6c81e42500c0e$export$a6ab2d8c92cb3c5d; }, function (v) { return $35a6c81e42500c0e$export$a6ab2d8c92cb3c5d = v; });
$parcel$export($35a6c81e42500c0e$exports, "button", function () { return $35a6c81e42500c0e$export$2ba01fb71ed41cb6; }, function (v) { return $35a6c81e42500c0e$export$2ba01fb71ed41cb6 = v; });
$parcel$export($35a6c81e42500c0e$exports, "popular", function () { return $35a6c81e42500c0e$export$cfb079464428d8c8; }, function (v) { return $35a6c81e42500c0e$export$cfb079464428d8c8 = v; });
$parcel$export($35a6c81e42500c0e$exports, "name", function () { return $35a6c81e42500c0e$export$a8ff84c12d48cfa6; }, function (v) { return $35a6c81e42500c0e$export$a8ff84c12d48cfa6 = v; });
$parcel$export($35a6c81e42500c0e$exports, "icon", function () { return $35a6c81e42500c0e$export$1ca1ec8b29a4ce27; }, function (v) { return $35a6c81e42500c0e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($35a6c81e42500c0e$exports, "price", function () { return $35a6c81e42500c0e$export$321c0b1a406de31f; }, function (v) { return $35a6c81e42500c0e$export$321c0b1a406de31f = v; });
$parcel$export($35a6c81e42500c0e$exports, "description", function () { return $35a6c81e42500c0e$export$6d59db4903f20f7d; }, function (v) { return $35a6c81e42500c0e$export$6d59db4903f20f7d = v; });
$parcel$export($35a6c81e42500c0e$exports, "content", function () { return $35a6c81e42500c0e$export$a7db06668cad9adb; }, function (v) { return $35a6c81e42500c0e$export$a7db06668cad9adb = v; });
$parcel$export($35a6c81e42500c0e$exports, "entry", function () { return $35a6c81e42500c0e$export$c407db72103fecfa; }, function (v) { return $35a6c81e42500c0e$export$c407db72103fecfa = v; });
$parcel$export($35a6c81e42500c0e$exports, "title", function () { return $35a6c81e42500c0e$export$fb184b623420d9be; }, function (v) { return $35a6c81e42500c0e$export$fb184b623420d9be = v; });
$parcel$export($35a6c81e42500c0e$exports, "boolTrue", function () { return $35a6c81e42500c0e$export$428ef1f8ddd66578; }, function (v) { return $35a6c81e42500c0e$export$428ef1f8ddd66578 = v; });
$parcel$export($35a6c81e42500c0e$exports, "boolFalse", function () { return $35a6c81e42500c0e$export$d4a36b86e0c64e34; }, function (v) { return $35a6c81e42500c0e$export$d4a36b86e0c64e34 = v; });
$parcel$export($35a6c81e42500c0e$exports, "icons", function () { return $35a6c81e42500c0e$export$df03f54e09e486fa; }, function (v) { return $35a6c81e42500c0e$export$df03f54e09e486fa = v; });
$parcel$export($35a6c81e42500c0e$exports, "descIcon", function () { return $35a6c81e42500c0e$export$674d17a43c1246d4; }, function (v) { return $35a6c81e42500c0e$export$674d17a43c1246d4 = v; });
$parcel$export($35a6c81e42500c0e$exports, "shopify", function () { return $35a6c81e42500c0e$export$6da9acb12d5139d4; }, function (v) { return $35a6c81e42500c0e$export$6da9acb12d5139d4 = v; });
$parcel$export($35a6c81e42500c0e$exports, "wordpress", function () { return $35a6c81e42500c0e$export$97971ff30d8c30d2; }, function (v) { return $35a6c81e42500c0e$export$97971ff30d8c30d2 = v; });
$parcel$export($35a6c81e42500c0e$exports, "webflow", function () { return $35a6c81e42500c0e$export$7902342170a40c7a; }, function (v) { return $35a6c81e42500c0e$export$7902342170a40c7a = v; });
$parcel$export($35a6c81e42500c0e$exports, "wix", function () { return $35a6c81e42500c0e$export$ad6718c788124d32; }, function (v) { return $35a6c81e42500c0e$export$ad6718c788124d32 = v; });
$parcel$export($35a6c81e42500c0e$exports, "prestashop", function () { return $35a6c81e42500c0e$export$7c5480d2d52b096a; }, function (v) { return $35a6c81e42500c0e$export$7c5480d2d52b096a = v; });
var $35a6c81e42500c0e$export$f88754492213681b;
var $35a6c81e42500c0e$export$d90250155de6d7e7;
var $35a6c81e42500c0e$export$a6ab2d8c92cb3c5d;
var $35a6c81e42500c0e$export$2ba01fb71ed41cb6;
var $35a6c81e42500c0e$export$cfb079464428d8c8;
var $35a6c81e42500c0e$export$a8ff84c12d48cfa6;
var $35a6c81e42500c0e$export$1ca1ec8b29a4ce27;
var $35a6c81e42500c0e$export$321c0b1a406de31f;
var $35a6c81e42500c0e$export$6d59db4903f20f7d;
var $35a6c81e42500c0e$export$a7db06668cad9adb;
var $35a6c81e42500c0e$export$c407db72103fecfa;
var $35a6c81e42500c0e$export$fb184b623420d9be;
var $35a6c81e42500c0e$export$428ef1f8ddd66578;
var $35a6c81e42500c0e$export$d4a36b86e0c64e34;
var $35a6c81e42500c0e$export$df03f54e09e486fa;
var $35a6c81e42500c0e$export$674d17a43c1246d4;
var $35a6c81e42500c0e$export$6da9acb12d5139d4;
var $35a6c81e42500c0e$export$97971ff30d8c30d2;
var $35a6c81e42500c0e$export$7902342170a40c7a;
var $35a6c81e42500c0e$export$ad6718c788124d32;
var $35a6c81e42500c0e$export$7c5480d2d52b096a;
$35a6c81e42500c0e$export$f88754492213681b = "BPLDf";
$35a6c81e42500c0e$export$d90250155de6d7e7 = "zIpIj";
$35a6c81e42500c0e$export$a6ab2d8c92cb3c5d = "F3cWF";
$35a6c81e42500c0e$export$2ba01fb71ed41cb6 = "e-cZr";
$35a6c81e42500c0e$export$cfb079464428d8c8 = "Im-wb";
$35a6c81e42500c0e$export$a8ff84c12d48cfa6 = "b9DRx";
$35a6c81e42500c0e$export$1ca1ec8b29a4ce27 = "_4Civj";
$35a6c81e42500c0e$export$321c0b1a406de31f = "SGE-o";
$35a6c81e42500c0e$export$6d59db4903f20f7d = "_8Y2ih";
$35a6c81e42500c0e$export$a7db06668cad9adb = "xnqsg";
$35a6c81e42500c0e$export$c407db72103fecfa = "MJAmK";
$35a6c81e42500c0e$export$fb184b623420d9be = "wL7iu";
$35a6c81e42500c0e$export$428ef1f8ddd66578 = "_5X3ec";
$35a6c81e42500c0e$export$d4a36b86e0c64e34 = "uSbdC";
$35a6c81e42500c0e$export$df03f54e09e486fa = "DfTVs";
$35a6c81e42500c0e$export$674d17a43c1246d4 = "v7kgz";
$35a6c81e42500c0e$export$6da9acb12d5139d4 = "Pdld2";
$35a6c81e42500c0e$export$97971ff30d8c30d2 = "lCju1";
$35a6c81e42500c0e$export$7902342170a40c7a = "_0171p";
$35a6c81e42500c0e$export$ad6718c788124d32 = "X-IRC";
$35a6c81e42500c0e$export$7c5480d2d52b096a = "pcQvc";



var $5FliW = parcelRequire("5FliW");






var $fsnB5 = parcelRequire("fsnB5");
var $f92b61f53f0cc10f$export$3b6d265609194a23;
$f92b61f53f0cc10f$export$3b6d265609194a23 = "kVHSJ";


class $b24949cca2bfe9b9$export$e18e2f8e82cdc428 extends (0, $fsnB5.Component) {
    commit() {
        super.commit();
        if (!this.isNull()) //language=HTML
        this.setTooltip(`
                <div style="max-width: 300px;text-align: center;">
                    ${this.description}
                </div>
            `, this.position);
    }
    constructor(description, position){
        super();
        this.type = "SPAN";
        this.description = description;
        this.position = position;
        //language=HTML
        this.template = `
            <span class="${$f92b61f53f0cc10f$export$3b6d265609194a23}"><span>?</span></span>
        `;
    }
}


class $4dc89b2658e0dfa2$export$abaa7eeb39abc6ba extends (0, $fsnB5.Component) {
    commit() {
        this.priceContainer = this.el($35a6c81e42500c0e$exports.price);
        this.contentContainer = this.el($35a6c81e42500c0e$exports.content);
        this.button = this.el($35a6c81e42500c0e$exports.button);
        this.button.onClick(()=>this.onPick());
        this.table.forEach((tableLine)=>{
            let entry = tableLine.entries.find((value)=>value.templateId == this.productTemplate.id);
            let entryCase;
            if (entry) {
                switch(tableLine.type){
                    case "text":
                        //language=HTML
                        entryCase = this.contentContainer.append(`
                            <div class="${$35a6c81e42500c0e$exports.entry}">
                                <div class="${$35a6c81e42500c0e$exports.title}">${tableLine.name}
                                    ${this.contentContainer.draw(new (0, $b24949cca2bfe9b9$export$e18e2f8e82cdc428)(tableLine.description))}
                                </div>
                                <div class="${$35a6c81e42500c0e$exports.description}">${entry.value}</div>
                            </div>
                        `);
                        break;
                    case "bool":
                    case "textBool":
                        //language=HTML
                        entryCase = this.contentContainer.append(`
                            <div class="${$35a6c81e42500c0e$exports.entry}">
                                <div class="${$35a6c81e42500c0e$exports.title}">
                                    ${entry.value ? `<div class="${$35a6c81e42500c0e$exports.boolTrue}"><div class="${$35a6c81e42500c0e$exports.icon}"></div></div>` : `<div class="${$35a6c81e42500c0e$exports.boolFalse}"></div>`}
                                    ${tableLine.name}
                                    ${this.contentContainer.draw(new (0, $b24949cca2bfe9b9$export$e18e2f8e82cdc428)(tableLine.description))}
                                </div>
                            </div>
                        `);
                        if (tableLine.type == "textBool" && entry.value) entryCase.append(`<div class="${$35a6c81e42500c0e$exports.description}">${entry.value}</div>`);
                        break;
                }
                if (tableLine.icons) //language=HTML
                entryCase.append(`
                        <div class="${$35a6c81e42500c0e$exports.icons}">
                            ${tableLine.icons.map((value)=>`<div class="${$35a6c81e42500c0e$exports.descIcon} ${$35a6c81e42500c0e$exports[(0, $d29384eb3821c3f1$export$6913bb0f068db6f0)[value].toLowerCase()]}"></div>`).join("")}
                        </div>
                    `);
            }
        });
        this.renderPrice();
        super.commit();
    }
    renderPrice() {
        let price = this.bundle.priceInitial / 100;
        if (this.period.periodType == (0, $7c9924087ecfb7dd$export$b7ac94010691eccd).ANNUAL) {
            price = price * 12;
            price = price - price * this.period.advantagePercentage;
        }
        this.priceContainer.clearAll();
        this.priceContainer.setHtml(this.productTemplate.level == (0, $377ed0589d754635$export$361763241a2a268d).FREE ? (0, $5FliW.Resources).t("words.free") : `${Math.round(price)}\u{20AC} <span>/${(0, $5FliW.Resources).t(`words.offerPeriodTitle${this.period.periodType}`)}</span>`);
    }
    setPeriod(period) {
        this.period = period;
        this.renderPrice();
    }
    setSelected() {
        this.addClass($35a6c81e42500c0e$exports.selected);
    }
    remSelected() {
        this.removeClass($35a6c81e42500c0e$exports.selected);
    }
    onPick() {}
    constructor(template, period, table){
        super();
        this.productTemplate = template;
        this.period = period;
        this.table = table;
        this.bundle = template.bundles[0];
        //language=HTML
        this.template = `
            <div class="${$35a6c81e42500c0e$exports.componentOfferTemplate}">
                ${(0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).popularTemplates().includes(template.id) ? `<div class="${$35a6c81e42500c0e$exports.popular}">${(0, $5FliW.Resources).t("words.popular")}</div>` : ``}
                <div class="${$35a6c81e42500c0e$exports.selectedCheck}"></div>
                <div class="${$35a6c81e42500c0e$exports.name}">
                    ${(0, $5FliW.Resources).t(`words.offerName${template.type}`)}
                </div>
                <div class="${$35a6c81e42500c0e$exports.icon}">
                    ${this.draw(new (0, $f49d8292e8bb8162$export$e11200deb10216e7)(template.type))}
                </div>
                <div class="${$35a6c81e42500c0e$exports.price}"></div>
                <div class="${$35a6c81e42500c0e$exports.description}">
                    ${(0, $5FliW.Resources).t(`words.offerDescription${template.type}`)}
                </div>
                <div class="${$35a6c81e42500c0e$exports.button}">
                    ${(0, $5FliW.Resources).t("words.choose")} ${(0, $5FliW.Resources).t(`words.offerName${template.type}`)}
                </div>
                <div class="${$35a6c81e42500c0e$exports.content}"></div>
            </div>
        `;
    }
}


class $edc19c6df1efc348$export$a0759ffb3acba2ce extends (0, $fsnB5.Component) {
    commit() {
        this.renderTemplates();
        this.table.forEach((tableLine)=>this.renderLine(tableLine));
        super.commit();
    }
    renderTemplates() {
        //language=HTML
        let line = this.append(`
            <div class="${$09a8079b610eaf30$exports.line}">
                <div class="${$09a8079b610eaf30$exports.entry}"></div>
            </div>`);
        this.templates.forEach((template)=>{
            let templateComponent = new (0, $4dc89b2658e0dfa2$export$abaa7eeb39abc6ba)(template, this.period, this.table);
            templateComponent.onPick = ()=>{
                this.templatesComponents.forEach((value)=>value.remSelected());
                templateComponent.setSelected();
                this.onPick(template);
            };
            //language=HTML
            line.append(`
                <div class="${$09a8079b610eaf30$exports.entry}">
                    ${line.draw(templateComponent)}
                </div>
            `);
            this.templatesComponents.push(templateComponent);
            if (template.id == this.selectedTemplateId) templateComponent.setSelected();
        });
    }
    renderLine(tableLine) {
        //language=HTML
        let line = this.append(`
            <div class="${$09a8079b610eaf30$exports.line}"></div>`);
        //language=HTML
        let entryDescription = line.append(`
            <div class="${$09a8079b610eaf30$exports.entry}">
                <div class="${$09a8079b610eaf30$exports.title}">
                    ${tableLine.name}
                </div>
                <div class="${$09a8079b610eaf30$exports.description}">
                    ${tableLine.description}
                </div>
            </div>
        `);
        if (tableLine.icons) //language=HTML
        entryDescription.append(`
                <div class="${$09a8079b610eaf30$exports.icons}">
                    ${tableLine.icons.map((value)=>`<div class="${$09a8079b610eaf30$exports.descIcon} ${$09a8079b610eaf30$exports[(0, $d29384eb3821c3f1$export$6913bb0f068db6f0)[value].toLowerCase()]}"></div>`).join("")}
                </div>
            `);
        tableLine.entries.forEach((tableLineEntry)=>{
            switch(tableLine.type){
                case "text":
                    //language=HTML
                    line.append(`
                        <div class="${$09a8079b610eaf30$exports.entry}">
                            <div class="${$09a8079b610eaf30$exports.value}">
                                ${tableLineEntry.value}
                            </div>
                        </div>
                    `);
                    break;
                case "bool":
                    //language=HTML
                    line.append(`
                        <div class="${$09a8079b610eaf30$exports.entry}">
                            ${tableLineEntry.value ? `<div class="${$09a8079b610eaf30$exports.boolTrue}"><div class="${$09a8079b610eaf30$exports.icon}"></div></div>` : `<div class="${$09a8079b610eaf30$exports.boolFalse}"></div>`}
                        </div>
                    `);
                    break;
                case "textBool":
                    //language=HTML
                    line.append(`
                        <div class="${$09a8079b610eaf30$exports.entry}">
                            ${tableLineEntry.value ? `<div class="${$09a8079b610eaf30$exports.boolTrue}"><div class="${$09a8079b610eaf30$exports.icon}"></div></div>` : `<div class="${$09a8079b610eaf30$exports.boolFalse}"></div>`}
                            ${tableLineEntry.value ? `<div class="${$09a8079b610eaf30$exports.description}">${tableLineEntry.value}</div>` : ``}
                        </div>
                    `);
                    break;
            }
        });
    }
    setPeriod(period) {
        this.templatesComponents.forEach((value)=>value.setPeriod(period));
    }
    onPick(template) {}
    constructor(templates, period, selectedTemplateId){
        super();
        this.templates = templates;
        this.period = period;
        this.selectedTemplateId = selectedTemplateId;
        this.table = (0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).table(templates);
        this.templatesComponents = [];
        //language=HTML
        this.template = `
            <div class="${$09a8079b610eaf30$exports.componentOfferGrid}"></div>`;
    }
}



var $2aBLW = parcelRequire("2aBLW");
class $6dd9c90eeb33d2ee$export$b39970eebb991951 extends (0, $fsnB5.Component) {
    commit() {
        super.commit();
        super.scrollable();
        this.renderAll(this.details);
    }
    async renderAll(details) {
        if (this.website) await this.renderAllTemplates();
        else if (details) await this.renderQuote(details);
        else {
            details = await (0, $6552c5473243fcef$export$a047eb6606b2561b).quote(this);
            if (details) await this.renderQuote(details);
            else {
                var _this_activeOffer;
                this.activeOffer = await (0, $6552c5473243fcef$export$a047eb6606b2561b).active(false, this);
                this.activeOfferProduct = (_this_activeOffer = this.activeOffer) === null || _this_activeOffer === void 0 ? void 0 : _this_activeOffer.offer.products[this.productType];
                await this.renderAllTemplates();
            }
        }
        super.scrollable();
    }
    async renderAllTemplates() {
        this.templates = await (0, $6552c5473243fcef$export$a047eb6606b2561b).findAll(this);
        this.clearAll();
        this.renderTop();
        this.renderTopPeriod();
        this.renderTemplatesContainer();
        this.renderSolutionsContainer();
        this.renderContentContainer();
        this.renderPriceContainer();
        this.renderBottomAll();
    }
    renderBottomAll() {
        this.solutionsContainer.clearAll();
        let solutions = this.el($1fdd39807a87de14$export$e29b1f3b2b6a7669);
        solutions.displayHide();
        if (this.selectedTemplate.level == (0, $377ed0589d754635$export$361763241a2a268d).PREMIUM) {
            solutions.displayShow();
            this.renderSolutions();
        }
        this.renderContent();
        this.renderPrice();
    }
    renderTop() {
        this.clearAll();
        //language=HTML
        this.append(`
            <div class="${$1fdd39807a87de14$export$1e95b668f3b82d}">
                <div class="${$1fdd39807a87de14$export$96ff94e0adb1d772}">
                    ${(0, $5FliW.Resources).t(`words.offerDescription${this.productType}`)}
                </div>
                <div class="${$1fdd39807a87de14$export$da0c8716dc13cd97}"></div>
                <div class="${$1fdd39807a87de14$export$40e52e4cb633d77a}">
                </div>
            </div>
        `);
        this.periodContainer = this.el($1fdd39807a87de14$export$da0c8716dc13cd97);
        this.advantageContainer = this.el($1fdd39807a87de14$export$40e52e4cb633d77a);
    }
    renderTopPeriod() {
        this.period = this.templates.periods[0];
        if (this.activeOffer) this.period = this.templates.periods.find((value)=>value.periodType == this.activeOffer.offer.periodType);
        this.periodContainer.clearAll();
        let periodPicker = new (0, $3f4821c0645aeb9a$export$8f6adf886c3e91d5)(this.templates.periods);
        this.periodContainer.render(periodPicker);
        periodPicker.select(this.period.periodType + "", true);
        periodPicker.onSelect = (value)=>{
            this.period = this.templates.periods.find((period)=>period.periodType == value);
            this.renderTopPeriodAdvantage(this.period.periodType);
            this.setPeriod(this.period);
            this.renderPrice();
        };
        this.renderTopPeriodAdvantage(this.period.periodType);
    }
    renderTopPeriodAdvantage(periodType) {
        let period = this.templates.periods.find((value)=>value.periodType == periodType);
        this.advantageContainer.setText((0, $5FliW.Resources).r("words.offerAdvantage", {
            advantage: period.advantagePercentage * 100
        }));
        if (periodType != (0, $7c9924087ecfb7dd$export$b7ac94010691eccd).MONTHLY) this.advantageContainer.show();
        else this.advantageContainer.hide();
    }
    renderTemplatesContainer() {
        //language=HTML
        this.templatesContainer = this.append(`
            <div class="${$1fdd39807a87de14$export$a8fc3402335b0b04}"></div>`);
        let templates = this.templates.templates[this.productType].filter((value)=>value.level == (0, $377ed0589d754635$export$361763241a2a268d).PREMIUM).sort((a, b)=>a.order < b.order ? 1 : -1).reverse();
        this.selectedTemplate = templates.find((value)=>value.level == (0, $377ed0589d754635$export$361763241a2a268d).PREMIUM);
        if (this.activeOffer) this.selectedTemplate = this.activeOfferProduct.template;
        this.gridComponent = new (0, $edc19c6df1efc348$export$a0759ffb3acba2ce)(templates, this.period, this.selectedTemplate.id);
        this.gridComponent.onPick = (template)=>{
            this.selectedTemplate = template;
            this.renderBottomAll();
            this.contentContainer.scrollTo((0, $2aBLW.SedestralInterface).html, -250);
        };
        this.templatesContainer.render(this.gridComponent);
    }
    renderSolutionsContainer() {
        //language=HTML
        this.solutionsSection = this.append(`
            <div class="${$1fdd39807a87de14$export$e29b1f3b2b6a7669}">
                <div class="${$1fdd39807a87de14$export$fb184b623420d9be}">
                    ${(0, $5FliW.Resources).t("words.offerSolutions")}
                </div>
                <div class="${$1fdd39807a87de14$export$6b8103ff35a0f6fe}"></div>
            </div>
        `);
        this.solutionsContainer = this.el($1fdd39807a87de14$export$6b8103ff35a0f6fe);
    }
    renderSolutions() {
        let bundle = this.selectedTemplate.bundles[0];
        const totalGranularity = bundle.solutions.reduce((sum, value)=>sum + value.granularity, 0);
        if (totalGranularity > 0) {
            this.solutionsComponents = [];
            bundle.solutions.forEach((solution)=>{
                if (solution.granularity > 0) {
                    let solutionComponent = new (0, $eff67f7dcb6c028b$export$3629cf1b14c0cc2b)(bundle, solution);
                    solutionComponent.onSolutionChange = (count)=>{
                        this.solutionsComponents.forEach((value)=>value.setGranularity(count));
                        this.renderContent();
                        this.renderPrice();
                    };
                    //language=HTML
                    if (!(0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type)) this.solutionsContainer.append(`
                                <div class="${$1fdd39807a87de14$export$333eed13d25bd57}">
                                    ${this.solutionsContainer.draw(solutionComponent)}
                                </div>
                            `);
                    this.solutionsComponents.push(solutionComponent);
                    if (this.activeOfferProduct) {
                        let activeBundle = this.activeOfferProduct.bundles.find((value)=>value.solutions.find((value1)=>value1.type == solution.type) != undefined);
                        if (activeBundle && (!bundle.maxOption || activeBundle.quantityOption <= bundle.maxOption)) {
                            if (this.activeOfferProduct.template.type == this.selectedTemplate.type) solutionComponent.setGranularity(activeBundle.quantityOption);
                        }
                    }
                }
            });
            this.solutionsSection.removeClass($1fdd39807a87de14$export$c99df9cf5e6bee9b);
        } else this.solutionsSection.addClass($1fdd39807a87de14$export$c99df9cf5e6bee9b);
    }
    renderContentContainer() {
        this.contentContainer = this.append(`<div class="${$1fdd39807a87de14$export$a7db06668cad9adb}"></div>`);
    }
    renderContent() {
        let bundle = this.selectedTemplate.bundles[0];
        let contents = bundle.solutions.filter((solution)=>!(0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).hiddenTypes().includes(solution.type)).map((solution)=>{
            let solutionComponent = this.solutionsComponents.find((value)=>value.solution == solution);
            let quantity = solution.quantityInitial;
            if (solutionComponent) quantity += solutionComponent.solutionCount() * solution.granularity;
            return `${quantity} ${(0, $5FliW.Resources).t(`words.offerSolution${this.selectedTemplate.type}${this.selectedTemplate.productType}${solution.type}`)}`;
        });
        this.contentContainer.clearAll();
        this.contentContainer.render(new (0, $bd33c90c0ceb36a8$export$48a3aac3632ef8)((0, $bc6537ccb176bcc0$export$b6ed60a23ae88524).contents(contents, this.selectedTemplate), (0, $5FliW.Resources).t("words.offerContentRecap")));
    }
    renderPriceContainer() {
        this.priceContainer = this.append(`<div class="${$1fdd39807a87de14$export$321c0b1a406de31f}"></div>`);
    }
    renderPrice() {
        if (this.selectedTemplate.level == (0, $377ed0589d754635$export$361763241a2a268d).FREE) this.priceContainer.hide();
        else {
            this.priceContainer.show();
            let bundle = this.selectedTemplate.bundles[0];
            let price = bundle.priceInitial;
            if (this.solutionsComponents.length > 0) price += this.solutionsComponents[0].solutionCount() * bundle.priceOption;
            this.priceContainer.clearAll();
            let priceComponent = new (0, $cd4983a2f3152f9d$export$19746147d1b55543)({
                period: this.period,
                price: price,
                text: this.activeOffer ? (0, $5FliW.Resources).t("words.offerEdit") : (0, $5FliW.Resources).t("words.getStarted")
            });
            priceComponent.onGetStarted = async ()=>{
                if (this.website) (0, $7AbeR.Network).router.pages.redirect((0, $7AbeR.Network).router.pages.getPanelUrl('signup'), true);
                else {
                    priceComponent.setLoading();
                    let product = {
                        templateId: this.selectedTemplate.id,
                        bundlesQuantity: [
                            this.solutionsComponents.length > 0 ? this.solutionsComponents[0].solutionCount() : 0
                        ]
                    };
                    let quote = await (0, $6552c5473243fcef$export$a047eb6606b2561b).quoteSubscription({
                        paymentPeriod: this.period.periodType,
                        products: [
                            product
                        ]
                    }, priceComponent);
                    if (quote) await this.renderQuote(quote);
                    priceComponent.remLoading();
                }
            };
            this.priceContainer.render(priceComponent);
        }
    }
    async renderQuote(quote) {
        if (quote.offer.state == (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).PAYMENT && quote.url) {
            location.href = quote.url;
            return;
        }
        if (quote.error) (0, $7AbeR.Network).router.static.components.notifications.notify((0, $5FliW.Resources).t("words.errorMessage"), undefined, 3000, "error");
        this.clearAll();
        let quoteComponent;
        switch(quote.offer.state){
            case (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).CONFIRMED:
                quoteComponent = new (0, $22f9cb9201e3dccd$export$958f4fee317b0b7c)(this.productType, quote);
                break;
            case (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).PAYMENT:
            case (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).FAILURE_TO_PAY:
            case (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).SUSPENDED:
                quoteComponent = new (0, $22f9cb9201e3dccd$export$958f4fee317b0b7c)(this.productType, quote);
                quoteComponent = new (0, $6d478d93f91d9a6c$export$97cdf95035444dd8)(this.productType, quote);
                break;
            case (0, $2fe4e1e98a5ae575$export$d4c083ce95fb2409).SCHEDULED:
                quoteComponent = new (0, $7b33bbac2cdd5613$export$18390818359c51b8)(this.productType, quote);
                break;
        }
        quoteComponent.onStep = (details)=>this.renderAll(details);
        quoteComponent.onCloseModal = ()=>this.onCloseModal();
        this.render(quoteComponent);
    }
    setPeriod(period) {
        this.gridComponent.setPeriod(period);
    }
    onCloseModal() {}
    constructor(productType, details, website){
        super(), this.solutionsComponents = [];
        this.details = details;
        this.productType = productType;
        this.website = website;
        //language=HTML
        this.template = `
            <div class="${$1fdd39807a87de14$export$77181601c038f22b} ${this.website ? $1fdd39807a87de14$export$61f6990d5944375a : $1fdd39807a87de14$export$96e4b36520c26a2c}">
                <div class="${$1fdd39807a87de14$export$f4c5de44377d2946}">
                    ${this.draw(new (0, $1d10a4a39a7b3567$export$71a85bce14e8f1c5)(true))}
                </div>
            </div>`;
    }
}



var $5FliW = parcelRequire("5FliW");
class $b1abca3e5af47c24$export$6191bb88e92acd1c extends (0, $d7fa30f5b69b40db$export$2a517e1cac1c1f85) {
    commit() {
        super.commit();
        this.headContainer.setStyle(`border-bottom: 1px solid var(--grey-sur);height: 44px;`);
        this.contentContainer.setStyle(`height: calc(100% - 25px);`);
    }
    constructor(productType, details){
        super();
        this.productType = productType;
        this.modalStyle = "width:1160px;height: 93%;";
        //language=HTML
        this.name = (0, $5FliW.Resources).t("words.offerPricing");
        let component = new (0, $6dd9c90eeb33d2ee$export$b39970eebb991951)(this.productType, details);
        component.onCloseModal = ()=>this.close();
        this.modalTemplate = this.draw(component);
    }
}



var $68Z0d = parcelRequire("68Z0d");


var $5FliW = parcelRequire("5FliW");
class $3605b655280e2d1f$export$6d0692ff2663f9ce extends (0, $cbeb6df493e9dc90$export$c4dc9eeb28e63095) {
    renderNoneSite(permissions) {
        this.template = this.draw(new (0, $fe687badf5a941a9$export$9635fd1ed971cc0d)(permissions));
    }
    renderNoneRole() {
        this.template = this.draw(new (0, $426287fa564c6079$export$a6f6f1cb6d6f034e)());
    }
    renderOffer(productType) {
        let offerProduct = (0, $68Z0d.EntityService).activeOfferProducts[productType];
        if (!offerProduct || offerProduct.level == (0, $377ed0589d754635$export$361763241a2a268d).FREE) {
            //language=HTML
            let offerContainer = this.prepend(`
                <div class="${$02c1d8df0a8a48da$export$4caf129a4f120781}">
                    <div class="${$02c1d8df0a8a48da$export$eabcd2c8791e7bf4}">
                        <div class="${$02c1d8df0a8a48da$export$acf4eaf431084f78}">
                            ${this.draw(new (0, $f49d8292e8bb8162$export$e11200deb10216e7)(offerProduct.template.type))}
                        </div>
                        <div class="${$02c1d8df0a8a48da$export$a8ff84c12d48cfa6}">
                            ${(0, $5FliW.Resources).t("words.offerFree")}
                        </div>
                        <div class="${$02c1d8df0a8a48da$export$321c0b1a406de31f}">
                            ${(0, $5FliW.Resources).t("words.free")}
                        </div>
                    </div>
                    <div class="${$02c1d8df0a8a48da$export$79ffe56a765070d2}">
                        <div class="${$02c1d8df0a8a48da$export$6f093cfa640b7166}">
                            ${(0, $5FliW.Resources).t("words.offerSubText")}
                        </div>
                        <div class="${$02c1d8df0a8a48da$export$2ba01fb71ed41cb6}">
                            ${(0, $5FliW.Resources).t("words.offerViewOffers")}
                        </div>
                    </div>
                </div>
            `);
            offerContainer.onClick(()=>{
                let modal = new (0, $b1abca3e5af47c24$export$6191bb88e92acd1c)(productType);
                modal.screenRender();
            });
            this.el($02c1d8df0a8a48da$export$a7db06668cad9adb).addClass($02c1d8df0a8a48da$export$13e2de3c33d99539);
        }
    }
}


class $cf14ff3012794a7f$export$31641b61980e511f extends (0, $3605b655280e2d1f$export$6d0692ff2663f9ce) {
    init() {
        //language=HTML
        this.template = `
            <div class="${$b4573842ced37483$export$d160ab07b491fe06}">
                <div class="${$b4573842ced37483$export$e9396702b45dbab1}">
                    <div class="${$b4573842ced37483$export$6f093cfa640b7166}">
                        <div class="${$b4573842ced37483$export$bd0dc469391eee2c}">
                            404
                        </div>
                        <div class="${$b4573842ced37483$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.youLandedInTheWrongPlace")}
                        </div>
                        <div class="${$b4573842ced37483$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.theRequestedPageDoesNotExistOrHasBeenRemoved")}
                        </div>
                    </div>
                </div>

                <div class="${$b4573842ced37483$export$14439f5cc10d722f}">
                    <div class="${$b4573842ced37483$export$1ca1ec8b29a4ce27}"></div>
                </div>
            </div>
        `;
    }
    onHash() {
        console.log("on hash");
    }
    remove() {
        super.remove();
    }
    constructor(){
        super();
        this.title = (0, $5FliW.Resources).t("words.notFound");
        this.status.online = false;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
class $8b9dceed2c4bc09a$export$383cb4a7b52cc636 extends (0, $fsnB5.Component) {
    // @ts-ignore
    init() {
        this.commit();
    }
    onHash() {}
    constructor(){
        super();
        this.template = "<div>static</div>";
    }
}


class $6c4be56322fba389$export$854fe5f7a33d16c2 extends (0, $8b9dceed2c4bc09a$export$383cb4a7b52cc636) {
    displayShow() {
        super.displayShow();
        this.setStyle("display:flex;opacity:1;");
    }
    async displayHide() {
        await super.fade("out", 200);
        super.displayHide();
    }
    onHash() {}
    constructor(){
        super();
        this.element = document.querySelector('.globalLoaderBackground:not([globalBg])');
    }
}


var $c19ab76d4b0e1af9$export$2cb412c852497e7f;
var $c19ab76d4b0e1af9$export$5fd5031fecdacec3;
var $c19ab76d4b0e1af9$export$a7db06668cad9adb;
var $c19ab76d4b0e1af9$export$fd59df041b888442;
var $c19ab76d4b0e1af9$export$34e0f9847d4c02dd;
var $c19ab76d4b0e1af9$export$ac96a2a951168044;
$c19ab76d4b0e1af9$export$2cb412c852497e7f = "kqQNp";
$c19ab76d4b0e1af9$export$5fd5031fecdacec3 = "_4sSGO";
$c19ab76d4b0e1af9$export$a7db06668cad9adb = "FiFOA";
$c19ab76d4b0e1af9$export$fd59df041b888442 = "TmGHb";
$c19ab76d4b0e1af9$export$34e0f9847d4c02dd = "i-x9E";
$c19ab76d4b0e1af9$export$ac96a2a951168044 = "N27Hn";



var $fsnB5 = parcelRequire("fsnB5");
var $5ba89b326fd08a81$export$9914389b95e1a1e8;
var $5ba89b326fd08a81$export$5ae74841c1c22479;
var $5ba89b326fd08a81$export$300b2c23f49a49cb;
var $5ba89b326fd08a81$export$60974f670aa8d75e;
var $5ba89b326fd08a81$export$364bb6944bd5af75;
var $5ba89b326fd08a81$export$a1fe6a2d7788354f;
var $5ba89b326fd08a81$export$db3c28d99448dcff;
var $5ba89b326fd08a81$export$fb184b623420d9be;
var $5ba89b326fd08a81$export$3931a0da49df8dc0;
var $5ba89b326fd08a81$export$e850e66917a23e0f;
var $5ba89b326fd08a81$export$b6aad051bad07f12;
var $5ba89b326fd08a81$export$1f96ae73734a86cc;
var $5ba89b326fd08a81$export$ee3212a4833dc722;
var $5ba89b326fd08a81$export$6b501c78a3684162;
var $5ba89b326fd08a81$export$7200a869094fec36;
var $5ba89b326fd08a81$export$1ca1ec8b29a4ce27;
var $5ba89b326fd08a81$export$6e0e6ce39e5a0361;
var $5ba89b326fd08a81$export$3e523c77c1f23f8c;
var $5ba89b326fd08a81$export$698bf39bb1e7111e;
var $5ba89b326fd08a81$export$ee1491bbb87d4653;
var $5ba89b326fd08a81$export$3ce6949f20cea765;
var $5ba89b326fd08a81$export$60912654947077e3;
var $5ba89b326fd08a81$export$1c4e7a9c31a6c071;
var $5ba89b326fd08a81$export$84eb487870768d99;
$5ba89b326fd08a81$export$9914389b95e1a1e8 = "TLoVY";
$5ba89b326fd08a81$export$5ae74841c1c22479 = "uqQxU";
$5ba89b326fd08a81$export$300b2c23f49a49cb = "wSkkj";
$5ba89b326fd08a81$export$60974f670aa8d75e = "_2xlwj";
$5ba89b326fd08a81$export$364bb6944bd5af75 = "Sy5qQ";
$5ba89b326fd08a81$export$a1fe6a2d7788354f = "aOE6F";
$5ba89b326fd08a81$export$db3c28d99448dcff = "Uwz-A";
$5ba89b326fd08a81$export$fb184b623420d9be = "rjiEX";
$5ba89b326fd08a81$export$3931a0da49df8dc0 = "Nqs87";
$5ba89b326fd08a81$export$e850e66917a23e0f = "klTSr";
$5ba89b326fd08a81$export$b6aad051bad07f12 = "Wo25U";
$5ba89b326fd08a81$export$1f96ae73734a86cc = "inlHz";
$5ba89b326fd08a81$export$ee3212a4833dc722 = "J5FLr";
$5ba89b326fd08a81$export$6b501c78a3684162 = "pnoj8";
$5ba89b326fd08a81$export$7200a869094fec36 = "qMXh2";
$5ba89b326fd08a81$export$1ca1ec8b29a4ce27 = "K6Unu";
$5ba89b326fd08a81$export$6e0e6ce39e5a0361 = "DjTdk";
$5ba89b326fd08a81$export$3e523c77c1f23f8c = "rKzrE";
$5ba89b326fd08a81$export$698bf39bb1e7111e = "qMxK1";
$5ba89b326fd08a81$export$ee1491bbb87d4653 = "s32-s";
$5ba89b326fd08a81$export$3ce6949f20cea765 = "_64JCz";
$5ba89b326fd08a81$export$60912654947077e3 = "mY5-A";
$5ba89b326fd08a81$export$1c4e7a9c31a6c071 = "g-zA1";
$5ba89b326fd08a81$export$84eb487870768d99 = "itSsE";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
var $a23746ad4c034e5a$export$ebcd94e5d6026061;
var $a23746ad4c034e5a$export$bbea856fdb3e3c5f;
var $a23746ad4c034e5a$export$b3571188c770cc5a;
var $a23746ad4c034e5a$export$596d806903d1f59e;
var $a23746ad4c034e5a$export$1ca1ec8b29a4ce27;
var $a23746ad4c034e5a$export$a7db06668cad9adb;
var $a23746ad4c034e5a$export$4e0c71f277ca26b3;
var $a23746ad4c034e5a$export$3ce6949f20cea765;
var $a23746ad4c034e5a$export$f2120bbfa5450bd2;
var $a23746ad4c034e5a$export$fb184b623420d9be;
var $a23746ad4c034e5a$export$3931a0da49df8dc0;
var $a23746ad4c034e5a$export$e850e66917a23e0f;
var $a23746ad4c034e5a$export$9c1acc30f900961c;
var $a23746ad4c034e5a$export$17a8a1cb950cf89a;
var $a23746ad4c034e5a$export$b602b78110e4ab1e;
var $a23746ad4c034e5a$export$9ebee87b1eb4e24e;
var $a23746ad4c034e5a$export$b4925ff091c7f556;
var $a23746ad4c034e5a$export$7f1a29bc3be2296e;
var $a23746ad4c034e5a$export$ac5985f28ad46107;
var $a23746ad4c034e5a$export$351f93dff0fc1e76;
var $a23746ad4c034e5a$export$e4c89085febbc618;
var $a23746ad4c034e5a$export$f38c853ae54ed474;
var $a23746ad4c034e5a$export$7dc4b9367473a505;
var $a23746ad4c034e5a$export$5d910be2177c3c87;
var $a23746ad4c034e5a$export$ad6718c788124d32;
var $a23746ad4c034e5a$export$7c5480d2d52b096a;
var $a23746ad4c034e5a$export$97971ff30d8c30d2;
var $a23746ad4c034e5a$export$6da9acb12d5139d4;
var $a23746ad4c034e5a$export$7902342170a40c7a;
var $a23746ad4c034e5a$export$29f9f81de5c56283;
var $a23746ad4c034e5a$export$959d3058f2a8f3e9;
var $a23746ad4c034e5a$export$6d59db4903f20f7d;
$a23746ad4c034e5a$export$ebcd94e5d6026061 = "-Vlt9";
$a23746ad4c034e5a$export$bbea856fdb3e3c5f = "dDQun";
$a23746ad4c034e5a$export$b3571188c770cc5a = "_0yX-y";
$a23746ad4c034e5a$export$596d806903d1f59e = "a-IcG";
$a23746ad4c034e5a$export$1ca1ec8b29a4ce27 = "ayL-M";
$a23746ad4c034e5a$export$a7db06668cad9adb = "vMrem";
$a23746ad4c034e5a$export$4e0c71f277ca26b3 = "LGn2t";
$a23746ad4c034e5a$export$3ce6949f20cea765 = "_03B5h";
$a23746ad4c034e5a$export$f2120bbfa5450bd2 = "v-2x3";
$a23746ad4c034e5a$export$fb184b623420d9be = "qZxXS";
$a23746ad4c034e5a$export$3931a0da49df8dc0 = "duq5w";
$a23746ad4c034e5a$export$e850e66917a23e0f = "etszA";
$a23746ad4c034e5a$export$9c1acc30f900961c = "Pt3yQ";
$a23746ad4c034e5a$export$17a8a1cb950cf89a = "_8G-OD";
$a23746ad4c034e5a$export$b602b78110e4ab1e = "Zmwiz";
$a23746ad4c034e5a$export$9ebee87b1eb4e24e = "VnbOJ";
$a23746ad4c034e5a$export$b4925ff091c7f556 = "mdOXG";
$a23746ad4c034e5a$export$7f1a29bc3be2296e = "VjRw1";
$a23746ad4c034e5a$export$ac5985f28ad46107 = "UhgYq";
$a23746ad4c034e5a$export$351f93dff0fc1e76 = "A-gTE";
$a23746ad4c034e5a$export$e4c89085febbc618 = "q9ze4";
$a23746ad4c034e5a$export$f38c853ae54ed474 = "VawEX";
$a23746ad4c034e5a$export$7dc4b9367473a505 = "ZPA1J";
$a23746ad4c034e5a$export$5d910be2177c3c87 = "OzNbr";
$a23746ad4c034e5a$export$ad6718c788124d32 = "_9PHzi";
$a23746ad4c034e5a$export$7c5480d2d52b096a = "J1akp";
$a23746ad4c034e5a$export$97971ff30d8c30d2 = "Vpy-G";
$a23746ad4c034e5a$export$6da9acb12d5139d4 = "DNoVU";
$a23746ad4c034e5a$export$7902342170a40c7a = "uOMwP";
$a23746ad4c034e5a$export$29f9f81de5c56283 = "N5Eu3";
$a23746ad4c034e5a$export$959d3058f2a8f3e9 = "y4A12";
$a23746ad4c034e5a$export$6d59db4903f20f7d = "_7ztef";



var $fsnB5 = parcelRequire("fsnB5");

class $d2bce0f2c76f57da$export$b02585722e8afc63 extends (0, $fsnB5.Component) {
    openColumn(column) {
        column.el($a23746ad4c034e5a$export$3931a0da49df8dc0).displayFlex();
        column.addClass($a23746ad4c034e5a$export$3ce6949f20cea765);
    }
    closeColumn(column) {
        column.el($a23746ad4c034e5a$export$3931a0da49df8dc0).displayHide();
        column.removeClass($a23746ad4c034e5a$export$3ce6949f20cea765);
    }
}



var $5FliW = parcelRequire("5FliW");

var $7AbeR = parcelRequire("7AbeR");


var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");


var $ftoGP = parcelRequire("ftoGP");
class $695d758e717d60ec$export$a51cf35744924ee2 extends (0, $d2bce0f2c76f57da$export$b02585722e8afc63) {
    commit() {
        if ((0, $ftoGP.isMobile)()) this.els($a23746ad4c034e5a$export$4e0c71f277ca26b3).forEach((value)=>{
            value.onClick(()=>{
                this.els($a23746ad4c034e5a$export$4e0c71f277ca26b3).forEach((value)=>this.closeColumn(value));
                this.openColumn(value);
            });
        });
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$a23746ad4c034e5a$export$ebcd94e5d6026061}">
                <div class="${$a23746ad4c034e5a$export$4e0c71f277ca26b3} ${$a23746ad4c034e5a$export$3ce6949f20cea765}">
                    <div class="${$a23746ad4c034e5a$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.tools")}
                        <div class="${$a23746ad4c034e5a$export$f2120bbfa5450bd2}"></div>
                    </div>
                    <div class="${$a23746ad4c034e5a$export$3931a0da49df8dc0}">
                        <a style="display: none;" itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('ai')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$7dc4b9367473a505}"></div>
                                </div>
                               <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.contentStrategy")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.contentStrategyDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('ai')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$f38c853ae54ed474}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.sedestralAI")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.sedestralAIDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('analysis')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$9ebee87b1eb4e24e}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.seoAnalytics")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.seoAnalyticsDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('autopilot')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$5d910be2177c3c87}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.autopilot")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.autopilotDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="${$a23746ad4c034e5a$export$4e0c71f277ca26b3}">
                    <div class="${$a23746ad4c034e5a$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.integrations")}
                        <div class="${$a23746ad4c034e5a$export$f2120bbfa5450bd2}"></div>
                    </div>
                    <div class="${$a23746ad4c034e5a$export$3931a0da49df8dc0}">
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('prestashop')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$7c5480d2d52b096a}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.prestaShop")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.prestaShopDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('shopify')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$6da9acb12d5139d4}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.shopify")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.shopifyDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('wordpress')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$97971ff30d8c30d2}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.wordpress")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.wordpressDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('wix')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$9c1acc30f900961c}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76} ${$a23746ad4c034e5a$export$e4c89085febbc618}">
                                    <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27} ${$a23746ad4c034e5a$export$ad6718c788124d32}"></div>
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.wix")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.wixDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `;
    }
}




var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");

class $2bb2a06ba3558186$export$aae1be5c386a10f3 extends (0, $d2bce0f2c76f57da$export$b02585722e8afc63) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <a href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('pricing')}" class="${$a23746ad4c034e5a$export$ebcd94e5d6026061}">
                <div class="${$a23746ad4c034e5a$export$4e0c71f277ca26b3}">
                    <h6 class="${$a23746ad4c034e5a$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.pricing")}
                        <span class="${$a23746ad4c034e5a$export$f2120bbfa5450bd2}"></span>
                    </h6>
                </div>
            </a>
        `;
    }
}




var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");

class $a28db1a0385cd501$export$f4312c6b981e35a extends (0, $d2bce0f2c76f57da$export$b02585722e8afc63) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <a href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('schedule')}" class="${$a23746ad4c034e5a$export$ebcd94e5d6026061}">
                <div class="${$a23746ad4c034e5a$export$4e0c71f277ca26b3}">
                    <h6 class="${$a23746ad4c034e5a$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.scheduleTitle")}
                        <span class="${$a23746ad4c034e5a$export$f2120bbfa5450bd2}"></span>
                    </h6>
                </div>
            </a>
        `;
    }
}


class $758bc1b187dfb52c$export$310360aa7761db45 extends (0, $d2bce0f2c76f57da$export$b02585722e8afc63) {
    onOpen() {
        let columns = this.els($a23746ad4c034e5a$export$4e0c71f277ca26b3);
        let openedColumn;
        columns.forEach((column)=>{
            this.closeColumn(column);
            let casesContainer = column.el($a23746ad4c034e5a$export$3931a0da49df8dc0);
            let cases = casesContainer.els($a23746ad4c034e5a$export$e850e66917a23e0f);
            cases === null || cases === void 0 ? void 0 : cases.forEach((caseElem)=>{
                if (caseElem.getHTMLElement().parentElement && caseElem.getHTMLElement().parentElement['href'] == window.location.href) {
                    openedColumn = column;
                    this.openColumn(column);
                }
            });
        });
        if (!openedColumn) this.openColumn(columns[0]);
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$a23746ad4c034e5a$export$ebcd94e5d6026061}">
                ${this.draw(new (0, $695d758e717d60ec$export$a51cf35744924ee2)())}
                ${this.draw(new (0, $2bb2a06ba3558186$export$aae1be5c386a10f3)())}
                ${this.draw(new (0, $a28db1a0385cd501$export$f4312c6b981e35a)())}

                <div class="${$a23746ad4c034e5a$export$bbea856fdb3e3c5f}">
                    <a href="${(0, $7AbeR.Network).router.pages.getPanelUrl('signup')}" target="_blank">
                        <div class="${$a23746ad4c034e5a$export$596d806903d1f59e}">
                            ${(0, $5FliW.Resources).t("words.beginFree")}
                        </div>
                    </a>
                    <a class="${$a23746ad4c034e5a$export$e850e66917a23e0f}" href="${(0, $7AbeR.Network).router.pages.getPanelUrl('login')}"
                       target="_blank">
                        <div class="${$a23746ad4c034e5a$export$b3571188c770cc5a} ${$a23746ad4c034e5a$export$596d806903d1f59e}">
                            <div></div>
                            <div class="${$a23746ad4c034e5a$export$a7db06668cad9adb}">
                                ${(0, $5FliW.Resources).t("words.login")}
                            </div>
                        </div>
                    </a>
                    <a class="${$a23746ad4c034e5a$export$e850e66917a23e0f}" href="${(0, $7AbeR.Network).router.pages.getPanelUrl('signup')}"
                       target="_blank">
                        <div class="${$a23746ad4c034e5a$export$b3571188c770cc5a}">
                            <div></div>
                            <div class="${$a23746ad4c034e5a$export$a7db06668cad9adb}">
                                ${(0, $5FliW.Resources).t("words.beginFree")}
                                <div class="${$a23746ad4c034e5a$export$1ca1ec8b29a4ce27}"></div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>`;
    }
}





var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");


class $99459264a7649d3e$export$68f03a9fb148d796 extends (0, $d2bce0f2c76f57da$export$b02585722e8afc63) {
    commit() {
        this.el($a23746ad4c034e5a$export$ac5985f28ad46107).onClick(()=>{
            (0, $7AbeR.Network).router.pages.redirect("/service-client");
        });
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$a23746ad4c034e5a$export$ebcd94e5d6026061}">
                <div class="${$a23746ad4c034e5a$export$4e0c71f277ca26b3}">
                    <h6 class="${$a23746ad4c034e5a$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.useCases")}
                        <span class="${$a23746ad4c034e5a$export$f2120bbfa5450bd2}"></span>
                    </h6>
                    <div class="${$a23746ad4c034e5a$export$3931a0da49df8dc0}">
                        <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('service-client')}">
                            <div class="${$a23746ad4c034e5a$export$e850e66917a23e0f} ${$a23746ad4c034e5a$export$ac5985f28ad46107}">
                                <div class="${$a23746ad4c034e5a$export$351f93dff0fc1e76}">
                                    ${this.draw(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).CLIENT_SERVICE))}
                                </div>
                                <div class="${$a23746ad4c034e5a$export$29f9f81de5c56283}">
                                    <p itemprop="name" class="${$a23746ad4c034e5a$export$959d3058f2a8f3e9}">
                                        ${(0, $5FliW.Resources).t("words.customerService")}
                                    </p>
                                    <p class="${$a23746ad4c034e5a$export$6d59db4903f20f7d}">
                                        ${(0, $5FliW.Resources).t("words.supportCustomers")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `;
    }
}


class $ef6ba031486eb69d$export$749158e506049de5 extends (0, $fsnB5.Component) {
    commit() {
        this.registerSubMenu(this.el($5ba89b326fd08a81$export$b6aad051bad07f12));
        this.registerSubMenu(this.el($5ba89b326fd08a81$export$1f96ae73734a86cc));
        this.registerMobile();
        //this.el(s.blog).onClick(() => window.open(process.env.BLOG_URL));
        this.el($5ba89b326fd08a81$export$ee3212a4833dc722).onClick(()=>(0, $7AbeR.Network).router.pages.redirect("/pricing"));
        this.el($5ba89b326fd08a81$export$60974f670aa8d75e).onClick(()=>(0, $7AbeR.Network).router.pages.redirect("/schedule"));
        super.commit();
    }
    registerSubMenu(caseButton) {
        let subMenu = caseButton.el($5ba89b326fd08a81$export$6e0e6ce39e5a0361);
        caseButton.onHover(()=>subMenu.scaleShow());
        caseButton.onLeave(()=>subMenu.scaleHide(80, 0.9, false));
        (0, $7AbeR.Network).router.pages.onPopState(this, ()=>subMenu.scaleHide(80, 0.9, false));
    }
    registerMobile() {
        let mobileCase = this.el($5ba89b326fd08a81$export$60912654947077e3);
        let mobileContainer = this.el($5ba89b326fd08a81$export$1c4e7a9c31a6c071);
        let hideMenu = ()=>{
            mobileContainer.displayHide();
            mobileContainer.clear();
            mobileCase.removeClass($5ba89b326fd08a81$export$3ce6949f20cea765);
            this.removeClass($5ba89b326fd08a81$export$5ae74841c1c22479);
            this.timeOut(()=>{
                mobileContainer.setStyle("max-height: 0%;");
            }, 1);
        };
        let showMenu = ()=>{
            let mobileMenuComponent = new (0, $758bc1b187dfb52c$export$310360aa7761db45)();
            mobileContainer.render(mobileMenuComponent);
            mobileContainer.displayShow();
            mobileMenuComponent.onOpen();
            mobileCase.addClass($5ba89b326fd08a81$export$3ce6949f20cea765);
            this.addClass($5ba89b326fd08a81$export$5ae74841c1c22479);
            this.timeOut(()=>{
                mobileContainer.setStyle("max-height: 100%;");
            }, 1);
        };
        mobileContainer.onOutsideClick(()=>hideMenu());
        mobileCase.onClick(()=>{
            if (mobileContainer.isDisplayNone()) showMenu();
            else hideMenu();
        }, true);
        (0, $7AbeR.Network).router.pages.onPopState(this, ()=>hideMenu());
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$5ba89b326fd08a81$export$9914389b95e1a1e8}">
                <div style="z-index: 4;" itemscope itemtype="https://schema.org/Organization">
                    <a itemprop="url" href="${"https://sedestral.com/" + (0, $5FliW.Resources).language + "/home"}">
                        <meta itemprop="brand" content="Sedestral">
                        <div class="${$5ba89b326fd08a81$export$364bb6944bd5af75}">
                            <div itemprop="logo" class="${$5ba89b326fd08a81$export$a1fe6a2d7788354f}">
                                <img itemprop="logo" class="${$5ba89b326fd08a81$export$db3c28d99448dcff}"
                                     src="${(0, $7AbeR.Network).vendor}images/logo-sedestral.svg"
                                     alt="${(0, $5FliW.Resources).t("words.logo")}">
                            </div>
                            <h2 itemprop="name" class="${$5ba89b326fd08a81$export$fb184b623420d9be}">
                                Sedestral
                            </h2>
                        </div>
                    </a>
                </div>
                <div itemscope itemtype="https://schema.org/SiteNavigationElement" class="${$5ba89b326fd08a81$export$3931a0da49df8dc0}">
                    <div class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$b6aad051bad07f12}">
                        ${(0, $5FliW.Resources).t("words.solutions")}
                        <i class="${$5ba89b326fd08a81$export$1ca1ec8b29a4ce27}"></i>

                        <div class="${$5ba89b326fd08a81$export$6e0e6ce39e5a0361}">
                            <div class="${$5ba89b326fd08a81$export$3e523c77c1f23f8c}"></div>
                            ${this.draw(new (0, $695d758e717d60ec$export$a51cf35744924ee2)())}
                        </div>
                    </div>
                    <div style="display: none;" class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$1f96ae73734a86cc}">
                        ${(0, $5FliW.Resources).t("words.useCases")}
                        <i class="${$5ba89b326fd08a81$export$1ca1ec8b29a4ce27}"></i>

                        <div class="${$5ba89b326fd08a81$export$6e0e6ce39e5a0361}">
                            <div class="${$5ba89b326fd08a81$export$3e523c77c1f23f8c}"></div>
                            ${this.draw(new (0, $99459264a7649d3e$export$68f03a9fb148d796)())}
                        </div>
                    </div>
                    <div class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$ee3212a4833dc722}">
                        <a href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('pricing')}">${(0, $5FliW.Resources).t("words.pricing")}</a>
                    </div>
                    <div class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$60974f670aa8d75e}">
                        <a href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('schedule')}">${(0, $5FliW.Resources).t("words.scheduleTitle")}</a>
                    </div>
                        <!--<div class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$300b2c23f49a49cb}">
                        <a target="_blank" href="${"https://blog.sedestral.com"}">Blog</a>
                    </div>-->
                    <a class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$6b501c78a3684162}" href="${(0, $7AbeR.Network).router.pages.getPanelUrl('login')}"
                       target="_blank">
                        ${(0, $5FliW.Resources).t("words.login")}
                    </a>
                    <a class="${$5ba89b326fd08a81$export$e850e66917a23e0f} ${$5ba89b326fd08a81$export$6b501c78a3684162} ${$5ba89b326fd08a81$export$7200a869094fec36}" href="${(0, $7AbeR.Network).router.pages.getPanelUrl('signup')}"
                       target="_blank">
                        ${(0, $5FliW.Resources).t("words.beginFree")}
                    </a>
                </div>
                <div class="${$5ba89b326fd08a81$export$698bf39bb1e7111e}">
                    <div class="${$5ba89b326fd08a81$export$ee1491bbb87d4653} ${$5ba89b326fd08a81$export$60912654947077e3}">
                        <span class="${$5ba89b326fd08a81$export$1ca1ec8b29a4ce27}"></span>
                    </div>
                </div>
                <div class="${$5ba89b326fd08a81$export$1c4e7a9c31a6c071}"></div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $1d999f79beb5ad10$export$70e3371ee669ebd3;
var $1d999f79beb5ad10$export$96ff94e0adb1d772;
var $1d999f79beb5ad10$export$364bb6944bd5af75;
var $1d999f79beb5ad10$export$a1fe6a2d7788354f;
var $1d999f79beb5ad10$export$db3c28d99448dcff;
var $1d999f79beb5ad10$export$fb184b623420d9be;
var $1d999f79beb5ad10$export$53b3c91859018cd4;
var $1d999f79beb5ad10$export$4e0c71f277ca26b3;
var $1d999f79beb5ad10$export$3e9f948b41964866;
var $1d999f79beb5ad10$export$c407db72103fecfa;
var $1d999f79beb5ad10$export$789c912f57fe164c;
var $1d999f79beb5ad10$export$666c3ad173ff70db;
$1d999f79beb5ad10$export$70e3371ee669ebd3 = "sWQBN";
$1d999f79beb5ad10$export$96ff94e0adb1d772 = "n2TOE";
$1d999f79beb5ad10$export$364bb6944bd5af75 = "_6indg";
$1d999f79beb5ad10$export$a1fe6a2d7788354f = "QzMt4";
$1d999f79beb5ad10$export$db3c28d99448dcff = "_3vKT0";
$1d999f79beb5ad10$export$fb184b623420d9be = "wCw69";
$1d999f79beb5ad10$export$53b3c91859018cd4 = "KAdqr";
$1d999f79beb5ad10$export$4e0c71f277ca26b3 = "eIrgo";
$1d999f79beb5ad10$export$3e9f948b41964866 = "kyTyE";
$1d999f79beb5ad10$export$c407db72103fecfa = "XePa5";
$1d999f79beb5ad10$export$789c912f57fe164c = "VPgA6";
$1d999f79beb5ad10$export$666c3ad173ff70db = "Vy4h7";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");


var $5FliW = parcelRequire("5FliW");
var $0be5d830987c2d4f$export$1bc61b600880820c;
var $0be5d830987c2d4f$export$a4510362933968c8;
$0be5d830987c2d4f$export$1bc61b600880820c = "PrJU2";
$0be5d830987c2d4f$export$a4510362933968c8 = "g8H2t";



var $3uVji = parcelRequire("3uVji");
class $2ec690b4570df58c$export$afc0a508cbf81cd2 extends (0, $fsnB5.Component) {
    commit() {
        var _this_settings;
        super.commit();
        this.selectBox = new (0, $e405542e42644909$export$32ca16bda187b168)((0, $3uVji.objectUpdate)(this.settings ? this.settings : {}, {
            entries: (0, $5FliW.Resources).worldLanguages.filter((l)=>!this.filters || this.filters.includes(l.code)).map((v)=>{
                return {
                    label: v.name,
                    value: v.code
                };
            }),
            selectedValue: this.value,
            search: ((_this_settings = this.settings) === null || _this_settings === void 0 ? void 0 : _this_settings.search) != undefined ? this.settings.search : true
        }));
        this.selectBox.onSelect = (entry)=>this.onSelect(entry.value);
        this.clearAll();
        this.render(this.selectBox);
    }
    onSelect(language) {}
    constructor(value, settings, filters){
        super();
        this.value = value;
        this.settings = settings;
        this.filters = filters;
        //language=HTML
        this.template = `
            <div class="${$0be5d830987c2d4f$export$1bc61b600880820c}"></div>
        `;
    }
}


class $605c97b8166a54f7$export$b25f5cc1eb7681bd {
}
$605c97b8166a54f7$export$b25f5cc1eb7681bd.panel = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.blog = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.helpCenter = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.livechat = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];
$605c97b8166a54f7$export$b25f5cc1eb7681bd.website = [
    "fr",
    "en",
    "es",
    "it",
    "pt",
    "nl",
    "de",
    "lb",
    "da"
];


class $3ab33421e0736592$export$ec10209cef18e52a extends (0, $2ec690b4570df58c$export$afc0a508cbf81cd2) {
    constructor(value){
        super(value, {
            search: false
        }, (0, $605c97b8166a54f7$export$b25f5cc1eb7681bd).website);
    }
}


class $2c0a70060657d3d3$export$f7cee7a23320c3c3 extends (0, $fsnB5.Component) {
    commit() {
        this.languagePicker.onSelect = (language)=>(0, $7AbeR.Network).router.pages.setLanguage(language);
        super.commit();
    }
    constructor(){
        super();
        this.languagePicker = new (0, $3ab33421e0736592$export$ec10209cef18e52a)((0, $5FliW.Resources).language);
        //language=HTML
        this.template = `
            <div class="${$1d999f79beb5ad10$export$70e3371ee669ebd3}">
                <div class="${$1d999f79beb5ad10$export$96ff94e0adb1d772}">
                    <div style="z-index: 4;" itemscope itemtype="https://schema.org/Organization">
                    <a itemprop="url" href="${"https://sedestral.com/" + (0, $5FliW.Resources).language + "/home"}">
                        <meta itemprop="brand" content="Sedestral">
                        <div class="${$1d999f79beb5ad10$export$364bb6944bd5af75}">
                            <div itemprop="logo" class="${$1d999f79beb5ad10$export$a1fe6a2d7788354f}">
                                <img itemprop="logo" class="${$1d999f79beb5ad10$export$db3c28d99448dcff}"
                                     src="${(0, $7AbeR.Network).vendor}images/logo-sedestral.svg"
                                     alt="${(0, $5FliW.Resources).t("words.logo")}">
                            </div>
                            <h2 itemprop="name" class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                                Sedestral
                            </h2>
                        </div>
                    </a>
                </div>
                </div>
                <div itemscope itemtype="https://schema.org/SiteNavigationElement" class="${$1d999f79beb5ad10$export$53b3c91859018cd4}">
                    <div class="${$1d999f79beb5ad10$export$4e0c71f277ca26b3}">
                        <nav class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.tools")}
                            <ul class="${$1d999f79beb5ad10$export$3e9f948b41964866}">
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('ai')}">
                                        ${(0, $5FliW.Resources).t("words.sedestralAI")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('analysis')}">
                                        ${(0, $5FliW.Resources).t("words.seoAnalytics")}
                                    </a> 
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('autopilot')}">
                                        ${(0, $5FliW.Resources).t("words.autopilot")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('style')}">
                                        ${(0, $5FliW.Resources).t("words.styleCloningTitle")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                     <div class="${$1d999f79beb5ad10$export$4e0c71f277ca26b3}">
                        <nav class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.integrations")}
                            <ul class="${$1d999f79beb5ad10$export$3e9f948b41964866}">
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('prestashop')}">
                                        ${(0, $5FliW.Resources).t("words.prestaShop")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('shopify')}">
                                        ${(0, $5FliW.Resources).t("words.shopify")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('wordpress')}">
                                        ${(0, $5FliW.Resources).t("words.wordpress")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('wix')}">
                                        ${(0, $5FliW.Resources).t("words.wix")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="${$1d999f79beb5ad10$export$4e0c71f277ca26b3}">
                        <nav class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.resources")}
                            <ul class="${$1d999f79beb5ad10$export$3e9f948b41964866}">
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('pricing')}">
                                        ${(0, $5FliW.Resources).t("words.pricing")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('schedule')}">
                                        ${(0, $5FliW.Resources).t("words.scheduleTitle")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('cgu')}">
                                        ${(0, $5FliW.Resources).t("words.conditionsOfUse")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('cgv')}">
                                        ${(0, $5FliW.Resources).t("words.generalSalesConditions")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getUrlWithPath('policy')}">
                                        ${(0, $5FliW.Resources).t("words.privacyPolicyName")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="${$1d999f79beb5ad10$export$4e0c71f277ca26b3}">
                        <nav class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.account")}
                            <ul class="${$1d999f79beb5ad10$export$3e9f948b41964866}">
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getPanelUrl('login')}" target="_blank">
                                        ${(0, $5FliW.Resources).t("words.myAccount")}
                                    </a>
                                </li>
                                <li itemprop="name" class="${$1d999f79beb5ad10$export$c407db72103fecfa}">
                                    <a itemprop="url" href="${(0, $7AbeR.Network).router.pages.getPanelUrl("signup")}" target="_blank">
                                        ${(0, $5FliW.Resources).t("words.signUp")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <nav class="${$1d999f79beb5ad10$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.language")}
                            <div class="${$1d999f79beb5ad10$export$789c912f57fe164c}">
                                ${this.draw(this.languagePicker)}
                            </div>
                        </nav>
                    </div>
                </div>
                <p class="${$1d999f79beb5ad10$export$666c3ad173ff70db}">
                    Copyright \xa9 ${new Date().getFullYear()} Sedestral. ${(0, $5FliW.Resources).t("words.allRightsReserved")}
                </p>
            </div>
        `;
    }
}





var $fsnB5 = parcelRequire("fsnB5");
var $d687a67d532c604e$export$8a4b034b88ce89d2;
var $d687a67d532c604e$export$e4b2ac9215619f8d;
var $d687a67d532c604e$export$fb184b623420d9be;
var $d687a67d532c604e$export$6d59db4903f20f7d;
var $d687a67d532c604e$export$b3571188c770cc5a;
var $d687a67d532c604e$export$1ca1ec8b29a4ce27;
var $d687a67d532c604e$export$5ff12484cc89d9be;
var $d687a67d532c604e$export$a7db06668cad9adb;
var $d687a67d532c604e$export$acf4eaf431084f78;
var $d687a67d532c604e$export$b8972b998723d602;
$d687a67d532c604e$export$8a4b034b88ce89d2 = "ncrla";
$d687a67d532c604e$export$e4b2ac9215619f8d = "KxwNl";
$d687a67d532c604e$export$fb184b623420d9be = "Av5iz";
$d687a67d532c604e$export$6d59db4903f20f7d = "SP8FW";
$d687a67d532c604e$export$b3571188c770cc5a = "GQy6k";
$d687a67d532c604e$export$1ca1ec8b29a4ce27 = "OXijq";
$d687a67d532c604e$export$5ff12484cc89d9be = "xDwRm";
$d687a67d532c604e$export$a7db06668cad9adb = "Qq00-";
$d687a67d532c604e$export$acf4eaf431084f78 = "qoRcZ";
$d687a67d532c604e$export$b8972b998723d602 = "dxpy-";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $9382a53107fea630$export$ecbe10969f9e521f extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$d687a67d532c604e$export$8a4b034b88ce89d2}">
                <div class="${$d687a67d532c604e$export$e4b2ac9215619f8d}">
                    <div class="${$d687a67d532c604e$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.organicTrafficWithinReach")}
                    </div>
                    <div class="${$d687a67d532c604e$export$6d59db4903f20f7d}">
                        ${(0, $5FliW.Resources).t("words.sedestralDescription")}
                    </div>
                    <a href="${(0, $7AbeR.Network).router.pages.getPanelUrl('signup')}" target="_blank" class="${$d687a67d532c604e$export$b3571188c770cc5a}">
                        <div class="${$d687a67d532c604e$export$5ff12484cc89d9be}"></div>
                        <div class="${$d687a67d532c604e$export$a7db06668cad9adb}">
                            ${(0, $5FliW.Resources).t("words.beginFree")}
                            <div class="${$d687a67d532c604e$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                </div>
                <div class="${$d687a67d532c604e$export$acf4eaf431084f78}">
                    <div class="${$d687a67d532c604e$export$1ca1ec8b29a4ce27}"></div>
                </div>
                <div class="${$d687a67d532c604e$export$b8972b998723d602}"></div>
            </div>
        `;
    }
}


class $e70ad9b6a622ca7a$export$f58f12b264b5aeb7 extends (0, $cbeb6df493e9dc90$export$c4dc9eeb28e63095) {
    contentComponent() {
        return undefined;
    }
    init() {
        //language=HTML
        this.template = `
            <div class="${$02c1d8df0a8a48da$export$523fb3936f49e028}">
                <div class="${$c19ab76d4b0e1af9$export$2cb412c852497e7f}">
                    <div class="${$c19ab76d4b0e1af9$export$5fd5031fecdacec3}">
                        ${this.draw(new (0, $ef6ba031486eb69d$export$749158e506049de5)())}
                    </div>
                    ${this.draw(this.contentComponent())}
                    <div class="${$c19ab76d4b0e1af9$export$a7db06668cad9adb}">
                        <div class="${$c19ab76d4b0e1af9$export$fd59df041b888442}">
                            <div class="${$c19ab76d4b0e1af9$export$34e0f9847d4c02dd}">
                                ${this.draw(new (0, $9382a53107fea630$export$ecbe10969f9e521f)())}
                            </div>
                        </div>
                    </div>
                    <div class="${$c19ab76d4b0e1af9$export$ac96a2a951168044}">
                        ${this.draw(new (0, $2c0a70060657d3d3$export$f7cee7a23320c3c3)())}
                    </div>
                </div>
            </div>
        `;
    }
    onHash() {}
    constructor(){
        super();
        //language=HTML
        this.template = `
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $974334ea2495c9d4$export$f997558458ede46c;
var $974334ea2495c9d4$export$8fa4e5556fd77a60;
var $974334ea2495c9d4$export$a7db06668cad9adb;
var $974334ea2495c9d4$export$34e0f9847d4c02dd;
$974334ea2495c9d4$export$f997558458ede46c = "_1xZ4z";
$974334ea2495c9d4$export$8fa4e5556fd77a60 = "_0u-sQ";
$974334ea2495c9d4$export$a7db06668cad9adb = "M6c0H";
$974334ea2495c9d4$export$34e0f9847d4c02dd = "OKAGF";


var $0aac9ecd4494bcf5$export$5016101a142bf96a;
var $0aac9ecd4494bcf5$export$3bf720ece7bc7b2e;
var $0aac9ecd4494bcf5$export$1f6feda8aa226b71;
var $0aac9ecd4494bcf5$export$34e0f9847d4c02dd;
$0aac9ecd4494bcf5$export$5016101a142bf96a = "Toz-F";
$0aac9ecd4494bcf5$export$3bf720ece7bc7b2e = "-gDaK";
$0aac9ecd4494bcf5$export$1f6feda8aa226b71 = "k0Z8m";
$0aac9ecd4494bcf5$export$34e0f9847d4c02dd = "_5OUdl";



var $fsnB5 = parcelRequire("fsnB5");
var $5ec73963a9359d7a$exports = {};

$parcel$export($5ec73963a9359d7a$exports, "componentWebsiteProduct", function () { return $5ec73963a9359d7a$export$50bc9fb5708a76a9; }, function (v) { return $5ec73963a9359d7a$export$50bc9fb5708a76a9 = v; });
$parcel$export($5ec73963a9359d7a$exports, "brandContainer", function () { return $5ec73963a9359d7a$export$b700ae2838043bbf; }, function (v) { return $5ec73963a9359d7a$export$b700ae2838043bbf = v; });
$parcel$export($5ec73963a9359d7a$exports, "imageContainer", function () { return $5ec73963a9359d7a$export$63e82393dc8977bf; }, function (v) { return $5ec73963a9359d7a$export$63e82393dc8977bf = v; });
$parcel$export($5ec73963a9359d7a$exports, "cardTexts", function () { return $5ec73963a9359d7a$export$48c304f518b09d1e; }, function (v) { return $5ec73963a9359d7a$export$48c304f518b09d1e = v; });
$parcel$export($5ec73963a9359d7a$exports, "title", function () { return $5ec73963a9359d7a$export$fb184b623420d9be; }, function (v) { return $5ec73963a9359d7a$export$fb184b623420d9be = v; });
$parcel$export($5ec73963a9359d7a$exports, "inbox", function () { return $5ec73963a9359d7a$export$9c1acc30f900961c; }, function (v) { return $5ec73963a9359d7a$export$9c1acc30f900961c = v; });
$parcel$export($5ec73963a9359d7a$exports, "statistics", function () { return $5ec73963a9359d7a$export$9ebee87b1eb4e24e; }, function (v) { return $5ec73963a9359d7a$export$9ebee87b1eb4e24e = v; });
$parcel$export($5ec73963a9359d7a$exports, "livechat", function () { return $5ec73963a9359d7a$export$17a8a1cb950cf89a; }, function (v) { return $5ec73963a9359d7a$export$17a8a1cb950cf89a = v; });
$parcel$export($5ec73963a9359d7a$exports, "mail", function () { return $5ec73963a9359d7a$export$b602b78110e4ab1e; }, function (v) { return $5ec73963a9359d7a$export$b602b78110e4ab1e = v; });
$parcel$export($5ec73963a9359d7a$exports, "serviceclient", function () { return $5ec73963a9359d7a$export$cbb43b43d319c590; }, function (v) { return $5ec73963a9359d7a$export$cbb43b43d319c590 = v; });
$parcel$export($5ec73963a9359d7a$exports, "text", function () { return $5ec73963a9359d7a$export$6f093cfa640b7166; }, function (v) { return $5ec73963a9359d7a$export$6f093cfa640b7166 = v; });
$parcel$export($5ec73963a9359d7a$exports, "round", function () { return $5ec73963a9359d7a$export$2077e0241d6afd3c; }, function (v) { return $5ec73963a9359d7a$export$2077e0241d6afd3c = v; });
$parcel$export($5ec73963a9359d7a$exports, "prestashop", function () { return $5ec73963a9359d7a$export$7c5480d2d52b096a; }, function (v) { return $5ec73963a9359d7a$export$7c5480d2d52b096a = v; });
$parcel$export($5ec73963a9359d7a$exports, "icon", function () { return $5ec73963a9359d7a$export$1ca1ec8b29a4ce27; }, function (v) { return $5ec73963a9359d7a$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($5ec73963a9359d7a$exports, "wix", function () { return $5ec73963a9359d7a$export$ad6718c788124d32; }, function (v) { return $5ec73963a9359d7a$export$ad6718c788124d32 = v; });
$parcel$export($5ec73963a9359d7a$exports, "wordpress", function () { return $5ec73963a9359d7a$export$97971ff30d8c30d2; }, function (v) { return $5ec73963a9359d7a$export$97971ff30d8c30d2 = v; });
$parcel$export($5ec73963a9359d7a$exports, "shopify", function () { return $5ec73963a9359d7a$export$6da9acb12d5139d4; }, function (v) { return $5ec73963a9359d7a$export$6da9acb12d5139d4 = v; });
$parcel$export($5ec73963a9359d7a$exports, "webflow", function () { return $5ec73963a9359d7a$export$7902342170a40c7a; }, function (v) { return $5ec73963a9359d7a$export$7902342170a40c7a = v; });
$parcel$export($5ec73963a9359d7a$exports, "promo", function () { return $5ec73963a9359d7a$export$40e52e4cb633d77a; }, function (v) { return $5ec73963a9359d7a$export$40e52e4cb633d77a = v; });
$parcel$export($5ec73963a9359d7a$exports, "button", function () { return $5ec73963a9359d7a$export$2ba01fb71ed41cb6; }, function (v) { return $5ec73963a9359d7a$export$2ba01fb71ed41cb6 = v; });
$parcel$export($5ec73963a9359d7a$exports, "shadow", function () { return $5ec73963a9359d7a$export$b8972b998723d602; }, function (v) { return $5ec73963a9359d7a$export$b8972b998723d602 = v; });
$parcel$export($5ec73963a9359d7a$exports, "content", function () { return $5ec73963a9359d7a$export$a7db06668cad9adb; }, function (v) { return $5ec73963a9359d7a$export$a7db06668cad9adb = v; });
var $5ec73963a9359d7a$export$50bc9fb5708a76a9;
var $5ec73963a9359d7a$export$b700ae2838043bbf;
var $5ec73963a9359d7a$export$63e82393dc8977bf;
var $5ec73963a9359d7a$export$48c304f518b09d1e;
var $5ec73963a9359d7a$export$fb184b623420d9be;
var $5ec73963a9359d7a$export$9c1acc30f900961c;
var $5ec73963a9359d7a$export$9ebee87b1eb4e24e;
var $5ec73963a9359d7a$export$17a8a1cb950cf89a;
var $5ec73963a9359d7a$export$b602b78110e4ab1e;
var $5ec73963a9359d7a$export$cbb43b43d319c590;
var $5ec73963a9359d7a$export$6f093cfa640b7166;
var $5ec73963a9359d7a$export$2077e0241d6afd3c;
var $5ec73963a9359d7a$export$7c5480d2d52b096a;
var $5ec73963a9359d7a$export$1ca1ec8b29a4ce27;
var $5ec73963a9359d7a$export$ad6718c788124d32;
var $5ec73963a9359d7a$export$97971ff30d8c30d2;
var $5ec73963a9359d7a$export$6da9acb12d5139d4;
var $5ec73963a9359d7a$export$7902342170a40c7a;
var $5ec73963a9359d7a$export$40e52e4cb633d77a;
var $5ec73963a9359d7a$export$2ba01fb71ed41cb6;
var $5ec73963a9359d7a$export$b8972b998723d602;
var $5ec73963a9359d7a$export$a7db06668cad9adb;
$5ec73963a9359d7a$export$50bc9fb5708a76a9 = "A6P3b";
$5ec73963a9359d7a$export$b700ae2838043bbf = "_2lx1n";
$5ec73963a9359d7a$export$63e82393dc8977bf = "aHiz1";
$5ec73963a9359d7a$export$48c304f518b09d1e = "wxWNP";
$5ec73963a9359d7a$export$fb184b623420d9be = "Lnmyj";
$5ec73963a9359d7a$export$9c1acc30f900961c = "Tz7ie";
$5ec73963a9359d7a$export$9ebee87b1eb4e24e = "k-pem";
$5ec73963a9359d7a$export$17a8a1cb950cf89a = "eHNQ9";
$5ec73963a9359d7a$export$b602b78110e4ab1e = "Fm-kD";
$5ec73963a9359d7a$export$cbb43b43d319c590 = "LdonG";
$5ec73963a9359d7a$export$6f093cfa640b7166 = "DM1Jo";
$5ec73963a9359d7a$export$2077e0241d6afd3c = "nvn8h";
$5ec73963a9359d7a$export$7c5480d2d52b096a = "wH2ys";
$5ec73963a9359d7a$export$1ca1ec8b29a4ce27 = "xJC3p";
$5ec73963a9359d7a$export$ad6718c788124d32 = "qODv7";
$5ec73963a9359d7a$export$97971ff30d8c30d2 = "h3WXc";
$5ec73963a9359d7a$export$6da9acb12d5139d4 = "MK1oF";
$5ec73963a9359d7a$export$7902342170a40c7a = "_8F1wQ";
$5ec73963a9359d7a$export$40e52e4cb633d77a = "hLzZO";
$5ec73963a9359d7a$export$2ba01fb71ed41cb6 = "_529Da";
$5ec73963a9359d7a$export$b8972b998723d602 = "_856Tg";
$5ec73963a9359d7a$export$a7db06668cad9adb = "Xqh-B";



var $fsnB5 = parcelRequire("fsnB5");
var $112ba63cdebd93ff$export$bd28379bbedb5475;
var $112ba63cdebd93ff$export$351f93dff0fc1e76;
var $112ba63cdebd93ff$export$75a30c72c46d1150;
$112ba63cdebd93ff$export$bd28379bbedb5475 = "chBpD";
$112ba63cdebd93ff$export$351f93dff0fc1e76 = "bgk4Z";
$112ba63cdebd93ff$export$75a30c72c46d1150 = "iDRe2";




var $kfkzw = parcelRequire("kfkzw");

var $bi5k0 = parcelRequire("bi5k0");

var $5FliW = parcelRequire("5FliW");
class $a9f7f0022deb0877$export$fc7ae33fafef4f1d extends (0, $fsnB5.Component) {
    commit() {
        this.capsuleContainer = this.el($112ba63cdebd93ff$export$351f93dff0fc1e76);
        if (!this.productType) this.capsuleContainer.remove();
        else this.capsuleContainer.render(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)(this.productType));
        super.commit();
    }
    constructor(productType, productName){
        super();
        this.productType = productType;
        this.productName = productName;
        let style = "";
        switch(productType){
            case (0, $kfkzw.ProductType).CLIENT_SERVICE:
                style = "display:none";
                break;
        }
        //language=HTML
        this.template = `
            <div class="${$112ba63cdebd93ff$export$bd28379bbedb5475}">
                <div class="${$112ba63cdebd93ff$export$351f93dff0fc1e76}" style="${style}"></div>
                <h1 class="${$112ba63cdebd93ff$export$75a30c72c46d1150}">
                    ${this.productName ? this.productName : this.productType == (0, $kfkzw.ProductType).CLIENT_SERVICE ? (0, $5FliW.Resources).t("words.customerService") : (0, $5FliW.Resources).t("words.products." + (0, $bi5k0.ProductName).toString(this.productType))}
                </h1>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $d0674153ae2fdcfe$exports = {};

$parcel$export($d0674153ae2fdcfe$exports, "componentWebsiteImageSkewed", function () { return $d0674153ae2fdcfe$export$120e66516e7c1a2; }, function (v) { return $d0674153ae2fdcfe$export$120e66516e7c1a2 = v; });
$parcel$export($d0674153ae2fdcfe$exports, "intermediate", function () { return $d0674153ae2fdcfe$export$28824b7d7b72532c; }, function (v) { return $d0674153ae2fdcfe$export$28824b7d7b72532c = v; });
$parcel$export($d0674153ae2fdcfe$exports, "discreet", function () { return $d0674153ae2fdcfe$export$b888741373b3dda2; }, function (v) { return $d0674153ae2fdcfe$export$b888741373b3dda2 = v; });
$parcel$export($d0674153ae2fdcfe$exports, "important", function () { return $d0674153ae2fdcfe$export$929888ab0c9f043c; }, function (v) { return $d0674153ae2fdcfe$export$929888ab0c9f043c = v; });
var $d0674153ae2fdcfe$export$120e66516e7c1a2;
var $d0674153ae2fdcfe$export$28824b7d7b72532c;
var $d0674153ae2fdcfe$export$b888741373b3dda2;
var $d0674153ae2fdcfe$export$929888ab0c9f043c;
$d0674153ae2fdcfe$export$120e66516e7c1a2 = "ugMaD";
$d0674153ae2fdcfe$export$28824b7d7b72532c = "arVTJ";
$d0674153ae2fdcfe$export$b888741373b3dda2 = "VUubG";
$d0674153ae2fdcfe$export$929888ab0c9f043c = "HUKHM";



var $5FliW = parcelRequire("5FliW");
class $30df9065b5ef9d68$export$1850aae07b2215a1 extends (0, $fsnB5.Component) {
    constructor(p){
        super();
        this.shadow = p.shadow;
        this.type = "IMG";
        //language=HTML
        this.template = `
            <img class="${$d0674153ae2fdcfe$exports.componentWebsiteImageSkewed} ${$d0674153ae2fdcfe$exports[this.shadow]}"
                 src="${p.link}"
                 alt="${(0, $5FliW.Resources).t("words.presentationImage")}"
                 width="${p.width}"
                 height="${p.height}"
            />
        `;
    }
}



var $bi5k0 = parcelRequire("bi5k0");

var $fsnB5 = parcelRequire("fsnB5");
class $b728abad6b753e49$export$860f11a0f47b60ac extends (0, $fsnB5.Component) {
    commit() {
        let video = this.el("video").getHTMLElement();
        video.addEventListener('canplay', ()=>{
            video.style.width = 'calc(100% + 1px)';
        });
        super.commit();
    }
    constructor(url){
        super();
        //language=HTML
        this.template = `
            <div style="width: 100%; overflow: hidden;box-shadow: 0 0 73.91px var(--black-alpha-middle);border-radius: 18px;position: relative;">
                <div style="height: 6px;width: 100%;background: #ffffff;position: absolute;bottom: 0;"></div>
                <video class="video" autoplay loop muted playsinline
                       style=" height: auto;width: 0;margin-top: -1px;">
                    <source src="${url}" type="video/mp4">
                    Votre navigateur ne supporte pas les vid\xe9os HTML5.
                </video>
            </div>
        `;
    }
}


class $7389044f417dac9d$export$dd68357b72560132 extends (0, $fsnB5.Component) {
    commit() {
        this.imageContainer = this.el($5ec73963a9359d7a$exports.imageContainer);
        if (this.pUrl.endsWith(".mp4")) //language=HTML
        this.imageContainer.render(new (0, $b728abad6b753e49$export$860f11a0f47b60ac)(this.pUrl));
        else this.imageContainer.render(new (0, $30df9065b5ef9d68$export$1850aae07b2215a1)({
            link: this.pUrl,
            shadow: "important",
            width: `920`,
            height: `517.5`
        }));
        super.commit();
    }
    constructor(p){
        super();
        this.productType = p.productType;
        this.pUrl = p.url;
        //language=HTML
        this.template = `
            <div class="${$5ec73963a9359d7a$exports.componentWebsiteProduct}">
                <div class="${$5ec73963a9359d7a$exports.brandContainer}">
                    ${this.draw(new (0, $a9f7f0022deb0877$export$fc7ae33fafef4f1d)(p.productType, p.productName))}
                </div>
                <div class="${$5ec73963a9359d7a$exports.imageContainer}"></div>
                <div class="${$5ec73963a9359d7a$exports.cardTexts}">
                    ${p.roundIcon ? `<div class="${$5ec73963a9359d7a$exports.round} ${$5ec73963a9359d7a$exports[p.roundIcon]}"><div class="${$5ec73963a9359d7a$exports.icon}"></div></div>` : ``}
                    <h2 class="${$5ec73963a9359d7a$exports.title} ${$5ec73963a9359d7a$exports[p.titleClass ? p.titleClass : (0, $bi5k0.ProductName).toString(this.productType)]}">
                        ${p.title}
                    </h2>
                    <p class="${$5ec73963a9359d7a$exports.text}">
                        ${p.text}
                    </p>
                    ${p.promo ? `<div class="${$5ec73963a9359d7a$exports.promo}">${p.promo}</div>` : ``}
                    ${p.buttonText ? `<a target="_blank" href="${p.buttonUrl}">
                                <div class="${$5ec73963a9359d7a$exports.button}">
                                    <div class="${$5ec73963a9359d7a$exports.shadow}"></div>
                                    <div class="${$5ec73963a9359d7a$exports.content}">
                                        ${p.buttonText}
                                        ${p.buttonIcon ? `<div class="${$5ec73963a9359d7a$exports.icon} ${$5ec73963a9359d7a$exports[p.buttonIcon]}"></div>` : `<div class="${$5ec73963a9359d7a$exports.icon}"></div>`}
                                    </div>
                                </div>
                            </a>` : ``}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $9dd7ddaf192a25a9$exports = {};

$parcel$export($9dd7ddaf192a25a9$exports, "componentWebsitePresentationLight", function () { return $9dd7ddaf192a25a9$export$984c3bc21b1a54fc; }, function (v) { return $9dd7ddaf192a25a9$export$984c3bc21b1a54fc = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "left", function () { return $9dd7ddaf192a25a9$export$eabcd2c8791e7bf4; }, function (v) { return $9dd7ddaf192a25a9$export$eabcd2c8791e7bf4 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "tall", function () { return $9dd7ddaf192a25a9$export$d06da4f97bb01f71; }, function (v) { return $9dd7ddaf192a25a9$export$d06da4f97bb01f71 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "medium", function () { return $9dd7ddaf192a25a9$export$649ecc744817b5c7; }, function (v) { return $9dd7ddaf192a25a9$export$649ecc744817b5c7 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "article", function () { return $9dd7ddaf192a25a9$export$bba2aacf8566461b; }, function (v) { return $9dd7ddaf192a25a9$export$bba2aacf8566461b = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "title", function () { return $9dd7ddaf192a25a9$export$fb184b623420d9be; }, function (v) { return $9dd7ddaf192a25a9$export$fb184b623420d9be = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "subtitle", function () { return $9dd7ddaf192a25a9$export$c96745152eb2740f; }, function (v) { return $9dd7ddaf192a25a9$export$c96745152eb2740f = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "more", function () { return $9dd7ddaf192a25a9$export$a627d162e8aad100; }, function (v) { return $9dd7ddaf192a25a9$export$a627d162e8aad100 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "arrow", function () { return $9dd7ddaf192a25a9$export$f2120bbfa5450bd2; }, function (v) { return $9dd7ddaf192a25a9$export$f2120bbfa5450bd2 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "right", function () { return $9dd7ddaf192a25a9$export$79ffe56a765070d2; }, function (v) { return $9dd7ddaf192a25a9$export$79ffe56a765070d2 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "visual", function () { return $9dd7ddaf192a25a9$export$496f218b657bbde0; }, function (v) { return $9dd7ddaf192a25a9$export$496f218b657bbde0 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "image", function () { return $9dd7ddaf192a25a9$export$5c452ff88e35e47d; }, function (v) { return $9dd7ddaf192a25a9$export$5c452ff88e35e47d = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "illus-mails-advanced", function () { return $9dd7ddaf192a25a9$export$5613b0a28e68c9f8; }, function (v) { return $9dd7ddaf192a25a9$export$5613b0a28e68c9f8 = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "illus-seo", function () { return $9dd7ddaf192a25a9$export$74a1f66030468d3b; }, function (v) { return $9dd7ddaf192a25a9$export$74a1f66030468d3b = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "illus-perms", function () { return $9dd7ddaf192a25a9$export$b439ac323795b8de; }, function (v) { return $9dd7ddaf192a25a9$export$b439ac323795b8de = v; });
$parcel$export($9dd7ddaf192a25a9$exports, "illus-funnel", function () { return $9dd7ddaf192a25a9$export$7c04b2d1cdbc98a7; }, function (v) { return $9dd7ddaf192a25a9$export$7c04b2d1cdbc98a7 = v; });
var $9dd7ddaf192a25a9$export$984c3bc21b1a54fc;
var $9dd7ddaf192a25a9$export$eabcd2c8791e7bf4;
var $9dd7ddaf192a25a9$export$d06da4f97bb01f71;
var $9dd7ddaf192a25a9$export$649ecc744817b5c7;
var $9dd7ddaf192a25a9$export$bba2aacf8566461b;
var $9dd7ddaf192a25a9$export$fb184b623420d9be;
var $9dd7ddaf192a25a9$export$c96745152eb2740f;
var $9dd7ddaf192a25a9$export$a627d162e8aad100;
var $9dd7ddaf192a25a9$export$f2120bbfa5450bd2;
var $9dd7ddaf192a25a9$export$79ffe56a765070d2;
var $9dd7ddaf192a25a9$export$496f218b657bbde0;
var $9dd7ddaf192a25a9$export$5c452ff88e35e47d;
var $9dd7ddaf192a25a9$export$5613b0a28e68c9f8;
var $9dd7ddaf192a25a9$export$74a1f66030468d3b;
var $9dd7ddaf192a25a9$export$b439ac323795b8de;
var $9dd7ddaf192a25a9$export$7c04b2d1cdbc98a7;
$9dd7ddaf192a25a9$export$984c3bc21b1a54fc = "_0Z1Fo";
$9dd7ddaf192a25a9$export$eabcd2c8791e7bf4 = "G-U-e";
$9dd7ddaf192a25a9$export$d06da4f97bb01f71 = "s64OX";
$9dd7ddaf192a25a9$export$649ecc744817b5c7 = "Fgvjw";
$9dd7ddaf192a25a9$export$bba2aacf8566461b = "_8OJXc";
$9dd7ddaf192a25a9$export$fb184b623420d9be = "JdsXP";
$9dd7ddaf192a25a9$export$c96745152eb2740f = "WNZNH";
$9dd7ddaf192a25a9$export$a627d162e8aad100 = "CcbG-";
$9dd7ddaf192a25a9$export$f2120bbfa5450bd2 = "QvmBK";
$9dd7ddaf192a25a9$export$79ffe56a765070d2 = "vZHsd";
$9dd7ddaf192a25a9$export$496f218b657bbde0 = "_9LfWb";
$9dd7ddaf192a25a9$export$5c452ff88e35e47d = "-rK3F";
$9dd7ddaf192a25a9$export$5613b0a28e68c9f8 = "lIcF7";
$9dd7ddaf192a25a9$export$74a1f66030468d3b = "wWDjF";
$9dd7ddaf192a25a9$export$b439ac323795b8de = "D0OHZ";
$9dd7ddaf192a25a9$export$7c04b2d1cdbc98a7 = "dALtA";



var $5FliW = parcelRequire("5FliW");
class $1d8c0622f75f2faf$export$e4b6d83931e2a971 extends (0, $fsnB5.Component) {
    constructor(p){
        super();
        this.illus = p.illus;
        this.size = p.size;
        this.url = p.url;
        if (p.direction == true) this.direction = ' style="flex-direction: row-reverse;"';
        else this.direction = "";
        //language=HTML
        this.template = `
            <div class="${$9dd7ddaf192a25a9$exports.componentWebsitePresentationLight}" ${this.direction}>
                <div class="${$9dd7ddaf192a25a9$exports.left} ${$9dd7ddaf192a25a9$exports[this.size]}">
                    <div class="${$9dd7ddaf192a25a9$exports.article}">
                        <h3 class="${$9dd7ddaf192a25a9$exports.title}">
                            ${p.title}
                        </h3>
                        <p class="${$9dd7ddaf192a25a9$exports.subtitle}">
                            ${p.subtitle}
                        </p>
                        ${p.url ? `                   
                          <a class="${$9dd7ddaf192a25a9$exports.more}" href="${p.url}">
                           ${(0, $5FliW.Resources).t("words.more")}
                            <i class="${$9dd7ddaf192a25a9$exports.arrow}"></i>
                        </a>` : ''}
                    </div>
                </div>
                <div class="${$9dd7ddaf192a25a9$exports.right} ${$9dd7ddaf192a25a9$exports[this.size]}">
                    <div class="${$9dd7ddaf192a25a9$exports.visual}">
                        <div class="${$9dd7ddaf192a25a9$exports.image} ${$9dd7ddaf192a25a9$exports[this.illus]}"></div>
                    </div>
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $c371a2a9c74633d8$exports = {};

$parcel$export($c371a2a9c74633d8$exports, "componentWebsitePresentationVertical", function () { return $c371a2a9c74633d8$export$eb8beb82df6ed103; }, function (v) { return $c371a2a9c74633d8$export$eb8beb82df6ed103 = v; });
$parcel$export($c371a2a9c74633d8$exports, "head", function () { return $c371a2a9c74633d8$export$5fd5031fecdacec3; }, function (v) { return $c371a2a9c74633d8$export$5fd5031fecdacec3 = v; });
$parcel$export($c371a2a9c74633d8$exports, "title", function () { return $c371a2a9c74633d8$export$fb184b623420d9be; }, function (v) { return $c371a2a9c74633d8$export$fb184b623420d9be = v; });
$parcel$export($c371a2a9c74633d8$exports, "blue", function () { return $c371a2a9c74633d8$export$2aa0182783e7e9de; }, function (v) { return $c371a2a9c74633d8$export$2aa0182783e7e9de = v; });
$parcel$export($c371a2a9c74633d8$exports, "red", function () { return $c371a2a9c74633d8$export$a90204d1394caf30; }, function (v) { return $c371a2a9c74633d8$export$a90204d1394caf30 = v; });
$parcel$export($c371a2a9c74633d8$exports, "black", function () { return $c371a2a9c74633d8$export$c073df10e766abfa; }, function (v) { return $c371a2a9c74633d8$export$c073df10e766abfa = v; });
$parcel$export($c371a2a9c74633d8$exports, "multi", function () { return $c371a2a9c74633d8$export$13e2537ceeaf8a3a; }, function (v) { return $c371a2a9c74633d8$export$13e2537ceeaf8a3a = v; });
$parcel$export($c371a2a9c74633d8$exports, "purple", function () { return $c371a2a9c74633d8$export$e13cce2a2d16a9d4; }, function (v) { return $c371a2a9c74633d8$export$e13cce2a2d16a9d4 = v; });
$parcel$export($c371a2a9c74633d8$exports, "green", function () { return $c371a2a9c74633d8$export$955a2ebd2fb142ae; }, function (v) { return $c371a2a9c74633d8$export$955a2ebd2fb142ae = v; });
$parcel$export($c371a2a9c74633d8$exports, "white", function () { return $c371a2a9c74633d8$export$8fa4e5556fd77a60; }, function (v) { return $c371a2a9c74633d8$export$8fa4e5556fd77a60 = v; });
$parcel$export($c371a2a9c74633d8$exports, "description", function () { return $c371a2a9c74633d8$export$6d59db4903f20f7d; }, function (v) { return $c371a2a9c74633d8$export$6d59db4903f20f7d = v; });
$parcel$export($c371a2a9c74633d8$exports, "imageContainer", function () { return $c371a2a9c74633d8$export$63e82393dc8977bf; }, function (v) { return $c371a2a9c74633d8$export$63e82393dc8977bf = v; });
$parcel$export($c371a2a9c74633d8$exports, "image", function () { return $c371a2a9c74633d8$export$5c452ff88e35e47d; }, function (v) { return $c371a2a9c74633d8$export$5c452ff88e35e47d = v; });
$parcel$export($c371a2a9c74633d8$exports, "tall", function () { return $c371a2a9c74633d8$export$d06da4f97bb01f71; }, function (v) { return $c371a2a9c74633d8$export$d06da4f97bb01f71 = v; });
$parcel$export($c371a2a9c74633d8$exports, "medium", function () { return $c371a2a9c74633d8$export$649ecc744817b5c7; }, function (v) { return $c371a2a9c74633d8$export$649ecc744817b5c7 = v; });
$parcel$export($c371a2a9c74633d8$exports, "intermediate", function () { return $c371a2a9c74633d8$export$28824b7d7b72532c; }, function (v) { return $c371a2a9c74633d8$export$28824b7d7b72532c = v; });
$parcel$export($c371a2a9c74633d8$exports, "shadow", function () { return $c371a2a9c74633d8$export$b8972b998723d602; }, function (v) { return $c371a2a9c74633d8$export$b8972b998723d602 = v; });
$parcel$export($c371a2a9c74633d8$exports, "border", function () { return $c371a2a9c74633d8$export$1edee58a52776cd9; }, function (v) { return $c371a2a9c74633d8$export$1edee58a52776cd9 = v; });
var $c371a2a9c74633d8$export$eb8beb82df6ed103;
var $c371a2a9c74633d8$export$5fd5031fecdacec3;
var $c371a2a9c74633d8$export$fb184b623420d9be;
var $c371a2a9c74633d8$export$2aa0182783e7e9de;
var $c371a2a9c74633d8$export$a90204d1394caf30;
var $c371a2a9c74633d8$export$c073df10e766abfa;
var $c371a2a9c74633d8$export$13e2537ceeaf8a3a;
var $c371a2a9c74633d8$export$e13cce2a2d16a9d4;
var $c371a2a9c74633d8$export$955a2ebd2fb142ae;
var $c371a2a9c74633d8$export$8fa4e5556fd77a60;
var $c371a2a9c74633d8$export$6d59db4903f20f7d;
var $c371a2a9c74633d8$export$63e82393dc8977bf;
var $c371a2a9c74633d8$export$5c452ff88e35e47d;
var $c371a2a9c74633d8$export$d06da4f97bb01f71;
var $c371a2a9c74633d8$export$649ecc744817b5c7;
var $c371a2a9c74633d8$export$28824b7d7b72532c;
var $c371a2a9c74633d8$export$b8972b998723d602;
var $c371a2a9c74633d8$export$1edee58a52776cd9;
$c371a2a9c74633d8$export$eb8beb82df6ed103 = "ygavk";
$c371a2a9c74633d8$export$5fd5031fecdacec3 = "r4yEW";
$c371a2a9c74633d8$export$fb184b623420d9be = "wUGOp";
$c371a2a9c74633d8$export$2aa0182783e7e9de = "sGXHA";
$c371a2a9c74633d8$export$a90204d1394caf30 = "B3jpP";
$c371a2a9c74633d8$export$c073df10e766abfa = "G-DXY";
$c371a2a9c74633d8$export$13e2537ceeaf8a3a = "_60-BV";
$c371a2a9c74633d8$export$e13cce2a2d16a9d4 = "gxllE";
$c371a2a9c74633d8$export$955a2ebd2fb142ae = "zsO-A";
$c371a2a9c74633d8$export$8fa4e5556fd77a60 = "YjMYk";
$c371a2a9c74633d8$export$6d59db4903f20f7d = "UIyoX";
$c371a2a9c74633d8$export$63e82393dc8977bf = "t9VEZ";
$c371a2a9c74633d8$export$5c452ff88e35e47d = "VdJMY";
$c371a2a9c74633d8$export$d06da4f97bb01f71 = "b-gKn";
$c371a2a9c74633d8$export$649ecc744817b5c7 = "_3uO1H";
$c371a2a9c74633d8$export$28824b7d7b72532c = "_37I23";
$c371a2a9c74633d8$export$b8972b998723d602 = "a-Cfj";
$c371a2a9c74633d8$export$1edee58a52776cd9 = "yOgS2";



var $5FliW = parcelRequire("5FliW");

class $eccf921ec7e11df0$export$366de2f3346a7a26 extends (0, $fsnB5.Component) {
    commit() {
        if (this.image || this.imageComponent) {
            this.imageContainer = this.append(`<div class="${$c371a2a9c74633d8$exports.imageContainer}"></div>`);
            if (this.imageComponent) this.imageContainer.render(this.imageComponent);
            if (this.image) {
                if (this.image.endsWith(".mp4")) this.imageContainer.render(new (0, $b728abad6b753e49$export$860f11a0f47b60ac)(this.image));
                else //language=HTM
                this.imageContainer.append(`
                        <img class="${$c371a2a9c74633d8$exports.image} ${$c371a2a9c74633d8$exports[this.size]} ${$c371a2a9c74633d8$exports[this.shadow]} ${$c371a2a9c74633d8$exports[this.border]}"
                             src="${this.image}"
                             alt="${(0, $5FliW.Resources).t("words.sedestralInterfacePageRepresenting")} : ${this.title}."/>`);
            }
        }
        super.commit();
    }
    constructor(p){
        super();
        this.imageComponent = p.imageComponent;
        this.title = p.title;
        this.image = p.image;
        this.color = p.color;
        this.size = p.size;
        this.shadow = p.shadow;
        this.border = p.border;
        //language=HTML
        this.template = `
            <div class="${$c371a2a9c74633d8$exports.componentWebsitePresentationVertical}">
                <div class="${$c371a2a9c74633d8$exports.head}">
                    <h2 class="${$c371a2a9c74633d8$exports.title} ${$c371a2a9c74633d8$exports[this.color]}">
                        ${p.title}
                    </h2>
                    ${p.description ? `<p class="${$c371a2a9c74633d8$exports.description}">${p.description}</p>` : ``}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $059cc2c30bc71e09$export$b81e1430fb6fcb09;
var $059cc2c30bc71e09$export$6d59db4903f20f7d;
var $059cc2c30bc71e09$export$53b3c91859018cd4;
var $059cc2c30bc71e09$export$4e0c71f277ca26b3;
var $059cc2c30bc71e09$export$1ca1ec8b29a4ce27;
var $059cc2c30bc71e09$export$83aa05add7fe0e17;
var $059cc2c30bc71e09$export$6f093cfa640b7166;
$059cc2c30bc71e09$export$b81e1430fb6fcb09 = "zLXxD";
$059cc2c30bc71e09$export$6d59db4903f20f7d = "pY2EZ";
$059cc2c30bc71e09$export$53b3c91859018cd4 = "iEBgs";
$059cc2c30bc71e09$export$4e0c71f277ca26b3 = "YigGP";
$059cc2c30bc71e09$export$1ca1ec8b29a4ce27 = "h9h5Y";
$059cc2c30bc71e09$export$83aa05add7fe0e17 = "oPrII";
$059cc2c30bc71e09$export$6f093cfa640b7166 = "ES7VN";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $1ca27900064f3d61$export$68bb1055da0209bf extends (0, $fsnB5.Component) {
    commit() {
        this.columnsContainer = this.el($059cc2c30bc71e09$export$53b3c91859018cd4);
        this.columns.forEach((column)=>{
            //language=HTML
            if (column.state == 'normal') this.columnsContainer.append(`
                    <div class="${$059cc2c30bc71e09$export$4e0c71f277ca26b3}">
                        <div class="${$059cc2c30bc71e09$export$6f093cfa640b7166}">
                            ${column.name}
                        </div>
                        <div class="${$059cc2c30bc71e09$export$1ca1ec8b29a4ce27}">
                            <img src="${(0, $7AbeR.Network).vendor}images/${column.picture}" alt="${(0, $5FliW.Resources).t("words.sedestralInterfacePageRepresenting")} ${column.name}." height="" width="272.66" height="347.53" />
                        </div>
                    </div>
                `);
            else this.columnsContainer.append(`
                    <div class="${$059cc2c30bc71e09$export$4e0c71f277ca26b3}">
                        <div class="${$059cc2c30bc71e09$export$6f093cfa640b7166}">
                            ${column.name}
                        </div>
                        <div class="${$059cc2c30bc71e09$export$1ca1ec8b29a4ce27}">
                            <img class="${$059cc2c30bc71e09$export$83aa05add7fe0e17}" src="${(0, $7AbeR.Network).vendor}images/${column.picture}" alt="${(0, $5FliW.Resources).t("words.sedestralInterfacePageRepresenting")} ${column.name}." width="122.7" height="122.7"/>
                        </div>
                    </div>
                `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.columns = p.columns;
        //language=HTML
        this.template = `
            <div class="${$059cc2c30bc71e09$export$b81e1430fb6fcb09}">
                <h2 class="${$059cc2c30bc71e09$export$6d59db4903f20f7d}">
                    ${p.title}
                </h2>
                <div class="${$059cc2c30bc71e09$export$53b3c91859018cd4}"></div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $3041af3083a5d0ac$export$4e81deb572f16c75;
var $3041af3083a5d0ac$export$6d59db4903f20f7d;
var $3041af3083a5d0ac$export$1ca1ec8b29a4ce27;
var $3041af3083a5d0ac$export$53b3c91859018cd4;
var $3041af3083a5d0ac$export$4e0c71f277ca26b3;
var $3041af3083a5d0ac$export$5c452ff88e35e47d;
$3041af3083a5d0ac$export$4e81deb572f16c75 = "k42bb";
$3041af3083a5d0ac$export$6d59db4903f20f7d = "uk1aS";
$3041af3083a5d0ac$export$1ca1ec8b29a4ce27 = "eD55P";
$3041af3083a5d0ac$export$53b3c91859018cd4 = "Zi-vH";
$3041af3083a5d0ac$export$4e0c71f277ca26b3 = "f9D4V";
$3041af3083a5d0ac$export$5c452ff88e35e47d = "fGNP5";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");


var $kfkzw = parcelRequire("kfkzw");
class $6790acc1b8f93158$export$7e355f9f7e662f9b extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$3041af3083a5d0ac$export$4e81deb572f16c75}">
                <h2 class="${$3041af3083a5d0ac$export$6d59db4903f20f7d}">
                    ${(0, $5FliW.Resources).t("words.customizeInbox")}
                </h2>
                <div class="${$3041af3083a5d0ac$export$1ca1ec8b29a4ce27}">
                    ${this.draw(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).STATISTICS))}
                </div>
                <div class="${$3041af3083a5d0ac$export$53b3c91859018cd4}">
                    <div class="${$3041af3083a5d0ac$export$4e0c71f277ca26b3}">
                        <img src="${(0, $7AbeR.Network).vendor}images/illus-number-conversation.webp"
                             alt="${(0, $5FliW.Resources).t("words.statisticsNumberConversations")}"
                             height="248.54"
                             width="354.66"
                        />
                    </div>
                    <div class="${$3041af3083a5d0ac$export$4e0c71f277ca26b3}">
                        <img src="${(0, $7AbeR.Network).vendor}images/illus-delay-answer.webp"
                             alt="${(0, $5FliW.Resources).t("words.statisticsResponseTime")}"
                             height="248.54"
                             width="354.66"
                        />
                    </div>
                    <div class="${$3041af3083a5d0ac$export$4e0c71f277ca26b3}">
                        <img src="${(0, $7AbeR.Network).vendor}images/illus-conversation-hours.webp"
                             alt="${(0, $5FliW.Resources).t("words.statisticsHours")}"
                             height="248.54"
                             width="354.66"
                        />
                    </div>
                </div>
                <div class="${$3041af3083a5d0ac$export$5c452ff88e35e47d}">
                    <img src="${(0, $7AbeR.Network).vendor}images/capture-collaboraters.webp"
                         alt="${(0, $5FliW.Resources).t("words.classificationEmployees")}"
                         height="582.19"
                         width="1035"
                    />
                </div>
            </div>
        `;
    }
}



var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");

var $fsnB5 = parcelRequire("fsnB5");
var $5d624c5b29050611$exports = {};

$parcel$export($5d624c5b29050611$exports, "componentWebsiteIssues", function () { return $5d624c5b29050611$export$cc4c34968a089886; }, function (v) { return $5d624c5b29050611$export$cc4c34968a089886 = v; });
$parcel$export($5d624c5b29050611$exports, "black", function () { return $5d624c5b29050611$export$c073df10e766abfa; }, function (v) { return $5d624c5b29050611$export$c073df10e766abfa = v; });
$parcel$export($5d624c5b29050611$exports, "issue", function () { return $5d624c5b29050611$export$69ad3503f98be476; }, function (v) { return $5d624c5b29050611$export$69ad3503f98be476 = v; });
$parcel$export($5d624c5b29050611$exports, "icon", function () { return $5d624c5b29050611$export$1ca1ec8b29a4ce27; }, function (v) { return $5d624c5b29050611$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($5d624c5b29050611$exports, "title", function () { return $5d624c5b29050611$export$fb184b623420d9be; }, function (v) { return $5d624c5b29050611$export$fb184b623420d9be = v; });
$parcel$export($5d624c5b29050611$exports, "issues", function () { return $5d624c5b29050611$export$564c0735c817a25e; }, function (v) { return $5d624c5b29050611$export$564c0735c817a25e = v; });
$parcel$export($5d624c5b29050611$exports, "top", function () { return $5d624c5b29050611$export$1e95b668f3b82d; }, function (v) { return $5d624c5b29050611$export$1e95b668f3b82d = v; });
$parcel$export($5d624c5b29050611$exports, "more", function () { return $5d624c5b29050611$export$a627d162e8aad100; }, function (v) { return $5d624c5b29050611$export$a627d162e8aad100 = v; });
$parcel$export($5d624c5b29050611$exports, "name", function () { return $5d624c5b29050611$export$a8ff84c12d48cfa6; }, function (v) { return $5d624c5b29050611$export$a8ff84c12d48cfa6 = v; });
$parcel$export($5d624c5b29050611$exports, "open", function () { return $5d624c5b29050611$export$3ce6949f20cea765; }, function (v) { return $5d624c5b29050611$export$3ce6949f20cea765 = v; });
$parcel$export($5d624c5b29050611$exports, "rotationLeft", function () { return $5d624c5b29050611$export$831e6269d94587a; }, function (v) { return $5d624c5b29050611$export$831e6269d94587a = v; });
$parcel$export($5d624c5b29050611$exports, "close", function () { return $5d624c5b29050611$export$8360e631d277ea4d; }, function (v) { return $5d624c5b29050611$export$8360e631d277ea4d = v; });
$parcel$export($5d624c5b29050611$exports, "rotationRight", function () { return $5d624c5b29050611$export$f73ada0996849266; }, function (v) { return $5d624c5b29050611$export$f73ada0996849266 = v; });
$parcel$export($5d624c5b29050611$exports, "bottom", function () { return $5d624c5b29050611$export$40e543e69a8b3fbb; }, function (v) { return $5d624c5b29050611$export$40e543e69a8b3fbb = v; });
$parcel$export($5d624c5b29050611$exports, "description", function () { return $5d624c5b29050611$export$6d59db4903f20f7d; }, function (v) { return $5d624c5b29050611$export$6d59db4903f20f7d = v; });
$parcel$export($5d624c5b29050611$exports, "hidden", function () { return $5d624c5b29050611$export$73920f18ca706874; }, function (v) { return $5d624c5b29050611$export$73920f18ca706874 = v; });
var $5d624c5b29050611$export$cc4c34968a089886;
var $5d624c5b29050611$export$c073df10e766abfa;
var $5d624c5b29050611$export$69ad3503f98be476;
var $5d624c5b29050611$export$1ca1ec8b29a4ce27;
var $5d624c5b29050611$export$fb184b623420d9be;
var $5d624c5b29050611$export$564c0735c817a25e;
var $5d624c5b29050611$export$1e95b668f3b82d;
var $5d624c5b29050611$export$a627d162e8aad100;
var $5d624c5b29050611$export$a8ff84c12d48cfa6;
var $5d624c5b29050611$export$3ce6949f20cea765;
var $5d624c5b29050611$export$831e6269d94587a;
var $5d624c5b29050611$export$8360e631d277ea4d;
var $5d624c5b29050611$export$f73ada0996849266;
var $5d624c5b29050611$export$40e543e69a8b3fbb;
var $5d624c5b29050611$export$6d59db4903f20f7d;
var $5d624c5b29050611$export$73920f18ca706874;
$5d624c5b29050611$export$cc4c34968a089886 = "WXVPM";
$5d624c5b29050611$export$c073df10e766abfa = "_75msI";
$5d624c5b29050611$export$69ad3503f98be476 = "b4WII";
$5d624c5b29050611$export$1ca1ec8b29a4ce27 = "_-4sl-";
$5d624c5b29050611$export$fb184b623420d9be = "_9pqef";
$5d624c5b29050611$export$564c0735c817a25e = "_9XQAG";
$5d624c5b29050611$export$1e95b668f3b82d = "uxuJv";
$5d624c5b29050611$export$a627d162e8aad100 = "aouCN";
$5d624c5b29050611$export$a8ff84c12d48cfa6 = "lhJ--";
$5d624c5b29050611$export$3ce6949f20cea765 = "bipT9";
$5d624c5b29050611$export$831e6269d94587a = "NqxeD";
$5d624c5b29050611$export$8360e631d277ea4d = "UzkRX";
$5d624c5b29050611$export$f73ada0996849266 = "Myd3e";
$5d624c5b29050611$export$40e543e69a8b3fbb = "CDFtg";
$5d624c5b29050611$export$6d59db4903f20f7d = "-wtOZ";
$5d624c5b29050611$export$73920f18ca706874 = "n-yOA";



var $5FliW = parcelRequire("5FliW");
class $a6e2cc43accecdce$export$f6f77077605a705e extends (0, $fsnB5.Component) {
    commit() {
        if (this.questions) {
            this.questionsContainer = this.el($5d624c5b29050611$exports.issues);
            this.questions.forEach((questions)=>{
                //language=HTML
                let questionComponent = this.questionsContainer.append(`
                    <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" class="${$5d624c5b29050611$exports.issue}">
                        <div class="${$5d624c5b29050611$exports.top}">
                            <h3 itemprop="name" class="${$5d624c5b29050611$exports.name}">
                                ${questions.question}
                            </h3>
                            <div class="${$5d624c5b29050611$exports.more}">
                                <div class="${$5d624c5b29050611$exports.icon} ${$5d624c5b29050611$exports.close}"></div>
                            </div>
                        </div>
                        <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer"
                             class="${$5d624c5b29050611$exports.bottom} ${$5d624c5b29050611$exports.hidden}">
                            <p itemprop="text" class="${$5d624c5b29050611$exports.description}">
                                ${questions.response}
                            </p>
                        </div>
                    </div>
                `);
                questionComponent.el($5d624c5b29050611$exports.top).onClick(()=>{
                    this.hideResponse(questionComponent.el($5d624c5b29050611$exports.bottom), questionComponent.el($5d624c5b29050611$exports.icon));
                });
            });
        }
        super.commit();
    }
    hideResponse(questions, icon) {
        if (questions.hasClass($5d624c5b29050611$exports.hidden)) {
            questions.removeClass($5d624c5b29050611$exports.hidden);
            icon.removeClass($5d624c5b29050611$exports.close);
            icon.addClass($5d624c5b29050611$exports.open);
        } else {
            questions.addClass($5d624c5b29050611$exports.hidden);
            icon.removeClass($5d624c5b29050611$exports.open);
            icon.addClass($5d624c5b29050611$exports.close);
        }
    }
    constructor(p){
        super();
        this.questions = p.questions;
        if (this.questions) //language=HTML
        this.template = `
                <div itemscope itemtype="https://schema.org/FAQPage"
                     class="${$5d624c5b29050611$exports.componentWebsiteIssues} ${p.theme ? $5d624c5b29050611$exports[p.theme] : ``}">
                    <h2 itemprop="name" class="${$5d624c5b29050611$exports.title}">
                        ${(0, $5FliW.Resources).t("words.faq")}
                    </h2>
                    <div class="${$5d624c5b29050611$exports.issues}">

                    </div>
                </div>
            `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $fb72d4e02f827c9c$export$cc5daa14ab636235 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$0aac9ecd4494bcf5$export$5016101a142bf96a}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.optimize"),
            text: (0, $5FliW.Resources).t("words.completeSolution"),
            productType: (0, $kfkzw.ProductType).INBOX,
            url: `${(0, $7AbeR.Network).vendor}images/capture-inbox.webp`
        }))}
                    </div>
                    <div class="${$0aac9ecd4494bcf5$export$3bf720ece7bc7b2e}"></div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1d8c0622f75f2faf$export$e4b6d83931e2a971)({
            title: (0, $5FliW.Resources).t("words.sendAndReceive"),
            subtitle: (0, $5FliW.Resources).t("words.createMails"),
            illus: "illus-mails-advanced",
            size: "medium",
            url: `${"https://sedestral.com"}/mail`
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.liveChat"),
            description: (0, $5FliW.Resources).t("words.customizeAndInstall"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-livechat-website.webp",
            color: "blue",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.replyTo"),
            description: (0, $5FliW.Resources).t("words.connectNetworks"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-social.svg",
            color: "red",
            size: "medium"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.summarize"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-funnel.svg",
            color: "black",
            size: "medium"
        }))}
                    </div>
                    <div class="${$0aac9ecd4494bcf5$export$1f6feda8aa226b71}">
                        <div class="${$0aac9ecd4494bcf5$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $1d8c0622f75f2faf$export$e4b6d83931e2a971)({
            title: (0, $5FliW.Resources).t("words.defined"),
            subtitle: (0, $5FliW.Resources).t("words.limited"),
            illus: "illus-perms",
            size: "tall"
        }))}
                        </div>
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.workTeam"),
            description: (0, $5FliW.Resources).t("words.invitedCollaborator"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-content.webp",
            color: "blue",
            size: "tall"
        }))}
                        </div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1ca27900064f3d61$export$68bb1055da0209bf)({
            title: (0, $5FliW.Resources).t("words.personalizeInbox"),
            columns: [
                {
                    name: (0, $5FliW.Resources).t("words.createdInbox"),
                    picture: "illus-inbox.webp",
                    state: "normal"
                },
                {
                    name: (0, $5FliW.Resources).t("words.organizeCategroies"),
                    picture: "illus-categories.webp",
                    state: "normal"
                },
                {
                    name: (0, $5FliW.Resources).t("words.filtersTalks"),
                    picture: "illus-conversation.webp",
                    state: "normal"
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $6790acc1b8f93158$export$7e355f9f7e662f9b)())}
                    </div>
                        <!--<div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        $ {this.draw(new WebsiteMobileComponent())}
                    </div>-->
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.inbox")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $3500acc187b7ca85$export$fdf70f43a3a81415 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $fb72d4e02f827c9c$export$cc5daa14ab636235)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("inbox");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $f2e52ae95c361dde$export$e434ce7de9258df4;
var $f2e52ae95c361dde$export$fb184b623420d9be;
var $f2e52ae95c361dde$export$4caf129a4f120781;
$f2e52ae95c361dde$export$e434ce7de9258df4 = "FvVUi";
$f2e52ae95c361dde$export$fb184b623420d9be = "PlotT";
$f2e52ae95c361dde$export$4caf129a4f120781 = "t2Z1k";




var $5FliW = parcelRequire("5FliW");


var $kfkzw = parcelRequire("kfkzw");
class $de3d10efbbd2cb80$export$d1e51e80a9e142de extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$f2e52ae95c361dde$export$e434ce7de9258df4}">
                <div style="gap:20px;" class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <h2 class="${$f2e52ae95c361dde$export$fb184b623420d9be}">
                        ${(0, $5FliW.Resources).t("words.sedestralRates")}
                    </h2>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            <div class="${$f2e52ae95c361dde$export$4caf129a4f120781}">
                                ${this.draw(new (0, $6dd9c90eeb33d2ee$export$b39970eebb991951)((0, $kfkzw.ProductType).BLOG, undefined, true))}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="gap:20px;" class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            questions: (0, $5FliW.Resources).t("words.questions.pricing")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $99f23431dbfc73c3$export$36d652602e27a852 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $de3d10efbbd2cb80$export$d1e51e80a9e142de)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("pricing");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $5a25dbfd33bc5a35$export$1d90f4fd07c087ab;
var $5a25dbfd33bc5a35$export$fb184b623420d9be;
var $5a25dbfd33bc5a35$export$53b3c91859018cd4;
var $5a25dbfd33bc5a35$export$4e0c71f277ca26b3;
var $5a25dbfd33bc5a35$export$41ee12f6f6f05843;
var $5a25dbfd33bc5a35$export$1ca1ec8b29a4ce27;
var $5a25dbfd33bc5a35$export$be246276456a52e7;
var $5a25dbfd33bc5a35$export$b714fa498b091246;
var $5a25dbfd33bc5a35$export$1f6feda8aa226b71;
var $5a25dbfd33bc5a35$export$30780d0b6b610af8;
var $5a25dbfd33bc5a35$export$a8ff84c12d48cfa6;
var $5a25dbfd33bc5a35$export$6d59db4903f20f7d;
var $5a25dbfd33bc5a35$export$bb5ee47d9ea2348e;
var $5a25dbfd33bc5a35$export$98e628dec113755e;
var $5a25dbfd33bc5a35$export$2f151dcf7eae7881;
$5a25dbfd33bc5a35$export$1d90f4fd07c087ab = "EJBeL";
$5a25dbfd33bc5a35$export$fb184b623420d9be = "MI3-z";
$5a25dbfd33bc5a35$export$53b3c91859018cd4 = "ayTYF";
$5a25dbfd33bc5a35$export$4e0c71f277ca26b3 = "J2-sU";
$5a25dbfd33bc5a35$export$41ee12f6f6f05843 = "Hw6UG";
$5a25dbfd33bc5a35$export$1ca1ec8b29a4ce27 = "wxJra";
$5a25dbfd33bc5a35$export$be246276456a52e7 = "kLb-5";
$5a25dbfd33bc5a35$export$b714fa498b091246 = "_63sdn";
$5a25dbfd33bc5a35$export$1f6feda8aa226b71 = "_7TnQ3";
$5a25dbfd33bc5a35$export$30780d0b6b610af8 = "-WFi7";
$5a25dbfd33bc5a35$export$a8ff84c12d48cfa6 = "_3y1At";
$5a25dbfd33bc5a35$export$6d59db4903f20f7d = "_9LxgU";
$5a25dbfd33bc5a35$export$bb5ee47d9ea2348e = "HmgLg";
$5a25dbfd33bc5a35$export$98e628dec113755e = "nv92A";
$5a25dbfd33bc5a35$export$2f151dcf7eae7881 = "_4EZm0";





var $fsnB5 = parcelRequire("fsnB5");
var $e40e08bbdaff6ff6$exports = {};

$parcel$export($e40e08bbdaff6ff6$exports, "componentWebsiteColumnsDouble", function () { return $e40e08bbdaff6ff6$export$562aeeb04ebda242; }, function (v) { return $e40e08bbdaff6ff6$export$562aeeb04ebda242 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "head", function () { return $e40e08bbdaff6ff6$export$5fd5031fecdacec3; }, function (v) { return $e40e08bbdaff6ff6$export$5fd5031fecdacec3 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "title", function () { return $e40e08bbdaff6ff6$export$fb184b623420d9be; }, function (v) { return $e40e08bbdaff6ff6$export$fb184b623420d9be = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "black", function () { return $e40e08bbdaff6ff6$export$c073df10e766abfa; }, function (v) { return $e40e08bbdaff6ff6$export$c073df10e766abfa = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "red", function () { return $e40e08bbdaff6ff6$export$a90204d1394caf30; }, function (v) { return $e40e08bbdaff6ff6$export$a90204d1394caf30 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "multi", function () { return $e40e08bbdaff6ff6$export$13e2537ceeaf8a3a; }, function (v) { return $e40e08bbdaff6ff6$export$13e2537ceeaf8a3a = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "columns", function () { return $e40e08bbdaff6ff6$export$53b3c91859018cd4; }, function (v) { return $e40e08bbdaff6ff6$export$53b3c91859018cd4 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "column", function () { return $e40e08bbdaff6ff6$export$4e0c71f277ca26b3; }, function (v) { return $e40e08bbdaff6ff6$export$4e0c71f277ca26b3 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "icon", function () { return $e40e08bbdaff6ff6$export$1ca1ec8b29a4ce27; }, function (v) { return $e40e08bbdaff6ff6$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "seo", function () { return $e40e08bbdaff6ff6$export$7dc4b9367473a505; }, function (v) { return $e40e08bbdaff6ff6$export$7dc4b9367473a505 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "handshake", function () { return $e40e08bbdaff6ff6$export$3b7178ef4b094956; }, function (v) { return $e40e08bbdaff6ff6$export$3b7178ef4b094956 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "customerService", function () { return $e40e08bbdaff6ff6$export$8a83870103bcf376; }, function (v) { return $e40e08bbdaff6ff6$export$8a83870103bcf376 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "transaction", function () { return $e40e08bbdaff6ff6$export$2d62d2646dd2fb3c; }, function (v) { return $e40e08bbdaff6ff6$export$2d62d2646dd2fb3c = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "error", function () { return $e40e08bbdaff6ff6$export$a3bc9b8ed74fc; }, function (v) { return $e40e08bbdaff6ff6$export$a3bc9b8ed74fc = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "mailSpam", function () { return $e40e08bbdaff6ff6$export$19f83829f98e3e86; }, function (v) { return $e40e08bbdaff6ff6$export$19f83829f98e3e86 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "letter", function () { return $e40e08bbdaff6ff6$export$30780d0b6b610af8; }, function (v) { return $e40e08bbdaff6ff6$export$30780d0b6b610af8 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "articleAi", function () { return $e40e08bbdaff6ff6$export$60c7b865d28898e9; }, function (v) { return $e40e08bbdaff6ff6$export$60c7b865d28898e9 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "name", function () { return $e40e08bbdaff6ff6$export$a8ff84c12d48cfa6; }, function (v) { return $e40e08bbdaff6ff6$export$a8ff84c12d48cfa6 = v; });
$parcel$export($e40e08bbdaff6ff6$exports, "text", function () { return $e40e08bbdaff6ff6$export$6f093cfa640b7166; }, function (v) { return $e40e08bbdaff6ff6$export$6f093cfa640b7166 = v; });
var $e40e08bbdaff6ff6$export$562aeeb04ebda242;
var $e40e08bbdaff6ff6$export$5fd5031fecdacec3;
var $e40e08bbdaff6ff6$export$fb184b623420d9be;
var $e40e08bbdaff6ff6$export$c073df10e766abfa;
var $e40e08bbdaff6ff6$export$a90204d1394caf30;
var $e40e08bbdaff6ff6$export$13e2537ceeaf8a3a;
var $e40e08bbdaff6ff6$export$53b3c91859018cd4;
var $e40e08bbdaff6ff6$export$4e0c71f277ca26b3;
var $e40e08bbdaff6ff6$export$1ca1ec8b29a4ce27;
var $e40e08bbdaff6ff6$export$7dc4b9367473a505;
var $e40e08bbdaff6ff6$export$3b7178ef4b094956;
var $e40e08bbdaff6ff6$export$8a83870103bcf376;
var $e40e08bbdaff6ff6$export$2d62d2646dd2fb3c;
var $e40e08bbdaff6ff6$export$a3bc9b8ed74fc;
var $e40e08bbdaff6ff6$export$19f83829f98e3e86;
var $e40e08bbdaff6ff6$export$30780d0b6b610af8;
var $e40e08bbdaff6ff6$export$60c7b865d28898e9;
var $e40e08bbdaff6ff6$export$a8ff84c12d48cfa6;
var $e40e08bbdaff6ff6$export$6f093cfa640b7166;
$e40e08bbdaff6ff6$export$562aeeb04ebda242 = "l5Zya";
$e40e08bbdaff6ff6$export$5fd5031fecdacec3 = "FMAOs";
$e40e08bbdaff6ff6$export$fb184b623420d9be = "HsUnm";
$e40e08bbdaff6ff6$export$c073df10e766abfa = "Vy0CW";
$e40e08bbdaff6ff6$export$a90204d1394caf30 = "lsnCj";
$e40e08bbdaff6ff6$export$13e2537ceeaf8a3a = "PZ0UG";
$e40e08bbdaff6ff6$export$53b3c91859018cd4 = "ett64";
$e40e08bbdaff6ff6$export$4e0c71f277ca26b3 = "fRL0f";
$e40e08bbdaff6ff6$export$1ca1ec8b29a4ce27 = "octwo";
$e40e08bbdaff6ff6$export$7dc4b9367473a505 = "FXwLh";
$e40e08bbdaff6ff6$export$3b7178ef4b094956 = "d1sAN";
$e40e08bbdaff6ff6$export$8a83870103bcf376 = "OQ5TK";
$e40e08bbdaff6ff6$export$2d62d2646dd2fb3c = "zVly8";
$e40e08bbdaff6ff6$export$a3bc9b8ed74fc = "_9LXQs";
$e40e08bbdaff6ff6$export$19f83829f98e3e86 = "Yz97v";
$e40e08bbdaff6ff6$export$30780d0b6b610af8 = "_2J2d9";
$e40e08bbdaff6ff6$export$60c7b865d28898e9 = "ZoKpH";
$e40e08bbdaff6ff6$export$a8ff84c12d48cfa6 = "lt4HJ";
$e40e08bbdaff6ff6$export$6f093cfa640b7166 = "zArqQ";


class $2202559933343005$export$d8eb6fbe0ee5dec2 extends (0, $fsnB5.Component) {
    commit() {
        this.columnsContainer = this.el($e40e08bbdaff6ff6$exports.columns);
        this.columns.forEach((column)=>{
            //language=HTML
            this.columnsContainer.append(`
                <div class="${$e40e08bbdaff6ff6$exports.column}">
                    <div class="${$e40e08bbdaff6ff6$exports.icon} ${$e40e08bbdaff6ff6$exports[column.icon]}"></div>
                    <h4 class="${$e40e08bbdaff6ff6$exports.name}">
                        ${column.name}
                    </h4>
                    <p class="${$e40e08bbdaff6ff6$exports.text}">
                        ${column.text}
                    </p>
                </div>
            `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.color = p.color;
        this.columns = p.columns;
        //language=HTML
        this.template = `
            <div class="${$e40e08bbdaff6ff6$exports.componentWebsiteColumnsDouble}">
                <div class="${$e40e08bbdaff6ff6$exports.head}">
                    <h3 class="${$e40e08bbdaff6ff6$exports.title} ${this.color ? $e40e08bbdaff6ff6$exports[this.color] : ``}">
                        ${p.title}
                    </h3>
                </div>
                <div class="${$e40e08bbdaff6ff6$exports.columns}"></div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");


var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $bfdcae3eca8e9f3e$export$f03a647dc37f632a extends (0, $fsnB5.Component) {
    commit() {
        this.contentContainer = this.el($5a25dbfd33bc5a35$export$53b3c91859018cd4);
        let lineUrl = `${(0, $7AbeR.Network).vendor}images/separator-wave.webp`;
        var number = 1;
        this.entries.forEach((value)=>{
            //language=HTML
            let entry = this.contentContainer.append(`
                <div class="${$5a25dbfd33bc5a35$export$4e0c71f277ca26b3}">
                    <div class="${$5a25dbfd33bc5a35$export$41ee12f6f6f05843}">
                        <div class="${$5a25dbfd33bc5a35$export$1ca1ec8b29a4ce27} ${value.icon}"></div>
                        <h4 class="${$5a25dbfd33bc5a35$export$a8ff84c12d48cfa6}">
                            ${value.name}
                        </h4>
                        <p class="${$5a25dbfd33bc5a35$export$6d59db4903f20f7d}">
                            ${value.description}
                        </p>
                    </div>
                    <img src="${lineUrl}" class="${$5a25dbfd33bc5a35$export$bb5ee47d9ea2348e}" alt="${(0, $5FliW.Resources).t("words.presentationLine")}"
                         onmousedown="return false" onmousemove="return false"/>
                    <div class="${$5a25dbfd33bc5a35$export$98e628dec113755e}">
                        <p class="${$5a25dbfd33bc5a35$export$2f151dcf7eae7881}">${number}</p>
                    </div>
                </div>
            `);
            number++;
        });
        super.commit();
    }
    constructor(p){
        super();
        this.entries = p.grid;
        //language=HTML
        this.template = `
            <div class="${$5a25dbfd33bc5a35$export$1d90f4fd07c087ab}">
                <h3 class="${$5a25dbfd33bc5a35$export$fb184b623420d9be}">
                    ${p.title}
                </h3>
                <div class="${$5a25dbfd33bc5a35$export$53b3c91859018cd4}">
                    
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $6566aac0692745b5$exports = {};

$parcel$export($6566aac0692745b5$exports, "componentWebsiteSliderLeft", function () { return $6566aac0692745b5$export$bfc36268175233c; }, function (v) { return $6566aac0692745b5$export$bfc36268175233c = v; });
$parcel$export($6566aac0692745b5$exports, "title", function () { return $6566aac0692745b5$export$fb184b623420d9be; }, function (v) { return $6566aac0692745b5$export$fb184b623420d9be = v; });
$parcel$export($6566aac0692745b5$exports, "slider", function () { return $6566aac0692745b5$export$b38bf4f33e9e4c25; }, function (v) { return $6566aac0692745b5$export$b38bf4f33e9e4c25 = v; });
$parcel$export($6566aac0692745b5$exports, "left", function () { return $6566aac0692745b5$export$eabcd2c8791e7bf4; }, function (v) { return $6566aac0692745b5$export$eabcd2c8791e7bf4 = v; });
$parcel$export($6566aac0692745b5$exports, "entry", function () { return $6566aac0692745b5$export$c407db72103fecfa; }, function (v) { return $6566aac0692745b5$export$c407db72103fecfa = v; });
$parcel$export($6566aac0692745b5$exports, "selected", function () { return $6566aac0692745b5$export$d90250155de6d7e7; }, function (v) { return $6566aac0692745b5$export$d90250155de6d7e7 = v; });
$parcel$export($6566aac0692745b5$exports, "titles", function () { return $6566aac0692745b5$export$1cbbc5990c2ee230; }, function (v) { return $6566aac0692745b5$export$1cbbc5990c2ee230 = v; });
$parcel$export($6566aac0692745b5$exports, "icon", function () { return $6566aac0692745b5$export$1ca1ec8b29a4ce27; }, function (v) { return $6566aac0692745b5$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($6566aac0692745b5$exports, "draft", function () { return $6566aac0692745b5$export$3776927205fb6aff; }, function (v) { return $6566aac0692745b5$export$3776927205fb6aff = v; });
$parcel$export($6566aac0692745b5$exports, "section", function () { return $6566aac0692745b5$export$fe2e36411d703b3d; }, function (v) { return $6566aac0692745b5$export$fe2e36411d703b3d = v; });
$parcel$export($6566aac0692745b5$exports, "paragraph", function () { return $6566aac0692745b5$export$9c206ddddb32a9b; }, function (v) { return $6566aac0692745b5$export$9c206ddddb32a9b = v; });
$parcel$export($6566aac0692745b5$exports, "trombone", function () { return $6566aac0692745b5$export$d1d7a8444e6e2c0e; }, function (v) { return $6566aac0692745b5$export$d1d7a8444e6e2c0e = v; });
$parcel$export($6566aac0692745b5$exports, "writePaper", function () { return $6566aac0692745b5$export$8f2886ebc4b1fa1a; }, function (v) { return $6566aac0692745b5$export$8f2886ebc4b1fa1a = v; });
$parcel$export($6566aac0692745b5$exports, "pensil", function () { return $6566aac0692745b5$export$b714fa498b091246; }, function (v) { return $6566aac0692745b5$export$b714fa498b091246 = v; });
$parcel$export($6566aac0692745b5$exports, "clock", function () { return $6566aac0692745b5$export$8c9e255416017e56; }, function (v) { return $6566aac0692745b5$export$8c9e255416017e56 = v; });
$parcel$export($6566aac0692745b5$exports, "home", function () { return $6566aac0692745b5$export$d12a05a2da93ee73; }, function (v) { return $6566aac0692745b5$export$d12a05a2da93ee73 = v; });
$parcel$export($6566aac0692745b5$exports, "mail", function () { return $6566aac0692745b5$export$b602b78110e4ab1e; }, function (v) { return $6566aac0692745b5$export$b602b78110e4ab1e = v; });
$parcel$export($6566aac0692745b5$exports, "mailAlias", function () { return $6566aac0692745b5$export$d1bf21c0c67a443b; }, function (v) { return $6566aac0692745b5$export$d1bf21c0c67a443b = v; });
$parcel$export($6566aac0692745b5$exports, "domains", function () { return $6566aac0692745b5$export$5d15c6f5dc2166f9; }, function (v) { return $6566aac0692745b5$export$5d15c6f5dc2166f9 = v; });
$parcel$export($6566aac0692745b5$exports, "description", function () { return $6566aac0692745b5$export$6d59db4903f20f7d; }, function (v) { return $6566aac0692745b5$export$6d59db4903f20f7d = v; });
$parcel$export($6566aac0692745b5$exports, "content", function () { return $6566aac0692745b5$export$a7db06668cad9adb; }, function (v) { return $6566aac0692745b5$export$a7db06668cad9adb = v; });
$parcel$export($6566aac0692745b5$exports, "picture", function () { return $6566aac0692745b5$export$1188214e9d38144e; }, function (v) { return $6566aac0692745b5$export$1188214e9d38144e = v; });
$parcel$export($6566aac0692745b5$exports, "hidden", function () { return $6566aac0692745b5$export$73920f18ca706874; }, function (v) { return $6566aac0692745b5$export$73920f18ca706874 = v; });
var $6566aac0692745b5$export$bfc36268175233c;
var $6566aac0692745b5$export$fb184b623420d9be;
var $6566aac0692745b5$export$b38bf4f33e9e4c25;
var $6566aac0692745b5$export$eabcd2c8791e7bf4;
var $6566aac0692745b5$export$c407db72103fecfa;
var $6566aac0692745b5$export$d90250155de6d7e7;
var $6566aac0692745b5$export$1cbbc5990c2ee230;
var $6566aac0692745b5$export$1ca1ec8b29a4ce27;
var $6566aac0692745b5$export$3776927205fb6aff;
var $6566aac0692745b5$export$fe2e36411d703b3d;
var $6566aac0692745b5$export$9c206ddddb32a9b;
var $6566aac0692745b5$export$d1d7a8444e6e2c0e;
var $6566aac0692745b5$export$8f2886ebc4b1fa1a;
var $6566aac0692745b5$export$b714fa498b091246;
var $6566aac0692745b5$export$8c9e255416017e56;
var $6566aac0692745b5$export$d12a05a2da93ee73;
var $6566aac0692745b5$export$b602b78110e4ab1e;
var $6566aac0692745b5$export$d1bf21c0c67a443b;
var $6566aac0692745b5$export$5d15c6f5dc2166f9;
var $6566aac0692745b5$export$6d59db4903f20f7d;
var $6566aac0692745b5$export$a7db06668cad9adb;
var $6566aac0692745b5$export$1188214e9d38144e;
var $6566aac0692745b5$export$73920f18ca706874;
$6566aac0692745b5$export$bfc36268175233c = "YUUlr";
$6566aac0692745b5$export$fb184b623420d9be = "lSnh6";
$6566aac0692745b5$export$b38bf4f33e9e4c25 = "fXBXT";
$6566aac0692745b5$export$eabcd2c8791e7bf4 = "grb3R";
$6566aac0692745b5$export$c407db72103fecfa = "K5cGb";
$6566aac0692745b5$export$d90250155de6d7e7 = "Y7GTC";
$6566aac0692745b5$export$1cbbc5990c2ee230 = "Qv4F5";
$6566aac0692745b5$export$1ca1ec8b29a4ce27 = "Ukb7J";
$6566aac0692745b5$export$3776927205fb6aff = "qOyeS";
$6566aac0692745b5$export$fe2e36411d703b3d = "TKD4b";
$6566aac0692745b5$export$9c206ddddb32a9b = "eMtn6";
$6566aac0692745b5$export$d1d7a8444e6e2c0e = "dEJ1d";
$6566aac0692745b5$export$8f2886ebc4b1fa1a = "uxSRm";
$6566aac0692745b5$export$b714fa498b091246 = "YVX28";
$6566aac0692745b5$export$8c9e255416017e56 = "xMOQY";
$6566aac0692745b5$export$d12a05a2da93ee73 = "OaGwx";
$6566aac0692745b5$export$b602b78110e4ab1e = "exXmA";
$6566aac0692745b5$export$d1bf21c0c67a443b = "zCXRG";
$6566aac0692745b5$export$5d15c6f5dc2166f9 = "X52gr";
$6566aac0692745b5$export$6d59db4903f20f7d = "pofdZ";
$6566aac0692745b5$export$a7db06668cad9adb = "-zrsP";
$6566aac0692745b5$export$1188214e9d38144e = "wGI6i";
$6566aac0692745b5$export$73920f18ca706874 = "yvUa4";


class $5a5a74645f4a26c3$export$21cf7e1029971b9d extends (0, $fsnB5.Component) {
    commit() {
        this.leftContainer = this.el($6566aac0692745b5$exports.left);
        this.contentContainer = this.el($6566aac0692745b5$exports.content);
        this.entries.forEach((value)=>{
            //language=HTML
            let entry = this.leftContainer.append(`
                <div class="${$6566aac0692745b5$exports.entry} ${$6566aac0692745b5$exports.selected}">
                    <div class="${$6566aac0692745b5$exports.titles}">
                        <div class="${$6566aac0692745b5$exports.icon} ${$6566aac0692745b5$exports[value.icon]}"></div>
                        <h4 class="${$6566aac0692745b5$exports.title}">
                            ${value.title}
                        </h4>
                    </div>
                    <p class="${$6566aac0692745b5$exports.description}">
                        ${value.desc}
                    </p>
                </div>
            `);
            entry.onClick(()=>this.select(this.entries.indexOf(value)));
            this.entriesComponents.push(entry);
        });
        this.select(0);
        super.commit();
    }
    select(index) {
        this.contentContainer.clearAll();
        this.entriesComponents.forEach((value)=>value.removeClass($6566aac0692745b5$exports.selected));
        let value = this.entries[index];
        let entry = this.entriesComponents[index];
        entry.addClass($6566aac0692745b5$exports.selected);
        this.contentContainer.append(`<img src="${value.image}" class="${$6566aac0692745b5$exports.picture}" alt="${value.title}" height="${value.height}" width="${value.width}"/>`);
    }
    constructor(title, entries){
        super();
        this.entries = entries;
        this.entriesComponents = [];
        //language=HTML
        this.template = `
            <div class="${$6566aac0692745b5$exports.componentWebsiteSliderLeft}">
                <h3 class="${$6566aac0692745b5$exports.title}">
                    ${title}
                </h3>
                <div class="${$6566aac0692745b5$exports.slider}">
                    <div class="${$6566aac0692745b5$exports.left}"></div>
                    <div class="${$6566aac0692745b5$exports.content}"></div>
                </div>
            </div>
        `;
    }
}



var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");


var $5FliW = parcelRequire("5FliW");
class $fae3756739518a78$export$1b5d99909ed4e8af extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.websiteLivechat"),
            text: (0, $5FliW.Resources).t("words.installSolution"),
            productType: (0, $kfkzw.ProductType).LIVECHAT,
            url: `${(0, $7AbeR.Network).vendor}images/capture-livechat.webp`
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $2202559933343005$export$d8eb6fbe0ee5dec2)({
            color: "black",
            title: (0, $5FliW.Resources).t("words.relationship"),
            columns: [
                {
                    icon: "customerService",
                    name: "Support",
                    text: (0, $5FliW.Resources).t("words.helpCustomer")
                },
                {
                    icon: "transaction",
                    name: "Ventes",
                    text: (0, $5FliW.Resources).t("words.quickContact")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $bfdcae3eca8e9f3e$export$f03a647dc37f632a)({
            title: (0, $5FliW.Resources).t("words.startNow"),
            grid: [
                {
                    name: (0, $5FliW.Resources).t("words.download"),
                    description: (0, $5FliW.Resources).t("words.codeCopy"),
                    icon: $5a25dbfd33bc5a35$export$be246276456a52e7
                },
                {
                    name: (0, $5FliW.Resources).t("words.customize"),
                    description: (0, $5FliW.Resources).t("words.colorCustomize"),
                    icon: $5a25dbfd33bc5a35$export$b714fa498b091246
                },
                {
                    name: (0, $5FliW.Resources).t("words.start"),
                    description: (0, $5FliW.Resources).t("words.startReply"),
                    icon: $5a25dbfd33bc5a35$export$30780d0b6b610af8
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.customerChatbox"),
            description: (0, $5FliW.Resources).t("words.fullyCustomizableLivechat"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-livechats.webp",
            color: "multi",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $5a5a74645f4a26c3$export$21cf7e1029971b9d)((0, $5FliW.Resources).t("words.features"), [
            {
                icon: "trombone",
                title: (0, $5FliW.Resources).t("words.files"),
                desc: (0, $5FliW.Resources).t("words.shareFiles"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "content-files.webp",
                width: "223.81",
                height: "399.98"
            },
            {
                icon: "writePaper",
                title: (0, $5FliW.Resources).t("words.answerQuickly"),
                desc: (0, $5FliW.Resources).t("words.predefinedTexts"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "content-answerQuickly.webp",
                width: "547.11",
                height: "399.99"
            },
            {
                icon: "pensil",
                title: (0, $5FliW.Resources).t("words.collectInformations"),
                desc: (0, $5FliW.Resources).t("words.customersForm"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "content-form.webp",
                width: "223.2",
                height: "399.98"
            },
            {
                icon: "clock",
                title: (0, $5FliW.Resources).t("words.activity"),
                desc: (0, $5FliW.Resources).t("words.activityHours"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "content-informationGathering.webp",
                width: "311.04",
                height: "399.99"
            }
        ]))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.analyzeYourPerformance"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "capture-poll.webp",
            color: "purple",
            size: "tall",
            shadow: "shadow",
            border: "border"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.livechatMore"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "capture-mail-connected.webp",
            color: "black",
            size: "tall"
        }))}
                    </div>
                        <!--<div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        $ {this.draw(new WebsiteMobileComponent())}
                    </div>-->
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.livechat")
        }))}
                    </div>
                </div>
        `;
    }
}


class $6fad8f87996cd842$export$3cbb6273c610a30 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $fae3756739518a78$export$1b5d99909ed4e8af)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("livechat");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");





var $7AbeR = parcelRequire("7AbeR");

var $fsnB5 = parcelRequire("fsnB5");
var $fa4110dc0d4c15e7$exports = {};

$parcel$export($fa4110dc0d4c15e7$exports, "componentWebsitePresentationDegraded", function () { return $fa4110dc0d4c15e7$export$d4cd5e862c20dc56; }, function (v) { return $fa4110dc0d4c15e7$export$d4cd5e862c20dc56 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "head", function () { return $fa4110dc0d4c15e7$export$5fd5031fecdacec3; }, function (v) { return $fa4110dc0d4c15e7$export$5fd5031fecdacec3 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "title", function () { return $fa4110dc0d4c15e7$export$fb184b623420d9be; }, function (v) { return $fa4110dc0d4c15e7$export$fb184b623420d9be = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "medium", function () { return $fa4110dc0d4c15e7$export$649ecc744817b5c7; }, function (v) { return $fa4110dc0d4c15e7$export$649ecc744817b5c7 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "small", function () { return $fa4110dc0d4c15e7$export$3c17b0e969a90510; }, function (v) { return $fa4110dc0d4c15e7$export$3c17b0e969a90510 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "blue", function () { return $fa4110dc0d4c15e7$export$2aa0182783e7e9de; }, function (v) { return $fa4110dc0d4c15e7$export$2aa0182783e7e9de = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "red", function () { return $fa4110dc0d4c15e7$export$a90204d1394caf30; }, function (v) { return $fa4110dc0d4c15e7$export$a90204d1394caf30 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "black", function () { return $fa4110dc0d4c15e7$export$c073df10e766abfa; }, function (v) { return $fa4110dc0d4c15e7$export$c073df10e766abfa = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "multi", function () { return $fa4110dc0d4c15e7$export$13e2537ceeaf8a3a; }, function (v) { return $fa4110dc0d4c15e7$export$13e2537ceeaf8a3a = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "purple", function () { return $fa4110dc0d4c15e7$export$e13cce2a2d16a9d4; }, function (v) { return $fa4110dc0d4c15e7$export$e13cce2a2d16a9d4 = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "imageContainer", function () { return $fa4110dc0d4c15e7$export$63e82393dc8977bf; }, function (v) { return $fa4110dc0d4c15e7$export$63e82393dc8977bf = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "image", function () { return $fa4110dc0d4c15e7$export$5c452ff88e35e47d; }, function (v) { return $fa4110dc0d4c15e7$export$5c452ff88e35e47d = v; });
$parcel$export($fa4110dc0d4c15e7$exports, "tall", function () { return $fa4110dc0d4c15e7$export$d06da4f97bb01f71; }, function (v) { return $fa4110dc0d4c15e7$export$d06da4f97bb01f71 = v; });
var $fa4110dc0d4c15e7$export$d4cd5e862c20dc56;
var $fa4110dc0d4c15e7$export$5fd5031fecdacec3;
var $fa4110dc0d4c15e7$export$fb184b623420d9be;
var $fa4110dc0d4c15e7$export$649ecc744817b5c7;
var $fa4110dc0d4c15e7$export$3c17b0e969a90510;
var $fa4110dc0d4c15e7$export$2aa0182783e7e9de;
var $fa4110dc0d4c15e7$export$a90204d1394caf30;
var $fa4110dc0d4c15e7$export$c073df10e766abfa;
var $fa4110dc0d4c15e7$export$13e2537ceeaf8a3a;
var $fa4110dc0d4c15e7$export$e13cce2a2d16a9d4;
var $fa4110dc0d4c15e7$export$63e82393dc8977bf;
var $fa4110dc0d4c15e7$export$5c452ff88e35e47d;
var $fa4110dc0d4c15e7$export$d06da4f97bb01f71;
$fa4110dc0d4c15e7$export$d4cd5e862c20dc56 = "s8jKV";
$fa4110dc0d4c15e7$export$5fd5031fecdacec3 = "G-nsn";
$fa4110dc0d4c15e7$export$fb184b623420d9be = "MA3hF";
$fa4110dc0d4c15e7$export$649ecc744817b5c7 = "_6nbKi";
$fa4110dc0d4c15e7$export$3c17b0e969a90510 = "-B4ob";
$fa4110dc0d4c15e7$export$2aa0182783e7e9de = "HeQjH";
$fa4110dc0d4c15e7$export$a90204d1394caf30 = "_3Gko9";
$fa4110dc0d4c15e7$export$c073df10e766abfa = "ne6Gn";
$fa4110dc0d4c15e7$export$13e2537ceeaf8a3a = "XKRi3";
$fa4110dc0d4c15e7$export$e13cce2a2d16a9d4 = "_88gPl";
$fa4110dc0d4c15e7$export$63e82393dc8977bf = "p6aWt";
$fa4110dc0d4c15e7$export$5c452ff88e35e47d = "benqp";
$fa4110dc0d4c15e7$export$d06da4f97bb01f71 = "y52n-";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $b0d482579f9f8a55$export$26ebd0be71b24829 extends (0, $fsnB5.Component) {
    commit() {
        this.smallContainer = this.el($fa4110dc0d4c15e7$exports.small);
        this.mediumContainer = this.el($fa4110dc0d4c15e7$exports.medium);
        this.bigContainer = this.el($fa4110dc0d4c15e7$exports.big);
        this.index = 0;
        this.titles.forEach((title)=>{
            //language=HTML
            if (this.index == 0) this.smallContainer.append(`
                    ${title.title}
                `);
            else if (this.index == 1) this.mediumContainer.append(`
                    ${title.title}
                `);
            else if (this.index == 2) this.bigContainer.append(`
                    ${title.title}
                `);
            this.index += 1;
        });
        super.commit();
    }
    constructor(p){
        super();
        this.color = p.color;
        this.size = p.size;
        this.titles = p.titles;
        //language=HTML
        this.template = `
            <div class="${$fa4110dc0d4c15e7$exports.componentWebsitePresentationDegraded}">
                <div class="${$fa4110dc0d4c15e7$exports.head} ${$fa4110dc0d4c15e7$exports[this.color]}">
                    <h2 class="${$fa4110dc0d4c15e7$exports.title} ${$fa4110dc0d4c15e7$exports.small}"></h2>
                    <h2 class="${$fa4110dc0d4c15e7$exports.title} ${$fa4110dc0d4c15e7$exports.medium}"></h2>
                    <h2 class="${$fa4110dc0d4c15e7$exports.title} ${$fa4110dc0d4c15e7$exports.big}"></h2>
                </div>
                <div class="${$fa4110dc0d4c15e7$exports.imageContainer}">
                    <img class="${$fa4110dc0d4c15e7$exports.image} ${$fa4110dc0d4c15e7$exports[this.size]}" src="${(0, $7AbeR.Network).vendor}images/${p.image}"
                         alt="${(0, $5FliW.Resources).t("words.extractSedestralInterface")}"/>
                </div>
            </div>
        `;
    }
}





var $kfkzw = parcelRequire("kfkzw");


var $5FliW = parcelRequire("5FliW");
class $1d471d79b5dbe02c$export$70f619274ccd91c3 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.businessMails"),
            text: (0, $5FliW.Resources).t("words.manageAndCreateMails"),
            productType: (0, $kfkzw.ProductType).MAILS,
            url: `${(0, $7AbeR.Network).vendor}images/capture-mail-ask.webp`
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $b0d482579f9f8a55$export$26ebd0be71b24829)({
            titles: [
                {
                    title: (0, $5FliW.Resources).t("words.yourMails")
                },
                {
                    title: (0, $5FliW.Resources).t("words.yourCompany")
                },
                {
                    title: (0, $5FliW.Resources).t("words.yourDomainName")
                }
            ],
            image: "illus-domain.svg",
            color: "multi",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1ca27900064f3d61$export$68bb1055da0209bf)({
            title: (0, $5FliW.Resources).t("words.bigTeams"),
            columns: [
                {
                    name: (0, $5FliW.Resources).t("words.createGroupMails"),
                    picture: "illus-members.svg",
                    state: "special"
                },
                {
                    name: (0, $5FliW.Resources).t("words.supportMails"),
                    picture: "illus-domains.svg",
                    state: "normal"
                },
                {
                    name: (0, $5FliW.Resources).t("words.collaborate"),
                    picture: "illus-editor.webp",
                    state: "normal"
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $5a5a74645f4a26c3$export$21cf7e1029971b9d)((0, $5FliW.Resources).t("words.fullControlMails"), [
            {
                icon: "home",
                title: (0, $5FliW.Resources).t("words.overview"),
                desc: (0, $5FliW.Resources).t("words.spaceManagement"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "capture-overview.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "mail",
                title: (0, $5FliW.Resources).t("words.manageMails"),
                desc: (0, $5FliW.Resources).t("words.allocateMails"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "capture-emailAttribution.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "mailAlias",
                title: (0, $5FliW.Resources).t("words.aliasesRedirections"),
                desc: (0, $5FliW.Resources).t("words.setUpAliases"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "capture-aliasAttribution.webp",
                width: "561.6",
                height: "315.9"
            },
            {
                icon: "domains",
                title: (0, $5FliW.Resources).t("words.domains"),
                desc: (0, $5FliW.Resources).t("words.addDomainName"),
                image: `${(0, $7AbeR.Network).vendor}images/` + "capture-domainValidation.webp",
                width: "561.6",
                height: "315.9"
            }
        ]))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $2202559933343005$export$d8eb6fbe0ee5dec2)({
            color: "red",
            title: (0, $5FliW.Resources).t("words.reliableMailsAddresses"),
            columns: [
                {
                    icon: "error",
                    name: (0, $5FliW.Resources).t("words.antiSpam"),
                    text: (0, $5FliW.Resources).t("words.blockSpam")
                },
                {
                    icon: "mailSpam",
                    name: (0, $5FliW.Resources).t("words.antiVirus"),
                    text: (0, $5FliW.Resources).t("words.securitySolution")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.connectSocialNetworks"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "capture-mail-connected.webp",
            color: "black",
            size: "tall"
        }))}
                    </div>
                        <!--<div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        $ {this.draw(new WebsiteMobileComponent())}
                    </div>-->
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.mails")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $42b42b5f4a3c09a6$export$98018fbb31b537b8 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $1d471d79b5dbe02c$export$70f619274ccd91c3)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("mails");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $78c31ff239818d0e$export$31666aeebab1a81b;
var $78c31ff239818d0e$export$c6575b6ed1dea316;
var $78c31ff239818d0e$export$c96745152eb2740f;
var $78c31ff239818d0e$export$fb184b623420d9be;
$78c31ff239818d0e$export$31666aeebab1a81b = "YR8RE";
$78c31ff239818d0e$export$c6575b6ed1dea316 = "BrAUn";
$78c31ff239818d0e$export$c96745152eb2740f = "SrIN7";
$78c31ff239818d0e$export$fb184b623420d9be = "B863R";




var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");

var $fsnB5 = parcelRequire("fsnB5");
var $64bca3fa043a2e18$export$552a907c2569cb26;
var $64bca3fa043a2e18$export$d8556a2a8f973135;
var $64bca3fa043a2e18$export$1e95b668f3b82d;
var $64bca3fa043a2e18$export$1ca1ec8b29a4ce27;
var $64bca3fa043a2e18$export$fb184b623420d9be;
var $64bca3fa043a2e18$export$40e543e69a8b3fbb;
var $64bca3fa043a2e18$export$eabcd2c8791e7bf4;
var $64bca3fa043a2e18$export$29f9f81de5c56283;
var $64bca3fa043a2e18$export$6f093cfa640b7166;
var $64bca3fa043a2e18$export$2ba01fb71ed41cb6;
var $64bca3fa043a2e18$export$9254cd51d610f2d2;
var $64bca3fa043a2e18$export$60bb6c1f29b8a8cc;
var $64bca3fa043a2e18$export$79ffe56a765070d2;
$64bca3fa043a2e18$export$552a907c2569cb26 = "_8obg6";
$64bca3fa043a2e18$export$d8556a2a8f973135 = "_5iUED";
$64bca3fa043a2e18$export$1e95b668f3b82d = "_23fJh";
$64bca3fa043a2e18$export$1ca1ec8b29a4ce27 = "JyyuX";
$64bca3fa043a2e18$export$fb184b623420d9be = "ZwOXq";
$64bca3fa043a2e18$export$40e543e69a8b3fbb = "onvxY";
$64bca3fa043a2e18$export$eabcd2c8791e7bf4 = "-V1ky";
$64bca3fa043a2e18$export$29f9f81de5c56283 = "TVnje";
$64bca3fa043a2e18$export$6f093cfa640b7166 = "-UMv5";
$64bca3fa043a2e18$export$2ba01fb71ed41cb6 = "GM9Wg";
$64bca3fa043a2e18$export$9254cd51d610f2d2 = "pIF8L";
$64bca3fa043a2e18$export$60bb6c1f29b8a8cc = "ahMLk";
$64bca3fa043a2e18$export$79ffe56a765070d2 = "rvzAK";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $a22d677547db5ee6$export$d95034cd4cf3650d extends (0, $fsnB5.Component) {
    commit() {
        this.componentContainer = this.el($64bca3fa043a2e18$export$552a907c2569cb26);
        this.components.forEach((components)=>{
            if (components.url && components.url !== "" && components.textButton !== "" && components.textButton) //language=HTML
            this.componentContainer.append(`
                    <div class="${$64bca3fa043a2e18$export$d8556a2a8f973135}">
                        <div class="${$64bca3fa043a2e18$export$1e95b668f3b82d}">
                            <div class="${$64bca3fa043a2e18$export$1ca1ec8b29a4ce27}"></div>
                            <h3 class="${$64bca3fa043a2e18$export$fb184b623420d9be}">
                                ${components.title}
                            </h3>
                        </div>
                        <div class="${$64bca3fa043a2e18$export$40e543e69a8b3fbb}">
                            <div class="${$64bca3fa043a2e18$export$eabcd2c8791e7bf4}">
                                <div class="${$64bca3fa043a2e18$export$29f9f81de5c56283}">
                                    <p class="${$64bca3fa043a2e18$export$6f093cfa640b7166}">${components.text}</p>
                                    <a href="/${components.url}">
                                        <div class="${$64bca3fa043a2e18$export$2ba01fb71ed41cb6}">
                                            <p class="${$64bca3fa043a2e18$export$9254cd51d610f2d2}">${components.textButton}</p>
                                            <i class="${$64bca3fa043a2e18$export$60bb6c1f29b8a8cc}"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="${$64bca3fa043a2e18$export$79ffe56a765070d2}">
                                <img src="${(0, $7AbeR.Network).vendor}images/${components.image}"
                                     alt="${(0, $5FliW.Resources).t("words.illustrationCategory")} ${components.title}."/>
                            </div>
                        </div>
                    </div>
                `);
            else //language=HTML
            this.componentContainer.append(`
                    <div class="${$64bca3fa043a2e18$export$d8556a2a8f973135}">
                        <div class="${$64bca3fa043a2e18$export$1e95b668f3b82d}">
                            <div class="${$64bca3fa043a2e18$export$1ca1ec8b29a4ce27}"></div>
                            <h3 class="${$64bca3fa043a2e18$export$fb184b623420d9be}">
                                ${components.title}
                            </h3>
                        </div>
                        <div class="${$64bca3fa043a2e18$export$40e543e69a8b3fbb}">
                            <div class="${$64bca3fa043a2e18$export$eabcd2c8791e7bf4}">
                                <div class="${$64bca3fa043a2e18$export$29f9f81de5c56283}">
                                    <p class="${$64bca3fa043a2e18$export$6f093cfa640b7166}">${components.text}</p>
                                </div>
                            </div>
                            <div class="${$64bca3fa043a2e18$export$79ffe56a765070d2}">
                                <img src="${(0, $7AbeR.Network).vendor}images/${components.image}"
                                     alt="${(0, $5FliW.Resources).t("words.illustrationCategory")} ${components.title}."/>
                            </div>
                        </div>
                    </div>
                `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.components = p.components;
        //language=HTML
        this.template = `
            <div class="${$64bca3fa043a2e18$export$552a907c2569cb26}"></div>
        `;
    }
}




var $5FliW = parcelRequire("5FliW");
class $7a9e5b3dc1c8cd47$export$a63ef9c175deac98 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$78c31ff239818d0e$export$31666aeebab1a81b}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.allInOne"),
            text: (0, $5FliW.Resources).t("words.fastSupport"),
            productType: (0, $kfkzw.ProductType).CLIENT_SERVICE,
            url: `${(0, $7AbeR.Network).vendor}images/capture-inbox.webp`
        }))}
                    </div>
                    <div class="${$78c31ff239818d0e$export$c6575b6ed1dea316}">
                        <h3 class="${$78c31ff239818d0e$export$c96745152eb2740f}">
                            ${(0, $5FliW.Resources).t("words.multiChannel")}
                        </h3>
                        <h4 class="${$78c31ff239818d0e$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.letSee")}

                        </h4>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a22d677547db5ee6$export$d95034cd4cf3650d)({
            components: [
                {
                    title: (0, $5FliW.Resources).t("words.products.frLivechat"),
                    text: (0, $5FliW.Resources).t("words.livechatCustomize"),
                    textButton: (0, $5FliW.Resources).t("words.desktop"),
                    image: "livechat-a.webp",
                    url: "livechat"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.mails"),
                    text: `<span>1.</span> ${(0, $5FliW.Resources).t("words.mailsConnect")}<br/><br/><span>2.</span> ${(0, $5FliW.Resources).t("words.mailsCreate")}<br/><br/><span>3.</span> ${(0, $5FliW.Resources).t("words.mailsAssigned")}<br/><br/><span>4.</span> ${(0, $5FliW.Resources).t("words.mailsWork")}`,
                    textButton: (0, $5FliW.Resources).t("words.mailsServe"),
                    image: "illus-sc-mails.webp",
                    url: "mail"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.socialNetworks"),
                    text: (0, $5FliW.Resources).t("words.linkToSN"),
                    textButton: (0, $5FliW.Resources).t("words.SNServe"),
                    image: "illus-sc-social.svg",
                    url: "inbox"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.helpCenter"),
                    text: (0, $5FliW.Resources).t("words.helpcenterCustomize"),
                    image: "illus-sc-support.svg"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.chatBot"),
                    text: (0, $5FliW.Resources).t("words.trainIA"),
                    image: "illus-sc-bots.svg"
                }
            ]
        }))}
                    </div>
                    <div class="${$78c31ff239818d0e$export$c6575b6ed1dea316}">
                        <h3 class="${$78c31ff239818d0e$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.customerService")}
                        </h3>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.customerService")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $c394b1d0979190fd$export$ea798b7c680ee0d5 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $7a9e5b3dc1c8cd47$export$a63ef9c175deac98)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("clientService");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $82a406569704d05c$export$8fa521ed3b789f84;
var $82a406569704d05c$export$2217aca24454a969;
var $82a406569704d05c$export$f7c42a96c638d4dc;
var $82a406569704d05c$export$eabcd2c8791e7bf4;
var $82a406569704d05c$export$fb184b623420d9be;
var $82a406569704d05c$export$c96745152eb2740f;
var $82a406569704d05c$export$79ffe56a765070d2;
var $82a406569704d05c$export$5c452ff88e35e47d;
var $82a406569704d05c$export$34e0f9847d4c02dd;
var $82a406569704d05c$export$53f1d5ea8de3d7c;
$82a406569704d05c$export$8fa521ed3b789f84 = "NLmOl";
$82a406569704d05c$export$2217aca24454a969 = "tC470";
$82a406569704d05c$export$f7c42a96c638d4dc = "_5962h";
$82a406569704d05c$export$eabcd2c8791e7bf4 = "g4Yqu";
$82a406569704d05c$export$fb184b623420d9be = "VBPaj";
$82a406569704d05c$export$c96745152eb2740f = "V2-ox";
$82a406569704d05c$export$79ffe56a765070d2 = "pIWc1";
$82a406569704d05c$export$5c452ff88e35e47d = "ydErr";
$82a406569704d05c$export$34e0f9847d4c02dd = "jyv06";
$82a406569704d05c$export$53f1d5ea8de3d7c = "gWBxP";




var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");


var $fsnB5 = parcelRequire("fsnB5");
var $ecd4d3dd22e808d5$exports = {};

$parcel$export($ecd4d3dd22e808d5$exports, "componentWebsiteColumnsGridWhite", function () { return $ecd4d3dd22e808d5$export$5b4fd01d942d3c49; }, function (v) { return $ecd4d3dd22e808d5$export$5b4fd01d942d3c49 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "head", function () { return $ecd4d3dd22e808d5$export$5fd5031fecdacec3; }, function (v) { return $ecd4d3dd22e808d5$export$5fd5031fecdacec3 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "title", function () { return $ecd4d3dd22e808d5$export$fb184b623420d9be; }, function (v) { return $ecd4d3dd22e808d5$export$fb184b623420d9be = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "blue", function () { return $ecd4d3dd22e808d5$export$2aa0182783e7e9de; }, function (v) { return $ecd4d3dd22e808d5$export$2aa0182783e7e9de = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "details", function () { return $ecd4d3dd22e808d5$export$41ee12f6f6f05843; }, function (v) { return $ecd4d3dd22e808d5$export$41ee12f6f6f05843 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "detail", function () { return $ecd4d3dd22e808d5$export$13a2d28b88853ef2; }, function (v) { return $ecd4d3dd22e808d5$export$13a2d28b88853ef2 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "icon", function () { return $ecd4d3dd22e808d5$export$1ca1ec8b29a4ce27; }, function (v) { return $ecd4d3dd22e808d5$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-chart", function () { return $ecd4d3dd22e808d5$export$b5c6e04a29996f44; }, function (v) { return $ecd4d3dd22e808d5$export$b5c6e04a29996f44 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-time", function () { return $ecd4d3dd22e808d5$export$ac5ad22284b5687f; }, function (v) { return $ecd4d3dd22e808d5$export$ac5ad22284b5687f = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-good", function () { return $ecd4d3dd22e808d5$export$9a9f95c5a2d62fc5; }, function (v) { return $ecd4d3dd22e808d5$export$9a9f95c5a2d62fc5 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-export", function () { return $ecd4d3dd22e808d5$export$b2c3039516e2b8e1; }, function (v) { return $ecd4d3dd22e808d5$export$b2c3039516e2b8e1 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-voice", function () { return $ecd4d3dd22e808d5$export$b861bd9c9b84a44d; }, function (v) { return $ecd4d3dd22e808d5$export$b861bd9c9b84a44d = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-words", function () { return $ecd4d3dd22e808d5$export$3452ba47e78af6e3; }, function (v) { return $ecd4d3dd22e808d5$export$3452ba47e78af6e3 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-seo", function () { return $ecd4d3dd22e808d5$export$18d1c96072158b62; }, function (v) { return $ecd4d3dd22e808d5$export$18d1c96072158b62 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-code", function () { return $ecd4d3dd22e808d5$export$f210b805fe669b2f; }, function (v) { return $ecd4d3dd22e808d5$export$f210b805fe669b2f = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-read", function () { return $ecd4d3dd22e808d5$export$c37b689a2403b457; }, function (v) { return $ecd4d3dd22e808d5$export$c37b689a2403b457 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-keywords", function () { return $ecd4d3dd22e808d5$export$24555e9708195adb; }, function (v) { return $ecd4d3dd22e808d5$export$24555e9708195adb = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-domains", function () { return $ecd4d3dd22e808d5$export$5881ae397af7f4cf; }, function (v) { return $ecd4d3dd22e808d5$export$5881ae397af7f4cf = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-conversations", function () { return $ecd4d3dd22e808d5$export$7fb52a7446f340fe; }, function (v) { return $ecd4d3dd22e808d5$export$7fb52a7446f340fe = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-planning", function () { return $ecd4d3dd22e808d5$export$f1f6f288bdcd89e1; }, function (v) { return $ecd4d3dd22e808d5$export$f1f6f288bdcd89e1 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-delay", function () { return $ecd4d3dd22e808d5$export$56795306f1762ee9; }, function (v) { return $ecd4d3dd22e808d5$export$56795306f1762ee9 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-rating", function () { return $ecd4d3dd22e808d5$export$fd1585561896434d; }, function (v) { return $ecd4d3dd22e808d5$export$fd1585561896434d = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "black-lineal-team", function () { return $ecd4d3dd22e808d5$export$5aedd97a193be748; }, function (v) { return $ecd4d3dd22e808d5$export$5aedd97a193be748 = v; });
$parcel$export($ecd4d3dd22e808d5$exports, "subtitle", function () { return $ecd4d3dd22e808d5$export$c96745152eb2740f; }, function (v) { return $ecd4d3dd22e808d5$export$c96745152eb2740f = v; });
var $ecd4d3dd22e808d5$export$5b4fd01d942d3c49;
var $ecd4d3dd22e808d5$export$5fd5031fecdacec3;
var $ecd4d3dd22e808d5$export$fb184b623420d9be;
var $ecd4d3dd22e808d5$export$2aa0182783e7e9de;
var $ecd4d3dd22e808d5$export$41ee12f6f6f05843;
var $ecd4d3dd22e808d5$export$13a2d28b88853ef2;
var $ecd4d3dd22e808d5$export$1ca1ec8b29a4ce27;
var $ecd4d3dd22e808d5$export$b5c6e04a29996f44;
var $ecd4d3dd22e808d5$export$ac5ad22284b5687f;
var $ecd4d3dd22e808d5$export$9a9f95c5a2d62fc5;
var $ecd4d3dd22e808d5$export$b2c3039516e2b8e1;
var $ecd4d3dd22e808d5$export$b861bd9c9b84a44d;
var $ecd4d3dd22e808d5$export$3452ba47e78af6e3;
var $ecd4d3dd22e808d5$export$18d1c96072158b62;
var $ecd4d3dd22e808d5$export$f210b805fe669b2f;
var $ecd4d3dd22e808d5$export$c37b689a2403b457;
var $ecd4d3dd22e808d5$export$24555e9708195adb;
var $ecd4d3dd22e808d5$export$5881ae397af7f4cf;
var $ecd4d3dd22e808d5$export$7fb52a7446f340fe;
var $ecd4d3dd22e808d5$export$f1f6f288bdcd89e1;
var $ecd4d3dd22e808d5$export$56795306f1762ee9;
var $ecd4d3dd22e808d5$export$fd1585561896434d;
var $ecd4d3dd22e808d5$export$5aedd97a193be748;
var $ecd4d3dd22e808d5$export$c96745152eb2740f;
$ecd4d3dd22e808d5$export$5b4fd01d942d3c49 = "ea3Uf";
$ecd4d3dd22e808d5$export$5fd5031fecdacec3 = "D8KYI";
$ecd4d3dd22e808d5$export$fb184b623420d9be = "pKtD4";
$ecd4d3dd22e808d5$export$2aa0182783e7e9de = "_8-INO";
$ecd4d3dd22e808d5$export$41ee12f6f6f05843 = "bsKOx";
$ecd4d3dd22e808d5$export$13a2d28b88853ef2 = "fdgHA";
$ecd4d3dd22e808d5$export$1ca1ec8b29a4ce27 = "HvutW";
$ecd4d3dd22e808d5$export$b5c6e04a29996f44 = "fseJ9";
$ecd4d3dd22e808d5$export$ac5ad22284b5687f = "bK8ii";
$ecd4d3dd22e808d5$export$9a9f95c5a2d62fc5 = "_7Elhc";
$ecd4d3dd22e808d5$export$b2c3039516e2b8e1 = "e8gfv";
$ecd4d3dd22e808d5$export$b861bd9c9b84a44d = "mrdpH";
$ecd4d3dd22e808d5$export$3452ba47e78af6e3 = "_-4NrD";
$ecd4d3dd22e808d5$export$18d1c96072158b62 = "P-UZS";
$ecd4d3dd22e808d5$export$f210b805fe669b2f = "sVvPK";
$ecd4d3dd22e808d5$export$c37b689a2403b457 = "q3A4x";
$ecd4d3dd22e808d5$export$24555e9708195adb = "z29iQ";
$ecd4d3dd22e808d5$export$5881ae397af7f4cf = "aGIoO";
$ecd4d3dd22e808d5$export$7fb52a7446f340fe = "LWfxr";
$ecd4d3dd22e808d5$export$f1f6f288bdcd89e1 = "M6L97";
$ecd4d3dd22e808d5$export$56795306f1762ee9 = "odq--";
$ecd4d3dd22e808d5$export$fd1585561896434d = "u9Rae";
$ecd4d3dd22e808d5$export$5aedd97a193be748 = "_78rux";
$ecd4d3dd22e808d5$export$c96745152eb2740f = "_1aumv";


class $f3629506c47fec9f$export$1965e7302a1f5007 extends (0, $fsnB5.Component) {
    commit() {
        this.detailsContainer = this.el($ecd4d3dd22e808d5$exports.details);
        this.details.forEach((detail)=>{
            //language=HTML
            this.detailsContainer.append(`
                <div class="${$ecd4d3dd22e808d5$exports.detail}">
                    <div class="${$ecd4d3dd22e808d5$exports.icon} ${$ecd4d3dd22e808d5$exports[detail.icon]}"></div>
                    <h4 class="${$ecd4d3dd22e808d5$exports.title}">
                        ${detail.title}
                    </h4>
                    <p class="${$ecd4d3dd22e808d5$exports.subtitle}">
                        ${detail.subtitle}
                    </p>
                </div>
            `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.color = p.color;
        this.details = p.details;
        //language=HTML
        this.template = `
            <div class="${$ecd4d3dd22e808d5$exports.componentWebsiteColumnsGridWhite}">
                <div class="${$ecd4d3dd22e808d5$exports.head}">
                    <h3 class="${$ecd4d3dd22e808d5$exports.title} ${$ecd4d3dd22e808d5$exports[this.color]}">
                        ${p.title}
                    </h3>
                </div>
                <div class="${$ecd4d3dd22e808d5$exports.details}">
                    
                </div>
            </div>
        `;
    }
}




var $5FliW = parcelRequire("5FliW");
class $d364cd7f2af60ad6$export$1277ab3aa9d165b3 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.yourPerformanceImpact"),
            text: (0, $5FliW.Resources).t("words.evaluatingYourImpact"),
            productType: (0, $kfkzw.ProductType).STATISTICS,
            url: `${(0, $7AbeR.Network).vendor}images/capture-statistics.webp`
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.centralizeStatistics"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-applications.svg",
            color: "black",
            size: "intermediate"
        }))}
                    </div>
                    <div class="${$82a406569704d05c$export$2217aca24454a969}">
                        <div class="${$82a406569704d05c$export$f7c42a96c638d4dc}">
                            <div class="${$82a406569704d05c$export$79ffe56a765070d2}">
                                <img class="${$82a406569704d05c$export$5c452ff88e35e47d}" src="${(0, $7AbeR.Network).vendor}images/illus-filter.webp"
                                     alt="${(0, $5FliW.Resources).t("words.creationPresentationReports")}" draggable="false"
                                     width="380" height="347.51"
                                />
                            </div>
                            <div class="${$82a406569704d05c$export$eabcd2c8791e7bf4}">
                                <h2 class="${$82a406569704d05c$export$fb184b623420d9be}">
                                    ${(0, $5FliW.Resources).t("words.createReports")}
                                </h2>
                                <p class="${$82a406569704d05c$export$c96745152eb2740f}">
                                    ${(0, $5FliW.Resources).t("words.filtersStatistics")}
                                </p>
                                <img class="${$82a406569704d05c$export$53f1d5ea8de3d7c}" src="${(0, $7AbeR.Network).vendor}images/separator-line.svg"
                                     alt="${(0, $5FliW.Resources).t("words.separationLine")}" draggable="false"/>
                            </div>
                        </div>
                        <div class="${$82a406569704d05c$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.evaluatedCollaborator"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "capture-collaboraters.webp",
            color: "black",
            size: "tall",
            border: "border"
        }))}
                        </div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $f3629506c47fec9f$export$1965e7302a1f5007)({
            title: (0, $5FliW.Resources).t("words.mainReports"),
            color: "blue",
            details: [
                {
                    icon: "black-lineal-conversations",
                    title: (0, $5FliW.Resources).t("words.numberConversations"),
                    subtitle: (0, $5FliW.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-planning",
                    title: (0, $5FliW.Resources).t("words.conversationsHours"),
                    subtitle: (0, $5FliW.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-delay",
                    title: (0, $5FliW.Resources).t("words.responseTime"),
                    subtitle: (0, $5FliW.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-rating",
                    title: (0, $5FliW.Resources).t("words.ratings"),
                    subtitle: (0, $5FliW.Resources).t("words.contactHours")
                },
                {
                    icon: "black-lineal-team",
                    title: (0, $5FliW.Resources).t("words.employees"),
                    subtitle: (0, $5FliW.Resources).t("words.contactHours")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.statistics")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $e5ced8850891e5d1$export$4f14dbe3a32e74d3 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $d364cd7f2af60ad6$export$1277ab3aa9d165b3)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("statistics");
        this.status.online = undefined;
    }
}



var $fsnB5 = parcelRequire("fsnB5");


var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");
var $754592304322301f$export$eb2fa5f3de7c69e3;
var $754592304322301f$export$fb184b623420d9be;
var $754592304322301f$export$c96745152eb2740f;
var $754592304322301f$export$40513806f2b08545;
var $754592304322301f$export$d92138c69f1228fc;
var $754592304322301f$export$61910e92ff177e73;
var $754592304322301f$export$db269b07546483b0;
$754592304322301f$export$eb2fa5f3de7c69e3 = "AQxmE";
$754592304322301f$export$fb184b623420d9be = "IERJg";
$754592304322301f$export$c96745152eb2740f = "gwW2L";
$754592304322301f$export$40513806f2b08545 = "eyuEU";
$754592304322301f$export$d92138c69f1228fc = "c-Mca";
$754592304322301f$export$61910e92ff177e73 = "Cj8oB";
$754592304322301f$export$db269b07546483b0 = "VK2zh";


class $3ebbaceac55c34c8$export$b6320866fd1832d9 extends (0, $fsnB5.Component) {
    commit() {
        this.clausesContainer = this.el($754592304322301f$export$db269b07546483b0);
        this.clauses.forEach((clause)=>{
            if (clause.explain != "") //language=HTML
            this.clausesContainer.append(`
                    <div class="${$754592304322301f$export$40513806f2b08545}">
                        <h3 class="${$754592304322301f$export$d92138c69f1228fc}">
                            ${clause.header}
                        </h3>
                        <p class="${$754592304322301f$export$61910e92ff177e73}">
                            ${clause.explain}
                        </p>
                    </div>
                `);
            else //language=HTML
            this.clausesContainer.append(`
                    <div class="${$754592304322301f$export$40513806f2b08545}">
                        <h3 class="${$754592304322301f$export$d92138c69f1228fc}">
                            ${clause.header}
                        </h3>
                    </div>
                `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.clauses = p.clauses;
        //language=HTML
        this.template = `
            <div class="${$754592304322301f$export$eb2fa5f3de7c69e3}">
                <h2 class="${$754592304322301f$export$fb184b623420d9be}">
                    ${p.title}
                </h2>
                <h4 class="${$754592304322301f$export$c96745152eb2740f}">
                    ${p.subtitle}
                </h4>
                <div class="${$754592304322301f$export$db269b07546483b0}">

                </div>
            </div>
        `;
    }
}


class $1bcba2e622eacab5$export$edff894759dc337f extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $3ebbaceac55c34c8$export$b6320866fd1832d9)({
            clauses: (0, $5FliW.Resources).t("words.generalConditionsSale.clauses"),
            title: (0, $5FliW.Resources).t("words.generalConditionsSale.conditions"),
            subtitle: (0, $5FliW.Resources).t("words.generalConditionsSale.date")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}



class $07d53c5d349e0db1$export$fb06d92033ba4bca extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $1bcba2e622eacab5$export$edff894759dc337f)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("cgv");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");


var $5FliW = parcelRequire("5FliW");

class $28f7808fda4e38fc$export$fc98eca6edd0a214 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $3ebbaceac55c34c8$export$b6320866fd1832d9)({
            clauses: (0, $5FliW.Resources).t("words.generalConditionsUse.clauses"),
            title: (0, $5FliW.Resources).t("words.generalConditionsUse.conditions"),
            subtitle: (0, $5FliW.Resources).t("words.generalConditionsUse.date")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $218ac6196cd5200e$export$2422684a229ca95d extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $28f7808fda4e38fc$export$fc98eca6edd0a214)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("cgu");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");


var $5FliW = parcelRequire("5FliW");

class $d9f812aef922f09a$export$82018ff1307c221f extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $3ebbaceac55c34c8$export$b6320866fd1832d9)({
            clauses: (0, $5FliW.Resources).t("words.privacyPolicy.clauses"),
            title: (0, $5FliW.Resources).t("words.privacyPolicy.conditions"),
            subtitle: (0, $5FliW.Resources).t("words.privacyPolicy.date")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $b514d3fc36d88e4e$export$8c2ad8bee15c420d extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $d9f812aef922f09a$export$82018ff1307c221f)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("policy");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $2267fa1ccd5777aa$export$fcbb65595819f6f6;
var $2267fa1ccd5777aa$export$3bf720ece7bc7b2e;
var $2267fa1ccd5777aa$export$34e0f9847d4c02dd;
$2267fa1ccd5777aa$export$fcbb65595819f6f6 = "e1dKy";
$2267fa1ccd5777aa$export$3bf720ece7bc7b2e = "lzoUU";
$2267fa1ccd5777aa$export$34e0f9847d4c02dd = "tGGse";







var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");


var $5FliW = parcelRequire("5FliW");

class $507ca6928df84bce$export$a91c64c48ed79244 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.communicationContinuous"),
            text: (0, $5FliW.Resources).t("words.publisherDescription"),
            productType: (0, $kfkzw.ProductType).PUBLISHER,
            url: `${(0, $7AbeR.Network).vendor}images/capture-publisher-agenda.webp`
        }))}
                    </div>
                    <div class="${$2267fa1ccd5777aa$export$3bf720ece7bc7b2e}"></div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $bfdcae3eca8e9f3e$export$f03a647dc37f632a)({
            title: (0, $5FliW.Resources).t("words.whatDo"),
            grid: [
                {
                    name: (0, $5FliW.Resources).t("words.create"),
                    description: (0, $5FliW.Resources).t("words.createPublication"),
                    icon: $5a25dbfd33bc5a35$export$b714fa498b091246
                },
                {
                    name: (0, $5FliW.Resources).t("words.collaborate"),
                    description: (0, $5FliW.Resources).t("words.collaboratePublish"),
                    icon: $5a25dbfd33bc5a35$export$1f6feda8aa226b71
                },
                {
                    name: (0, $5FliW.Resources).t("words.publish"),
                    description: (0, $5FliW.Resources).t("words.publishEverywhere"),
                    icon: $5a25dbfd33bc5a35$export$30780d0b6b610af8
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.resumePublish"),
            description: "",
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-content-publisher.svg",
            color: "black",
            size: "medium"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.schedulePublications"),
            description: (0, $5FliW.Resources).t("words.schedulePublicationsDetails"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "capture-publisher.webp",
            shadow: "shadow",
            border: "border",
            color: "green",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.disponibleEverywhere"),
            description: (0, $5FliW.Resources).t("words.socialEngagement"),
            image: `${(0, $7AbeR.Network).vendor}images/` + "illus-social.svg",
            color: "red",
            size: "medium"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1d8c0622f75f2faf$export$e4b6d83931e2a971)({
            title: (0, $5FliW.Resources).t("words.personalizePosts"),
            subtitle: (0, $5FliW.Resources).t("words.customizeEveryPost"),
            illus: "capture-publisher-creator",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1d8c0622f75f2faf$export$e4b6d83931e2a971)({
            title: (0, $5FliW.Resources).t("words.receiveMessage"),
            subtitle: (0, $5FliW.Resources).t("words.descriptionReceiveMessage"),
            illus: "illus-funnel",
            size: "tall",
            url: (0, $7AbeR.Network).router.pages.getUrlWithPath('inbox'),
            direction: true
        }))}
                    </div>
                        <!--<div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        $ {this.draw(new WebsiteMobileComponent())}
                    </div>-->
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.publisher")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $66fb1d5cfed2e426$export$574699e312ffd9fc extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $507ca6928df84bce$export$a91c64c48ed79244)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("publisher");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");




var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");


var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");
var $0b35ab67d7230ed7$export$552a907c2569cb26;
var $0b35ab67d7230ed7$export$d8556a2a8f973135;
var $0b35ab67d7230ed7$export$1e95b668f3b82d;
var $0b35ab67d7230ed7$export$1ca1ec8b29a4ce27;
var $0b35ab67d7230ed7$export$fb184b623420d9be;
var $0b35ab67d7230ed7$export$40e543e69a8b3fbb;
var $0b35ab67d7230ed7$export$eabcd2c8791e7bf4;
var $0b35ab67d7230ed7$export$29f9f81de5c56283;
var $0b35ab67d7230ed7$export$6f093cfa640b7166;
var $0b35ab67d7230ed7$export$2ba01fb71ed41cb6;
var $0b35ab67d7230ed7$export$9254cd51d610f2d2;
var $0b35ab67d7230ed7$export$60bb6c1f29b8a8cc;
var $0b35ab67d7230ed7$export$79ffe56a765070d2;
$0b35ab67d7230ed7$export$552a907c2569cb26 = "LdoR-";
$0b35ab67d7230ed7$export$d8556a2a8f973135 = "OvGB-";
$0b35ab67d7230ed7$export$1e95b668f3b82d = "_1J-Of";
$0b35ab67d7230ed7$export$1ca1ec8b29a4ce27 = "crt1m";
$0b35ab67d7230ed7$export$fb184b623420d9be = "XkFbv";
$0b35ab67d7230ed7$export$40e543e69a8b3fbb = "_5uF3l";
$0b35ab67d7230ed7$export$eabcd2c8791e7bf4 = "BFSYr";
$0b35ab67d7230ed7$export$29f9f81de5c56283 = "aXGDu";
$0b35ab67d7230ed7$export$6f093cfa640b7166 = "FTAVd";
$0b35ab67d7230ed7$export$2ba01fb71ed41cb6 = "j68oj";
$0b35ab67d7230ed7$export$9254cd51d610f2d2 = "FbUQf";
$0b35ab67d7230ed7$export$60bb6c1f29b8a8cc = "rr0bA";
$0b35ab67d7230ed7$export$79ffe56a765070d2 = "My2zJ";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $d90472b0f545d66f$export$ae690cddcd3d91e1 extends (0, $fsnB5.Component) {
    commit() {
        this.componentContainer = this.el($0b35ab67d7230ed7$export$552a907c2569cb26);
        this.components.forEach((components)=>{
            if (components.url && components.url !== "" && components.textButton !== "" && components.textButton) //language=HTML
            this.componentContainer.append(`
                    <div class="${$0b35ab67d7230ed7$export$d8556a2a8f973135}">
                        <div class="${$0b35ab67d7230ed7$export$1e95b668f3b82d}">
                            <div class="${$0b35ab67d7230ed7$export$1ca1ec8b29a4ce27}"></div>
                            <h3 class="${$0b35ab67d7230ed7$export$fb184b623420d9be}">
                                ${components.title}
                            </h3>
                        </div>
                        <div class="${$0b35ab67d7230ed7$export$40e543e69a8b3fbb}">
                            <div class="${$0b35ab67d7230ed7$export$eabcd2c8791e7bf4}">
                                <div class="${$0b35ab67d7230ed7$export$29f9f81de5c56283}">
                                    <p class="${$0b35ab67d7230ed7$export$6f093cfa640b7166}">${components.text}</p>
                                    <a href="/${components.url}">
                                        <div class="${$0b35ab67d7230ed7$export$2ba01fb71ed41cb6}">
                                            <p class="${$0b35ab67d7230ed7$export$9254cd51d610f2d2}">${components.textButton}</p>
                                            <i class="${$0b35ab67d7230ed7$export$60bb6c1f29b8a8cc}"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="${$0b35ab67d7230ed7$export$79ffe56a765070d2}">
                                <img src="${(0, $7AbeR.Network).vendor}images/${components.image}"
                                     alt="${(0, $5FliW.Resources).t("words.illustrationCategory")} ${components.title}."/>
                            </div>
                        </div>
                    </div>
                `);
            else //language=HTML
            this.componentContainer.append(`
                    <div class="${$0b35ab67d7230ed7$export$d8556a2a8f973135}">
                        <div class="${$0b35ab67d7230ed7$export$1e95b668f3b82d}">
                            <div class="${$0b35ab67d7230ed7$export$1ca1ec8b29a4ce27}"></div>
                            <h3 class="${$0b35ab67d7230ed7$export$fb184b623420d9be}">
                                ${components.title}
                            </h3>
                        </div>
                        <div class="${$0b35ab67d7230ed7$export$40e543e69a8b3fbb}">
                            <div class="${$0b35ab67d7230ed7$export$eabcd2c8791e7bf4}">
                                <div class="${$0b35ab67d7230ed7$export$29f9f81de5c56283}">
                                    <p class="${$0b35ab67d7230ed7$export$6f093cfa640b7166}">${components.text}</p>
                                </div>
                            </div>
                            <div class="${$0b35ab67d7230ed7$export$79ffe56a765070d2}">
                                <img src="${(0, $7AbeR.Network).vendor}images/${components.image}"
                                     alt="${(0, $5FliW.Resources).t("words.illustrationCategory")} ${components.title}."/>
                            </div>
                        </div>
                    </div>
                `);
        });
        super.commit();
    }
    constructor(p){
        super();
        this.components = p.components;
        //language=HTML
        this.template = `
            <div class="${$0b35ab67d7230ed7$export$552a907c2569cb26}"></div>
        `;
    }
}


class $f7f82499c67933b8$export$700149dde71fa4 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$78c31ff239818d0e$export$31666aeebab1a81b}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.helpcenterBusiness"),
            text: (0, $5FliW.Resources).t("words.fastSupport"),
            productType: (0, $kfkzw.ProductType).CLIENT_SERVICE,
            url: `${(0, $7AbeR.Network).vendor}images/capture-inbox.webp`
        }))}
                    </div>
                    <div class="${$78c31ff239818d0e$export$c6575b6ed1dea316}">
                        <h3 class="${$78c31ff239818d0e$export$c96745152eb2740f}">
                            ${(0, $5FliW.Resources).t("words.multiChannel")}
                        </h3>
                        <h4 class="${$78c31ff239818d0e$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.letSee")}

                        </h4>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $d90472b0f545d66f$export$ae690cddcd3d91e1)({
            components: [
                {
                    title: (0, $5FliW.Resources).t("words.products.frLivechat"),
                    text: (0, $5FliW.Resources).t("words.livechatCustomize"),
                    textButton: (0, $5FliW.Resources).t("words.desktop"),
                    image: "livechat-a.webp",
                    url: "livechat"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.mails"),
                    text: `<span>1.</span> ${(0, $5FliW.Resources).t("words.mailsConnect")}<br/><br/><span>2.</span> ${(0, $5FliW.Resources).t("words.mailsCreate")}<br/><br/><span>3.</span> ${(0, $5FliW.Resources).t("words.mailsAssigned")}<br/><br/><span>4.</span> ${(0, $5FliW.Resources).t("words.mailsWork")}`,
                    textButton: (0, $5FliW.Resources).t("words.mailsServe"),
                    image: "illus-sc-mails.webp",
                    url: "mail"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.socialNetworks"),
                    text: (0, $5FliW.Resources).t("words.linkToSN"),
                    textButton: (0, $5FliW.Resources).t("words.SNServe"),
                    image: "illus-sc-social.svg",
                    url: "inbox"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.frHelpcenter"),
                    text: (0, $5FliW.Resources).t("words.helpcenterCustomize"),
                    image: "illus-sc-support.svg"
                },
                {
                    title: (0, $5FliW.Resources).t("words.products.chatBot"),
                    text: (0, $5FliW.Resources).t("words.trainIA"),
                    image: "illus-sc-bots.svg"
                }
            ]
        }))}
                    </div>
                    <div class="${$78c31ff239818d0e$export$c6575b6ed1dea316}">
                        <h3 class="${$78c31ff239818d0e$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.customerService")}
                        </h3>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: (0, $5FliW.Resources).t("words.questions.customerService")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $193aa6d3c91baa2d$export$17f3ea6ee3033913 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $f7f82499c67933b8$export$700149dde71fa4)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("helpcenter");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");







var $kfkzw = parcelRequire("kfkzw");

var $7AbeR = parcelRequire("7AbeR");


var $5FliW = parcelRequire("5FliW");



var $5FliW = parcelRequire("5FliW");

var $7AbeR = parcelRequire("7AbeR");
class $072d9015278afa7d$export$a27e371a094e4e50 {
    static image(name) {
        let lang = (0, $5FliW.Resources).language;
        if (this.images.find((value)=>{
            return value.lang == lang && value.name == name;
        })) return `${(0, $7AbeR.Network).vendor}images/${lang}/${name}`;
        else return `${(0, $7AbeR.Network).vendor}images/en/${name}`;
    }
    static illus(name) {
        return `${(0, $7AbeR.Network).vendor}images/${name}`;
    }
    static customer(name) {
        return `${(0, $7AbeR.Network).vendor}images/customers/${name}`;
    }
    static reviews(type) {
        return [
            {
                platform: "Shopify App Store",
                platformIcon: "shopify",
                content: (0, $5FliW.Resources).t("words.shopifyReview1"),
                avatarUrl: $072d9015278afa7d$export$a27e371a094e4e50.customer("blog-gourmet.svg"),
                avatarName: "Le Coq Gourmet",
                avatarDescription: (0, $5FliW.Resources).t("words.ecommerceSite"),
                stars: 5,
                datePublished: "2024-09-03",
                productName: "SmartBlog"
            },
            {
                platform: "Google",
                platformIcon: "google",
                content: (0, $5FliW.Resources).t("words.googleReview1"),
                avatarUrl: $072d9015278afa7d$export$a27e371a094e4e50.customer("blog-dylan.jpg"),
                avatarName: "Dylan DELIQUE",
                avatarDescription: (0, $5FliW.Resources).t("words.realEstateAdvisor"),
                stars: 5,
                datePublished: "2024-06-17",
                productName: "SmartBlog"
            }
        ];
    }
}
$072d9015278afa7d$export$a27e371a094e4e50.images = [];



var $fsnB5 = parcelRequire("fsnB5");

var $fsnB5 = parcelRequire("fsnB5");
var $184109bdc3ded95e$exports = {};

$parcel$export($184109bdc3ded95e$exports, "componentWebsiteReview", function () { return $184109bdc3ded95e$export$79bad0724c35cf21; }, function (v) { return $184109bdc3ded95e$export$79bad0724c35cf21 = v; });
$parcel$export($184109bdc3ded95e$exports, "stars", function () { return $184109bdc3ded95e$export$cccfc0e200cdf418; }, function (v) { return $184109bdc3ded95e$export$cccfc0e200cdf418 = v; });
$parcel$export($184109bdc3ded95e$exports, "star", function () { return $184109bdc3ded95e$export$c869496b69afe520; }, function (v) { return $184109bdc3ded95e$export$c869496b69afe520 = v; });
$parcel$export($184109bdc3ded95e$exports, "provider", function () { return $184109bdc3ded95e$export$ca328f169d304df4; }, function (v) { return $184109bdc3ded95e$export$ca328f169d304df4 = v; });
$parcel$export($184109bdc3ded95e$exports, "by", function () { return $184109bdc3ded95e$export$766bf7dcfb630b6c; }, function (v) { return $184109bdc3ded95e$export$766bf7dcfb630b6c = v; });
$parcel$export($184109bdc3ded95e$exports, "shopify", function () { return $184109bdc3ded95e$export$6da9acb12d5139d4; }, function (v) { return $184109bdc3ded95e$export$6da9acb12d5139d4 = v; });
$parcel$export($184109bdc3ded95e$exports, "icon", function () { return $184109bdc3ded95e$export$1ca1ec8b29a4ce27; }, function (v) { return $184109bdc3ded95e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($184109bdc3ded95e$exports, "google", function () { return $184109bdc3ded95e$export$2d1fdedcfa4b711e; }, function (v) { return $184109bdc3ded95e$export$2d1fdedcfa4b711e = v; });
$parcel$export($184109bdc3ded95e$exports, "content", function () { return $184109bdc3ded95e$export$a7db06668cad9adb; }, function (v) { return $184109bdc3ded95e$export$a7db06668cad9adb = v; });
$parcel$export($184109bdc3ded95e$exports, "author", function () { return $184109bdc3ded95e$export$571b02044ddb2ab3; }, function (v) { return $184109bdc3ded95e$export$571b02044ddb2ab3 = v; });
$parcel$export($184109bdc3ded95e$exports, "image", function () { return $184109bdc3ded95e$export$5c452ff88e35e47d; }, function (v) { return $184109bdc3ded95e$export$5c452ff88e35e47d = v; });
$parcel$export($184109bdc3ded95e$exports, "name", function () { return $184109bdc3ded95e$export$a8ff84c12d48cfa6; }, function (v) { return $184109bdc3ded95e$export$a8ff84c12d48cfa6 = v; });
$parcel$export($184109bdc3ded95e$exports, "description", function () { return $184109bdc3ded95e$export$6d59db4903f20f7d; }, function (v) { return $184109bdc3ded95e$export$6d59db4903f20f7d = v; });
var $184109bdc3ded95e$export$79bad0724c35cf21;
var $184109bdc3ded95e$export$cccfc0e200cdf418;
var $184109bdc3ded95e$export$c869496b69afe520;
var $184109bdc3ded95e$export$ca328f169d304df4;
var $184109bdc3ded95e$export$766bf7dcfb630b6c;
var $184109bdc3ded95e$export$6da9acb12d5139d4;
var $184109bdc3ded95e$export$1ca1ec8b29a4ce27;
var $184109bdc3ded95e$export$2d1fdedcfa4b711e;
var $184109bdc3ded95e$export$a7db06668cad9adb;
var $184109bdc3ded95e$export$571b02044ddb2ab3;
var $184109bdc3ded95e$export$5c452ff88e35e47d;
var $184109bdc3ded95e$export$a8ff84c12d48cfa6;
var $184109bdc3ded95e$export$6d59db4903f20f7d;
$184109bdc3ded95e$export$79bad0724c35cf21 = "XFZ-n";
$184109bdc3ded95e$export$cccfc0e200cdf418 = "_9Uo3c";
$184109bdc3ded95e$export$c869496b69afe520 = "uidhD";
$184109bdc3ded95e$export$ca328f169d304df4 = "hd61J";
$184109bdc3ded95e$export$766bf7dcfb630b6c = "AAaF1";
$184109bdc3ded95e$export$6da9acb12d5139d4 = "_9X34Z";
$184109bdc3ded95e$export$1ca1ec8b29a4ce27 = "OBEL0";
$184109bdc3ded95e$export$2d1fdedcfa4b711e = "_41OXe";
$184109bdc3ded95e$export$a7db06668cad9adb = "SCGSn";
$184109bdc3ded95e$export$571b02044ddb2ab3 = "_8casC";
$184109bdc3ded95e$export$5c452ff88e35e47d = "lnQ2D";
$184109bdc3ded95e$export$a8ff84c12d48cfa6 = "GYBvd";
$184109bdc3ded95e$export$6d59db4903f20f7d = "lt-8w";



var $5FliW = parcelRequire("5FliW");
class $f54c8068b05100dd$export$8ead506451ba0d9d extends (0, $fsnB5.Component) {
    constructor(reviewsCount, review){
        super();
        //language=HTML
        this.template = `
            <div class="${$184109bdc3ded95e$exports.componentWebsiteReview}" itemscope itemtype="https://schema.org/Review">
                <div class="${$184109bdc3ded95e$exports.stars}" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">
                    <meta itemprop="ratingValue" content="${review.stars}"/>
                    <meta itemprop="bestRating" content="5"/>
                    <meta itemprop="worstRating" content="1"/>
                    <div>
                        <div class="${$184109bdc3ded95e$exports.star}"></div>
                        <div class="${$184109bdc3ded95e$exports.star}"></div>
                        <div class="${$184109bdc3ded95e$exports.star}"></div>
                        <div class="${$184109bdc3ded95e$exports.star}"></div>
                        <div class="${$184109bdc3ded95e$exports.star}"></div>
                    </div>
                    <div class="${$184109bdc3ded95e$exports.provider} ${$184109bdc3ded95e$exports[review.platformIcon]}">
                        <span class="${$184109bdc3ded95e$exports.by}">${(0, $5FliW.Resources).t("words.publishedOn")}</span>
                        <span itemprop="publisher">${review.platform}</span>
                        <div class="${$184109bdc3ded95e$exports.icon}"></div>
                    </div>
                    <div class="${$184109bdc3ded95e$exports.content}" itemprop="reviewBody">
                        ${review.content}
                    </div>
                </div>
                <div class="${$184109bdc3ded95e$exports.author}" itemprop="author" itemscope itemtype="https://schema.org/Person">
                    <div class="${$184109bdc3ded95e$exports.image}">
                        <img src="${review.avatarUrl}" alt="${review.avatarName}" itemprop="image"/>
                    </div>
                    <div>
                        <div class="${$184109bdc3ded95e$exports.name}" itemprop="name">${review.avatarName}</div>
                        <div class="${$184109bdc3ded95e$exports.description}">
                            ${review.avatarDescription}
                        </div>
                    </div>
                </div>
                <meta itemprop="datePublished" content="${review.datePublished}"/>
                <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/Product">
                    <meta itemprop="name" content="${review.productName}"/>
                    <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
                        <meta itemprop="ratingValue" content="${review.stars}"/>
                        <meta itemprop="reviewCount" content="${reviewsCount}"/>
                        <meta itemprop="bestRating" content="5"/>
                        <meta itemprop="worstRating" content="1">
                    </div>
                </div>
            </div>
        `;
    }
}


var $32dc4299780daffa$export$c32be3e6c06658c8;
var $32dc4299780daffa$export$fb184b623420d9be;
var $32dc4299780daffa$export$a5cc789282b6873;
$32dc4299780daffa$export$c32be3e6c06658c8 = "P5o2F";
$32dc4299780daffa$export$fb184b623420d9be = "rY15Z";
$32dc4299780daffa$export$a5cc789282b6873 = "_1-Wsg";


class $78bbdfb845d14d49$export$e9f2082bf3648ed6 extends (0, $fsnB5.Component) {
    constructor(title, reviews){
        super();
        //language=HTML
        this.template = `
            <div class="${$32dc4299780daffa$export$c32be3e6c06658c8}">
                <div class="${$32dc4299780daffa$export$fb184b623420d9be}">${title}</div>
                <div class="${$32dc4299780daffa$export$a5cc789282b6873}">
                    ${reviews.map((value)=>this.draw(new (0, $f54c8068b05100dd$export$8ead506451ba0d9d)(reviews.length, value))).join("")}
                </div>
            </div>
        `;
    }
}



var $2aBLW = parcelRequire("2aBLW");

var $fsnB5 = parcelRequire("fsnB5");
var $c20ce8f82da73782$exports = {};

$parcel$export($c20ce8f82da73782$exports, "componentCustomerPopup", function () { return $c20ce8f82da73782$export$e0ce3e6c6a4477a8; }, function (v) { return $c20ce8f82da73782$export$e0ce3e6c6a4477a8 = v; });
$parcel$export($c20ce8f82da73782$exports, "box", function () { return $c20ce8f82da73782$export$827f4ee28efc37; }, function (v) { return $c20ce8f82da73782$export$827f4ee28efc37 = v; });
$parcel$export($c20ce8f82da73782$exports, "head", function () { return $c20ce8f82da73782$export$5fd5031fecdacec3; }, function (v) { return $c20ce8f82da73782$export$5fd5031fecdacec3 = v; });
$parcel$export($c20ce8f82da73782$exports, "title", function () { return $c20ce8f82da73782$export$fb184b623420d9be; }, function (v) { return $c20ce8f82da73782$export$fb184b623420d9be = v; });
$parcel$export($c20ce8f82da73782$exports, "close", function () { return $c20ce8f82da73782$export$8360e631d277ea4d; }, function (v) { return $c20ce8f82da73782$export$8360e631d277ea4d = v; });
$parcel$export($c20ce8f82da73782$exports, "icon", function () { return $c20ce8f82da73782$export$1ca1ec8b29a4ce27; }, function (v) { return $c20ce8f82da73782$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($c20ce8f82da73782$exports, "content", function () { return $c20ce8f82da73782$export$a7db06668cad9adb; }, function (v) { return $c20ce8f82da73782$export$a7db06668cad9adb = v; });
$parcel$export($c20ce8f82da73782$exports, "text", function () { return $c20ce8f82da73782$export$6f093cfa640b7166; }, function (v) { return $c20ce8f82da73782$export$6f093cfa640b7166 = v; });
$parcel$export($c20ce8f82da73782$exports, "cases", function () { return $c20ce8f82da73782$export$3931a0da49df8dc0; }, function (v) { return $c20ce8f82da73782$export$3931a0da49df8dc0 = v; });
$parcel$export($c20ce8f82da73782$exports, "case", function () { return $c20ce8f82da73782$export$e850e66917a23e0f; }, function (v) { return $c20ce8f82da73782$export$e850e66917a23e0f = v; });
$parcel$export($c20ce8f82da73782$exports, "context", function () { return $c20ce8f82da73782$export$a078c61943f9dbbe; }, function (v) { return $c20ce8f82da73782$export$a078c61943f9dbbe = v; });
$parcel$export($c20ce8f82da73782$exports, "style", function () { return $c20ce8f82da73782$export$1d567c320f4763bc; }, function (v) { return $c20ce8f82da73782$export$1d567c320f4763bc = v; });
$parcel$export($c20ce8f82da73782$exports, "ai", function () { return $c20ce8f82da73782$export$f38c853ae54ed474; }, function (v) { return $c20ce8f82da73782$export$f38c853ae54ed474 = v; });
$parcel$export($c20ce8f82da73782$exports, "round", function () { return $c20ce8f82da73782$export$2077e0241d6afd3c; }, function (v) { return $c20ce8f82da73782$export$2077e0241d6afd3c = v; });
$parcel$export($c20ce8f82da73782$exports, "button", function () { return $c20ce8f82da73782$export$2ba01fb71ed41cb6; }, function (v) { return $c20ce8f82da73782$export$2ba01fb71ed41cb6 = v; });
var $c20ce8f82da73782$export$e0ce3e6c6a4477a8;
var $c20ce8f82da73782$export$827f4ee28efc37;
var $c20ce8f82da73782$export$5fd5031fecdacec3;
var $c20ce8f82da73782$export$fb184b623420d9be;
var $c20ce8f82da73782$export$8360e631d277ea4d;
var $c20ce8f82da73782$export$1ca1ec8b29a4ce27;
var $c20ce8f82da73782$export$a7db06668cad9adb;
var $c20ce8f82da73782$export$6f093cfa640b7166;
var $c20ce8f82da73782$export$3931a0da49df8dc0;
var $c20ce8f82da73782$export$e850e66917a23e0f;
var $c20ce8f82da73782$export$a078c61943f9dbbe;
var $c20ce8f82da73782$export$1d567c320f4763bc;
var $c20ce8f82da73782$export$f38c853ae54ed474;
var $c20ce8f82da73782$export$2077e0241d6afd3c;
var $c20ce8f82da73782$export$2ba01fb71ed41cb6;
$c20ce8f82da73782$export$e0ce3e6c6a4477a8 = "TBvlc";
$c20ce8f82da73782$export$827f4ee28efc37 = "-KmyV";
$c20ce8f82da73782$export$5fd5031fecdacec3 = "WGM9H";
$c20ce8f82da73782$export$fb184b623420d9be = "X6Gwb";
$c20ce8f82da73782$export$8360e631d277ea4d = "gSjsg";
$c20ce8f82da73782$export$1ca1ec8b29a4ce27 = "MN3oY";
$c20ce8f82da73782$export$a7db06668cad9adb = "-csry";
$c20ce8f82da73782$export$6f093cfa640b7166 = "P-cL4";
$c20ce8f82da73782$export$3931a0da49df8dc0 = "_3CPqo";
$c20ce8f82da73782$export$e850e66917a23e0f = "BFE7C";
$c20ce8f82da73782$export$a078c61943f9dbbe = "_1ICUF";
$c20ce8f82da73782$export$1d567c320f4763bc = "nJEw-";
$c20ce8f82da73782$export$f38c853ae54ed474 = "_7-e8R";
$c20ce8f82da73782$export$2077e0241d6afd3c = "_0Gh5d";
$c20ce8f82da73782$export$2ba01fb71ed41cb6 = "njImB";


class $9d22929ebfbc1373$export$a0872ea153981ca8 extends (0, $fsnB5.Component) {
    commit() {
        this.boxContainer = this.el($c20ce8f82da73782$exports.box);
        this.actionButton = this.el($c20ce8f82da73782$exports.button);
        this.closeButton = this.el($c20ce8f82da73782$exports.close);
        this.boxContainer.translate({
            translateY: 0,
            scale: 1,
            delay: 300
        });
        this.closeButton.onClick(async ()=>{
            await this.boxContainer.translate({
                translateY: 500,
                opacity: 0,
                delay: 300
            });
            this.remove();
            this.onClose();
        });
        super.commit();
    }
    onClose() {}
    constructor(p){
        super();
        //language=HTML
        this.template = `
            <div class="${$c20ce8f82da73782$exports.componentCustomerPopup}">
                <div class="${$c20ce8f82da73782$exports.box}">
                    <div class="${$c20ce8f82da73782$exports.head}">
                        <div class="${$c20ce8f82da73782$exports.title}">${p.title}</div>
                        <div class="${$c20ce8f82da73782$exports.close}">
                            <div class="${$c20ce8f82da73782$exports.icon}"></div>
                        </div>
                    </div>
                    <div class="${$c20ce8f82da73782$exports.content}">
                        <div class="${$c20ce8f82da73782$exports.icon}"></div>
                        <div class="${$c20ce8f82da73782$exports.text}">
                            ${p.content}
                        </div>
                    </div>
                    <div class="${$c20ce8f82da73782$exports.cases}">
                        ${p.cases ? p.cases.map((value)=>{
            //language=HTML
            return `
                            <div class="${$c20ce8f82da73782$exports.case} ${$c20ce8f82da73782$exports[value.icon]}">
                                <div class="${$c20ce8f82da73782$exports.head}">
                                    <div class="${$c20ce8f82da73782$exports.round}">
                                        <div class="${$c20ce8f82da73782$exports.icon}"></div>
                                    </div>
                                    ${value.title}
                                </div>
                                <div class="${$c20ce8f82da73782$exports.text}">
                                    ${value.text}
                                </div>
                            </div>
                            `;
        }).join("") : ``}
                    </div>
                    <a href="${p.buttonUrl}" target="_blank" class="${$c20ce8f82da73782$exports.button}">
                        ${p.buttonText}
                        <div class="${$c20ce8f82da73782$exports.icon}"></div>
                    </a>
                </div>
            </div>
        `;
    }
}



var $1wiPK = parcelRequire("1wiPK");

var $nyKU9 = parcelRequire("nyKU9");

var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");

class $ea62fcbd69a0df0d$export$4718cc74f3daff00 {
    static blog() {
        (0, $nyKU9.SedestralMachine).setTimeout(()=>{
            //if (SedestralStorage.getItem("CblogClosed") == undefined) {
            if (!this.blogRendered) {
                if (!(0, $d808f887fcf63765$export$f650c34b939fcf30).hasSsr()) {
                    let popup = new (0, $9d22929ebfbc1373$export$a0872ea153981ca8)({
                        title: (0, $5FliW.Resources).t("words.threeFreeContents"),
                        content: (0, $5FliW.Resources).t("words.createAccountSeoContent"),
                        buttonText: (0, $5FliW.Resources).t("words.beginFree"),
                        buttonUrl: (0, $7AbeR.Network).router.pages.getPanelUrl('signup')
                    });
                    popup.onClose = ()=>(0, $1wiPK.SedestralStorage).setItem("CblogClosed", "open");
                    (0, $2aBLW.SedestralInterface).body.render(popup);
                }
                this.blogRendered = true;
            }
        //}
        }, 15000);
    }
    static blogWriteFinished() {
        let popup = new (0, $9d22929ebfbc1373$export$a0872ea153981ca8)({
            title: (0, $5FliW.Resources).t("words.congratulationsFirstContent"),
            content: (0, $5FliW.Resources).t("words.scheduleDemoSeoBoost"),
            buttonText: (0, $5FliW.Resources).t("words.scheduleDemo"),
            buttonUrl: (0, $7AbeR.Network).router.pages.getWebsiteUrl('schedule'),
            large: true,
            cases: [
                {
                    title: (0, $5FliW.Resources).t("words.instructions"),
                    icon: "ai",
                    text: (0, $5FliW.Resources).t("words.optimizeAiInstructions")
                },
                {
                    title: (0, $5FliW.Resources).t("words.context"),
                    icon: "context",
                    text: (0, $5FliW.Resources).t("words.explainBusinessActivity")
                },
                {
                    title: (0, $5FliW.Resources).t("words.styleCloning"),
                    icon: "style",
                    text: (0, $5FliW.Resources).t("words.keepWritingStyle")
                }
            ]
        });
        popup.onClose = ()=>(0, $1wiPK.SedestralStorage).setItem("CblogClosed", "open");
        (0, $2aBLW.SedestralInterface).body.render(popup);
    }
}
$ea62fcbd69a0df0d$export$4718cc74f3daff00.blogRendered = false;


class $d22ae1fdce455a4d$export$db95308c3d59a34d extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7389044f417dac9d$export$dd68357b72560132)({
            title: (0, $5FliW.Resources).t("words.letAIGenerateArticles"),
            text: (0, $5FliW.Resources).t("words.smartBlogDescription"),
            productType: (0, $kfkzw.ProductType).BLOG,
            url: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-a.webp"),
            buttonText: (0, $5FliW.Resources).t("words.generatethreeFreeContents"),
            buttonUrl: (0, $7AbeR.Network).router.pages.getPanelUrl('signup')
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.seeSmartBlogInAction"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-video-a.mp4"),
            color: "black",
            size: "tall",
            border: "border",
            shadow: "shadow"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $bfdcae3eca8e9f3e$export$f03a647dc37f632a)({
            title: (0, $5FliW.Resources).t("words.howItWorks"),
            grid: [
                {
                    name: (0, $5FliW.Resources).t("words.customizeConfig"),
                    description: (0, $5FliW.Resources).t("words.customizeDescription"),
                    icon: $5a25dbfd33bc5a35$export$b714fa498b091246
                },
                {
                    name: (0, $5FliW.Resources).t("words.explainTitle"),
                    description: (0, $5FliW.Resources).t("words.explainDescription"),
                    icon: $5a25dbfd33bc5a35$export$be246276456a52e7
                },
                {
                    name: (0, $5FliW.Resources).t("words.publishArticleTitle"),
                    description: (0, $5FliW.Resources).t("words.publishArticleDescription"),
                    icon: $5a25dbfd33bc5a35$export$30780d0b6b610af8
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.connectExistingBlog"),
            description: (0, $5FliW.Resources).t("words.chooseCmsPlatform"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).illus("illus-cms.svg"),
            color: "black",
            size: "intermediate"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.customizeYourBlog"),
            description: (0, $5FliW.Resources).t("words.customizeBlogDescription"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-d.webp"),
            color: "multi",
            size: "tall"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $5a5a74645f4a26c3$export$21cf7e1029971b9d)((0, $5FliW.Resources).t("words.iaArticleWriting"), [
            {
                icon: "draft",
                title: (0, $5FliW.Resources).t("words.instructionsTitle"),
                desc: (0, $5FliW.Resources).t("words.instructionsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $5FliW.Resources).t("words.proposalsTitle"),
                desc: (0, $5FliW.Resources).t("words.proposalsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $5FliW.Resources).t("words.planTitle"),
                desc: (0, $5FliW.Resources).t("words.planDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $5FliW.Resources).t("words.writingTitle"),
                desc: (0, $5FliW.Resources).t("words.writingDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ]))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $1d8c0622f75f2faf$export$e4b6d83931e2a971)({
            title: (0, $5FliW.Resources).t("words.seoOptimizedBlog"),
            subtitle: (0, $5FliW.Resources).t("words.seoOptimizedBlogSubtitle"),
            illus: "illus-seo",
            size: "medium"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $f3629506c47fec9f$export$1965e7302a1f5007)({
            title: (0, $5FliW.Resources).t("words.otherFeatures"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-domains",
                    title: (0, $5FliW.Resources).t("words.domainNameTitle"),
                    subtitle: (0, $5FliW.Resources).t("words.domainNameSubtitle")
                },
                {
                    icon: "black-export",
                    title: (0, $5FliW.Resources).t("words.exportArticlesTitle"),
                    subtitle: (0, $5FliW.Resources).t("words.exportArticlesSubtitle")
                },
                {
                    icon: "black-lineal-delay",
                    title: (0, $5FliW.Resources).t("words.scheduleArticlesTitle"),
                    subtitle: (0, $5FliW.Resources).t("words.scheduleArticlesSubtitle")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $78bbdfb845d14d49$export$e9f2082bf3648ed6)((0, $5FliW.Resources).t("words.whatOurClientsSay"), (0, $072d9015278afa7d$export$a27e371a094e4e50).reviews()))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            questions: [
                {
                    "question": (0, $5FliW.Resources).t("words.doesGooglePenalizeAiContent"),
                    "response": (0, $5FliW.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                ...(0, $5FliW.Resources).t("words.questions.smartblog")
            ]
        }))}
                    </div>
                </div>
        `;
    }
}


class $da16cb06e6f63a3a$export$d7d15f70146cf1a7 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $d22ae1fdce455a4d$export$db95308c3d59a34d)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("blog");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $5acafaa622436fcf$export$74766011f560cccc;
var $5acafaa622436fcf$export$130be424786e852f;
$5acafaa622436fcf$export$74766011f560cccc = "I68Mt";
$5acafaa622436fcf$export$130be424786e852f = "YSJEJ";




var $5FliW = parcelRequire("5FliW");
function $86359f522f1a9856$export$2cb99e4be0dc4646(url, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            if (callback) callback();
        }
    };
    else script.onload = function() {
        if (callback) callback();
    };
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}




class $70ff75f2f88060fc$export$fa6bf7fb87b222ae extends (0, $fsnB5.Component) {
    commit() {
        super.commit();
        (0, $86359f522f1a9856$export$2cb99e4be0dc4646)("https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js", ()=>{});
    }
    constructor(){
        super(), this.loaderLightComponent = new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$5acafaa622436fcf$export$74766011f560cccc}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.schedule"),
            description: "",
            color: "white",
            size: "intermediate"
        }))}
                        <div style="margin-top:40px;" class="meetings-iframe-container" data-src="https://meetings.hubspot.com/alexis-avril?embed=true"></div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            questions: (0, $5FliW.Resources).t("words.questions.schedule")
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $08bda45b57402495$export$dad0f9f593647209 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $70ff75f2f88060fc$export$fa6bf7fb87b222ae)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("schedule");
        this.status.online = undefined;
    }
}





var $fsnB5 = parcelRequire("fsnB5");


var $fsnB5 = parcelRequire("fsnB5");
var $c4d83a1e07de1315$export$27262836c31796ac;
var $c4d83a1e07de1315$export$3481c78889e8fbe8;
var $c4d83a1e07de1315$export$fb184b623420d9be;
var $c4d83a1e07de1315$export$6d59db4903f20f7d;
var $c4d83a1e07de1315$export$7317a7c5ea43bbe0;
var $c4d83a1e07de1315$export$f83c4d891692a29b;
var $c4d83a1e07de1315$export$de7e4d92f917a218;
var $c4d83a1e07de1315$export$4bd6df12cc64b67d;
var $c4d83a1e07de1315$export$86e62408adb4b70d;
var $c4d83a1e07de1315$export$cc620c11ab3a91af;
var $c4d83a1e07de1315$export$f333d7638cf8abde;
var $c4d83a1e07de1315$export$bbea856fdb3e3c5f;
var $c4d83a1e07de1315$export$b3571188c770cc5a;
var $c4d83a1e07de1315$export$1ca1ec8b29a4ce27;
var $c4d83a1e07de1315$export$8fa4e5556fd77a60;
var $c4d83a1e07de1315$export$b8972b998723d602;
var $c4d83a1e07de1315$export$a7db06668cad9adb;
var $c4d83a1e07de1315$export$7c5480d2d52b096a;
var $c4d83a1e07de1315$export$5c754c0557bd8d37;
var $c4d83a1e07de1315$export$5eeba3dd1f988465;
$c4d83a1e07de1315$export$27262836c31796ac = "_52VCW";
$c4d83a1e07de1315$export$3481c78889e8fbe8 = "fzD9t";
$c4d83a1e07de1315$export$fb184b623420d9be = "OYML3";
$c4d83a1e07de1315$export$6d59db4903f20f7d = "pX5NR";
$c4d83a1e07de1315$export$7317a7c5ea43bbe0 = "GujlJ";
$c4d83a1e07de1315$export$f83c4d891692a29b = "Wi9mZ";
$c4d83a1e07de1315$export$de7e4d92f917a218 = "GIt79";
$c4d83a1e07de1315$export$4bd6df12cc64b67d = "_9Bt5v";
$c4d83a1e07de1315$export$86e62408adb4b70d = "rO5f3";
$c4d83a1e07de1315$export$cc620c11ab3a91af = "cpRAF";
$c4d83a1e07de1315$export$f333d7638cf8abde = "tTGka";
$c4d83a1e07de1315$export$bbea856fdb3e3c5f = "vuphj";
$c4d83a1e07de1315$export$b3571188c770cc5a = "_2Mumn";
$c4d83a1e07de1315$export$1ca1ec8b29a4ce27 = "ux-Oq";
$c4d83a1e07de1315$export$8fa4e5556fd77a60 = "Sz80f";
$c4d83a1e07de1315$export$b8972b998723d602 = "rkJA8";
$c4d83a1e07de1315$export$a7db06668cad9adb = "-uSQp";
$c4d83a1e07de1315$export$7c5480d2d52b096a = "GLQDJ";
$c4d83a1e07de1315$export$5c754c0557bd8d37 = "ObTY6";
$c4d83a1e07de1315$export$5eeba3dd1f988465 = "fXOt-";



var $7AbeR = parcelRequire("7AbeR");

var $5FliW = parcelRequire("5FliW");
class $7484749ce292151c$export$6d14472d28e42cd8 extends (0, $fsnB5.Component) {
    commit() {
        this.buttons = this.el($c4d83a1e07de1315$export$bbea856fdb3e3c5f);
        if (this.p.people) //language=HTML
        this.buttons.append(`
                <div class="${$c4d83a1e07de1315$export$5c754c0557bd8d37}">
                    <div class="${$c4d83a1e07de1315$export$1ca1ec8b29a4ce27}"></div>
                    ${(0, $5FliW.Resources).t("words.improveRankingMessage")}
                </div>
            `);
        super.commit();
    }
    constructor(p){
        super();
        this.p = p;
        let bigIconClass = undefined;
        if (p.partnerIcon) switch(p.partnerIcon){
            case "prestashop":
                bigIconClass = $c4d83a1e07de1315$export$4bd6df12cc64b67d;
                break;
            case "wordpress":
                bigIconClass = $c4d83a1e07de1315$export$cc620c11ab3a91af;
                break;
            case "shopify":
                bigIconClass = $c4d83a1e07de1315$export$86e62408adb4b70d;
                break;
            case "wix":
                bigIconClass = $c4d83a1e07de1315$export$f333d7638cf8abde;
                break;
        }
        var _p_firstButtonLink;
        //language=HTML
        this.template = `
            <div class="${$c4d83a1e07de1315$export$27262836c31796ac} ${p.center ? $c4d83a1e07de1315$export$3481c78889e8fbe8 : ``}">
                <div class="${$c4d83a1e07de1315$export$5eeba3dd1f988465}"></div>
                <div class="${$c4d83a1e07de1315$export$fb184b623420d9be}">
                    ${p.title}
                </div>
                <div class="${$c4d83a1e07de1315$export$6d59db4903f20f7d}">
                    ${p.description}
                </div>
                ${bigIconClass ? `
                <div class="${$c4d83a1e07de1315$export$7317a7c5ea43bbe0}">
                    <div class="${$c4d83a1e07de1315$export$f83c4d891692a29b}"></div>
                    <div class="${$c4d83a1e07de1315$export$de7e4d92f917a218}"></div>
                   <div class="${bigIconClass}"></div>
                </div>
                ` : ``}
                <div class="${$c4d83a1e07de1315$export$bbea856fdb3e3c5f}">
                    <a href="${(_p_firstButtonLink = p.firstButtonLink) !== null && _p_firstButtonLink !== void 0 ? _p_firstButtonLink : (0, $7AbeR.Network).router.pages.getPanelUrl('signup')}" target="_blank" class="${$c4d83a1e07de1315$export$b3571188c770cc5a}">
                        <div class="${$c4d83a1e07de1315$export$b8972b998723d602}"></div>
                        <div class="${$c4d83a1e07de1315$export$a7db06668cad9adb}">
                            ${p.startText}
                            <div class="${$c4d83a1e07de1315$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                    ${p.secondButton ? `
                    <a href="https://prestashop.strl.io/my-blog" target="_blank" class="${$c4d83a1e07de1315$export$b3571188c770cc5a} ${$c4d83a1e07de1315$export$8fa4e5556fd77a60}">
                       <div class="${$c4d83a1e07de1315$export$a7db06668cad9adb}">
                            <div class="${$c4d83a1e07de1315$export$1ca1ec8b29a4ce27} ${$c4d83a1e07de1315$export$7c5480d2d52b096a}"></div>
                            ${(0, $5FliW.Resources).t("words.viewDemoBlog")}
                            <div class="${$c4d83a1e07de1315$export$1ca1ec8b29a4ce27}"></div>
                        </div>
                    </a>
                    ` : ``}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $04f063ce060a8e63$exports = {};

$parcel$export($04f063ce060a8e63$exports, "componentWebsiteBlackSteps", function () { return $04f063ce060a8e63$export$22248bcf0be7d5f1; }, function (v) { return $04f063ce060a8e63$export$22248bcf0be7d5f1 = v; });
$parcel$export($04f063ce060a8e63$exports, "bottomShadow", function () { return $04f063ce060a8e63$export$6e1e3cd95d0461b9; }, function (v) { return $04f063ce060a8e63$export$6e1e3cd95d0461b9 = v; });
$parcel$export($04f063ce060a8e63$exports, "top", function () { return $04f063ce060a8e63$export$1e95b668f3b82d; }, function (v) { return $04f063ce060a8e63$export$1e95b668f3b82d = v; });
$parcel$export($04f063ce060a8e63$exports, "topShadow", function () { return $04f063ce060a8e63$export$c9e520a45cbb2500; }, function (v) { return $04f063ce060a8e63$export$c9e520a45cbb2500 = v; });
$parcel$export($04f063ce060a8e63$exports, "title", function () { return $04f063ce060a8e63$export$fb184b623420d9be; }, function (v) { return $04f063ce060a8e63$export$fb184b623420d9be = v; });
$parcel$export($04f063ce060a8e63$exports, "icon", function () { return $04f063ce060a8e63$export$1ca1ec8b29a4ce27; }, function (v) { return $04f063ce060a8e63$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($04f063ce060a8e63$exports, "seo", function () { return $04f063ce060a8e63$export$7dc4b9367473a505; }, function (v) { return $04f063ce060a8e63$export$7dc4b9367473a505 = v; });
$parcel$export($04f063ce060a8e63$exports, "value", function () { return $04f063ce060a8e63$export$2ab9a8f9f1186f14; }, function (v) { return $04f063ce060a8e63$export$2ab9a8f9f1186f14 = v; });
$parcel$export($04f063ce060a8e63$exports, "buttons", function () { return $04f063ce060a8e63$export$bbea856fdb3e3c5f; }, function (v) { return $04f063ce060a8e63$export$bbea856fdb3e3c5f = v; });
$parcel$export($04f063ce060a8e63$exports, "button", function () { return $04f063ce060a8e63$export$2ba01fb71ed41cb6; }, function (v) { return $04f063ce060a8e63$export$2ba01fb71ed41cb6 = v; });
$parcel$export($04f063ce060a8e63$exports, "progress", function () { return $04f063ce060a8e63$export$504d7abb21fa8c9; }, function (v) { return $04f063ce060a8e63$export$504d7abb21fa8c9 = v; });
$parcel$export($04f063ce060a8e63$exports, "name", function () { return $04f063ce060a8e63$export$a8ff84c12d48cfa6; }, function (v) { return $04f063ce060a8e63$export$a8ff84c12d48cfa6 = v; });
$parcel$export($04f063ce060a8e63$exports, "content", function () { return $04f063ce060a8e63$export$a7db06668cad9adb; }, function (v) { return $04f063ce060a8e63$export$a7db06668cad9adb = v; });
$parcel$export($04f063ce060a8e63$exports, "image", function () { return $04f063ce060a8e63$export$5c452ff88e35e47d; }, function (v) { return $04f063ce060a8e63$export$5c452ff88e35e47d = v; });
var $04f063ce060a8e63$export$22248bcf0be7d5f1;
var $04f063ce060a8e63$export$6e1e3cd95d0461b9;
var $04f063ce060a8e63$export$1e95b668f3b82d;
var $04f063ce060a8e63$export$c9e520a45cbb2500;
var $04f063ce060a8e63$export$fb184b623420d9be;
var $04f063ce060a8e63$export$1ca1ec8b29a4ce27;
var $04f063ce060a8e63$export$7dc4b9367473a505;
var $04f063ce060a8e63$export$2ab9a8f9f1186f14;
var $04f063ce060a8e63$export$bbea856fdb3e3c5f;
var $04f063ce060a8e63$export$2ba01fb71ed41cb6;
var $04f063ce060a8e63$export$504d7abb21fa8c9;
var $04f063ce060a8e63$export$a8ff84c12d48cfa6;
var $04f063ce060a8e63$export$a7db06668cad9adb;
var $04f063ce060a8e63$export$5c452ff88e35e47d;
$04f063ce060a8e63$export$22248bcf0be7d5f1 = "PoB7X";
$04f063ce060a8e63$export$6e1e3cd95d0461b9 = "Vhl-t";
$04f063ce060a8e63$export$1e95b668f3b82d = "VkiXO";
$04f063ce060a8e63$export$c9e520a45cbb2500 = "oZZa3";
$04f063ce060a8e63$export$fb184b623420d9be = "HaV8-";
$04f063ce060a8e63$export$1ca1ec8b29a4ce27 = "DYaIt";
$04f063ce060a8e63$export$7dc4b9367473a505 = "c486o";
$04f063ce060a8e63$export$2ab9a8f9f1186f14 = "-KzaJ";
$04f063ce060a8e63$export$bbea856fdb3e3c5f = "_2MtyC";
$04f063ce060a8e63$export$2ba01fb71ed41cb6 = "qxc5x";
$04f063ce060a8e63$export$504d7abb21fa8c9 = "DwOoN";
$04f063ce060a8e63$export$a8ff84c12d48cfa6 = "IEX5n";
$04f063ce060a8e63$export$a7db06668cad9adb = "JQG93";
$04f063ce060a8e63$export$5c452ff88e35e47d = "hr8SM";


class $001b31774028e938$export$41c8d4c54c27d95f extends (0, $fsnB5.Component) {
    commit() {
        this.buttonsContainer = this.el($04f063ce060a8e63$exports.buttons);
        this.contentContainer = this.el($04f063ce060a8e63$exports.content);
        this.steps.contents.forEach((content)=>{
            //language=HTML
            let component = this.buttonsContainer.append(`
                <div class="${$04f063ce060a8e63$exports.button}">
                    <div class="${$04f063ce060a8e63$exports.progress}"></div>
                    <div class="${$04f063ce060a8e63$exports.name}">${content.name}</div>
                </div>
            `);
            let progress = component.el($04f063ce060a8e63$exports.progress);
            let button = {
                button: component,
                progress: progress,
                content: content
            };
            this.buttons.push(button);
            component.onClick(()=>this.renderContent(button));
        });
        this.renderContent(this.buttons[0]);
        super.commit();
    }
    renderContent(button) {
        if (this.contentButton) {
            this.contentButton.progress.setStyle(`width:0%;transition:0s;`);
            clearTimeout(this.contentProgressInterval);
        }
        this.contentContainer.clearAll();
        clearTimeout(this.contentTimeout);
        this.contentButton = button;
        switch(this.contentButton.content.type){
            case "img":
                this.contentContainer.append(`<img class="${$04f063ce060a8e63$exports.image}" src="${this.contentButton.content.path}"/>`);
                break;
            case "video":
                //language=HTML
                let video = this.contentContainer.append(`
                    <video autoplay loop muted playsinline style="width: 100%;">
                        <source src="${this.contentButton.content.path}" type="video/mp4"/>
                    </video>`);
                video.getHTMLElement().onloadedmetadata = ()=>{
                    this.contentContainer.setStyle(`height: ${this.contentContainer.getHeight()}px;`);
                    let contentSizeTimeout;
                    this.contentContainer.putListener(window, "resize", ()=>{
                        clearTimeout(contentSizeTimeout);
                        this.contentContainer.setStyle(`height: unset;`);
                        contentSizeTimeout = this.timeOut(()=>{
                            this.contentContainer.setStyle(`height: ${this.contentContainer.getHeight()}px;`);
                        }, 1000);
                    });
                };
                break;
        }
        let width = 0;
        this.contentProgressInterval = this.interval(()=>{
            width += 0.5;
            this.contentButton.progress.setStyle(`width:${width}%;transition:0s;`);
        }, button.content.duration / 200);
        this.contentTimeout = this.timeOut(()=>{
            let currentIndex = this.buttons.indexOf(this.contentButton);
            let nextIndex = currentIndex + 1;
            if (this.buttons.length - 1 >= nextIndex) this.renderContent(this.buttons[nextIndex]);
            else this.renderContent(this.buttons[0]);
        }, this.contentButton.content.duration);
    }
    constructor(steps){
        super();
        this.steps = steps;
        this.buttons = [];
        //language=HTML
        this.template = `
            <div class="${$04f063ce060a8e63$exports.componentWebsiteBlackSteps}">
                <div class="${$04f063ce060a8e63$exports.bottomShadow}"></div>

                <div class="${$04f063ce060a8e63$exports.top}">
                    <div class="${$04f063ce060a8e63$exports.topShadow}"></div>
                    <div class="${$04f063ce060a8e63$exports.title}">
                        <div class="${$04f063ce060a8e63$exports.icon} ${$04f063ce060a8e63$exports[steps.icon]}"></div>
                        <div class="${$04f063ce060a8e63$exports.value}">
                            ${steps.title}
                        </div>
                    </div>
                    <div class="${$04f063ce060a8e63$exports.buttons}"></div>
                </div>
                <div class="${$04f063ce060a8e63$exports.content}"></div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $4b3a90a072416cc0$exports = {};

$parcel$export($4b3a90a072416cc0$exports, "componentWebsiteBlackText", function () { return $4b3a90a072416cc0$export$44742403a52a2f0f; }, function (v) { return $4b3a90a072416cc0$export$44742403a52a2f0f = v; });
$parcel$export($4b3a90a072416cc0$exports, "sizeNormal", function () { return $4b3a90a072416cc0$export$f1af96aedc86f3e3; }, function (v) { return $4b3a90a072416cc0$export$f1af96aedc86f3e3 = v; });
$parcel$export($4b3a90a072416cc0$exports, "content", function () { return $4b3a90a072416cc0$export$a7db06668cad9adb; }, function (v) { return $4b3a90a072416cc0$export$a7db06668cad9adb = v; });
$parcel$export($4b3a90a072416cc0$exports, "sizeBig", function () { return $4b3a90a072416cc0$export$253b27e74ad938c7; }, function (v) { return $4b3a90a072416cc0$export$253b27e74ad938c7 = v; });
$parcel$export($4b3a90a072416cc0$exports, "colorBlue", function () { return $4b3a90a072416cc0$export$4280a44aebc4cc67; }, function (v) { return $4b3a90a072416cc0$export$4280a44aebc4cc67 = v; });
$parcel$export($4b3a90a072416cc0$exports, "shadow", function () { return $4b3a90a072416cc0$export$b8972b998723d602; }, function (v) { return $4b3a90a072416cc0$export$b8972b998723d602 = v; });
var $4b3a90a072416cc0$export$44742403a52a2f0f;
var $4b3a90a072416cc0$export$f1af96aedc86f3e3;
var $4b3a90a072416cc0$export$a7db06668cad9adb;
var $4b3a90a072416cc0$export$253b27e74ad938c7;
var $4b3a90a072416cc0$export$4280a44aebc4cc67;
var $4b3a90a072416cc0$export$b8972b998723d602;
$4b3a90a072416cc0$export$44742403a52a2f0f = "-aEG-";
$4b3a90a072416cc0$export$f1af96aedc86f3e3 = "iCnEs";
$4b3a90a072416cc0$export$a7db06668cad9adb = "bA27x";
$4b3a90a072416cc0$export$253b27e74ad938c7 = "bHiY6";
$4b3a90a072416cc0$export$4280a44aebc4cc67 = "p4ztM";
$4b3a90a072416cc0$export$b8972b998723d602 = "YQURL";


class $e6a50373d11f2ef1$export$67fc1824eabdc07e extends (0, $fsnB5.Component) {
    constructor(text){
        super();
        //language=HTML
        this.template = `
            <div class="${$4b3a90a072416cc0$exports.componentWebsiteBlackText} ${$4b3a90a072416cc0$exports[text.size]} ${$4b3a90a072416cc0$exports[text.shadow]}">
                <div class="${$4b3a90a072416cc0$exports.shadow}"></div>
                <div class="${$4b3a90a072416cc0$exports.content}">
                    ${text.text}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $4cdf03072c0df866$export$b3ff231557e20c05;
var $4cdf03072c0df866$export$71ef6e19fae6c840;
var $4cdf03072c0df866$export$f38c853ae54ed474;
var $4cdf03072c0df866$export$2cc7ff91bcacba5e;
var $4cdf03072c0df866$export$1ca1ec8b29a4ce27;
var $4cdf03072c0df866$export$6f093cfa640b7166;
var $4cdf03072c0df866$export$6d59db4903f20f7d;
var $4cdf03072c0df866$export$53f1d5ea8de3d7c;
var $4cdf03072c0df866$export$b8972b998723d602;
var $4cdf03072c0df866$export$a7db06668cad9adb;
var $4cdf03072c0df866$export$324fbeb68ccbc72b;
$4cdf03072c0df866$export$b3ff231557e20c05 = "zT2fa";
$4cdf03072c0df866$export$71ef6e19fae6c840 = "_4krrE";
$4cdf03072c0df866$export$f38c853ae54ed474 = "APUgj";
$4cdf03072c0df866$export$2cc7ff91bcacba5e = "LTdkm";
$4cdf03072c0df866$export$1ca1ec8b29a4ce27 = "wJONj";
$4cdf03072c0df866$export$6f093cfa640b7166 = "QCAI8";
$4cdf03072c0df866$export$6d59db4903f20f7d = "haNuL";
$4cdf03072c0df866$export$53f1d5ea8de3d7c = "_8iGRt";
$4cdf03072c0df866$export$b8972b998723d602 = "_6GR0q";
$4cdf03072c0df866$export$a7db06668cad9adb = "jLehA";
$4cdf03072c0df866$export$324fbeb68ccbc72b = "NCbz5";



var $fsnB5 = parcelRequire("fsnB5");
var $76186166c5249771$exports = {};

$parcel$export($76186166c5249771$exports, "componentWebsiteBlackGrid", function () { return $76186166c5249771$export$6ef958818d7dbb11; }, function (v) { return $76186166c5249771$export$6ef958818d7dbb11 = v; });
$parcel$export($76186166c5249771$exports, "line", function () { return $76186166c5249771$export$53f1d5ea8de3d7c; }, function (v) { return $76186166c5249771$export$53f1d5ea8de3d7c = v; });
$parcel$export($76186166c5249771$exports, "entry", function () { return $76186166c5249771$export$c407db72103fecfa; }, function (v) { return $76186166c5249771$export$c407db72103fecfa = v; });
$parcel$export($76186166c5249771$exports, "names", function () { return $76186166c5249771$export$e4b2ac9215619f8d; }, function (v) { return $76186166c5249771$export$e4b2ac9215619f8d = v; });
$parcel$export($76186166c5249771$exports, "title", function () { return $76186166c5249771$export$fb184b623420d9be; }, function (v) { return $76186166c5249771$export$fb184b623420d9be = v; });
$parcel$export($76186166c5249771$exports, "hasStep", function () { return $76186166c5249771$export$93a5057b3118dcd; }, function (v) { return $76186166c5249771$export$93a5057b3118dcd = v; });
$parcel$export($76186166c5249771$exports, "step", function () { return $76186166c5249771$export$35d34bc0ed591a92; }, function (v) { return $76186166c5249771$export$35d34bc0ed591a92 = v; });
$parcel$export($76186166c5249771$exports, "stepShadow", function () { return $76186166c5249771$export$60b3551206497142; }, function (v) { return $76186166c5249771$export$60b3551206497142 = v; });
$parcel$export($76186166c5249771$exports, "text", function () { return $76186166c5249771$export$6f093cfa640b7166; }, function (v) { return $76186166c5249771$export$6f093cfa640b7166 = v; });
$parcel$export($76186166c5249771$exports, "ai", function () { return $76186166c5249771$export$f38c853ae54ed474; }, function (v) { return $76186166c5249771$export$f38c853ae54ed474 = v; });
$parcel$export($76186166c5249771$exports, "aiShadow", function () { return $76186166c5249771$export$2516fe6c625b33a; }, function (v) { return $76186166c5249771$export$2516fe6c625b33a = v; });
$parcel$export($76186166c5249771$exports, "aiIcon", function () { return $76186166c5249771$export$c142f6a77c53147e; }, function (v) { return $76186166c5249771$export$c142f6a77c53147e = v; });
$parcel$export($76186166c5249771$exports, "description", function () { return $76186166c5249771$export$6d59db4903f20f7d; }, function (v) { return $76186166c5249771$export$6d59db4903f20f7d = v; });
$parcel$export($76186166c5249771$exports, "iconContainer", function () { return $76186166c5249771$export$acf4eaf431084f78; }, function (v) { return $76186166c5249771$export$acf4eaf431084f78 = v; });
$parcel$export($76186166c5249771$exports, "icon", function () { return $76186166c5249771$export$1ca1ec8b29a4ce27; }, function (v) { return $76186166c5249771$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($76186166c5249771$exports, "optimize", function () { return $76186166c5249771$export$f90719f89646befa; }, function (v) { return $76186166c5249771$export$f90719f89646befa = v; });
$parcel$export($76186166c5249771$exports, "ready", function () { return $76186166c5249771$export$28ee1007e174a2a6; }, function (v) { return $76186166c5249771$export$28ee1007e174a2a6 = v; });
$parcel$export($76186166c5249771$exports, "unique", function () { return $76186166c5249771$export$7a5d5c156e7dc406; }, function (v) { return $76186166c5249771$export$7a5d5c156e7dc406 = v; });
$parcel$export($76186166c5249771$exports, "picture", function () { return $76186166c5249771$export$1188214e9d38144e; }, function (v) { return $76186166c5249771$export$1188214e9d38144e = v; });
$parcel$export($76186166c5249771$exports, "seo", function () { return $76186166c5249771$export$7dc4b9367473a505; }, function (v) { return $76186166c5249771$export$7dc4b9367473a505 = v; });
$parcel$export($76186166c5249771$exports, "write", function () { return $76186166c5249771$export$68d8715fc104d294; }, function (v) { return $76186166c5249771$export$68d8715fc104d294 = v; });
$parcel$export($76186166c5249771$exports, "plan", function () { return $76186166c5249771$export$3c7172b0b56389d; }, function (v) { return $76186166c5249771$export$3c7172b0b56389d = v; });
$parcel$export($76186166c5249771$exports, "chart", function () { return $76186166c5249771$export$8fde8ebd684d5072; }, function (v) { return $76186166c5249771$export$8fde8ebd684d5072 = v; });
$parcel$export($76186166c5249771$exports, "google", function () { return $76186166c5249771$export$2d1fdedcfa4b711e; }, function (v) { return $76186166c5249771$export$2d1fdedcfa4b711e = v; });
$parcel$export($76186166c5249771$exports, "searchEngine", function () { return $76186166c5249771$export$bc784e6c5653beec; }, function (v) { return $76186166c5249771$export$bc784e6c5653beec = v; });
$parcel$export($76186166c5249771$exports, "funnel", function () { return $76186166c5249771$export$cd223ad0107da099; }, function (v) { return $76186166c5249771$export$cd223ad0107da099 = v; });
$parcel$export($76186166c5249771$exports, "autopilot", function () { return $76186166c5249771$export$5d910be2177c3c87; }, function (v) { return $76186166c5249771$export$5d910be2177c3c87 = v; });
$parcel$export($76186166c5249771$exports, "chartPurple", function () { return $76186166c5249771$export$b5c1237f4655e054; }, function (v) { return $76186166c5249771$export$b5c1237f4655e054 = v; });
$parcel$export($76186166c5249771$exports, "languages", function () { return $76186166c5249771$export$d0d68bb9ed2c643d; }, function (v) { return $76186166c5249771$export$d0d68bb9ed2c643d = v; });
$parcel$export($76186166c5249771$exports, "imageContainer", function () { return $76186166c5249771$export$63e82393dc8977bf; }, function (v) { return $76186166c5249771$export$63e82393dc8977bf = v; });
$parcel$export($76186166c5249771$exports, "image", function () { return $76186166c5249771$export$5c452ff88e35e47d; }, function (v) { return $76186166c5249771$export$5c452ff88e35e47d = v; });
$parcel$export($76186166c5249771$exports, "shadow", function () { return $76186166c5249771$export$b8972b998723d602; }, function (v) { return $76186166c5249771$export$b8972b998723d602 = v; });
$parcel$export($76186166c5249771$exports, "colorBlue", function () { return $76186166c5249771$export$4280a44aebc4cc67; }, function (v) { return $76186166c5249771$export$4280a44aebc4cc67 = v; });
$parcel$export($76186166c5249771$exports, "colorYellow", function () { return $76186166c5249771$export$54336073cc165189; }, function (v) { return $76186166c5249771$export$54336073cc165189 = v; });
$parcel$export($76186166c5249771$exports, "colorWhite", function () { return $76186166c5249771$export$e440a56bff5718e8; }, function (v) { return $76186166c5249771$export$e440a56bff5718e8 = v; });
$parcel$export($76186166c5249771$exports, "colorPurple", function () { return $76186166c5249771$export$e2ab8c1ee254ce8f; }, function (v) { return $76186166c5249771$export$e2ab8c1ee254ce8f = v; });
$parcel$export($76186166c5249771$exports, "shadowBottomCenter", function () { return $76186166c5249771$export$bd679f57ea2e4e2b; }, function (v) { return $76186166c5249771$export$bd679f57ea2e4e2b = v; });
$parcel$export($76186166c5249771$exports, "shadowLeftCenter", function () { return $76186166c5249771$export$aecbfdca6b8a6495; }, function (v) { return $76186166c5249771$export$aecbfdca6b8a6495 = v; });
$parcel$export($76186166c5249771$exports, "shadowNone", function () { return $76186166c5249771$export$14fae57729df0db; }, function (v) { return $76186166c5249771$export$14fae57729df0db = v; });
$parcel$export($76186166c5249771$exports, "shadowMid", function () { return $76186166c5249771$export$ded960129251095d; }, function (v) { return $76186166c5249771$export$ded960129251095d = v; });
$parcel$export($76186166c5249771$exports, "sizeLarge", function () { return $76186166c5249771$export$994c44911440ea2d; }, function (v) { return $76186166c5249771$export$994c44911440ea2d = v; });
$parcel$export($76186166c5249771$exports, "sizeLargeCenter", function () { return $76186166c5249771$export$fc5cf8c4e7d669f4; }, function (v) { return $76186166c5249771$export$fc5cf8c4e7d669f4 = v; });
$parcel$export($76186166c5249771$exports, "sizeMid", function () { return $76186166c5249771$export$3cf57bd17692eda2; }, function (v) { return $76186166c5249771$export$3cf57bd17692eda2 = v; });
$parcel$export($76186166c5249771$exports, "sizeMidColumn", function () { return $76186166c5249771$export$ae6e0e6826020bcd; }, function (v) { return $76186166c5249771$export$ae6e0e6826020bcd = v; });
var $76186166c5249771$export$6ef958818d7dbb11;
var $76186166c5249771$export$53f1d5ea8de3d7c;
var $76186166c5249771$export$c407db72103fecfa;
var $76186166c5249771$export$e4b2ac9215619f8d;
var $76186166c5249771$export$fb184b623420d9be;
var $76186166c5249771$export$93a5057b3118dcd;
var $76186166c5249771$export$35d34bc0ed591a92;
var $76186166c5249771$export$60b3551206497142;
var $76186166c5249771$export$6f093cfa640b7166;
var $76186166c5249771$export$f38c853ae54ed474;
var $76186166c5249771$export$2516fe6c625b33a;
var $76186166c5249771$export$c142f6a77c53147e;
var $76186166c5249771$export$6d59db4903f20f7d;
var $76186166c5249771$export$acf4eaf431084f78;
var $76186166c5249771$export$1ca1ec8b29a4ce27;
var $76186166c5249771$export$f90719f89646befa;
var $76186166c5249771$export$28ee1007e174a2a6;
var $76186166c5249771$export$7a5d5c156e7dc406;
var $76186166c5249771$export$1188214e9d38144e;
var $76186166c5249771$export$7dc4b9367473a505;
var $76186166c5249771$export$68d8715fc104d294;
var $76186166c5249771$export$3c7172b0b56389d;
var $76186166c5249771$export$8fde8ebd684d5072;
var $76186166c5249771$export$2d1fdedcfa4b711e;
var $76186166c5249771$export$bc784e6c5653beec;
var $76186166c5249771$export$cd223ad0107da099;
var $76186166c5249771$export$5d910be2177c3c87;
var $76186166c5249771$export$b5c1237f4655e054;
var $76186166c5249771$export$d0d68bb9ed2c643d;
var $76186166c5249771$export$63e82393dc8977bf;
var $76186166c5249771$export$5c452ff88e35e47d;
var $76186166c5249771$export$b8972b998723d602;
var $76186166c5249771$export$4280a44aebc4cc67;
var $76186166c5249771$export$54336073cc165189;
var $76186166c5249771$export$e440a56bff5718e8;
var $76186166c5249771$export$e2ab8c1ee254ce8f;
var $76186166c5249771$export$bd679f57ea2e4e2b;
var $76186166c5249771$export$aecbfdca6b8a6495;
var $76186166c5249771$export$14fae57729df0db;
var $76186166c5249771$export$ded960129251095d;
var $76186166c5249771$export$994c44911440ea2d;
var $76186166c5249771$export$fc5cf8c4e7d669f4;
var $76186166c5249771$export$3cf57bd17692eda2;
var $76186166c5249771$export$ae6e0e6826020bcd;
$76186166c5249771$export$6ef958818d7dbb11 = "qKCUJ";
$76186166c5249771$export$53f1d5ea8de3d7c = "WPmMr";
$76186166c5249771$export$c407db72103fecfa = "C8CXK";
$76186166c5249771$export$e4b2ac9215619f8d = "dWs1Q";
$76186166c5249771$export$fb184b623420d9be = "b-s4o";
$76186166c5249771$export$93a5057b3118dcd = "gTIC5";
$76186166c5249771$export$35d34bc0ed591a92 = "u-01b";
$76186166c5249771$export$60b3551206497142 = "tyMh-";
$76186166c5249771$export$6f093cfa640b7166 = "T-c5i";
$76186166c5249771$export$f38c853ae54ed474 = "U-iGy";
$76186166c5249771$export$2516fe6c625b33a = "BF8rl";
$76186166c5249771$export$c142f6a77c53147e = "wQjPy";
$76186166c5249771$export$6d59db4903f20f7d = "L-nqz";
$76186166c5249771$export$acf4eaf431084f78 = "JJUy6";
$76186166c5249771$export$1ca1ec8b29a4ce27 = "ff7Pk";
$76186166c5249771$export$f90719f89646befa = "_7bZ0S";
$76186166c5249771$export$28ee1007e174a2a6 = "lv8jF";
$76186166c5249771$export$7a5d5c156e7dc406 = "S7SPX";
$76186166c5249771$export$1188214e9d38144e = "YT-pf";
$76186166c5249771$export$7dc4b9367473a505 = "Cliu1";
$76186166c5249771$export$68d8715fc104d294 = "PYhl0";
$76186166c5249771$export$3c7172b0b56389d = "CFik-";
$76186166c5249771$export$8fde8ebd684d5072 = "pLCxC";
$76186166c5249771$export$2d1fdedcfa4b711e = "rSty3";
$76186166c5249771$export$bc784e6c5653beec = "Mo3sE";
$76186166c5249771$export$cd223ad0107da099 = "MGs8X";
$76186166c5249771$export$5d910be2177c3c87 = "MsCft";
$76186166c5249771$export$b5c1237f4655e054 = "-oQhP";
$76186166c5249771$export$d0d68bb9ed2c643d = "IpCFF";
$76186166c5249771$export$63e82393dc8977bf = "pJg8E";
$76186166c5249771$export$5c452ff88e35e47d = "IEky7";
$76186166c5249771$export$b8972b998723d602 = "D-XNO";
$76186166c5249771$export$4280a44aebc4cc67 = "KpKma";
$76186166c5249771$export$54336073cc165189 = "_0oATR";
$76186166c5249771$export$e440a56bff5718e8 = "_0EH4V";
$76186166c5249771$export$e2ab8c1ee254ce8f = "iq-lJ";
$76186166c5249771$export$bd679f57ea2e4e2b = "WTtBr";
$76186166c5249771$export$aecbfdca6b8a6495 = "RLhYf";
$76186166c5249771$export$14fae57729df0db = "NVEv7";
$76186166c5249771$export$ded960129251095d = "S-jOx";
$76186166c5249771$export$994c44911440ea2d = "qUy8L";
$76186166c5249771$export$fc5cf8c4e7d669f4 = "hMPR6";
$76186166c5249771$export$3cf57bd17692eda2 = "vdbJ-";
$76186166c5249771$export$ae6e0e6826020bcd = "Qn-3O";


class $d875ed951709d967$export$9cf1ff22c077cd0b extends (0, $fsnB5.Component) {
    commit() {
        this.grid.lines.forEach((value)=>this.renderLine(value.entries));
        super.commit();
    }
    renderLine(entries) {
        let line = this.append(`<div class="${$76186166c5249771$exports.line}"></div>`);
        entries.forEach((entry)=>{
            //language=HTML
            let entryContainer = line.append(`
                <div class="${$76186166c5249771$exports.entry} ${$76186166c5249771$exports[entry.color]} ${$76186166c5249771$exports[entry.size]} ${$76186166c5249771$exports[entry.shadowPosition]}">
                    <div class="${$76186166c5249771$exports.names}">
                        <div class="${$76186166c5249771$exports.title} ${entry.step ? $76186166c5249771$exports.hasStep : ``}">
                            ${entry.step ? `<div class="${$76186166c5249771$exports.step}"><div class="${$76186166c5249771$exports.stepShadow}"></div><div class="${$76186166c5249771$exports.text}">${entry.step}</div></div>` : ``}
                            ${entry.ai ? `<div class="${$76186166c5249771$exports.ai}"><div class="${$76186166c5249771$exports.aiShadow}"></div><div class="${$76186166c5249771$exports.aiIcon}"></div></div>` : ``}
                            ${entry.title}
                        </div>
                        <div class="${$76186166c5249771$exports.description}">
                            ${entry.description}
                        </div>
                    </div>

                    ${entry.type == "image" ? `<div class="${$76186166c5249771$exports.imageContainer}"><img class="${$76186166c5249771$exports.image}" src="${entry.image}" alt="presentation"/></div>` : ``}
                    ${entry.type == "icon" ? `<div class="${$76186166c5249771$exports.iconContainer}"><div class="${$76186166c5249771$exports.icon} ${$76186166c5249771$exports[entry.icon]}"></div></div>` : ``}
                    <div class="${$76186166c5249771$exports.shadow}"></div>
                </div>
            `);
            let imageContainer = entryContainer.el($76186166c5249771$exports.imageContainer);
            let iconContainer = entryContainer.el($76186166c5249771$exports.iconContainer);
            entryContainer.isBelowScroll((isVisible)=>{
                if (!isVisible) {
                    if (!imageContainer.isNull()) imageContainer.translate({
                        opacity: 0,
                        translateY: 60,
                        delay: 200
                    });
                    if (!iconContainer.isNull()) iconContainer.translate({
                        opacity: 0,
                        translateY: 60,
                        delay: 200
                    });
                } else {
                    if (!imageContainer.isNull()) imageContainer.translate({
                        opacity: 1,
                        translateY: 0,
                        delay: 250
                    });
                    if (!iconContainer.isNull()) iconContainer.translate({
                        opacity: 1,
                        translateY: 0,
                        delay: 250
                    });
                }
            }, true);
        });
    }
    constructor(grid){
        super();
        this.grid = grid;
        //language=HTML
        this.template = `
            <div class="${$76186166c5249771$exports.componentWebsiteBlackGrid}"></div>`;
    }
}


class $477750546aba331a$export$ab765ed4f8df7556 extends (0, $fsnB5.Component) {
    constructor(divide){
        super();
        //language=HTML
        this.template = `
            <div class="${$4cdf03072c0df866$export$b3ff231557e20c05}">
                <div class="${$4cdf03072c0df866$export$71ef6e19fae6c840}">
                    <div class="${$4cdf03072c0df866$export$f38c853ae54ed474}">
                        <div class="${$4cdf03072c0df866$export$2cc7ff91bcacba5e}"></div>
                        <div class="${$4cdf03072c0df866$export$1ca1ec8b29a4ce27}"></div>
                    </div>
                    <div class="${$4cdf03072c0df866$export$6f093cfa640b7166}">
                        Que fait Sedestral AI ?
                    </div>
                </div>
                <div class="${$4cdf03072c0df866$export$6d59db4903f20f7d}">
                    Sedestral AI s'occupe d'analyser vos concurrents, de mener les recherches et d'effectuer toutes les
                    t\xe2ches fastidieuses pour vous.
                </div>
                <div class="${$4cdf03072c0df866$export$53f1d5ea8de3d7c}">
                    <div class="${$4cdf03072c0df866$export$b8972b998723d602}"></div>
                    <div class="${$4cdf03072c0df866$export$a7db06668cad9adb}"></div>
                </div>
                <div class="${$4cdf03072c0df866$export$324fbeb68ccbc72b}">
                    Les t\xe2ches se divisent en plusieurs \xe9tapes
                </div>
                <div>
                    ${this.draw(new (0, $d875ed951709d967$export$9cf1ff22c077cd0b)(divide.grid))}
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $e543ccd3653de8da$export$7766bce351faa67c;
var $e543ccd3653de8da$export$71ef6e19fae6c840;
var $e543ccd3653de8da$export$f38c853ae54ed474;
var $e543ccd3653de8da$export$2cc7ff91bcacba5e;
var $e543ccd3653de8da$export$1ca1ec8b29a4ce27;
var $e543ccd3653de8da$export$6f093cfa640b7166;
var $e543ccd3653de8da$export$1f6c9cc012ebacae;
var $e543ccd3653de8da$export$98e628dec113755e;
var $e543ccd3653de8da$export$e13cce2a2d16a9d4;
var $e543ccd3653de8da$export$2aa0182783e7e9de;
var $e543ccd3653de8da$export$32744b5b3bba4764;
var $e543ccd3653de8da$export$6d59db4903f20f7d;
var $e543ccd3653de8da$export$53f1d5ea8de3d7c;
var $e543ccd3653de8da$export$853d2c6a78e32826;
var $e543ccd3653de8da$export$3e523c77c1f23f8c;
var $e543ccd3653de8da$export$6c6e679936662ba2;
var $e543ccd3653de8da$export$9ba38043771de2c2;
var $e543ccd3653de8da$export$c407db72103fecfa;
var $e543ccd3653de8da$export$fb184b623420d9be;
var $e543ccd3653de8da$export$8fde8ebd684d5072;
var $e543ccd3653de8da$export$92840075cfbc6612;
var $e543ccd3653de8da$export$8fa4e5556fd77a60;
var $e543ccd3653de8da$export$2ab9a8f9f1186f14;
var $e543ccd3653de8da$export$d927737047eb3867;
$e543ccd3653de8da$export$7766bce351faa67c = "_7pnq0";
$e543ccd3653de8da$export$71ef6e19fae6c840 = "USf1h";
$e543ccd3653de8da$export$f38c853ae54ed474 = "_0JAhl";
$e543ccd3653de8da$export$2cc7ff91bcacba5e = "CaPpf";
$e543ccd3653de8da$export$1ca1ec8b29a4ce27 = "OIF4j";
$e543ccd3653de8da$export$6f093cfa640b7166 = "jK8xj";
$e543ccd3653de8da$export$1f6c9cc012ebacae = "_0e7rD";
$e543ccd3653de8da$export$98e628dec113755e = "jNxQi";
$e543ccd3653de8da$export$e13cce2a2d16a9d4 = "EKOK2";
$e543ccd3653de8da$export$2aa0182783e7e9de = "yzn1U";
$e543ccd3653de8da$export$32744b5b3bba4764 = "h-h3d";
$e543ccd3653de8da$export$6d59db4903f20f7d = "tApxT";
$e543ccd3653de8da$export$53f1d5ea8de3d7c = "_339gc";
$e543ccd3653de8da$export$853d2c6a78e32826 = "Wjq5j";
$e543ccd3653de8da$export$3e523c77c1f23f8c = "PR59F";
$e543ccd3653de8da$export$6c6e679936662ba2 = "GtLcl";
$e543ccd3653de8da$export$9ba38043771de2c2 = "tfe0b";
$e543ccd3653de8da$export$c407db72103fecfa = "Ss-uZ";
$e543ccd3653de8da$export$fb184b623420d9be = "M1iSK";
$e543ccd3653de8da$export$8fde8ebd684d5072 = "u-1-W";
$e543ccd3653de8da$export$92840075cfbc6612 = "UXbZk";
$e543ccd3653de8da$export$8fa4e5556fd77a60 = "OFjmr";
$e543ccd3653de8da$export$2ab9a8f9f1186f14 = "EJoIw";
$e543ccd3653de8da$export$d927737047eb3867 = "lHulI";



var $5FliW = parcelRequire("5FliW");
class $e050426328846cb5$export$7f8c4dbd337fa85b extends (0, $fsnB5.Component) {
    commit() {
        this.els($e543ccd3653de8da$export$92840075cfbc6612).forEach((progressionComponent)=>{
            let width = parseInt(progressionComponent.getHTMLElement().style.width);
            this.el($e543ccd3653de8da$export$9ba38043771de2c2).isBelowScroll((isVisible)=>{
                if (isVisible) progressionComponent.translate({
                    widthPercent: width,
                    delay: 600
                });
                else progressionComponent.translate({
                    widthPercent: 0,
                    delay: 600
                });
            }, true);
        });
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$e543ccd3653de8da$export$7766bce351faa67c}">
                <div class="${$e543ccd3653de8da$export$71ef6e19fae6c840}">
                    <div class="${$e543ccd3653de8da$export$f38c853ae54ed474}">
                        <div class="${$e543ccd3653de8da$export$2cc7ff91bcacba5e}"></div>
                        <div class="${$e543ccd3653de8da$export$1ca1ec8b29a4ce27}"></div>
                    </div>
                    <div class="${$e543ccd3653de8da$export$6f093cfa640b7166}">
                        ${(0, $5FliW.Resources).t("words.sedestralAiIntro")}
                    </div>
                </div>
                <div class="${$e543ccd3653de8da$export$1f6c9cc012ebacae}">
                    <div class="${$e543ccd3653de8da$export$98e628dec113755e} ${$e543ccd3653de8da$export$e13cce2a2d16a9d4}">
                        <div class="${$e543ccd3653de8da$export$32744b5b3bba4764}">
                            <div class="${$e543ccd3653de8da$export$2cc7ff91bcacba5e}"></div>
                            <div class="${$e543ccd3653de8da$export$6f093cfa640b7166}">
                                50+
                            </div>
                        </div>
                        <div class="${$e543ccd3653de8da$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.metricsUsed")}
                        </div>
                    </div>
                    <div class="${$e543ccd3653de8da$export$98e628dec113755e} ${$e543ccd3653de8da$export$2aa0182783e7e9de}">
                        <div class="${$e543ccd3653de8da$export$32744b5b3bba4764}">
                            <div class="${$e543ccd3653de8da$export$2cc7ff91bcacba5e}"></div>
                            <div class="${$e543ccd3653de8da$export$6f093cfa640b7166}">
                                350 000
                            </div>
                        </div>
                        <div class="${$e543ccd3653de8da$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.wordsAnalyzed")}
                        </div>
                        <div class="${$e543ccd3653de8da$export$53f1d5ea8de3d7c}"></div>
                    </div>
                </div>
                <div class="${$e543ccd3653de8da$export$853d2c6a78e32826}">
                    <div class="${$e543ccd3653de8da$export$3e523c77c1f23f8c}"></div>
                    <div class="${$e543ccd3653de8da$export$2cc7ff91bcacba5e}"></div>
                </div>
                <div class="${$e543ccd3653de8da$export$6c6e679936662ba2}">
                    ${(0, $5FliW.Resources).t("words.sedestralAiExploration")}
                </div>
                <div class="${$e543ccd3653de8da$export$9ba38043771de2c2}">
                    <div class="${$e543ccd3653de8da$export$c407db72103fecfa}">
                        <div class="${$e543ccd3653de8da$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.sedestralAnalysis")}
                        </div>
                        <div class="${$e543ccd3653de8da$export$8fde8ebd684d5072} ${$e543ccd3653de8da$export$2aa0182783e7e9de}">
                            <div class="${$e543ccd3653de8da$export$d927737047eb3867}">
                                <div style="width: 100%;" class="${$e543ccd3653de8da$export$92840075cfbc6612}"></div>
                            </div>
                            <div class="${$e543ccd3653de8da$export$2ab9a8f9f1186f14}">
                                350K
                            </div>
                        </div>
                    </div>
                    <div class="${$e543ccd3653de8da$export$c407db72103fecfa}">
                        <div class="${$e543ccd3653de8da$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.firstFourHarryPotter")}
                        </div>
                        <div class="${$e543ccd3653de8da$export$8fde8ebd684d5072} ${$e543ccd3653de8da$export$8fa4e5556fd77a60}">
                            <div class="${$e543ccd3653de8da$export$d927737047eb3867}">
                                <div style="width: 90%;" class="${$e543ccd3653de8da$export$92840075cfbc6612}"></div>
                            </div>
                            <div class="${$e543ccd3653de8da$export$2ab9a8f9f1186f14}">
                                327K
                            </div>
                        </div>
                    </div>
                    <div class="${$e543ccd3653de8da$export$c407db72103fecfa}">
                        <div class="${$e543ccd3653de8da$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.nineStarWarsFilms")}
                        </div>
                        <div class="${$e543ccd3653de8da$export$8fde8ebd684d5072} ${$e543ccd3653de8da$export$8fa4e5556fd77a60}">
                            <div class="${$e543ccd3653de8da$export$d927737047eb3867}">
                                <div style="width: 70%;" class="${$e543ccd3653de8da$export$92840075cfbc6612}"></div>
                            </div>
                            <div class="${$e543ccd3653de8da$export$2ab9a8f9f1186f14}">
                                267K
                            </div>
                        </div>
                    </div>
                    <div class="${$e543ccd3653de8da$export$c407db72103fecfa}">
                        <div class="${$e543ccd3653de8da$export$fb184b623420d9be}">
                            ${(0, $5FliW.Resources).t("words.lotrAndHobbit")}
                        </div>
                        <div class="${$e543ccd3653de8da$export$8fde8ebd684d5072} ${$e543ccd3653de8da$export$8fa4e5556fd77a60}">
                            <div class="${$e543ccd3653de8da$export$d927737047eb3867}">
                                <div style="width: 50%;" class="${$e543ccd3653de8da$export$92840075cfbc6612}"></div>
                            </div>
                            <div class="${$e543ccd3653de8da$export$2ab9a8f9f1186f14}">
                                192K
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $400af0e3737c4f8c$export$ba553c79a28cb56e extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            title: (0, $5FliW.Resources).t("words.sedestralTrafficGeneration"),
            description: (0, $5FliW.Resources).t("words.sedestralContentGenerationDescription"),
            people: false,
            center: true
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $5FliW.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $5FliW.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $5FliW.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e6a50373d11f2ef1$export$67fc1824eabdc07e)({
            text: (0, $5FliW.Resources).t("words.fiveMinuteArticle"),
            size: "sizeBig"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $477750546aba331a$export$ab765ed4f8df7556)({
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                step: 1,
                                title: (0, $5FliW.Resources).t("words.googleResearch"),
                                description: (0, $5FliW.Resources).t("words.googleResearchDescription"),
                                type: "icon",
                                icon: "google",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            },
                            {
                                step: 2,
                                title: (0, $5FliW.Resources).t("words.detailedSiteAnalysis"),
                                description: (0, $5FliW.Resources).t("words.detailedSiteAnalysisDescription"),
                                type: "icon",
                                icon: "chart",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 3,
                                title: (0, $5FliW.Resources).t("words.createPlanProvideGuidelines"),
                                description: (0, $5FliW.Resources).t("words.createPlanProvideGuidelinesDescription"),
                                type: "icon",
                                icon: "plan",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                step: 4,
                                title: (0, $5FliW.Resources).t("words.generateContentFromMetrics"),
                                description: (0, $5FliW.Resources).t("words.generateContentFromMetricsDescription"),
                                type: "icon",
                                icon: "write",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 5,
                                title: (0, $5FliW.Resources).t("words.applySeoPractices"),
                                description: (0, $5FliW.Resources).t("words.applySeoPracticesDescription"),
                                type: "icon",
                                icon: "seo",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                step: 6,
                                title: (0, $5FliW.Resources).t("words.searchSuitableImages"),
                                description: (0, $5FliW.Resources).t("words.searchSuitableImagesDescription"),
                                type: "icon",
                                icon: "picture",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                step: 7,
                                title: (0, $5FliW.Resources).t("words.enhanceAuthenticity"),
                                description: (0, $5FliW.Resources).t("words.enhanceAuthenticityDescription"),
                                type: "icon",
                                icon: "unique",
                                size: "sizeMid",
                                color: "colorWhite",
                                shadowPosition: "shadowNone"
                            },
                            {
                                step: 8,
                                title: (0, $5FliW.Resources).t("words.readyContentIntent"),
                                description: (0, $5FliW.Resources).t("words.readyContentIntentDescription"),
                                type: "icon",
                                icon: "ready",
                                size: "sizeMid",
                                color: "colorYellow",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.nativeIntegration"),
                                description: (0, $5FliW.Resources).t("words.nativeIntegrationDescription"),
                                type: "icon",
                                icon: "funnel",
                                size: "sizeLargeCenter",
                                color: "colorPurple",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e050426328846cb5$export$7f8c4dbd337fa85b)())}
                    </div>
                </div>
            </div>
        `;
    }
}


class $9e0dc5aa3878b0a0$export$aa5b5f3c49dad377 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $400af0e3737c4f8c$export$ba553c79a28cb56e)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("ai");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");




var $5FliW = parcelRequire("5FliW");





class $efb74f2ea2bb8b03$export$18552b4bb0fbada3 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            title: (0, $5FliW.Resources).t("words.automateBlogManagement"),
            description: (0, $5FliW.Resources).t("words.aiHandlesEverything"),
            people: false,
            center: true
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.autopilotConfiguration"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.autopilot"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-video-c.mp4"),
                    duration: 7000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $2202559933343005$export$d8eb6fbe0ee5dec2)({
            title: (0, $5FliW.Resources).t("words.howItWorks"),
            columns: [
                {
                    icon: "articleAi",
                    name: (0, $5FliW.Resources).t("words.intelligentCreation"),
                    text: (0, $5FliW.Resources).t("words.aiThinksAndWrites")
                },
                {
                    icon: "letter",
                    name: (0, $5FliW.Resources).t("words.personalizedDelivery"),
                    text: (0, $5FliW.Resources).t("words.chooseDelivery")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $f3629506c47fec9f$export$1965e7302a1f5007)({
            title: (0, $5FliW.Resources).t("words.whyUseAutopilot"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-time",
                    title: (0, $5FliW.Resources).t("words.savePreciousTime"),
                    subtitle: (0, $5FliW.Resources).t("words.aiHandlesResearchAndWriting")
                },
                {
                    icon: "black-chart",
                    title: (0, $5FliW.Resources).t("words.boostVisibility"),
                    subtitle: (0, $5FliW.Resources).t("words.maximizeSEOPositioning")
                },
                {
                    icon: "black-lineal-good",
                    title: (0, $5FliW.Resources).t("words.ensureConstantPublication"),
                    subtitle: (0, $5FliW.Resources).t("words.freshContentAlignedWithTrends")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        <div class="${$82a406569704d05c$export$2217aca24454a969}">
                        <div class="${$82a406569704d05c$export$f7c42a96c638d4dc}">
                            <div class="${$82a406569704d05c$export$79ffe56a765070d2}">
                                <img class="${$82a406569704d05c$export$5c452ff88e35e47d}" src="${(0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.webp")}"
                                     alt="styleCloning" draggable="false"
                                     width="380" height="347.51"
                                />
                            </div>
                            <div class="${$82a406569704d05c$export$eabcd2c8791e7bf4}">
                                <h2 class="${$82a406569704d05c$export$fb184b623420d9be}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleTitle")}
                                </h2>
                                <p class="${$82a406569704d05c$export$c96745152eb2740f}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleText")}
                                </p>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            "questions": [
                {
                    "question": (0, $5FliW.Resources).t("words.howAiGeneratesIdeas"),
                    "response": (0, $5FliW.Resources).t("words.aiAnalyzesIndustry")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.areContentsSEOOptimized"),
                    "response": (0, $5FliW.Resources).t("words.articlesSEOOptimized")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.canChooseArticleFrequency"),
                    "response": (0, $5FliW.Resources).t("words.controlArticleFrequency")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.howArecContentsDelivered"),
                    "response": (0, $5FliW.Resources).t("words.chooseArticleDelivery")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.canModifyContentsBeforePublication"),
                    "response": (0, $5FliW.Resources).t("words.reviseAndPersonalizeArticles")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.canAiAdaptToDifferentContentTypes"),
                    "response": (0, $5FliW.Resources).t("words.aiAdaptsToVariousContentTypes")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.howAiUnderstandsBusiness"),
                    "response": (0, $5FliW.Resources).t("words.provideInfoForAiToAdapt")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.doesAiMaintainBrandTone"),
                    "response": (0, $5FliW.Resources).t("words.aiMaintainsBrandTone")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.whoCanUseAutopilot"),
                    "response": (0, $5FliW.Resources).t("words.autopilotForAllBusinesses")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.canModifyOrStopServiceAnytime"),
                    "response": (0, $5FliW.Resources).t("words.freedomToModifyOrStopService")
                }
            ]
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $9d3dd967f973b161$export$c87593f158eae05c extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $efb74f2ea2bb8b03$export$18552b4bb0fbada3)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("autopilot");
        this.status.online = undefined;
    }
}




var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");






class $a41617ed68dcdf59$export$402470387581fde2 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.writingStyleReplication"),
            description: (0, $5FliW.Resources).t("words.styleCloningFeatureDescription"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h.webp"),
            color: "white",
            size: "tall",
            border: "border",
            shadow: "shadow"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $2202559933343005$export$d8eb6fbe0ee5dec2)({
            title: (0, $5FliW.Resources).t("words.whyAdoptStyleCloning"),
            columns: [
                {
                    icon: "handshake",
                    name: (0, $5FliW.Resources).t("words.brandConsistency"),
                    text: (0, $5FliW.Resources).t("words.brandConsistencyDescription")
                },
                {
                    icon: "seo",
                    name: (0, $5FliW.Resources).t("words.seoOptimization"),
                    text: (0, $5FliW.Resources).t("words.seoOptimizationDescription")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            "questions": [
                {
                    "question": (0, $5FliW.Resources).t("words.howDoesStyleCloningWork"),
                    "response": (0, $5FliW.Resources).t("words.styleCloningWorkDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.styleCloningAccuracy"),
                    "response": (0, $5FliW.Resources).t("words.styleCloningAccuracyDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.canEditGeneratedArticles"),
                    "response": (0, $5FliW.Resources).t("words.canEditGeneratedArticlesDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.adaptableToDifferentContentTypes"),
                    "response": (0, $5FliW.Resources).t("words.adaptableToDifferentContentTypesDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.seoOptimizedArticles"),
                    "response": (0, $5FliW.Resources).t("words.seoOptimizedArticlesDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.styleCloningTime"),
                    "response": (0, $5FliW.Resources).t("words.styleCloningTimeDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.changeWritingStyle"),
                    "response": (0, $5FliW.Resources).t("words.changeWritingStyleDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.adaptableToAllIndustries"),
                    "response": (0, $5FliW.Resources).t("words.adaptableToAllIndustriesDescription")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.multipleAuthors"),
                    "response": (0, $5FliW.Resources).t("words.multipleAuthorsDescription")
                }
            ]
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $0f5b9a40666e36a2$export$441a0cd60fee079c extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $a41617ed68dcdf59$export$402470387581fde2)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("writingStyle");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");





var $5FliW = parcelRequire("5FliW");






class $907be2818bbfb831$export$1739ae649e596444 extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            center: true,
            title: (0, $5FliW.Resources).t("words.wixSeoModuleTitle"),
            description: (0, $5FliW.Resources).t("words.wixSeoModuleDescription"),
            partnerIcon: "wix",
            secondButton: false,
            firstButtonLink: "https://sedestral.com/connect-wix"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $5FliW.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $5FliW.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $5FliW.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $f3629506c47fec9f$export$1965e7302a1f5007)({
            title: (0, $5FliW.Resources).t("words.searchEngineContent"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-read",
                    title: (0, $5FliW.Resources).t("words.fleschReadingEase"),
                    subtitle: (0, $5FliW.Resources).t("words.fleschReadingEaseSubtitle")
                },
                {
                    icon: "black-lineal-keywords",
                    title: (0, $5FliW.Resources).t("words.keywords"),
                    subtitle: (0, $5FliW.Resources).t("words.keywordsSubtitle")
                },
                {
                    icon: "black-lineal-words",
                    title: (0, $5FliW.Resources).t("words.transitionWords"),
                    subtitle: (0, $5FliW.Resources).t("words.transitionWordsSubtitle")
                },
                {
                    icon: "black-lineal-code",
                    title: (0, $5FliW.Resources).t("words.htmlTagging"),
                    subtitle: (0, $5FliW.Resources).t("words.htmlTaggingSubtitle")
                },
                {
                    icon: "black-lineal-voice",
                    title: (0, $5FliW.Resources).t("words.passiveVoice"),
                    subtitle: (0, $5FliW.Resources).t("words.passiveVoiceSubtitle")
                },
                {
                    icon: "black-lineal-seo",
                    title: (0, $5FliW.Resources).t("words.seoTools"),
                    subtitle: (0, $5FliW.Resources).t("words.seoToolsSubtitle")
                }
            ]
        }))}
                    </div>
                    <div class="${$82a406569704d05c$export$2217aca24454a969}">
                        <div class="${$82a406569704d05c$export$f7c42a96c638d4dc}">
                            <div class="${$82a406569704d05c$export$79ffe56a765070d2}">
                                <img class="${$82a406569704d05c$export$5c452ff88e35e47d}" src="${(0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.webp")}"
                                     alt="${(0, $5FliW.Resources).t("words.styleCloning")}" draggable="false"
                                     width="380" height="347.51"
                                />
                            </div>
                            <div class="${$82a406569704d05c$export$eabcd2c8791e7bf4}">
                                <h2 class="${$82a406569704d05c$export$fb184b623420d9be}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleTitle")}
                                </h2>
                                <p class="${$82a406569704d05c$export$c96745152eb2740f}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleText")}
                                </p>
                                <img class="${$82a406569704d05c$export$53f1d5ea8de3d7c}" src="${(0, $072d9015278afa7d$export$a27e371a094e4e50).illus("separator-line.svg")}"
                                     alt="${(0, $5FliW.Resources).t("words.separationLine")}" draggable="false"/>
                            </div>
                        </div>
                        <div class="${$82a406569704d05c$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.explainContextToAI"),
            description: (0, $5FliW.Resources).t("words.contextFeatureText"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.webp"),
            color: "black",
            size: "medium",
            border: "border"
        }))}
                        </div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $5a5a74645f4a26c3$export$21cf7e1029971b9d)((0, $5FliW.Resources).t("words.howItWorks"), [
            {
                icon: "draft",
                title: (0, $5FliW.Resources).t("words.instructionsTitle"),
                desc: (0, $5FliW.Resources).t("words.instructionsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $5FliW.Resources).t("words.proposalsTitle"),
                desc: (0, $5FliW.Resources).t("words.proposalsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $5FliW.Resources).t("words.planTitle"),
                desc: (0, $5FliW.Resources).t("words.planDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $5FliW.Resources).t("words.writingTitle"),
                desc: (0, $5FliW.Resources).t("words.writingDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ]))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            "questions": [
                {
                    "question": (0, $5FliW.Resources).t("words.doesGooglePenalizeAiContent"),
                    "response": (0, $5FliW.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.seoOptimizationQuestion"),
                    "response": (0, $5FliW.Resources).t("words.seoOptimizationResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.platformConnectionQuestion"),
                    "response": (0, $5FliW.Resources).t("words.platformConnectionResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.articleFormattingQuestion"),
                    "response": (0, $5FliW.Resources).t("words.articleFormattingResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.smartBlogAdvantagesQuestion"),
                    "response": (0, $5FliW.Resources).t("words.smartBlogAdvantagesResponse")
                }
            ]
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $3ef160c9274a1d34$export$a58278a45a3d1e00 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $907be2818bbfb831$export$1739ae649e596444)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("wix");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");




var $5FliW = parcelRequire("5FliW");







var $fsnB5 = parcelRequire("fsnB5");
var $028f01eb314ab13a$exports = {};

$parcel$export($028f01eb314ab13a$exports, "componentWebsiteBlackFlow", function () { return $028f01eb314ab13a$export$bd457616a7188bb8; }, function (v) { return $028f01eb314ab13a$export$bd457616a7188bb8 = v; });
$parcel$export($028f01eb314ab13a$exports, "title", function () { return $028f01eb314ab13a$export$fb184b623420d9be; }, function (v) { return $028f01eb314ab13a$export$fb184b623420d9be = v; });
$parcel$export($028f01eb314ab13a$exports, "bigTitle", function () { return $028f01eb314ab13a$export$b2b3286365e789d9; }, function (v) { return $028f01eb314ab13a$export$b2b3286365e789d9 = v; });
$parcel$export($028f01eb314ab13a$exports, "contents", function () { return $028f01eb314ab13a$export$fd59df041b888442; }, function (v) { return $028f01eb314ab13a$export$fd59df041b888442 = v; });
$parcel$export($028f01eb314ab13a$exports, "imageContainer", function () { return $028f01eb314ab13a$export$63e82393dc8977bf; }, function (v) { return $028f01eb314ab13a$export$63e82393dc8977bf = v; });
$parcel$export($028f01eb314ab13a$exports, "image", function () { return $028f01eb314ab13a$export$5c452ff88e35e47d; }, function (v) { return $028f01eb314ab13a$export$5c452ff88e35e47d = v; });
$parcel$export($028f01eb314ab13a$exports, "imgShadow", function () { return $028f01eb314ab13a$export$7d74a5d084cc5a23; }, function (v) { return $028f01eb314ab13a$export$7d74a5d084cc5a23 = v; });
$parcel$export($028f01eb314ab13a$exports, "texts", function () { return $028f01eb314ab13a$export$29f9f81de5c56283; }, function (v) { return $028f01eb314ab13a$export$29f9f81de5c56283 = v; });
$parcel$export($028f01eb314ab13a$exports, "textCollapse", function () { return $028f01eb314ab13a$export$d88b746f6a4665c4; }, function (v) { return $028f01eb314ab13a$export$d88b746f6a4665c4 = v; });
$parcel$export($028f01eb314ab13a$exports, "entry", function () { return $028f01eb314ab13a$export$c407db72103fecfa; }, function (v) { return $028f01eb314ab13a$export$c407db72103fecfa = v; });
$parcel$export($028f01eb314ab13a$exports, "canCollapse", function () { return $028f01eb314ab13a$export$6cefeda42b08f11c; }, function (v) { return $028f01eb314ab13a$export$6cefeda42b08f11c = v; });
$parcel$export($028f01eb314ab13a$exports, "name", function () { return $028f01eb314ab13a$export$a8ff84c12d48cfa6; }, function (v) { return $028f01eb314ab13a$export$a8ff84c12d48cfa6 = v; });
$parcel$export($028f01eb314ab13a$exports, "arrow", function () { return $028f01eb314ab13a$export$f2120bbfa5450bd2; }, function (v) { return $028f01eb314ab13a$export$f2120bbfa5450bd2 = v; });
$parcel$export($028f01eb314ab13a$exports, "collapsed", function () { return $028f01eb314ab13a$export$27c57cc52d388509; }, function (v) { return $028f01eb314ab13a$export$27c57cc52d388509 = v; });
$parcel$export($028f01eb314ab13a$exports, "description", function () { return $028f01eb314ab13a$export$6d59db4903f20f7d; }, function (v) { return $028f01eb314ab13a$export$6d59db4903f20f7d = v; });
$parcel$export($028f01eb314ab13a$exports, "nameContainer", function () { return $028f01eb314ab13a$export$3b9d909fcd39d8ae; }, function (v) { return $028f01eb314ab13a$export$3b9d909fcd39d8ae = v; });
$parcel$export($028f01eb314ab13a$exports, "icon", function () { return $028f01eb314ab13a$export$1ca1ec8b29a4ce27; }, function (v) { return $028f01eb314ab13a$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($028f01eb314ab13a$exports, "aiWrite", function () { return $028f01eb314ab13a$export$c79b3a2d88454829; }, function (v) { return $028f01eb314ab13a$export$c79b3a2d88454829 = v; });
$parcel$export($028f01eb314ab13a$exports, "aiStars", function () { return $028f01eb314ab13a$export$12258f938f4857fd; }, function (v) { return $028f01eb314ab13a$export$12258f938f4857fd = v; });
$parcel$export($028f01eb314ab13a$exports, "colorPurple", function () { return $028f01eb314ab13a$export$e2ab8c1ee254ce8f; }, function (v) { return $028f01eb314ab13a$export$e2ab8c1ee254ce8f = v; });
var $028f01eb314ab13a$export$bd457616a7188bb8;
var $028f01eb314ab13a$export$fb184b623420d9be;
var $028f01eb314ab13a$export$b2b3286365e789d9;
var $028f01eb314ab13a$export$fd59df041b888442;
var $028f01eb314ab13a$export$63e82393dc8977bf;
var $028f01eb314ab13a$export$5c452ff88e35e47d;
var $028f01eb314ab13a$export$7d74a5d084cc5a23;
var $028f01eb314ab13a$export$29f9f81de5c56283;
var $028f01eb314ab13a$export$d88b746f6a4665c4;
var $028f01eb314ab13a$export$c407db72103fecfa;
var $028f01eb314ab13a$export$6cefeda42b08f11c;
var $028f01eb314ab13a$export$a8ff84c12d48cfa6;
var $028f01eb314ab13a$export$f2120bbfa5450bd2;
var $028f01eb314ab13a$export$27c57cc52d388509;
var $028f01eb314ab13a$export$6d59db4903f20f7d;
var $028f01eb314ab13a$export$3b9d909fcd39d8ae;
var $028f01eb314ab13a$export$1ca1ec8b29a4ce27;
var $028f01eb314ab13a$export$c79b3a2d88454829;
var $028f01eb314ab13a$export$12258f938f4857fd;
var $028f01eb314ab13a$export$e2ab8c1ee254ce8f;
$028f01eb314ab13a$export$bd457616a7188bb8 = "_75Y8q";
$028f01eb314ab13a$export$fb184b623420d9be = "_8Pp7V";
$028f01eb314ab13a$export$b2b3286365e789d9 = "ONbEQ";
$028f01eb314ab13a$export$fd59df041b888442 = "Pj9Wo";
$028f01eb314ab13a$export$63e82393dc8977bf = "RV-V3";
$028f01eb314ab13a$export$5c452ff88e35e47d = "IiyNK";
$028f01eb314ab13a$export$7d74a5d084cc5a23 = "OLoHn";
$028f01eb314ab13a$export$29f9f81de5c56283 = "_5Rxs4";
$028f01eb314ab13a$export$d88b746f6a4665c4 = "hbHMv";
$028f01eb314ab13a$export$c407db72103fecfa = "mj-Wj";
$028f01eb314ab13a$export$6cefeda42b08f11c = "VRqmf";
$028f01eb314ab13a$export$a8ff84c12d48cfa6 = "_-2n00";
$028f01eb314ab13a$export$f2120bbfa5450bd2 = "N9jiU";
$028f01eb314ab13a$export$27c57cc52d388509 = "ovOfg";
$028f01eb314ab13a$export$6d59db4903f20f7d = "-K7MZ";
$028f01eb314ab13a$export$3b9d909fcd39d8ae = "qhSaF";
$028f01eb314ab13a$export$1ca1ec8b29a4ce27 = "-NYLb";
$028f01eb314ab13a$export$c79b3a2d88454829 = "R8Qym";
$028f01eb314ab13a$export$12258f938f4857fd = "_0MS0V";
$028f01eb314ab13a$export$e2ab8c1ee254ce8f = "MnNf1";



var $ftoGP = parcelRequire("ftoGP");
class $2b3fcb624b5986de$export$27a48b752485acc3 extends (0, $fsnB5.Component) {
    commit() {
        this.textsContainer = this.el($028f01eb314ab13a$exports.texts);
        this.imageContainer = this.el($028f01eb314ab13a$exports.imageContainer);
        this.image = this.el($028f01eb314ab13a$exports.image);
        this.flow.texts.entries.forEach((entry)=>this.renderEntry(entry));
        if (this.flow.texts.canCollapse) this.entriesComponents[0].removeClass($028f01eb314ab13a$exports.collapsed);
        if (!(0, $ftoGP.isMobile)()) this.image.getHTMLElement().onload = ()=>{
            let imageWidth = this.image.getWidth();
            this.imageContainer.isBelowScroll((isVisible)=>{
                if (isVisible) {
                    this.imageContainer.translate({
                        translateX: 0,
                        delay: 750
                    });
                    this.timeOut(()=>this.textsContainer.translate({
                            opacity: 1,
                            delay: 1000
                        }), 300);
                } else {
                    this.imageContainer.translate({
                        translateX: imageWidth / 2,
                        delay: 1000
                    });
                    this.textsContainer.translate({
                        opacity: 0,
                        delay: 1000
                    });
                }
            }, true);
        };
        super.commit();
    }
    renderEntry(entry) {
        //language=HTML
        let entryComponent = this.textsContainer.append(`
            <div class="${$028f01eb314ab13a$exports.entry} ${this.flow.texts.canCollapse ? $028f01eb314ab13a$exports.canCollapse : ``}">
                <div class="${$028f01eb314ab13a$exports.nameContainer}">
                    <div class="${$028f01eb314ab13a$exports.name}">
                        <div class="${$028f01eb314ab13a$exports.icon} ${$028f01eb314ab13a$exports[entry.icon]} ${$028f01eb314ab13a$exports[entry.iconColor]}"></div>
                        ${entry.title}
                    </div>
                    <div class="${$028f01eb314ab13a$exports.arrow}"></div>
                </div>
                <div class="${$028f01eb314ab13a$exports.description}">
                    ${entry.description}
                </div>
            </div>
        `);
        this.entriesComponents.push(entryComponent);
        if (this.flow.texts.canCollapse) {
            entryComponent.addClass($028f01eb314ab13a$exports.collapsed);
            entryComponent.onClick(()=>{
                this.entriesComponents.forEach((value)=>value.addClass($028f01eb314ab13a$exports.collapsed));
                entryComponent.removeClass($028f01eb314ab13a$exports.collapsed);
            });
        }
    }
    constructor(flow){
        super();
        this.flow = flow;
        this.entriesComponents = [];
        //language=HTML
        this.template = `
            <div class="${$028f01eb314ab13a$exports.componentWebsiteBlackFlow}">
                <div class="${$028f01eb314ab13a$exports.title}">
                    ${flow.title}
                </div>
                <div class="${$028f01eb314ab13a$exports.bigTitle}">
                    ${flow.bigTitle}
                </div>
                <div class="${$028f01eb314ab13a$exports.contents}">
                    <div class="${$028f01eb314ab13a$exports.imageContainer}">
                        <div class="${$028f01eb314ab13a$exports.imgShadow}"></div>
                        <img class="${$028f01eb314ab13a$exports.image}" src="${flow.image}" alt="slide"/>
                    </div>
                    <div class="${$028f01eb314ab13a$exports.texts} ${this.flow.texts.canCollapse ? $028f01eb314ab13a$exports.textCollapse : ``}"></div>
                </div>
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $458a2477ccf58fd1$export$a47911b81bc97c6f;
var $458a2477ccf58fd1$export$fb184b623420d9be;
var $458a2477ccf58fd1$export$6d59db4903f20f7d;
var $458a2477ccf58fd1$export$b8972b998723d602;
var $458a2477ccf58fd1$export$a7db06668cad9adb;
var $458a2477ccf58fd1$export$85fc379452d91af0;
$458a2477ccf58fd1$export$a47911b81bc97c6f = "WQMTb";
$458a2477ccf58fd1$export$fb184b623420d9be = "YX2FI";
$458a2477ccf58fd1$export$6d59db4903f20f7d = "ttH3u";
$458a2477ccf58fd1$export$b8972b998723d602 = "CNm8g";
$458a2477ccf58fd1$export$a7db06668cad9adb = "VnLNW";
$458a2477ccf58fd1$export$85fc379452d91af0 = "MET-I";



class $9f703a6670927d09$export$e95aadd4cd13f6de extends (0, $fsnB5.Component) {
    constructor(platform){
        super();
        //language=HTML
        this.template = `
            <div class="${$458a2477ccf58fd1$export$a47911b81bc97c6f}">
                <div class="${$458a2477ccf58fd1$export$fb184b623420d9be}">
                    ${platform.title}
                </div>
                <div class="${$458a2477ccf58fd1$export$6d59db4903f20f7d}">
                    <div class="${$458a2477ccf58fd1$export$b8972b998723d602}"></div>
                    <div class="${$458a2477ccf58fd1$export$a7db06668cad9adb}">
                        ${platform.description}
                    </div>
                </div>
                <div class="${$458a2477ccf58fd1$export$85fc379452d91af0}">
                    ${this.draw(new (0, $d875ed951709d967$export$9cf1ff22c077cd0b)(platform.grid))}
                </div>
            </div>
        `;
    }
}



class $dd54a2a4caa8d785$export$ba30467c9e89462a extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            center: true,
            title: (0, $5FliW.Resources).t("words.shopifyModuleTitle"),
            description: (0, $5FliW.Resources).t("words.shopifyModuleDescription"),
            partnerIcon: "shopify",
            secondButton: false
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $5FliW.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $5FliW.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $5FliW.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $78bbdfb845d14d49$export$e9f2082bf3648ed6)((0, $5FliW.Resources).t("words.whatShopifyClientsSay"), (0, $072d9015278afa7d$export$a27e371a094e4e50).reviews()))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $f3629506c47fec9f$export$1965e7302a1f5007)({
            title: (0, $5FliW.Resources).t("words.searchEngineContent"),
            color: "black",
            details: [
                {
                    icon: "black-lineal-read",
                    title: (0, $5FliW.Resources).t("words.fleschReadingEase"),
                    subtitle: (0, $5FliW.Resources).t("words.fleschReadingEaseSubtitle")
                },
                {
                    icon: "black-lineal-keywords",
                    title: (0, $5FliW.Resources).t("words.keywords"),
                    subtitle: (0, $5FliW.Resources).t("words.keywordsSubtitle")
                },
                {
                    icon: "black-lineal-words",
                    title: (0, $5FliW.Resources).t("words.transitionWords"),
                    subtitle: (0, $5FliW.Resources).t("words.transitionWordsSubtitle")
                },
                {
                    icon: "black-lineal-code",
                    title: (0, $5FliW.Resources).t("words.htmlTagging"),
                    subtitle: (0, $5FliW.Resources).t("words.htmlTaggingSubtitle")
                },
                {
                    icon: "black-lineal-voice",
                    title: (0, $5FliW.Resources).t("words.passiveVoice"),
                    subtitle: (0, $5FliW.Resources).t("words.passiveVoiceSubtitle")
                },
                {
                    icon: "black-lineal-seo",
                    title: (0, $5FliW.Resources).t("words.seoTools"),
                    subtitle: (0, $5FliW.Resources).t("words.seoToolsSubtitle")
                }
            ]
        }))}
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $2b3fcb624b5986de$export$27a48b752485acc3)({
            title: (0, $5FliW.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $5FliW.Resources).t("words.shopifySeoApp"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $5FliW.Resources).t("words.optimizeExistingSeoShopify"),
                        description: (0, $5FliW.Resources).t("words.optimizeExistingSeoDescriptionShopify"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.createEngagingContent"),
                        description: (0, $5FliW.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.competitorAnalysis"),
                        description: (0, $5FliW.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.autopilot"),
                        description: (0, $5FliW.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        }))}
                        </div>
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $9f703a6670927d09$export$e95aadd4cd13f6de)({
            title: (0, $5FliW.Resources).t("words.ourPlatform"),
            description: (0, $5FliW.Resources).t("words.shopifySeoModuleDescription"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.automaticPilot"),
                                description: (0, $5FliW.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.workInAnyLanguage"),
                                description: (0, $5FliW.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            "questions": [
                {
                    "question": (0, $5FliW.Resources).t("words.doesGooglePenalizeAiContent"),
                    "response": (0, $5FliW.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.seoOptimizationQuestion"),
                    "response": (0, $5FliW.Resources).t("words.seoOptimizationResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.importContentQuestion"),
                    "response": (0, $5FliW.Resources).t("words.importContentResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.contentCustomizationQuestion"),
                    "response": (0, $5FliW.Resources).t("words.contentCustomizationResponse")
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e050426328846cb5$export$7f8c4dbd337fa85b)())}
                    </div>
                </div>
            </div>
        `;
    }
}


class $625a00ae57ce0a4a$export$cb59a6d6d90ba48b extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $dd54a2a4caa8d785$export$ba30467c9e89462a)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("shopify");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");










var $fsnB5 = parcelRequire("fsnB5");
var $7e47543c6912898b$exports = {};

$parcel$export($7e47543c6912898b$exports, "componentWebsiteBlackCases", function () { return $7e47543c6912898b$export$806ec8ebcc7680ea; }, function (v) { return $7e47543c6912898b$export$806ec8ebcc7680ea = v; });
$parcel$export($7e47543c6912898b$exports, "title", function () { return $7e47543c6912898b$export$fb184b623420d9be; }, function (v) { return $7e47543c6912898b$export$fb184b623420d9be = v; });
$parcel$export($7e47543c6912898b$exports, "cases", function () { return $7e47543c6912898b$export$3931a0da49df8dc0; }, function (v) { return $7e47543c6912898b$export$3931a0da49df8dc0 = v; });
$parcel$export($7e47543c6912898b$exports, "case", function () { return $7e47543c6912898b$export$e850e66917a23e0f; }, function (v) { return $7e47543c6912898b$export$e850e66917a23e0f = v; });
$parcel$export($7e47543c6912898b$exports, "name", function () { return $7e47543c6912898b$export$a8ff84c12d48cfa6; }, function (v) { return $7e47543c6912898b$export$a8ff84c12d48cfa6 = v; });
$parcel$export($7e47543c6912898b$exports, "description", function () { return $7e47543c6912898b$export$6d59db4903f20f7d; }, function (v) { return $7e47543c6912898b$export$6d59db4903f20f7d = v; });
$parcel$export($7e47543c6912898b$exports, "iconContainer", function () { return $7e47543c6912898b$export$acf4eaf431084f78; }, function (v) { return $7e47543c6912898b$export$acf4eaf431084f78 = v; });
$parcel$export($7e47543c6912898b$exports, "icon", function () { return $7e47543c6912898b$export$1ca1ec8b29a4ce27; }, function (v) { return $7e47543c6912898b$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($7e47543c6912898b$exports, "page", function () { return $7e47543c6912898b$export$523fb3936f49e028; }, function (v) { return $7e47543c6912898b$export$523fb3936f49e028 = v; });
$parcel$export($7e47543c6912898b$exports, "target", function () { return $7e47543c6912898b$export$44271b4f0c6a3563; }, function (v) { return $7e47543c6912898b$export$44271b4f0c6a3563 = v; });
$parcel$export($7e47543c6912898b$exports, "box", function () { return $7e47543c6912898b$export$827f4ee28efc37; }, function (v) { return $7e47543c6912898b$export$827f4ee28efc37 = v; });
$parcel$export($7e47543c6912898b$exports, "shadow", function () { return $7e47543c6912898b$export$b8972b998723d602; }, function (v) { return $7e47543c6912898b$export$b8972b998723d602 = v; });
var $7e47543c6912898b$export$806ec8ebcc7680ea;
var $7e47543c6912898b$export$fb184b623420d9be;
var $7e47543c6912898b$export$3931a0da49df8dc0;
var $7e47543c6912898b$export$e850e66917a23e0f;
var $7e47543c6912898b$export$a8ff84c12d48cfa6;
var $7e47543c6912898b$export$6d59db4903f20f7d;
var $7e47543c6912898b$export$acf4eaf431084f78;
var $7e47543c6912898b$export$1ca1ec8b29a4ce27;
var $7e47543c6912898b$export$523fb3936f49e028;
var $7e47543c6912898b$export$44271b4f0c6a3563;
var $7e47543c6912898b$export$827f4ee28efc37;
var $7e47543c6912898b$export$b8972b998723d602;
$7e47543c6912898b$export$806ec8ebcc7680ea = "tANMT";
$7e47543c6912898b$export$fb184b623420d9be = "tXBMU";
$7e47543c6912898b$export$3931a0da49df8dc0 = "L-boR";
$7e47543c6912898b$export$e850e66917a23e0f = "C6-fI";
$7e47543c6912898b$export$a8ff84c12d48cfa6 = "XOTpq";
$7e47543c6912898b$export$6d59db4903f20f7d = "SLsTh";
$7e47543c6912898b$export$acf4eaf431084f78 = "_7jvfw";
$7e47543c6912898b$export$1ca1ec8b29a4ce27 = "_6LQ3h";
$7e47543c6912898b$export$523fb3936f49e028 = "_7wE4r";
$7e47543c6912898b$export$44271b4f0c6a3563 = "-op1F";
$7e47543c6912898b$export$827f4ee28efc37 = "_9BFxK";
$7e47543c6912898b$export$b8972b998723d602 = "k8h4B";


class $4a03e34569e2c080$export$81d85f5ace7f975f extends (0, $fsnB5.Component) {
    commit() {
        this.casesContainer = this.el($7e47543c6912898b$exports.cases);
        this.cases.cases.forEach((value)=>{
            //language=HTML
            this.casesContainer.append(`
                <div class="${$7e47543c6912898b$exports.case}">
                    <div class="${$7e47543c6912898b$exports.name}">${value.name}</div>
                    <div class="${$7e47543c6912898b$exports.description}">
                        ${value.description}
                    </div>
                    <div class="${$7e47543c6912898b$exports.iconContainer}">
                        <div class="${$7e47543c6912898b$exports.icon} ${$7e47543c6912898b$exports[value.icon]}"></div>
                    </div>
                    <div class="${$7e47543c6912898b$exports.shadow}"></div>
                </div>
            `);
        });
        super.commit();
    }
    constructor(cases){
        super();
        this.cases = cases;
        //language=HTML
        this.template = `
            <div class="${$7e47543c6912898b$exports.componentWebsiteBlackCases}">
                <div class="${$7e47543c6912898b$exports.title}">${cases.title}</div>
                <div class="${$7e47543c6912898b$exports.cases}"></div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $b94f9041c5d972d0$export$13d8c63fa0fa71bd extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.downloadModuleFree"),
            center: true,
            title: (0, $5FliW.Resources).t("words.freeBlogModuleTitle"),
            description: (0, $5FliW.Resources).t("words.freeBlogModuleDescription"),
            partnerIcon: "prestashop",
            secondButton: true
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.stepsToCreatePublishArticle"),
            icon: "seo",
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-i.mp4"),
                    duration: 16300
                },
                {
                    name: (0, $5FliW.Resources).t("words.managementInPrestaShop"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-j.mp4"),
                    duration: 20000
                },
                {
                    name: (0, $5FliW.Resources).t("words.finalRender"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-k.mp4"),
                    duration: 7000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e6a50373d11f2ef1$export$67fc1824eabdc07e)({
            text: (0, $5FliW.Resources).t("words.dailyEcommerceOptimization"),
            size: "sizeNormal",
            shadow: "colorBlue"
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $4a03e34569e2c080$export$81d85f5ace7f975f)({
            title: (0, $5FliW.Resources).t("words.moduleFeatures"),
            cases: [
                {
                    name: (0, $5FliW.Resources).t("words.fullInterface"),
                    description: (0, $5FliW.Resources).t("words.fullInterfaceDescription"),
                    icon: "page"
                },
                {
                    name: (0, $5FliW.Resources).t("words.seoFriendly"),
                    description: (0, $5FliW.Resources).t("words.seoFriendlyDescription"),
                    icon: "target"
                },
                {
                    name: (0, $5FliW.Resources).t("words.compatibleWithExistingBlog"),
                    description: (0, $5FliW.Resources).t("words.compatibleWithExistingBlogDescription"),
                    icon: "box"
                }
            ]
        }))}
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $2b3fcb624b5986de$export$27a48b752485acc3)({
            title: (0, $5FliW.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $5FliW.Resources).t("words.completeSeoPlatform"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $5FliW.Resources).t("words.optimizeExistingSeo"),
                        description: (0, $5FliW.Resources).t("words.optimizeExistingSeoDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.createEngagingContent"),
                        description: (0, $5FliW.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.competitorAnalysis"),
                        description: (0, $5FliW.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.autopilot"),
                        description: (0, $5FliW.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        }))}
                        </div>
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $9f703a6670927d09$export$e95aadd4cd13f6de)({
            title: (0, $5FliW.Resources).t("words.ourPlatform"),
            description: (0, $5FliW.Resources).t("words.perfectForPrestashop"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.automaticPilot"),
                                description: (0, $5FliW.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.workInAnyLanguage"),
                                description: (0, $5FliW.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e050426328846cb5$export$7f8c4dbd337fa85b)())}
                    </div>
                </div>
            </div>
        `;
    }
}


class $a710c8248fd90b19$export$26219a799f10bcc9 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $b94f9041c5d972d0$export$13d8c63fa0fa71bd)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("prestashop");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");





var $5FliW = parcelRequire("5FliW");








class $b9d0bd6a141f97d9$export$7405d286852a5a68 extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$82a406569704d05c$export$8fa521ed3b789f84}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            center: true,
            title: (0, $5FliW.Resources).t("words.wordpressExtensionTraffic"),
            description: (0, $5FliW.Resources).t("words.wordpressExtensionDescription"),
            partnerIcon: "wordpress",
            secondButton: false
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.generationSteps"),
            icon: "seo",
            center: true,
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.keyword"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.mp4"),
                    duration: 14000
                },
                {
                    name: (0, $5FliW.Resources).t("words.instructions"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.mp4"),
                    duration: 8000
                },
                {
                    name: (0, $5FliW.Resources).t("words.plan"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-g.mp4"),
                    duration: 21000
                },
                {
                    name: (0, $5FliW.Resources).t("words.writing"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h.mp4"),
                    duration: 15000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $5a5a74645f4a26c3$export$21cf7e1029971b9d)((0, $5FliW.Resources).t("words.howItWorks"), [
            {
                icon: "draft",
                title: (0, $5FliW.Resources).t("words.instructionsTitle"),
                desc: (0, $5FliW.Resources).t("words.instructionsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-1.webp")
            },
            {
                icon: "paragraph",
                title: (0, $5FliW.Resources).t("words.proposalsTitle"),
                desc: (0, $5FliW.Resources).t("words.proposalsDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-2.webp")
            },
            {
                icon: "section",
                title: (0, $5FliW.Resources).t("words.planTitle"),
                desc: (0, $5FliW.Resources).t("words.planDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-3.webp")
            },
            {
                icon: "pensil",
                title: (0, $5FliW.Resources).t("words.writingTitle"),
                desc: (0, $5FliW.Resources).t("words.writingDescription"),
                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-h-4.webp")
            }
        ]))}
                    </div>
                    <div class="${$82a406569704d05c$export$2217aca24454a969}">
                        <div class="${$82a406569704d05c$export$f7c42a96c638d4dc}">
                            <div class="${$82a406569704d05c$export$79ffe56a765070d2}">
                                <img class="${$82a406569704d05c$export$5c452ff88e35e47d}" src="${(0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-e.webp")}"
                                     alt="${(0, $5FliW.Resources).t("words.styleCloning")}" draggable="false"
                                     width="380" height="347.51"
                                />
                            </div>
                            <div class="${$82a406569704d05c$export$eabcd2c8791e7bf4}">
                                <h2 class="${$82a406569704d05c$export$fb184b623420d9be}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleTitle")}
                                </h2>
                                <p class="${$82a406569704d05c$export$c96745152eb2740f}">
                                    ${(0, $5FliW.Resources).t("words.keepWritingStyleText")}
                                </p>
                                <img class="${$82a406569704d05c$export$53f1d5ea8de3d7c}" src="${(0, $072d9015278afa7d$export$a27e371a094e4e50).illus("separator-line.svg")}"
                                     alt="${(0, $5FliW.Resources).t("words.separationLine")}" draggable="false"/>
                            </div>
                        </div>
                        <div class="${$82a406569704d05c$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $eccf921ec7e11df0$export$366de2f3346a7a26)({
            title: (0, $5FliW.Resources).t("words.explainContextToAI"),
            description: (0, $5FliW.Resources).t("words.contextFeatureText"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-f.webp"),
            color: "black",
            size: "medium",
            border: "border"
        }))}
                        </div>
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $a6e2cc43accecdce$export$f6f77077605a705e)({
            theme: "black",
            "questions": [
                {
                    "question": (0, $5FliW.Resources).t("words.doesGooglePenalizeAiContent"),
                    "response": (0, $5FliW.Resources).t("words.googleDoesNotPenalizeAiContent")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.seoOptimizationQuestion"),
                    "response": (0, $5FliW.Resources).t("words.seoOptimizationResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.platformConnectionQuestion"),
                    "response": (0, $5FliW.Resources).t("words.platformConnectionResponse")
                },
                {
                    "question": (0, $5FliW.Resources).t("words.smartBlogAdvantagesQuestion"),
                    "response": (0, $5FliW.Resources).t("words.smartBlogAdvantagesResponse")
                }
            ]
        }))}
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $2b3fcb624b5986de$export$27a48b752485acc3)({
            title: (0, $5FliW.Resources).t("words.bestSeoAlly"),
            bigTitle: (0, $5FliW.Resources).t("words.completeWordpressExtension"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-n.webp"),
            texts: {
                canCollapse: true,
                entries: [
                    {
                        title: (0, $5FliW.Resources).t("words.optimizeExistingSeoWordpress"),
                        description: (0, $5FliW.Resources).t("words.optimizeExistingSeoDescriptionWordpress"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.createEngagingContent"),
                        description: (0, $5FliW.Resources).t("words.createEngagingContentDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.competitorAnalysis"),
                        description: (0, $5FliW.Resources).t("words.competitorAnalysisDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.autopilot"),
                        description: (0, $5FliW.Resources).t("words.delegateContentCreationDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    }
                ]
            }
        }))}
                        </div>
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $9f703a6670927d09$export$e95aadd4cd13f6de)({
            title: (0, $5FliW.Resources).t("words.ourPlatform"),
            description: (0, $5FliW.Resources).t("words.seoToolDescriptionWordpress"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.automaticPilot"),
                                description: (0, $5FliW.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.workInAnyLanguage"),
                                description: (0, $5FliW.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMidColumn",
                                color: "colorYellow",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        }))}
                                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e050426328846cb5$export$7f8c4dbd337fa85b)())}
                    </div>
                </div>
            </div>
        `;
    }
}


class $12c50e8eec9c918f$export$3a96fed2f93e0d19 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $b9d0bd6a141f97d9$export$7405d286852a5a68)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("wordpress");
        this.status.online = undefined;
    }
}





var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");






class $53b9badba796165e$export$45e36e94ebd3c478 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            title: (0, $5FliW.Resources).t("words.mostPerformantContent"),
            description: (0, $5FliW.Resources).t("words.sedestralSystemDescription"),
            people: true,
            center: true
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.simplifiedSeoSteps"),
            icon: "seo",
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.analysisAndResearch"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-a.mp4"),
                    duration: 5700
                },
                {
                    name: (0, $5FliW.Resources).t("words.writeOrGenerate"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-b.mp4"),
                    duration: 22000
                },
                {
                    name: (0, $5FliW.Resources).t("words.verifyAndPublish"),
                    type: "img",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-c.webp"),
                    duration: 6000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $e6a50373d11f2ef1$export$67fc1824eabdc07e)({
            text: (0, $5FliW.Resources).t("words.dailyOptimizationUsers"),
            size: "sizeNormal",
            shadow: "colorBlue"
        }))}
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $2b3fcb624b5986de$export$27a48b752485acc3)({
            title: (0, $5FliW.Resources).t("words.createAndOptimize"),
            bigTitle: (0, $5FliW.Resources).t("words.createEngagingContent"),
            image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-c.webp"),
            texts: {
                canCollapse: false,
                entries: [
                    {
                        title: (0, $5FliW.Resources).t("words.autoOptimizeExistingContent"),
                        description: (0, $5FliW.Resources).t("words.autoOptimizeDescription"),
                        icon: "aiStars",
                        iconColor: "colorPurple"
                    },
                    {
                        title: (0, $5FliW.Resources).t("words.createEngagingSeoContent"),
                        description: (0, $5FliW.Resources).t("words.createEngagingDescription"),
                        icon: "aiWrite",
                        iconColor: "colorPurple"
                    }
                ]
            }
        }))}
                        </div>
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $9f703a6670927d09$export$e95aadd4cd13f6de)({
            title: (0, $5FliW.Resources).t("words.ourPlatform"),
            description: (0, $5FliW.Resources).t("words.ourPlatformDescription"),
            grid: {
                lines: [
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.seoScore"),
                                description: (0, $5FliW.Resources).t("words.seoScoreDescription"),
                                type: "icon",
                                icon: "optimize",
                                ai: true
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.sedestralAi"),
                                description: (0, $5FliW.Resources).t("words.sedestralAiDescription"),
                                type: "image",
                                image: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-d.webp"),
                                ai: true,
                                size: "sizeLarge",
                                color: "colorBlue"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.workInAnyLanguage"),
                                description: (0, $5FliW.Resources).t("words.workInAnyLanguageDescription"),
                                type: "icon",
                                icon: "languages",
                                size: "sizeMid",
                                color: "colorYellow",
                                shadowPosition: "shadowBottomCenter"
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.deepCompetitorAnalysis"),
                                description: (0, $5FliW.Resources).t("words.deepCompetitorDescription"),
                                type: "icon",
                                icon: "chartPurple",
                                size: "sizeMid",
                                color: "colorPurple",
                                shadowPosition: "shadowLeftCenter"
                            }
                        ]
                    },
                    {
                        entries: [
                            {
                                title: (0, $5FliW.Resources).t("words.automaticPiloting"),
                                description: (0, $5FliW.Resources).t("words.automaticPilotDescription"),
                                type: "icon",
                                icon: "autopilot",
                                size: "sizeMidColumn",
                                color: "colorBlue",
                                shadowPosition: "shadowMid"
                            },
                            {
                                title: (0, $5FliW.Resources).t("words.nativeIntegration"),
                                description: (0, $5FliW.Resources).t("words.nativeIntegrationDescription"),
                                type: "icon",
                                icon: "funnel",
                                size: "sizeMidColumn",
                                color: "colorPurple",
                                shadowPosition: "shadowMid"
                            }
                        ]
                    }
                ]
            }
        }))}
                    </div>
                </div>
            </div>
        `;
    }
}


class $09eef984c6f5d235$export$a04f4b273a33409f extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $53b9badba796165e$export$45e36e94ebd3c478)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("home");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");






var $5FliW = parcelRequire("5FliW");

var $fsnB5 = parcelRequire("fsnB5");
var $6ce21416bc1ace0e$export$a47911b81bc97c6f;
var $6ce21416bc1ace0e$export$6d59db4903f20f7d;
var $6ce21416bc1ace0e$export$a7db06668cad9adb;
var $6ce21416bc1ace0e$export$55518a6b07703516;
var $6ce21416bc1ace0e$export$2cc7ff91bcacba5e;
$6ce21416bc1ace0e$export$a47911b81bc97c6f = "NZXhT";
$6ce21416bc1ace0e$export$6d59db4903f20f7d = "yRwUc";
$6ce21416bc1ace0e$export$a7db06668cad9adb = "BsxTO";
$6ce21416bc1ace0e$export$55518a6b07703516 = "HvZho";
$6ce21416bc1ace0e$export$2cc7ff91bcacba5e = "hENoT";



var $fsnB5 = parcelRequire("fsnB5");
var $e1b8eccc0be4e67e$exports = {};

$parcel$export($e1b8eccc0be4e67e$exports, "componentWebsiteBlackUnion", function () { return $e1b8eccc0be4e67e$export$31612e1b4b9ea7c2; }, function (v) { return $e1b8eccc0be4e67e$export$31612e1b4b9ea7c2 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "rect", function () { return $e1b8eccc0be4e67e$export$4b409e53cf4df6e6; }, function (v) { return $e1b8eccc0be4e67e$export$4b409e53cf4df6e6 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "pastille", function () { return $e1b8eccc0be4e67e$export$564e4a74ab2e0db0; }, function (v) { return $e1b8eccc0be4e67e$export$564e4a74ab2e0db0 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "iconContainer", function () { return $e1b8eccc0be4e67e$export$acf4eaf431084f78; }, function (v) { return $e1b8eccc0be4e67e$export$acf4eaf431084f78 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "shadow", function () { return $e1b8eccc0be4e67e$export$b8972b998723d602; }, function (v) { return $e1b8eccc0be4e67e$export$b8972b998723d602 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "icon", function () { return $e1b8eccc0be4e67e$export$1ca1ec8b29a4ce27; }, function (v) { return $e1b8eccc0be4e67e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "union", function () { return $e1b8eccc0be4e67e$export$971dd5b0dfd021b6; }, function (v) { return $e1b8eccc0be4e67e$export$971dd5b0dfd021b6 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "cases", function () { return $e1b8eccc0be4e67e$export$3931a0da49df8dc0; }, function (v) { return $e1b8eccc0be4e67e$export$3931a0da49df8dc0 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "case", function () { return $e1b8eccc0be4e67e$export$e850e66917a23e0f; }, function (v) { return $e1b8eccc0be4e67e$export$e850e66917a23e0f = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "blue", function () { return $e1b8eccc0be4e67e$export$2aa0182783e7e9de; }, function (v) { return $e1b8eccc0be4e67e$export$2aa0182783e7e9de = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "content", function () { return $e1b8eccc0be4e67e$export$a7db06668cad9adb; }, function (v) { return $e1b8eccc0be4e67e$export$a7db06668cad9adb = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "blur", function () { return $e1b8eccc0be4e67e$export$2cc7ff91bcacba5e; }, function (v) { return $e1b8eccc0be4e67e$export$2cc7ff91bcacba5e = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "name", function () { return $e1b8eccc0be4e67e$export$a8ff84c12d48cfa6; }, function (v) { return $e1b8eccc0be4e67e$export$a8ff84c12d48cfa6 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "purple", function () { return $e1b8eccc0be4e67e$export$e13cce2a2d16a9d4; }, function (v) { return $e1b8eccc0be4e67e$export$e13cce2a2d16a9d4 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "yellow", function () { return $e1b8eccc0be4e67e$export$594c5a8758200c32; }, function (v) { return $e1b8eccc0be4e67e$export$594c5a8758200c32 = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "names", function () { return $e1b8eccc0be4e67e$export$e4b2ac9215619f8d; }, function (v) { return $e1b8eccc0be4e67e$export$e4b2ac9215619f8d = v; });
$parcel$export($e1b8eccc0be4e67e$exports, "description", function () { return $e1b8eccc0be4e67e$export$6d59db4903f20f7d; }, function (v) { return $e1b8eccc0be4e67e$export$6d59db4903f20f7d = v; });
var $e1b8eccc0be4e67e$export$31612e1b4b9ea7c2;
var $e1b8eccc0be4e67e$export$4b409e53cf4df6e6;
var $e1b8eccc0be4e67e$export$564e4a74ab2e0db0;
var $e1b8eccc0be4e67e$export$acf4eaf431084f78;
var $e1b8eccc0be4e67e$export$b8972b998723d602;
var $e1b8eccc0be4e67e$export$1ca1ec8b29a4ce27;
var $e1b8eccc0be4e67e$export$971dd5b0dfd021b6;
var $e1b8eccc0be4e67e$export$3931a0da49df8dc0;
var $e1b8eccc0be4e67e$export$e850e66917a23e0f;
var $e1b8eccc0be4e67e$export$2aa0182783e7e9de;
var $e1b8eccc0be4e67e$export$a7db06668cad9adb;
var $e1b8eccc0be4e67e$export$2cc7ff91bcacba5e;
var $e1b8eccc0be4e67e$export$a8ff84c12d48cfa6;
var $e1b8eccc0be4e67e$export$e13cce2a2d16a9d4;
var $e1b8eccc0be4e67e$export$594c5a8758200c32;
var $e1b8eccc0be4e67e$export$e4b2ac9215619f8d;
var $e1b8eccc0be4e67e$export$6d59db4903f20f7d;
$e1b8eccc0be4e67e$export$31612e1b4b9ea7c2 = "klryu";
$e1b8eccc0be4e67e$export$4b409e53cf4df6e6 = "PoaQ4";
$e1b8eccc0be4e67e$export$564e4a74ab2e0db0 = "BGowu";
$e1b8eccc0be4e67e$export$acf4eaf431084f78 = "_943qj";
$e1b8eccc0be4e67e$export$b8972b998723d602 = "Stx-W";
$e1b8eccc0be4e67e$export$1ca1ec8b29a4ce27 = "g9YOi";
$e1b8eccc0be4e67e$export$971dd5b0dfd021b6 = "EEDpq";
$e1b8eccc0be4e67e$export$3931a0da49df8dc0 = "vYEcJ";
$e1b8eccc0be4e67e$export$e850e66917a23e0f = "ckG9B";
$e1b8eccc0be4e67e$export$2aa0182783e7e9de = "XuQ9s";
$e1b8eccc0be4e67e$export$a7db06668cad9adb = "bD7k7";
$e1b8eccc0be4e67e$export$2cc7ff91bcacba5e = "_7-4ya";
$e1b8eccc0be4e67e$export$a8ff84c12d48cfa6 = "_1kcaj";
$e1b8eccc0be4e67e$export$e13cce2a2d16a9d4 = "d84Qm";
$e1b8eccc0be4e67e$export$594c5a8758200c32 = "h9MMA";
$e1b8eccc0be4e67e$export$e4b2ac9215619f8d = "CpC5t";
$e1b8eccc0be4e67e$export$6d59db4903f20f7d = "xurSr";


class $d625674889892126$export$1c0bc67f9d9907fa extends (0, $fsnB5.Component) {
    commit() {
        this.casesContainer = this.el($e1b8eccc0be4e67e$exports.cases);
        this.union.cases.forEach((value)=>{
            //language=HTML
            this.casesContainer.append(`
                <div class="${$e1b8eccc0be4e67e$exports.case} ${$e1b8eccc0be4e67e$exports[value.color]}">
                    <div class="${$e1b8eccc0be4e67e$exports.content}">
                        <div class="${$e1b8eccc0be4e67e$exports.names}">
                            <div class="${$e1b8eccc0be4e67e$exports.blur}"></div>
                            <div class="${$e1b8eccc0be4e67e$exports.name}">
                                ${value.name}
                            </div>
                        </div>
                        <div class="${$e1b8eccc0be4e67e$exports.description}">
                            ${value.description}
                        </div>
                    </div>
                </div>
            `);
        });
        super.commit();
    }
    constructor(union){
        super();
        this.union = union;
        //language=HTML
        this.template = `
            <div class="${$e1b8eccc0be4e67e$exports.componentWebsiteBlackUnion}">
                <div class="${$e1b8eccc0be4e67e$exports.rect}">
                    <div class="${$e1b8eccc0be4e67e$exports.pastille}">
                        <div class="${$e1b8eccc0be4e67e$exports.iconContainer}">
                            <div class="${$e1b8eccc0be4e67e$exports.shadow}"></div>
                            <div class="${$e1b8eccc0be4e67e$exports.icon}"></div>
                        </div>
                        ${union.ai}
                    </div>
                </div>
                <div class="${$e1b8eccc0be4e67e$exports.union}"></div>
                <div class="${$e1b8eccc0be4e67e$exports.cases}"></div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $d1649d9cd5fdac75$export$dc94a094b7b0ae05 extends (0, $fsnB5.Component) {
    constructor(indicators){
        super();
        //language=HTML
        this.template = `
            <div class="${$6ce21416bc1ace0e$export$a47911b81bc97c6f}">
                <div class="${$6ce21416bc1ace0e$export$6d59db4903f20f7d}">
                    <div class="${$6ce21416bc1ace0e$export$a7db06668cad9adb}">
                        ${indicators.description}
                    </div>
                </div>
                <div class="${$6ce21416bc1ace0e$export$55518a6b07703516}">
                    <div class="${$6ce21416bc1ace0e$export$2cc7ff91bcacba5e}"></div>
                    <div class="${$6ce21416bc1ace0e$export$a7db06668cad9adb}">
                        ${indicators.content}
                    </div>
                </div>
                ${this.draw(new (0, $d625674889892126$export$1c0bc67f9d9907fa)({
            ai: (0, $5FliW.Resources).t("words.sedestralAI"),
            cases: [
                {
                    color: "blue",
                    name: (0, $5FliW.Resources).t("words.siteAnalysis"),
                    description: (0, $5FliW.Resources).t("words.siteAnalysisDescription")
                },
                {
                    color: "purple",
                    name: (0, $5FliW.Resources).t("words.firstKeywords"),
                    description: (0, $5FliW.Resources).t("words.firstKeywordsDescription")
                },
                {
                    color: "yellow",
                    name: (0, $5FliW.Resources).t("words.googleSearches"),
                    description: (0, $5FliW.Resources).t("words.googleSearchesDescription")
                }
            ]
        }))}
            </div>
        `;
    }
}



var $fsnB5 = parcelRequire("fsnB5");
var $515ae0f924af4037$export$e079a52b1c897733;
var $515ae0f924af4037$export$fb184b623420d9be;
var $515ae0f924af4037$export$b2b3286365e789d9;
var $515ae0f924af4037$export$3931a0da49df8dc0;
var $515ae0f924af4037$export$e850e66917a23e0f;
var $515ae0f924af4037$export$2adb16ac204af30e;
var $515ae0f924af4037$export$a8ff84c12d48cfa6;
var $515ae0f924af4037$export$1ca1ec8b29a4ce27;
var $515ae0f924af4037$export$8fde8ebd684d5072;
var $515ae0f924af4037$export$dd9cd24e500b6d0b;
var $515ae0f924af4037$export$2d6e9b4c68afb6c8;
var $515ae0f924af4037$export$6d59db4903f20f7d;
var $515ae0f924af4037$export$df03f54e09e486fa;
var $515ae0f924af4037$export$75904fce00b7240e;
var $515ae0f924af4037$export$f90719f89646befa;
var $515ae0f924af4037$export$3c7172b0b56389d;
var $515ae0f924af4037$export$a4331299cbd0247f;
$515ae0f924af4037$export$e079a52b1c897733 = "mmdtX";
$515ae0f924af4037$export$fb184b623420d9be = "_1XfjP";
$515ae0f924af4037$export$b2b3286365e789d9 = "Ximav";
$515ae0f924af4037$export$3931a0da49df8dc0 = "q9R-P";
$515ae0f924af4037$export$e850e66917a23e0f = "hErou";
$515ae0f924af4037$export$2adb16ac204af30e = "htg4g";
$515ae0f924af4037$export$a8ff84c12d48cfa6 = "gfp3D";
$515ae0f924af4037$export$1ca1ec8b29a4ce27 = "Lh8-0";
$515ae0f924af4037$export$8fde8ebd684d5072 = "nOlcb";
$515ae0f924af4037$export$dd9cd24e500b6d0b = "jExnb";
$515ae0f924af4037$export$2d6e9b4c68afb6c8 = "Pa1qn";
$515ae0f924af4037$export$6d59db4903f20f7d = "_5spjo";
$515ae0f924af4037$export$df03f54e09e486fa = "gpTJb";
$515ae0f924af4037$export$75904fce00b7240e = "Ou0oS";
$515ae0f924af4037$export$f90719f89646befa = "su6yq";
$515ae0f924af4037$export$3c7172b0b56389d = "AexdA";
$515ae0f924af4037$export$a4331299cbd0247f = "U5Kmi";



var $5FliW = parcelRequire("5FliW");
class $991f42666deb5e25$export$8697f8918118012b extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$515ae0f924af4037$export$e079a52b1c897733}">
                <div class="${$515ae0f924af4037$export$fb184b623420d9be}">
                    ${(0, $5FliW.Resources).t("words.yourBestSeoAlly")}
                </div>
                <div class="${$515ae0f924af4037$export$b2b3286365e789d9}">
                    ${(0, $5FliW.Resources).t("words.analyzeRankingAndCompetitors")}
                </div>
                <div class="${$515ae0f924af4037$export$3931a0da49df8dc0}">
                    <div class="${$515ae0f924af4037$export$e850e66917a23e0f}">
                        <div class="${$515ae0f924af4037$export$a8ff84c12d48cfa6}">
                            <div class="${$515ae0f924af4037$export$1ca1ec8b29a4ce27} ${$515ae0f924af4037$export$8fde8ebd684d5072}"></div>
                            ${(0, $5FliW.Resources).t("words.identifyKeywordsToOptimize")}
                        </div>
                        <div class="${$515ae0f924af4037$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.identifyLowCompetitionKeywords")}
                        </div>
                    </div>
                    <div class="${$515ae0f924af4037$export$e850e66917a23e0f}">
                        <div class="${$515ae0f924af4037$export$a8ff84c12d48cfa6}">
                            <div class="${$515ae0f924af4037$export$1ca1ec8b29a4ce27} ${$515ae0f924af4037$export$dd9cd24e500b6d0b}"></div>
                            ${(0, $5FliW.Resources).t("words.trackKeywordsYouWorkOn")}
                        </div>
                        <div class="${$515ae0f924af4037$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.monitorPerformanceAndRanking")}
                        </div>
                    </div>
                    <div class="${$515ae0f924af4037$export$e850e66917a23e0f}">
                        <div class="${$515ae0f924af4037$export$a8ff84c12d48cfa6}">
                            <div class="${$515ae0f924af4037$export$1ca1ec8b29a4ce27} ${$515ae0f924af4037$export$2d6e9b4c68afb6c8}"></div>
                            ${(0, $5FliW.Resources).t("words.reactQuicklyToChanges")}
                        </div>
                        <div class="${$515ae0f924af4037$export$6d59db4903f20f7d}">
                            ${(0, $5FliW.Resources).t("words.realTimeAnalysisToOptimize")}
                        </div>
                    </div>
                </div>
                <div class="${$515ae0f924af4037$export$a4331299cbd0247f}"></div>
                <div class="${$515ae0f924af4037$export$b2b3286365e789d9}">
                    ${(0, $5FliW.Resources).t("words.useAiToCreateAndOptimizeContent")}
                </div>
                <div class="${$515ae0f924af4037$export$3931a0da49df8dc0}">
                    <div class="${$515ae0f924af4037$export$e850e66917a23e0f} ${$515ae0f924af4037$export$2adb16ac204af30e}">
                        <div class="${$515ae0f924af4037$export$a8ff84c12d48cfa6}">
                            ${(0, $5FliW.Resources).t("words.optimizeExistingContentForKeyword")}
                        </div>
                        <div class="${$515ae0f924af4037$export$df03f54e09e486fa}">
                            <div class="${$515ae0f924af4037$export$6d59db4903f20f7d}">
                                ${(0, $5FliW.Resources).t("words.advancedSystemForOptimization")}
                            </div>
                            <div class="${$515ae0f924af4037$export$75904fce00b7240e} ${$515ae0f924af4037$export$f90719f89646befa}"></div>
                        </div>
                    </div>
                    <div class="${$515ae0f924af4037$export$e850e66917a23e0f} ${$515ae0f924af4037$export$2adb16ac204af30e}">
                        <div class="${$515ae0f924af4037$export$a8ff84c12d48cfa6}">
                            ${(0, $5FliW.Resources).t("words.createEngagingSeoContent")}
                        </div>
                        <div class="${$515ae0f924af4037$export$df03f54e09e486fa}">
                            <div class="${$515ae0f924af4037$export$6d59db4903f20f7d}">
                                ${(0, $5FliW.Resources).t("words.generateOptimizedContents")}
                            </div>
                            <div class="${$515ae0f924af4037$export$75904fce00b7240e} ${$515ae0f924af4037$export$3c7172b0b56389d}"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}


class $9b9c4593f1953bac$export$b45c10ab8c2a6c72 extends (0, $fsnB5.Component) {
    commit() {
        (0, $ea62fcbd69a0df0d$export$4718cc74f3daff00).blog();
        super.commit();
    }
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c}">
                <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $7484749ce292151c$export$6d14472d28e42cd8)({
            startText: (0, $5FliW.Resources).t("words.beginFree"),
            center: true,
            title: (0, $5FliW.Resources).t("words.indicatorsGiveEdge"),
            description: (0, $5FliW.Resources).t("words.sedestralTrackingDescription")
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $001b31774028e938$export$41c8d4c54c27d95f)({
            title: (0, $5FliW.Resources).t("words.steps"),
            icon: "seo",
            contents: [
                {
                    name: (0, $5FliW.Resources).t("words.rankVisualization"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-l.mp4"),
                    duration: 10000
                },
                {
                    name: (0, $5FliW.Resources).t("words.competitorComparison"),
                    type: "video",
                    path: (0, $072d9015278afa7d$export$a27e371a094e4e50).image("blog-m.mp4"),
                    duration: 14000
                }
            ]
        }))}
                    </div>
                    <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                        ${this.draw(new (0, $d1649d9cd5fdac75$export$dc94a094b7b0ae05)({
            description: (0, $5FliW.Resources).t("words.cannotImproveWhatNotSeen"),
            content: (0, $5FliW.Resources).t("words.sedestralReviewDescription")
        }))}
                    </div>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            ${this.draw(new (0, $991f42666deb5e25$export$8697f8918118012b)())}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}


class $d5e0a38d2a4be226$export$ab7ea9573211da38 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $9b9c4593f1953bac$export$b45c10ab8c2a6c72)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("analysis");
        this.status.online = undefined;
    }
}




var $fsnB5 = parcelRequire("fsnB5");

var $ad62d58c8afbf262$export$e434ce7de9258df4;
var $ad62d58c8afbf262$export$d92e6f982d8d582;
var $ad62d58c8afbf262$export$fb184b623420d9be;
$ad62d58c8afbf262$export$e434ce7de9258df4 = "_1Gqz5";
$ad62d58c8afbf262$export$d92e6f982d8d582 = "wgKID";
$ad62d58c8afbf262$export$fb184b623420d9be = "w60GZ";



var $fsnB5 = parcelRequire("fsnB5");
var $561bb8857634c056$export$717af95ad73b5517;
var $561bb8857634c056$export$a7db06668cad9adb;
var $561bb8857634c056$export$fb184b623420d9be;
var $561bb8857634c056$export$5c452ff88e35e47d;
var $561bb8857634c056$export$6e22c362a0406a2c;
var $561bb8857634c056$export$6f093cfa640b7166;
var $561bb8857634c056$export$41ee12f6f6f05843;
var $561bb8857634c056$export$40e543e69a8b3fbb;
$561bb8857634c056$export$717af95ad73b5517 = "_6e4O7";
$561bb8857634c056$export$a7db06668cad9adb = "Ck9DZ";
$561bb8857634c056$export$fb184b623420d9be = "_111Lr";
$561bb8857634c056$export$5c452ff88e35e47d = "k1jrV";
$561bb8857634c056$export$6e22c362a0406a2c = "UHgVd";
$561bb8857634c056$export$6f093cfa640b7166 = "_25oiB";
$561bb8857634c056$export$41ee12f6f6f05843 = "_4reGz";
$561bb8857634c056$export$40e543e69a8b3fbb = "fK-rB";



var $9qDN7 = parcelRequire("9qDN7");

var $cyFTW = parcelRequire("cyFTW");

var $5FliW = parcelRequire("5FliW");
/**
 * retourne la date pour les metas
 */ function $f0189ef13681fbe4$export$9863893cf6a97125(date) {
    const isoDate = date.toISOString();
    const offset = -date.getTimezoneOffset();
    const offsetSign = offset >= 0 ? '+' : '-';
    const offsetHours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, '0');
    const offsetMinutes = Math.abs(offset % 60).toString().padStart(2, '0');
    const timezoneFormat = `${offsetSign}${offsetHours}:${offsetMinutes}`;
    const localISODate = `${isoDate.substring(0, isoDate.length - 1)}${timezoneFormat}`;
    return localISODate;
}



var $5FliW = parcelRequire("5FliW");
function $ab3b6e9b2cd71c73$export$4d4ebea86394cbb3(date) {
    return new Intl.DateTimeFormat((0, $5FliW.Resources).language, {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).format(new Date(date));
}


class $0507b0637848cec1$export$be23e26c77269b4e extends (0, $fsnB5.Component) {
    commit() {
        this.imageContainer = this.el($561bb8857634c056$export$5c452ff88e35e47d);
        this.renderImage();
        super.commit();
    }
    renderImage() {
        //language=HTML
        this.imageContainer.append(`
            <img class="lazyload" itemprop="image" alt="${this.article.title}"
                 src="${(0, $9qDN7.IMG_EMPTY)}"
                 data-src="https://marketing-assets.surferseo.art/wf-cdn/62666115cfab453aacbd513c/67584a0e2d788b53571b9762_Academy%2010%20-%20Cover-p-1080.png"
                 data-sizes="auto"
                 width="auto"
                 height="auto"
            />
        `);
        //language=HTML
        this.imageContainer.append(`
            <noscript>
                <img itemprop="image" src="https://marketing-assets.surferseo.art/wf-cdn/62666115cfab453aacbd513c/67584a0e2d788b53571b9762_Academy%2010%20-%20Cover-p-1080.png" alt="${this.article.title}" width="auto"
                     height="auto"/>
            </noscript>
        `);
    }
    constructor(article){
        super();
        this.article = article;
        //language=HTML
        this.template = `
            <article itemprop="blogPosts" itemscope itemtype="https://schema.org/BlogPosting"
                     class="${$561bb8857634c056$export$717af95ad73b5517}">
                <meta itemprop="url" content="${this.article.url}">
                <meta itemprop="inLanguage" content="fr">
                <meta itemprop="articleSection" content="${(0, $cyFTW.filterXSS)(this.article.title)}">
                <div class="${$561bb8857634c056$export$5c452ff88e35e47d}"></div>
                <div class="${$561bb8857634c056$export$a7db06668cad9adb}">
                    <h2 itemprop="headline" class="${$561bb8857634c056$export$fb184b623420d9be}">
                        ${(0, $cyFTW.filterXSS)(this.article.title)}
                    </h2>
                    <p itemprop="description" class="${$561bb8857634c056$export$6f093cfa640b7166}">
                        ${(0, $cyFTW.filterXSS)(this.article.snippet)}
                    </p>
                </div>

                <div class="${$561bb8857634c056$export$41ee12f6f6f05843}">
                    ${(0, $ab3b6e9b2cd71c73$export$4d4ebea86394cbb3)(new Date(this.article.time))} |
                    ${Math.round(this.article.readingSeconds / 60)} ${(0, $5FliW.Resources).t("words.timeToRead")}
                </div>
                ${this.article.keywords.length > 0 ? `<meta itemprop="keywords" content="${(0, $cyFTW.filterXSS)(this.article.keywords.join(", "))}">` : ``}
                <meta itemprop="datePublished" content="${(0, $f0189ef13681fbe4$export$9863893cf6a97125)(new Date(this.article.time))}">
                ${this.article.lastEditTime > 0 ? `<meta itemprop="dateModified" content="${(0, $f0189ef13681fbe4$export$9863893cf6a97125)(new Date(this.article.lastEditTime))}">` : ``}
            </article>
        `;
    }
}


class $c3ad970fb491387f$export$c4ac2da9aee0d2eb extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$974334ea2495c9d4$export$f997558458ede46c} ${$ad62d58c8afbf262$export$e434ce7de9258df4}">
                <div style="gap:20px;" class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                    <div class="${$ad62d58c8afbf262$export$d92e6f982d8d582}">
                        Acad\xe9mie
                    </div>
                    <h2 class="${$ad62d58c8afbf262$export$fb184b623420d9be}">
                        D\xe9couvrez nos cours et conseils pratiques pour optimiser efficacement votre SEO
                    </h2>
                </div>
                <div class="${$974334ea2495c9d4$export$8fa4e5556fd77a60}">
                    <div class="${$974334ea2495c9d4$export$a7db06668cad9adb}">
                        <div class="${$974334ea2495c9d4$export$34e0f9847d4c02dd}">
                            <div style="display: flex;gap:30px;width: 100%;margin-bottom: 35px;">
                                ${this.draw(new (0, $0507b0637848cec1$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        }))}
                                ${this.draw(new (0, $0507b0637848cec1$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        }))}
                            </div>
                            <div style="display: flex;gap:30px;width: 100%;">
                                ${this.draw(new (0, $0507b0637848cec1$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        }))}
                                ${this.draw(new (0, $0507b0637848cec1$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        }))}
                                ${this.draw(new (0, $0507b0637848cec1$export$be23e26c77269b4e)({
            title: "Ma\xeetriser le SEO : strat\xe9gies avanc\xe9es pour optimiser votre visibilit\xe9 en ligne",
            url: "URL",
            snippet: "Apprenez \xe0 optimiser votre site web avec des techniques SEO avanc\xe9es : analyse s\xe9mantique, clusters de mots-cl\xe9s et suivi de performance.",
            keywords: [],
            time: Date.now(),
            lastEditTime: Date.now(),
            readingSeconds: 300
        }))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}


class $20a878b3c010efc3$export$649513343506d210 extends (0, $e70ad9b6a622ca7a$export$f58f12b264b5aeb7) {
    contentComponent() {
        return new (0, $c3ad970fb491387f$export$c4ac2da9aee0d2eb)();
    }
    onHash() {}
    constructor(){
        super();
        this.updateMetas("academy");
        this.status.online = undefined;
    }
}


class $060834e4778a6d1c$export$6c295a1800b38e94 extends (0, $e116fd09b7cc437c$export$d35034d02907e61a) {
    async init(config) {
        super.init(config);
        super.initStarted();
    }
    registerPages() {
        this.pages.registerPage("/404", ()=>new (0, $cf14ff3012794a7f$export$31641b61980e511f)());
        this.pages.registerPage("/home", ()=>new (0, $09eef984c6f5d235$export$a04f4b273a33409f)());
        this.pages.registerPage("/inbox", ()=>new (0, $3500acc187b7ca85$export$fdf70f43a3a81415)());
        this.pages.registerPage("/pricing", ()=>new (0, $99f23431dbfc73c3$export$36d652602e27a852)());
        this.pages.registerPage("/academy", ()=>new (0, $20a878b3c010efc3$export$649513343506d210)());
        this.pages.registerPage("/livechat", ()=>new (0, $6fad8f87996cd842$export$3cbb6273c610a30)());
        this.pages.registerPage("/mail", ()=>new (0, $42b42b5f4a3c09a6$export$98018fbb31b537b8)());
        this.pages.registerPage("/publisher", ()=>new (0, $66fb1d5cfed2e426$export$574699e312ffd9fc)());
        this.pages.registerPage("/helpcenter", ()=>new (0, $193aa6d3c91baa2d$export$17f3ea6ee3033913)());
        this.pages.registerPage("/service-client", ()=>new (0, $c394b1d0979190fd$export$ea798b7c680ee0d5)());
        this.pages.registerPage("/statistics", ()=>new (0, $e5ced8850891e5d1$export$4f14dbe3a32e74d3)());
        this.pages.registerPage("/schedule", ()=>new (0, $08bda45b57402495$export$dad0f9f593647209)());
        this.pages.registerPage("/cgv", ()=>new (0, $07d53c5d349e0db1$export$fb06d92033ba4bca)());
        this.pages.registerPage("/smartblog", ()=>new (0, $da16cb06e6f63a3a$export$d7d15f70146cf1a7)());
        this.pages.registerPage("/ai", ()=>new (0, $9e0dc5aa3878b0a0$export$aa5b5f3c49dad377)());
        this.pages.registerPage("/autopilot", ()=>new (0, $9d3dd967f973b161$export$c87593f158eae05c)());
        this.pages.registerPage("/style", ()=>new (0, $0f5b9a40666e36a2$export$441a0cd60fee079c)());
        this.pages.registerPage("/analysis", ()=>new (0, $d5e0a38d2a4be226$export$ab7ea9573211da38)());
        this.pages.registerPage("/wix", ()=>new (0, $3ef160c9274a1d34$export$a58278a45a3d1e00)());
        this.pages.registerPage("/wordpress", ()=>new (0, $12c50e8eec9c918f$export$3a96fed2f93e0d19)());
        this.pages.registerPage("/shopify", ()=>new (0, $625a00ae57ce0a4a$export$cb59a6d6d90ba48b)());
        this.pages.registerPage("/prestashop", ()=>new (0, $a710c8248fd90b19$export$26219a799f10bcc9)());
        this.pages.registerPage("/cgu", ()=>new (0, $218ac6196cd5200e$export$2422684a229ca95d)());
        this.pages.registerPage("/policy", ()=>new (0, $b514d3fc36d88e4e$export$8c2ad8bee15c420d)());
        this.pages.path404 = "/404";
        this.pages.pathHome = "/home";
        this.pages.pathLogin = "/home";
    }
    registerStatic() {
        this.static.register("loader", new (0, $6c4be56322fba389$export$854fe5f7a33d16c2)());
    }
    onLogin() {
        this.pages.redirect(this.pages.pathHome);
    }
    onLogout() {
        setTimeout(()=>{
            this.pages.redirect(this.pages.pathLogin);
        }, 3000);
    }
}





class $06b74486bfb83daf$export$e9fe003e12bfbc08 {
    static async init() {
        this.router = new (0, $060834e4778a6d1c$export$6c295a1800b38e94)((0, $605c97b8166a54f7$export$b25f5cc1eb7681bd).website);
        await (0, $7AbeR.Network).start(this.router);
        await (0, $5FliW.Resources).init([
            this.router.language()
        ], this.router.languages);
        try {
            await Promise.all([
                await (0, $5FliW.Resources).loadI18n("website"),
                await (0, $5FliW.Resources).loadCountries(),
                await (0, $5FliW.Resources).loadWorldLanguages()
            ]);
        } catch (e) {}
        await this.router.init({
            defaultLanguage: (0, $5FliW.Resources).language,
            languages: (0, $5FliW.Resources).languages
        });
    }
}



var $7AbeR = parcelRequire("7AbeR");


var $fdmdr = parcelRequire("fdmdr");

var $9jYbZ = parcelRequire("9jYbZ");

var $7Aqrk = parcelRequire("7Aqrk");

var $g0YRJ = parcelRequire("g0YRJ");

var $fYPFR = parcelRequire("fYPFR");

var $bKmye = parcelRequire("bKmye");

var $68Z0d = parcelRequire("68Z0d");


var $2aBLW = parcelRequire("2aBLW");

var $fsnB5 = parcelRequire("fsnB5");
var $5dd4d2a71d96ce86$export$94079eade4e4655e;
var $5dd4d2a71d96ce86$export$97691fbb80847c19;
var $5dd4d2a71d96ce86$export$1ca1ec8b29a4ce27;
var $5dd4d2a71d96ce86$export$6f093cfa640b7166;
var $5dd4d2a71d96ce86$export$db3c28d99448dcff;
var $5dd4d2a71d96ce86$export$351f93dff0fc1e76;
var $5dd4d2a71d96ce86$export$a8ff84c12d48cfa6;
$5dd4d2a71d96ce86$export$94079eade4e4655e = "zRLIt";
$5dd4d2a71d96ce86$export$97691fbb80847c19 = "TKUoI";
$5dd4d2a71d96ce86$export$1ca1ec8b29a4ce27 = "C2Rxd";
$5dd4d2a71d96ce86$export$6f093cfa640b7166 = "XP-33";
$5dd4d2a71d96ce86$export$db3c28d99448dcff = "o8tgT";
$5dd4d2a71d96ce86$export$351f93dff0fc1e76 = "_7Y2KA";
$5dd4d2a71d96ce86$export$a8ff84c12d48cfa6 = "hu4NY";





var $kfkzw = parcelRequire("kfkzw");

var $5FliW = parcelRequire("5FliW");
class $c5dae9559cc8dadc$export$cb3fc5fbc3cd8ca6 extends (0, $fsnB5.Component) {
    constructor(){
        super();
        //language=HTML
        this.template = `
            <div class="${$5dd4d2a71d96ce86$export$94079eade4e4655e}">

                <div style="margin-top:100px;">
                    <div class="${$5dd4d2a71d96ce86$export$97691fbb80847c19}">
                        <div class="${$5dd4d2a71d96ce86$export$1ca1ec8b29a4ce27}">
                            ${this.draw(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).SEDESTRAL))}
                        </div>
                    </div>
                    <div class="${$5dd4d2a71d96ce86$export$97691fbb80847c19}">
                        <div class="${$5dd4d2a71d96ce86$export$6f093cfa640b7166}">
                            ${(0, $5FliW.Resources).t("words.unavailableMessage")}
                        </div>
                    </div>
                    <div class="${$5dd4d2a71d96ce86$export$97691fbb80847c19}">
                        <div style="position: relative;height: 80px;width: 100%;">
                            ${this.draw(new (0, $34e30a061648660e$export$8ed40a6e8d9e757d)())}
                        </div>
                    </div>
                    <div class="${$5dd4d2a71d96ce86$export$97691fbb80847c19}">
                        <div class="${$5dd4d2a71d96ce86$export$db3c28d99448dcff}">
                            <div class="${$5dd4d2a71d96ce86$export$351f93dff0fc1e76}">
                                ${this.draw(new (0, $e44d13759b9e9405$export$5c3f85cf9710806e)((0, $kfkzw.ProductType).SEDESTRAL))}
                            </div>
                            <div class="${$5dd4d2a71d96ce86$export$a8ff84c12d48cfa6}">
                                Sedestral
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        `;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");
class $cee9b6c023f6bf1b$export$3aed5f2d684ba248 {
    static init() {}
    static dispose() {}
    /**
     * http
     */ static async create(currentToken, isMobile, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).PANEL, "/webpush", {
            token: currentToken,
            isMobile: isMobile
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let webPush = request.data;
        }
    }
}



var $1b6Hd = parcelRequire("1b6Hd");
var $a381df8a51fba94f$export$952b839b257f74a4 = /*#__PURE__*/ function(StatisticsSplitType) {
    StatisticsSplitType[StatisticsSplitType["HOUR"] = 1] = "HOUR";
    StatisticsSplitType[StatisticsSplitType["DAY"] = 2] = "DAY";
    StatisticsSplitType[StatisticsSplitType["WEEK"] = 3] = "WEEK";
    StatisticsSplitType[StatisticsSplitType["MONTH"] = 4] = "MONTH";
    return StatisticsSplitType;
}({});



var $5FliW = parcelRequire("5FliW");


var $h08y3 = parcelRequire("h08y3");

var $i4Vbe = parcelRequire("i4Vbe");

var $h08y3 = parcelRequire("h08y3");

var $hpTr2 = parcelRequire("hpTr2");
function $f0975ec41bdd1f68$export$eb61126ed8585dd(startTime, endTime) {
    let from = (0, $hpTr2.dateToCompare)(new Date(startTime));
    let to = (0, $hpTr2.dateToCompare)(new Date(endTime), true);
    let daysCount = (0, $h08y3.dateCountDaysBetweenDates)(from, to);
    let result = [];
    for(let i = 0; i < daysCount; i++){
        if (from.getDay() == 1) result.push(new Date((0, $hpTr2.dateToCompare)(from)));
        from.setDate(from.getDate() + 1);
    }
    return result;
}


/**
 * Retourne les codes de mois entre deux dates
 */ 
var $h08y3 = parcelRequire("h08y3");

var $hpTr2 = parcelRequire("hpTr2");
function $e2859abb198df423$export$dfb4d92304ae9a88(startTime, endTime) {
    let months = [];
    let from = (0, $hpTr2.dateToCompare)(new Date(startTime));
    let to = (0, $hpTr2.dateToCompare)(new Date(endTime), true);
    let daysCount = (0, $h08y3.dateCountDaysBetweenDates)(from, to);
    for(let i = 0; i < daysCount; i++){
        if (months.filter((value)=>value[0] == from.getFullYear() && value[1] == from.getMonth())[0] == undefined) months.push([
            from.getFullYear(),
            from.getMonth()
        ]);
        from.setDate(from.getDate() + 1);
    }
    return months;
}


/**
 * date format display date
 */ function $bc6c1f71aa6c2ad3$export$f38b86edb697ac0d(date, language, format) {
    let formatter = new Intl.DateTimeFormat(language, format == undefined ? {
        day: "numeric",
        month: "long",
        year: "numeric"
    } : format);
    return formatter.format(date);
}



var $hpTr2 = parcelRequire("hpTr2");
/**
 * Retourne retourne l'année et le code de semaine
 */ function $44d8da2ea318855a$export$2d23e4485b86a497(d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    //console.log(d.getUTCDate() + 4 - (d.getUTCDay() || 2))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 3));
    let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // @ts-ignore
    let weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return [
        d.getUTCFullYear(),
        weekNo
    ];
}


class $adef5ff04d8059af$export$2ba536885b8718d9 {
    static init() {}
    static dispose() {}
    /**
     * values to charts
     */ static cleanValues(values, oldValues) {
        if (oldValues[0].length > values[0].length) oldValues[0].splice(0, oldValues[0].length - values[0].length);
        if (values[0].length > oldValues[0].length) values[0].splice(0, values[0].length - oldValues[0].length);
        return [
            values,
            oldValues
        ];
    }
    static typeValues(type, startTime, endTime, values) {
        if (values == undefined) return [
            [],
            []
        ];
        switch(type){
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).HOUR:
                return $adef5ff04d8059af$export$2ba536885b8718d9.hourValues(startTime, endTime, values);
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).WEEK:
                return $adef5ff04d8059af$export$2ba536885b8718d9.weeksValues(startTime, endTime, values);
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).MONTH:
                return $adef5ff04d8059af$export$2ba536885b8718d9.monthsValues(startTime, endTime, values);
        }
        return $adef5ff04d8059af$export$2ba536885b8718d9.dayValues(startTime, endTime, values);
    }
    static hourValues(startTime, endTime, values) {
        let from = (0, $hpTr2.dateToCompare)(new Date(startTime));
        let to = (0, $hpTr2.dateToCompare)(new Date(endTime), true);
        let daysCount = (0, $h08y3.dateCountDaysBetweenDates)(from, to);
        let resultValues = [];
        let resultKeys = [];
        let now = Date.now();
        for(let i = 0; i < daysCount; i++){
            let dayDate = new Date(from);
            for(let h = 0; h < 24; h++){
                dayDate.setHours(h);
                if (dayDate.getTime() <= now) {
                    let value = values.find((v)=>v.dateKey == dayDate.getTime());
                    resultValues.push(value == undefined ? 0 : value.value);
                    resultKeys.push(dayDate.getTime());
                }
            }
            from.setDate(from.getDate() + 1);
        }
        return [
            resultValues,
            resultKeys
        ];
    }
    static dayValues(startTime, endTime, values) {
        let entries = {};
        let resultValues = [];
        let resultKeys = [];
        let from = (0, $hpTr2.dateToCompare)(new Date(startTime));
        let to = (0, $hpTr2.dateToCompare)(new Date(endTime), true);
        let daysCount = (0, $h08y3.dateCountDaysBetweenDates)(from, to);
        values.sort((a, b)=>a.dateKey > b.dateKey ? 1 : -1);
        values.forEach((value)=>entries[(0, $hpTr2.dateToCompare)(new Date(value.dateKey)).getTime()] = value.value);
        while(resultValues.length < daysCount){
            resultValues.push(entries[from.getTime()] == undefined ? 0 : entries[from.getTime()]);
            resultKeys.push(from.getTime());
            from.setDate(from.getDate() + 1);
        }
        return [
            resultValues,
            resultKeys
        ];
    }
    static weeksValues(startTime, endTime, values) {
        let sundays = (0, $f0975ec41bdd1f68$export$eb61126ed8585dd)(startTime, endTime);
        let resultValues = [];
        let resultKeys = [];
        for (let sunday of sundays){
            let weekResult = (0, $44d8da2ea318855a$export$2d23e4485b86a497)(sunday);
            let value = values.find((v)=>v.dateKey == weekResult[0] + weekResult[1]);
            resultValues.push(value ? value.value : 0);
            resultKeys.push(sunday.getTime());
        }
        return [
            resultValues,
            resultKeys
        ];
    }
    static monthsValues(startTime, endTime, values) {
        let months = (0, $e2859abb198df423$export$dfb4d92304ae9a88)(startTime, endTime);
        let resultValues = [];
        let resultKeys = [];
        for (let month of months){
            let value = values.find((v)=>v.dateKey == month[0] + month[1]);
            resultValues.push(value ? value.value : 0);
            resultKeys.push(new Date(month[0], month[1]).getTime());
        }
        return [
            resultValues,
            resultKeys
        ];
    }
    /**
     * format
     */ static valueFormat(date, type) {
        switch(type){
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).DAY:
                return (0, $bc6c1f71aa6c2ad3$export$f38b86edb697ac0d)(date, (0, $5FliW.Resources).language, {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                });
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).MONTH:
                return (0, $bc6c1f71aa6c2ad3$export$f38b86edb697ac0d)(date, (0, $5FliW.Resources).language, {
                    month: "short",
                    year: "numeric"
                });
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).WEEK:
                let endDate = new Date(date);
                endDate.setDate(endDate.getDate() + 7);
                return (0, $bc6c1f71aa6c2ad3$export$f38b86edb697ac0d)(date, (0, $5FliW.Resources).language, {
                    month: "short",
                    day: "numeric"
                }) + " - " + (0, $bc6c1f71aa6c2ad3$export$f38b86edb697ac0d)(endDate, (0, $5FliW.Resources).language, {
                    month: "short",
                    day: "numeric"
                });
            case (0, $a381df8a51fba94f$export$952b839b257f74a4).HOUR:
                date.setMinutes(0);
                return (0, $c675d49824235e50$export$1aac387c4ed0273c)(date);
        }
    }
    /**
     * time
     */ static startTime(previousDays) {
        return (0, $hpTr2.dateToCompare)((0, $i4Vbe.datePrevious)(previousDays)).getTime();
    }
    static endTime(startTime) {
        if (startTime) {
            let date = new Date(startTime);
            date.setDate(date.getDate() - 1);
            return (0, $hpTr2.dateToCompare)(date, true).getTime();
        } else return (0, $hpTr2.dateToCompare)(new Date(), true).getTime();
    }
}




var $jdUQG = parcelRequire("jdUQG");

var $kCcuA = parcelRequire("kCcuA");

var $jdUQG = parcelRequire("jdUQG");

var $4ymN9 = parcelRequire("4ymN9");

var $68Z0d = parcelRequire("68Z0d");
class $d493c1628d3686c4$export$bcc04e5ab52ff38 {
    static init() {}
    static dispose() {}
    static admin() {
        return (0, $jdUQG.RoleService).can((0, $4ymN9.RolePermissionsType).ADMINISTRATOR);
    }
    static blogWriting() {
        return (0, $jdUQG.RoleService).can((0, $4ymN9.RolePermissionsType).BLOG_WRITING, (0, $4ymN9.RolePermissionsType).BLOG_ADMINISTRATOR, (0, $4ymN9.RolePermissionsType).BLOG_PUBLISH);
    }
    static blogLoad() {
        return (0, $jdUQG.RoleService).can((0, $4ymN9.RolePermissionsType).BLOG_READING, (0, $4ymN9.RolePermissionsType).BLOG_WRITING, (0, $4ymN9.RolePermissionsType).BLOG_ADMINISTRATOR, (0, $4ymN9.RolePermissionsType).BLOG_PUBLISH);
    }
    static helpcenterWriting() {
        return (0, $jdUQG.RoleService).can((0, $4ymN9.RolePermissionsType).HELPCENTER_WRITING, (0, $4ymN9.RolePermissionsType).HELPCENTER_ADMINISTRATOR, (0, $4ymN9.RolePermissionsType).HELPCENTER_PUBLISH);
    }
    /**
     * product
     */ static canProduct(type) {
        if (!(0, $68Z0d.EntityService).activeSite) return false;
        return (0, $68Z0d.EntityService).activeSite.products.includes(type);
    }
    /**
     * utilities
     */ static d(permission) {
        return permission ? `` : `display:none;`;
    }
    static o(permission) {
        return permission ? `` : `opacity:0.3;pointer-events:none;`;
    }
}



var $i3Hbv = parcelRequire("i3Hbv");

var $7AbeR = parcelRequire("7AbeR");

var $2eT6g = parcelRequire("2eT6g");

var $2Y8XI = parcelRequire("2Y8XI");

var $7Aqrk = parcelRequire("7Aqrk");

var $j8ebN = parcelRequire("j8ebN");

var $bKmye = parcelRequire("bKmye");
/**
 * Observable class prototype.
 *
 * @module observable
 */ /**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $525cb12bf06b8e36$export$185802fd694ee1f5 = ()=>new Map();
const $525cb12bf06b8e36$export$784d13d8ee351f07 = (m)=>{
    const r = $525cb12bf06b8e36$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $525cb12bf06b8e36$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $525cb12bf06b8e36$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $525cb12bf06b8e36$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $525cb12bf06b8e36$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};


/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $e958eb447fee22f4$export$185802fd694ee1f5 = ()=>new Set();
const $e958eb447fee22f4$export$45b10814cc054894 = (set)=>Array.from(set);
const $e958eb447fee22f4$export$43128fadae87b74a = (set)=>{
    var _set_values_next_value;
    return (_set_values_next_value = set.values().next().value) !== null && _set_values_next_value !== void 0 ? _set_values_next_value : undefined;
};
const $e958eb447fee22f4$export$6788812c4e6611e6 = (entries)=>new Set(entries);


/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
const $9d3c953c20b3f869$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $9d3c953c20b3f869$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $9d3c953c20b3f869$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $9d3c953c20b3f869$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $9d3c953c20b3f869$export$6788812c4e6611e6 = Array.from;
const $9d3c953c20b3f869$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $9d3c953c20b3f869$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $9d3c953c20b3f869$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $9d3c953c20b3f869$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $9d3c953c20b3f869$export$bffa455ba8c619a6 = (arr)=>$9d3c953c20b3f869$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $9d3c953c20b3f869$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $9d3c953c20b3f869$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $9d3c953c20b3f869$export$43bee75e5e14138e = Array.isArray;
const $9d3c953c20b3f869$export$7a5d5c156e7dc406 = (arr)=>$9d3c953c20b3f869$export$6788812c4e6611e6($e958eb447fee22f4$export$6788812c4e6611e6(arr));
const $9d3c953c20b3f869$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $e958eb447fee22f4$export$185802fd694ee1f5();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
const $9d3c953c20b3f869$export$871de8747c9eaa88 = (arr, mapper)=>{
    /**
   * @type {Array<any>}
   */ const res = Array(arr.length);
    for(let i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};


class $be5de554a627eab7$export$e23d3436ce401adc {
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ on(name, f) {
        $525cb12bf06b8e36$export$dccd489362a8619(this._observers, /** @type {string} */ name, $e958eb447fee22f4$export$185802fd694ee1f5).add(f);
        return f;
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, /** @type {any} */ _f);
            f(...args);
        };
        this.on(name, /** @type {any} */ _f);
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $9d3c953c20b3f869$export$6788812c4e6611e6((this._observers.get(name) || $525cb12bf06b8e36$export$185802fd694ee1f5()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $525cb12bf06b8e36$export$185802fd694ee1f5();
    }
    constructor(){
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $525cb12bf06b8e36$export$185802fd694ee1f5();
    }
}
class $be5de554a627eab7$export$77cea355fa80b5f4 {
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $525cb12bf06b8e36$export$dccd489362a8619(this._observers, name, $e958eb447fee22f4$export$185802fd694ee1f5).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $9d3c953c20b3f869$export$6788812c4e6611e6((this._observers.get(name) || $525cb12bf06b8e36$export$185802fd694ee1f5()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $525cb12bf06b8e36$export$185802fd694ee1f5();
    }
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $525cb12bf06b8e36$export$185802fd694ee1f5();
    }
} /* c8 ignore end */ 



/**
 * Common Math expressions.
 *
 * @module math
 */ const $03d3cbe4a95134dd$export$a3fe094919f356fd = Math.floor;
const $03d3cbe4a95134dd$export$803ce6b71a0a94b2 = Math.ceil;
const $03d3cbe4a95134dd$export$2335f513bbd82c6d = Math.abs;
const $03d3cbe4a95134dd$export$46de3d998ca9a030 = Math.imul;
const $03d3cbe4a95134dd$export$2077e0241d6afd3c = Math.round;
const $03d3cbe4a95134dd$export$75e08744a3ff8516 = Math.log10;
const $03d3cbe4a95134dd$export$b9fae0bba9d9094d = Math.log2;
const $03d3cbe4a95134dd$export$bef1f36f5486a6a3 = Math.log;
const $03d3cbe4a95134dd$export$eba8049fb5020b81 = Math.sqrt;
const $03d3cbe4a95134dd$export$e16d8520af44a096 = (a, b)=>a + b;
const $03d3cbe4a95134dd$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $03d3cbe4a95134dd$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $03d3cbe4a95134dd$export$c9f5652083b8129d = Number.isNaN;
const $03d3cbe4a95134dd$export$9c297f60e22e3389 = Math.pow;
const $03d3cbe4a95134dd$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $03d3cbe4a95134dd$export$c5552dfdbc7cec71 = Math.sign;
const $03d3cbe4a95134dd$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;



/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $0844609dcbe0a62a$export$ee2c6657cb286da4 = 1;
const $0844609dcbe0a62a$export$1f117f3b0edc2676 = 2;
const $0844609dcbe0a62a$export$e5294f8c78cf7711 = 4;
const $0844609dcbe0a62a$export$873ae8db4cef5125 = 8;
const $0844609dcbe0a62a$export$b6e6496517dfbd31 = 16;
const $0844609dcbe0a62a$export$daf23f774967089 = 32;
const $0844609dcbe0a62a$export$eb5a8e0006ab4bb5 = 64;
const $0844609dcbe0a62a$export$e25597372303a045 = 128;
const $0844609dcbe0a62a$export$f15587807021fe79 = 256;
const $0844609dcbe0a62a$export$70939d57ba836c5 = 512;
const $0844609dcbe0a62a$export$9ec47920d80e8c85 = 1024;
const $0844609dcbe0a62a$export$bc5dd16b35d4584b = 2048;
const $0844609dcbe0a62a$export$76a85e893e6d6ecc = 4096;
const $0844609dcbe0a62a$export$fb6ca64a3ffa3aa9 = 8192;
const $0844609dcbe0a62a$export$e7adc86ee9ea4b00 = 16384;
const $0844609dcbe0a62a$export$6aa68b9346d558bb = 32768;
const $0844609dcbe0a62a$export$5d7aab37466c79ea = 65536;
const $0844609dcbe0a62a$export$3aa401309ff3940 = 131072;
const $0844609dcbe0a62a$export$1fd8467d3320465f = 262144;
const $0844609dcbe0a62a$export$d1dceb84a396f684 = 524288;
const $0844609dcbe0a62a$export$ef62e7729d79baec = 1048576;
const $0844609dcbe0a62a$export$40651ae3846a7710 = 2097152;
const $0844609dcbe0a62a$export$e03976987cb0b818 = 4194304;
const $0844609dcbe0a62a$export$dd5dceb22223d8ef = 8388608;
const $0844609dcbe0a62a$export$aecaefba6ae044e4 = 16777216;
const $0844609dcbe0a62a$export$6e47d6f6c411c0e1 = 33554432;
const $0844609dcbe0a62a$export$321a8fda0150a18 = 67108864;
const $0844609dcbe0a62a$export$d7843230fff08622 = 134217728;
const $0844609dcbe0a62a$export$9fe7219cb72d1ed8 = 268435456;
const $0844609dcbe0a62a$export$c85121a54e1cc97f = 536870912;
const $0844609dcbe0a62a$export$76075a64dc7c21ef = 1073741824;
const $0844609dcbe0a62a$export$49d5cdcf29800e09 = -2147483648;
const $0844609dcbe0a62a$export$853d99058378c102 = 0;
const $0844609dcbe0a62a$export$b859c32a415b3ec1 = 1;
const $0844609dcbe0a62a$export$decefe6957191373 = 3;
const $0844609dcbe0a62a$export$d1defff3cbd2c6f4 = 7;
const $0844609dcbe0a62a$export$8d2b432c8c02ae65 = 15;
const $0844609dcbe0a62a$export$bc2aba63e4099c09 = 31;
const $0844609dcbe0a62a$export$f39f4e074e983a34 = 63;
const $0844609dcbe0a62a$export$f84d6bebff154ceb = 127;
const $0844609dcbe0a62a$export$c880072ee0e87648 = 255;
const $0844609dcbe0a62a$export$cbbfa5d3c076ad8c = 511;
const $0844609dcbe0a62a$export$e365aa75b5fa7293 = 1023;
const $0844609dcbe0a62a$export$51bfc23c1b7b60c3 = 2047;
const $0844609dcbe0a62a$export$3b0a099b88523ac = 4095;
const $0844609dcbe0a62a$export$8345c1c06d3e5fc1 = 8191;
const $0844609dcbe0a62a$export$e20cffba663a7688 = 16383;
const $0844609dcbe0a62a$export$cd0970fd37b207c6 = 32767;
const $0844609dcbe0a62a$export$250487b182389b6a = 65535;
const $0844609dcbe0a62a$export$9d6e01d73abdaadb = $0844609dcbe0a62a$export$3aa401309ff3940 - 1;
const $0844609dcbe0a62a$export$eedeab0ac4009664 = $0844609dcbe0a62a$export$1fd8467d3320465f - 1;
const $0844609dcbe0a62a$export$e1840c3c33a76ffc = $0844609dcbe0a62a$export$d1dceb84a396f684 - 1;
const $0844609dcbe0a62a$export$f0ae3ba8312e92e3 = $0844609dcbe0a62a$export$ef62e7729d79baec - 1;
const $0844609dcbe0a62a$export$b5ffbef7f0f6f536 = $0844609dcbe0a62a$export$40651ae3846a7710 - 1;
const $0844609dcbe0a62a$export$33ae34bc8e747862 = $0844609dcbe0a62a$export$e03976987cb0b818 - 1;
const $0844609dcbe0a62a$export$3629272792e6a9a0 = $0844609dcbe0a62a$export$dd5dceb22223d8ef - 1;
const $0844609dcbe0a62a$export$a07300a4cc2ba23c = $0844609dcbe0a62a$export$aecaefba6ae044e4 - 1;
const $0844609dcbe0a62a$export$9137f2824b26e02b = $0844609dcbe0a62a$export$6e47d6f6c411c0e1 - 1;
const $0844609dcbe0a62a$export$94d4c3aa7cfbb8dd = $0844609dcbe0a62a$export$321a8fda0150a18 - 1;
const $0844609dcbe0a62a$export$8af89455097efce0 = $0844609dcbe0a62a$export$d7843230fff08622 - 1;
const $0844609dcbe0a62a$export$dee9196bb8567fe9 = $0844609dcbe0a62a$export$9fe7219cb72d1ed8 - 1;
const $0844609dcbe0a62a$export$bd0b5ef1d89e90f = $0844609dcbe0a62a$export$c85121a54e1cc97f - 1;
const $0844609dcbe0a62a$export$e5560e011efa8766 = $0844609dcbe0a62a$export$76075a64dc7c21ef - 1;
const $0844609dcbe0a62a$export$87ec42487f19c66c = 0x7FFFFFFF;
const $0844609dcbe0a62a$export$3ea07c5174cba08a = 0xFFFFFFFF;


const $7b399bf19462644e$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $7b399bf19462644e$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $7b399bf19462644e$export$7accc3db8e859605 = -2147483648;
const $7b399bf19462644e$export$a5f353c3c14c00d0 = $0844609dcbe0a62a$export$87ec42487f19c66c;
const $7b399bf19462644e$export$f055c566d4c0f541 = $0844609dcbe0a62a$export$3ea07c5174cba08a;
const $7b399bf19462644e$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === 'number' && isFinite(num) && $03d3cbe4a95134dd$export$a3fe094919f356fd(num) === num);
const $7b399bf19462644e$export$c9f5652083b8129d = Number.isNaN;
const $7b399bf19462644e$export$5f87784a266e50a4 = Number.parseInt;
const $7b399bf19462644e$export$33de6ea056a4cdbb = (n)=>{
    n &= $0844609dcbe0a62a$export$3ea07c5174cba08a;
    let count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};




const $36b37b8c4e1afb7f$export$30216c0101da0ee0 = String.fromCharCode;
const $36b37b8c4e1afb7f$export$73bfc63873071f74 = String.fromCodePoint;
const $36b37b8c4e1afb7f$export$e3a9a653b2a11ac1 = $36b37b8c4e1afb7f$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $36b37b8c4e1afb7f$var$toLowerCase = (s)=>s.toLowerCase();
const $36b37b8c4e1afb7f$var$trimLeftRegex = /^\s*/g;
const $36b37b8c4e1afb7f$export$c5557f40488c48ec = (s)=>s.replace($36b37b8c4e1afb7f$var$trimLeftRegex, '');
const $36b37b8c4e1afb7f$var$fromCamelCaseRegex = /([A-Z])/g;
const $36b37b8c4e1afb7f$export$87429743646c3257 = (s, separator)=>$36b37b8c4e1afb7f$export$c5557f40488c48ec(s.replace($36b37b8c4e1afb7f$var$fromCamelCaseRegex, (match)=>`${separator}${$36b37b8c4e1afb7f$var$toLowerCase(match)}`));
const $36b37b8c4e1afb7f$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $36b37b8c4e1afb7f$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $36b37b8c4e1afb7f$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
const $36b37b8c4e1afb7f$export$9a0a70804ee285dd = (str)=>$36b37b8c4e1afb7f$export$f3ce4806f2484eb.encode(str);
const $36b37b8c4e1afb7f$export$8f647c2204da8484 = $36b37b8c4e1afb7f$export$f3ce4806f2484eb ? $36b37b8c4e1afb7f$export$9a0a70804ee285dd : $36b37b8c4e1afb7f$export$83d8cea287b4dfcd;
const $36b37b8c4e1afb7f$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = '';
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $36b37b8c4e1afb7f$export$f477633695bbbcd = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($36b37b8c4e1afb7f$export$f477633695bbbcd && $36b37b8c4e1afb7f$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $36b37b8c4e1afb7f$export$f477633695bbbcd = null;
const $36b37b8c4e1afb7f$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $36b37b8c4e1afb7f$export$f477633695bbbcd.decode(buf);
const $36b37b8c4e1afb7f$export$72118b85b055afd = $36b37b8c4e1afb7f$export$f477633695bbbcd ? $36b37b8c4e1afb7f$export$23d5f1ce72f56168 : $36b37b8c4e1afb7f$export$154b750182ae32cf;
const $36b37b8c4e1afb7f$export$869882364835d202 = (str, index, remove, insert = '')=>str.slice(0, index) + insert + str.slice(index + remove);
const $36b37b8c4e1afb7f$export$76d90c956114f2c2 = (source, n)=>$9d3c953c20b3f869$export$c48e357c1a89b78d(n, ()=>source).join('');



class $f760bbc2c6d392e1$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $f760bbc2c6d392e1$export$4e76eeb6df88c889 = ()=>new $f760bbc2c6d392e1$export$a50aceb0e02a00aa();
const $f760bbc2c6d392e1$export$c564cdbbe6da493 = (f)=>{
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    f(encoder);
    return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
};
const $f760bbc2c6d392e1$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $f760bbc2c6d392e1$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $f760bbc2c6d392e1$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($f760bbc2c6d392e1$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $f760bbc2c6d392e1$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($03d3cbe4a95134dd$export$8960430cfd85939f(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $f760bbc2c6d392e1$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $f760bbc2c6d392e1$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $f760bbc2c6d392e1$export$826a1a6619653272 = $f760bbc2c6d392e1$export$68d8715fc104d294;
const $f760bbc2c6d392e1$export$83964ea8501fbf8 = $f760bbc2c6d392e1$export$adaa4cf7ef1b65be;
const $f760bbc2c6d392e1$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, num & $0844609dcbe0a62a$export$c880072ee0e87648);
    $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, num >>> 8 & $0844609dcbe0a62a$export$c880072ee0e87648);
};
const $f760bbc2c6d392e1$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $f760bbc2c6d392e1$export$adaa4cf7ef1b65be(encoder, pos, num & $0844609dcbe0a62a$export$c880072ee0e87648);
    $f760bbc2c6d392e1$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $0844609dcbe0a62a$export$c880072ee0e87648);
};
const $f760bbc2c6d392e1$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, num & $0844609dcbe0a62a$export$c880072ee0e87648);
        num >>>= 8;
    }
};
const $f760bbc2c6d392e1$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$f760bbc2c6d392e1$export$68d8715fc104d294(encoder, num >>> 8 * i & $0844609dcbe0a62a$export$c880072ee0e87648);
};
const $f760bbc2c6d392e1$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $f760bbc2c6d392e1$export$adaa4cf7ef1b65be(encoder, pos + i, num & $0844609dcbe0a62a$export$c880072ee0e87648);
        num >>>= 8;
    }
};
const $f760bbc2c6d392e1$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $0844609dcbe0a62a$export$f84d6bebff154ceb){
        $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, $0844609dcbe0a62a$export$e25597372303a045 | $0844609dcbe0a62a$export$f84d6bebff154ceb & num);
        num = $03d3cbe4a95134dd$export$a3fe094919f356fd(num / 128) // shift >>> 7
        ;
    }
    $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, $0844609dcbe0a62a$export$f84d6bebff154ceb & num);
};
const $f760bbc2c6d392e1$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $03d3cbe4a95134dd$export$dc0a61f4a9121f92(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, (num > $0844609dcbe0a62a$export$f39f4e074e983a34 ? $0844609dcbe0a62a$export$e25597372303a045 : 0) | (isNegative ? $0844609dcbe0a62a$export$eb5a8e0006ab4bb5 : 0) | $0844609dcbe0a62a$export$f39f4e074e983a34 & num);
    num = $03d3cbe4a95134dd$export$a3fe094919f356fd(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, (num > $0844609dcbe0a62a$export$f84d6bebff154ceb ? $0844609dcbe0a62a$export$e25597372303a045 : 0) | $0844609dcbe0a62a$export$f84d6bebff154ceb & num);
        num = $03d3cbe4a95134dd$export$a3fe094919f356fd(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $f760bbc2c6d392e1$var$_strBuffer = new Uint8Array(30000);
const $f760bbc2c6d392e1$var$_maxStrBSize = $f760bbc2c6d392e1$var$_strBuffer.length / 3;
const $f760bbc2c6d392e1$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $f760bbc2c6d392e1$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $36b37b8c4e1afb7f$export$f3ce4806f2484eb.encodeInto(str, $f760bbc2c6d392e1$var$_strBuffer).written || 0;
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$f760bbc2c6d392e1$export$68d8715fc104d294(encoder, $f760bbc2c6d392e1$var$_strBuffer[i]);
    } else $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $36b37b8c4e1afb7f$export$8f647c2204da8484(str));
};
const $f760bbc2c6d392e1$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$f760bbc2c6d392e1$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $f760bbc2c6d392e1$export$dde49cb52d5f1650 = $36b37b8c4e1afb7f$export$f3ce4806f2484eb && /** @type {any} */ $36b37b8c4e1afb7f$export$f3ce4806f2484eb.encodeInto ? $f760bbc2c6d392e1$export$dff327976627e12b : $f760bbc2c6d392e1$export$94cf4193edfe959a;
const $f760bbc2c6d392e1$export$be5604ffb9fbbd0c = (encoder, str)=>$f760bbc2c6d392e1$export$6c17d6eec4abdaa6(encoder, $36b37b8c4e1afb7f$export$8f647c2204da8484(str));
const $f760bbc2c6d392e1$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 1);
        $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, buf[i]);
    }
    $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 0);
};
const $f760bbc2c6d392e1$export$c029b62321ea3da = (encoder, append)=>$f760bbc2c6d392e1$export$73b5e63e27d2b4c7(encoder, $f760bbc2c6d392e1$export$73470fd2221e6aef(append));
const $f760bbc2c6d392e1$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $03d3cbe4a95134dd$export$96ec731ed4dcb222(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($03d3cbe4a95134dd$export$8960430cfd85939f(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $f760bbc2c6d392e1$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $f760bbc2c6d392e1$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $f760bbc2c6d392e1$export$1f031ae9c71bd530 = (encoder, len)=>{
    $f760bbc2c6d392e1$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $f760bbc2c6d392e1$export$a33455db0a9638a6 = (encoder, num)=>$f760bbc2c6d392e1$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $f760bbc2c6d392e1$export$231a04cea676c54c = (encoder, num)=>$f760bbc2c6d392e1$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $f760bbc2c6d392e1$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $f760bbc2c6d392e1$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $f760bbc2c6d392e1$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $f760bbc2c6d392e1$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $f760bbc2c6d392e1$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $f760bbc2c6d392e1$var$isFloat32 = (num)=>{
    $f760bbc2c6d392e1$var$floatTestBed.setFloat32(0, num);
    return $f760bbc2c6d392e1$var$floatTestBed.getFloat32(0) === num;
};
const $f760bbc2c6d392e1$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case 'string':
            // TYPE 119: STRING
            $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 119);
            $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, data);
            break;
        case 'number':
            if ($7b399bf19462644e$export$a287f47fed4544b8(data) && $03d3cbe4a95134dd$export$2335f513bbd82c6d(data) <= $0844609dcbe0a62a$export$87ec42487f19c66c) {
                // TYPE 125: INTEGER
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 125);
                $f760bbc2c6d392e1$export$ff90f819e16cc9bb(encoder, data);
            } else if ($f760bbc2c6d392e1$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 124);
                $f760bbc2c6d392e1$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 123);
                $f760bbc2c6d392e1$export$231a04cea676c54c(encoder, data);
            }
            break;
        case 'bigint':
            // TYPE 122: BigInt
            $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 122);
            $f760bbc2c6d392e1$export$4fbfa93dd6e14543(encoder, data);
            break;
        case 'object':
            if (data === null) // TYPE 126: null
            $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 126);
            else if ($9d3c953c20b3f869$export$43bee75e5e14138e(data)) {
                // TYPE 117: Array
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 117);
                $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$f760bbc2c6d392e1$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 116);
                $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, key);
                    $f760bbc2c6d392e1$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case 'boolean':
            // TYPE 120/121: boolean (true/false)
            $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, 127);
    }
};
class $f760bbc2c6d392e1$export$8fa72bb4fa9409ff extends $f760bbc2c6d392e1$export$a50aceb0e02a00aa {
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $f760bbc2c6d392e1$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
}
class $f760bbc2c6d392e1$export$c636f3fa46f2752c extends $f760bbc2c6d392e1$export$a50aceb0e02a00aa {
    /**
   * @param {number} v
   */ write(v) {
        $f760bbc2c6d392e1$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
}
class $f760bbc2c6d392e1$export$29917ece4cb403fb extends $f760bbc2c6d392e1$export$a50aceb0e02a00aa {
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $f760bbc2c6d392e1$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $f760bbc2c6d392e1$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $f760bbc2c6d392e1$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $f760bbc2c6d392e1$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $f760bbc2c6d392e1$export$785ebd3312c38061 {
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $f760bbc2c6d392e1$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f760bbc2c6d392e1$var$flushUintOptRleEncoder(this);
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(this.encoder);
    }
    constructor(){
        this.encoder = new $f760bbc2c6d392e1$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
}
class $f760bbc2c6d392e1$export$f460a01fb0702193 {
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $f760bbc2c6d392e1$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f760bbc2c6d392e1$var$flushUintOptRleEncoder(this);
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(this.encoder);
    }
    constructor(){
        this.encoder = new $f760bbc2c6d392e1$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $f760bbc2c6d392e1$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $f760bbc2c6d392e1$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $f760bbc2c6d392e1$export$7542c66a59375c6f {
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $f760bbc2c6d392e1$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $f760bbc2c6d392e1$var$flushIntDiffOptRleEncoder(this);
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(this.encoder);
    }
    constructor(){
        this.encoder = new $f760bbc2c6d392e1$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
}
class $f760bbc2c6d392e1$export$7dcdc5c32f31c550 {
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = '';
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $f760bbc2c6d392e1$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = '';
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, this.sarr.join(''));
        $f760bbc2c6d392e1$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
    }
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = '';
        this.lensE = new $f760bbc2c6d392e1$export$785ebd3312c38061();
    }
}


/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 



/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $ac5470ebbde53fbd$export$185802fd694ee1f5 = (s)=>new Error(s);
const $ac5470ebbde53fbd$export$73ced5c7e10d6d0f = ()=>{
    throw $ac5470ebbde53fbd$export$185802fd694ee1f5('Method unimplemented');
};
const $ac5470ebbde53fbd$export$965b6bccecbd9673 = ()=>{
    throw $ac5470ebbde53fbd$export$185802fd694ee1f5('Unexpected case');
};



const $26cf1cc17970e4a1$var$errorUnexpectedEndOfArray = $ac5470ebbde53fbd$export$185802fd694ee1f5('Unexpected end of array');
const $26cf1cc17970e4a1$var$errorIntegerOutOfRange = $ac5470ebbde53fbd$export$185802fd694ee1f5('Integer out of Range');
class $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $26cf1cc17970e4a1$export$f8c898e83b60faaa = (uint8Array)=>new $26cf1cc17970e4a1$export$f9de6ca0bc043724(uint8Array);
const $26cf1cc17970e4a1$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $26cf1cc17970e4a1$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $26cf1cc17970e4a1$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $26cf1cc17970e4a1$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
const $26cf1cc17970e4a1$export$7418bbc18dee40f3 = (decoder)=>$26cf1cc17970e4a1$export$e21b2fe168d56a89(decoder, $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder));
const $26cf1cc17970e4a1$export$8c9f57cb3e3e2d3b = (decoder)=>$26cf1cc17970e4a1$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $26cf1cc17970e4a1$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $26cf1cc17970e4a1$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $26cf1cc17970e4a1$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $26cf1cc17970e4a1$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $26cf1cc17970e4a1$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $26cf1cc17970e4a1$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $26cf1cc17970e4a1$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $26cf1cc17970e4a1$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $26cf1cc17970e4a1$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $0844609dcbe0a62a$export$f84d6bebff154ceb) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $0844609dcbe0a62a$export$e25597372303a045) return num;
        /* c8 ignore start */ if (num > $7b399bf19462644e$export$18510406f204a1b9) throw $26cf1cc17970e4a1$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $26cf1cc17970e4a1$var$errorUnexpectedEndOfArray;
};
const $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $0844609dcbe0a62a$export$f39f4e074e983a34;
    let mult = 64;
    const sign = (r & $0844609dcbe0a62a$export$eb5a8e0006ab4bb5) > 0 ? -1 : 1;
    if ((r & $0844609dcbe0a62a$export$e25597372303a045) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $0844609dcbe0a62a$export$f84d6bebff154ceb) * mult;
        mult *= 128;
        if (r < $0844609dcbe0a62a$export$e25597372303a045) return sign * num;
        /* c8 ignore start */ if (num > $7b399bf19462644e$export$18510406f204a1b9) throw $26cf1cc17970e4a1$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $26cf1cc17970e4a1$var$errorUnexpectedEndOfArray;
};
const $26cf1cc17970e4a1$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $26cf1cc17970e4a1$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $26cf1cc17970e4a1$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return '';
    else {
        let encodedString = String.fromCodePoint($26cf1cc17970e4a1$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($26cf1cc17970e4a1$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $26cf1cc17970e4a1$export$7247eefae50fb91a = (decoder)=>/** @type any */ $36b37b8c4e1afb7f$export$f477633695bbbcd.decode($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
const $26cf1cc17970e4a1$export$3b64b4d753b81ec2 = $36b37b8c4e1afb7f$export$f477633695bbbcd ? $26cf1cc17970e4a1$export$7247eefae50fb91a : $26cf1cc17970e4a1$export$e73299e6158668bb;
const $26cf1cc17970e4a1$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    let b;
    while(true){
        b = $26cf1cc17970e4a1$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
        if (b === 1) b = $26cf1cc17970e4a1$export$d5778a2beba4ceef(decoder);
        $f760bbc2c6d392e1$export$68d8715fc104d294(encoder, b);
    }
};
const $26cf1cc17970e4a1$export$d38ec182b293d566 = (decoder)=>$36b37b8c4e1afb7f$export$72118b85b055afd($26cf1cc17970e4a1$export$23764cfecad9ae2f(decoder));
const $26cf1cc17970e4a1$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $26cf1cc17970e4a1$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $26cf1cc17970e4a1$export$dbc4aa781d9afe3b = (decoder)=>$26cf1cc17970e4a1$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $26cf1cc17970e4a1$export$d89a471990a89a7f = (decoder)=>$26cf1cc17970e4a1$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $26cf1cc17970e4a1$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $26cf1cc17970e4a1$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $26cf1cc17970e4a1$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $26cf1cc17970e4a1$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $26cf1cc17970e4a1$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8,
    $26cf1cc17970e4a1$export$dbc4aa781d9afe3b,
    $26cf1cc17970e4a1$export$d89a471990a89a7f,
    $26cf1cc17970e4a1$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $26cf1cc17970e4a1$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder);
            obj[key] = $26cf1cc17970e4a1$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($26cf1cc17970e4a1$export$82863139061f472f(decoder));
        return arr;
    },
    $26cf1cc17970e4a1$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $26cf1cc17970e4a1$export$82863139061f472f = (decoder)=>$26cf1cc17970e4a1$var$readAnyLookupTable[127 - $26cf1cc17970e4a1$export$d5778a2beba4ceef(decoder)](decoder);
class $26cf1cc17970e4a1$export$f1f1200492b832af extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($26cf1cc17970e4a1$export$7ad75c69830b76d7(this)) this.count = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
}
class $26cf1cc17970e4a1$export$938378143fffe1b4 extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    /**
   * @return {number}
   */ read() {
        this.s += $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
}
class $26cf1cc17970e4a1$export$595b36f1b42934c6 extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(this);
            if ($26cf1cc17970e4a1$export$7ad75c69830b76d7(this)) this.count = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
}
class $26cf1cc17970e4a1$export$2dc62fb2f864b82e extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    read() {
        if (this.count === 0) {
            this.s = $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $03d3cbe4a95134dd$export$dc0a61f4a9121f92(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
}
class $26cf1cc17970e4a1$export$727389af14dfe417 extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    read() {
        if (this.count === 0) {
            this.s = $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $03d3cbe4a95134dd$export$dc0a61f4a9121f92(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
}
class $26cf1cc17970e4a1$export$d502ab0bf048a596 extends $26cf1cc17970e4a1$export$f9de6ca0bc043724 {
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $03d3cbe4a95134dd$export$a3fe094919f356fd(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
}
class $26cf1cc17970e4a1$export$63a7aa211a91ed69 {
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $26cf1cc17970e4a1$export$2dc62fb2f864b82e(uint8Array);
        this.str = $26cf1cc17970e4a1$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
}


/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 

/* eslint-env browser */ const $d1ea67f1361d78f0$export$f45422fd2e8042d4 = crypto.subtle;
const $d1ea67f1361d78f0$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);


const $505d68ca6296b3d2$export$bb0a9c36cf454ea0 = Math.random;
const $505d68ca6296b3d2$export$de9ffb9418dd7d0d = ()=>(0, $d1ea67f1361d78f0$export$960b9ff25e7d4257)(new Uint32Array(1))[0];
const $505d68ca6296b3d2$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $d1ea67f1361d78f0$export$960b9ff25e7d4257)(new Uint32Array(8));
    return (arr[0] & $0844609dcbe0a62a$export$b5ffbef7f0f6f536) * ($0844609dcbe0a62a$export$3ea07c5174cba08a + 1) + (arr[1] >>> 0);
};
const $505d68ca6296b3d2$export$a9a18ae5ba42aeab = (arr)=>arr[$03d3cbe4a95134dd$export$a3fe094919f356fd($505d68ca6296b3d2$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $505d68ca6296b3d2$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $505d68ca6296b3d2$export$abe4376e1bf796d6 = ()=>$505d68ca6296b3d2$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $505d68ca6296b3d2$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));


/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ /**
 * Utility module to work with time.
 *
 * @module time
 */ /**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
const $ddc548db641b1033$export$3c3f39195836e927 = 1e24;
const $ddc548db641b1033$export$bc1fc8bc8e1895cf = 1e21;
const $ddc548db641b1033$export$91377b751fc464a0 = 1e18;
const $ddc548db641b1033$export$fc10d2598c9417a5 = 1e15;
const $ddc548db641b1033$export$ce366dc9d5abf7ac = 1e12;
const $ddc548db641b1033$export$197e40aa3a484017 = 1e9;
const $ddc548db641b1033$export$580f1e8cf64f2815 = 1e6;
const $ddc548db641b1033$export$a3ed9693cfbf67fa = 1e3;
const $ddc548db641b1033$export$6ec17edd70114a88 = 1e2;
const $ddc548db641b1033$export$6ffbaf3528ca9f3f = 10;
const $ddc548db641b1033$export$ec5800edbd9f0b69 = 0.1;
const $ddc548db641b1033$export$9faf718fe58aaa35 = 0.01;
const $ddc548db641b1033$export$fab274f99578ceb6 = 1e-3;
const $ddc548db641b1033$export$77bd0ce503b87b26 = 1e-6;
const $ddc548db641b1033$export$ddef5c050164e23e = 1e-9;
const $ddc548db641b1033$export$e10c52a2ab594201 = 1e-12;
const $ddc548db641b1033$export$c49f04803481822 = 1e-15;
const $ddc548db641b1033$export$5510a0bcf77f39 = 1e-18;
const $ddc548db641b1033$export$2b85cc24af20b7fe = 1e-21;
const $ddc548db641b1033$export$a2878e23774b59ce = 1e-24;
const $ddc548db641b1033$var$prefixUp = [
    '',
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y'
];
const $ddc548db641b1033$var$prefixDown = [
    '',
    'm',
    "\u03BC",
    'n',
    'p',
    'f',
    'a',
    'z',
    'y'
];
const $ddc548db641b1033$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $03d3cbe4a95134dd$export$75e08744a3ff8516(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $ddc548db641b1033$var$prefixDown[-baseMultiplier] : $ddc548db641b1033$var$prefixUp[baseMultiplier];
    return {
        n: $03d3cbe4a95134dd$export$2077e0241d6afd3c((mult > 0 ? n / $03d3cbe4a95134dd$export$1bb2a14208c790f7(mult * 3) : n * $03d3cbe4a95134dd$export$1bb2a14208c790f7(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};



const $7e6fd9b4f77f8bda$export$aa350b96d91cd94 = ()=>new Date();
const $7e6fd9b4f77f8bda$export$1f77c0008d16313 = Date.now;
const $7e6fd9b4f77f8bda$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $ddc548db641b1033$export$82e9f45cca5ba907(d, -1);
        return $03d3cbe4a95134dd$export$2077e0241d6afd3c(p.n * 100) / 100 + p.prefix + 's';
    }
    d = $03d3cbe4a95134dd$export$a3fe094919f356fd(d / 1000);
    const seconds = d % 60;
    const minutes = $03d3cbe4a95134dd$export$a3fe094919f356fd(d / 60) % 60;
    const hours = $03d3cbe4a95134dd$export$a3fe094919f356fd(d / 3600) % 24;
    const days = $03d3cbe4a95134dd$export$a3fe094919f356fd(d / 86400);
    if (days > 0) return days + 'd' + (hours > 0 || minutes > 30 ? ' ' + (minutes > 30 ? hours + 1 : hours) + 'h' : '');
    if (hours > 0) /* c8 ignore next */ return hours + 'h' + (minutes > 0 || seconds > 30 ? ' ' + (seconds > 30 ? minutes + 1 : minutes) + 'min' : '');
    return minutes + 'min' + (seconds > 0 ? ' ' + seconds + 's' : '');
};


const $209bc47c6afc4cc1$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $209bc47c6afc4cc1$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $209bc47c6afc4cc1$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $209bc47c6afc4cc1$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $209bc47c6afc4cc1$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $209bc47c6afc4cc1$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $209bc47c6afc4cc1$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$209bc47c6afc4cc1$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($7e6fd9b4f77f8bda$export$1f77c0008d16313() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error('Timeout'));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $209bc47c6afc4cc1$export$6ab8c822a2b03a03 = async (check, timeout = 0, intervalResolution = 10)=>{
    const startTime = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
    const noTimeout = timeout <= 0;
    // eslint-disable-next-line no-unmodified-loop-condition
    while(noTimeout || $7e6fd9b4f77f8bda$export$1f77c0008d16313() - startTime <= timeout){
        if (await check()) return;
        await $209bc47c6afc4cc1$export$5c069c93d2b7493f(intervalResolution);
    }
    throw new Error('Timeout');
};
const $209bc47c6afc4cc1$export$5c069c93d2b7493f = (timeout)=>$209bc47c6afc4cc1$export$185802fd694ee1f5((resolve, _reject)=>setTimeout(resolve, timeout));
const $209bc47c6afc4cc1$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;


/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module environment
 */ 

/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $ccc8f512f8087b9b$export$43874719a1af321f = (v)=>v === undefined ? null : v;


/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $fe2925c7d83c1114$var$VarStoragePolyfill {
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
    constructor(){
        this.map = new Map();
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $fe2925c7d83c1114$var$_localStorage = new $fe2925c7d83c1114$var$VarStoragePolyfill();
let $fe2925c7d83c1114$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== 'undefined' && localStorage) {
        $fe2925c7d83c1114$var$_localStorage = localStorage;
        $fe2925c7d83c1114$var$usePolyfill = false;
    }
} catch (e) {}
const $fe2925c7d83c1114$export$86b84a8d42aa2c65 = $fe2925c7d83c1114$var$_localStorage;
const $fe2925c7d83c1114$export$bd913411069e59d3 = (eventHandler)=>$fe2925c7d83c1114$var$usePolyfill || addEventListener('storage', /** @type {any} */ eventHandler);
const $fe2925c7d83c1114$export$ff6a13ad336aa064 = (eventHandler)=>$fe2925c7d83c1114$var$usePolyfill || removeEventListener('storage', /** @type {any} */ eventHandler);


/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ const $d54324b97fded352$export$185802fd694ee1f5 = ()=>Object.create(null);
const $d54324b97fded352$export$e6e34fd1f2686227 = Object.assign;
const $d54324b97fded352$export$ed97f33186d4b816 = Object.keys;
const $d54324b97fded352$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $d54324b97fded352$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $d54324b97fded352$export$f24224f1c91d8156 = (obj)=>$d54324b97fded352$export$ed97f33186d4b816(obj).length;
const $d54324b97fded352$export$346677f925de839c = (obj)=>$d54324b97fded352$export$ed97f33186d4b816(obj).length;
const $d54324b97fded352$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $d54324b97fded352$export$dd1bc94b04021eeb = (obj)=>{
    // eslint-disable-next-line
    for(const _k in obj)return false;
    return true;
};
const $d54324b97fded352$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $d54324b97fded352$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $d54324b97fded352$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $d54324b97fded352$export$346677f925de839c(a) === $d54324b97fded352$export$346677f925de839c(b) && $d54324b97fded352$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $d54324b97fded352$export$bf9617eaf5d2451(b, key)) && b[key] === val);
const $d54324b97fded352$export$792f3d81ea979f55 = Object.freeze;
const $d54324b97fded352$export$7e32b29e1cb162e1 = (o)=>{
    for(const key in o){
        const c = o[key];
        if (typeof c === 'object' || typeof c === 'function') $d54324b97fded352$export$7e32b29e1cb162e1(o[key]);
    }
    return $d54324b97fded352$export$792f3d81ea979f55(o);
};


const $fabe4bd8d0c6d92b$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $fabe4bd8d0c6d92b$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $fabe4bd8d0c6d92b$export$b5f1cfe7b08e6ed5 = ()=>{};
const $fabe4bd8d0c6d92b$export$5635d7ef4b8fee1c = (f)=>f();
const $fabe4bd8d0c6d92b$export$d560c7e4a29451c2 = (a)=>a;
const $fabe4bd8d0c6d92b$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $fabe4bd8d0c6d92b$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($9d3c953c20b3f869$export$43bee75e5e14138e(a) && $9d3c953c20b3f869$export$4f1c34abb2bb4c8(a, /** @type {Array<T>} */ b) || typeof a === 'object' && $d54324b97fded352$export$4f1c34abb2bb4c8(a, b));
const $fabe4bd8d0c6d92b$export$2ca9a723affd5d11 = (a, b)=>{
    if (a == null || b == null) return $fabe4bd8d0c6d92b$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$fabe4bd8d0c6d92b$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case Object:
            if ($d54324b97fded352$export$f24224f1c91d8156(a) !== $d54324b97fded352$export$f24224f1c91d8156(b)) return false;
            for(const key in a){
                if (!$d54324b97fded352$export$bf9617eaf5d2451(a, key) || !$fabe4bd8d0c6d92b$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$fabe4bd8d0c6d92b$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $fabe4bd8d0c6d92b$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $fabe4bd8d0c6d92b$export$43bee75e5e14138e = $9d3c953c20b3f869$export$43bee75e5e14138e;
const $fabe4bd8d0c6d92b$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $fabe4bd8d0c6d92b$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $fabe4bd8d0c6d92b$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $fabe4bd8d0c6d92b$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;



var $f8ZNS = parcelRequire("f8ZNS");
const $1d21f59048a9fe89$export$8ee0fc9ee280b4ee = typeof $f8ZNS !== 'undefined' && $f8ZNS.release && /node|io\.js/.test($f8ZNS.release.name) && Object.prototype.toString.call(typeof $f8ZNS !== 'undefined' ? $f8ZNS : 0) === '[object process]';
const $1d21f59048a9fe89$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof document !== 'undefined' && !$1d21f59048a9fe89$export$8ee0fc9ee280b4ee;
const $1d21f59048a9fe89$export$9ac100e40613ea10 = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $1d21f59048a9fe89$var$params;
const $1d21f59048a9fe89$var$args = [];
/* c8 ignore start */ const $1d21f59048a9fe89$var$computeParams = ()=>{
    if ($1d21f59048a9fe89$var$params === undefined) {
        if ($1d21f59048a9fe89$export$8ee0fc9ee280b4ee) {
            $1d21f59048a9fe89$var$params = $525cb12bf06b8e36$export$185802fd694ee1f5();
            const pargs = $f8ZNS.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === '-') {
                    if (currParamName !== null) $1d21f59048a9fe89$var$params.set(currParamName, '');
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $1d21f59048a9fe89$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $1d21f59048a9fe89$var$args.push(parg);
            }
            if (currParamName !== null) $1d21f59048a9fe89$var$params.set(currParamName, '');
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === 'object') {
            $1d21f59048a9fe89$var$params = $525cb12bf06b8e36$export$185802fd694ee1f5(); // eslint-disable-next-line no-undef
            (location.search || '?').slice(1).split('&').forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split('=');
                    $1d21f59048a9fe89$var$params.set(`--${$36b37b8c4e1afb7f$export$87429743646c3257(key, '-')}`, value);
                    $1d21f59048a9fe89$var$params.set(`-${$36b37b8c4e1afb7f$export$87429743646c3257(key, '-')}`, value);
                }
            });
        } else $1d21f59048a9fe89$var$params = $525cb12bf06b8e36$export$185802fd694ee1f5();
    }
    return $1d21f59048a9fe89$var$params;
};
const $1d21f59048a9fe89$export$3ad523d4e4ddff75 = (name)=>$1d21f59048a9fe89$var$computeParams().has(name);
const $1d21f59048a9fe89$export$ecf541e09a511845 = (name, defaultVal)=>$1d21f59048a9fe89$var$computeParams().get(name) || defaultVal;
const $1d21f59048a9fe89$export$39fb32ac18db3f88 = (name)=>$1d21f59048a9fe89$export$8ee0fc9ee280b4ee ? $ccc8f512f8087b9b$export$43874719a1af321f($f8ZNS.env[name.toUpperCase().replaceAll('-', '_')]) : $ccc8f512f8087b9b$export$43874719a1af321f($fe2925c7d83c1114$export$86b84a8d42aa2c65.getItem(name));
const $1d21f59048a9fe89$export$137940a4fd07b923 = (name)=>$1d21f59048a9fe89$var$computeParams().get('--' + name) || $1d21f59048a9fe89$export$39fb32ac18db3f88(name);
const $1d21f59048a9fe89$export$e336c1d2b3b2390d = (name)=>{
    const c = $1d21f59048a9fe89$export$137940a4fd07b923(name);
    if (c == null) throw new Error(`Expected configuration "${name.toUpperCase().replaceAll('-', '_')}"`);
    return c;
};
const $1d21f59048a9fe89$export$41f29dc169f5b0eb = (name)=>$1d21f59048a9fe89$export$3ad523d4e4ddff75('--' + name) || $1d21f59048a9fe89$export$39fb32ac18db3f88(name) !== null;
const $1d21f59048a9fe89$export$d71d1489bc353e92 = $1d21f59048a9fe89$export$41f29dc169f5b0eb('production');
/* c8 ignore next 2 */ const $1d21f59048a9fe89$var$forceColor = $1d21f59048a9fe89$export$8ee0fc9ee280b4ee && $fabe4bd8d0c6d92b$export$532a90c0e5e8e48c(undefined, [
    'true',
    '1',
    '2'
]);
const $1d21f59048a9fe89$export$fcbe44f5d6fcebd = $1d21f59048a9fe89$var$forceColor || !$1d21f59048a9fe89$export$3ad523d4e4ddff75('--no-colors') && // @todo deprecate --no-colors
!$1d21f59048a9fe89$export$41f29dc169f5b0eb('no-color') && (!$1d21f59048a9fe89$export$8ee0fc9ee280b4ee || $f8ZNS.stdout.isTTY) && (!$1d21f59048a9fe89$export$8ee0fc9ee280b4ee || $1d21f59048a9fe89$export$3ad523d4e4ddff75('--color') || $1d21f59048a9fe89$export$39fb32ac18db3f88('COLORTERM') !== null || ($1d21f59048a9fe89$export$39fb32ac18db3f88('TERM') || '').includes('color')) /* c8 ignore stop */ ;







var $a94H4 = parcelRequire("a94H4");
var $e84e5e8aa33903d1$require$Buffer = $a94H4.Buffer;
const $e84e5e8aa33903d1$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $e84e5e8aa33903d1$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $e84e5e8aa33903d1$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $e84e5e8aa33903d1$var$toBase64Browser = (bytes)=>{
    let s = '';
    for(let i = 0; i < bytes.byteLength; i++)s += $36b37b8c4e1afb7f$export$30216c0101da0ee0(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $e84e5e8aa33903d1$var$toBase64Node = (bytes)=>$e84e5e8aa33903d1$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString('base64');
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ const $e84e5e8aa33903d1$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $e84e5e8aa33903d1$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ const $e84e5e8aa33903d1$var$fromBase64Node = (s)=>{
    const buf = $e84e5e8aa33903d1$require$Buffer.from(s, 'base64');
    return $e84e5e8aa33903d1$export$f3c8b5f6d250ec43(buf.buffer, buf.byteOffset, buf.byteLength);
};
const $e84e5e8aa33903d1$export$37cc283d8fbd3462 = $1d21f59048a9fe89$export$4e09c449d6c407f7 ? $e84e5e8aa33903d1$var$toBase64Browser : $e84e5e8aa33903d1$var$toBase64Node;
const $e84e5e8aa33903d1$export$c537b38001c583b7 = $1d21f59048a9fe89$export$4e09c449d6c407f7 ? $e84e5e8aa33903d1$var$fromBase64Browser : $e84e5e8aa33903d1$var$fromBase64Node;
const $e84e5e8aa33903d1$export$31f478961f22a29 = (buf)=>$e84e5e8aa33903d1$export$37cc283d8fbd3462(buf).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
const $e84e5e8aa33903d1$export$2fcb175ca881fa06 = (base64)=>$e84e5e8aa33903d1$export$c537b38001c583b7(base64.replaceAll('-', '+').replaceAll('_', '/'));
const $e84e5e8aa33903d1$export$f4915efbb94d4d01 = (buf)=>$9d3c953c20b3f869$export$871de8747c9eaa88(buf, (b)=>b.toString(16).padStart(2, '0')).join('');
const $e84e5e8aa33903d1$export$99a70112ceb8327b = (hex)=>{
    const hlen = hex.length;
    const buf = new Uint8Array($03d3cbe4a95134dd$export$803ce6b71a0a94b2(hlen / 2));
    for(let i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
const $e84e5e8aa33903d1$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $e84e5e8aa33903d1$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $e84e5e8aa33903d1$export$355ad3726be07997 = (data)=>$f760bbc2c6d392e1$export$c564cdbbe6da493((encoder)=>$f760bbc2c6d392e1$export$264b1e8551468ea(encoder, data));
const $e84e5e8aa33903d1$export$929c279cfec29a23 = (buf)=>$26cf1cc17970e4a1$export$82863139061f472f($26cf1cc17970e4a1$export$f8c898e83b60faaa(buf));
const $e84e5e8aa33903d1$export$e87773390ebfdab4 = (bs, N)=>{
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(let i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};






/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 

/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $8c1b82bf1be9645a$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $8c1b82bf1be9645a$export$185802fd694ee1f5 = (left, right)=>new $8c1b82bf1be9645a$export$d63d7cff08fe4dc9(left, right);
const $8c1b82bf1be9645a$export$ca0ea131672c5a9b = (right, left)=>new $8c1b82bf1be9645a$export$d63d7cff08fe4dc9(left, right);
const $8c1b82bf1be9645a$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $8c1b82bf1be9645a$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));


/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 

const $825bb0d7ea8a0421$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== 'undefined' ? document : {};
const $825bb0d7ea8a0421$export$c8a8987d4410bf2d = (name)=>$825bb0d7ea8a0421$export$2a111da947c407d2.createElement(name);
const $825bb0d7ea8a0421$export$fb51152cd5328759 = ()=>$825bb0d7ea8a0421$export$2a111da947c407d2.createDocumentFragment();
const $825bb0d7ea8a0421$export$b2ce9ad90858ed7a = (text)=>$825bb0d7ea8a0421$export$2a111da947c407d2.createTextNode(text);
const $825bb0d7ea8a0421$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== 'undefined' ? new DOMParser() : null;
const $825bb0d7ea8a0421$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $825bb0d7ea8a0421$export$74da2cba014bdc09 = (el, attrs)=>{
    $8c1b82bf1be9645a$export$4b80e395e36b5a56(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, '');
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $825bb0d7ea8a0421$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $825bb0d7ea8a0421$export$f00aeb236b6f05af = (children)=>{
    const fragment = $825bb0d7ea8a0421$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$825bb0d7ea8a0421$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $825bb0d7ea8a0421$export$10d8903dec122b9d = (parent, nodes)=>{
    $825bb0d7ea8a0421$export$1b8e57c9ea42f1d2(parent, $825bb0d7ea8a0421$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $825bb0d7ea8a0421$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $825bb0d7ea8a0421$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $825bb0d7ea8a0421$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $825bb0d7ea8a0421$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $8c1b82bf1be9645a$export$4b80e395e36b5a56(listeners, (name, f)=>$825bb0d7ea8a0421$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $825bb0d7ea8a0421$export$8c7b13b21690651d = (node, listeners)=>{
    $8c1b82bf1be9645a$export$4b80e395e36b5a56(listeners, (name, f)=>$825bb0d7ea8a0421$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $825bb0d7ea8a0421$export$8454457683f90105 = (name, attrs = [], children = [])=>$825bb0d7ea8a0421$export$10d8903dec122b9d($825bb0d7ea8a0421$export$74da2cba014bdc09($825bb0d7ea8a0421$export$c8a8987d4410bf2d(name), attrs), children);
const $825bb0d7ea8a0421$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $825bb0d7ea8a0421$export$c8a8987d4410bf2d('canvas');
    c.height = height;
    c.width = width;
    return c;
};
const $825bb0d7ea8a0421$export$6f093cfa640b7166 = $825bb0d7ea8a0421$export$b2ce9ad90858ed7a;
const $825bb0d7ea8a0421$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $825bb0d7ea8a0421$export$3d24a00500154f45 = (pairs)=>pairs.map($825bb0d7ea8a0421$export$7f60f118cd3e6292).join('');
const $825bb0d7ea8a0421$export$7d9cafe158c3b49 = (m)=>$525cb12bf06b8e36$export$871de8747c9eaa88(m, (value, key)=>`${key}:${value};`).join('');
const $825bb0d7ea8a0421$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $825bb0d7ea8a0421$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $825bb0d7ea8a0421$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $825bb0d7ea8a0421$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $825bb0d7ea8a0421$var$_parse = (html)=>$825bb0d7ea8a0421$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, 'text/html').body;
const $825bb0d7ea8a0421$export$e1152f5efcc82ad = (html)=>$825bb0d7ea8a0421$export$f00aeb236b6f05af(/** @type {any} */ $825bb0d7ea8a0421$var$_parse(html).childNodes);
const $825bb0d7ea8a0421$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $825bb0d7ea8a0421$var$_parse(html).firstElementChild;
const $825bb0d7ea8a0421$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $825bb0d7ea8a0421$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $825bb0d7ea8a0421$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $825bb0d7ea8a0421$export$51c8a276ee4b8f51 = $825bb0d7ea8a0421$export$2a111da947c407d2.ELEMENT_NODE;
const $825bb0d7ea8a0421$export$5bcc40203615fc2e = $825bb0d7ea8a0421$export$2a111da947c407d2.TEXT_NODE;
const $825bb0d7ea8a0421$export$e5fc6332c1c8eb8e = $825bb0d7ea8a0421$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $825bb0d7ea8a0421$export$3d597a6ef0f08b0a = $825bb0d7ea8a0421$export$2a111da947c407d2.COMMENT_NODE;
const $825bb0d7ea8a0421$export$4139dcda4f7f83db = $825bb0d7ea8a0421$export$2a111da947c407d2.DOCUMENT_NODE;
const $825bb0d7ea8a0421$export$e9e7ddfdb004b848 = $825bb0d7ea8a0421$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $825bb0d7ea8a0421$export$b86725031ae151ee = $825bb0d7ea8a0421$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $825bb0d7ea8a0421$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $825bb0d7ea8a0421$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;


/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $9e3741044e4acf78$export$fac44ee5b035f737 = JSON.stringify;
const $9e3741044e4acf78$export$98e6a39c04603d36 = JSON.parse;



/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $d845939d26f0868e$var$queue = [];
const $d845939d26f0868e$var$_runQueue = ()=>{
    for(let i = 0; i < $d845939d26f0868e$var$queue.length; i++)$d845939d26f0868e$var$queue[i]();
    $d845939d26f0868e$var$queue = [];
};
const $d845939d26f0868e$export$513072ba72100d9c = (f)=>{
    $d845939d26f0868e$var$queue.push(f);
    if ($d845939d26f0868e$var$queue.length === 1) setTimeout($d845939d26f0868e$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $d845939d26f0868e$var$createTimeoutClass = (clearFunction)=>{
    class TT {
        destroy() {
            clearFunction(this._);
        }
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
    }
    return TT;
};
const $d845939d26f0868e$var$Timeout = $d845939d26f0868e$var$createTimeoutClass(clearTimeout);
const $d845939d26f0868e$export$83e74882c5df8fe1 = (timeout, callback)=>new $d845939d26f0868e$var$Timeout(setTimeout(callback, timeout));
const $d845939d26f0868e$var$Interval = $d845939d26f0868e$var$createTimeoutClass(clearInterval);
const $d845939d26f0868e$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $d845939d26f0868e$var$Interval(setInterval(callback, timeout));
const $d845939d26f0868e$export$c35d437ae5945fcd = $d845939d26f0868e$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== 'undefined' && cancelAnimationFrame(arg));
const $d845939d26f0868e$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === 'undefined' ? $d845939d26f0868e$export$83e74882c5df8fe1(0, cb) : new $d845939d26f0868e$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $d845939d26f0868e$var$Idle = $d845939d26f0868e$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(arg));
const $d845939d26f0868e$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== 'undefined' ? new $d845939d26f0868e$var$Idle(requestIdleCallback(cb)) : $d845939d26f0868e$export$83e74882c5df8fe1(1000, cb);
const $d845939d26f0868e$export$21cd608c50c2ba31 = (timeout)=>{
    let timer = -1;
    return (f)=>{
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};



/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ const $65a677d3d0a3fa9c$export$185802fd694ee1f5 = Symbol;
const $65a677d3d0a3fa9c$export$a244864fd9645c7f = (s)=>typeof s === 'symbol';






const $d30ac04941c45b73$export$c1286c4c2a7c066 = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$f0ce1666bb40789b = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$738c3b9a44c87ecc = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$7d278ca694634874 = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$48d4b2cd5bc0e88b = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$aa201224bb439d47 = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$7ffdeca4b2f927a2 = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$3de5e29ed1757f9b = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$b586f81201748dd0 = $65a677d3d0a3fa9c$export$185802fd694ee1f5();
const $d30ac04941c45b73$export$3454091cc3c6c473 = (args)=>{
    var _args_;
    if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg === undefined) break;
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) break;
    }
    if (i > 0) // create logArgs with what we have so far
    logArgs.push(strBuilder.join(''));
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ const $d30ac04941c45b73$var$loggingColors = [
    $d30ac04941c45b73$export$48d4b2cd5bc0e88b,
    $d30ac04941c45b73$export$7ffdeca4b2f927a2,
    $d30ac04941c45b73$export$3de5e29ed1757f9b,
    $d30ac04941c45b73$export$738c3b9a44c87ecc
];
let $d30ac04941c45b73$var$nextColor = 0;
let $d30ac04941c45b73$var$lastLoggingTime = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
const $d30ac04941c45b73$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $d30ac04941c45b73$var$loggingColors[$d30ac04941c45b73$var$nextColor];
    const debugRegexVar = $1d21f59048a9fe89$export$39fb32ac18db3f88('log');
    const doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
    $d30ac04941c45b73$var$nextColor = ($d30ac04941c45b73$var$nextColor + 1) % $d30ac04941c45b73$var$loggingColors.length;
    moduleName += ': ';
    return !doLogging ? $fabe4bd8d0c6d92b$export$b5f1cfe7b08e6ed5 : (...args)=>{
        var _args_;
        if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = args[0]();
        const timeNow = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
        const timeDiff = timeNow - $d30ac04941c45b73$var$lastLoggingTime;
        $d30ac04941c45b73$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $d30ac04941c45b73$export$b586f81201748dd0, ...args.map((arg)=>{
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            const t = typeof arg;
            switch(t){
                case 'string':
                case 'symbol':
                    return arg;
                default:
                    return $9e3741044e4acf78$export$fac44ee5b035f737(arg);
            }
        }), color, ' +' + timeDiff + 'ms');
    };
} /* c8 ignore stop */ ;


/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $eaf1c30dff9742e4$var$_browserStyleMap = {
    [$d30ac04941c45b73$export$c1286c4c2a7c066]: $8c1b82bf1be9645a$export$185802fd694ee1f5('font-weight', 'bold'),
    [$d30ac04941c45b73$export$f0ce1666bb40789b]: $8c1b82bf1be9645a$export$185802fd694ee1f5('font-weight', 'normal'),
    [$d30ac04941c45b73$export$738c3b9a44c87ecc]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'blue'),
    [$d30ac04941c45b73$export$48d4b2cd5bc0e88b]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'green'),
    [$d30ac04941c45b73$export$7d278ca694634874]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'grey'),
    [$d30ac04941c45b73$export$aa201224bb439d47]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'red'),
    [$d30ac04941c45b73$export$7ffdeca4b2f927a2]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'purple'),
    [$d30ac04941c45b73$export$3de5e29ed1757f9b]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'orange'),
    [$d30ac04941c45b73$export$b586f81201748dd0]: $8c1b82bf1be9645a$export$185802fd694ee1f5('color', 'black')
};
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $eaf1c30dff9742e4$var$computeBrowserLoggingArgs = (args)=>{
    var _args_;
    if (args.length === 1 && ((_args_ = args[0]) === null || _args_ === void 0 ? void 0 : _args_.constructor) === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const styles = [];
    const currentStyle = $525cb12bf06b8e36$export$185802fd694ee1f5();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $eaf1c30dff9742e4$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $825bb0d7ea8a0421$export$7d9cafe158c3b49(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push('%c' + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(''));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $eaf1c30dff9742e4$var$computeLoggingArgs = $1d21f59048a9fe89$export$fcbe44f5d6fcebd ? $eaf1c30dff9742e4$var$computeBrowserLoggingArgs : $d30ac04941c45b73$export$3454091cc3c6c473;
const $eaf1c30dff9742e4$export$c2d084dc44961371 = (...args)=>{
    console.log(...$eaf1c30dff9742e4$var$computeLoggingArgs(args));
    /* c8 ignore next */ $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $eaf1c30dff9742e4$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$eaf1c30dff9742e4$var$computeLoggingArgs(args));
    args.unshift($d30ac04941c45b73$export$3de5e29ed1757f9b);
    $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $eaf1c30dff9742e4$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $eaf1c30dff9742e4$export$85acd411250ab137 = (url, height)=>{
    if ($1d21f59048a9fe89$export$4e09c449d6c407f7) console.log('%c                      ', `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $eaf1c30dff9742e4$export$fcd48d8a033dbfbf = (base64, height)=>$eaf1c30dff9742e4$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $eaf1c30dff9742e4$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$eaf1c30dff9742e4$var$computeLoggingArgs(args));
    /* c8 ignore next */ $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $eaf1c30dff9742e4$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$eaf1c30dff9742e4$var$computeLoggingArgs(args));
    /* c8 ignore next */ $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $eaf1c30dff9742e4$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $eaf1c30dff9742e4$export$76dff282388623b3 = (createNode)=>$eaf1c30dff9742e4$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $eaf1c30dff9742e4$export$98f2e847362d891 = (canvas, height)=>$eaf1c30dff9742e4$export$85acd411250ab137(canvas.toDataURL(), height);
const $eaf1c30dff9742e4$export$6f0283bff34730a1 = $e958eb447fee22f4$export$185802fd694ee1f5();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $eaf1c30dff9742e4$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        let arg = args[i];
        // @ts-ignore
        const style = $eaf1c30dff9742e4$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = 'undefined ';
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $825bb0d7ea8a0421$export$8454457683f90105('span', [
                    $8c1b82bf1be9645a$export$185802fd694ee1f5('style', $825bb0d7ea8a0421$export$7d9cafe158c3b49(currentStyle))
                ], [
                    $825bb0d7ea8a0421$export$6f093cfa640b7166(arg.toString())
                ]);
                if (span.innerHTML === '') span.innerHTML = '&nbsp;';
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = ' ' + $9e3741044e4acf78$export$fac44ee5b035f737(content) + ' ';
            spans.push($825bb0d7ea8a0421$export$8454457683f90105('span', [], [
                $825bb0d7ea8a0421$export$6f093cfa640b7166(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $eaf1c30dff9742e4$var$lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';
class $eaf1c30dff9742e4$export$79dd518d42f6d7a1 {
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            const triangleDown = $825bb0d7ea8a0421$export$8454457683f90105('span', [
                $8c1b82bf1be9645a$export$185802fd694ee1f5('hidden', collapsed),
                $8c1b82bf1be9645a$export$185802fd694ee1f5('style', 'color:grey;font-size:120%;')
            ], [
                $825bb0d7ea8a0421$export$6f093cfa640b7166("\u25BC")
            ]);
            const triangleRight = $825bb0d7ea8a0421$export$8454457683f90105('span', [
                $8c1b82bf1be9645a$export$185802fd694ee1f5('hidden', !collapsed),
                $8c1b82bf1be9645a$export$185802fd694ee1f5('style', 'color:grey;font-size:125%;')
            ], [
                $825bb0d7ea8a0421$export$6f093cfa640b7166("\u25B6")
            ]);
            const content = $825bb0d7ea8a0421$export$8454457683f90105('div', [
                $8c1b82bf1be9645a$export$185802fd694ee1f5('style', `${$eaf1c30dff9742e4$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $825bb0d7ea8a0421$export$6f093cfa640b7166(' ')
            ].concat($eaf1c30dff9742e4$var$_computeLineSpans(args)));
            const nextContainer = $825bb0d7ea8a0421$export$8454457683f90105('div', [
                $8c1b82bf1be9645a$export$185802fd694ee1f5('hidden', collapsed)
            ]);
            const nextLine = $825bb0d7ea8a0421$export$8454457683f90105('div', [], [
                content,
                nextContainer
            ]);
            $825bb0d7ea8a0421$export$10d8903dec122b9d(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $825bb0d7ea8a0421$export$3f65cefe8380dbea(content, 'click', (_event)=>{
                nextContainer.toggleAttribute('hidden');
                triangleDown.toggleAttribute('hidden');
                triangleRight.toggleAttribute('hidden');
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            $825bb0d7ea8a0421$export$10d8903dec122b9d(this.ccontainer, [
                $825bb0d7ea8a0421$export$8454457683f90105('div', [
                    $8c1b82bf1be9645a$export$185802fd694ee1f5('style', `${$eaf1c30dff9742e4$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $eaf1c30dff9742e4$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $d30ac04941c45b73$export$aa201224bb439d47,
            $d30ac04941c45b73$export$c1286c4c2a7c066,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            $825bb0d7ea8a0421$export$10d8903dec122b9d(this.ccontainer, [
                $825bb0d7ea8a0421$export$8454457683f90105('img', [
                    $8c1b82bf1be9645a$export$185802fd694ee1f5('src', url),
                    $8c1b82bf1be9645a$export$185802fd694ee1f5('height', `${$03d3cbe4a95134dd$export$2077e0241d6afd3c(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            $825bb0d7ea8a0421$export$10d8903dec122b9d(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $d845939d26f0868e$export$513072ba72100d9c(()=>{
            $eaf1c30dff9742e4$export$6f0283bff34730a1.delete(this);
        });
    }
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $eaf1c30dff9742e4$export$6f0283bff34730a1.add(this);
    }
}
const $eaf1c30dff9742e4$export$3b589da4ab12cf23 = (dom)=>new $eaf1c30dff9742e4$export$79dd518d42f6d7a1(dom);
const $eaf1c30dff9742e4$export$c2977e725d59a2fd = (moduleName)=>$d30ac04941c45b73$export$c2977e725d59a2fd($eaf1c30dff9742e4$export$c2d084dc44961371, moduleName);




/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $bb9cd1b6dec22831$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $bb9cd1b6dec22831$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $bb9cd1b6dec22831$export$88f0b2eef157f31a = (iterator, filter)=>$bb9cd1b6dec22831$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $bb9cd1b6dec22831$export$1570d514f543056a = (iterator, fmap)=>$bb9cd1b6dec22831$export$7342c78d7e13e778(()=>{
        const { done: done, value: value } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });




/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ class $17e21ac980463a29$export$c3faceeb92aa39dd extends (0, $be5de554a627eab7$export$e23d3436ce401adc) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $17e21ac980463a29$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $17e21ac980463a29$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $17e21ac980463a29$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(let i = 0; i < deletes.length; i++){
            const del = deletes[i];
            $17e21ac980463a29$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $03d3cbe4a95134dd$export$a3fe094919f356fd((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $17e21ac980463a29$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $03d3cbe4a95134dd$export$8960430cfd85939f(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $17e21ac980463a29$export$b7826cadad53901e = (dss)=>{
    const merged = new $17e21ac980463a29$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$9d3c953c20b3f869$export$9ceefe31f12a3778(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $17e21ac980463a29$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$addToDeleteSet = (ds, client, clock, length)=>{
    $525cb12bf06b8e36$export$dccd489362a8619(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $17e21ac980463a29$var$DeleteItem(clock, length));
};
const $17e21ac980463a29$export$8cbac0d946238699 = ()=>new $17e21ac980463a29$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$8450d668bec558e2 = (ss)=>{
    const ds = $17e21ac980463a29$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $17e21ac980463a29$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$writeDeleteSet = (encoder, ds)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $9d3c953c20b3f869$export$6788812c4e6611e6(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, client);
        const len = dsitems.length;
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readDeleteSet = (decoder)=>{
    const ds = new $17e21ac980463a29$var$DeleteSet();
    const numClients = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        const numberOfDeletes = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $525cb12bf06b8e36$export$dccd489362a8619(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $17e21ac980463a29$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $17e21ac980463a29$var$DeleteSet();
    const numClients = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        const numberOfDeletes = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $17e21ac980463a29$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $17e21ac980463a29$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $17e21ac980463a29$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $17e21ac980463a29$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $17e21ac980463a29$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $17e21ac980463a29$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $17e21ac980463a29$export$30c99e08943e1c2();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(ds.restEncoder, 0); // encode 0 structs
        $17e21ac980463a29$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ const $17e21ac980463a29$export$9697b72c46fd3a5d = (ds1, ds2)=>{
    if (ds1.clients.size !== ds2.clients.size) return false;
    for (const [client, deleteItems1] of ds1.clients.entries()){
        const deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
        if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
        for(let i = 0; i < deleteItems1.length; i++){
            const di1 = deleteItems1[i];
            const di2 = deleteItems2[i];
            if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
        }
    }
    return true;
};
/**
 * @module Y
 */ const $17e21ac980463a29$var$generateNewClientId = $505d68ca6296b3d2$export$de9ffb9418dd7d0d;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ class $17e21ac980463a29$export$bceacc74c2212615 extends (0, $be5de554a627eab7$export$e23d3436ce401adc) {
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $17e21ac980463a29$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($9d3c953c20b3f869$export$6788812c4e6611e6(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $17e21ac980463a29$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = /** @type {any} */ $17e21ac980463a29$export$c265dc8338484497) {
        const type = $525cb12bf06b8e36$export$dccd489362a8619(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $17e21ac980463a29$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $17e21ac980463a29$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return /** @type {InstanceType<Type>} */ t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return /** @type {InstanceType<Type>} */ type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = '') {
        return /** @type {YArray<T>} */ this.get(name, $17e21ac980463a29$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = '') {
        return this.get(name, $17e21ac980463a29$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = '') {
        return /** @type {YMap<T>} */ this.get(name, $17e21ac980463a29$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ getXmlElement(name = '') {
        return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $17e21ac980463a29$export$4db87581d3ca170d);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = '') {
        return this.get(name, $17e21ac980463a29$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        this.isDestroyed = true;
        $9d3c953c20b3f869$export$6788812c4e6611e6(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $17e21ac980463a29$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $17e21ac980463a29$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        // @ts-ignore
        this.emit('destroyed', [
            true
        ]); // DEPRECATED!
        this.emit('destroy', [
            this
        ]);
        super.destroy();
    }
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $505d68ca6296b3d2$export$abe4376e1bf796d6(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $17e21ac980463a29$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $17e21ac980463a29$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        this.isDestroyed = false;
        /**
     * Promise that resolves once the document has been loaded from a persistence provider.
     */ this.whenLoaded = $209bc47c6afc4cc1$export$185802fd694ee1f5((resolve)=>{
            this.on('load', ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$209bc47c6afc4cc1$export$185802fd694ee1f5((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off('sync', eventHandler);
                        resolve();
                    }
                };
                this.on('sync', eventHandler);
            });
        this.on('sync', (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (this.isSynced && !this.isLoaded) this.emit('load', [
                this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
}
class $17e21ac980463a29$var$DSDecoderV1 {
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
}
class $17e21ac980463a29$export$1aa46d9818b5d1ec extends $17e21ac980463a29$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $17e21ac980463a29$export$6c7d4e6171d008d0($26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder), $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $17e21ac980463a29$export$6c7d4e6171d008d0($26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder), $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $26cf1cc17970e4a1$export$d5778a2beba4ceef(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $26cf1cc17970e4a1$export$3b64b4d753b81ec2(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $26cf1cc17970e4a1$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $e84e5e8aa33903d1$export$fe6f60023cd5ffaf($26cf1cc17970e4a1$export$7418bbc18dee40f3(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($26cf1cc17970e4a1$export$3b64b4d753b81ec2(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $26cf1cc17970e4a1$export$3b64b4d753b81ec2(this.restDecoder);
    }
}
class $17e21ac980463a29$var$DSDecoderV2 {
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
}
class $17e21ac980463a29$export$1c932452355c5571 extends $17e21ac980463a29$var$DSDecoderV2 {
    /**
   * @return {ID}
   */ readLeftID() {
        return new $17e21ac980463a29$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $17e21ac980463a29$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $26cf1cc17970e4a1$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $26cf1cc17970e4a1$export$7418bbc18dee40f3(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $26cf1cc17970e4a1$export$82863139061f472f(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $26cf1cc17970e4a1$export$d502ab0bf048a596($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.clientDecoder = new $26cf1cc17970e4a1$export$2dc62fb2f864b82e($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.leftClockDecoder = new $26cf1cc17970e4a1$export$d502ab0bf048a596($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.rightClockDecoder = new $26cf1cc17970e4a1$export$d502ab0bf048a596($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.infoDecoder = new $26cf1cc17970e4a1$export$f1f1200492b832af($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder), $26cf1cc17970e4a1$export$d5778a2beba4ceef);
        this.stringDecoder = new $26cf1cc17970e4a1$export$63a7aa211a91ed69($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.parentInfoDecoder = new $26cf1cc17970e4a1$export$f1f1200492b832af($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder), $26cf1cc17970e4a1$export$d5778a2beba4ceef);
        this.typeRefDecoder = new $26cf1cc17970e4a1$export$2dc62fb2f864b82e($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
        this.lenDecoder = new $26cf1cc17970e4a1$export$2dc62fb2f864b82e($26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
    }
}
class $17e21ac980463a29$var$DSEncoderV1 {
    toUint8Array() {
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, len);
    }
    constructor(){
        this.restEncoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    }
}
class $17e21ac980463a29$export$99171b804d9c5b54 extends $17e21ac980463a29$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, id.client);
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, id.client);
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $f760bbc2c6d392e1$export$826a1a6619653272(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $f760bbc2c6d392e1$export$264b1e8551468ea(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $f760bbc2c6d392e1$export$f7d11515275e88a2(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(this.restEncoder, key);
    }
}
class $17e21ac980463a29$var$DSEncoderV2 {
    toUint8Array() {
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $ac5470ebbde53fbd$export$965b6bccecbd9673();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
    constructor(){
        this.restEncoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
}
class $17e21ac980463a29$export$30c99e08943e1c2 extends $17e21ac980463a29$var$DSEncoderV2 {
    toUint8Array() {
        const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, 0); // this is a feature flag that we might use in the future
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.keyClockEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.clientEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.leftClockEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.rightClockEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $f760bbc2c6d392e1$export$73470fd2221e6aef(this.infoEncoder));
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.stringEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $f760bbc2c6d392e1$export$73470fd2221e6aef(this.parentInfoEncoder));
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.typeRefEncoder.toUint8Array());
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $f760bbc2c6d392e1$export$73b5e63e27d2b4c7(encoder, $f760bbc2c6d392e1$export$73470fd2221e6aef(this.restEncoder));
        return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $f760bbc2c6d392e1$export$264b1e8551468ea(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $f760bbc2c6d392e1$export$f7d11515275e88a2(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $f760bbc2c6d392e1$export$264b1e8551468ea(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next unique key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $f760bbc2c6d392e1$export$7542c66a59375c6f();
        this.clientEncoder = new $f760bbc2c6d392e1$export$785ebd3312c38061();
        this.leftClockEncoder = new $f760bbc2c6d392e1$export$7542c66a59375c6f();
        this.rightClockEncoder = new $f760bbc2c6d392e1$export$7542c66a59375c6f();
        this.infoEncoder = new $f760bbc2c6d392e1$export$8fa72bb4fa9409ff($f760bbc2c6d392e1$export$826a1a6619653272);
        this.stringEncoder = new $f760bbc2c6d392e1$export$7dcdc5c32f31c550();
        this.parentInfoEncoder = new $f760bbc2c6d392e1$export$8fa72bb4fa9409ff($f760bbc2c6d392e1$export$826a1a6619653272);
        this.typeRefEncoder = new $f760bbc2c6d392e1$export$785ebd3312c38061();
        this.lenEncoder = new $f760bbc2c6d392e1$export$785ebd3312c38061();
    }
}
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $17e21ac980463a29$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $03d3cbe4a95134dd$export$8960430cfd85939f(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $17e21ac980463a29$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($17e21ac980463a29$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $17e21ac980463a29$var$getStateVector(store).forEach((_clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $9d3c953c20b3f869$export$6788812c4e6611e6(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $17e21ac980463a29$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $525cb12bf06b8e36$export$185802fd694ee1f5();
    const numOfStateUpdates = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($0844609dcbe0a62a$export$bc2aba63e4099c09 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $17e21ac980463a29$export$12d259ff017e6b58($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
                        refs[i] = new $17e21ac980463a29$export$38d24f5c1eb0e4c0($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($0844609dcbe0a62a$export$eb5a8e0006ab4bb5 | $0844609dcbe0a62a$export$e25597372303a045)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), null, (info & $0844609dcbe0a62a$export$e25597372303a045) === $0844609dcbe0a62a$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $0844609dcbe0a62a$export$eb5a8e0006ab4bb5) === $0844609dcbe0a62a$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $0844609dcbe0a62a$export$daf23f774967089) === $0844609dcbe0a62a$export$daf23f774967089 ? decoder.readString() : null, $17e21ac980463a29$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // left
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is equal to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $9d3c953c20b3f869$export$6788812c4e6611e6(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $17e21ac980463a29$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const inapplicableItems = clientsStructRefs.get(client);
            if (inapplicableItems) {
                // decrement because we weren't able to apply previous operation
                inapplicableItems.i--;
                restStructs.clients.set(client, inapplicableItems.refs.slice(inapplicableItems.i));
                clientsStructRefs.delete(client);
                inapplicableItems.i = 0;
                inapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $17e21ac980463a29$export$38d24f5c1eb0e4c0) {
            const localClock = $525cb12bf06b8e36$export$dccd489362a8619(state, stackHead.id.client, ()=>$17e21ac980463a29$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $17e21ac980463a29$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $17e21ac980463a29$export$30c99e08943e1c2();
        $17e21ac980463a29$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$writeStructsFromTransaction = (encoder, transaction)=>$17e21ac980463a29$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $17e21ac980463a29$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $17e21ac980463a29$export$1c932452355c5571(decoder))=>$17e21ac980463a29$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $17e21ac980463a29$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $17e21ac980463a29$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $17e21ac980463a29$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $17e21ac980463a29$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $17e21ac980463a29$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $17e21ac980463a29$export$1c932452355c5571($26cf1cc17970e4a1$export$f8c898e83b60faaa(store.pendingDs));
            $26cf1cc17970e4a1$export$5a476e4dbe7923d5(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $17e21ac980463a29$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $17e21ac980463a29$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $17e21ac980463a29$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $17e21ac980463a29$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$17e21ac980463a29$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $17e21ac980463a29$export$1aa46d9818b5d1ec(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $17e21ac980463a29$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    const decoder = $26cf1cc17970e4a1$export$f8c898e83b60faaa(update);
    $17e21ac980463a29$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $17e21ac980463a29$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$17e21ac980463a29$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $17e21ac980463a29$export$1aa46d9818b5d1ec);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $17e21ac980463a29$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $17e21ac980463a29$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $17e21ac980463a29$var$writeDeleteSet(encoder, $17e21ac980463a29$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $17e21ac980463a29$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $17e21ac980463a29$export$30c99e08943e1c2())=>{
    const targetStateVector = $17e21ac980463a29$export$324ac6fb20a844e3(encodedTargetStateVector);
    $17e21ac980463a29$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($17e21ac980463a29$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $17e21ac980463a29$export$99171b804d9c5b54) return $17e21ac980463a29$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $17e21ac980463a29$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $17e21ac980463a29$export$30c99e08943e1c2) return $17e21ac980463a29$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $17e21ac980463a29$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$17e21ac980463a29$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $17e21ac980463a29$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $17e21ac980463a29$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        const clock = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $17e21ac980463a29$export$324ac6fb20a844e3 = (decodedState)=>$17e21ac980463a29$var$readStateVector(new $17e21ac980463a29$var$DSDecoderV1($26cf1cc17970e4a1$export$f8c898e83b60faaa(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $17e21ac980463a29$var$writeStateVector = (encoder, sv)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, sv.size);
    $9d3c953c20b3f869$export$6788812c4e6611e6(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $17e21ac980463a29$var$writeDocumentStateVector = (encoder, doc)=>$17e21ac980463a29$var$writeStateVector(encoder, $17e21ac980463a29$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $17e21ac980463a29$var$encodeStateVectorV2 = (doc, encoder = new $17e21ac980463a29$var$DSEncoderV2())=>{
    if (doc instanceof Map) $17e21ac980463a29$var$writeStateVector(encoder, doc);
    else $17e21ac980463a29$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $17e21ac980463a29$export$3e2f5393f32e71f = (doc)=>$17e21ac980463a29$var$encodeStateVectorV2(doc, new $17e21ac980463a29$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $17e21ac980463a29$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$createEventHandler = ()=>new $17e21ac980463a29$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error('[yjs] Tried to remove event handler that doesn\'t exist.');
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$fabe4bd8d0c6d92b$export$9dd9a52f2dd5b9ce(eventHandler.l, [
        arg0,
        arg1
    ]);
class $17e21ac980463a29$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $17e21ac980463a29$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$6c7d4e6171d008d0 = (client, clock)=>new $17e21ac980463a29$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$writeID = (encoder, id)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, id.client);
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readID = (decoder)=>$17e21ac980463a29$export$6c7d4e6171d008d0($26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder), $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $17e21ac980463a29$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log('Children: ', res);
    console.log('Children content: ', res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $17e21ac980463a29$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $17e21ac980463a29$export$a5c7b93649eaf8f8();
            user.set('ids', new $17e21ac980463a29$export$c4be6576ca6fe4aa());
            user.set('ds', new $17e21ac980463a29$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get('ids').push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get('ids').push([
                            clientid
                        ]);
                    });
                    const encoder = new $17e21ac980463a29$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $17e21ac980463a29$var$writeDeleteSet(encoder, ds);
                        user.get('ds').push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on('afterTransaction', /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get('ds');
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $17e21ac980463a29$var$DSEncoderV1();
                    $17e21ac980463a29$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($17e21ac980463a29$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap('users')){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get('ds');
            const ids = user.get('ids');
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $17e21ac980463a29$export$b7826cadad53901e([
                            this.dss.get(userDescription) || $17e21ac980463a29$export$8cbac0d946238699(),
                            $17e21ac980463a29$var$readDeleteSet(new $17e21ac980463a29$var$DSDecoderV1($26cf1cc17970e4a1$export$f8c898e83b60faaa(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $17e21ac980463a29$export$b7826cadad53901e(ds.map((encodedDs)=>$17e21ac980463a29$var$readDeleteSet(new $17e21ac980463a29$var$DSDecoderV1($26cf1cc17970e4a1$export$f8c898e83b60faaa(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add initial data
        storeType.forEach(initUser);
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $17e21ac980463a29$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the character
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $17e21ac980463a29$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $17e21ac980463a29$export$ddad8a1b8f7475d8 = (json)=>{
    var _json_tname;
    return new $17e21ac980463a29$export$da21a415c5907662(json.type == null ? null : $17e21ac980463a29$export$6c7d4e6171d008d0(json.type.client, json.type.clock), (_json_tname = json.tname) !== null && _json_tname !== void 0 ? _json_tname : null, json.item == null ? null : $17e21ac980463a29$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
};
class $17e21ac980463a29$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $17e21ac980463a29$var$createAbsolutePosition = (type, index, assoc = 0)=>new $17e21ac980463a29$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $17e21ac980463a29$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $17e21ac980463a29$export$e726a40920d54663(type);
    else typeid = $17e21ac980463a29$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $17e21ac980463a29$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $17e21ac980463a29$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $17e21ac980463a29$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $17e21ac980463a29$var$createRelativePosition(type, $17e21ac980463a29$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $17e21ac980463a29$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $17e21ac980463a29$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $17e21ac980463a29$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type, tname: tname, item: item, assoc: assoc } = rpos;
    if (item !== null) {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, 0);
        $17e21ac980463a29$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $f760bbc2c6d392e1$export$826a1a6619653272(encoder, 1);
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $f760bbc2c6d392e1$export$826a1a6619653272(encoder, 2);
        $17e21ac980463a29$var$writeID(encoder, type);
    } else throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
    $f760bbc2c6d392e1$export$ff90f819e16cc9bb(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    $17e21ac980463a29$var$writeRelativePosition(encoder, rpos);
    return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $17e21ac980463a29$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $17e21ac980463a29$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $17e21ac980463a29$var$readID(decoder);
    }
    const assoc = $26cf1cc17970e4a1$export$7ad75c69830b76d7(decoder) ? $26cf1cc17970e4a1$export$1dd5b9ddf6575ae8(decoder) : 0;
    return new $17e21ac980463a29$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $17e21ac980463a29$export$58a46cebc90e7851 = (uint8Array)=>$17e21ac980463a29$var$readRelativePosition($26cf1cc17970e4a1$export$f8c898e83b60faaa(uint8Array));
/**
 * @param {StructStore} store
 * @param {ID} id
 */ const $17e21ac980463a29$var$getItemWithOffset = (store, id)=>{
    const item = $17e21ac980463a29$export$f92dfeb71e9bb569(store, id);
    const diff = id.clock - item.id.clock;
    return {
        item: item,
        diff: diff
    };
};
/**
 * Transform a relative position to an absolute position.
 *
 * If you want to share the relative position with other users, you should set
 * `followUndoneDeletions` to false to get consistent results across all clients.
 *
 * When calculating the absolute position, we try to follow the "undone deletions". This yields
 * better results for the user who performed undo. However, only the user who performed the undo
 * will get the better results, the other users don't know which operations recreated a deleted
 * range of content. There is more information in this ticket: https://github.com/yjs/yjs/issues/638
 *
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @param {boolean} followUndoneDeletions - whether to follow undone deletions - see https://github.com/yjs/yjs/issues/638
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $17e21ac980463a29$export$8fc3152f62fb7ed1 = (rpos, doc, followUndoneDeletions = true)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($17e21ac980463a29$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = followUndoneDeletions ? $17e21ac980463a29$var$followRedone(store, rightID) : $17e21ac980463a29$var$getItemWithOffset(store, rightID);
        const right = res.item;
        if (!(right instanceof $17e21ac980463a29$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($17e21ac980463a29$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item } = followUndoneDeletions ? $17e21ac980463a29$var$followRedone(store, typeID) : {
                item: $17e21ac980463a29$export$f92dfeb71e9bb569(store, typeID)
            };
            if (item instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && item.content instanceof $17e21ac980463a29$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $17e21ac980463a29$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $17e21ac980463a29$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $17e21ac980463a29$export$c0af976e7e459c02(a.item, b.item) && $17e21ac980463a29$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $17e21ac980463a29$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $17e21ac980463a29$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$b946cadc55f8e512 = (snapshot, encoder = new $17e21ac980463a29$var$DSEncoderV2())=>{
    $17e21ac980463a29$var$writeDeleteSet(encoder, snapshot.ds);
    $17e21ac980463a29$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$a6d29989648e995 = (snapshot)=>$17e21ac980463a29$export$b946cadc55f8e512(snapshot, new $17e21ac980463a29$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $17e21ac980463a29$export$b0049fa299f4f58e = (buf, decoder = new $17e21ac980463a29$var$DSDecoderV2($26cf1cc17970e4a1$export$f8c898e83b60faaa(buf)))=>{
    return new $17e21ac980463a29$export$c963130a5525248f($17e21ac980463a29$var$readDeleteSet(decoder), $17e21ac980463a29$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $17e21ac980463a29$export$5c696daccf32bd2e = (buf)=>$17e21ac980463a29$export$b0049fa299f4f58e(buf, new $17e21ac980463a29$var$DSDecoderV1($26cf1cc17970e4a1$export$f8c898e83b60faaa(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $17e21ac980463a29$export$548fae0445f878fd = (ds, sm)=>new $17e21ac980463a29$export$c963130a5525248f(ds, sm);
const $17e21ac980463a29$export$d4568a81dd107a34 = $17e21ac980463a29$export$548fae0445f878fd($17e21ac980463a29$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $17e21ac980463a29$export$b8801ea43165ed7d = (doc)=>$17e21ac980463a29$export$548fae0445f878fd($17e21ac980463a29$export$8450d668bec558e2(doc.store), $17e21ac980463a29$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $17e21ac980463a29$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$17e21ac980463a29$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $17e21ac980463a29$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $525cb12bf06b8e36$export$dccd489362a8619(transaction.meta, $17e21ac980463a29$var$splitSnapshotAffectedStructs, $e958eb447fee22f4$export$185802fd694ee1f5);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $17e21ac980463a29$export$50fdfeece43146fd(store, client)) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(client, clock));
        });
        $17e21ac980463a29$export$8afefebbaf4e4c78(transaction, snapshot.ds, (_item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $17e21ac980463a29$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $17e21ac980463a29$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error('Garbage-collection must be disabled in `originDoc`!');
    const { sv: sv, ds: ds } = snapshot;
    const encoder = new $17e21ac980463a29$export$30c99e08943e1c2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $17e21ac980463a29$export$50fdfeece43146fd(originDoc.store, client)) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $17e21ac980463a29$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $17e21ac980463a29$var$writeDeleteSet(encoder, ds);
    });
    $17e21ac980463a29$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), 'snapshot');
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ const $17e21ac980463a29$var$snapshotContainsUpdateV2 = (snapshot, update, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    const updateDecoder = new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $17e21ac980463a29$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    const mergedDS = $17e21ac980463a29$export$b7826cadad53901e([
        snapshot.ds,
        $17e21ac980463a29$var$readDeleteSet(updateDecoder)
    ]);
    return $17e21ac980463a29$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ const $17e21ac980463a29$export$f938135bed5d8db7 = (snapshot, update)=>$17e21ac980463a29$var$snapshotContainsUpdateV2(snapshot, update, $17e21ac980463a29$export$1aa46d9818b5d1ec);
class $17e21ac980463a29$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $17e21ac980463a29$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $17e21ac980463a29$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $03d3cbe4a95134dd$export$a3fe094919f356fd(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $03d3cbe4a95134dd$export$a3fe094919f356fd((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$17e21ac980463a29$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $17e21ac980463a29$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $17e21ac980463a29$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $17e21ac980463a29$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $17e21ac980463a29$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $17e21ac980463a29$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $17e21ac980463a29$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$e550586ad633138d = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$17e21ac980463a29$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$73a181de908c608 = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $17e21ac980463a29$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $17e21ac980463a29$export$12d259ff017e6b58) structs.splice(index + 1, 0, $17e21ac980463a29$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$17e21ac980463a29$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $17e21ac980463a29$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $17e21ac980463a29$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $17e21ac980463a29$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const ydoc = new Y.Doc()
 * const map = ydoc.getMap('map')
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * ydoc.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $17e21ac980463a29$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $17e21ac980463a29$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $17e21ac980463a29$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
        /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $17e21ac980463a29$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$525cb12bf06b8e36$export$4154a199d7d90455(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $17e21ac980463a29$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $17e21ac980463a29$var$writeStructsFromTransaction(encoder, transaction);
    $17e21ac980463a29$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $17e21ac980463a29$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $525cb12bf06b8e36$export$dccd489362a8619(transaction.changed, type, $e958eb447fee22f4$export$185802fd694ee1f5).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ const $17e21ac980463a29$var$tryToMergeWithLefts = (structs, pos)=>{
    let right = structs[pos];
    let left = structs[pos - 1];
    let i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    const merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $17e21ac980463a29$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $17e21ac980463a29$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $17e21ac980463a29$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiency and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $03d3cbe4a95134dd$export$96ec731ed4dcb222(structs.length - 1, 1 + $17e21ac980463a29$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $17e21ac980463a29$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $17e21ac980463a29$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $17e21ac980463a29$var$tryGcDeleteSet(ds, store, gcFilter);
    $17e21ac980463a29$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $17e21ac980463a29$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $17e21ac980463a29$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $17e21ac980463a29$var$getStateVector(transaction.doc.store);
            doc.emit('beforeObserverCalls', [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>{
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                        events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                        events.forEach((event)=>{
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort((event1, event2)=>event1.path.length - event2.path.length);
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $17e21ac980463a29$var$callEventHandlerListeners(type._dEH, events, transaction);
                    }
                });
            });
            fs.push(()=>doc.emit('afterTransaction', [
                    transaction,
                    doc
                ]));
            (0, $fabe4bd8d0c6d92b$export$9dd9a52f2dd5b9ce)(fs, []);
            if (transaction._needFormattingCleanup) $17e21ac980463a29$var$cleanupYTextAfterTransaction(transaction);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $17e21ac980463a29$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $17e21ac980463a29$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $03d3cbe4a95134dd$export$8960430cfd85939f($17e21ac980463a29$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos;)i -= 1 + $17e21ac980463a29$var$tryToMergeWithLefts(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = mergeStructs.length - 1; i >= 0; i--){
                const { client: client, clock: clock } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $17e21ac980463a29$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($17e21ac980463a29$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $17e21ac980463a29$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $eaf1c30dff9742e4$export$c2d084dc44961371($d30ac04941c45b73$export$3de5e29ed1757f9b, $d30ac04941c45b73$export$c1286c4c2a7c066, '[yjs] ', $d30ac04941c45b73$export$f0ce1666bb40789b, $d30ac04941c45b73$export$aa201224bb439d47, 'Changed the client-id because another client seems to be using it.');
                doc.clientID = $17e21ac980463a29$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit('afterTransactionCleanup', [
                transaction,
                doc
            ]);
            if (doc._observers.has('update')) {
                const encoder = new $17e21ac980463a29$export$99171b804d9c5b54();
                const hasContent = $17e21ac980463a29$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('update', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has('updateV2')) {
                const encoder = new $17e21ac980463a29$export$30c99e08943e1c2();
                const hasContent = $17e21ac980463a29$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit('updateV2', [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit('subdocs', [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit('afterAllTransactions', [
                    doc,
                    transactionCleanups
                ]);
            } else $17e21ac980463a29$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $17e21ac980463a29$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $17e21ac980463a29$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit('beforeAllTransactions', [
            doc
        ]);
        doc.emit('beforeTransaction', [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $17e21ac980463a29$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $17e21ac980463a29$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $17e21ac980463a29$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $17e21ac980463a29$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && um.scope.some((type)=>type === tr.doc || $17e21ac980463a29$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item))) $17e21ac980463a29$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ const $17e21ac980463a29$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $17e21ac980463a29$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && undoManager.currStackItem === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $17e21ac980463a29$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $17e21ac980463a29$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item, diff: diff } = $17e21ac980463a29$var$followRedone(store, struct.id);
                        if (diff > 0) item = $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>type === transaction.doc || $17e21ac980463a29$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $17e21ac980463a29$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && scope.some((type)=>type === transaction.doc || $17e21ac980463a29$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$17e21ac980463a29$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $17e21ac980463a29$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    const res = undoManager.currStackItem;
    if (res != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit('stack-item-popped', [
            {
                stackItem: res,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return res;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ class $17e21ac980463a29$export$932a3f9a7e88971c extends (0, $be5de554a627eab7$export$e23d3436ce401adc) {
    /**
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */ addToScope(ytypes) {
        const tmpSet = new Set(this.scope);
        ytypes = $9d3c953c20b3f869$export$43bee75e5e14138e(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (!tmpSet.has(ytype)) {
                tmpSet.add(ytype);
                if (ytype instanceof $17e21ac980463a29$export$c265dc8338484497 ? ytype.doc !== this.doc : ytype !== this.doc) $eaf1c30dff9742e4$export$c106dd0671a0fc2d('[yjs#509] Not same Y.Doc'); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                this.scope.push(ytype);
            }
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$17e21ac980463a29$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$17e21ac980463a29$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit('stack-cleared', [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $17e21ac980463a29$var$popStackItem(this, this.undoStack, 'undo');
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $17e21ac980463a29$var$popStackItem(this, this.redoStack, 'redo');
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off('afterTransaction', this.afterTransactionHandler);
        super.destroy();
    }
    /**
   * @param {Doc|AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500, captureTransaction: captureTransaction = (_tr)=>true, deleteFilter: deleteFilter = ()=>true, trackedOrigins: trackedOrigins = new Set([
        null
    ]), ignoreRemoteMapChanges: ignoreRemoteMapChanges = false, doc: doc = /** @type {Doc} */ $9d3c953c20b3f869$export$43bee75e5e14138e(typeScope) ? typeScope[0].doc : typeScope instanceof $17e21ac980463a29$export$bceacc74c2212615 ? typeScope : typeScope.doc } = {}){
        super();
        /**
     * @type {Array<AbstractType<any> | Doc>}
     */ this.scope = [];
        this.doc = doc;
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ this.currStackItem = null;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(/** @type {AbstractType<any>} */ type) || type === this.doc) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $17e21ac980463a29$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $17e21ac980463a29$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $17e21ac980463a29$export$b7826cadad53901e([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $17e21ac980463a29$export$b7826cadad53901e([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $17e21ac980463a29$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $17e21ac980463a29$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $17e21ac980463a29$export$6d08773d2e66f8f2 && this.scope.some((type)=>type === transaction.doc || $17e21ac980463a29$export$3c81af374b054d6a(/** @type {AbstractType<any>} */ type, item))) $17e21ac980463a29$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? 'redo' : 'undo',
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit('stack-item-added', changeEvent);
            else this.emit('stack-item-updated', changeEvent);
        };
        this.doc.on('afterTransaction', this.afterTransactionHandler);
        this.doc.on('destroy', ()=>{
            this.destroy();
        });
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $17e21ac980463a29$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder.restDecoder);
                yield new $17e21ac980463a29$export$38d24f5c1eb0e4c0($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($0844609dcbe0a62a$export$bc2aba63e4099c09 & info) !== 0) {
                const cantCopyParentInfo = (info & ($0844609dcbe0a62a$export$eb5a8e0006ab4bb5 | $0844609dcbe0a62a$export$e25597372303a045)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), null, (info & $0844609dcbe0a62a$export$e25597372303a045) === $0844609dcbe0a62a$export$e25597372303a045 ? decoder.readLeftID() : null, null, (info & $0844609dcbe0a62a$export$eb5a8e0006ab4bb5) === $0844609dcbe0a62a$export$eb5a8e0006ab4bb5 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $0844609dcbe0a62a$export$daf23f774967089) === $0844609dcbe0a62a$export$daf23f774967089 ? decoder.readString() : null, $17e21ac980463a29$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $17e21ac980463a29$export$12d259ff017e6b58($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $17e21ac980463a29$var$LazyStructReader {
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0);
        return this.curr;
    }
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $17e21ac980463a29$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $17e21ac980463a29$export$d6235ced6e55ace9 = (update)=>$17e21ac980463a29$export$624b3f0248c2dc40(update, $17e21ac980463a29$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $17e21ac980463a29$export$624b3f0248c2dc40 = (update, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $17e21ac980463a29$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $eaf1c30dff9742e4$export$c2d084dc44961371('Structs: ', structs);
    const ds = $17e21ac980463a29$var$readDeleteSet(updateDecoder);
    $eaf1c30dff9742e4$export$c2d084dc44961371('DeleteSet: ', ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $17e21ac980463a29$export$aa45cba8121663dc = (update)=>$17e21ac980463a29$export$2fed33908eb23d71(update, $17e21ac980463a29$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $17e21ac980463a29$export$2fed33908eb23d71 = (update, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $17e21ac980463a29$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $17e21ac980463a29$var$readDeleteSet(updateDecoder)
    };
};
class $17e21ac980463a29$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$6319871659fd2460 = (updates)=>$17e21ac980463a29$export$ce273d78de0331d1(updates, $17e21ac980463a29$export$1aa46d9818b5d1ec, $17e21ac980463a29$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$ed51750cf3ab2381 = (update, YEncoder = $17e21ac980463a29$var$DSEncoderV2, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $17e21ac980463a29$var$LazyStructReader(new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, currClient);
                    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, currClient);
            $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(enc, size);
        $f760bbc2c6d392e1$export$c029b62321ea3da(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$5c451fd8502b011f = (update)=>$17e21ac980463a29$export$ed51750cf3ab2381(update, $17e21ac980463a29$var$DSEncoderV1, $17e21ac980463a29$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $17e21ac980463a29$export$8212a58b2178fdcf = (update, YDecoder = $17e21ac980463a29$export$1c932452355c5571)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $17e21ac980463a29$var$LazyStructReader(new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $17e21ac980463a29$export$e212b06fd4bf78fd = (update)=>$17e21ac980463a29$export$8212a58b2178fdcf(update, $17e21ac980463a29$export$1aa46d9818b5d1ec);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $17e21ac980463a29$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $17e21ac980463a29$export$12d259ff017e6b58) {
        const { client: client, clock: clock } = left.id;
        return new $17e21ac980463a29$export$12d259ff017e6b58($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0) {
        const { client: client, clock: clock } = left.id;
        return new $17e21ac980463a29$export$38d24f5c1eb0e4c0($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client, clock: clock } = leftItem.id;
        return new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff), null, $17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $17e21ac980463a29$export$ce273d78de0331d1 = (updates, YDecoder = $17e21ac980463a29$export$1c932452355c5571, YEncoder = $17e21ac980463a29$export$30c99e08943e1c2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $17e21ac980463a29$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $17e21ac980463a29$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $17e21ac980463a29$export$38d24f5c1eb0e4c0($17e21ac980463a29$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $17e21ac980463a29$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $17e21ac980463a29$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $17e21ac980463a29$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$17e21ac980463a29$var$readDeleteSet(decoder));
    const ds = $17e21ac980463a29$export$b7826cadad53901e(dss);
    $17e21ac980463a29$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $17e21ac980463a29$export$a8143edf39d2ad8e = (update, sv, YDecoder = $17e21ac980463a29$export$1c932452355c5571, YEncoder = $17e21ac980463a29$export$30c99e08943e1c2)=>{
    const state = $17e21ac980463a29$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $17e21ac980463a29$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update));
    const reader = new $17e21ac980463a29$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $17e21ac980463a29$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $03d3cbe4a95134dd$export$8960430cfd85939f(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $17e21ac980463a29$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $17e21ac980463a29$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $17e21ac980463a29$var$readDeleteSet(decoder);
    $17e21ac980463a29$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $17e21ac980463a29$export$bf60b51d6c283426 = (update, sv)=>$17e21ac980463a29$export$a8143edf39d2ad8e(update, sv, $17e21ac980463a29$export$1aa46d9818b5d1ec, $17e21ac980463a29$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $17e21ac980463a29$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $f760bbc2c6d392e1$export$73470fd2221e6aef(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $17e21ac980463a29$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $17e21ac980463a29$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $f760bbc2c6d392e1$export$872f48c75febcd2b(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $17e21ac980463a29$var$finishLazyStructWriting = (lazyWriter)=>{
    $17e21ac980463a29$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $f760bbc2c6d392e1$export$872f48c75febcd2b(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $f760bbc2c6d392e1$export$872f48c75febcd2b(restEncoder, partStructs.written);
        // write the rest of the fragment
        $f760bbc2c6d392e1$export$73b5e63e27d2b4c7(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $17e21ac980463a29$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($26cf1cc17970e4a1$export$f8c898e83b60faaa(update));
    const lazyDecoder = new $17e21ac980463a29$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $17e21ac980463a29$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$17e21ac980463a29$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $17e21ac980463a29$var$finishLazyStructWriting(lazyWriter);
    const ds = $17e21ac980463a29$var$readDeleteSet(updateDecoder);
    $17e21ac980463a29$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $17e21ac980463a29$var$createObfuscator = ({ formatting: formatting = true, subdocs: subdocs = true, yxml: yxml = true } = {})=>{
    let i = 0;
    const mapKeyCache = $525cb12bf06b8e36$export$185802fd694ee1f5();
    const nodeNameCache = $525cb12bf06b8e36$export$185802fd694ee1f5();
    const formattingKeyCache = $525cb12bf06b8e36$export$185802fd694ee1f5();
    const formattingValueCache = $525cb12bf06b8e36$export$185802fd694ee1f5();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $17e21ac980463a29$export$12d259ff017e6b58:
            case $17e21ac980463a29$export$38d24f5c1eb0e4c0:
                return block;
            case $17e21ac980463a29$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $17e21ac980463a29$export$3b06e0b3a2ece602:
                            break;
                        case $17e21ac980463a29$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $17e21ac980463a29$export$4db87581d3ca170d) type.nodeName = $525cb12bf06b8e36$export$dccd489362a8619(nodeNameCache, type.nodeName, ()=>'node-' + i);
                                if (type instanceof $17e21ac980463a29$export$ec64c1dd5e7a264) type.hookName = $525cb12bf06b8e36$export$dccd489362a8619(nodeNameCache, type.hookName, ()=>'hook-' + i);
                            }
                            break;
                        case $17e21ac980463a29$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $17e21ac980463a29$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $17e21ac980463a29$export$b564c0e69572c0e:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + '';
                                }
                                break;
                            }
                        case $17e21ac980463a29$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $17e21ac980463a29$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $525cb12bf06b8e36$export$dccd489362a8619(formattingKeyCache, c.key, ()=>i + '');
                                    c.value = $525cb12bf06b8e36$export$dccd489362a8619(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $17e21ac980463a29$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $17e21ac980463a29$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $36b37b8c4e1afb7f$export$76d90c956114f2c2(i % 10 + '', c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $ac5470ebbde53fbd$export$965b6bccecbd9673();
                    }
                    if (item.parentSub) item.parentSub = $525cb12bf06b8e36$export$dccd489362a8619(mapKeyCache, item.parentSub, ()=>i + '');
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $ac5470ebbde53fbd$export$965b6bccecbd9673();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $17e21ac980463a29$export$2dc24d59ec48a24e = (update, opts)=>$17e21ac980463a29$var$convertUpdateFormat(update, $17e21ac980463a29$var$createObfuscator(opts), $17e21ac980463a29$export$1aa46d9818b5d1ec, $17e21ac980463a29$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $17e21ac980463a29$export$90648fb14f8c31aa = (update, opts)=>$17e21ac980463a29$var$convertUpdateFormat(update, $17e21ac980463a29$var$createObfuscator(opts), $17e21ac980463a29$export$1c932452355c5571, $17e21ac980463a29$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $17e21ac980463a29$export$162408325d5832c = (update)=>$17e21ac980463a29$var$convertUpdateFormat(update, $fabe4bd8d0c6d92b$export$d560c7e4a29451c2, $17e21ac980463a29$export$1aa46d9818b5d1ec, $17e21ac980463a29$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $17e21ac980463a29$export$afffbdeed14adbd = (update)=>$17e21ac980463a29$var$convertUpdateFormat(update, $fabe4bd8d0c6d92b$export$d560c7e4a29451c2, $17e21ac980463a29$export$1c932452355c5571, $17e21ac980463a29$export$99171b804d9c5b54);
const $17e21ac980463a29$var$errorComputeChanges = 'You must not compute changes after the event-handler fired.';
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $17e21ac980463a29$export$80fac438977fb51c {
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        return this._path || (this._path = $17e21ac980463a29$var$getPathTo(this.currentTarget, this.target));
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $17e21ac980463a29$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $ac5470ebbde53fbd$export$185802fd694ee1f5($17e21ac980463a29$var$errorComputeChanges);
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = 'delete';
                                oldValue = $9d3c953c20b3f869$export$4c7897fafd92b108(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = 'update';
                            oldValue = $9d3c953c20b3f869$export$4c7897fafd92b108(prev.content.getContent());
                        } else {
                            action = 'add';
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = 'delete';
                            oldValue = $9d3c953c20b3f869$export$4c7897fafd92b108(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $ac5470ebbde53fbd$export$185802fd694ee1f5($17e21ac980463a29$var$errorComputeChanges);
            const target = this.target;
            const added = $e958eb447fee22f4$export$185802fd694ee1f5();
            const deleted = $e958eb447fee22f4$export$185802fd694ee1f5();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted && c.countable) i += c.length;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
/**
 * https://docs.yjs.dev/getting-started/working-with-shared-types#caveats
 */ const $17e21ac980463a29$var$warnPrematureAccess = ()=>{
    $eaf1c30dff9742e4$export$c106dd0671a0fc2d('Invalid access: Add Yjs type to a document before reading data.');
};
const $17e21ac980463a29$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $17e21ac980463a29$var$globalSearchMarkerTimestamp = 0;
class $17e21ac980463a29$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $17e21ac980463a29$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $17e21ac980463a29$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $17e21ac980463a29$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $17e21ac980463a29$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $17e21ac980463a29$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $17e21ac980463a29$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $17e21ac980463a29$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $17e21ac980463a29$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $17e21ac980463a29$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $17e21ac980463a29$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$03d3cbe4a95134dd$export$2335f513bbd82c6d(index - a.index) < $03d3cbe4a95134dd$export$2335f513bbd82c6d(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $17e21ac980463a29$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengths == null) {
    //     window.lengths = []
    //     window.getLengths = () => window.lengths.sort((a, b) => a - b)
    //   }
    //   window.lengths.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $03d3cbe4a95134dd$export$2335f513bbd82c6d(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $17e21ac980463a29$var$maxSearchMarker) {
        // adjust existing marker
        $17e21ac980463a29$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $17e21ac980463a29$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $17e21ac980463a29$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $03d3cbe4a95134dd$export$8960430cfd85939f(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $17e21ac980463a29$export$5418d693f13991b3 = (t)=>{
    var _t_doc;
    (_t_doc = t.doc) !== null && _t_doc !== void 0 ? _t_doc : $17e21ac980463a29$var$warnPrematureAccess();
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $17e21ac980463a29$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $525cb12bf06b8e36$export$dccd489362a8619(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $17e21ac980463a29$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $17e21ac980463a29$export$c265dc8338484497 {
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $17e21ac980463a29$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $17e21ac980463a29$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $17e21ac980463a29$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $17e21ac980463a29$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $17e21ac980463a29$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $17e21ac980463a29$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListSlice = (type, start, end)=>{
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $17e21ac980463a29$var$warnPrematureAccess();
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListToArray = (type)=>{
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $17e21ac980463a29$var$warnPrematureAccess();
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $17e21ac980463a29$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on every element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $17e21ac980463a29$var$warnPrematureAccess();
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $17e21ac980463a29$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListGet = (type, index)=>{
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $17e21ac980463a29$var$warnPrematureAccess();
    const marker = $17e21ac980463a29$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $17e21ac980463a29$export$bceacc74c2212615:
                        left = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $17e21ac980463a29$export$c265dc8338484497) {
                            left = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error('Unexpected content type in insert operation');
                }
        }
    });
    packJsonContent();
};
const $17e21ac980463a29$var$lengthExceeded = ()=>$ac5470ebbde53fbd$export$185802fd694ee1f5('Length exceeded!');
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $17e21ac980463a29$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $17e21ac980463a29$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $17e21ac980463a29$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $17e21ac980463a29$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $17e21ac980463a29$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $17e21ac980463a29$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the search marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $17e21ac980463a29$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $17e21ac980463a29$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $17e21ac980463a29$var$lengthExceeded();
    if (parent._searchMarker) $17e21ac980463a29$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $17e21ac980463a29$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $17e21ac980463a29$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $17e21ac980463a29$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $17e21ac980463a29$export$bceacc74c2212615:
            content = new $17e21ac980463a29$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $17e21ac980463a29$export$c265dc8338484497) content = new $17e21ac980463a29$export$e2e108cbe2e4f865(value);
            else throw new Error('Unexpected content type');
    }
    new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeMapGet = (parent, key)=>{
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $17e21ac980463a29$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $17e21ac980463a29$var$warnPrematureAccess();
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$typeMapHas = (parent, key)=>{
    var _parent_doc;
    (_parent_doc = parent.doc) !== null && _parent_doc !== void 0 ? _parent_doc : $17e21ac980463a29$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $17e21ac980463a29$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$export$7769bdedaef2c91b = (parent, snapshot)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        /**
     * @type {Item|null}
     */ let v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $17e21ac980463a29$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any> & { _map: Map<string, Item> }} type
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$createMapIterator = (type)=>{
    var _type_doc;
    (_type_doc = type.doc) !== null && _type_doc !== void 0 ? _type_doc : $17e21ac980463a29$var$warnPrematureAccess();
    return $bb9cd1b6dec22831$export$88f0b2eef157f31a(type._map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
};
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $17e21ac980463a29$export$a095f7fee639264a extends $17e21ac980463a29$export$80fac438977fb51c {
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $17e21ac980463a29$export$c4be6576ca6fe4aa extends $17e21ac980463a29$export$c265dc8338484497 {
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $17e21ac980463a29$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $17e21ac980463a29$export$c4be6576ca6fe4aa();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $17e21ac980463a29$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $17e21ac980463a29$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $17e21ac980463a29$var$callTypeObservers(this, transaction, new $17e21ac980463a29$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $17e21ac980463a29$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $17e21ac980463a29$var$typeListToArray(this);
    }
    /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $17e21ac980463a29$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $17e21ac980463a29$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $17e21ac980463a29$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $17e21ac980463a29$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $17e21ac980463a29$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YArrayRefID);
    }
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYArray = (_decoder)=>new $17e21ac980463a29$export$c4be6576ca6fe4aa();
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $17e21ac980463a29$export$33aab1b1a47c1cc3 extends $17e21ac980463a29$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ class $17e21ac980463a29$export$a5c7b93649eaf8f8 extends $17e21ac980463a29$export$c265dc8338484497 {
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $17e21ac980463a29$export$a5c7b93649eaf8f8();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $17e21ac980463a29$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $17e21ac980463a29$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $17e21ac980463a29$var$callTypeObservers(this, transaction, new $17e21ac980463a29$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $17e21ac980463a29$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$17e21ac980463a29$var$createMapIterator(this)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $bb9cd1b6dec22831$export$1570d514f543056a($17e21ac980463a29$var$createMapIterator(this), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ values() {
        return $bb9cd1b6dec22831$export$1570d514f543056a($17e21ac980463a29$var$createMapIterator(this), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ entries() {
        return $bb9cd1b6dec22831$export$1570d514f543056a($17e21ac980463a29$var$createMapIterator(this), /** @param {any} v */ (v)=>/** @type {any} */ [
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $17e21ac980463a29$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $17e21ac980463a29$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $17e21ac980463a29$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YMapRefID);
    }
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYMap = (_decoder)=>new $17e21ac980463a29$export$a5c7b93649eaf8f8();
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $17e21ac980463a29$var$equalAttrs = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && a && b && $d54324b97fded352$export$4f1c34abb2bb4c8(a, b);
class $17e21ac980463a29$var$ItemTextListPosition {
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $ac5470ebbde53fbd$export$965b6bccecbd9673();
        switch(this.right.content.constructor){
            case $17e21ac980463a29$export$3194899188fb5a88:
                if (!this.right.deleted) $17e21ac980463a29$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $17e21ac980463a29$export$3194899188fb5a88:
                if (!pos.right.deleted) $17e21ac980463a29$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
    const currentAttributes = new Map();
    const marker = useSearchMarker ? $17e21ac980463a29$var$findMarker(parent, index) : null;
    if (marker) {
        const pos = new $17e21ac980463a29$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $17e21ac980463a29$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $17e21ac980463a29$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $17e21ac980463a29$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $17e21ac980463a29$export$3194899188fb5a88 && $17e21ac980463a29$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key, value: value } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        var _attributes_currPos_right_content_key;
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $17e21ac980463a29$export$3194899188fb5a88 && $17e21ac980463a29$var$equalAttrs((_attributes_currPos_right_content_key = attributes[/** @type {ContentFormat} */ currPos.right.content.key]) !== null && _attributes_currPos_right_content_key !== void 0 ? _attributes_currPos_right_content_key : null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $17e21ac980463a29$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        var _currPos_currentAttributes_get;
        const currentVal = (_currPos_currentAttributes_get = currPos.currentAttributes.get(key)) !== null && _currPos_currentAttributes_get !== void 0 ? _currPos_currentAttributes_get : null;
        if (!$17e21ac980463a29$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left, right: right } = currPos;
            currPos.right = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $17e21ac980463a29$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $17e21ac980463a29$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $17e21ac980463a29$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $17e21ac980463a29$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $17e21ac980463a29$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $17e21ac980463a29$export$c265dc8338484497 ? new $17e21ac980463a29$export$e2e108cbe2e4f865(text) : new $17e21ac980463a29$export$c3787ba7f6086664(text);
    let { left: left, right: right, index: index } = currPos;
    if (parent._searchMarker) $17e21ac980463a29$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $17e21ac980463a29$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $17e21ac980463a29$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $17e21ac980463a29$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $17e21ac980463a29$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $17e21ac980463a29$export$3194899188fb5a88:
                {
                    const { key: key, value: value } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($17e21ac980463a29$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = '';
        for(; length > 0; length--)newlines += '\n';
        currPos.right = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(ownClientId, $17e21ac980463a29$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $17e21ac980463a29$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $17e21ac980463a29$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $17e21ac980463a29$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $525cb12bf06b8e36$export$185802fd694ee1f5();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $17e21ac980463a29$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $17e21ac980463a29$export$3194899188fb5a88:
                    {
                        const { key: key, value: value } = /** @type {ContentFormat} */ content;
                        var _startAttributes_get;
                        const startAttrValue = (_startAttributes_get = startAttributes.get(key)) !== null && _startAttributes_get !== void 0 ? _startAttributes_get : null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            var _currAttributes_get;
                            if (!reachedCurr && ((_currAttributes_get = currAttributes.get(key)) !== null && _currAttributes_get !== void 0 ? _currAttributes_get : null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $17e21ac980463a29$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $17e21ac980463a29$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $17e21ac980463a29$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $17e21ac980463a29$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $17e21ac980463a29$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $525cb12bf06b8e36$export$185802fd694ee1f5();
        const currentAttributes = $525cb12bf06b8e36$export$784d13d8ee351f07(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $17e21ac980463a29$export$3194899188fb5a88:
                    $17e21ac980463a29$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $17e21ac980463a29$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $525cb12bf06b8e36$export$784d13d8ee351f07(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transaction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ const $17e21ac980463a29$var$cleanupYTextAfterTransaction = (transaction)=>{
    /**
   * @type {Set<YText>}
   */ const needFullCleanup = new Set();
    // check if another formatting item was inserted
    const doc = transaction.doc;
    for (const [client, afterClock] of transaction.afterState.entries()){
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) continue;
        $17e21ac980463a29$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
            if (!item.deleted && /** @type {Item} */ item.content.constructor === $17e21ac980463a29$export$3194899188fb5a88 && item.constructor !== $17e21ac980463a29$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
        });
    }
    // cleanup in a new transaction
    $17e21ac980463a29$export$dac1bad6146b2469(doc, (t)=>{
        $17e21ac980463a29$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
            if (item instanceof $17e21ac980463a29$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            const parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $17e21ac980463a29$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $17e21ac980463a29$var$cleanupContextlessFormattingGap(t, item);
        });
        // If a formatting item was inserted, we simply clean the whole type.
        // We need to compute currentAttributes for the current position anyway.
        for (const yText of needFullCleanup)$17e21ac980463a29$export$5d9f53c13ebffb65(yText);
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $525cb12bf06b8e36$export$784d13d8ee351f07(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $17e21ac980463a29$export$e2e108cbe2e4f865:
            case $17e21ac980463a29$export$c3787ba7f6086664:
            case $17e21ac980463a29$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $17e21ac980463a29$export$e550586ad633138d(transaction, $17e21ac980463a29$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $17e21ac980463a29$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $17e21ac980463a29$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For more information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $17e21ac980463a29$export$51155b8ebb74188a extends $17e21ac980463a29$export$80fac438977fb51c {
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $17e21ac980463a29$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = '';
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case 'delete':
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case 'insert':
                                if (typeof insert === 'object' || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = '';
                                break;
                            case 'retain':
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$d54324b97fded352$export$dd1bc94b04021eeb(attributes)) op.attributes = $d54324b97fded352$export$e6e34fd1f2686227({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $17e21ac980463a29$export$e2e108cbe2e4f865:
                        case $17e21ac980463a29$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = 'insert';
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += 1;
                            }
                            break;
                        case $17e21ac980463a29$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== 'insert') {
                                        addOp();
                                        action = 'insert';
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== 'delete') {
                                    addOp();
                                    action = 'delete';
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== 'retain') {
                                    addOp();
                                    action = 'retain';
                                }
                                retain += item.length;
                            }
                            break;
                        case $17e21ac980463a29$export$3194899188fb5a88:
                            {
                                const { key: key, value: value } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        var _currentAttributes_get;
                                        const curVal = (_currentAttributes_get = currentAttributes.get(key)) !== null && _currentAttributes_get !== void 0 ? _currentAttributes_get : null;
                                        if (!$17e21ac980463a29$var$equalAttrs(curVal, value)) {
                                            if (action === 'retain') addOp();
                                            var _oldAttributes_get;
                                            if ($17e21ac980463a29$var$equalAttrs(value, (_oldAttributes_get = oldAttributes.get(key)) !== null && _oldAttributes_get !== void 0 ? _oldAttributes_get : null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    var _currentAttributes_get1;
                                    const curVal = (_currentAttributes_get1 = currentAttributes.get(key)) !== null && _currentAttributes_get1 !== void 0 ? _currentAttributes_get1 : null;
                                    if (!$17e21ac980463a29$var$equalAttrs(curVal, value)) {
                                        if (action === 'retain') addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$17e21ac980463a29$var$equalAttrs(attr, value)) {
                                            if (action === 'retain') addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === 'insert') addOp();
                                    $17e21ac980463a29$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $17e21ac980463a29$export$5f1af8db9871e1d6 extends $17e21ac980463a29$export$c265dc8338484497 {
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $17e21ac980463a29$export$5f1af8db9871e1d6();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */ clone() {
        const text = new $17e21ac980463a29$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $17e21ac980463a29$export$51155b8ebb74188a(this, transaction, parentSubs);
        $17e21ac980463a29$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        let str = '';
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $17e21ac980463a29$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $17e21ac980463a29$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === 'string' && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === '\n' ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== 'string' || ins.length > 0) $17e21ac980463a29$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $17e21ac980463a29$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $17e21ac980463a29$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = '';
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = '';
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($17e21ac980463a29$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $17e21ac980463a29$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $17e21ac980463a29$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get('ychange');
                            if (snapshot !== undefined && !$17e21ac980463a29$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'removed') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('removed', n.id) : {
                                        type: 'removed'
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$17e21ac980463a29$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== 'added') {
                                    packStr();
                                    currentAttributes.set('ychange', computeYChange ? computeYChange('added', n.id) : {
                                        type: 'added'
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete('ychange');
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $17e21ac980463a29$export$e2e108cbe2e4f865:
                    case $17e21ac980463a29$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $17e21ac980463a29$export$3194899188fb5a88:
                        if ($17e21ac980463a29$var$isVisible(n, snapshot)) {
                            packStr();
                            $17e21ac980463a29$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $17e21ac980463a29$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $17e21ac980463a29$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $17e21ac980463a29$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, 'cleanup');
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $17e21ac980463a29$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $17e21ac980463a29$var$findPosition(transaction, this, index, !attributes);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $17e21ac980463a29$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes) {
        const y = this.doc;
        if (y !== null) $17e21ac980463a29$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $17e21ac980463a29$var$findPosition(transaction, this, index, !attributes);
            $17e21ac980463a29$var$insertText(transaction, this, pos, embed, attributes || {});
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $17e21ac980463a29$export$dac1bad6146b2469(y, (transaction)=>{
            $17e21ac980463a29$var$deleteText(transaction, $17e21ac980463a29$var$findPosition(transaction, this, index, true), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $17e21ac980463a29$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $17e21ac980463a29$var$findPosition(transaction, this, index, false);
            if (pos.right === null) return;
            $17e21ac980463a29$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $17e21ac980463a29$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $17e21ac980463a29$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YTextRefID);
    }
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ this._hasFormatting = false;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYText = (_decoder)=>new $17e21ac980463a29$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $17e21ac980463a29$var$YXmlTreeWalker {
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $17e21ac980463a29$export$4db87581d3ca170d || type.constructor === $17e21ac980463a29$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                /**
             * @type {Item | null}
             */ const nxt = n.next;
                if (nxt !== null) {
                    n = nxt;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
        var _root_doc;
        (_root_doc = root.doc) !== null && _root_doc !== void 0 ? _root_doc : $17e21ac980463a29$var$warnPrematureAccess();
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $17e21ac980463a29$export$d5ce8c3e1731f1a7 extends $17e21ac980463a29$export$c265dc8338484497 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $17e21ac980463a29$export$d5ce8c3e1731f1a7();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */ clone() {
        const el = new $17e21ac980463a29$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $17e21ac980463a29$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        var _this_doc;
        (_this_doc = this.doc) !== null && _this_doc !== void 0 ? _this_doc : $17e21ac980463a29$var$warnPrematureAccess();
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $17e21ac980463a29$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $17e21ac980463a29$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $9d3c953c20b3f869$export$6788812c4e6611e6(new $17e21ac980463a29$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $17e21ac980463a29$var$callTypeObservers(this, transaction, new $17e21ac980463a29$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $17e21ac980463a29$var$typeListMap(this, (xml)=>xml.toString()).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $17e21ac980463a29$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $17e21ac980463a29$export$c265dc8338484497 ? ref._item : ref;
            $17e21ac980463a29$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $ac5470ebbde53fbd$export$185802fd694ee1f5('Reference item not found');
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $17e21ac980463a29$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $17e21ac980463a29$var$typeListGet(this, index);
    }
    /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $17e21ac980463a29$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $17e21ac980463a29$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YXmlFragmentRefID);
    }
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYXmlFragment = (_decoder)=>new $17e21ac980463a29$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $17e21ac980463a29$export$4db87581d3ca170d extends $17e21ac980463a29$export$d5ce8c3e1731f1a7 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $17e21ac980463a29$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $17e21ac980463a29$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $d54324b97fded352$export$4b80e395e36b5a56(attrs, (value, key)=>{
            if (typeof value === 'string') el.setAttribute(key, value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $17e21ac980463a29$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? ' ' + stringBuilder.join(' ') : '';
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $17e21ac980463a29$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $17e21ac980463a29$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $17e21ac980463a29$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $17e21ac980463a29$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes(snapshot) {
        return /** @type {any} */ snapshot ? $17e21ac980463a29$export$7769bdedaef2c91b(this, snapshot) : $17e21ac980463a29$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === 'string') dom.setAttribute(key, value);
        }
        $17e21ac980463a29$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
    constructor(nodeName = 'UNDEFINED'){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $17e21ac980463a29$var$readYXmlElement = (decoder)=>new $17e21ac980463a29$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $17e21ac980463a29$export$88c9145a0c3b556c extends $17e21ac980463a29$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with which the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $17e21ac980463a29$export$ec64c1dd5e7a264 extends $17e21ac980463a29$export$a5c7b93649eaf8f8 {
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $17e21ac980463a29$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */ clone() {
        const el = new $17e21ac980463a29$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute('data-yjs-hook', this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYXmlHook = (decoder)=>new $17e21ac980463a29$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $17e21ac980463a29$export$b35b8f45887823df extends $17e21ac980463a29$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $17e21ac980463a29$export$b35b8f45887823df();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */ clone() {
        const text = new $17e21ac980463a29$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = '';
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += '>';
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join('');
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($17e21ac980463a29$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $17e21ac980463a29$var$readYXmlText = (decoder)=>new $17e21ac980463a29$export$b35b8f45887823df();
class $17e21ac980463a29$export$3cf6f9765c5c3196 {
    /**
   * @type {boolean}
   */ get deleted() {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
}
const $17e21ac980463a29$var$structGCRefNumber = 0;
/**
 * @private
 */ class $17e21ac980463a29$export$12d259ff017e6b58 extends $17e21ac980463a29$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $17e21ac980463a29$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($17e21ac980463a29$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $17e21ac980463a29$export$e8d530cdf62d1cbd {
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $17e21ac980463a29$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $17e21ac980463a29$var$readContentBinary = (decoder)=>new $17e21ac980463a29$export$e8d530cdf62d1cbd(decoder.readBuf());
class $17e21ac980463a29$export$3b06e0b3a2ece602 {
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $17e21ac980463a29$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $17e21ac980463a29$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $17e21ac980463a29$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $17e21ac980463a29$var$readContentDeleted = (decoder)=>new $17e21ac980463a29$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $17e21ac980463a29$var$createDocFromOpts = (guid, opts)=>new $17e21ac980463a29$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $17e21ac980463a29$export$b564c0e69572c0e {
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $17e21ac980463a29$export$b564c0e69572c0e($17e21ac980463a29$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error('This document was already integrated as a sub-document. You should create a second instance instead with the same guid.');
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $17e21ac980463a29$var$readContentDoc = (decoder)=>new $17e21ac980463a29$export$b564c0e69572c0e($17e21ac980463a29$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $17e21ac980463a29$export$c3787ba7f6086664 {
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $17e21ac980463a29$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $17e21ac980463a29$var$readContentEmbed = (decoder)=>new $17e21ac980463a29$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $17e21ac980463a29$export$3194899188fb5a88 {
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $17e21ac980463a29$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ splice(_offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ mergeWith(_right) {
        return false;
    }
    /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ integrate(_transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        const p = /** @type {YText} */ item.parent;
        p._searchMarker = null;
        p._hasFormatting = true;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $17e21ac980463a29$var$readContentFormat = (decoder)=>new $17e21ac980463a29$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $17e21ac980463a29$export$6a907ea8f733ecf3 {
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $17e21ac980463a29$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $17e21ac980463a29$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? 'undefined' : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $17e21ac980463a29$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === 'undefined') cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $17e21ac980463a29$export$6a907ea8f733ecf3(cs);
};
const $17e21ac980463a29$var$isDevMode = $1d21f59048a9fe89$export$39fb32ac18db3f88('node_env') === 'development';
class $17e21ac980463a29$export$1d788b93bbb631a0 {
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $17e21ac980463a29$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $17e21ac980463a29$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
        $17e21ac980463a29$var$isDevMode && $d54324b97fded352$export$7e32b29e1cb162e1(arr);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $17e21ac980463a29$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $17e21ac980463a29$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $17e21ac980463a29$export$ee670b2cf091bbb6 {
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split('');
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $17e21ac980463a29$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $17e21ac980463a29$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "\uFFFD";
            // replace right as well
            right.str = "\uFFFD" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $17e21ac980463a29$var$readContentString = (decoder)=>new $17e21ac980463a29$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $17e21ac980463a29$var$typeRefs = [
    $17e21ac980463a29$var$readYArray,
    $17e21ac980463a29$var$readYMap,
    $17e21ac980463a29$var$readYText,
    $17e21ac980463a29$var$readYXmlElement,
    $17e21ac980463a29$var$readYXmlFragment,
    $17e21ac980463a29$var$readYXmlHook,
    $17e21ac980463a29$var$readYXmlText
];
const $17e21ac980463a29$var$YArrayRefID = 0;
const $17e21ac980463a29$var$YMapRefID = 1;
const $17e21ac980463a29$var$YTextRefID = 2;
const $17e21ac980463a29$var$YXmlElementRefID = 3;
const $17e21ac980463a29$var$YXmlFragmentRefID = 4;
const $17e21ac980463a29$var$YXmlHookRefID = 5;
const $17e21ac980463a29$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $17e21ac980463a29$export$e2e108cbe2e4f865 {
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $17e21ac980463a29$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $ac5470ebbde53fbd$export$73ced5c7e10d6d0f();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $17e21ac980463a29$var$readContentType = (decoder)=>new $17e21ac980463a29$export$e2e108cbe2e4f865($17e21ac980463a29$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $17e21ac980463a29$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $17e21ac980463a29$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $17e21ac980463a29$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $17e21ac980463a29$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $17e21ac980463a29$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $17e21ac980463a29$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client, clock: clock } = leftItem.id;
    const rightItem = new $17e21ac980463a29$export$6d08773d2e66f8f2($17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $17e21ac980463a29$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $17e21ac980463a29$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $17e21ac980463a29$var$isDeletedByUndoStack = (stack, id)=>$9d3c953c20b3f869$export$ad14ef4001db2bcd(stack, /** @param {StackItem} s */ (s)=>$17e21ac980463a29$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $17e21ac980463a29$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $17e21ac980463a29$export$e550586ad633138d(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $17e21ac980463a29$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $17e21ac980463a29$export$e550586ad633138d(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $17e21ac980463a29$export$e550586ad633138d(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $17e21ac980463a29$export$e550586ad633138d(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $17e21ac980463a29$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $17e21ac980463a29$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $17e21ac980463a29$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $17e21ac980463a29$export$e550586ad633138d(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $17e21ac980463a29$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $17e21ac980463a29$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $17e21ac980463a29$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $17e21ac980463a29$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $17e21ac980463a29$export$6d08773d2e66f8f2 extends $17e21ac980463a29$export$3cf6f9765c5c3196 {
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $0844609dcbe0a62a$export$873ae8db4cef5125) > 0 !== isMarked) this.info ^= $0844609dcbe0a62a$export$873ae8db4cef5125;
    }
    get marker() {
        return (this.info & $0844609dcbe0a62a$export$873ae8db4cef5125) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $0844609dcbe0a62a$export$ee2c6657cb286da4) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $0844609dcbe0a62a$export$ee2c6657cb286da4;
    }
    get countable() {
        return (this.info & $0844609dcbe0a62a$export$1f117f3b0edc2676) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $0844609dcbe0a62a$export$e5294f8c78cf7711) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $0844609dcbe0a62a$export$e5294f8c78cf7711;
    }
    markDeleted() {
        this.info |= $0844609dcbe0a62a$export$e5294f8c78cf7711;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $17e21ac980463a29$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $17e21ac980463a29$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $17e21ac980463a29$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $17e21ac980463a29$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $17e21ac980463a29$export$73a181de908c608(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $17e21ac980463a29$export$e550586ad633138d(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $17e21ac980463a29$export$12d259ff017e6b58 || this.right && this.right.constructor === $17e21ac980463a29$export$12d259ff017e6b58) this.parent = null;
        else if (!this.parent) {
            // only set parent if this shouldn't be garbage collected
            if (this.left && this.left.constructor === $17e21ac980463a29$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            } else if (this.right && this.right.constructor === $17e21ac980463a29$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $17e21ac980463a29$export$8be180ec26319f9f) {
            const parentItem = $17e21ac980463a29$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $17e21ac980463a29$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $17e21ac980463a29$export$73a181de908c608(transaction, transaction.doc.store, $17e21ac980463a29$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($17e21ac980463a29$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($17e21ac980463a29$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($17e21ac980463a29$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($17e21ac980463a29$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $17e21ac980463a29$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $17e21ac980463a29$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $17e21ac980463a29$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $17e21ac980463a29$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $17e21ac980463a29$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $17e21ac980463a29$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $17e21ac980463a29$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $17e21ac980463a29$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $ac5470ebbde53fbd$export$965b6bccecbd9673();
        this.content.gc(store);
        if (parentGCd) $17e21ac980463a29$var$replaceStruct(store, this, new $17e21ac980463a29$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $17e21ac980463a29$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $17e21ac980463a29$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $0844609dcbe0a62a$export$bc2aba63e4099c09 | (origin === null ? 0 : $0844609dcbe0a62a$export$e25597372303a045) | // origin is defined
        (rightOrigin === null ? 0 : $0844609dcbe0a62a$export$eb5a8e0006ab4bb5) | // right origin is defined
        (parentSub === null ? 0 : $0844609dcbe0a62a$export$daf23f774967089); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $17e21ac980463a29$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $17e21ac980463a29$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $ac5470ebbde53fbd$export$965b6bccecbd9673();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $0844609dcbe0a62a$export$1f117f3b0edc2676 : 0;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $17e21ac980463a29$var$readItemContent = (decoder, info)=>$17e21ac980463a29$var$contentRefs[info & $0844609dcbe0a62a$export$bc2aba63e4099c09](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $17e21ac980463a29$var$contentRefs = [
    ()=>{
        $ac5470ebbde53fbd$export$965b6bccecbd9673();
    },
    $17e21ac980463a29$var$readContentDeleted,
    $17e21ac980463a29$var$readContentJSON,
    $17e21ac980463a29$var$readContentBinary,
    $17e21ac980463a29$var$readContentString,
    $17e21ac980463a29$var$readContentEmbed,
    $17e21ac980463a29$var$readContentFormat,
    $17e21ac980463a29$var$readContentType,
    $17e21ac980463a29$var$readContentAny,
    $17e21ac980463a29$var$readContentDoc,
    ()=>{
        $ac5470ebbde53fbd$export$965b6bccecbd9673();
    } // 10 - Skip is not ItemContent
];
const $17e21ac980463a29$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $17e21ac980463a29$export$38d24f5c1eb0e4c0 extends $17e21ac980463a29$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $ac5470ebbde53fbd$export$965b6bccecbd9673();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($17e21ac980463a29$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $17e21ac980463a29$var$glo = /** @type {any} */ typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $17e21ac980463a29$var$importIdentifier = '__ $YJS$ __';
if ($17e21ac980463a29$var$glo[$17e21ac980463a29$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error('Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438');
$17e21ac980463a29$var$glo[$17e21ac980463a29$var$importIdentifier] = true;


/**
 * @module provider/websocket
 */ /* eslint-env browser */ 
/* eslint-env browser */ /**
 * Helpers for cross-tab communication using broadcastchannel with LocalStorage fallback.
 *
 * ```js
 * // In browser window A:
 * broadcastchannel.subscribe('my events', data => console.log(data))
 * broadcastchannel.publish('my events', 'Hello world!') // => A: 'Hello world!' fires synchronously in same tab
 *
 * // In browser window B:
 * broadcastchannel.publish('my events', 'hello from tab B') // => A: 'hello from tab B'
 * ```
 *
 * @module broadcastchannel
 */ // @todo before next major: use Uint8Array instead as buffer object




/**
 * @typedef {Object} Channel
 * @property {Set<function(any, any):any>} Channel.subs
 * @property {any} Channel.bc
 */ /**
 * @type {Map<string, Channel>}
 */ const $1a8fe686e723735f$var$channels = new Map();
/* c8 ignore start */ class $1a8fe686e723735f$var$LocalStoragePolyfill {
    /**
   * @param {ArrayBuffer} buf
   */ postMessage(buf) {
        $fe2925c7d83c1114$export$86b84a8d42aa2c65.setItem(this.room, $e84e5e8aa33903d1$export$37cc283d8fbd3462($e84e5e8aa33903d1$export$1b999ddd54e5bed1(buf)));
    }
    close() {
        $fe2925c7d83c1114$export$ff6a13ad336aa064(this._onChange);
    }
    /**
   * @param {string} room
   */ constructor(room){
        this.room = room;
        /**
     * @type {null|function({data:ArrayBuffer}):void}
     */ this.onmessage = null;
        /**
     * @param {any} e
     */ this._onChange = (e)=>e.key === room && this.onmessage !== null && this.onmessage({
                data: $e84e5e8aa33903d1$export$c537b38001c583b7(e.newValue || '')
            });
        $fe2925c7d83c1114$export$bd913411069e59d3(this._onChange);
    }
}
/* c8 ignore stop */ // Use BroadcastChannel or Polyfill
/* c8 ignore next */ const $1a8fe686e723735f$var$BC = typeof BroadcastChannel === 'undefined' ? $1a8fe686e723735f$var$LocalStoragePolyfill : BroadcastChannel;
/**
 * @param {string} room
 * @return {Channel}
 */ const $1a8fe686e723735f$var$getChannel = (room)=>$525cb12bf06b8e36$export$dccd489362a8619($1a8fe686e723735f$var$channels, room, ()=>{
        const subs = $e958eb447fee22f4$export$185802fd694ee1f5();
        const bc = new $1a8fe686e723735f$var$BC(room);
        /**
     * @param {{data:ArrayBuffer}} e
     */ /* c8 ignore next */ bc.onmessage = (e)=>subs.forEach((sub)=>sub(e.data, 'broadcastchannel'));
        return {
            bc: bc,
            subs: subs
        };
    });
const $1a8fe686e723735f$export$ec068583843480e7 = (room, f)=>{
    $1a8fe686e723735f$var$getChannel(room).subs.add(f);
    return f;
};
const $1a8fe686e723735f$export$f500693cef883ffd = (room, f)=>{
    const channel = $1a8fe686e723735f$var$getChannel(room);
    const unsubscribed = channel.subs.delete(f);
    if (unsubscribed && channel.subs.size === 0) {
        channel.bc.close();
        $1a8fe686e723735f$var$channels.delete(room);
    }
    return unsubscribed;
};
const $1a8fe686e723735f$export$89b472e03be495df = (room, data, origin = null)=>{
    const c = $1a8fe686e723735f$var$getChannel(room);
    c.bc.postMessage(data);
    c.subs.forEach((sub)=>sub(data, origin));
};





/**
 * @module sync-protocol
 */ 


const $f443a211c70458e6$export$edbc8479a3fd0d51 = 0;
const $f443a211c70458e6$export$ff102031071a8f85 = 1;
const $f443a211c70458e6$export$f589a35bfce33e17 = 2;
const $f443a211c70458e6$export$2a4abf6cf2c7e66f = (encoder, doc)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $f443a211c70458e6$export$edbc8479a3fd0d51);
    const sv = $17e21ac980463a29$export$3e2f5393f32e71f(doc);
    $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, sv);
};
const $f443a211c70458e6$export$b2b01faa10f64871 = (encoder, doc, encodedStateVector)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $f443a211c70458e6$export$ff102031071a8f85);
    $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $17e21ac980463a29$export$e5848df80e65bd53(doc, encodedStateVector));
};
const $f443a211c70458e6$export$24e7fa74cb33e063 = (decoder, encoder, doc)=>$f443a211c70458e6$export$b2b01faa10f64871(encoder, doc, $26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder));
const $f443a211c70458e6$export$60818ebea09048c1 = (decoder, doc, transactionOrigin)=>{
    try {
        $17e21ac980463a29$export$c271737a9c02e925(doc, $26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder), transactionOrigin);
    } catch (error) {
        // This catches errors that are thrown by event handlers
        console.error('Caught error while handling a Yjs update', error);
    }
};
const $f443a211c70458e6$export$72c173541034b28e = (encoder, update)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $f443a211c70458e6$export$f589a35bfce33e17);
    $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, update);
};
const $f443a211c70458e6$export$d67ac8d73b7d336c = $f443a211c70458e6$export$60818ebea09048c1;
const $f443a211c70458e6$export$26b589e63b591e96 = (decoder, encoder, doc, transactionOrigin)=>{
    const messageType = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
    switch(messageType){
        case $f443a211c70458e6$export$edbc8479a3fd0d51:
            $f443a211c70458e6$export$24e7fa74cb33e063(decoder, encoder, doc);
            break;
        case $f443a211c70458e6$export$ff102031071a8f85:
            $f443a211c70458e6$export$60818ebea09048c1(decoder, doc, transactionOrigin);
            break;
        case $f443a211c70458e6$export$f589a35bfce33e17:
            $f443a211c70458e6$export$d67ac8d73b7d336c(decoder, doc, transactionOrigin);
            break;
        default:
            throw new Error('Unknown message type');
    }
    return messageType;
};





const $a6c838641ff2c182$export$cfc218bc4e82266b = 0;
const $a6c838641ff2c182$export$492291cd287a058f = (encoder, reason)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $a6c838641ff2c182$export$cfc218bc4e82266b);
    $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, reason);
};
const $a6c838641ff2c182$export$7e13d1a8c99eb68e = (decoder, y, permissionDeniedHandler)=>{
    switch($26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder)){
        case $a6c838641ff2c182$export$cfc218bc4e82266b:
            permissionDeniedHandler(y, $26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder));
    }
};


/**
 * @module awareness-protocol
 */ 






const $26df11291dff2d5b$export$47b58b45939fff5e = 30000;
class $26df11291dff2d5b$export$5bb40478b91fee65 extends (0, $be5de554a627eab7$export$77cea355fa80b5f4) {
    destroy() {
        this.emit('destroy', [
            this
        ]);
        this.setLocalState(null);
        super.destroy();
        clearInterval(this._checkInterval);
    }
    /**
   * @return {Object<string,any>|null}
   */ getLocalState() {
        return this.states.get(this.clientID) || null;
    }
    /**
   * @param {Object<string,any>|null} state
   */ setLocalState(state) {
        const clientID = this.clientID;
        const currLocalMeta = this.meta.get(clientID);
        const clock = currLocalMeta === undefined ? 0 : currLocalMeta.clock + 1;
        const prevState = this.states.get(clientID);
        if (state === null) this.states.delete(clientID);
        else this.states.set(clientID, state);
        this.meta.set(clientID, {
            clock: clock,
            lastUpdated: $7e6fd9b4f77f8bda$export$1f77c0008d16313()
        });
        const added = [];
        const updated = [];
        const filteredUpdated = [];
        const removed = [];
        if (state === null) removed.push(clientID);
        else if (prevState == null) {
            if (state != null) added.push(clientID);
        } else {
            updated.push(clientID);
            if (!$fabe4bd8d0c6d92b$export$2ca9a723affd5d11(prevState, state)) filteredUpdated.push(clientID);
        }
        if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit('change', [
            {
                added: added,
                updated: filteredUpdated,
                removed: removed
            },
            'local'
        ]);
        this.emit('update', [
            {
                added: added,
                updated: updated,
                removed: removed
            },
            'local'
        ]);
    }
    /**
   * @param {string} field
   * @param {any} value
   */ setLocalStateField(field, value) {
        const state = this.getLocalState();
        if (state !== null) this.setLocalState({
            ...state,
            [field]: value
        });
    }
    /**
   * @return {Map<number,Object<string,any>>}
   */ getStates() {
        return this.states;
    }
    /**
   * @param {Y.Doc} doc
   */ constructor(doc){
        super();
        this.doc = doc;
        /**
     * @type {number}
     */ this.clientID = doc.clientID;
        /**
     * Maps from client id to client state
     * @type {Map<number, Object<string, any>>}
     */ this.states = new Map();
        /**
     * @type {Map<number, MetaClientState>}
     */ this.meta = new Map();
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            const now = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
            if (this.getLocalState() !== null && $26df11291dff2d5b$export$47b58b45939fff5e / 2 <= now - /** @type {{lastUpdated:number}} */ this.meta.get(this.clientID).lastUpdated) // renew local clock
            this.setLocalState(this.getLocalState());
            /**
       * @type {Array<number>}
       */ const remove = [];
            this.meta.forEach((meta, clientid)=>{
                if (clientid !== this.clientID && $26df11291dff2d5b$export$47b58b45939fff5e <= now - meta.lastUpdated && this.states.has(clientid)) remove.push(clientid);
            });
            if (remove.length > 0) $26df11291dff2d5b$export$3edbfe2f45ae9ff8(this, remove, 'timeout');
        }, $03d3cbe4a95134dd$export$a3fe094919f356fd($26df11291dff2d5b$export$47b58b45939fff5e / 10));
        doc.on('destroy', ()=>{
            this.destroy();
        });
        this.setLocalState({});
    }
}
const $26df11291dff2d5b$export$3edbfe2f45ae9ff8 = (awareness, clients, origin)=>{
    const removed = [];
    for(let i = 0; i < clients.length; i++){
        const clientID = clients[i];
        if (awareness.states.has(clientID)) {
            awareness.states.delete(clientID);
            if (clientID === awareness.clientID) {
                const curMeta = /** @type {MetaClientState} */ awareness.meta.get(clientID);
                awareness.meta.set(clientID, {
                    clock: curMeta.clock + 1,
                    lastUpdated: $7e6fd9b4f77f8bda$export$1f77c0008d16313()
                });
            }
            removed.push(clientID);
        }
    }
    if (removed.length > 0) {
        awareness.emit('change', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
        awareness.emit('update', [
            {
                added: [],
                updated: [],
                removed: removed
            },
            origin
        ]);
    }
};
const $26df11291dff2d5b$export$e194fa93ebd743e9 = (awareness, clients, states = awareness.states)=>{
    const len = clients.length;
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = clients[i];
        const state = states.get(clientID) || null;
        const clock = /** @type {MetaClientState} */ awareness.meta.get(clientID).clock;
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, clientID);
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, clock);
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, JSON.stringify(state));
    }
    return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
};
const $26df11291dff2d5b$export$17dfc8fb4d274726 = (update, modify)=>{
    const decoder = $26cf1cc17970e4a1$export$f8c898e83b60faaa(update);
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++){
        const clientID = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        const clock = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        const state = JSON.parse($26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder));
        const modifiedState = modify(state);
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, clientID);
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, clock);
        $f760bbc2c6d392e1$export$dde49cb52d5f1650(encoder, JSON.stringify(modifiedState));
    }
    return $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder);
};
const $26df11291dff2d5b$export$2f92845406d72d1a = (awareness, update, origin)=>{
    const decoder = $26cf1cc17970e4a1$export$f8c898e83b60faaa(update);
    const timestamp = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
    const added = [];
    const updated = [];
    const filteredUpdated = [];
    const removed = [];
    const len = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
    for(let i = 0; i < len; i++){
        const clientID = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        let clock = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        const state = JSON.parse($26cf1cc17970e4a1$export$3b64b4d753b81ec2(decoder));
        const clientMeta = awareness.meta.get(clientID);
        const prevState = awareness.states.get(clientID);
        const currClock = clientMeta === undefined ? 0 : clientMeta.clock;
        if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
            if (state === null) {
                // never let a remote client remove this local state
                if (clientID === awareness.clientID && awareness.getLocalState() != null) // remote client removed the local state. Do not remote state. Broadcast a message indicating
                // that this client still exists by increasing the clock
                clock++;
                else awareness.states.delete(clientID);
            } else awareness.states.set(clientID, state);
            awareness.meta.set(clientID, {
                clock: clock,
                lastUpdated: timestamp
            });
            if (clientMeta === undefined && state !== null) added.push(clientID);
            else if (clientMeta !== undefined && state === null) removed.push(clientID);
            else if (state !== null) {
                if (!$fabe4bd8d0c6d92b$export$2ca9a723affd5d11(state, prevState)) filteredUpdated.push(clientID);
                updated.push(clientID);
            }
        }
    }
    if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit('change', [
        {
            added: added,
            updated: filteredUpdated,
            removed: removed
        },
        origin
    ]);
    if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit('update', [
        {
            added: added,
            updated: updated,
            removed: removed
        },
        origin
    ]);
};




/**
 * Utility module to work with urls.
 *
 * @module url
 */ 
const $69956acb8aeb3a38$export$6025d61c37f75253 = (url)=>{
    /**
   * @type {Object<string,string>}
   */ const query = {};
    const urlQuerySplit = url.split('?');
    const pairs = urlQuerySplit[urlQuerySplit.length - 1].split('&');
    for(let i = 0; i < pairs.length; i++){
        const item = pairs[i];
        if (item.length > 0) {
            const pair = item.split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
    }
    return query;
};
const $69956acb8aeb3a38$export$8c0ce924e434923b = (params)=>$d54324b97fded352$export$871de8747c9eaa88(params, (val, key)=>`${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');



var $f8ZNS = parcelRequire("f8ZNS");
const $1a74706d495413ad$export$70790f6f28b13205 = 0;
const $1a74706d495413ad$export$83b62f7afdd0e333 = 3;
const $1a74706d495413ad$export$790bca08a5d3ef2c = 1;
const $1a74706d495413ad$export$89c03a973d1d6923 = 2;
/**
 *                       encoder,          decoder,          provider,          emitSynced, messageType
 * @type {Array<function(encoding.Encoder, decoding.Decoder, WebsocketProvider, boolean,    number):void>}
 */ const $1a74706d495413ad$var$messageHandlers = [];
$1a74706d495413ad$var$messageHandlers[$1a74706d495413ad$export$70790f6f28b13205] = (encoder, decoder, provider, emitSynced, _messageType)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$70790f6f28b13205);
    const syncMessageType = $f443a211c70458e6$export$26b589e63b591e96(decoder, encoder, provider.doc, provider);
    if (emitSynced && syncMessageType === $f443a211c70458e6$export$ff102031071a8f85 && !provider.synced) provider.synced = true;
};
$1a74706d495413ad$var$messageHandlers[$1a74706d495413ad$export$83b62f7afdd0e333] = (encoder, _decoder, provider, _emitSynced, _messageType)=>{
    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$790bca08a5d3ef2c);
    $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $26df11291dff2d5b$export$e194fa93ebd743e9(provider.awareness, Array.from(provider.awareness.getStates().keys())));
};
$1a74706d495413ad$var$messageHandlers[$1a74706d495413ad$export$790bca08a5d3ef2c] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $26df11291dff2d5b$export$2f92845406d72d1a(provider.awareness, $26cf1cc17970e4a1$export$7418bbc18dee40f3(decoder), provider);
};
$1a74706d495413ad$var$messageHandlers[$1a74706d495413ad$export$89c03a973d1d6923] = (_encoder, decoder, provider, _emitSynced, _messageType)=>{
    $a6c838641ff2c182$export$7e13d1a8c99eb68e(decoder, provider.doc, (_ydoc, reason)=>$1a74706d495413ad$var$permissionDeniedHandler(provider, reason));
};
// @todo - this should depend on awareness.outdatedTime
const $1a74706d495413ad$var$messageReconnectTimeout = 30000;
/**
 * @param {WebsocketProvider} provider
 * @param {string} reason
 */ const $1a74706d495413ad$var$permissionDeniedHandler = (provider, reason)=>console.warn(`Permission denied to access ${provider.url}.\n${reason}`);
/**
 * @param {WebsocketProvider} provider
 * @param {Uint8Array} buf
 * @param {boolean} emitSynced
 * @return {encoding.Encoder}
 */ const $1a74706d495413ad$var$readMessage = (provider, buf, emitSynced)=>{
    const decoder = $26cf1cc17970e4a1$export$f8c898e83b60faaa(buf);
    const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
    try {
        const messageType = $26cf1cc17970e4a1$export$5a476e4dbe7923d5(decoder);
        const messageHandler = provider.messageHandlers[messageType];
        if (/** @type {any} */ messageHandler) messageHandler(encoder, decoder, provider, emitSynced, messageType);
        else console.error('Unable to compute message');
    } catch (e) {}
    return encoder;
};
/**
 * @param {WebsocketProvider} provider
 */ const $1a74706d495413ad$var$setupWS = (provider)=>{
    if (provider.shouldConnect && provider.ws === null) {
        const websocket = new provider._WS(provider.url);
        websocket.binaryType = 'arraybuffer';
        provider.ws = websocket;
        provider.wsconnecting = true;
        provider.wsconnected = false;
        provider.synced = false;
        websocket.onmessage = (event)=>{
            provider.wsLastMessageReceived = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
            let ab = new Uint8Array(event.data);
            let stringEventData = String.fromCharCode.apply(null, ab);
            if (stringEventData === 'SedestralSync#!') {
                // always send sync step 1 when connected
                const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
                $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$70790f6f28b13205);
                $f443a211c70458e6$export$2a4abf6cf2c7e66f(encoder, provider.doc);
                websocket.send($f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
                // broadcast local awareness state
                if (provider.awareness.getLocalState() !== null) {
                    const encoderAwarenessState = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
                    $f760bbc2c6d392e1$export$872f48c75febcd2b(encoderAwarenessState, $1a74706d495413ad$export$790bca08a5d3ef2c);
                    $f760bbc2c6d392e1$export$f7d11515275e88a2(encoderAwarenessState, $26df11291dff2d5b$export$e194fa93ebd743e9(provider.awareness, [
                        provider.doc.clientID
                    ]));
                    websocket.send($f760bbc2c6d392e1$export$73470fd2221e6aef(encoderAwarenessState));
                }
            } else {
                const encoder = $1a74706d495413ad$var$readMessage(provider, ab, true);
                if ($f760bbc2c6d392e1$export$f24224f1c91d8156(encoder) > 1) websocket.send($f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
            }
        };
        websocket.onerror = (event)=>{
            provider.emit('connection-error', [
                event,
                provider
            ]);
        };
        websocket.onclose = (event)=>{
            provider.emit('connection-close', [
                event,
                provider
            ]);
            provider.ws = null;
            provider.wsconnecting = false;
            if (provider.wsconnected) {
                provider.wsconnected = false;
                provider.synced = false;
                // update awareness (all users except local left)
                $26df11291dff2d5b$export$3edbfe2f45ae9ff8(provider.awareness, Array.from(provider.awareness.getStates().keys()).filter((client)=>client !== provider.doc.clientID), provider);
                provider.emit('status', [
                    {
                        status: 'disconnected'
                    }
                ]);
            } else provider.wsUnsuccessfulReconnects++;
            // Start with no reconnect timeout and increase timeout by
            // using exponential backoff starting with 100ms
            setTimeout($1a74706d495413ad$var$setupWS, $03d3cbe4a95134dd$export$96ec731ed4dcb222($03d3cbe4a95134dd$export$9c297f60e22e3389(2, provider.wsUnsuccessfulReconnects) * 100, provider.maxBackoffTime), provider);
        };
        websocket.onopen = ()=>{
            provider.wsLastMessageReceived = $7e6fd9b4f77f8bda$export$1f77c0008d16313();
            provider.wsconnecting = false;
            provider.wsconnected = true;
            provider.wsUnsuccessfulReconnects = 0;
            provider.emit('status', [
                {
                    status: 'connected'
                }
            ]);
        };
        provider.emit('status', [
            {
                status: 'connecting'
            }
        ]);
    }
};
/**
 * @param {WebsocketProvider} provider
 * @param {ArrayBuffer} buf
 */ const $1a74706d495413ad$var$broadcastMessage = (provider, buf)=>{
    if (provider.wsconnected) /** @type {WebSocket} */ provider.ws.send(buf);
    if (provider.bcconnected) $1a8fe686e723735f$export$89b472e03be495df(provider.bcChannel, buf, provider);
};
class $1a74706d495413ad$export$c0e03644998998fb extends (0, $be5de554a627eab7$export$77cea355fa80b5f4) {
    /**
   * @type {boolean}
   */ get synced() {
        return this._synced;
    }
    set synced(state) {
        if (this._synced !== state) {
            this._synced = state;
            this.emit('synced', [
                state
            ]);
            this.emit('sync', [
                state
            ]);
        }
    }
    destroy() {
        if (this._resyncInterval !== 0) clearInterval(this._resyncInterval);
        clearInterval(this._checkInterval);
        this.disconnect();
        if (typeof window !== 'undefined') window.removeEventListener('unload', this._unloadHandler);
        else if (typeof $f8ZNS !== 'undefined') $f8ZNS.off('exit', this._unloadHandler);
        this.awareness.off('update', this._awarenessUpdateHandler);
        this.doc.off('update', this._updateHandler);
        super.destroy();
    }
    connectBc() {
        if (this.disableBc) return;
        if (!this.bcconnected) {
            $1a8fe686e723735f$export$ec068583843480e7(this.bcChannel, this._bcSubscriber);
            this.bcconnected = true;
        }
        // send sync step1 to bc
        // write sync step 1
        const encoderSync = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoderSync, $1a74706d495413ad$export$70790f6f28b13205);
        $f443a211c70458e6$export$2a4abf6cf2c7e66f(encoderSync, this.doc);
        $1a8fe686e723735f$export$89b472e03be495df(this.bcChannel, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoderSync), this);
        // broadcast local state
        const encoderState = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoderState, $1a74706d495413ad$export$70790f6f28b13205);
        $f443a211c70458e6$export$b2b01faa10f64871(encoderState, this.doc);
        $1a8fe686e723735f$export$89b472e03be495df(this.bcChannel, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoderState), this);
        // write queryAwareness
        const encoderAwarenessQuery = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoderAwarenessQuery, $1a74706d495413ad$export$83b62f7afdd0e333);
        $1a8fe686e723735f$export$89b472e03be495df(this.bcChannel, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoderAwarenessQuery), this);
        // broadcast local awareness state
        const encoderAwarenessState = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoderAwarenessState, $1a74706d495413ad$export$790bca08a5d3ef2c);
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoderAwarenessState, $26df11291dff2d5b$export$e194fa93ebd743e9(this.awareness, [
            this.doc.clientID
        ]));
        $1a8fe686e723735f$export$89b472e03be495df(this.bcChannel, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoderAwarenessState), this);
    }
    disconnectBc() {
        // broadcast message with local awareness state set to null (indicating disconnect)
        const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
        $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$790bca08a5d3ef2c);
        $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $26df11291dff2d5b$export$e194fa93ebd743e9(this.awareness, [
            this.doc.clientID
        ], new Map()));
        $1a74706d495413ad$var$broadcastMessage(this, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
        if (this.bcconnected) {
            $1a8fe686e723735f$export$f500693cef883ffd(this.bcChannel, this._bcSubscriber);
            this.bcconnected = false;
        }
    }
    disconnect() {
        this.shouldConnect = false;
        this.disconnectBc();
        if (this.ws !== null) this.ws.close();
    }
    connect() {
        this.shouldConnect = true;
        if (!this.wsconnected && this.ws === null) {
            $1a74706d495413ad$var$setupWS(this);
            this.connectBc();
        }
    }
    /**
   * @param {string} serverUrl
   * @param {string} roomname
   * @param {Y.Doc} doc
   * @param {object} [opts]
   * @param {boolean} [opts.connect]
   * @param {awarenessProtocol.Awareness} [opts.awareness]
   * @param {Object<string,string>} [opts.params]
   * @param {typeof WebSocket} [opts.WebSocketPolyfill] Optionall provide a WebSocket polyfill
   * @param {number} [opts.resyncInterval] Request server state every `resyncInterval` milliseconds
   * @param {number} [opts.maxBackoffTime] Maximum amount of time to wait before trying to reconnect (we try to reconnect using exponential backoff)
   * @param {boolean} [opts.disableBc] Disable cross-tab BroadcastChannel communication
   */ constructor(serverUrl, roomname, doc, { connect: connect = true, awareness: awareness = new $26df11291dff2d5b$export$5bb40478b91fee65(doc), params: params = {}, WebSocketPolyfill: WebSocketPolyfill = WebSocket, resyncInterval: resyncInterval = -1, maxBackoffTime: maxBackoffTime = 2500, disableBc: disableBc = false } = {}){
        super();
        // ensure that url is always ends with /
        while(serverUrl[serverUrl.length - 1] === '/')serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        const encodedParams = $69956acb8aeb3a38$export$8c0ce924e434923b(params);
        this.maxBackoffTime = maxBackoffTime;
        this.bcChannel = serverUrl + '/' + roomname;
        this.url = serverUrl + '/' + roomname + (encodedParams.length === 0 ? '' : '?' + encodedParams);
        this.roomname = roomname;
        this.doc = doc;
        this._WS = WebSocketPolyfill;
        this.awareness = awareness;
        this.wsconnected = false;
        this.wsconnecting = false;
        this.bcconnected = false;
        this.disableBc = disableBc;
        this.wsUnsuccessfulReconnects = 0;
        this.messageHandlers = $1a74706d495413ad$var$messageHandlers.slice();
        /**
     * @type {boolean}
     */ this._synced = false;
        /**
     * @type {WebSocket?}
     */ this.ws = null;
        this.wsLastMessageReceived = 0;
        /**
     * Whether to connect to other peers or not
     * @type {boolean}
     */ this.shouldConnect = connect;
        /**
     * @type {number}
     */ this._resyncInterval = 0;
        if (resyncInterval > 0) this._resyncInterval = /** @type {any} */ setInterval(()=>{
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                // resend sync step 1
                const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
                $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$70790f6f28b13205);
                $f443a211c70458e6$export$2a4abf6cf2c7e66f(encoder, doc);
                this.ws.send($f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
            }
        }, resyncInterval);
        /**
     * @param {ArrayBuffer} data
     * @param {any} origin
     */ this._bcSubscriber = (data, origin)=>{
            if (origin !== this) {
                const encoder = $1a74706d495413ad$var$readMessage(this, new Uint8Array(data), false);
                if ($f760bbc2c6d392e1$export$f24224f1c91d8156(encoder) > 1) $1a8fe686e723735f$export$89b472e03be495df(this.bcChannel, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder), this);
            }
        };
        /**
     * Listens to Yjs updates and sends them to remote peers (ws and broadcastchannel)
     * @param {Uint8Array} update
     * @param {any} origin
     */ this._updateHandler = (update, origin)=>{
            if (origin !== this) {
                const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
                $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$70790f6f28b13205);
                $f443a211c70458e6$export$72c173541034b28e(encoder, update);
                $1a74706d495413ad$var$broadcastMessage(this, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
            }
        };
        this.doc.on('update', this._updateHandler);
        /**
     * @param {any} changed
     * @param {any} _origin
     */ this._awarenessUpdateHandler = ({ added: added, updated: updated, removed: removed }, _origin)=>{
            const changedClients = added.concat(updated).concat(removed);
            const encoder = $f760bbc2c6d392e1$export$4e76eeb6df88c889();
            $f760bbc2c6d392e1$export$872f48c75febcd2b(encoder, $1a74706d495413ad$export$790bca08a5d3ef2c);
            $f760bbc2c6d392e1$export$f7d11515275e88a2(encoder, $26df11291dff2d5b$export$e194fa93ebd743e9(awareness, changedClients));
            $1a74706d495413ad$var$broadcastMessage(this, $f760bbc2c6d392e1$export$73470fd2221e6aef(encoder));
        };
        this._unloadHandler = ()=>{
            $26df11291dff2d5b$export$3edbfe2f45ae9ff8(this.awareness, [
                doc.clientID
            ], 'window unload');
        };
        if (typeof window !== 'undefined') window.addEventListener('unload', this._unloadHandler);
        else if (typeof $f8ZNS !== 'undefined') $f8ZNS.on('exit', this._unloadHandler);
        awareness.on('update', this._awarenessUpdateHandler);
        this._checkInterval = /** @type {any} */ setInterval(()=>{
            if (this.wsconnected && $1a74706d495413ad$var$messageReconnectTimeout < $7e6fd9b4f77f8bda$export$1f77c0008d16313() - this.wsLastMessageReceived) // no message received in a long time - not even your own awareness
            // updates (which are updated every 15 seconds)
            /** @type {WebSocket} */ this.ws.close();
        }, $1a74706d495413ad$var$messageReconnectTimeout / 10);
        if (connect) this.connect();
    }
}



var $271MM = parcelRequire("271MM");

var $kfkzw = parcelRequire("kfkzw");

var $bi5k0 = parcelRequire("bi5k0");
class $eca38d8f83f4604c$export$d9845d64048805ae {
    static dispose() {
        this.editors = (0, $i3Hbv.observable)([]);
    }
    static init() {
        (0, $2Y8XI.Services).beforeInit(this);
        this.products = [
            (0, $kfkzw.ProductType).PANEL,
            (0, $kfkzw.ProductType).COMMUNITY
        ];
        this.products.forEach((productType)=>{
            (0, $2Y8XI.Services).on(this, productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_METADATA, (data)=>{
                if (data != undefined) this.metadataEvents.forEach((value)=>{
                    if (value.editorId == data.editorId) value.func(data);
                });
            });
            (0, $2Y8XI.Services).on(this, productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_ATTACHMENTS, (data)=>{
                let attachments = this.storeAttachments(data);
                let editor = this.editors.filter((value)=>value.id == data.editorId)[0];
                if (editor) editor.attachments = attachments;
                this.attachmentsChangesEvents.forEach((value)=>{
                    if (value.editorId == data.editorId) value.func(data.viewerId, attachments);
                });
            });
            (0, $2Y8XI.Services).on(this, productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_VIEWER_JOIN, (viewer)=>{
                viewer = this.storeViewer(viewer);
                let editor = this.editors.filter((v)=>v.id == viewer.editorId)[0];
                if (editor != undefined) {
                    editor.viewers = [
                        ...editor.viewers,
                        viewer
                    ];
                    this.viewerJoinEvents.forEach((events)=>{
                        if (events.editorId == viewer.editorId) events.func(viewer);
                    });
                }
            });
            (0, $2Y8XI.Services).on(this, productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_VIEWER_LEAVE, (viewer)=>{
                viewer = this.storeViewer(viewer);
                let editor = this.editors.filter((v)=>v.id == viewer.editorId)[0];
                if (editor != undefined) {
                    editor.viewers.forEach((v)=>{
                        if (v.id == viewer.id) editor.viewers.splice(editor.viewers.indexOf(v), 1);
                    });
                    this.viewerLeaveEvents.forEach((events)=>{
                        if (events.editorId == viewer.editorId) events.func(viewer);
                    });
                }
            });
        });
    }
    /**
     * action
     */ static onMetadata(editorId, v, component) {
        let i = {
            editorId: editorId,
            func: v
        };
        this.metadataEvents.push(i);
        component.onRemove(()=>this.metadataEvents.splice(this.metadataEvents.indexOf(i), 1));
    }
    static onAttachmentsChanges(editorId, v, component) {
        let i = {
            editorId: editorId,
            func: v
        };
        this.attachmentsChangesEvents.push(i);
        component.onRemove(()=>this.attachmentsChangesEvents.splice(this.attachmentsChangesEvents.indexOf(i), 1));
    }
    static onViewerJoin(editorId, v, component) {
        let i = {
            editorId: editorId,
            func: v
        };
        this.viewerJoinEvents.push(i);
        component.onRemove(()=>this.viewerJoinEvents.splice(this.viewerJoinEvents.indexOf(i), 1));
    }
    static onViewerLeave(editorId, v, component) {
        let i = {
            editorId: editorId,
            func: v
        };
        this.viewerLeaveEvents.push(i);
        component.onRemove(()=>this.viewerLeaveEvents.splice(this.viewerLeaveEvents.indexOf(i), 1));
    }
    /**
     * saving
     */ static async savingMetadata(productType, p) {
        await (0, $7AbeR.Network).emitSync(productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_METADATA, p);
    }
    static async savingAttachments(productType, p) {
        await (0, $7AbeR.Network).emitSync(productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_SAVE_ATTACHMENTS, p);
    }
    /**
     * websocket doc
     */ static collaborationJoin(component, productType, editorId, privateId, connect, error) {
        let yDoc = new $17e21ac980463a29$export$bceacc74c2212615();
        let meta = yDoc.getMap('meta');
        let productName = (0, $bi5k0.ProductName).toString(productType);
        let provider = new (0, $1a74706d495413ad$export$c0e03644998998fb)(`${(0, $271MM.config).editorCollaborationUrl}/?productType=${productName}&private=${privateId}&editor=${editorId}&`, editorId, yDoc);
        component.onRemove(()=>provider.disconnect());
        provider.on("status", (data)=>{
            if (data.status == "connected") connect({
                yDoc: yDoc,
                yText: yDoc.getText(editorId),
                provider: provider
            });
            else {
                provider.disconnect();
                yDoc.destroy();
                error();
            }
        });
        provider.on('connection-error', (data)=>{
            if (!component.isNull()) {
                provider.disconnect();
                yDoc.destroy();
                error();
            }
        });
    }
    /**
     * websocket handshaking
     */ static async join(productType, data) {
        if (data != null) {
            let join = await (0, $7AbeR.Network).join(productType, data, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_JOIN);
            if (typeof join != "number") {
                join.editor = this.store(join.editor);
                join.viewer = this.storeViewer(join.viewer);
            }
            return join;
        }
        return undefined;
    }
    static leave(productType, editorId, viewerId) {
        (0, $7AbeR.Network).emit(productType, (0, $2eT6g.WebSocketPanelEventName).COLLABORATION_EDITOR_LEAVE, {
            editorId: editorId,
            viewerId: viewerId
        });
    }
    /**
     * store
     */ static storeAll(editors) {
        for(let key in editors)editors[key] = this.store(editors[key]);
        return (0, $2Y8XI.Services).storeAll(editors);
    }
    static store(editor) {
        editor.viewers = this.storeViewersAll(editor.viewers);
        editor.attachments = this.storeAttachments(editor.attachments);
        editor = (0, $2Y8XI.Services).store("id", this.editors, editor);
        return editor;
    }
    static storeAttachments(attachments) {
        attachments.previews.forEach((value)=>{
            value.preview = (0, $j8ebN.PreviewService).store(value.preview);
            value.account = (0, $7Aqrk.AccountService).store(value.account);
        });
        attachments.files.forEach((value)=>{
            value.file = (0, $bKmye.FileService).store(value.file);
            value.account = (0, $7Aqrk.AccountService).store(value.account);
            if (value.cropping) Object.keys(value.cropping).forEach((key)=>{
                let crop = value.cropping[key];
                if (crop) crop.content = (0, $bKmye.FileService).store(crop.content);
            });
        });
        return attachments;
    }
    static storeViewersAll(viewers) {
        for(let key in viewers)viewers[key] = this.storeViewer(viewers[key]);
        return (0, $2Y8XI.Services).storeAll(viewers);
    }
    static storeViewer(viewer) {
        viewer.account = (0, $7Aqrk.AccountService).store(viewer.account);
        viewer = (0, $2Y8XI.Services).store("id", this.viewers, viewer);
        return viewer;
    }
}
$eca38d8f83f4604c$export$d9845d64048805ae.editors = (0, $i3Hbv.observable)([]);
$eca38d8f83f4604c$export$d9845d64048805ae.viewers = (0, $i3Hbv.observable)([]);
$eca38d8f83f4604c$export$d9845d64048805ae.attachmentsChangesEvents = [];
$eca38d8f83f4604c$export$d9845d64048805ae.viewerJoinEvents = [];
$eca38d8f83f4604c$export$d9845d64048805ae.viewerLeaveEvents = [];
$eca38d8f83f4604c$export$d9845d64048805ae.metadataEvents = [];
$eca38d8f83f4604c$export$d9845d64048805ae.products = [];



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $2Y8XI = parcelRequire("2Y8XI");

var $5FliW = parcelRequire("5FliW");

var $7ZaxO = parcelRequire("7ZaxO");
class $36d265ad8cd70e05$export$961fa99b63baa1c2 {
    static dispose() {}
    static init() {}
    /**
     * rest
     */ static async lost(lost, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.forgotPasswordEmailNoFound")
            }
        ]);
        return await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/account/password/lost`, lost, component);
    }
}




var $kfkzw = parcelRequire("kfkzw");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $680ec485db5e71e8$export$88eb42c4a6e30051 {
    static dispose() {}
    static init() {}
    /**
     * store
     */ static async update(id, text) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/text/update/" + id, text);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static storeAll(texts) {
        for(let key in texts)texts[key] = this.store(texts[key]);
        return (0, $2Y8XI.Services).storeAll(texts);
    }
    static store(text) {
        return (0, $2Y8XI.Services).store("id", this.texts, text);
    }
}
$680ec485db5e71e8$export$88eb42c4a6e30051.texts = (0, $i3Hbv.observable)([]);



var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7Aqrk = parcelRequire("7Aqrk");

var $7AbeR = parcelRequire("7AbeR");

var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");
class $e1536de0087baae2$export$e473f7e46afe97f7 {
}
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_JOIN = "community/join";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_LEAVE = "community/leave";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_UPDATE = "community/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_WRITING_STYLE_UPDATE = "community/writingStyle/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE = "community/seo/cluster/keywords/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_SEO_AUDIT_UPDATE = "community/seo/audit/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_JOIN = "community/article/join";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_LEAVE = "community/article/leave";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_CREATE = "community/article/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_DELETE = "community/article/delete";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_UPDATE = "community/article/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_RATING_UPDATE = "community/article/rating/update";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_PROPOSAL_CREATE = "community/article/proposal/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_SECTION_CREATE = "community/article/section/create";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE = "community/article/generate";
$e1536de0087baae2$export$e473f7e46afe97f7.COMMUNITY_ARTICLE_GENERATE_START = "community/article/generate/start";



var $i3Hbv = parcelRequire("i3Hbv");

var $2Y8XI = parcelRequire("2Y8XI");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $271MM = parcelRequire("271MM");
class $e76657c0ca80eee3$export$3d1acc6bf13b6cd1 {
    static dispose() {}
    static init() {}
    static async create(communityId, fileType, files, progress, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).COMMUNITY, `/community/files`, {
            communityId: communityId,
            files: files,
            fileType: fileType
        }, component, {
            onUploadProgress: (progressEvent)=>{
                if (progress) progress(progressEvent.loaded * 100 / progressEvent.total);
            }
        });
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async searchImages(communityId, query, page, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/files/search/images", {
            communityId: communityId,
            query: query,
            page: page
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async downloadImage(communityId, imageId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/files/download/image", {
            communityId: communityId,
            imageId: imageId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
    }
    /**
     * link
     */ static link(file) {
        var _config_httpCommunityUrl;
        return ((_config_httpCommunityUrl = (0, $271MM.config).httpCommunityUrl) !== null && _config_httpCommunityUrl !== void 0 ? _config_httpCommunityUrl : (0, $271MM.config).domain) + `/community/files/${file.id}.${file.extension}`;
    }
    /**
     * store
     */ static storeAll(files) {
        for(let key in files)files[key] = this.store(files[key]);
        return (0, $2Y8XI.Services).storeAll(files);
    }
    static store(file) {
        file.link = this.link(file);
        return (0, $2Y8XI.Services).store("id", this.files, file);
    }
}
$e76657c0ca80eee3$export$3d1acc6bf13b6cd1.files = (0, $i3Hbv.observable)([]);


/**
 * Retire un élément de l'array
 */ function $430c7e198afa9f6b$export$30a014203d0d7e4f(arr, obj) {
    let index = arr.indexOf(obj);
    if (index >= 0) arr.splice(index, 1);
}


var $00ecc5127dabc543$export$1f6539ddf1c5815 = /*#__PURE__*/ function(CommunityArticleAIState) {
    CommunityArticleAIState[CommunityArticleAIState["NONE"] = 0] = "NONE";
    CommunityArticleAIState[CommunityArticleAIState["WAITING_IA"] = 1] = "WAITING_IA";
    CommunityArticleAIState[CommunityArticleAIState["ERROR"] = 2] = "ERROR";
    CommunityArticleAIState[CommunityArticleAIState["DONE"] = 3] = "DONE";
    return CommunityArticleAIState;
}({});



var $cyFTW = parcelRequire("cyFTW");
class $5aab3284ce582eaf$export$439035f52ab89a16 {
    static dispose() {
        this.createEvents = [];
        this.deleteEvents = [];
        this.updateEvents = [];
        this.proposalEvents = [];
        this.sectionEvents = [];
        this.generateEvents = [];
        this.ratingUpdateEvents = [];
        this.generateStartEvents = [];
    }
    static init() {
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["CommunityArticleService"] = this;
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_CREATE, (data)=>{
            let article = this.store(data);
            this.createEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_UPDATE, (data)=>{
            let article = this.store(data);
            this.updateEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_DELETE, (data)=>{
            let article = this.store(data);
            this.deleteEvents.forEach((value)=>value(article));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_PROPOSAL_CREATE, (proposal)=>{
            this.storeProposal(proposal);
            this.proposalEvents.forEach((value)=>value(proposal));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_SECTION_CREATE, (section)=>{
            this.storeSection(section);
            this.sectionEvents.forEach((value)=>value(section));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE, (data)=>{
            this.generateEvents.forEach((value)=>value(data));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_RATING_UPDATE, (data)=>{
            this.ratingUpdateEvents.forEach((value)=>value(data));
        });
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_GENERATE_START, (data)=>{
            this.generateStarts.push(data);
            this.generateStartEvents.forEach((value)=>value(data));
        });
    }
    /**
     * websocket
     */ static onCreateEvent(component, func) {
        this.createEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.createEvents, func));
    }
    static onDeleteEvent(component, func) {
        this.deleteEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.deleteEvents, func));
    }
    static onUpdateEvent(component, func) {
        this.updateEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.updateEvents, func));
    }
    static onProposalEvent(component, func) {
        this.proposalEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.proposalEvents, func));
    }
    static onSectionEvent(component, func) {
        this.sectionEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.sectionEvents, func));
    }
    static onGenerateEvent(component, func) {
        this.generateEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.generateEvents, func));
    }
    static onRatingUpdateEvent(component, func) {
        this.ratingUpdateEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.ratingUpdateEvents, func));
    }
    static onGenerateStartEvent(component, articleId, func) {
        let start = this.generateStarts.find((value)=>value.articleId == articleId);
        if (start) {
            func(start);
            (0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.generateStarts, start);
        }
        this.generateStartEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.generateStartEvents, func));
    }
    /**
     * http
     */ static async stepOptimization(communityArticleStepOptimization, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/optimization", communityArticleStepOptimization, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async stepKeyword(keyword, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxProposalsPerItem")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/keyword", keyword, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async stepSelectTerms(terms, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/manual/selectTerms", terms, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async getLinks(articleId, proposalItemIndex, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/article/links", {
            articleId: articleId,
            proposalItemIndex: proposalItemIndex
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async aiStepRulesValidate(rules, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/ai/rules", rules, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiStepRulesUpdate(rules, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            },
            {
                status: (0, $7ZaxO.HttpStatus).UNAUTHORIZED,
                message: "none"
            },
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: "none"
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, "/community/article/step/ai/rules", rules, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiProposalsRetry(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/proposals/retry`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSections(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSectionsRetry(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections/retry`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiSectionsUpdate(p, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/sections/update`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async aiGenerate(p, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).GPT_RETRY_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxRetryLimit")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article/ai/generate`, p, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async lastUserContexts(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/last-user-contexts/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async findById(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async generatedCount(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/generated/count/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async update(update, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).ROUTE_EXIST,
                message: (0, $5FliW.Resources).t("words.routeExist")
            }
        ]);
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, `/community/article`, update, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            this.store(request.data);
            return true;
        }
        return false;
    }
    static async delete(articleId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/article/${articleId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) this.unStore(request.data);
        return undefined;
    }
    static async search(communityId, language, search, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/list/${communityId}/${language}/${search}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeArticles(request.data);
        return undefined;
    }
    static async alternate(id, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/alternate/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async getArticlesMonitoring(communityId, pagination, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/articles/monitoring/${communityId}`, pagination, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getRatingTermOverview(articleId, term, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/article/rating/term/overview", {
            articleId: articleId,
            term: term
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async switchContentVersioning(articleId, contentVersioningId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/article/switchContentVersioning", {
            articleId: articleId,
            contentVersioningId: contentVersioningId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getContentsVersioning(articleId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/contentsVersioning/${articleId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async importContent(communityId, url, remoteId, localId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: (0, $5FliW.Resources).t("words.importFailedContentTooSmall")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/article/import", {
            communityId: communityId,
            url: url,
            remoteId: remoteId,
            localId: localId
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) {
            let imported = request.data;
            if (imported.title) imported.title = (0, $cyFTW.filterXSS)(imported.title);
            if (imported.html) imported.html = (0, $cyFTW.filterXSS)(imported.html);
            if (imported.snippet) imported.snippet = (0, $cyFTW.filterXSS)(imported.snippet);
            return imported;
        }
    }
    static async getLastArticlesOverview(communityId, remote, cursor, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/article/overview", {
            communityId: communityId,
            remote: remote,
            cursor: cursor
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getByCommunity(communityId, nextCursor, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/article/list/${communityId}/${nextCursor}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    /**
     * websocket
     */ static async join(id) {
        if (id != null) {
            await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).COMMUNITY, id, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_JOIN);
            this.joinedArticleId = id;
        }
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_ARTICLE_LEAVE, id);
        this.joinedArticleId = undefined;
    }
    /**
     * store
     */ static storeArticles(articles) {
        articles.articles = $5aab3284ce582eaf$export$439035f52ab89a16.storeAll(articles.articles);
        return articles;
    }
    static storeAll(articles) {
        for(let key in articles)articles[key] = this.store(articles[key]);
        return (0, $2Y8XI.Services).storeAll(articles);
    }
    static storeProposal(proposal) {
        let article = this.articles.find((value)=>value.id == proposal.articleId);
        if (article && article.proposals) article.proposals.items[proposal.index].proposals.push(proposal.proposal);
    }
    static storeSection(section) {
        let article = this.articles.find((value)=>value.id == section.articleId);
        if (article && article.sections) article.sections.items[section.indexSection].sections.push(section.section);
    }
    static store(article) {
        let storedArticle = (0, $2Y8XI.Services).get("id", this.articles, article.id);
        if (storedArticle != undefined) {
            if (article.writersAccounts.length == 0 && storedArticle.writersAccounts.length !== 0) article.writersAccounts = storedArticle.writersAccounts;
            if (article.writersRedactors.length == 0 && storedArticle.writersRedactors.length !== 0) article.writersRedactors = storedArticle.writersRedactors;
        }
        if (article.imageFile) article.imageFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(article.imageFile);
        (0, $7Aqrk.AccountService).storeAll(article.writersAccounts);
        return (0, $2Y8XI.Services).store("id", this.articles, article);
    }
    static unStore(article) {
        (0, $2Y8XI.Services).unStore("id", this.articles, article);
    }
    static storeMetadata(metadata) {
        if (metadata.imageFile) metadata.imageFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(metadata.imageFile);
        (0, $7Aqrk.AccountService).storeAll(metadata.writersAccounts);
    }
    static getMainKeyword(article) {
        var _article_sections, _article_proposals_items_doneSection_index_keywords, _article_proposals_items_doneSection_index, _article_proposals;
        const doneSection = article === null || article === void 0 ? void 0 : (_article_sections = article.sections) === null || _article_sections === void 0 ? void 0 : _article_sections.items.find((section)=>section.state === (0, $00ecc5127dabc543$export$1f6539ddf1c5815).DONE);
        var _article_proposals_items_doneSection_index_keywords_;
        return doneSection ? (_article_proposals_items_doneSection_index_keywords_ = article === null || article === void 0 ? void 0 : (_article_proposals = article.proposals) === null || _article_proposals === void 0 ? void 0 : (_article_proposals_items_doneSection_index = _article_proposals.items[doneSection.index]) === null || _article_proposals_items_doneSection_index === void 0 ? void 0 : (_article_proposals_items_doneSection_index_keywords = _article_proposals_items_doneSection_index.keywords) === null || _article_proposals_items_doneSection_index_keywords === void 0 ? void 0 : _article_proposals_items_doneSection_index_keywords[0]) !== null && _article_proposals_items_doneSection_index_keywords_ !== void 0 ? _article_proposals_items_doneSection_index_keywords_ : "" : "";
    }
}
$5aab3284ce582eaf$export$439035f52ab89a16.NB_MAX_SECTIONS_BY_ITEM = 7;
$5aab3284ce582eaf$export$439035f52ab89a16.articles = (0, $i3Hbv.observable)([]);
$5aab3284ce582eaf$export$439035f52ab89a16.createEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.deleteEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.updateEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.proposalEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.sectionEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.ratingUpdateEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateStartEvents = [];
$5aab3284ce582eaf$export$439035f52ab89a16.generateStarts = [];



var $7ZaxO = parcelRequire("7ZaxO");

var $kfkzw = parcelRequire("kfkzw");

var $271MM = parcelRequire("271MM");

var $bi5k0 = parcelRequire("bi5k0");

var $5FliW = parcelRequire("5FliW");


var $bTARt = parcelRequire("bTARt");


var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");
var $75961db7d7c0df07$export$27fb916c8cac12c7 = /*#__PURE__*/ function(CommunityVisitorActionType) {
    CommunityVisitorActionType[CommunityVisitorActionType["LINK"] = 1] = "LINK";
    return CommunityVisitorActionType;
}({});



var $nyKU9 = parcelRequire("nyKU9");
class $57a401ba8ef81077$export$d41076a259927884 {
    static dispose() {}
    static init() {
        (0, $7AbeR.Network).onStarted(()=>{
            (0, $7AbeR.Network).router.pages.stats.onNewPage((stats, page)=>{
                this.queuedPages.push({
                    duration: page.duration,
                    route: page.route,
                    endTime: page.endTime,
                    startTime: page.startTime,
                    viewedPercentage: page.viewedPercentage,
                    actions: page.actions.map((value)=>{
                        return {
                            name: value.name,
                            value: value.value,
                            time: value.time,
                            actionType: value.type == "link" ? (0, $75961db7d7c0df07$export$27fb916c8cac12c7).LINK : (0, $75961db7d7c0df07$export$27fb916c8cac12c7).LINK
                        };
                    })
                });
            });
            (0, $7AbeR.Network).router.pages.stats.onClosePage((stats)=>this.save());
            (0, $nyKU9.SedestralMachine).setInterval(()=>this.save(), 15000);
        });
    }
    static save() {
        if (this.queuedPages.length > 0) {
            this.insert({
                frontId: (0, $7AbeR.Network).router.pages.stats.frontId,
                referrer: (0, $7AbeR.Network).router.pages.stats.referrer,
                pages: this.queuedPages
            });
            this.queuedPages = [];
        }
    }
    static async insert(visitor, component) {
        await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/visitor`, visitor, component);
    }
}
$57a401ba8ef81077$export$d41076a259927884.queuedPages = [];



var $nyKU9 = parcelRequire("nyKU9");

var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");


var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $ea99dfb6cc838099$export$6368a938bdcd0b2 {
    static dispose() {}
    static init() {}
    static async update(communityId, communityAutopilot, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).COMMUNITY_AUTOPILOT_DAYS_MAX,
                message: (0, $5FliW.Resources).t("words.communityAutopilotDaysMax")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/autopilot/update/${communityId}`, communityAutopilot);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
    static async addCluster(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/autopilot/cluster/add/${communityId}/${clusterId}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
    static async deleteCluster(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/autopilot/cluster/delete/${communityId}/${clusterId}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");



class $8a2826395ed74d11$export$106b309753d02dc0 {
    static dispose() {
        this.styleEvents = [];
    }
    static init() {
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_WRITING_STYLE_UPDATE, (data)=>{
            (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(data.community);
            this.styleEvents.forEach((value)=>value(data));
        });
    }
    /**
     * websocket
     */ static onWritingStyle(component, func) {
        this.styleEvents.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.styleEvents, func));
    }
    static async create(style, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/writingStyle`, style, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async delete(communityId, writingStyleId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/writingStyle/${communityId}/${writingStyleId}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).store(request.data);
        return undefined;
    }
}
$8a2826395ed74d11$export$106b309753d02dc0.styleEvents = [];



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $16fe27051c61311b$export$c8c9ba79e1431b49 {
    static dispose() {}
    static init() {}
    static async getKeywordsSite(search, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/site`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async searchKeywords(name, search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/search/${name}`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async searchKeywordsHistory(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/keywords/search/history/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createRankingOverview(communityId, host, owner, dateStart, dateEnd, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: (0, $5FliW.Resources).t("words.domainAlreadyInStats")
            }
        ]);
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/overview/create/${communityId}/${host}/${owner}/${dateStart}/${dateEnd}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getRankingOverview(communityId, dateStart, dateEnd, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/overview/${communityId}/${dateStart}/${dateEnd}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        if (request.status == (0, $7ZaxO.HttpStatus).NOT_FOUND) return [];
        return undefined;
    }
    static async getIndividualsPositioning(id, search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/individualsPositioning/${id}`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getCannibalization(communityId, pagination, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/cannibalization/${communityId}`, pagination, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getComparativePositioning(search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/comparativePositioning`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async deleteRanking(id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/ranking/${id}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $4db228f3f242765b$export$b7b630d38b5e9168 {
    static dispose() {}
    static init() {}
    static async getByCommunity(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/${communityId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return [];
    }
    static async create(communityId, name, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/${communityId}/${name}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async update(communityId, knowledgeId, name, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/update/${communityId}/${knowledgeId}/${name}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, knowledgeId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/delete/${communityId}/${knowledgeId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createResource(communityId, knowledgeId, resource, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/resource/${communityId}/${knowledgeId}`, resource, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async createResourceFile(communityId, knowledgeId, meshing, file, component) {
        let request = await (0, $7AbeR.Network).postFormData((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/create/resource/file/${communityId}/${meshing}/${knowledgeId}`, {
            file: file
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async deleteResource(communityId, knowledgeId, resourceId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/knowledge/delete/${communityId}/${knowledgeId}/${resourceId}`, component);
        if (request.status === (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");



var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $39bece87a6f042d1$export$19e8f5eea8d43acd {
    static dispose() {
        this.events = [];
    }
    static init() {
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE, (data)=>{
            this.events.forEach((value)=>value(data));
        });
    }
    static async create(communityId, query, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/create/${communityId}/${query}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async update(communityId, clusterId, keywords, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MIN,
                message: (0, $5FliW.Resources).t("words.minKeywords")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).SIZE_MAX,
                message: (0, $5FliW.Resources).t("words.maxKeywords")
            },
            {
                errorCode: (0, $bTARt.ErrorCode).MAX_LIMIT,
                message: (0, $5FliW.Resources).t("words.maxClusterModification")
            }
        ]);
        let request = await (0, $7AbeR.Network).putJson((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/update/${communityId}/${clusterId}`, keywords, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getPreviewsByCommunityId(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getClusters(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/${communityId}/${clusterId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getCompetitors(communityId, clusterId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/keywords/competitors/${communityId}/${clusterId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, id, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/clusters/${communityId}/${id}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static onClusterCreate(component, func) {
        this.events.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.events, func));
    }
}
$39bece87a6f042d1$export$19e8f5eea8d43acd.events = [];



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");

var $2Y8XI = parcelRequire("2Y8XI");

var $5FliW = parcelRequire("5FliW");
class $cefa0647525faafd$export$d57fb523d3be1724 {
    static dispose() {}
    static init() {}
    static async getGsc(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/${communityId}`, component);
        return request.data;
    }
    static async disconnect(communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/disconnect/${communityId}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async verification(communityId, verificationType, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/verification/${verificationType}/${communityId}`, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async addSitemapGsc(communityId, url, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.sitemapRejectedByGoogle")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/addSitemap/${communityId}`, {
            url: url
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
    static async deleteSitemapGsc(communityId, url, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                message: (0, $5FliW.Resources).t("words.requestRejectedByGoogle")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/gsc/deleteSitemap/${communityId}`, {
            url: url
        }, component);
        return request.status == (0, $7ZaxO.HttpStatus).OK;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");



var $2Y8XI = parcelRequire("2Y8XI");

var $bTARt = parcelRequire("bTARt");

var $5FliW = parcelRequire("5FliW");
class $dea35e21668196b4$export$902bc259cc27ba13 {
    static dispose() {
        this.events = [];
    }
    static init() {
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_SEO_AUDIT_UPDATE, (data)=>{
            this.events.forEach((value)=>value(data));
        });
    }
    static async create(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).AUDIT_ALREADY_RUNNING,
                message: (0, $5FliW.Resources).t("words.auditAlreadyRunningMessage")
            }
        ]);
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/seo/audit/create/${communityId}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getPageByUrl(data, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/seo/audit/page`, data, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getById(auditId, communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/seo/audit/${auditId}/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getPages(pageOutgoing, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/seo/audit/pages", pageOutgoing, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getOverviews(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/seo/audit/overviews/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static onAuditUpdate(component, func) {
        this.events.push(func);
        component.onRemove(()=>(0, $430c7e198afa9f6b$export$30a014203d0d7e4f)(this.events, func));
    }
}
$dea35e21668196b4$export$902bc259cc27ba13.events = [];


class $b1e6fff8c0d9b52f$export$55b7b226f6213252 {
    static dispose() {
        (0, $680ec485db5e71e8$export$88eb42c4a6e30051).dispose();
        (0, $5aab3284ce582eaf$export$439035f52ab89a16).dispose();
        (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).dispose();
        (0, $ea99dfb6cc838099$export$6368a938bdcd0b2).dispose();
        (0, $16fe27051c61311b$export$c8c9ba79e1431b49).dispose();
        (0, $39bece87a6f042d1$export$19e8f5eea8d43acd).dispose();
        (0, $dea35e21668196b4$export$902bc259cc27ba13).dispose();
        (0, $4db228f3f242765b$export$b7b630d38b5e9168).dispose();
        (0, $57a401ba8ef81077$export$d41076a259927884).dispose();
        (0, $8a2826395ed74d11$export$106b309753d02dc0).dispose();
        (0, $cefa0647525faafd$export$d57fb523d3be1724).dispose();
    }
    static init() {
        (0, $680ec485db5e71e8$export$88eb42c4a6e30051).init();
        (0, $5aab3284ce582eaf$export$439035f52ab89a16).init();
        (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).init();
        (0, $ea99dfb6cc838099$export$6368a938bdcd0b2).init();
        (0, $16fe27051c61311b$export$c8c9ba79e1431b49).init();
        (0, $39bece87a6f042d1$export$19e8f5eea8d43acd).init();
        (0, $dea35e21668196b4$export$902bc259cc27ba13).init();
        (0, $4db228f3f242765b$export$b7b630d38b5e9168).init();
        (0, $8a2826395ed74d11$export$106b309753d02dc0).init();
        (0, $cefa0647525faafd$export$d57fb523d3be1724).init();
        if ((0, $271MM.config).product != (0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).LIVECHAT)) window["CommunityService"] = this;
        (0, $7AbeR.Network).on((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_UPDATE, (data)=>{
            this.store(data);
        });
    }
    /**
     * http
     */ static async addLanguage(communityId, language, component) {
        let request = await (0, $7AbeR.Network).put((0, $kfkzw.ProductType).COMMUNITY, "/community/addLanguage", {
            communityId: communityId,
            language: language
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateSendEmailNotificationRanking(communityId, sendEmailNotificationRanking) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/sendEmailNotificationRanking/update/${communityId}/${sendEmailNotificationRanking}`);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async updateContext(communityId, context, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/context/update`, {
            communityId: communityId,
            context: context
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createHost(communityId, host, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/host/create`, {
            communityId: communityId,
            host: host
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async findBySite(siteId, type, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).SERVICE_UNAVAILABLE,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/site/${siteId}/${type}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return this.storeAll(request.data);
        return undefined;
    }
    static async findLimitsBySite(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/site/${siteId}/limits`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async delete(communityId, component) {
        await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/${communityId}`, component);
    }
    static async findById(communityId, language, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/${communityId}/${language}`, component);
        if (request && request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createStep0(communityCreateStep0Model, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/create/step/0", communityCreateStep0Model, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async createStep1(communityCreateStep1Model, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, "/community/create/step/1", communityCreateStep1Model, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async configExportNone(communityId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/config/export/none/${communityId}`, {}, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async addRedactor(communityId, name, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, "/community/redactor", {
            communityId: communityId,
            name: name
        }, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async deleteRedactor(communityId, redactorId, component) {
        let request = await (0, $7AbeR.Network).delete((0, $kfkzw.ProductType).COMMUNITY, `/community/redactor/${communityId}/${redactorId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
        return undefined;
    }
    static async checkInternalHost(communityId, hostname, communityType, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                status: (0, $7ZaxO.HttpStatus).BAD_REQUEST,
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST,
                message: "none"
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                errorCode: (0, $bTARt.ErrorCode).HOST_EXIST
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/checkInternalHost/${hostname}/${communityType}/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
        return undefined;
    }
    static async getById(communityId, component) {
        (0, $2Y8XI.Services).handleErrors(component, [
            {
                errorCode: (0, $bTARt.ErrorCode).SUSPENDED,
                message: (0, $5FliW.Resources).t("words.communitySuspendedDueToOfferInsufficiency")
            },
            {
                status: (0, $7ZaxO.HttpStatus).NOT_FOUND,
                message: "none"
            }
        ]);
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
    }
    static async selectPartnerBlog(communityId, remoteId, component) {
        let request = await (0, $7AbeR.Network).post((0, $kfkzw.ProductType).COMMUNITY, `/community/select/partner/blog/${communityId}/${remoteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return this.store(request.data);
    }
    static async getPartnerBlogColumns(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/columns/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async updatePartnerBlogColumns(communityId, columns, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/columns/${communityId}`, columns, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getListPartnerBlog(communityId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/list/partner/blog/${communityId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async getCommunitiesAdmin(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/admin/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
    static async resetCommunityStatsBySiteId(siteId, component) {
        let request = await (0, $7AbeR.Network).get((0, $kfkzw.ProductType).COMMUNITY, `/community/admin/resetStats/${siteId}`, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return true;
    }
    /**
     * start
     */ static async start(options, communityCreateStep0Model, component) {
        let community = await this.createStep0(communityCreateStep0Model, component);
        if (community) await (0, $7AbeR.Network).router.pages.reload(`/${options.basePath}/${community.id}/content/home`);
        return community;
    }
    /**
     * websocket
     */ static async startSocket(onRetry) {
        let retry = async ()=>{
            if (onRetry) onRetry();
            await (0, $nyKU9.SedestralMachine).sleep(2500);
            if (await this.startSocket()) {
                await (0, $nyKU9.SedestralMachine).sleep(7000);
                window.location.reload();
            }
        };
        let socket = await (0, $7AbeR.Network).startWebSocket((0, $kfkzw.ProductType).COMMUNITY, ()=>retry());
        if (!socket) await retry();
        return socket;
    }
    static disposeSocket() {
        (0, $7AbeR.Network).getSocket((0, $kfkzw.ProductType).COMMUNITY).disconnect(true);
    }
    static async join(id) {
        if (id != null) await (0, $7AbeR.Network).join((0, $kfkzw.ProductType).COMMUNITY, id, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_JOIN);
    }
    static leave(id) {
        (0, $7AbeR.Network).emit((0, $kfkzw.ProductType).COMMUNITY, (0, $e1536de0087baae2$export$e473f7e46afe97f7).COMMUNITY_LEAVE, id);
    }
    /**
     * store
     */ static storeAll(communities) {
        for(let key in communities)communities[key] = this.store(communities[key]);
        return (0, $2Y8XI.Services).storeAll(communities);
    }
    static store(community) {
        let storedCommunity = (0, $2Y8XI.Services).get("id", this.communities, community.id);
        if (storedCommunity != undefined) {
            if (!community.autopilot && storedCommunity.autopilot) community.autopilot = storedCommunity.autopilot;
            if (!community.partner && storedCommunity.partner) community.partner = storedCommunity.partner;
            if (!community.context && storedCommunity.context) community.context = storedCommunity.context;
            if (!community.writingStyles && storedCommunity.writingStyles) community.writingStyles = storedCommunity.writingStyles;
            if (!community.redactors && storedCommunity.redactors) community.redactors = storedCommunity.redactors;
        }
        if (community.text) community.text = (0, $680ec485db5e71e8$export$88eb42c4a6e30051).store(community.text);
        if (community.logoFile) community.logoFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.logoFile);
        if (community.footerFile) community.footerFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.footerFile);
        if (community.faviconFile) community.faviconFile = (0, $e76657c0ca80eee3$export$3d1acc6bf13b6cd1).store(community.faviconFile);
        return (0, $2Y8XI.Services).store("id", this.communities, community);
    }
    static getHost(community) {
        community.host.startsWith("mon url");
        return community.host.startsWith("http") ? community.host : "https://" + community.host;
    }
}
$b1e6fff8c0d9b52f$export$55b7b226f6213252.communities = (0, $i3Hbv.observable)([]);




var $fsnB5 = parcelRequire("fsnB5");

var $fsnB5 = parcelRequire("fsnB5");
var $d2531115e2a10385$exports = {};

$parcel$export($d2531115e2a10385$exports, "globalProgressBar", function () { return $d2531115e2a10385$export$e10d7fe02c4d3a0c; }, function (v) { return $d2531115e2a10385$export$e10d7fe02c4d3a0c = v; });
$parcel$export($d2531115e2a10385$exports, "white", function () { return $d2531115e2a10385$export$8fa4e5556fd77a60; }, function (v) { return $d2531115e2a10385$export$8fa4e5556fd77a60 = v; });
$parcel$export($d2531115e2a10385$exports, "percent", function () { return $d2531115e2a10385$export$626336c2cd4b14de; }, function (v) { return $d2531115e2a10385$export$626336c2cd4b14de = v; });
$parcel$export($d2531115e2a10385$exports, "bar", function () { return $d2531115e2a10385$export$d927737047eb3867; }, function (v) { return $d2531115e2a10385$export$d927737047eb3867 = v; });
$parcel$export($d2531115e2a10385$exports, "orange", function () { return $d2531115e2a10385$export$ad766f34ace1cafd; }, function (v) { return $d2531115e2a10385$export$ad766f34ace1cafd = v; });
$parcel$export($d2531115e2a10385$exports, "red", function () { return $d2531115e2a10385$export$a90204d1394caf30; }, function (v) { return $d2531115e2a10385$export$a90204d1394caf30 = v; });
$parcel$export($d2531115e2a10385$exports, "green", function () { return $d2531115e2a10385$export$955a2ebd2fb142ae; }, function (v) { return $d2531115e2a10385$export$955a2ebd2fb142ae = v; });
var $d2531115e2a10385$export$e10d7fe02c4d3a0c;
var $d2531115e2a10385$export$8fa4e5556fd77a60;
var $d2531115e2a10385$export$626336c2cd4b14de;
var $d2531115e2a10385$export$d927737047eb3867;
var $d2531115e2a10385$export$ad766f34ace1cafd;
var $d2531115e2a10385$export$a90204d1394caf30;
var $d2531115e2a10385$export$955a2ebd2fb142ae;
$d2531115e2a10385$export$e10d7fe02c4d3a0c = "e-V-Z";
$d2531115e2a10385$export$8fa4e5556fd77a60 = "SBf3T";
$d2531115e2a10385$export$626336c2cd4b14de = "rJYe6";
$d2531115e2a10385$export$d927737047eb3867 = "UQ3HL";
$d2531115e2a10385$export$ad766f34ace1cafd = "wAHO5";
$d2531115e2a10385$export$a90204d1394caf30 = "OZINJ";
$d2531115e2a10385$export$955a2ebd2fb142ae = "aOQjW";



var $nyKU9 = parcelRequire("nyKU9");
class $2c4bf4d474a1e8b0$export$19e02114ee9734c8 extends (0, $fsnB5.Component) {
    commit() {
        this.barComponent = this.el($d2531115e2a10385$exports.bar);
        if (this.p.tooltip) super.commitTooltips();
        this.barComponent.setStyle(`width:0%;`);
        this.setBar(this.p.value);
        super.commit();
    }
    setBar(value) {
        this.p.value = value;
        if (this.p.autoTooltip) {
            this.clearTooltipListeners();
            this.setTooltip(`${this.p.value}/${this.p.maxValue}`);
        }
        if (this.p.autoColor || this.p.autoColorInvert) {
            this.barComponent.setAttribute("class", $d2531115e2a10385$exports.bar);
            this.barComponent.addClass($d2531115e2a10385$exports[this.p.autoColorInvert ? this.getColorInvert() : this.getColor()]);
        }
        let width = Math.round(this.p.value * 100 / this.p.maxValue);
        (0, $nyKU9.SedestralMachine).requestFrame()(()=>{
            this.barComponent.setStyle(`width:${width}%;transition-duration: ${this.p.animationDelay / 1000}s;`);
        });
    }
    getColor() {
        const percentage = this.p.value / this.p.maxValue * 100;
        if (percentage < 30) return "red";
        else if (percentage >= 30 && percentage <= 60) return "orange";
        else return "green";
    }
    getColorReal() {
        const percentage = this.p.value / this.p.maxValue * 100;
        if (percentage < 30) return "var(--red)";
        else if (percentage >= 30 && percentage <= 60) return "var(--orange-cover)";
        else return "#3ece80";
    }
    getColorInvert() {
        const percentage = this.p.value / this.p.maxValue * 100;
        if (percentage < 50) return "green";
        else if (percentage < 65) return "orange";
        else return "red";
    }
    constructor(p){
        super();
        this.p = p;
        //language=HTML
        this.template = `
            <div data-tooltip="${p.tooltip}" class="${$d2531115e2a10385$exports.globalProgressBar} ${p.white ? $d2531115e2a10385$exports.white : ``}">
                <div class="${$d2531115e2a10385$exports.bar} ${p.color ? $d2531115e2a10385$exports[p.color] : ``}"></div>
                ${p.showValue ? `<div class="${$d2531115e2a10385$exports.percent}">50%</div>` : ``}
            </div>
        `;
    }
}


var $4bb1a4ac9670a03a$export$a43cfac3bb87a4c;
var $4bb1a4ac9670a03a$export$6d59db4903f20f7d;
var $4bb1a4ac9670a03a$export$504d7abb21fa8c9;
var $4bb1a4ac9670a03a$export$2ba01fb71ed41cb6;
var $4bb1a4ac9670a03a$export$1ca1ec8b29a4ce27;
$4bb1a4ac9670a03a$export$a43cfac3bb87a4c = "ynzIG";
$4bb1a4ac9670a03a$export$6d59db4903f20f7d = "nPGy9";
$4bb1a4ac9670a03a$export$504d7abb21fa8c9 = "d0vhn";
$4bb1a4ac9670a03a$export$2ba01fb71ed41cb6 = "DozN7";
$4bb1a4ac9670a03a$export$1ca1ec8b29a4ce27 = "AEdIg";



var $kfkzw = parcelRequire("kfkzw");


var $5FliW = parcelRequire("5FliW");

var $68Z0d = parcelRequire("68Z0d");

var $7AbeR = parcelRequire("7AbeR");
class $6865c9c08d788c0d$export$713337cf8164d1db extends (0, $fsnB5.Component) {
    commit() {
        this.el($4bb1a4ac9670a03a$export$2ba01fb71ed41cb6).onClick(async ()=>{
            if ((0, $68Z0d.EntityService).activeOfferIsFailureToPay) {
                await (0, $7AbeR.Network).router.pages.redirect("/b/home/content/subscriptions/home");
                location.reload();
            } else {
                let offerModal = new (0, $b1abca3e5af47c24$export$6191bb88e92acd1c)((0, $kfkzw.ProductType).BLOG);
                offerModal.screenRender();
            }
        });
        super.commit();
    }
    constructor(currentQuantity, limitQuantity, solutionType, productType){
        super();
        //language=HTML
        this.template = `
            <div class="${$4bb1a4ac9670a03a$export$a43cfac3bb87a4c}">
                <div class="${$4bb1a4ac9670a03a$export$6d59db4903f20f7d}">
                    ${(0, $5FliW.Resources).t("words.offerBlockedDesc")}
                </div>
                <div class="${$4bb1a4ac9670a03a$export$504d7abb21fa8c9}">
                    ${this.draw(new (0, $2c4bf4d474a1e8b0$export$19e02114ee9734c8)({
            animationDelay: 500,
            maxValue: limitQuantity,
            value: currentQuantity,
            tooltip: `${currentQuantity}/${limitQuantity}`
        }))}
                </div>
                <div class="${$4bb1a4ac9670a03a$export$2ba01fb71ed41cb6}">
                    ${(0, $5FliW.Resources).t("words.offerBlockedButton")}
                </div>
                <div class="${$4bb1a4ac9670a03a$export$1ca1ec8b29a4ce27}"></div>
            </div>
        `;
    }
}



var $5FliW = parcelRequire("5FliW");
class $f19c119b8bc2e618$export$3c54fb971d2da0a3 extends (0, $d7fa30f5b69b40db$export$2a517e1cac1c1f85) {
    constructor(currentQuantity, limitQuantity, solutionType, productType){
        super();
        this.name = (0, $5FliW.Resources).t("words.offerBlocked");
        this.modalStyle = "width: 300px;";
        this.modalTemplate = this.draw(new (0, $6865c9c08d788c0d$export$713337cf8164d1db)(currentQuantity, limitQuantity, solutionType, productType));
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $8ec890312761cf0f$export$73044afb89dc5de3 {
    static dispose() {}
    static init() {}
    /**
     * rest
     */ static async searchLogs(search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/account/logs`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $kfkzw = parcelRequire("kfkzw");

var $7ZaxO = parcelRequire("7ZaxO");
class $8e91f1a78ded9f3a$export$8700658f21c9a426 {
    static dispose() {}
    static init() {}
    /**
     * rest
     */ static async searchLogs(search, component) {
        let request = await (0, $7AbeR.Network).postJson((0, $kfkzw.ProductType).PANEL, `/tracking/logs`, search, component);
        if (request.status == (0, $7ZaxO.HttpStatus).OK) return request.data;
    }
}


class $a79abfbae13910be$export$cec36545a5eebac5 {
    static async init() {
        /**
         * override
         */ (0, $7AbeR.Network).onToken = async ()=>{
            return (0, $d808f887fcf63765$export$f650c34b939fcf30).hasSsr() ? true : await (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).token();
        };
        (0, $7AbeR.Network).onLogin = async ()=>{
            (0, $7AbeR.Network).logged = true;
            let connected = await (0, $7AbeR.Network).startWebSocket((0, $kfkzw.ProductType).PANEL);
            if (connected) {
                await (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).onLogin();
                this.initServices();
                this.initEvents();
                return true;
            }
            return false;
        };
        (0, $7AbeR.Network).onLogout = async ()=>{
            (0, $7AbeR.Network).logged = false;
            (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).onLogout();
            this.disposeServices();
            await (0, $7AbeR.Network).disconnect((0, $kfkzw.ProductType).PANEL, true);
            return true;
        };
        (0, $7AbeR.Network).onError = (message)=>{
            var _Network_router_static, _Network_router_static1;
            if ((_Network_router_static = (0, $7AbeR.Network).router.static) === null || _Network_router_static === void 0 ? void 0 : _Network_router_static.components.notifications) (_Network_router_static1 = (0, $7AbeR.Network).router.static) === null || _Network_router_static1 === void 0 ? void 0 : _Network_router_static1.components.notifications.notify(message, undefined, 8000);
        };
        (0, $7AbeR.Network).onPaymentRequired = (currentQuantity, limitQuantity, solutionType, productType)=>{
            let modal = new (0, $f19c119b8bc2e618$export$3c54fb971d2da0a3)(currentQuantity, limitQuantity, solutionType, productType);
            modal.screenRender();
        };
        /**
         * on error
         */ (0, $7AbeR.Network).lostFunctions = [];
        (0, $7AbeR.Network).onNetworkLost(()=>{
            (0, $2aBLW.SedestralInterface).body.render(new (0, $c5dae9559cc8dadc$export$cb3fc5fbc3cd8ca6)());
        });
        (0, $7AbeR.Network).lostSolvedFunctions = [];
        (0, $7AbeR.Network).onNetworkLostSolved(()=>window.location.reload());
    }
    static initServices() {
        (0, $68Z0d.EntityService).init();
        (0, $fdmdr.SiteService).init();
        (0, $9jYbZ.SiteChannelService).init();
        (0, $jdUQG.RoleService).init();
        (0, $kCcuA.RoleAccountService).init();
        (0, $36d265ad8cd70e05$export$961fa99b63baa1c2).init();
        (0, $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1).init();
        (0, $7Aqrk.AccountService).init();
        (0, $8ec890312761cf0f$export$73044afb89dc5de3).init();
        (0, $8e91f1a78ded9f3a$export$8700658f21c9a426).init();
        (0, $eca38d8f83f4604c$export$d9845d64048805ae).init();
        (0, $82dd075fc824038c$export$dcb66d9e8650d51c).init();
        (0, $g0YRJ.AvatarService).init();
        (0, $fYPFR.AvatarColorService).init();
        (0, $bKmye.FileService).init();
        (0, $cee9b6c023f6bf1b$export$3aed5f2d684ba248).init();
        (0, $1b6Hd.PreferencesService).init();
        (0, $adef5ff04d8059af$export$2ba536885b8718d9).init();
        (0, $d493c1628d3686c4$export$bcc04e5ab52ff38).init();
        (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).init();
    }
    static disposeServices() {
        (0, $fdmdr.SiteService).dispose();
        (0, $9jYbZ.SiteChannelService).dispose();
        (0, $36d265ad8cd70e05$export$961fa99b63baa1c2).dispose();
        (0, $1fc8ff2a75b0fb6d$export$1ad9ba1937b657a1).dispose();
        (0, $c7f887b940cb52a2$export$8b2d45e406ebb5ab).dispose();
        (0, $7Aqrk.AccountService).dispose();
        (0, $8ec890312761cf0f$export$73044afb89dc5de3).dispose();
        (0, $8e91f1a78ded9f3a$export$8700658f21c9a426).dispose();
        (0, $82dd075fc824038c$export$dcb66d9e8650d51c).dispose();
        (0, $g0YRJ.AvatarService).dispose();
        (0, $fYPFR.AvatarColorService).dispose();
        (0, $bKmye.FileService).dispose();
        (0, $68Z0d.EntityService).dispose();
        (0, $cee9b6c023f6bf1b$export$3aed5f2d684ba248).dispose();
        (0, $1b6Hd.PreferencesService).dispose();
        (0, $adef5ff04d8059af$export$2ba536885b8718d9).dispose();
        (0, $d493c1628d3686c4$export$bcc04e5ab52ff38).dispose();
        (0, $b1e6fff8c0d9b52f$export$55b7b226f6213252).dispose();
    }
    static initEvents() {
        (0, $fdmdr.SiteService).onReload = ()=>{
            location.reload();
        };
    }
}



var $7AbeR = parcelRequire("7AbeR");

var $1b6Hd = parcelRequire("1b6Hd");
class $ec8cfe3fcee91d4b$export$6570986f4924cf71 extends (0, $a79abfbae13910be$export$cec36545a5eebac5) {
    static async init() {
        await (0, $a79abfbae13910be$export$cec36545a5eebac5).init();
        (0, $7AbeR.Network).onToken = async ()=>{
            return true;
        };
        (0, $7AbeR.Network).onLogout = async ()=>{
            return true;
        };
        (0, $7AbeR.Network).onLogin = async ()=>{
            return true;
        };
        (0, $7AbeR.Network).lostFunctions = [];
        (0, $7AbeR.Network).onNetworkLost(()=>{});
        (0, $7AbeR.Network).lostSolvedFunctions = [];
        (0, $7AbeR.Network).onNetworkLostSolved(()=>{});
    }
    static initServices() {
        (0, $1b6Hd.PreferencesService).init();
    }
}



var $bi5k0 = parcelRequire("bi5k0");

var $kfkzw = parcelRequire("kfkzw");

const $a4004b1a5b170d77$var$r = ()=>"undefined" != typeof window, $a4004b1a5b170d77$var$t = ()=>!(!$a4004b1a5b170d77$var$r() || !window.hj), $a4004b1a5b170d77$var$e = (t, ...e)=>{
    if ($a4004b1a5b170d77$var$r() && window.hj) return window.hj(t, ...e);
    throw Error("Hotjar is not available, make sure init has been called.");
}, $a4004b1a5b170d77$var$n = (r, e, n)=>{
    if (!((r, t, e)=>{
        try {
            const n = document.getElementById(t) || document.createElement("script");
            return n.id = t, n.nonce = e, n.innerText = r, n.crossOrigin = "anonymous", document.head.appendChild(n), !0;
        } catch (r) {
            return !1;
        }
    })(`(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${r},hjsv:${e},hjdebug:${(null == n ? void 0 : n.debug) || !1}};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`, "hotjar-init-script", null == n ? void 0 : n.nonce) || !$a4004b1a5b170d77$var$t()) throw Error("Failed to initialize Hotjar tracking script.");
}, $a4004b1a5b170d77$var$o = {
    init: (r, t, e)=>{
        try {
            return $a4004b1a5b170d77$var$n(r, t, e), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    event: (r)=>{
        try {
            return $a4004b1a5b170d77$var$e("event", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    identify: (r, t)=>{
        try {
            return $a4004b1a5b170d77$var$e("identify", r, t), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    stateChange: (r)=>{
        try {
            return $a4004b1a5b170d77$var$e("stateChange", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    isReady: $a4004b1a5b170d77$var$t
};
var $a4004b1a5b170d77$export$2e2bcd8739ae039 = $a4004b1a5b170d77$var$o;



(0, $271MM.config).import("website");
(0, $805fc3389134ffba$export$d1af847c14d84dee).ready(async ()=>{
    await (0, $805fc3389134ffba$export$d1af847c14d84dee).init();
    await (0, $ec8cfe3fcee91d4b$export$6570986f4924cf71).init();
    await (0, $7AbeR.Network).init((0, $bi5k0.ProductName).toString((0, $kfkzw.ProductType).WEBSITE));
    await (0, $06b74486bfb83daf$export$e9fe003e12bfbc08).init();
    if (!(0, $d808f887fcf63765$export$f650c34b939fcf30).hasSsr() && !/Googlebot|Spiders|Crawlers/i.test(navigator.userAgent)) {
        (0, $86359f522f1a9856$export$2cb99e4be0dc4646)("https://js-na1.hs-scripts.com/48111012.js", ()=>{});
        try {
            if (!(0, $271MM.config).isDev && !(0, $d808f887fcf63765$export$f650c34b939fcf30).hasSsr()) {
                const hotjarId = (0, $271MM.config).hotjarId;
                const hotjarVersion = 6;
                (0, $a4004b1a5b170d77$export$2e2bcd8739ae039).init(Number(hotjarId), hotjarVersion);
            }
        } catch (e) {
            console.error(e);
        }
    }
});


//# sourceMappingURL=website.de42d0a3.js.map
 }());